/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The `AccountId` scalar represents the ID of a Buffer Account */
  AccountId: { input: any; output: any; }
  /** The `ChangelogEntryId` scalar represents the ID of a Changelog Entry. */
  ChangelogEntryId: { input: any; output: any; }
  /** The `ChannelGroupId` scalar represents the ID of a Channel Group. */
  ChannelGroupId: { input: any; output: any; }
  /** The `ChannelId` scalar represents the ID of a Buffer Channel */
  ChannelId: { input: any; output: any; }
  /**
   * The `CommentId` scalar represents the ID of a Comment.
   * A Comment is a reply to a post
   */
  CommentId: { input: any; output: any; }
  /** A unique identifier for a content item. */
  ContentItemId: { input: any; output: any; }
  /**
   * The `ConversationId` scalar is the ID of a Conversation (a DM chat, a comment
   * thread or a mention thread). Not an EngagementId.
   */
  ConversationId: { input: any; output: any; }
  /** The `Date` scalar represents a date */
  Date: { input: any; output: any; }
  /** The `DateTime` scalar represents a date and time following the ISO 8601 standard. */
  DateTime: { input: any; output: any; }
  /** A unique identifier for a channel-less draft's content. */
  DraftContentId: { input: any; output: any; }
  /** The `DraftId` scalar represents the ID of a Buffer Draft */
  DraftId: { input: any; output: any; }
  /**
   * The `Email` scalar represents a valid, normalized email address.
   * Input is trimmed and lowercased before validation.
   */
  Email: { input: any; output: any; }
  /** The `EngagementId` scalar is the ID of an Engagement item (Mention or Comment). */
  EngagementId: { input: any; output: any; }
  /**
   * The `FeedCollectionId` scalar represents the ID of a Feed Group
   * A Feed Group is a collection of Feeds for a particular organization
   */
  FeedCollectionId: { input: any; output: any; }
  /**
   * The `FeedId` scalar represents the ID of a Content Feed (eg RSS)
   * A Feed is a source of content- for example, a specific RSS feed
   */
  FeedId: { input: any; output: any; }
  /**
   * The `FeedItemId` scalar represents the ID of a Feed Item
   * A Feed Item is a single item in a Feed- for example, an article from an RSS feed
   */
  FeedItemId: { input: any; output: any; }
  /**
   * The `FilterJSON` scalar represents a JSON object containing filter state for a saved view.
   * Validated for size (max 5KB), nesting depth (max 4 levels), and prohibited keys.
   */
  FilterJSON: { input: any; output: any; }
  /** The `HexColorCode` scalar represents a valid hex color code. */
  HexColorCode: { input: any; output: any; }
  /** The `IdeaId` scalar represents the ID of a Buffer Idea */
  IdeaId: { input: any; output: any; }
  /** The `InvitationId` scalar represents the ID of a pending team invitation */
  InvitationId: { input: any; output: any; }
  /** The `MimeType` scalar represents a valid MIME type, e.g. `image/png` */
  MimeType: { input: any; output: any; }
  /** The `NoteId` scalar represents the ID of a Buffer Note */
  NoteId: { input: any; output: any; }
  /** The `OrganizationId` scalar represents the ID of a Buffer Organization */
  OrganizationId: { input: any; output: any; }
  /** The `PostGroupId` scalar represents the ID of a Buffer Post Group. */
  PostGroupId: { input: any; output: any; }
  /** The `PostId` scalar represents the ID of a Buffer Post */
  PostId: { input: any; output: any; }
  /** The `PostTemplateCampaignId` scalar represents the ID of a Post Template Campaign. */
  PostTemplateCampaignId: { input: any; output: any; }
  /** The `PostTemplateId` scalar represents the ID of a Post Template. */
  PostTemplateId: { input: any; output: any; }
  /** The `SavedReplyId` scalar represents the ID of a Saved Reply. */
  SavedReplyId: { input: any; output: any; }
  /** The `SavedViewId` scalar represents the ID of a Saved View. */
  SavedViewId: { input: any; output: any; }
  /** The `ShopGridLinkId` scalar represents the ID of a Buffer ShopGridLink */
  ShopGridLinkId: { input: any; output: any; }
  /** The `SnippetId` scalar represents the ID of a Snippet. */
  SnippetId: { input: any; output: any; }
  /** The `SubProfileId` scalar represents the ID of a Buffer SubProfile */
  SubProfileId: { input: any; output: any; }
  /** The `TagId` scalar represents the ID of a Buffer Tag */
  TagId: { input: any; output: any; }
  /** The `TakeawayId` scalar represents the ID of a Buffer Takeaway */
  TakeawayId: { input: any; output: any; }
  /** The `TimeZone` scalar represents a valid timezone, e.g. `America/New_York` */
  TimeZone: { input: any; output: any; }
  /** The `URL` scalar represents a valid URL */
  URL: { input: any; output: any; }
  /**
   * The `URN` scalar represents a branded URN in its canonical string form,
   * e.g. `urn:buffer:ext:instagram:user:<igsid>`.
   */
  URN: { input: any; output: any; }
  /**
   * The `Uuid` scalar represents an RFC 4122 v4 UUID,
   * e.g. `550e8400-e29b-41d4-a716-446655440000`.
   */
  Uuid: { input: any; output: any; }
};

/** AI Specific settings */
export type AiSettings = {
  __typename?: 'AISettings';
  /** Flag that indicates if AI onboarding has been completed */
  onboarded?: Maybe<Scalars['Boolean']['output']>;
};

export type AiSettingsInput = {
  /** Flag that indicates if AI onboarding has been completed */
  onboarded: Scalars['Boolean']['input'];
};

/** An API Client is an application or service registered to access the Buffer API. */
export type ApiClient = {
  __typename?: 'APIClient';
  /** The client Id of the API Client */
  clientId: Scalars['String']['output'];
  /** The name of the API Client */
  clientName: Scalars['String']['output'];
  /** The client secret of the API Client. */
  clientSecret?: Maybe<Scalars['String']['output']>;
  /** The date the API Client was created */
  createdAt: Scalars['DateTime']['output'];
  /** The unique identifier for the API Client. */
  id: Scalars['String']['output'];
  /**
   * Whether the API Client is marked as suspended or not.
   * A suspended API Client is inactive
   */
  isSuspended: Scalars['Boolean']['output'];
  /** The logo URI for the API Client */
  logoUri?: Maybe<Scalars['String']['output']>;
  /** The privacy policy URI for the API Client */
  privacyPolicyUri?: Maybe<Scalars['String']['output']>;
  /** The uris to redirect to after authentication */
  redirectUris: Array<Scalars['String']['output']>;
  /** The scopes associated with the client */
  scopes: Array<OAuthScope>;
};

/** Input for the apiClient query */
export type ApiClientInput = {
  /** The ID of the API Client to be retrieved */
  id: Scalars['String']['input'];
};

/** API Client Query Payload */
export type ApiClientPayload = ApiClient | NotFoundError;

/** Enum of the allowed actions */
export enum ApiClientSuspensionAction {
  Reactivate = 'reactivate',
  Suspend = 'suspend'
}

/** Usage statistics for a specific time period with limit information */
export type ApiClientUsagePeriod = {
  __typename?: 'APIClientUsagePeriod';
  /** Maximum allowed requests in this period */
  limit: Scalars['Int']['output'];
  /** Number of requests used in this period */
  used: Scalars['Int']['output'];
};

/** API Client usage statistics from rate limiter counters */
export type ApiClientUsageStatistics = {
  __typename?: 'APIClientUsageStatistics';
  /** Usage statistics for the last 15 minutes */
  last15Minutes: ApiClientUsagePeriod;
  /** Usage statistics for the last 24 hours (1 day) */
  lastDay: ApiClientUsagePeriod;
  /** Usage statistics for the last 30 days (1 month) */
  lastMonth: ApiClientUsagePeriod;
};

/** Input for the API client usage statistics query */
export type ApiClientUsageStatisticsInput = {
  /** The ID of the API Client */
  clientId: Scalars['String']['input'];
};

/** API Client Usage Statistics Query Payload */
export type ApiClientUsageStatisticsPayload = ApiClientUsageStatistics | NotFoundError;

/**
 * Input for the apiClientsForAccount query.
 * Used by BufferAdmin actors to query API clients for a specific account.
 */
export type ApiClientsForAccountInput = {
  /** The account ID to fetch API clients for. */
  accountId: Scalars['AccountId']['input'];
};

/** Response for apiClientsForAccount query */
export type ApiClientsForAccountResponse = {
  __typename?: 'APIClientsForAccountResponse';
  /** The API clients associated with the account */
  clients: Array<ApiClient>;
};

/** Response for apiClients query */
export type ApiClientsResponse = {
  __typename?: 'APIClientsResponse';
  /** Whether upgrading the plan would increase the client limit */
  canUpgradeForMore: Scalars['Boolean']['output'];
  /** The API clients associated with the account */
  clients: Array<ApiClient>;
  /** The maximum number of API clients allowed for this account's plan */
  maxClients: Scalars['Int']['output'];
};

/**
 * Input for accepting an invitation. Called from `/invite/accept` in
 * publish-frontend after the invitee signs up or logs in.
 */
export type AcceptInvitationInput = {
  /** The signed JWT from the invite link. */
  jwt: Scalars['String']['input'];
};

/** Result of accepting an invitation. */
export type AcceptInvitationPayload = EmailAlreadyMemberError | EmptySuccess | InvitationEmailMismatchError | TwoFactorSetupRequiredError;

/** OAuth scope permissions that can be required on public API fields. */
export enum AccessScope {
  AccountRead = 'accountRead',
  AccountWrite = 'accountWrite',
  EngagementsRead = 'engagementsRead',
  EngagementsWrite = 'engagementsWrite',
  IdeasRead = 'ideasRead',
  IdeasWrite = 'ideasWrite',
  InsightsRead = 'insightsRead',
  PostsRead = 'postsRead',
  PostsWrite = 'postsWrite',
  SnippetsRead = 'snippetsRead',
  SnippetsWrite = 'snippetsWrite'
}

/** Response for successful getAccessTokenForChannel query */
export type AccessTokens = {
  __typename?: 'AccessTokens';
  /** access token for channel */
  accessToken: Scalars['String']['output'];
  /** shared access token for channel */
  sharedAccessToken?: Maybe<Scalars['String']['output']>;
  /**
   * JWT token to that can be used instead of TFA code. This token expires in 30 minutes and allows advocates a short window
   * of time to perform sensitive actions without needing to enter a TFA code again.
   */
  tfaToken?: Maybe<Scalars['String']['output']>;
};

/** Account is a representation of a Buffer user. */
export type Account = {
  __typename?: 'Account';
  /** The internal admin comment associated with this account */
  adminComment?: Maybe<Scalars['String']['output']>;
  /** Affiliate program information for the account */
  affiliateData?: Maybe<AffiliateData>;
  /** URL to the account's avatar image */
  avatar: Scalars['String']['output'];
  /** Backup email address for account recovery */
  backupEmail?: Maybe<Scalars['String']['output']>;
  backupEmailVerificationRequestedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The latest changelog entry that the user has to display. Rendered as a
   * bottom-left popover or a centered modal depending on its `displayType`.
   */
  changelogEntryToDisplay?: Maybe<ChangelogEntry>;
  /**
   * Fetch all channels for the account taking into account the current's user permissions
   * This is an expensive call because it returns the channels for all the organizations the user has access to.
   * Consider using Organization.channels or Query.channels instead
   * @deprecated Use root 'channels' query instead
   */
  channels: Array<Channel>;
  /** The connected apps for the account */
  connectedApps?: Maybe<Array<ConnectedApp>>;
  /** Date the account was created in the Core DB. For older customers, it's possible a Publish account existed in the Publish DB for this customer before this date */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currentOrganization?: Maybe<Organization>;
  /** Array of user's dismissed banners */
  dismissedBanners?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Primary email address for the account */
  email: Scalars['String']['output'];
  emailVerificationRequestedAt?: Maybe<Scalars['DateTime']['output']>;
  featureFlips: Array<Scalars['String']['output']>;
  hasVerifiedBackupEmail?: Maybe<Scalars['Boolean']['output']>;
  hasVerifiedEmail?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Used during the login verification flow to indicate if the user has successfully completed the login verification flow.
   * This field will only be set for users who require login verification.
   */
  hasVerifiedLogin?: Maybe<Scalars['Boolean']['output']>;
  hellonextSsoToken?: Maybe<Scalars['String']['output']>;
  helpScoutBeaconSignature?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the account */
  id: Scalars['ID']['output'];
  isImpersonation: Scalars['Boolean']['output'];
  isSuspended: Scalars['Boolean']['output'];
  /** The date of the last login for the account */
  lastLoginAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The date that the login verification flow was initiated.
   * This field will only be set for users who require login verification.
   */
  loginVerificationRequestedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The account name, different from the organization name */
  name?: Maybe<Scalars['String']['output']>;
  organizations: Array<Organization>;
  /** The accounts preferences */
  preferences?: Maybe<Preferences>;
  products?: Maybe<Array<ProductLink>>;
  role: AccountRole;
  /** Account specific settings */
  settings?: Maybe<Settings>;
  /** Flag for new users to indicate if banner should be shown for email verification */
  shouldShowEmailVerificationCommunication?: Maybe<Scalars['Boolean']['output']>;
  /** Flag for existing users to indicate if banner should be shown to request email verification */
  shouldShowEmailVerificationLinkRequest?: Maybe<Scalars['Boolean']['output']>;
  /** The account-level TFA information */
  tfa?: Maybe<Tfa>;
  /** The account-level timezone - this is used as a default input for streaks, posting plans, and new channel channel connections. */
  timezone?: Maybe<Scalars['String']['output']>;
};


/** Account is a representation of a Buffer user. */
export type AccountChannelsArgs = {
  input?: InputMaybe<AccountChannelsInput>;
  product?: InputMaybe<Product>;
};


/** Account is a representation of a Buffer user. */
export type AccountOrganizationsArgs = {
  filter?: InputMaybe<OrganizationFilterInput>;
};

/** A monetary balance amount with its currency. */
export type AccountBalance = {
  __typename?: 'AccountBalance';
  /**
   * The balance amount in cents. Negative values indicate credit;
   * positive values indicate an amount owed.
   */
  amount: Scalars['Int']['output'];
  /** ISO 4217 currency code (e.g. "usd", "gbp"). */
  currency: Scalars['String']['output'];
};

/** Input for the channels field on Account */
export type AccountChannelsInput = {
  /** Query's filter. */
  filter?: InputMaybe<ChannelsFiltersInput>;
};

export type AccountCompleteEmailVerification = AccountCompleteEmailVerificationErrorJwtExpired | AccountCompleteEmailVerificationResponse | Error;

export type AccountCompleteEmailVerificationErrorJwtExpired = {
  __typename?: 'AccountCompleteEmailVerificationErrorJWTExpired';
  /** A raw error message to help developpers understand the root cause of the issue. */
  cause: Scalars['String']['output'];
  errorMessageCode: Scalars['String']['output'];
};

export type AccountCompleteEmailVerificationResponse = {
  __typename?: 'AccountCompleteEmailVerificationResponse';
  channelId?: Maybe<Scalars['ID']['output']>;
  redirectTo?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  sucessMessageCode: Scalars['String']['output'];
};

/** Reason to delete an account */
export type AccountDeletedReason = {
  /** Additional information about the account deletion */
  message?: InputMaybe<Scalars['String']['input']>;
  /** Reason for the account to be deleted */
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type AccountInitiateEmailVerificationError = {
  __typename?: 'AccountInitiateEmailVerificationError';
  /** A raw error message to help developers understand the root cause of the issue. */
  cause: Scalars['String']['output'];
  /** A user-friendly message that is safe to be displayed to users. */
  userFriendlyMessage: Scalars['String']['output'];
};

export type AccountInitiateEmailVerificationPayload = AccountInitiateEmailVerificationError | AccountInitiateEmailVerificationResponse;

export type AccountInitiateEmailVerificationResponse = {
  __typename?: 'AccountInitiateEmailVerificationResponse';
  success: Scalars['Boolean']['output'];
};

export type AccountPrivileges = {
  __typename?: 'AccountPrivileges';
  canEdit: Scalars['Boolean']['output'];
  canManageAllNotes: Scalars['Boolean']['output'];
  canManageBilling: Scalars['Boolean']['output'];
  canManageChannels: Scalars['Boolean']['output'];
  canManageTeamMembers: Scalars['Boolean']['output'];
  canPublishStartPages: Scalars['Boolean']['output'];
  canReceiveOrganizationOwnership: Scalars['Boolean']['output'];
  canTransferOwnership: Scalars['Boolean']['output'];
  canView: Scalars['Boolean']['output'];
};

export type AccountRemoveError = {
  __typename?: 'AccountRemoveError';
  /** A raw error message to help developers understand the root cause of the issue. */
  cause: Scalars['String']['output'];
  /** A user-friendly message that is safe to be displayed to users. */
  userFriendlyMessage: Scalars['String']['output'];
};

export type AccountRemovePayload = AccountRemoveError | AccountRemoveResponse;

export type AccountRemoveResponse = {
  __typename?: 'AccountRemoveResponse';
  /** The id of the account that was removed. */
  id: Scalars['String']['output'];
};

export enum AccountRole {
  Admin = 'admin',
  Customer = 'customer'
}

export type AccountSetSettingsError = {
  __typename?: 'AccountSetSettingsError';
  /** A raw error message to help developers understand the root cause of the issue. */
  cause: Scalars['String']['output'];
  /** A user-friendly message that is safe to be displayed to users. */
  userFriendlyMessage: Scalars['String']['output'];
};

export type AccountSetSettingsResponse = {
  __typename?: 'AccountSetSettingsResponse';
  settings: Settings;
  success: Scalars['Boolean']['output'];
};

export type AccountSuspendResponse = Error | Response;

export type AccountUnsuspendResponse = Error | Response;

/** input for the accountUpdateRole mutation */
export type AccountUpdateRoleInput = {
  accountId: Scalars['String']['input'];
  role: AccountRole;
};

/** The response of the accountUpdateRole mutation */
export type AccountUpdateRoleResponse = Error | Response;

/** An actor represents who/what the currently authorized entity is */
export enum Actor {
  /** Represents a caller querying the core-api from api-gateway */
  Account = 'Account',
  /** Represents a caller making a request to the authentication service from the api-gateway */
  ApiGateway = 'ApiGateway',
  /** Represents a caller, who is a Buffer Admin, querying the core-api from api-gateway */
  BufferAdmin = 'BufferAdmin',
  /** Represents a caller querying the core-api from an internal service */
  InternalService = 'InternalService',
  /** Represents a caller who are authenticated using a Publish access token */
  LegacyClient = 'LegacyClient',
  /** NullActor to be used in test to represent a request that is not authenticated */
  NullActor = 'NullActor',
  /** For request coming from the legacy RPC API */
  RpcClient = 'RpcClient',
  /** Represents a script using some of the use cases */
  Script = 'Script'
}

export type AddEntityNoteInput = {
  entityId: Scalars['String']['input'];
  entityType: EntityWithNotes;
  noteType: NoteType;
  text: Scalars['String']['input'];
};

export type AddEntityNotePayload = AddEntityNoteResponse | CoreWebAppCommonError;

export type AddEntityNoteResponse = {
  __typename?: 'AddEntityNoteResponse';
  entityId: Scalars['String']['output'];
  entityType: EntityWithNotes;
  noteId: Scalars['String']['output'];
};

/** Input to pass when creating a Note */
export type AddNoteToPostInput = {
  /** The id of post */
  postId: Scalars['PostId']['input'];
  /** The content of note to create */
  text: Scalars['String']['input'];
};

/** Create note request response payload. */
export type AddNoteToPostPayload = AddNoteToPostSuccess | InvalidInputError | LimitReachedError | NotFoundError | UnauthorizedError | UnexpectedError;

/** Success response returns the full up-to-date post from after the note was created */
export type AddNoteToPostSuccess = {
  __typename?: 'AddNoteToPostSuccess';
  /** Post on which the note was successfully created */
  post: Post;
};

export type AddOrUpdateDismissedObjectError = {
  __typename?: 'AddOrUpdateDismissedObjectError';
  /** A raw error message to help developers understand the root cause of the issue. */
  cause: Scalars['String']['output'];
  /** A user-friendly message that is safe to be displayed to users. */
  userFriendlyMessage: Scalars['String']['output'];
};

export type AddOrUpdateDismissedObjectPayload = AddOrUpdateDismissedObjectError | AddOrUpdateDismissedObjectResponse;

export type AddOrUpdateDismissedObjectResponse = {
  __typename?: 'AddOrUpdateDismissedObjectResponse';
  success: Scalars['Boolean']['output'];
};

/** Input for addPostToContentItem. */
export type AddPostToContentItemInput = {
  /** The content item to add the post to. */
  id: Scalars['ContentItemId']['input'];
  /**
   * The post to add. The post must already exist. The post and the content item
   * must belong to the same organization.
   */
  postId: Scalars['PostId']['input'];
};

/** All possible responses for addPostToContentItem. */
export type AddPostToContentItemPayload = AddPostToContentItemSuccess | VoidMutationError;

/** Successful addPostToContentItem response. */
export type AddPostToContentItemSuccess = {
  __typename?: 'AddPostToContentItemSuccess';
  /** The content item after the mutation added the post. */
  contentItem: ContentItem;
  /**
   * The post after the mutation added it. Its contentItemId names this content
   * item.
   */
  post: Post;
};

/** addPostToQueue mutation schedule to the next available post by id. */
export type AddPostToQueueInput = {
  /** Post id to schedule to the next available slot. */
  id: Scalars['PostId']['input'];
};

/** All possible response types that can be returned by addPostToQueue mutation. */
export type AddPostToQueuePayload = LimitReachedError | NotFoundError | PostActionSuccess | RestProxyError | UnauthorizedError | UnexpectedError;

/** Input for the mutation to add a shop grid custom link */
export type AddShopGridCustomLinkInput = {
  /** The ID of the channel */
  channelId: Scalars['ChannelId']['input'];
  /** Link text to be saved */
  text: Scalars['String']['input'];
  /** URL to be saved */
  url: Scalars['String']['input'];
};

export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

/** Affiliate program information for the account */
export type AffiliateData = {
  __typename?: 'AffiliateData';
  /** Data used to embed the affiliate dashboard within Buffer */
  embedData: AffiliateEmbedData;
  /** The affiliate program ID. Only available for admins and internal services. */
  programId?: Maybe<Scalars['String']['output']>;
  /** The current status of the account's affiliate enrollment */
  status: AffiliateStatus;
};

/** Information for embedding the affiliate dashboard within Buffer */
export type AffiliateEmbedData = {
  __typename?: 'AffiliateEmbedData';
  /** Embed token for the affiliate dashboard */
  token: Scalars['String']['output'];
  /** Expiration date of the embed token */
  tokenExpiresAt: Scalars['DateTime']['output'];
};

/** Affiliate status enum */
export enum AffiliateStatus {
  /** Account is actively enrolled in the affiliate program */
  Active = 'active',
  /** Account is not enrolled in the affiliate program */
  NotEnrolled = 'notEnrolled',
  /** Affiliate application is pending review */
  Pending = 'pending',
  /** Affiliate application was rejected */
  Rejected = 'rejected',
  /** Affiliate access has been revoked */
  Revoked = 'revoked'
}

/**
 * Aggregated post metrics across a filtered post set. Each entry in
 * `metrics` mirrors the shape of a `Post.metrics` entry; the total number
 * of matched posts is carried as a regular `PostMetric` entry with
 * `type: postCount`.
 */
export type AggregatedPostMetrics = {
  __typename?: 'AggregatedPostMetrics';
  /**
   * Normalized metric aggregates across the matched posts. Always includes
   * a baseline trio (`postCount`, `reactions`, `comments`) — posts on
   * networks that don't track reactions or comments contribute 0 to those
   * totals. Beyond the baseline, additional metric types are included only
   * when every channel in the filter set supports them.
   */
  metrics: Array<PostMetric>;
  /**
   * The latest `metricsUpdatedAt` across the matched posts, indicating the
   * freshness of the aggregate. Metrics are refreshed daily, so values can
   * be up to ~24h behind the source network. Null when no posts matched
   * the filter.
   */
  metricsUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Input for the `aggregatedPostMetrics` query. */
export type AggregatedPostMetricsInput = {
  /**
   * Optional list of channel IDs to filter by. When omitted (null), the
   * aggregate spans every channel in the organization the actor has
   * insights access to. When set to an empty array, no channels match and
   * the result is empty.
   */
  channelIds?: InputMaybe<Array<Scalars['ChannelId']['input']>>;
  /**
   * End of the aggregation window. Consumers typically pass UTC midnight of
   * the last calendar day in the window (the backend treats the range as
   * inclusive of that day), for example `2026-01-31T00:00:00Z`. Date range
   * is capped to 365 days.
   */
  endDateTime: Scalars['DateTime']['input'];
  /** The organization ID */
  organizationId: Scalars['OrganizationId']['input'];
  /**
   * Start of the aggregation window. Consumers typically pass UTC midnight
   * of the first calendar day in the window, for example
   * `2026-01-01T00:00:00Z`.
   */
  startDateTime: Scalars['DateTime']['input'];
  /**
   * Filter to posts with specific tags.
   * When omitted, all posts are included regardless of tags.
   */
  tags?: InputMaybe<TagComparator>;
};

/** AI features supported for an engagement type. Grows additively. */
export enum AiFeature {
  Insights = 'insights',
  Suggestions = 'suggestions'
}

/** An Alipay payment method. */
export type AlipayPaymentMethodDetails = {
  __typename?: 'AlipayPaymentMethodDetails';
  /** A human-readable description of the Alipay account. */
  displayName: Scalars['String']['output'];
};

/** Aggregated post insights across all channels */
export type AllChannelsPostInsights = {
  __typename?: 'AllChannelsPostInsights';
  /** Per-channel insights summaries */
  channelInsights: Array<ChannelInsightsSummary>;
  /** Per-channel time series data */
  channelTimeSeries: Array<ChannelInsightsTimeSeries>;
  /**
   * Aggregated summary metrics across the filtered channel set.
   * Always includes posts, followers, reactions, and comments. Dynamically adds richer metrics
   * (reach, impressions, engagement rate, etc.) when every network in the filtered set supports them.
   */
  summary: Array<InsightsSummaryMetric>;
};

/** Input for fetching post insights across all channels */
export type AllChannelsPostInsightsInput = {
  /** Optional list of channel IDs to filter by */
  channelIds?: InputMaybe<Array<Scalars['ChannelId']['input']>>;
  /**
   * Optional explicit comparison period end date. Must be provided together
   * with `comparisonStartDate`.
   */
  comparisonEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * Optional explicit comparison period start date. Must be provided together
   * with `comparisonEndDate`. When provided, `channelTimeSeries[].comparison`
   * is populated for the chosen window. When omitted, `comparison` is null
   * and `summary[].difference` falls back to the equal-length period
   * immediately before `[startDate, endDate]`.
   * Mismatched-length comparisons are allowed; clients should warn users when
   * the comparison length differs from the primary length, since sum-based
   * summary metrics (`postCount`, `reactions`, `comments`) have window-size-
   * dependent denominators.
   */
  comparisonStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The end date */
  endDate: Scalars['DateTime']['input'];
  /** The organization ID */
  organizationId: Scalars['OrganizationId']['input'];
  /**
   * Filter insights to posts of specific formats. Same rules as
   * `InsightsFilterInput.postTypes`.
   *
   * Followers are not affected — they come from daily channel snapshots rather
   * than from posts, so no post filter can narrow them.
   */
  postTypes?: InputMaybe<Array<PostType>>;
  /** The start date */
  startDate: Scalars['DateTime']['input'];
  /**
   * Filter insights to posts with specific tags.
   * When omitted, all posts are included regardless of tags.
   */
  tags?: InputMaybe<TagComparator>;
};

export type AlphaFeature = {
  __typename?: 'AlphaFeature';
  description: Scalars['String']['output'];
  feedbackUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  platforms: Array<FeaturePlatform>;
  rolloutStatus?: Maybe<RolloutStatus>;
  splitName: Scalars['String']['output'];
};

/** An Amazon Pay payment method. */
export type AmazonPayPaymentMethodDetails = {
  __typename?: 'AmazonPayPaymentMethodDetails';
  /** A human-readable description of the Amazon Pay account. */
  displayName: Scalars['String']['output'];
};

/** Represents a fixed amount discount. */
export type AmountDiscount = BaseDiscount & {
  __typename?: 'AmountDiscount';
  /** The currency for the discount amount as an uppercase, three-letter ISO 4217 currency code (e.g., "USD", "EUR") */
  currency: Scalars['String']['output'];
  /** How long the discount should remain active */
  duration: DiscountDuration;
  /**
   * For repeating discounts, specifies the number of months the discount repeats for.
   * Only applicable when duration is 'repeating'.
   */
  durationInMonths?: Maybe<Scalars['Int']['output']>;
  /** External identifier from the payment gateway (e.g., Stripe discount ID) */
  gatewayId?: Maybe<Scalars['String']['output']>;
  /** Human-readable name for the discount */
  name: Scalars['String']['output'];
  /** The scope of the discount - whether it applies to the entire customer or just a specific subscription */
  scope: DiscountScope;
  /** The amount of the discount in cents. */
  value: Scalars['Int']['output'];
};

export type AnalyticsAnswer = {
  __typename?: 'AnalyticsAnswer';
  best?: Maybe<Scalars['String']['output']>;
  metrics?: Maybe<Array<Maybe<AnalyticsAnswersMetric>>>;
};

export type AnalyticsAnswers = {
  __typename?: 'AnalyticsAnswers';
  day: AnalyticsAnswer;
  frequency: AnalyticsAnswer;
  type: AnalyticsAnswer;
};

export type AnalyticsAnswersMetric = {
  __typename?: 'AnalyticsAnswersMetric';
  key: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type AnalyticsContent = {
  __typename?: 'AnalyticsContent';
  description?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type AnalyticsDaily = {
  __typename?: 'AnalyticsDaily';
  day: Scalars['Date']['output'];
  organic: AnalyticsDailyStatisticsOrganic;
  paid?: Maybe<AnalyticsDailyStatisticsPaid>;
  previousDay?: Maybe<Scalars['Date']['output']>;
  previousOrganic?: Maybe<AnalyticsDailyStatisticsOrganic>;
  previousPaid?: Maybe<AnalyticsDailyStatisticsPaid>;
  serviceId: Scalars['String']['output'];
  serviceType: Scalars['String']['output'];
};

export type AnalyticsDailyStatisticsOrganic = {
  __typename?: 'AnalyticsDailyStatisticsOrganic';
  clicks?: Maybe<Scalars['Int']['output']>;
  comments?: Maybe<Scalars['Int']['output']>;
  engagementRate?: Maybe<Scalars['Float']['output']>;
  engagements?: Maybe<Scalars['Int']['output']>;
  followers?: Maybe<Scalars['Int']['output']>;
  followersGainOrganic?: Maybe<Scalars['Int']['output']>;
  impressions?: Maybe<Scalars['Int']['output']>;
  likes?: Maybe<Scalars['Int']['output']>;
  pageViews?: Maybe<Scalars['Int']['output']>;
  postsCount?: Maybe<Scalars['Int']['output']>;
  shares?: Maybe<Scalars['Int']['output']>;
};

export type AnalyticsDailyStatisticsPaid = {
  __typename?: 'AnalyticsDailyStatisticsPaid';
  followersGainPaid?: Maybe<Scalars['Int']['output']>;
};

export type AnalyticsHashtag = {
  __typename?: 'AnalyticsHashtag';
  avgClicks?: Maybe<Scalars['Float']['output']>;
  avgComments?: Maybe<Scalars['Float']['output']>;
  avgEngagement?: Maybe<Scalars['Float']['output']>;
  avgEngagementRate?: Maybe<Scalars['Float']['output']>;
  avgImpressions?: Maybe<Scalars['Float']['output']>;
  avgLikes?: Maybe<Scalars['Float']['output']>;
  avgMentions?: Maybe<Scalars['Float']['output']>;
  avgShares?: Maybe<Scalars['Float']['output']>;
  displayName: Scalars['String']['output'];
  postsCount: Scalars['Int']['output'];
};

export type AnalyticsLastUpdatedAtInput = {
  channelId: Scalars['String']['input'];
  ingestionType: ChannelIngestionType;
  organizationId: Scalars['String']['input'];
};

export type AnalyticsOrderByField = {
  field: AnalyticsSortFields;
  order: AnalyticsSortOrder;
};

export type AnalyticsPeriodPostStatistics = {
  __typename?: 'AnalyticsPeriodPostStatistics';
  clicks?: Maybe<Scalars['Int']['output']>;
  comments?: Maybe<Scalars['Int']['output']>;
  engagementRate?: Maybe<Scalars['Float']['output']>;
  engagements?: Maybe<Scalars['Int']['output']>;
  impressions?: Maybe<Scalars['Int']['output']>;
  likes?: Maybe<Scalars['Int']['output']>;
  mentions?: Maybe<Scalars['Int']['output']>;
  postsCount: Scalars['Int']['output'];
  shares?: Maybe<Scalars['Int']['output']>;
};

export type AnalyticsPost = {
  __typename?: 'AnalyticsPost';
  content?: Maybe<AnalyticsContent>;
  id: Scalars['String']['output'];
  postId: Scalars['String']['output'];
  sentAt: Scalars['DateTime']['output'];
  serviceId: Scalars['String']['output'];
  serviceType: Scalars['String']['output'];
  statistics?: Maybe<AnalyticsPostStatistics>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AnalyticsPostStatistics = {
  __typename?: 'AnalyticsPostStatistics';
  clicks?: Maybe<Scalars['Int']['output']>;
  comments?: Maybe<Scalars['Int']['output']>;
  engagementRate?: Maybe<Scalars['Float']['output']>;
  engagements?: Maybe<Scalars['Int']['output']>;
  impressions?: Maybe<Scalars['Int']['output']>;
  likes?: Maybe<Scalars['Int']['output']>;
  mentions?: Maybe<Scalars['Int']['output']>;
  shares?: Maybe<Scalars['Int']['output']>;
};

export type AnalyticsPostsTotals = {
  __typename?: 'AnalyticsPostsTotals';
  organic: AnalyticsPeriodPostStatistics;
  paid?: Maybe<AnalyticsPeriodPostStatistics>;
  previousOrganic?: Maybe<AnalyticsPeriodPostStatistics>;
};

export enum AnalyticsSortFields {
  Clicks = 'CLICKS',
  Comments = 'COMMENTS',
  Engagements = 'ENGAGEMENTS',
  EngagementRate = 'ENGAGEMENT_RATE',
  Impressions = 'IMPRESSIONS',
  Likes = 'LIKES',
  Mentions = 'MENTIONS',
  SentAt = 'SENT_AT',
  Shares = 'SHARES'
}

export enum AnalyticsSortOrder {
  /** Sort records in ascending order. */
  Asc = 'ASC',
  /** Sort records in descending order. */
  Desc = 'DESC'
}

export type AnalyticsTotals = {
  __typename?: 'AnalyticsTotals';
  organic: AnalyticsDailyStatisticsOrganic;
  paid?: Maybe<AnalyticsDailyStatisticsPaid>;
  previousOrganic?: Maybe<AnalyticsDailyStatisticsOrganic>;
  previousPaid?: Maybe<AnalyticsDailyStatisticsPaid>;
  serviceId: Scalars['String']['output'];
  serviceType: Scalars['String']['output'];
};

/** Annotation representing all the entities in the text */
export type Annotation = {
  __typename?: 'Annotation';
  /**
   * The content of the annotation. Annotations can sometimes be different from the actual text content.
   * E.g., Mastodon mentions have 'text: @buffer', but includes the server name in the content, 'content: @buffer@threads.net'
   */
  content: Scalars['String']['output'];
  /** The display value, when present */
  displayValue?: Maybe<Scalars['String']['output']>;
  /** The indices of the annotation in the text */
  indices: Array<Scalars['Int']['output']>;
  /** The service entity ID, when present */
  serviceEntityId?: Maybe<Scalars['String']['output']>;
  /** The text representation of the annotation, eg '@buffer' */
  text: Scalars['String']['output'];
  /** The type of the annotation */
  type: AnnotationType;
  /** The URL the annotation points to */
  url: Scalars['String']['output'];
};

/** An annotation in text input. */
export type AnnotationInput = {
  /** The text content in the annotation span. */
  content: Scalars['String']['input'];
  /** The display value, when present. */
  displayValue?: InputMaybe<Scalars['String']['input']>;
  /** The start and exclusive end offsets in the text. */
  indices: Array<Scalars['Int']['input']>;
  /** The service entity ID, when present. */
  serviceEntityId?: InputMaybe<Scalars['String']['input']>;
  /** The text representation of the annotation. */
  text: Scalars['String']['input'];
  /** The annotation type. */
  type: AnnotationType;
  /** The annotation URL, when present. */
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Annotation representing all the entities in the text */
export type AnnotationInputFacebook = {
  /** The content of the annotation, e.g. '107509875938399' */
  content: Scalars['String']['input'];
  /** The indices of the annotation in the text, e.g. [6, 9] (from 6 to 9 characters in the text) */
  indices: Array<Scalars['Int']['input']>;
  /** The text representation of the annotation, eg 'Buffer' */
  text: Scalars['String']['input'];
  /** The URL the annotation points to, e.g. https://www.facebook.com/107509875938399 */
  url: Scalars['String']['input'];
};

/** Annotation representing all the entities in the text */
export type AnnotationInputLinkedIn = {
  /** The entity of the annotation, e.g. urn:li:organization:1521226 */
  entity: Scalars['String']['input'];
  /** The id of the annotation, e.g. 1521226 */
  id: Scalars['String']['input'];
  /** The length of the annotation, e.g. 6 */
  length: Scalars['Int']['input'];
  /** The link of the annotation, e.g. https://www.linkedin.com/company/bufferapp */
  link: Scalars['String']['input'];
  /** The localized name of the annotation, e.g. Buffer */
  localizedName: Scalars['String']['input'];
  /** The start of the annotation, e.g. 5 */
  start: Scalars['Int']['input'];
  /** The vanity name of the annotation, e.g. bufferapp */
  vanityName: Scalars['String']['input'];
};

/** List of possible types for an annotation */
export enum AnnotationType {
  Annotation = 'annotation',
  Bold = 'bold',
  BulletedListItem = 'bulletedListItem',
  Cashtag = 'cashtag',
  Hashtag = 'hashtag',
  Heading = 'heading',
  Italic = 'italic',
  Mention = 'mention',
  OrderedListItem = 'orderedListItem',
  Strikethrough = 'strikethrough',
  Url = 'url'
}

/** Input for a signed anonymous media access URL. */
export type AnonymousMediaAccessInput = {
  /** Stable identifier URL from the upload request. */
  assetUrl: Scalars['String']['input'];
  /**
   * Original file name for an attachment download.
   * Omit this field for a preview URL.
   */
  downloadFileName?: InputMaybe<Scalars['String']['input']>;
};

/** Result of the anonymousMediaAccess query. */
export type AnonymousMediaAccessPayload = AnonymousMediaAccessSuccess | InvalidInputError | LimitReachedError;

/** Successful result for an anonymous media access request. */
export type AnonymousMediaAccessSuccess = {
  __typename?: 'AnonymousMediaAccessSuccess';
  /** Short-lived signed URL for the file. */
  accessUrl: Scalars['String']['output'];
  /** Fixed time when the uploaded file expires. */
  assetExpiresAt: Scalars['DateTime']['output'];
};

/** A field for the signed anonymous media upload form. */
export type AnonymousMediaUploadField = {
  __typename?: 'AnonymousMediaUploadField';
  /** Form field name. */
  name: Scalars['String']['output'];
  /** Form field value. */
  value: Scalars['String']['output'];
};

/** Approve Post request. */
export type ApprovePostInput = {
  /** Post id to approve. */
  id: Scalars['PostId']['input'];
};

/** Reject approval request response payload. */
export type ApprovePostPayload = LimitReachedError | NotFoundError | PostActionSuccess | RestProxyError | UnauthorizedError | UnexpectedError;

/** Asset interface with common fields */
export type Asset = {
  /** The ID of the asset in the database */
  id?: Maybe<Scalars['ID']['output']>;
  /** The MIME type of the asset */
  mimeType: Scalars['String']['output'];
  /** URL to the file source */
  source: Scalars['String']['output'];
  /** URL to the static thumbnail of the asset */
  thumbnail: Scalars['String']['output'];
  /** The type of the asset */
  type: AssetType;
};

/** A single entity's asset. Exactly one variant must be provided. */
export type AssetInput =
  /** Document asset */
  { document: DocumentAssetInput; image?: never; link?: never; video?: never; }
  |  /** Image asset */
  { document?: never; image: ImageAssetInput; link?: never; video?: never; }
  |  /**
   * Use metadata.{service}.linkAttachment instead. This field will be removed on December 15, 2026.
   * @deprecated Use metadata.{service}.linkAttachment instead. This field will be removed on December 15, 2026.
   */
  { document?: never; image?: never; link: LinkAssetInput; video?: never; }
  |  /** Video asset */
  { document?: never; image?: never; link?: never; video: VideoAssetInput; };

/** Asset types */
export enum AssetType {
  Document = 'document',
  Image = 'image',
  Video = 'video'
}

/** A channel available for assignment to team members */
export type AssignableChannel = {
  __typename?: 'AssignableChannel';
  /** The channel */
  channel: Channel;
  /**
   * The member's current per-product access for this channel, keyed by
   * product (all `none` if not assigned). Resolved via the per-product
   * access resolver so the split rollout and legacy rows are consistent.
   */
  currentProductAccessLevels: ChannelProductAccessLevels;
};

/** Input for assignableChannels query */
export type AssignableChannelsInput = {
  /**
   * The Account ID of the team member to check current assignments for.
   * If not provided, all channels will be returned with currentProductAccessLevels
   * set to `none` for each product.
   * This is useful when inviting new team members who don't have an accountId yet.
   */
  accountId?: InputMaybe<Scalars['AccountId']['input']>;
  /** The organization ID */
  organizationId: Scalars['OrganizationId']['input'];
};

export type AttributionInput = {
  cta?: InputMaybe<Scalars['String']['input']>;
  upgradePathName?: InputMaybe<Scalars['String']['input']>;
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmContent?: InputMaybe<Scalars['String']['input']>;
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
  utmTerm?: InputMaybe<Scalars['String']['input']>;
};

export enum AuthConnectionFlowType {
  Multi = 'multi',
  Single = 'single'
}

/** Represent the author of a post or note. */
export type Author = {
  __typename?: 'Author';
  /** The avatar URL of the author. */
  avatar: Scalars['String']['output'];
  /** The email address of the author. */
  email: Scalars['String']['output'];
  /** The unique identifier of the author. */
  id: Scalars['AccountId']['output'];
  /** Indicates whether the author is a deleted. */
  isDeleted: Scalars['Boolean']['output'];
  /** The name of the author. Null if the user has not yet set a name. */
  name?: Maybe<Scalars['String']['output']>;
  /**
   * The Buffer account URN for this author, in the form
   * `urn:buffer:account:<account-id>`. Null when the author is deleted or the
   * account ID is missing or invalid. A URN identifies an account. It does not
   * prove that the account exists, that the caller has access, or that the
   * account can be mentioned.
   */
  urn?: Maybe<Scalars['String']['output']>;
};

/** Represents the authorization evaluation result for a feature. */
export enum AuthorizationStatus {
  /** Authorization exists but requires token refresh */
  NeedsRefresh = 'needsRefresh',
  /**
   * The client version is below the minimum required to access this feature.
   * The client should prompt the user to upgrade.
   */
  NeedsUpgrade = 'needsUpgrade',
  /**
   * Insufficient data to determine authorization state.
   * Typically indicates missing scopes or webhook metadata.
   */
  NotEnoughData = 'notEnoughData',
  /**
   * The connected platform user's role/permissions are insufficient for this
   * feature, so reconnecting with the same user cannot fix it. Clients should
   * prompt the user to contact an administrator of the platform account (or
   * have one connect the channel) instead of offering a reconnect.
   */
  NotEnoughRights = 'notEnoughRights',
  /** Authorization is valid and the feature can be used. */
  Ok = 'ok'
}

export type AuthorizeChannelsError = {
  __typename?: 'AuthorizeChannelsError';
  /** A raw error message to help developers understand the root cause of the issue. */
  cause: Scalars['String']['output'];
  /** An enum representing the type of error that occurred. */
  errorType: ChannelAuthorizationErrorType;
  /** A user-friendly message that is safe to be displayed to users. */
  userFriendlyMessage: Scalars['String']['output'];
};

export type AuthorizeChannelsPayload = AuthorizeChannelsError | AuthorizeChannelsResponse;

export type AuthorizeChannelsResponse = {
  __typename?: 'AuthorizeChannelsResponse';
  channels: Array<Channel>;
};

/** Input for backfilling channel analytics */
export type BackfillChannelAnalyticsInput = {
  /** The channel id to backfill analytics for */
  channelId: Scalars['ChannelId']['input'];
};

/** BackfillChannelAnalytics possible responses */
export type BackfillChannelAnalyticsPayload = BackfillChannelAnalyticsSuccess | VoidMutationError;

/** Success response for backfillChannelAnalytics mutation */
export type BackfillChannelAnalyticsSuccess = MutationSuccess & {
  __typename?: 'BackfillChannelAnalyticsSuccess';
  /**
   * The value is always an empty string ''
   * Note: GraphQL doesn't allow types with no fields, so we have to add this field
   */
  _empty: Scalars['String']['output'];
};

export type BackfillChannelPostsAndAnalyticsPayload = BasicError | MutationBasicResponse;

export type BackfillChannelUpdatesResponse = Error | Response;

/** Input for backfilling the updates for grid preview */
export type BackfillUpdatesForGridInput = {
  /** The channel id to backfill updates for */
  channelId: Scalars['ChannelId']['input'];
};

/**
 * The payload of the response from backfillUpdatesForGrid.
 * Since it requires internal client, UnauthorizedError is thrown
 * for unofficial clients. If the rate limit is hit, the response
 * is still successful to not throw too many errors at the client.
 */
export type BackfillUpdatesForGridPayload = BackfillUpdatesForGridResponse | InvalidInputError | NotFoundError | UnauthorizedError | UnexpectedError;

/** success response for updateLastActivityAtForChannel mutation */
export type BackfillUpdatesForGridResponse = MutationSuccess & {
  __typename?: 'BackfillUpdatesForGridResponse';
  /**
   * The value is always an empty string ''
   * Note: GraphQL doesn't allow types with no fields, so we have to add this field
   */
  _empty: Scalars['String']['output'];
};

/** A bank account (ACH) payment method. */
export type BankPaymentMethodDetails = {
  __typename?: 'BankPaymentMethodDetails';
  /**
   * The name of the bank, if available (e.g. "Chase", "Bank of America").
   * Typically available for US bank accounts but not SEPA.
   */
  bankName?: Maybe<Scalars['String']['output']>;
  /** A human-readable description of the bank account (e.g. "Chase ****4242"). */
  displayName: Scalars['String']['output'];
  /** The last four digits of the bank account number or IBAN. */
  last4: Scalars['String']['output'];
};

/** Represents the main information for a comment in the system. */
export type BaseComment = {
  /** Media attachments associated with the comment. */
  assets: Array<Asset>;
  /** Information about the author of the comment. */
  author: CommentAuthor;
  /** The ID of the channel that the comment belongs to. */
  channelId: Scalars['ChannelId']['output'];
  /**
   * The kind of content carried by the comment (text, image, unsupported, ...).
   * Useful when `text` is empty and `assets` is empty — e.g. `unsupported` for
   * TikTok sticker-only comments — so clients can render a placeholder.
   */
  contentType: CommentContentType;
  /** The timestamp when the comment was created in the system. */
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the comment */
  id: Scalars['CommentId']['output'];
  /** Whether the comment is deleted by the third party. */
  isDeleted: Scalars['Boolean']['output'];
  /** Whether the comment is hidden. */
  isHidden: Scalars['Boolean']['output'];
  /**
   * Whether this comment is an own reply. The comment has been
   * sent by the user using Buffer or natively.
   */
  isOwnReply: Scalars['Boolean']['output'];
  /** Replies to this comment. */
  lastReplies?: Maybe<Array<LastReply>>;
  /** Service-specific metadata for the comment (e.g., Google Business review details). */
  metadata?: Maybe<CommentMetadata>;
  /** The ID of the organization that owns the comment. */
  organizationId: Scalars['OrganizationId']['output'];
  /**
   * The ID of the parent comment, if applicable.
   * We set this value in replies to comments as the id of the replied comment.
   * For top-level comments (replies to post) will be null.
   */
  parentId?: Maybe<Scalars['CommentId']['output']>;
  /** BaseComment: Refers to the post the comment belongs to. */
  post: Post;
  /** The timestamp when the related post was published on the third-party service. */
  postPublishedAt: Scalars['DateTime']['output'];
  /**
   * URL of the comment on the third-party service. It could be undefined
   * if the comment hasn't be published yet.
   */
  publicUrl?: Maybe<Scalars['String']['output']>;
  /**
   * The timestamp when this comment was created on the third-party service. It could be undefined
   *   if the comment hasn't be published yet.
   */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Reactions to the comment. */
  reactions: Array<Reaction>;
  /**
   * The time difference in seconds between the comment's publication and a response.
   * For top-level comments is the difference between post's publication and this
   * comment's creation, calculated even if the comment fails to be sent.
   */
  responseTimeDiffInSeconds: Scalars['Int']['output'];
  /** The type of service the comment belongs to: threads, facebook, etc */
  serviceType: Service;
  /** The status of the comment (e.g., unreplied, replied, dismissed). */
  status: CommentStatus;
  /**
   * The text content of the comment. It could be empty. Comments could have
   * text and/or assets and we're making them both mandatory to avoid the case
   * where none of them could be provided.
   */
  text: Scalars['String']['output'];
  /** The timestamp when the comment was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /**
   * User rating for review-based platforms (e.g., Google Business star ratings).
   * Integer value typically 1-5. Only applicable for platforms that support reviews with ratings.
   * @deprecated Use metadata { ... on GoogleBusinessCommentMetadata { userRating } }
   */
  userRating?: Maybe<Scalars['Int']['output']>;
};

/** An interface for a base discount that can be applied to a plan. */
export type BaseDiscount = {
  /** How long the discount should remain active */
  duration: DiscountDuration;
  /**
   * For repeating discounts, specifies the number of months the discount repeats for.
   * Only applicable when duration is 'repeating'.
   */
  durationInMonths?: Maybe<Scalars['Int']['output']>;
  /** External identifier from the payment gateway (e.g., Stripe discount ID) */
  gatewayId?: Maybe<Scalars['String']['output']>;
  /** Human-readable name for the discount */
  name: Scalars['String']['output'];
  /** The scope of the discount - whether it applies to the entire customer or just a specific subscription */
  scope: DiscountScope;
};

export type BaseResponse = Error | Response;

/** Basic information about a channel. */
export type BasicChannelInfo = {
  __typename?: 'BasicChannelInfo';
  /** The avatar URL of the channel */
  avatar?: Maybe<Scalars['String']['output']>;
  /** The display name of the channel */
  displayName: Scalars['String']['output'];
  /** The service ID of the channel */
  serviceId: Scalars['String']['output'];
};

export type BasicError = MutationBasicError & {
  __typename?: 'BasicError';
  /** A raw error message to help developers understand the root cause of the issue. */
  cause: Scalars['String']['output'];
  /** A user-friendly message that is safe to be displayed to users. */
  userFriendlyMessage: Scalars['String']['output'];
};

/** Distribution of values for a benchmark's comparison cohort. */
export type BenchmarkComparison = {
  __typename?: 'BenchmarkComparison';
  /** Percentile values for the comparison distribution. */
  percentiles: BenchmarkPercentiles;
  /** Number of channels that contributed to this month's distribution. */
  sampleSize: Scalars['Int']['output'];
};

/** A single month of benchmark data for a channel. */
export type BenchmarkHistoryPoint = {
  __typename?: 'BenchmarkHistoryPoint';
  /**
   * Approximate percentile rank (0–100) of `channelValue` within the
   * month's comparison distribution, interpolated from the stored
   * p10/p25/p50/p75/p90 percentiles. Null when `channelValue` or
   * `comparison` is null.
   */
  channelPercentileRank?: Maybe<Scalars['Float']['output']>;
  /**
   * The channel's value for the month. Null when the channel had no data
   * or did not meet the metric's inclusion criteria.
   */
  channelValue?: Maybe<Scalars['Float']['output']>;
  /**
   * Distribution of values for the comparison cohort this month. Null
   * when no benchmark data exists for this month yet.
   */
  comparison?: Maybe<BenchmarkComparison>;
  /** First day of the month, at UTC midnight. */
  month: Scalars['DateTime']['output'];
};

/** Identifier for a benchmark metric. */
export enum BenchmarkMetricType {
  /** Monthly follower growth rate. */
  FollowerGrowth = 'followerGrowth'
}

/** Percentile values for a benchmark distribution. */
export type BenchmarkPercentiles = {
  __typename?: 'BenchmarkPercentiles';
  /** 10th percentile. */
  p10: Scalars['Float']['output'];
  /** 25th percentile. */
  p25: Scalars['Float']['output'];
  /** Median. */
  p50: Scalars['Float']['output'];
  /** 75th percentile. */
  p75: Scalars['Float']['output'];
  /** 90th percentile. */
  p90: Scalars['Float']['output'];
};

export type BetaFeature = {
  __typename?: 'BetaFeature';
  description: Scalars['String']['output'];
  feedbackUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  platforms: Array<FeaturePlatform>;
  rolloutStatus?: Maybe<RolloutStatus>;
  splitName: Scalars['String']['output'];
};

/** Represents the billing details for both One Buffer and Multi-Products organizations. */
export type Billing = {
  address?: Maybe<Address>;
  balance: Scalars['Float']['output'];
  /** @deprecated Use `Organization.entitlements` and check for `analytics` instead. This field is computed from the same entitlement set. */
  canAccessAnalytics: Scalars['Boolean']['output'];
  /** @deprecated Use `Organization.entitlements` and check for `engagement` instead. This field is computed from the same entitlement set. */
  canAccessEngagement: Scalars['Boolean']['output'];
  /** @deprecated Use `Organization.entitlements` and check for `publishing` instead. This field is computed from the same entitlement set. */
  canAccessPublishing: Scalars['Boolean']['output'];
  canGenerateContent: Scalars['Boolean']['output'];
  discount?: Maybe<Discount>;
  gateway: GatewayDetails;
  /** Organization ID for which these billing details belong to */
  id: Scalars['String']['output'];
  isAutomaticTaxEnabled?: Maybe<Scalars['Boolean']['output']>;
  isSubscriptionTaxEnabled?: Maybe<Scalars['Boolean']['output']>;
  paymentDetails: PaymentDetails;
  previousGateway?: Maybe<GatewayDetails>;
  taxDetails?: Maybe<TaxDetails>;
  taxExempt?: Maybe<Scalars['String']['output']>;
  taxIds?: Maybe<Array<Maybe<TaxId>>>;
  upcomingInvoice?: Maybe<InvoiceDetails>;
  upcomingInvoiceAmount?: Maybe<Scalars['Float']['output']>;
};

/**
 * A billing address on file with the payment gateway. All fields are nullable
 * since Stripe allows partial address data.
 */
export type BillingAddress = {
  __typename?: 'BillingAddress';
  /** City or district. */
  city?: Maybe<Scalars['String']['output']>;
  /** Two-letter ISO 3166-1 alpha-2 country code (e.g. "US", "GB"). */
  country?: Maybe<Scalars['String']['output']>;
  /** First line of the address (e.g. street, PO box). */
  line1?: Maybe<Scalars['String']['output']>;
  /** Second line of the address (e.g. apartment, suite, unit). */
  line2?: Maybe<Scalars['String']['output']>;
  /** ZIP or postal code. */
  postalCode?: Maybe<Scalars['String']['output']>;
  /** State, county, province, or region. */
  state?: Maybe<Scalars['String']['output']>;
};

export type BillingCreateCheckoutSessionPayload = BillingCreateCheckoutSessionResponse | BillingError;

export type BillingCreateCheckoutSessionResponse = {
  __typename?: 'BillingCreateCheckoutSessionResponse';
  /** The url returned by Stripe as a redirect for success, failed, or cancelled session */
  redirectUrl: Scalars['String']['output'];
};

/** Deprecated in favor of the CreateCustomerPortalSessionPayload type. */
export type BillingCreateCustomerPortalSessionPayload = BillingCreateCustomerPortalSessionResponse | BillingError;

/** Deprecated in favor of the CreateCustomerPortalSessionResponse type. */
export type BillingCreateCustomerPortalSessionResponse = {
  __typename?: 'BillingCreateCustomerPortalSessionResponse';
  /** The customer session url returned by Stripe */
  customerPortalSessionUrl: Scalars['String']['output'];
};

export type BillingCreateSetupIntentResponse = {
  __typename?: 'BillingCreateSetupIntentResponse';
  /** The setup intent client secret returned by Stripe to use in the Stripe payment mehtod form */
  clientSecret: Scalars['String']['output'];
  /** Temporary because we need to declare a type for the union returned by the mutation. Ideally, we should evolve it with more meaningful data for the frontend. */
  success: Scalars['Boolean']['output'];
};

export type BillingCreatedSetupIntentPayload = BillingCreateSetupIntentResponse | BillingError;

/**
 * Common billing information shared across all billing platforms.
 * Use inline fragments to access platform-specific fields
 * (e.g. ... on WebBillingDetails or ... on MobileBillingDetails).
 */
export type BillingDetails = {
  /**
   * The email address used for billing notifications (invoices, payment failures, etc.).
   * Returns the custom billing email if set, otherwise the organization owner's email.
   */
  billingEmail: Scalars['String']['output'];
  /** Whether this organization is eligible to start a free trial. */
  canStartTrial: Scalars['Boolean']['output'];
  /** The current billing gateway processing payments for this organization. */
  gateway: BillingGatewayDetails;
  /** Whether this organization has ever had a paid subscription, across any gateway. */
  hasEverBeenPayingCustomer: Scalars['Boolean']['output'];
  /**
   * The previous billing gateway, if the organization has migrated between platforms
   * (e.g. Stripe to RevenueCat or vice versa). Null if no migration has occurred.
   */
  previousGateway?: Maybe<BillingGatewayDetails>;
  /** The organization's current subscription, including plan, billing cycle, and trial status. */
  subscription: BufferSubscription;
};

/** Error returned when billing email validation fails */
export type BillingEmailValidationError = MutationError & {
  __typename?: 'BillingEmailValidationError';
  /** The invalid email that was provided */
  invalidEmail: Scalars['String']['output'];
  /** Human-readable error message */
  message: Scalars['String']['output'];
};

export type BillingError = {
  __typename?: 'BillingError';
  /** A raw error message to help developers understand the root cause of the issue. */
  cause: Scalars['String']['output'];
  /** A user-friendly message that is safe to be displayed to users. */
  userFriendlyMessage: Scalars['String']['output'];
};

/** The payment processor or gateway handling the organization's billing. */
export enum BillingGateway {
  Android = 'android',
  Apple = 'apple',
  Bank = 'bank',
  Check = 'check',
  Gift = 'gift',
  None = 'none',
  Paypal = 'paypal',
  Revenuecat = 'revenuecat',
  Stripe = 'stripe'
}

/** Identifies which payment gateway processes an organization's billing. */
export type BillingGatewayDetails = {
  __typename?: 'BillingGatewayDetails';
  /** The payment gateway type (e.g. stripe, revenuecat, apple, none). */
  type: BillingGateway;
};

/** The platform on which the subscription was originally purchased. */
export enum BillingGatewayPlatform {
  Android = 'android',
  Apple = 'apple',
  Web = 'web'
}

export type BillingIncreaseSubscriptionQuantityByChannelIdsPayload = BillingError | BillingResponse;

/** Input for querying billing settings for an organization */
export type BillingInput = {
  /** The organization ID to fetch billing settings for */
  organizationId: Scalars['OrganizationId']['input'];
};

export enum BillingInterval {
  Month = 'month',
  Year = 'year'
}

export type BillingNotificationSet = {
  __typename?: 'BillingNotificationSet';
  shouldDowngradeMobileSubscription?: Maybe<Scalars['Boolean']['output']>;
  shouldUpgradeMobileSubscription?: Maybe<Scalars['Boolean']['output']>;
};

export type BillingResponse = {
  __typename?: 'BillingResponse';
  /** Temporary because we need to declare a type for the union returned by the mutation. Ideally, we should evolve it with more meaningful data for the frontend. */
  success: Scalars['Boolean']['output'];
};

export type BillingStartTrialPayload = BillingError | BillingResponse;

export enum BillingState {
  Free = 'free',
  Paid = 'paid',
  Trial = 'trial'
}

/** Tax configuration and registered tax IDs for a Stripe customer. */
export type BillingTaxDetails = {
  __typename?: 'BillingTaxDetails';
  /**
   * Whether Stripe could not determine the customer's tax location, typically
   * because no billing address is on file.
   */
  hasUnrecognizedTaxLocation: Scalars['Boolean']['output'];
  /** Whether Stripe Tax is enabled for automatic tax calculation on new invoices. */
  isAutomaticTaxEnabled: Scalars['Boolean']['output'];
  /** Whether the current subscription has automatic tax collection enabled. */
  isSubscriptionTaxEnabled: Scalars['Boolean']['output'];
  /**
   * The customer's tax-exempt status in Stripe (e.g. "exempt", "reverse", "none").
   * Kept as String rather than an enum since Stripe may add new values.
   */
  taxExempt?: Maybe<Scalars['String']['output']>;
  /** All tax IDs registered for this customer. */
  taxIds: Array<BillingTaxId>;
};

/** A tax identification number registered for the customer (e.g. VAT number, GST ID). */
export type BillingTaxId = {
  __typename?: 'BillingTaxId';
  /** The two-letter ISO country code for the tax ID (e.g. "US", "DE"). */
  country: Scalars['String']['output'];
  /** When the tax ID was added to the customer record. */
  createdAt: Scalars['DateTime']['output'];
  /** The Stripe tax ID type identifier (e.g. "eu_vat", "us_ein", "au_abn"). */
  type: Scalars['String']['output'];
  /** The tax ID value (e.g. "DE123456789", "12-3456789"). */
  value: Scalars['String']['output'];
  /** Verification details for this tax ID, including status and verified business information. */
  verification: BillingTaxIdVerification;
};

/** Verification details for a tax ID, including the verified business name and address. */
export type BillingTaxIdVerification = {
  __typename?: 'BillingTaxIdVerification';
  /** The current verification status of the tax ID. */
  status: BillingTaxIdVerificationStatus;
  /** The business address as verified by the tax authority. Empty string if not yet verified. */
  verifiedAddress: Scalars['String']['output'];
  /** The business name as verified by the tax authority. Empty string if not yet verified. */
  verifiedName: Scalars['String']['output'];
};

/** The verification status of a customer's tax ID as reported by Stripe. */
export enum BillingTaxIdVerificationStatus {
  /** Verification is in progress. */
  Pending = 'pending',
  /** Verification is not available for this tax ID type. */
  Unavailable = 'unavailable',
  /** The tax ID could not be verified. */
  Unverified = 'unverified',
  /** The tax ID has been successfully verified. */
  Verified = 'verified'
}

export type BillingUpdateCustomerPaymentMethodPayload = BillingError | BillingResponse;

/** The payload response of the billing mutations */
export type BillingUpdateSubscriptionPlanPayload = BillingError | BillingUpdateSubscriptionPlanResponse;

export type BillingUpdateSubscriptionPlanResponse = {
  __typename?: 'BillingUpdateSubscriptionPlanResponse';
  scheduledUpdate?: Maybe<ScheduledSubscriptionUpdate>;
  success: Scalars['Boolean']['output'];
};

export type BillingUpdateSubscriptionQuantityPayload = BillingError | BillingUpdateSubscriptionPlanResponse;

/** Input Types */
export type BlockConfigInput = {
  data?: InputMaybe<BlockDataInput>;
  type?: InputMaybe<StartPageBlockTypes>;
};

export type BlockDataInput = {
  backgroundMedia?: InputMaybe<MediaInput>;
  caption?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  htmlJson?: InputMaybe<Scalars['String']['input']>;
  htmlText?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  layout?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<Array<InputMaybe<LinkInput>>>;
  logoMedia?: InputMaybe<MediaInput>;
  media?: InputMaybe<MediaInput>;
  overlay?: InputMaybe<Scalars['Int']['input']>;
  serviceId?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type BlockMutationResponse = BlockMutationSuccess | CommonError;

/** Query / Mutation responses */
export type BlockMutationSuccess = MutationResponse & {
  __typename?: 'BlockMutationSuccess';
  block?: Maybe<StartPageBlock>;
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  mutation: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type BlocksMutationResponse = BlocksMutationSuccess | CommonError;

export type BlocksMutationSuccess = MutationResponse & {
  __typename?: 'BlocksMutationSuccess';
  blocks?: Maybe<Array<Maybe<StartPageBlock>>>;
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  mutation: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

/** Bluesky metadata */
export type BlueskyMetadata = {
  __typename?: 'BlueskyMetadata';
  /** The instance of bluesky of the channel */
  serverUrl: Scalars['String']['output'];
};

/** Bluesky post metadata */
export type BlueskyPostMetadata = CommonPostMetadata & ThreadedPostMetadata & {
  __typename?: 'BlueskyPostMetadata';
  /** Annotations representing entities in the text */
  annotations: Array<Annotation>;
  /** Link attachment */
  linkAttachment?: Maybe<LinkAttachment>;
  /** The list of threaded posts (not paginated) */
  thread: Array<ThreadedPost>;
  /** The number of threaded posts */
  threadCount: Scalars['Int']['output'];
  /** The channel-specific type of the post, eg, post, story, reel for Instagram */
  type: PostType;
};

/** Bluesky post metadata */
export type BlueskyPostMetadataInput = {
  /** Link attachment. Mutually exclusive with a non-empty `assets` array — input providing both is rejected. */
  linkAttachment?: InputMaybe<LinkAttachmentInput>;
  /**
   * The ordered list of posts that make up the thread (not paginated). This
   * array is the source of truth for what gets published: every post in the
   * thread, including the root post, must be provided here. Posts are
   * published in order, each replying to the previous one. The first item is
   * the root post and should match the top-level `text` on the post input.
   */
  thread?: InputMaybe<Array<ThreadedPostInput>>;
};

/**
 * The state of the Buffer Home first-steps checklist for an organization.
 * Returned by `Query.bufferHomeChecklist`. Status transitions are driven by
 * `markBufferHomeTaskComplete` and `dismissBufferHomeTask`.
 */
export type BufferHomeChecklist = {
  __typename?: 'BufferHomeChecklist';
  /**
   * The full visible task list for this organization. The server synthesises
   * one entry per `BufferHomeTaskKey` enum value at read time; entries not
   * yet acted on carry `status: pending`.
   */
  tasks: Array<BufferHomeTask>;
};

/** Input for `Query.bufferHomeChecklist`. */
export type BufferHomeChecklistInput = {
  /** The organization whose checklist to fetch. */
  organizationId: Scalars['OrganizationId']['input'];
};

/** A single first-steps task on Buffer Home. */
export type BufferHomeTask = {
  __typename?: 'BufferHomeTask';
  /** The user's current state for this task. */
  status: BufferHomeTaskStatus;
  /** The identifier of this task. */
  taskKey: BufferHomeTaskKey;
};

/** Identifier for a Buffer Home first-steps task. */
export enum BufferHomeTaskKey {
  /** Connect your first social channel. */
  ConnectChannel = 'connectChannel',
  /** Create your first scheduled post. */
  CreateFirstPost = 'createFirstPost',
  /** Invite teammates to the organization. */
  InviteTeam = 'inviteTeam',
  /** Explore the Buffer API and create a first API key. */
  TryBufferApi = 'tryBufferApi'
}

/** Current status of a Buffer Home task for an organization. */
export enum BufferHomeTaskStatus {
  /** The user explicitly marked this task complete. */
  Completed = 'completed',
  /** The user dismissed this task. */
  Dismissed = 'dismissed',
  /** The user has not acted on this task yet. */
  Pending = 'pending'
}

/**
 * Represents an active subscription for an organization, including its plan details,
 * billing cycle, and subscription status information
 */
export type BufferSubscription = {
  __typename?: 'BufferSubscription';
  /** The UTC DateTime when the subscription was canceled. Only populated if the subscription has been canceled. */
  canceledAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * External identifier from the payment gateway (e.g., Stripe subscription ID).
   * This field is restricted to internal services and Buffer admins.
   */
  gatewayId?: Maybe<Scalars['String']['output']>;
  /** The billing cycle interval for this subscription (month or year) */
  interval: BillingInterval;
  /** Indicates if a subscription is going to be canceled at the end of the its period */
  isCanceledAtPeriodEnd: Scalars['Boolean']['output'];
  /**
   * Indicates whether the customer's current subscription payment is past due. This field is not for
   * the purpose of determining overall subscription status (see the Billing type instead)
   */
  isPaymentPastDue?: Maybe<Scalars['Boolean']['output']>;
  /** The UTC DateTime of the subscription period end. Free plan does not have periodEnd */
  periodEnd?: Maybe<Scalars['DateTime']['output']>;
  /** The Buffer plan associated with this subscription, containing pricing and limits */
  plan: Plan;
  /** The number of units (e.g., channels) included in this subscription */
  quantity: Scalars['Int']['output'];
  /** Details about any scheduled changes to this subscription that will take effect at the next billing cycle */
  scheduledUpdate?: Maybe<ScheduledSubscriptionUpdateV2>;
  /** The UTC DateTime of when the subscription was originally created */
  startDate?: Maybe<Scalars['DateTime']['output']>;
  /** Trial information, populated if the subscription is currently in a trial period */
  trial?: Maybe<PlanTrial>;
};

export type Calendar = {
  __typename?: 'Calendar';
  campaigns?: Maybe<Array<PublishingCampaign>>;
  days?: Maybe<Array<CalendarDay>>;
  posts: Array<PublishingPost>;
};

export type CalendarDay = Day & {
  __typename?: 'CalendarDay';
  /** A list of campaigns present on the requested day */
  campaigns?: Maybe<Array<PublishingCampaign>>;
  /** The number of posts for the given day */
  counts?: Maybe<Array<PostServiceCount>>;
  /** The day of the week, e.g., 'Monday' */
  dayName: DayName;
  /** The numerical day of the month, e.g., 31 */
  dayOfMonth: Scalars['Int']['output'];
  /** A collection of time spans for the given day which may contain posts */
  intervals?: Maybe<Array<CalendarInterval>>;
  /** The name of the month, e.g., 'January' */
  monthName: MonthName;
  /** A list of posts for the given day */
  posts?: Maybe<Array<PublishingPost>>;
  /** The start timestamp of the day in seconds */
  startTimestamp: Scalars['Int']['output'];
};

export type CalendarInput = {
  /** MOCK MODE ONLY: Seed value for random generator */
  _seed?: InputMaybe<Scalars['Int']['input']>;
  /** The campaign(s) to fetch posts for */
  campaignIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The channel(s) to fetch posts for */
  channelIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The oldest date of posts to return, a unix timestamp (in seconds) */
  endDate: Scalars['Int']['input'];
  /** Whether or not to include posts with status set to 'draft' */
  includeDrafts?: InputMaybe<Scalars['Boolean']['input']>;
  /** The span of time for each group of posts */
  intervalSize?: InputMaybe<IntervalSize>;
  /** The start date of posts to return, a unix timestamp (in seconds) */
  startDate: Scalars['Int']['input'];
  /** The timezone to use for formatting dates and times */
  timezone: Scalars['String']['input'];
  /** Whether to return date/time strings in 24 hour time format */
  use24HourTime?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Represents a span of time in the calendar which may or may not contain post items.
 * The length of the interval is configured by the intervalLength passed to the query.
 */
export type CalendarInterval = {
  __typename?: 'CalendarInterval';
  /** A human readable label for the start of the interval, e.g., '2 PM' or '14:00' */
  label: Scalars['String']['output'];
  /** A list of posts within this interval */
  posts?: Maybe<Array<PublishingPost>>;
  /** A unix timestamp representing the beginning of the interval */
  startTimestamp: Scalars['Int']['output'];
};

/** Input to fetch a single post by id */
export type CalendarPostInput = {
  /** The id of the post to fetch */
  id: Scalars['ID']['input'];
  /** The timezone to use for formatting dates and times */
  timezone: Scalars['String']['input'];
  /** Whether to return date/time strings in 24 hour time format */
  use24HourTime: Scalars['Boolean']['input'];
};

export type CalendarsPayload = Calendar | PublishingError;

/** A tooltip displayed on a campaign toggle. */
export type CampaignToggleTip = {
  __typename?: 'CampaignToggleTip';
  /** The tooltip description text. */
  description: Scalars['String']['output'];
  /** A URL for more information. */
  link: Scalars['String']['output'];
};

/** Input for a campaign toggle tip. */
export type CampaignToggleTipInput = {
  /** The tooltip description text. */
  description: Scalars['String']['input'];
  /** A URL for more information. */
  link: Scalars['String']['input'];
};

export type CanMigrateToOneBuffer = {
  __typename?: 'CanMigrateToOneBuffer';
  /** Whether the organization is eligible to be migrated to One Buffer */
  canMigrate: Scalars['Boolean']['output'];
  /** Reasons why canMigrate resolved to false. It will be an empty array otherwise. */
  reasons: Array<Maybe<Scalars['String']['output']>>;
  /** Subscription discount information used in the migration process */
  subscriptionDiscount?: Maybe<Discount>;
};

/** Cancel recurrence on a post */
export type CancelPostRecurrenceInput = {
  /** Post ID to cancel recurrence on */
  id: Scalars['PostId']['input'];
};

/** Result of cancelling recurrence on a post. */
export type CancelPostRecurrencePayload = PostActionSuccess | VoidMutationError;

/** input for cancelTrial mutation */
export type CancelTrialInput = {
  /** Id of organization on the trial. */
  organizationId: Scalars['OrganizationId']['input'];
};

/** cancelTrial response payload. */
export type CancelTrialPayload = CancelTrialResponse | NotFoundError | UnauthorizedError | UnexpectedError;

/** Response for successful cancelTrial mutation */
export type CancelTrialResponse = MutationSuccess & {
  __typename?: 'CancelTrialResponse';
  /**
   * The value is always an empty string ''
   * Note: GraphQL doesn't allow types with no fields, so we have to add this field
   */
  _empty: Scalars['String']['output'];
};

/** Error when trying to remove the organization owner */
export type CannotRemoveOwnerError = MutationError & {
  __typename?: 'CannotRemoveOwnerError';
  /** Human-readable error message. */
  message: Scalars['String']['output'];
};

/** A credit or debit card payment method. */
export type CardPaymentMethodDetails = {
  __typename?: 'CardPaymentMethodDetails';
  /** The card network brand (e.g. "visa", "mastercard", "amex"). */
  brand: Scalars['String']['output'];
  /** The two-digit expiration month (e.g. "01", "12"). */
  expMonth: Scalars['String']['output'];
  /** The four-digit expiration year (e.g. "2027"). */
  expYear: Scalars['String']['output'];
  /** The last four digits of the card number. */
  last4: Scalars['String']['output'];
};

/** A Cash App payment method. */
export type CashAppPaymentMethodDetails = {
  __typename?: 'CashAppPaymentMethodDetails';
  /** The customer's Cash App identifier (e.g. "$janedoe"). */
  cashtag?: Maybe<Scalars['String']['output']>;
  /** A human-readable description of the Cash App account. */
  displayName: Scalars['String']['output'];
};

/** Represent a node in the pagination result using the Connect Relay convention. */
export type ChangelogEntriesEdge = {
  __typename?: 'ChangelogEntriesEdge';
  /** Opaque cursor to be used in pagination to fetch from current node. */
  cursor: Scalars['String']['output'];
  /** Represents the current changelog entry in the list. */
  node: ChangelogEntry;
};

/** Input for fetching changelog entries */
export type ChangelogEntriesInput = {
  /** The cursor of the changelog entry to start fetching from */
  after?: InputMaybe<Scalars['String']['input']>;
  /** The number of changelog entries to return */
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** Response for changelog entries query */
export type ChangelogEntriesResponse = {
  __typename?: 'ChangelogEntriesResponse';
  /** The list of changelog entries that match the query. */
  edges: Array<ChangelogEntriesEdge>;
  /** Information to aid in pagination. */
  pageInfo: PaginationPageInfo;
};

/**
 * Represents a single changelog entry shown to users,
 * such as new feature announcements or important updates.
 */
export type ChangelogEntry = {
  __typename?: 'ChangelogEntry';
  /** The audience of the changelog entry. */
  audience: ChangelogEntryAudience;
  /** The author of the changelog entry. */
  author?: Maybe<ChangelogEntryAuthor>;
  /** The full content of the changelog, supporting markdown or rich text. */
  content: Scalars['String']['output'];
  /** Optional URL for a cover image associated with this changelog entry. */
  coverImageUrl?: Maybe<Scalars['URL']['output']>;
  /**
   * Date and time the changelog entry was created (ISO 8601 format).
   * @deprecated Use `publishedAt` for display and ordering. `createdAt` is the DB record creation timestamp and no longer drives any user-facing behavior.
   */
  createdAt: Scalars['DateTime']['output'];
  /** The user who created this changelog entry. */
  createdBy: Scalars['AccountId']['output'];
  /**
   * Call-to-action buttons for modal-display entries (max 2; first = primary).
   * Empty for popover entries.
   */
  ctas: Array<ChangelogEntryCta>;
  /**
   * Whether the entry is surfaced as a popover or a centered modal. Defaults to
   * `popover` for entries created before this field existed.
   */
  displayType: ChangelogEntryDisplayType;
  /**
   * Optional date after which the entry should no longer be surfaced
   * (auto-retire). Applies to both popover and modal entries. Null means it never
   * expires.
   */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier for the changelog entry. */
  id: Scalars['ChangelogEntryId']['output'];
  /**
   * Date and time the entry is considered published (ISO 8601 format). Controls
   * list ordering and announcement visibility. Falls back to createdAt for entries
   * created before this field existed.
   */
  publishedAt: Scalars['DateTime']['output'];
  /**
   * URL-safe identifier used by the public marketing changelog page
   * (`/changelog/{slug}`). Unique across the changelog collection.
   */
  slug: Scalars['String']['output'];
  /**
   * The entry's concise blurb — the authored summary, or a derived excerpt of
   * `content` when none was set. Always present, so popover / modal / What's New /
   * marketing surfaces can show it directly.
   */
  summary: Scalars['String']['output'];
  /** The main title of the changelog entry. */
  title: Scalars['String']['output'];
  /**
   * Date and time when the changelog entry was last updated (ISO 8601 format).
   * @deprecated No longer used for user-facing display or ordering. Mutations bump this field implicitly, but clients should not rely on it.
   */
  updatedAt: Scalars['DateTime']['output'];
};

/** Represents the audience of a changelog entry. */
export enum ChangelogEntryAudience {
  Alpha = 'alpha',
  Beta = 'beta',
  General = 'general'
}

/** Represents the author of a changelog entry. */
export type ChangelogEntryAuthor = {
  __typename?: 'ChangelogEntryAuthor';
  /** The avatar URL of the author. */
  avatar: Scalars['String']['output'];
  /** The name of the author. */
  name: Scalars['String']['output'];
};

/**
 * A call-to-action button rendered on a modal-display changelog entry. The first
 * CTA is styled as primary, the second as secondary.
 */
export type ChangelogEntryCta = {
  __typename?: 'ChangelogEntryCta';
  /**
   * Author-set, human-readable identifier (e.g. `set-up-now`), unique within the
   * entry. Attached to click-tracking events to attribute which button a user
   * clicked, independently of the label.
   */
  id: Scalars['String']['output'];
  /** The button label. */
  label: Scalars['String']['output'];
  /**
   * The destination. A value starting with `/` is treated as an in-app route
   * (client-side navigation); anything else opens externally.
   */
  url: Scalars['String']['output'];
};

/** A call-to-action button on a modal-display changelog entry (first = primary). */
export type ChangelogEntryCtaInput = {
  /**
   * Optional author-set, human-readable identifier (e.g. `set-up-now`), unique
   * within the entry. Attached to click-tracking events to attribute which button
   * a user clicked, independently of the label. When omitted, the server derives
   * one from the label (e.g. `Set up now` → `set-up-now`).
   */
  id?: InputMaybe<Scalars['String']['input']>;
  /** The button label. */
  label: Scalars['String']['input'];
  /**
   * The destination. A value starting with `/` is treated as an in-app route;
   * anything else opens externally.
   */
  url: Scalars['String']['input'];
};

/**
 * How a changelog entry is surfaced to a user when it is due for display: a
 * low-key bottom-left popover, or a big centered, dismissible modal.
 */
export enum ChangelogEntryDisplayType {
  Modal = 'modal',
  Popover = 'popover'
}

/**
 * Input for fetching a single changelog entry. Exactly one of `id` or `slug`
 * must be provided — the resolver branches on whichever is set.
 */
export type ChangelogEntryInput =
  /** The changelog entry ID */
  { id: Scalars['ChangelogEntryId']['input']; slug?: never; }
  |  /**
   * The URL-safe slug of the changelog entry, used by the public marketing
   * changelog page (`/changelog/{slug}`).
   */
  { id?: never; slug: Scalars['String']['input']; };

/** Response for changelog entry query */
export type ChangelogEntryResponse = {
  __typename?: 'ChangelogEntryResponse';
  /** The changelog entry */
  changelogEntry: ChangelogEntry;
};

/** Channel entity */
export type Channel = {
  __typename?: 'Channel';
  /**
   * The level of permissions a user has for a channel.
   * For display only, not for authorization — see `ChannelAccessLevel`. To
   * decide what the current user can do, use the `allowedActions` field below.
   * Organizations on Roles resolve this from the member's role, which is a
   * lossy projection: a role grants finer-grained abilities than this field
   * can express.
   * Source: field resolver
   * Defined in: new proposal
   * @deprecated Use allowedActions instead
   */
  accessLevel: ChannelAccessLevel;
  /**
   * The allowed actions for the current user
   * Source: field resolver
   * Defined in: new proposal
   */
  allowedActions: Array<ChannelAction>;
  /**
   * A collection of timestamps with related to analytics ingestion for the channel or for the channel updates
   * Source: mapper from channel collection - channel.analytics
   * Defined in: current implementation
   */
  analytics?: Maybe<ChannelAnalyticsMetadata>;
  /**
   * The version of the third-party API used by the channel - null if we don't track the version on the backend
   * Source: mapper from channel collection - channel.credentials.apiVersion
   * Defined in: current implementation
   */
  apiVersion?: Maybe<Scalars['String']['output']>;
  /**
   * The avatar URL of the channel
   * Source: mapper from channel collection - channel.avatar
   * Defined in: both proposals
   */
  avatar: Scalars['String']['output'];
  /**
   * Indicates if banners should be shown - often tied to using an old version of the API
   * Source: mapper from channel collection data
   * Defined in: new proposal
   */
  banners: Array<ChannelBanner>;
  /**
   * Indicates if the user can publish the start page
   * Source: field resolver - legacy query.resolver
   * Defined in: current implementation
   * @deprecated Use allowedActions instead
   */
  canPublishStartPage: Scalars['Boolean']['output'];
  /** Verified capabilities stored for this channel. */
  capabilities: ChannelCapabilities;
  /**
   * A collection of timestamps related to comments ingestion for the channel
   * Source: mapper from channel collection - channel.comments
   * Defined in: current implementation
   */
  comments?: Maybe<ChannelCommentsMetadata>;
  /**
   * The creation date of the channel
   * Source: mapper from channel collection - channel.createdAt
   * Defined in: both proposals
   */
  createdAt: Scalars['DateTime']['output'];
  /**
   * Formatted name of the channel service and type: e.g. 'Twitter Profile' or 'Facebook Page'
   * Source: mapper from channel collection - channel.service and channel.type
   * Defined in: current implementation
   */
  descriptor: Scalars['String']['output'];
  /**
   * The display name of the channel - nullable (reason?)
   * Source: mapper from channel collection - channel.displayName
   * Defined in: current implementation
   */
  displayName?: Maybe<Scalars['String']['output']>;
  /**
   * The channel's URL on the social network (e.g. instagram.com/username or facebook.com/page)
   * Source: field resolver
   * Returns null if the channel is not supported
   */
  externalLink?: Maybe<Scalars['String']['output']>;
  /**
   * Per-feature access state for this channel. An absent entry for a feature means
   * it works. Populated by the OAuth write path (missingScope) and analytics
   * ingestion (permissionRevoked). Internal-only at v1.
   * Source: mapper from channel collection - channel.featureAccess
   */
  featureAccess: ChannelFeatureAccess;
  /**
   * Whether at least one member of the orginization who have access to this channel
   * also has a user device registered for push notifications
   */
  hasActiveMemberDevice: Scalars['Boolean']['output'];
  /**
   * The ID of the channel
   * Source: mapper from channel collection - channel._id
   * Defined in: both proposals
   */
  id: Scalars['ChannelId']['output'];
  /**
   * Indicates if the channel is properly connected to Buffer
   * Source: mapper from channel collection - channel.credentials.invalid
   * Defined in: both proposals
   */
  isDisconnected: Scalars['Boolean']['output'];
  /**
   * Indicates if the channel is locked - Locked channels can't be used for posting.
   * A channel can be locked when the organization downgrades and reduces the channel quantity of their plan.
   * Source: mapper from channel collection - channel.isLocked
   * Defined in: both proposals
   */
  isLocked: Scalars['Boolean']['output'];
  /**
   * Indicates if the channel was recently created (in less than 10 seconds). This is used to determine the redirect modal after channel authorization
   * Source: mapper from channel collection - channel.createdAt comparison with current time
   * Defined in: current implementation
   */
  isNew: Scalars['Boolean']['output'];
  /**
   * Indicates is the queue is paused for the channel. A paused queue means schedules posts won't be published.
   * Source: Field resolver - From profiles collection - profile.paused
   * Defined in: new proposal
   */
  isQueuePaused: Scalars['Boolean']['output'];
  /** Link Shortening settings for the channel */
  linkShortening: ChannelLinkShortening;
  /**
   * Metadata about the location of the business associated with the channel. Only available for Facebook and GPB
   * Source: mapper from channel collection - channel.locationData
   * Defined in: current implementation
   * @deprecated Use metadata instead
   */
  locationData?: Maybe<LocationData>;
  /**
   * Metadata or settings depending on the service type - such as the server URL for Mastodon or Location data for Facebook/GPB
   * Source: Field resolver - From channel collection: channel.locationData + channel.serverURL | profile collection: profile.default_to_reminder
   * Defined in: new proposal
   */
  metadata?: Maybe<ChannelMetadata>;
  /**
   * The name of the channel - the handle name, username, etc.
   * Source: mapper from channel collection - channel.name
   * Defined in: both proposals
   */
  name: Scalars['String']['output'];
  /**
   * Data Loader is not applied here so we risk having a n+1 query if we fetch this field for a set of channels
   * Source: field resolvers in legacy query.resolver
   * Defined in: current implementation
   * @deprecated only used internally - we don't want to promote for public API
   */
  organization?: Maybe<ChannelOrganization>;
  /**
   * The organization ID of the channel
   * Source: mapper from channel collection - channel.organizationId
   * Defined in: both proposals
   */
  organizationId: Scalars['OrganizationId']['output'];
  /** The posting goal for the channel */
  postingGoal?: Maybe<PostingGoal>;
  /**
   * Provides the posting slots for each day of the week
   * Source: field resolver based on profiles collection - getPostingSchedule
   */
  postingSchedule: Array<ScheduleV2>;
  /**
   * Per-product access levels the current user holds on this channel.
   * For display only, not for authorization — see `ChannelProductAccessLevels`.
   * To decide what the current user can do, use the `allowedActions` field below.
   * Organizations on Roles resolve both products from the member's role, which
   * is a lossy projection: a role grants finer-grained abilities than this
   * field can express, and roles are not per-product.
   * Source: field resolver
   * @deprecated Use allowedActions instead
   */
  productAccessLevels: ChannelProductAccessLevels;
  /** Products that support a given channel */
  products?: Maybe<Array<Product>>;
  /**
   * Scopes requested for a given channel - empty array if we don't have them tracked
   * Source: mapper from channel collection - channel.credentials.scopes
   * Defined in: current implementation
   */
  scopes: Array<Maybe<Scalars['String']['output']>>;
  /**
   * The instance of mastodon of the channel
   * Source: mapper from channel collection - channel.serverUrl
   * Defined in: current implementation
   * @deprecated Use metadata instead
   */
  serverUrl?: Maybe<Scalars['String']['output']>;
  /**
   * Represents the social network
   * Source: mapper from channel collection - channel.serviceType
   * Defined in: both proposals
   */
  service: Service;
  /**
   * Similar to metadata - Deprecated
   * Source: mapper from channel collection - channel.serviceData
   * Defined in: current implementation
   * @deprecated use metadata (TwitterMetadata) instead
   */
  serviceData?: Maybe<ServiceData>;
  /**
   * Represents the external ID of the channel on social network API
   * Source: mapper from channel collection - channel.serviceId
   * Defined in: both proposals
   */
  serviceId: Scalars['String']['output'];
  /**
   * Flags to indicate if banner should be shown for IG Login channels missing the insights scope
   * Source: mapper from channel collection data
   * @deprecated in favor of banners
   */
  shouldShowIgLoginRefreshBanner: Scalars['Boolean']['output'];
  /**
   * Flags to indicate if banner should be shown for old versions
   * Source: mapper from resolver for now but they all rely on channel collection data - TODO: move to mapper
   * @deprecated in favor of banners
   */
  shouldShowLinkedInUpgradeBanner: Scalars['Boolean']['output'];
  /**
   * Flags to indicate if banner should be shown for old versions
   * Source: mapper from resolver for now but they all rely on channel collection data - TODO: move to mapper
   * @deprecated in favor of banners
   */
  shouldShowPinterestUpgradeBanner: Scalars['Boolean']['output'];
  /**
   * Flags to indicate if banner should be shown for old versions
   * Source: mapper from resolver for now but they all rely on channel collection data - TODO: move to mapper
   * @deprecated in favor of banners
   */
  shouldShowTiktokUpgradeBanner: Scalars['Boolean']['output'];
  /**
   * Indicates if trending topic suggestions should be shown in the composer.
   * When false, users can still access trends via the trending icon button.
   * Defaults to true for backward compatibility.
   * Source: Field resolver - From profiles collection - profile.show_trending_topic_suggestions
   */
  showTrendingTopicSuggestions: Scalars['Boolean']['output'];
  /**
   * The timezone of the channel - Default if not set is Europe/London
   * Source: field resolver based on profiles collection - timezone
   * Defined in: both proposals
   */
  timezone: Scalars['String']['output'];
  /**
   * The type of the channel - Page, Profile, Business, Group, Account, etc.
   * Source: mapper from channel collection - channel.type
   * Defined in: both proposals
   */
  type: ChannelType;
  /**
   * The last time the channel was updated
   * Source: mapper from channel collection - channel.updatedAt
   * Defined in: both proposals
   */
  updatedAt: Scalars['DateTime']['output'];
  /**
   * Weekly posting limit for the channel
   * @deprecated This field is not used anymore
   */
  weeklyPostingLimit?: Maybe<WeeklyPostingLimit>;
};

/**
 * Describes the authorization status of a specific feature
 * for a given channel.
 */
export type ChannelAccessCapabilities = {
  __typename?: 'ChannelAccessCapabilities';
  /** The comments-related feature being evaluated. */
  feature: ChannelCommentsFeature;
  /** Current authorization state for the feature. */
  status: AuthorizationStatus;
};

/**
 * The level of permissions a user has for a channel.
 * Should only be used for displaying to the user (e.g. showing a member's
 * current access while an admin edits team permissions), not for authorization
 * purposes. To decide whether the current user can take a specific action, use
 * the `allowedActions` field on the entity being acted on (e.g.
 * `Post.allowedActions`, `Note.allowedActions`, `Channel.allowedActions`).
 * If the entity you work with doesn't have `allowedActions`, please implement
 * that pattern.
 */
export enum ChannelAccessLevel {
  FullPosting = 'fullPosting',
  None = 'none',
  RequiresApproval = 'requiresApproval',
  /**
   * Read-only tier: can see a product's surface but not act on it. On the
   * `comments` product, view comments but not reply/react/resolve; on the
   * `publish` product, view the queue/calendar/analytics but not
   * create/edit/delete/schedule/approve posts. Used where `requiresApproval`
   * (a publish contributor concept) does not apply.
   */
  ViewOnly = 'viewOnly'
}

/** List of possible actions that can be performed on a Channel */
export enum ChannelAction {
  BackfillChannel = 'backfillChannel',
  ExportInsights = 'exportInsights',
  ManageCapabilities = 'manageCapabilities',
  ManageChannelSettings = 'manageChannelSettings',
  ManageComments = 'manageComments',
  ManageDms = 'manageDms',
  ManageIntegrations = 'manageIntegrations',
  ManagePostingSchedule = 'managePostingSchedule',
  ManageUpdates = 'manageUpdates',
  PublishStartPage = 'publishStartPage',
  ReadUpdates = 'readUpdates',
  ReconnectChannel = 'reconnectChannel',
  RemoveChannel = 'removeChannel',
  ScheduleUpdates = 'scheduleUpdates',
  ViewCapabilities = 'viewCapabilities',
  ViewChannel = 'viewChannel',
  ViewComments = 'viewComments',
  ViewDms = 'viewDms',
  ViewInsights = 'viewInsights',
  ViewPublish = 'viewPublish',
  /** @deprecated Renamed to `viewPublish`. Still emitted for backward-compat with clients that gate on `viewUpdates`; use `viewPublish` to gate the Publish UI or `readUpdates` to gate reading post data. Will be removed once no client reads it. */
  ViewUpdates = 'viewUpdates'
}

/** The export job failed. */
export type ChannelAnalyticsExportFailure = {
  __typename?: 'ChannelAnalyticsExportFailure';
  /** The unique identifier for this export job */
  jobId: Scalars['String']['output'];
  /** Description of what went wrong */
  message: Scalars['String']['output'];
};

/** The format for the channel analytics export. */
export enum ChannelAnalyticsExportFormat {
  /** Comma-separated values */
  Csv = 'csv',
  /** Markdown optimized for LLM consumption */
  Markdown = 'markdown',
  /** PDF rendered to visually mirror the Insights page */
  Pdf = 'pdf'
}

/** The export job is being processed. */
export type ChannelAnalyticsExportProcessing = {
  __typename?: 'ChannelAnalyticsExportProcessing';
  /** The unique identifier for this export job */
  jobId: Scalars['String']['output'];
};

/** The current status of a channel analytics export job. */
export type ChannelAnalyticsExportStatus = ChannelAnalyticsExportFailure | ChannelAnalyticsExportProcessing | ChannelAnalyticsExportSuccess;

/** Input for checking the status of a channel analytics export job. */
export type ChannelAnalyticsExportStatusInput = {
  /** The job ID returned by createChannelAnalyticsExport */
  jobId: Scalars['String']['input'];
};

/** The export job completed successfully. */
export type ChannelAnalyticsExportSuccess = {
  __typename?: 'ChannelAnalyticsExportSuccess';
  /** Pre-signed URL to download the exported file */
  downloadUrl: Scalars['String']['output'];
  /**
   * Human-readable filename the browser should save the download as.
   * Mirrors the `ResponseContentDisposition` embedded in the pre-signed URL —
   * clients must set this on `<a download>` because cross-origin S3 downloads
   * ignore the response header in some browsers.
   */
  filename: Scalars['String']['output'];
  /** The unique identifier for this export job */
  jobId: Scalars['String']['output'];
};

export type ChannelAnalyticsLastUpdateAtPayload = Error | Response;

/** List of analytics timestamp used to track the last time the channel was checked for updates/posts */
export type ChannelAnalyticsMetadata = {
  __typename?: 'ChannelAnalyticsMetadata';
  /** Timestamp of the last time the channel succesfully collected channel analytics */
  channelLastUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Timestamp of the last time the channel succesfully collected post analytics */
  postsLastUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Timestamp of the last time the channel was checked for update/post analytics */
  updatesLastCheckedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Timestamp of the last time the channel was checked for collecting new updates/posts */
  updatesLastCollectedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ChannelAuthorizationError = {
  __typename?: 'ChannelAuthorizationError';
  /** A raw error message to help developers understand the root cause of the issue. */
  cause: Scalars['String']['output'];
  /** A user-friendly message that is safe to be displayed to users. */
  userFriendlyMessage: Scalars['String']['output'];
};

export enum ChannelAuthorizationErrorType {
  NoChannelsError = 'noChannelsError',
  NotEnoughPermissions = 'notEnoughPermissions',
  StealingNotAllowed = 'stealingNotAllowed',
  UndefinedError = 'undefinedError'
}

/** Input for getting the authorization info for a network. */
export type ChannelAuthorizationInfoInput = {
  /** The metadata for the service. */
  metadata?: InputMaybe<ChannelAuthorizationInfoMetadata>;
  /** The redirect URI to be used for the authorization. */
  redirectUri: Scalars['String']['input'];
  /** The service to authorize. */
  service: Service;
};

/** Metadata for Channel Authorization for different services */
export type ChannelAuthorizationInfoMetadata = {
  /** Instagram metadata for Channel Authorization */
  instagramMetadata?: InputMaybe<ChannelAuthorizationInstagramMetadata>;
  /** Mastodon metadata for Channel Authorization */
  mastodonMetadata?: InputMaybe<ChannelAuthorizationMastodonMetadata>;
};

/** The response with authorization info for a network. */
export type ChannelAuthorizationInfoResponse = {
  __typename?: 'ChannelAuthorizationInfoResponse';
  /**
   * PKCE code verifier, present only for services that require PKCE (Substack).
   * The client keeps it until the token exchange and returns it as
   * `substackMetadata.codeVerifier`.
   */
  codeVerifier?: Maybe<Scalars['String']['output']>;
  /** The redirect URI to be used for the authorization. */
  redirectUri: Scalars['String']['output'];
  /** The state token used for the authorization URL */
  state: Scalars['String']['output'];
  /** The URL to use to authorize the channel. */
  url: Scalars['String']['output'];
};

export type ChannelAuthorizationInput = {
  code: Scalars['String']['input'];
  codeVerifier?: InputMaybe<Scalars['String']['input']>;
  followBuffer?: InputMaybe<Scalars['Boolean']['input']>;
  mastodonServer?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  redirectUri?: InputMaybe<Scalars['String']['input']>;
  service: Service;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

/** Instagram API to be used for authorization */
export enum ChannelAuthorizationInstagramApi {
  /** Facebook Login API - used for business and creator accounts, with all features */
  FacebookLogin = 'facebookLogin',
  /** Instagram Login API - used for business and creator accounts, with limited features */
  InstagramLogin = 'instagramLogin'
}

/** Instagram metadata for Channel Authorization */
export type ChannelAuthorizationInstagramMetadata = {
  /** Method of authorization used for IG Auth */
  apiVersion: ChannelAuthorizationInstagramApi;
};

/** Mastodon metadata for Channel Authorization */
export type ChannelAuthorizationMastodonMetadata = {
  /** Follow Buffer in the mastodon.social instance */
  followBuffer?: InputMaybe<Scalars['Boolean']['input']>;
  /** The Mastodon server to be used for connection */
  server: Scalars['String']['input'];
};

export type ChannelAuthorizationPayload = ChannelAuthorizationError | ChannelAuthorizationResponse;

export type ChannelAuthorizationResponse = {
  __typename?: 'ChannelAuthorizationResponse';
  channel: Channel;
  /** @deprecated deprecated in favor of returning a channel */
  success: Scalars['Boolean']['output'];
};

/**
 * Represents the authorization state of a specific channel
 * for comments-related capabilities within Community.
 */
export type ChannelAuthorizationStatus = {
  __typename?: 'ChannelAuthorizationStatus';
  /**
   * List of access capabilities and their current authorization status
   * for this channel.
   */
  accessTo: Array<ChannelAccessCapabilities>;
  /** Unique identifier of the channel. */
  id: Scalars['ChannelId']['output'];
};

/** Substack metadata for Channel Authorization */
export type ChannelAuthorizationSubstackMetadata = {
  /**
   * The PKCE code verifier that `channelAuthorizationInfo` returned for this
   * authorization. The client keeps it until the token exchange and sends it back here.
   */
  codeVerifier: Scalars['String']['input'];
};

/** Twitter metadata for Channel Authorization */
export type ChannelAuthorizationTwitterMetadata = {
  /** The Twitter oauth_verifier token to be used for getting the credentials */
  codeVerifier: Scalars['String']['input'];
};

export type ChannelAuthorizationUrlError = {
  __typename?: 'ChannelAuthorizationUrlError';
  /** A raw error message to help developers understand the root cause of the issue. */
  cause: Scalars['String']['output'];
  /** A user-friendly message that is safe to be displayed to users. */
  userFriendlyMessage: Scalars['String']['output'];
};

export type ChannelAuthorizationUrlInput = {
  mastodonServer?: InputMaybe<Scalars['String']['input']>;
  redirectUri: Scalars['String']['input'];
  service: Service;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type ChannelAuthorizationUrlPayload = ChannelAuthorizationUrlError | ChannelAuthorizationUrlResponse;

export type ChannelAuthorizationUrlResponse = {
  __typename?: 'ChannelAuthorizationUrlResponse';
  url: Scalars['String']['output'];
};

/** Allows the backfilling of posts and analytics for a given channel */
export type ChannelBackfillInput = {
  channelId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};

/** The list of channel banners that we currently support */
export enum ChannelBanner {
  IgLoginRefresh = 'igLoginRefresh',
  LinkedinUpgrade = 'linkedinUpgrade',
  PinterestUpgrade = 'pinterestUpgrade',
  TiktokUpgrade = 'tiktokUpgrade'
}

/**
 * One benchmark time series: a single channel × metric pair with monthly
 * history. The cohort comparison is carried per history point because it
 * varies by (network, channel type, audience tier) and by month.
 */
export type ChannelBenchmarkSeries = {
  __typename?: 'ChannelBenchmarkSeries';
  /** The channel these benchmarks belong to. */
  channel: Channel;
  /**
   * Description of the metric and the cohort it compares against. Varies
   * per series — by network, type, and (when bucketed) tier.
   */
  description: Scalars['String']['output'];
  /** Display name suitable for a UI label. */
  displayName: Scalars['String']['output'];
  /**
   * Monthly history, ordered ascending by month. Contains one point per
   * settled month overlapping the request's date range; months past the
   * most recent settled month are omitted. Months within the range but
   * without benchmark data still appear with nullable fields so the
   * timeline has no gaps.
   */
  history: Array<BenchmarkHistoryPoint>;
  /** Stable metric identifier. */
  type: BenchmarkMetricType;
  /** Unit the channel and benchmark values are expressed in. */
  unit: PostMetricUnit;
};

/** Input for fetching benchmark observations for an organization's channels. */
export type ChannelBenchmarksInput = {
  /**
   * Restrict to specific channels. Omit the field (or pass null) to
   * include every channel the actor can view; an empty list returns no
   * channels.
   */
  channelIds?: InputMaybe<Array<Scalars['ChannelId']['input']>>;
  /** End of the range. The month containing `endDate` is included. */
  endDate: Scalars['DateTime']['input'];
  /**
   * Restrict to specific metrics. Omit the field (or pass null) to
   * include every benchmark applicable to each channel; an empty list
   * returns no metrics per channel.
   */
  metrics?: InputMaybe<Array<BenchmarkMetricType>>;
  /** Organization whose channels to evaluate. */
  organizationId: Scalars['OrganizationId']['input'];
  /**
   * Start of the range to fetch history for. A month is included when
   * its `[firstOfMonth, firstOfNextMonth)` window overlaps
   * `[startDate, endDate]`; months past the most recent closed (settled)
   * benchmark month are silently omitted. UTC is assumed; the time
   * component is collapsed to a month bucket on the server.
   */
  startDate: Scalars['DateTime']['input'];
};

/**
 * Flat list of (channel × metric) benchmark series. Channels with no
 * applicable benchmark do not appear — derive that signal from
 * `organization.channels`.
 */
export type ChannelBenchmarksPayload = {
  __typename?: 'ChannelBenchmarksPayload';
  /** The (channel × metric) benchmark series. */
  series: Array<ChannelBenchmarkSeries>;
};

/**
 * The verified capabilities for a channel: every available capability with this
 * channel's earned state, plus the channel's synchronization settings.
 */
export type ChannelCapabilities = {
  __typename?: 'ChannelCapabilities';
  /**
   * Every available verified capability, populated with this channel's earned
   * state.
   */
  capabilities: Array<ChannelCapability>;
  /**
   * Whether the channel synchronizes its chosen capability to the connected
   * platform profile.
   */
  isEnabled: Scalars['Boolean']['output'];
  /**
   * When the channel's capabilities were last evaluated, or null if no check has
   * completed.
   */
  lastCheckedAt?: Maybe<Scalars['DateTime']['output']>;
};

/**
 * A single verified capability for a channel, with its display copy and the
 * channel's earned state.
 */
export type ChannelCapability = {
  __typename?: 'ChannelCapability';
  /** Stable identifier for the capability. */
  capabilityKey: ChannelCapabilityKey;
  /** Description of how the capability is earned. */
  description: Scalars['String']['output'];
  /**
   * Whether this capability is the one selected for display on the connected
   * platform profile. Actual visibility also requires the channel-level `isEnabled`
   * flag to be true; at most one capability can be selected at a time.
   */
  isDisplayedOnPlatform: Scalars['Boolean']['output'];
  /** Whether the channel has earned this capability. */
  isEarned: Scalars['Boolean']['output'];
  /** Human-readable name of the capability. */
  name: Scalars['String']['output'];
};

/** Stable identifier for a verified capability that can be earned for a channel. */
export enum ChannelCapabilityKey {
  BufferApiBuilder = 'bufferApiBuilder',
  CommunityManager = 'communityManager',
  InstagramLinkedInPublisher = 'instagramLinkedInPublisher',
  MultiChannelPublisher = 'multiChannelPublisher'
}

/** Options that define how the service should be grouped */
export enum ChannelCategory {
  Creator = 'creator',
  Ecommerce = 'ecommerce',
  SmallBusiness = 'small_business'
}

/** The character limit for a channel */
export type ChannelCharacterLimit = {
  __typename?: 'ChannelCharacterLimit';
  /** The id of the channel */
  id: Scalars['ChannelId']['output'];
  /** The character limit for the channel */
  limit: Scalars['Int']['output'];
};

/**
 * Enumerates all comments-related features that may require
 * authorization at channel level.
 */
export enum ChannelCommentsFeature {
  /** Ability to read and manage comments. */
  Comments = 'comments'
}

/**
 * List of comments timestamps used to track the last time the channel was checked for new comments
 * and/or the last time the channel was updated with new comments
 */
export type ChannelCommentsMetadata = {
  __typename?: 'ChannelCommentsMetadata';
  /**
   * Timestamp of the last time the channel was checked for new comments.
   * This is only used for Services that do not support real-time comments (e.g. LinkedIn profiles).
   */
  lastCheckedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Timestamp of the last time the channel was updated with new comments. */
  lastUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Timestamp of the next time the channel will be updated with new comments. */
  nextUpdateAt?: Maybe<Scalars['DateTime']['output']>;
};

/**
 * Everything for one connected channel: its engagement capabilities, its full
 * `content` config, and per-feature authorization. Each channel carries
 * its own complete config — there is no service-level default to merge against.
 */
export type ChannelConfiguration = {
  __typename?: 'ChannelConfiguration';
  /**
   * Authorization status per feature for this channel. A feature is a capability
   * a channel can expose — e.g. posting, commenting, mentions, insights (see the
   * `Feature` enum).
   */
  authorizationStatus: Array<FeatureAuthorizationStatus>;
  /** The connected channel this config describes. */
  channelId: Scalars['ChannelId']['output'];
  /** The channel's type within the service (e.g. profile, page, business). */
  channelType: ChannelType;
  /**
   * Content config — one entry per content type, or a single entry
   * grouping several types that share identical rules (post / story / reel /
   * comment reply).
   */
  content: Array<ContentConfiguration>;
  /**
   * Engagement capabilities — one entry per engagement type. Empty when
   * engagement isn't supported on the channel.
   */
  engagement: Array<EngagementTypeConfiguration>;
  /** The channel's social service (e.g. twitter, instagram). */
  service: Service;
};

export type ChannelConnectionAvailability = {
  __typename?: 'ChannelConnectionAvailability';
  connectionAvailability: ConnectionAvailability;
  service: Service;
  serviceId: Scalars['String']['output'];
};

/** Channel Authorization error when a channel cannot be stolen */
export type ChannelConnectionCannotStealChannelError = MutationError & {
  __typename?: 'ChannelConnectionCannotStealChannelError';
  /** The error message */
  message: Scalars['String']['output'];
};

export type ChannelConnectionInput = {
  channelId?: InputMaybe<Scalars['ID']['input']>;
  credentials: ChannelCredentialsInput;
  service: Service;
  serviceId: Scalars['String']['input'];
};

/** Input for listing the channels of a service. */
export type ChannelConnectionListInput = {
  /** The code to be used to exchange the access_token. */
  code: Scalars['String']['input'];
  /** The metadata for the service. */
  metadata?: InputMaybe<ChannelConnectionListMetadata>;
  /** The organization ID to list the channels. */
  organizationId: Scalars['OrganizationId']['input'];
  /** The redirect URI to be used for the authorization. */
  redirectUri: Scalars['String']['input'];
  /** The service to list the channels from. */
  service: Service;
};

/** Input for metadata for Channel Connection List */
export type ChannelConnectionListMetadata = {
  /** Instagram metadata for Channel Authorization */
  instagramMetadata?: InputMaybe<ChannelAuthorizationInstagramMetadata>;
  /** Mastodon metadata for Channel Authorization */
  mastodonMetadata?: InputMaybe<ChannelAuthorizationMastodonMetadata>;
  /** Substack metadata for Channel Authorization */
  substackMetadata?: InputMaybe<ChannelAuthorizationSubstackMetadata>;
  /** Twitter metadata for Channel Authorization */
  twitterMetadata?: InputMaybe<ChannelAuthorizationTwitterMetadata>;
};

/** The payload of the response from ChannelConnectionList */
export type ChannelConnectionListPayload = ChannelConnectionListResponse | ChannelConnectionNoChannelsError | UnauthorizedError | UnexpectedError;

/** The response with the list of channels fetch from the service. */
export type ChannelConnectionListResponse = {
  __typename?: 'ChannelConnectionListResponse';
  /** The list of channels */
  channels: Array<ConnectableChannel>;
};

/** Channel Authorization error when there are no channels found */
export type ChannelConnectionNoChannelsError = MutationError & {
  __typename?: 'ChannelConnectionNoChannelsError';
  /** The error message */
  message: Scalars['String']['output'];
};

/** Input for reconnecting the channels of a service. */
export type ChannelConnectionRefreshInput = {
  /**
   * Buffer channel ID being refreshed. When provided, the refresh must match this
   * channel — sibling matches alone must not count as success (e.g. IG Login → FB
   * Login conversion when the target account is not linked to a Facebook Page).
   */
  channelId?: InputMaybe<Scalars['ChannelId']['input']>;
  /** The code to be used to exchange the access_token. */
  code: Scalars['String']['input'];
  /** The metadata for the service. */
  metadata?: InputMaybe<ChannelConnectionRefreshMetadata>;
  /** The organization ID to reconnect the service. */
  organizationId: Scalars['OrganizationId']['input'];
  /** The redirect URI to be used for the authorization. */
  redirectUri: Scalars['String']['input'];
  /** The service to reconnect. */
  service: Service;
};

/** Input for metadata for Channel Authorization Reconnect */
export type ChannelConnectionRefreshMetadata = {
  /** Instagram metadata for Channel Authorization */
  instagramMetadata?: InputMaybe<ChannelAuthorizationInstagramMetadata>;
  /** Mastodon metadata for Channel Authorization */
  mastodonMetadata?: InputMaybe<ChannelAuthorizationMastodonMetadata>;
  /** Substack metadata for Channel Authorization */
  substackMetadata?: InputMaybe<ChannelAuthorizationSubstackMetadata>;
  /** Twitter metadata for Channel Authorization */
  twitterMetadata?: InputMaybe<ChannelAuthorizationTwitterMetadata>;
};

/** The payload of the response from ChannelConnectionRefresh */
export type ChannelConnectionRefreshPayload = ChannelConnectionCannotStealChannelError | ChannelConnectionNoChannelsError | ChannelConnectionRefreshResponse | ChannelConnectionRefreshWrongAccountError | UnauthorizedError | UnexpectedError;

/** The response with the list of channels that were reconnected. */
export type ChannelConnectionRefreshResponse = {
  __typename?: 'ChannelConnectionRefreshResponse';
  /** The list of channels that were reconnected. */
  channels: Array<Channel>;
};

/** Channel Authorization error when the channel belongs to a different account. */
export type ChannelConnectionRefreshWrongAccountError = MutationError & {
  __typename?: 'ChannelConnectionRefreshWrongAccountError';
  /** Channel that exist on network but are not connected to Buffer */
  channel: BasicChannelInfo;
  /** The error message */
  message: Scalars['String']['output'];
};

/** The current connection status of the service */
export type ChannelConnectionStatus = {
  __typename?: 'ChannelConnectionStatus';
  /** An optional message to be displayed when the ConnectionStatus is of the `disabled` type */
  message?: Maybe<Scalars['String']['output']>;
  /** The connection status of a service */
  status: ConnectionStatus;
};

export type ChannelCredentials = {
  __typename?: 'ChannelCredentials';
  accessToken: Scalars['String']['output'];
  accessTokenExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  accessTokenSecret?: Maybe<Scalars['String']['output']>;
  invalid?: Maybe<Scalars['Boolean']['output']>;
  refreshToken?: Maybe<Scalars['String']['output']>;
  refreshTokenExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  sharedAccessToken?: Maybe<Scalars['String']['output']>;
  sharedAccessTokenExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  sharedOwner?: Maybe<Scalars['String']['output']>;
};

export type ChannelCredentialsInput = {
  accessToken: Scalars['String']['input'];
  accessTokenExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  accessTokenSecret?: InputMaybe<Scalars['String']['input']>;
  refreshToken?: InputMaybe<Scalars['String']['input']>;
  refreshTokenExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  sharedAccessToken?: InputMaybe<Scalars['String']['input']>;
  sharedAccessTokenExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  sharedOwner?: InputMaybe<Scalars['String']['input']>;
};

export type ChannelData = {
  __typename?: 'ChannelData';
  googlebusiness?: Maybe<GoogleBusinessData>;
  instagram?: Maybe<InstagramData>;
  linkedin?: Maybe<LinkedinData>;
  pinterest?: Maybe<PinterestData>;
  startPage?: Maybe<StartPageData>;
  threads?: Maybe<ThreadsData>;
  youtube?: Maybe<YoutubeData>;
};

/**
 * Per-feature access state for a channel. An absent entry means the feature works.
 * Set on detection (scope check at connect/refresh, runtime permission errors);
 * cleared on the next successful collection (permissionRevoked) or reconnect with
 * the required scope (missingScope).
 */
export type ChannelFeatureAccess = {
  __typename?: 'ChannelFeatureAccess';
  /** Blocked state of channel-level analytics for this channel, if any. */
  channelAnalytics?: Maybe<FeatureAccessState>;
  /** Blocked state of comments for this channel, if any. */
  comments?: Maybe<FeatureAccessState>;
  /** Blocked state of direct messages for this channel, if any. */
  directMessages?: Maybe<FeatureAccessState>;
  /** Blocked state of per-post analytics for this channel, if any. */
  postAnalytics?: Maybe<FeatureAccessState>;
  /** Blocked state of publishing for this channel, if any. */
  publish?: Maybe<FeatureAccessState>;
};

/** A group of channels that can be managed together. */
export type ChannelGroup = {
  __typename?: 'ChannelGroup';
  /** ID of the account that owns this channel group */
  accountId: Scalars['AccountId']['output'];
  /** The number of channels in the channel group, regardless of the limit set on the channel group */
  channelCount: Scalars['Int']['output'];
  /** The channels that are part of the Channel Group. Sorted */
  channels?: Maybe<Array<Channel>>;
  /** The date and time the channel group was created */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier for the channel group */
  id: Scalars['ChannelGroupId']['output'];
  /** Display name of the channel group */
  name: Scalars['String']['output'];
  /** ID of the organization this channel group belongs to */
  organizationId: Scalars['OrganizationId']['output'];
  /** The date and time the channel group was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** Input for fetching a single channel group */
export type ChannelGroupInput = {
  /** The channel group ID */
  id: Scalars['ChannelGroupId']['input'];
};

/** Channel Group Query Payload: Success and errors */
export type ChannelGroupPayload = ChannelGroup | UnauthorizedError | UnexpectedError;

/** Response for channel group query */
export type ChannelGroupResponse = {
  __typename?: 'ChannelGroupResponse';
  /** The channel group */
  channelGroup: ChannelGroup;
};

/** Input for fetching all channel groups for an account in the organization */
export type ChannelGroupsInput = {
  /** The account for which the user fetches the channel groups */
  accountId: Scalars['AccountId']['input'];
  /** The limit of the channel groups to fetch */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** The organization for which the user fetches the channel groups */
  organizationId: Scalars['OrganizationId']['input'];
};

/** Channel Groups Query Payload: Success and errors */
export type ChannelGroupsPayload = ChannelGroupsResponse | UnauthorizedError | UnexpectedError;

/** Response for channel groups query */
export type ChannelGroupsResponse = {
  __typename?: 'ChannelGroupsResponse';
  /** The channel groups */
  channelGroups: Array<ChannelGroup>;
};

export enum ChannelIngestionType {
  Channel = 'channel',
  Posts = 'posts'
}

/** Input for the channel query */
export type ChannelInput = {
  /** The ID of the channel to be retrieved */
  id: Scalars['ChannelId']['input'];
};

/** Insights summary for a single channel */
export type ChannelInsightsSummary = {
  __typename?: 'ChannelInsightsSummary';
  /** The channel */
  channel: Channel;
  /** The summary metrics for the channel */
  metrics: Array<PostInsightsSummaryMetric>;
};

/** Time series data for a single channel */
export type ChannelInsightsTimeSeries = {
  __typename?: 'ChannelInsightsTimeSeries';
  /** The channel */
  channel: Channel;
  /**
   * Comparison-period series with the same metric shape as the primary.
   * Null unless the caller provided `comparisonStartDate` and `comparisonEndDate`
   * on the filter input. Data points carry their own dates from the comparison
   * window — different-length ranges are positionally aligned, not date-aligned.
   */
  comparison?: Maybe<ChannelInsightsTimeSeriesData>;
  /**
   * The earliest day Buffer has a channel-analytics data point for this channel —
   * where its time series actually begins. Distinct from the channel connection
   * date (`Channel.createdAt`): for a channel connected before Buffer began
   * collecting, this marks the day data collection started. Null until the first
   * collection has run.
   */
  firstChannelDataCollectedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Daily followers count time series
   * @deprecated Use `primary.followers` instead.
   */
  followers: Array<TimeSeriesDataPoint>;
  /**
   * Daily posts count time series
   * @deprecated Use `primary.posts` instead.
   */
  posts: Array<TimeSeriesDataPoint>;
  /** Time series for the primary date range (`startDate`..`endDate`). */
  primary: ChannelInsightsTimeSeriesData;
  /**
   * Daily reach time series
   * @deprecated Use `primary.reach` instead.
   */
  reach: Array<TimeSeriesDataPoint>;
  /**
   * Daily views time series
   * @deprecated Use `primary.views` instead.
   */
  views: Array<TimeSeriesDataPoint>;
};

/**
 * A bundle of metric time series for a single period (primary or comparison).
 * Shared shape so adding a future metric is a single-field change on this type
 * and both periods automatically expose it.
 */
export type ChannelInsightsTimeSeriesData = {
  __typename?: 'ChannelInsightsTimeSeriesData';
  /** Daily followers count time series */
  followers: Array<TimeSeriesDataPoint>;
  /** Daily posts count time series */
  posts: Array<TimeSeriesDataPoint>;
  /** Daily reach time series */
  reach: Array<TimeSeriesDataPoint>;
  /** Daily views time series */
  views: Array<TimeSeriesDataPoint>;
};

export type ChannelLimitError = {
  __typename?: 'ChannelLimitError';
  /** A raw error message to help developers understand the root cause of the issue. */
  cause: Scalars['String']['output'];
};

/** Settings for link shortening */
export type ChannelLinkShortening = {
  __typename?: 'ChannelLinkShortening';
  /** Configuration of link shortening integration. Null if disabled. */
  config?: Maybe<LinkShorteningConfig>;
  /** If link shortening is enabled for the channel */
  isEnabled: Scalars['Boolean']['output'];
};

/** The payload of the response from updateChannelLinkShortening */
export type ChannelLinkShorteningPayload = ChannelLinkShortening | NotFoundError | UnauthorizedError | UnexpectedError;

export type ChannelLocationData = {
  __typename?: 'ChannelLocationData';
  location?: Maybe<Scalars['String']['output']>;
  mapsLink?: Maybe<Scalars['String']['output']>;
};

/** Metadata or settings about the channel depending on the service type */
export type ChannelMetadata = BlueskyMetadata | FacebookMetadata | GoogleBusinessMetadata | InstagramMetadata | LinkedInMetadata | MastodonMetadata | PinterestMetadata | TiktokMetadata | TwitterMetadata | WhatsAppMetadata | YoutubeMetadata;

/** Channel-level metric types (as opposed to post-level PostMetricType) */
export enum ChannelMetricType {
  Followers = 'followers'
}

export type ChannelMutationResponse = ChannelResponse | Error;

export enum ChannelNativeService {
  StartPage = 'startPage'
}

/** Subset of the Organization type - only used internally to reduce the number of GraphQL queries - should not be used in public API */
export type ChannelOrganization = {
  __typename?: 'ChannelOrganization';
  /** Account ID of the "main" admin */
  contactAccountId: Scalars['String']['output'];
  /** List of entitlements for the organization */
  entitlements: Array<Maybe<Entitlement>>;
  /** The ID of the organization */
  id: Scalars['OrganizationId']['output'];
};

/**
 * A single channel's posting goal progress within an
 * OrganizationPostingGoalsSummary.
 */
export type ChannelPostingGoalSummary = {
  __typename?: 'ChannelPostingGoalSummary';
  /**
   * The channel this row is for. Resolves to the full Channel type so
   * consumers can render avatar, service, and display name without an
   * extra round trip.
   */
  channel: Channel;
  /**
   * The channel's posting goal: target, sent, scheduled, status, and
   * period. Always populated — rows for channels without a configured
   * goal are filtered out before they reach this list.
   */
  postingGoal: PostingGoal;
};

/**
 * Per-product channel access, keyed by product. Mirrors the permission
 * layer's stored `{ publish, comments }` shape. Used by invitations, team
 * members, and assignable channels. `none` means the product is not granted
 * on this channel (the field is never null — consistent with
 * `ChannelAccessLevel` modelling "no access" as a value).
 * Like `ChannelAccessLevel`, these values are for display only and must never
 * be used for authorization — use `allowedActions` on the entity being acted
 * on instead.
 */
export type ChannelProductAccessLevels = {
  __typename?: 'ChannelProductAccessLevels';
  /** Access level for the comments product. */
  comments: ChannelAccessLevel;
  /** Access level for the publish product. */
  publish: ChannelAccessLevel;
};

/**
 * Per-product channel access for a channel assignment, keyed by
 * product. Mirrors the permission layer's `{ publish, comments }` shape.
 * `none` means the product is not granted (never null — consistent with
 * `ChannelAccessLevel`). Both products are persisted and written to the
 * member's channel permission; the FE still sends `comments: none` until
 * the per-product UI lands.
 */
export type ChannelProductAccessLevelsInput = {
  /**
   * Access level to grant for the comments product. Persisted on the
   * invitation and written to the member's channel permission on accept.
   */
  comments: ChannelAccessLevel;
  /** Access level to grant for the publish product. */
  publish: ChannelAccessLevel;
};

/**
 * A channel assignment keyed by product. Used across team/channel
 * mutations as the per-product permission model rolls out.
 */
export type ChannelProductAssignmentInput = {
  /** The channel ID. */
  channelId: Scalars['ChannelId']['input'];
  /** Per-product access levels to grant on this channel. */
  productAccessLevels: ChannelProductAccessLevelsInput;
};

/**
 * Channel-level access keyed by product. Used across team members,
 * invitations, and assignable channels as the per-product permission model
 * rolls out.
 */
export type ChannelProductPermission = {
  __typename?: 'ChannelProductPermission';
  /** The channel for this permission. */
  channel: Channel;
  /** Per-product access levels granted on this channel. */
  productAccessLevels: ChannelProductAccessLevels;
};

/** Error returned when the channel needs a refresh */
export type ChannelRefreshRequired = MutationError & {
  __typename?: 'ChannelRefreshRequired';
  /** ChannelIds that need refreshing */
  channelIds: Array<Scalars['ChannelId']['output']>;
  /** Error message */
  message: Scalars['String']['output'];
};

export type ChannelResponse = {
  __typename?: 'ChannelResponse';
  channel: Channel;
  success: Scalars['Boolean']['output'];
};

/** Individual channel score with channel ID and its score details */
export type ChannelScore = {
  __typename?: 'ChannelScore';
  /** The channel ID for this score */
  channelId: Scalars['ChannelId']['output'];
  /** The score details for this channel */
  scoreDetails: ChannelScoreDetails;
};

/** Individual channel score details */
export type ChannelScoreDetails = {
  __typename?: 'ChannelScoreDetails';
  /** An achievement level based on the current period score. */
  currentAchievementLevel: CommentsScoreAchievement;
  /** The score of comments for the current period */
  currentPeriodScore: CommentScoreDetailed;
  /** The score of comments for the previous period */
  previousPeriodScore: CommentScoreDetailed;
};

export type ChannelServiceDataInput = {
  subscriptionType?: InputMaybe<Scalars['String']['input']>;
};

export type ChannelSlotDetails = {
  __typename?: 'ChannelSlotDetails';
  /** The number of channels purchased that the customer will pay a per unit amount. For non Agency plans that will be equal to currentQuantity */
  chargableQuantity: Scalars['Int']['output'];
  /** The number of channels purchased for this subscription. */
  currentQuantity: Scalars['Int']['output'];
  /** Fixed amount for the plan. It will contain a non 0 value only for the Agency plan */
  flatFee: Scalars['Float']['output'];
  /** The lowest value that the quantity can have for the specific subscription. It will be 1 for all plans except for Agency, where it will be 10. */
  minimumQuantity: Scalars['Int']['output'];
  /** The price that a customer will pay for every chargableQuantity */
  pricePerQuantity: Scalars['Float']['output'];
};

export type ChannelStoreTemporaryCredentialsResponse = Error | Response;

/** The available synchronization strategies for fetching user comments. */
export enum ChannelSyncType {
  /**
   * Subscribe to a Firehose (ATProto repo subscription).
   * Streams all network events and requires filtering for comments.
   */
  Firehose = 'firehose',
  /** Periodically pull comments from the REST API endpoints. */
  Polling = 'polling',
  /**
   * Receive comments via webhooks when supported by the platform.
   * Allows near real-time delivery.
   */
  Webhook = 'webhook'
}

/** Channel takeaways query input */
export type ChannelTakeawaysInput = {
  /** The channel ID */
  channelId: Scalars['ChannelId']['input'];
  /** The organization ID */
  organizationId: Scalars['OrganizationId']['input'];
};

export enum ChannelThirdPartyService {
  Bluesky = 'bluesky',
  Facebook = 'facebook',
  Googlebusiness = 'googlebusiness',
  Instagram = 'instagram',
  Linkedin = 'linkedin',
  Mastodon = 'mastodon',
  Pinterest = 'pinterest',
  Substack = 'substack',
  Threads = 'threads',
  Tiktok = 'tiktok',
  Twitter = 'twitter',
  Whatsapp = 'whatsapp',
  Youtube = 'youtube'
}

/** Channel is a representation of a social media account or page that can be connected to Buffer. */
export enum ChannelType {
  Account = 'account',
  Business = 'business',
  Channel = 'channel',
  Group = 'group',
  Page = 'page',
  Profile = 'profile'
}

export type ChannelUpdateCredentialsInput = {
  credentials: ChannelCredentialsInput;
  service: Service;
  serviceIds: Array<Scalars['String']['input']>;
};

export type ChannelUpdateLockedStatusInput = {
  channelId: Scalars['ID']['input'];
  isLocked: Scalars['Boolean']['input'];
};

export type ChannelUpdateLockedStatusResponse = ChannelLimitError | Error | Response;

export type ChannelWithCredentialsInput = {
  avatar: Scalars['String']['input'];
  channelId?: InputMaybe<Scalars['ID']['input']>;
  credentials?: InputMaybe<ChannelCredentialsInput>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  locationData?: InputMaybe<LocationDataInput>;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  /** Channels are now linked to a single Buffer product by default. This field will be removed on the 29th September */
  products?: InputMaybe<Array<Product>>;
  serverUrl?: InputMaybe<Scalars['String']['input']>;
  service: ChannelThirdPartyService;
  serviceData?: InputMaybe<ChannelServiceDataInput>;
  serviceId: Scalars['String']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
  type: ChannelType;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ChannelsConnectError = {
  __typename?: 'ChannelsConnectError';
  /** A raw error message to help developers understand the root cause of the issue. */
  cause: Scalars['String']['output'];
  /** A user-friendly message that is safe to be displayed to users. */
  userFriendlyMessage: Scalars['String']['output'];
};

export type ChannelsConnectPayload = ChannelsConnectError | ChannelsConnectResponse;

export type ChannelsConnectResponse = {
  __typename?: 'ChannelsConnectResponse';
  channels: Array<Channel>;
};

/** Filter to pass when fetching channels. */
export type ChannelsFiltersInput = {
  /**
   * If not defined, it returns all channels
   * Else,
   *   if true, it only returns locked channels
   *   if false, it only returns not locked channels
   */
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * If not passed, it return all channels
   * Else, it filters the channels based on what the product supports.
   */
  product?: InputMaybe<Product>;
};

/** Input to pass when fetching channels. */
export type ChannelsInput = {
  /** A list of option filters - passing null means we don't want to filter */
  filter?: InputMaybe<ChannelsFiltersInput>;
  /** The Organization id to fetch channels for */
  organizationId: Scalars['OrganizationId']['input'];
};

export type ChannelsSetRecommendationsError = {
  __typename?: 'ChannelsSetRecommendationsError';
  /** A raw error message to help developers understand the root cause of the issue. */
  cause: Scalars['String']['output'];
  /** A user-friendly message that is safe to be displayed to users. */
  userFriendlyMessage: Scalars['String']['output'];
};

export type ChannelsSetRecommendationsPayload = ChannelsSetRecommendationsError | ChannelsSetRecommendationsResponse;

export type ChannelsSetRecommendationsResponse = {
  __typename?: 'ChannelsSetRecommendationsResponse';
  success: Scalars['Boolean']['output'];
};

export type ChannelsUpdateCredentialsResponse = Error | Response;

export type Charge = {
  __typename?: 'Charge';
  amount: Scalars['Float']['output'];
  amountAvailableForRefund: Scalars['Float']['output'];
  amountPaid: Scalars['Float']['output'];
  amountRefunded: Scalars['Float']['output'];
  canBeRefunded: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  failureCode?: Maybe<Scalars['String']['output']>;
  failureMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isPaid: Scalars['Boolean']['output'];
  /** 'isRefunded' will only be true if the charge was fully refunded. It will remain false for partial refunds */
  isRefunded: Scalars['Boolean']['output'];
  receiptUrl?: Maybe<Scalars['String']['output']>;
  status: ChargeStatus;
};

export enum ChargeStatus {
  Failed = 'failed',
  Pending = 'pending',
  Succeeded = 'succeeded'
}

/**
 * Input for triggering an on-demand evaluation of a channel's verified
 * capabilities.
 */
export type CheckChannelCapabilitiesInput = {
  /** The channel whose capabilities should be evaluated. */
  channelId: Scalars['ChannelId']['input'];
};

/** Possible responses for the checkChannelCapabilities mutation. */
export type CheckChannelCapabilitiesPayload = EmptySuccess | LimitReachedError;

/** Query responses */
export type Checklist = {
  __typename?: 'Checklist';
  id: Scalars['Int']['output'];
  items?: Maybe<Array<Maybe<ChecklistItem>>>;
  title: Scalars['String']['output'];
};

export type ChecklistItem = {
  __typename?: 'ChecklistItem';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isCompleted: Scalars['Boolean']['output'];
};

export type ChecklistsPayload = ChecklistsResponse | CoreWebAppCommonError;

export type ChecklistsResponse = {
  __typename?: 'ChecklistsResponse';
  checklists?: Maybe<Array<Maybe<Checklist>>>;
};

export type ChildBlockConfigInput = {
  data?: InputMaybe<BlockDataInput>;
  parentBlockId?: InputMaybe<Scalars['String']['input']>;
  scheduledAt?: InputMaybe<Scalars['String']['input']>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<StartPageBlockTypes>;
};

/** Input for claiming a LinkedIn Premium promo code */
export type ClaimLinkedInPremiumPromoCodeInput = {
  /** Optional LinkedIn channel ID if claim is associated with a channel */
  channelId?: InputMaybe<Scalars['ChannelId']['input']>;
  /**
   * Source of the claim (e.g., 'linkedin_channel_cta', 'queue_page_banner')
   * Used for analytics tracking
   */
  source: Scalars['String']['input'];
};

/** Payload returned when claiming a LinkedIn Premium promo code */
export type ClaimLinkedInPremiumPromoCodePayload = ClaimLinkedInPremiumPromoCodeSuccess | VoidMutationError;

/** Success payload for claiming a LinkedIn Premium promo code */
export type ClaimLinkedInPremiumPromoCodeSuccess = {
  __typename?: 'ClaimLinkedInPremiumPromoCodeSuccess';
  /** The claimed promo code details */
  promoCode: LinkedInPremiumPromoCode;
};

/** Client response returned by the client query, containing configuration details for the client making the request */
export type Client = {
  __typename?: 'Client';
  supportStatus: ClientSupportStatus;
};

/** Error response returned when there is a problem retrieving the information for a client */
export type ClientError = {
  __typename?: 'ClientError';
  cause: Scalars['String']['output'];
};

export type ClientInput = {
  platform: ClientPlatform;
  version: Scalars['String']['input'];
};

/** Payload response returned by the client query */
export type ClientPayload = Client | ClientError;

/** The platform that the client is being used on */
export enum ClientPlatform {
  Android = 'android',
  Ios = 'ios',
  Web = 'web'
}

/** Specifies the support status of a client, along with an (optional) reason as to why that client might not be supported */
export type ClientSupportStatus = {
  __typename?: 'ClientSupportStatus';
  reason?: Maybe<Scalars['String']['output']>;
  status: SupportStatus;
};

/** A collaboration Note on a Post. */
export type CollaborationNote = {
  __typename?: 'CollaborationNote';
  /** The actions the current account can perform on the Note. */
  allowedActions: Array<NoteAction>;
  /** The annotations in the Note text. */
  annotations: Array<Annotation>;
  /** The author, or null when the account no longer exists. */
  author?: Maybe<Author>;
  /** The author's Account ID, including when the account no longer exists. */
  authorId: Scalars['AccountId']['output'];
  /** The date and time of Note creation. */
  createdAt: Scalars['DateTime']['output'];
  /** The Note ID. */
  id: Scalars['NoteId']['output'];
  /** One reaction group per emoji, in the order each emoji was first used. */
  reactions: Array<CollaborationNoteReaction>;
  /** The Note text. */
  text: Scalars['String']['output'];
  /** The date and time of the last Note update. */
  updatedAt: Scalars['DateTime']['output'];
};

/** How a collaboration Note changed. */
export enum CollaborationNoteChangeKind {
  /** A member created the Note. */
  Created = 'created',
  /** A member edited the Note or changed its reactions. */
  Updated = 'updated'
}

/** A member created a collaboration Note. */
export type CollaborationNoteCreated = {
  __typename?: 'CollaborationNoteCreated';
  /** The new Note and its cursor. */
  edge: CollaborationNoteEdge;
  /** The Post the Note belongs to. */
  post: Post;
};

/** A member deleted a collaboration Note. */
export type CollaborationNoteDeleted = {
  __typename?: 'CollaborationNoteDeleted';
  /** The deleted Note ID. */
  noteId: Scalars['NoteId']['output'];
  /** The Post the Note belonged to. */
  post: Post;
};

/** A Note and its pagination cursor. */
export type CollaborationNoteEdge = {
  __typename?: 'CollaborationNoteEdge';
  /** The opaque cursor for this Note. */
  cursor: Scalars['String']['output'];
  /** The Note. */
  node: CollaborationNote;
};

/** The reactions on a collaboration Note that use one emoji. */
export type CollaborationNoteReaction = {
  __typename?: 'CollaborationNoteReaction';
  /**
   * The accounts that reacted with this emoji, in reaction order. Deleted
   * accounts are omitted.
   */
  accounts: Array<Author>;
  /** The number of accounts in `accounts`. */
  count: Scalars['Int']['output'];
  /** The emoji for this reaction group. */
  emoji: Scalars['String']['output'];
  /** Whether the current account reacted with this emoji. */
  hasReacted: Scalars['Boolean']['output'];
};

/** One change to the collaboration Notes in one thread. */
export type CollaborationNoteSubjectChange = CollaborationNoteSubjectNoteChanged | CollaborationNoteSubjectNoteDeleted;

/** The Notes thread to watch. */
export type CollaborationNoteSubjectChangesInput = {
  /**
   * The entity whose Notes thread to watch. Post subjects are not supported: use
   * `collaborationNotesChanges` for Post Notes.
   */
  subject: CollaborationNoteSubjectInput;
};

/** The entity whose Notes thread to use. Set exactly one field. */
export type CollaborationNoteSubjectInput =
  /**
   * The ContentItem ID. Selects the ContentItem's own thread, not the threads of
   * its Posts.
   */
  { contentItemId: Scalars['ContentItemId']['input']; postId?: never; }
  |  /** The Post ID. */
  { contentItemId?: never; postId: Scalars['PostId']['input']; };

/** A member created or changed a collaboration Note in the watched thread. */
export type CollaborationNoteSubjectNoteChanged = {
  __typename?: 'CollaborationNoteSubjectNoteChanged';
  /** Whether the Note is new or changed. */
  kind: CollaborationNoteChangeKind;
  /** The Note after the change. */
  note: CollaborationNote;
};

/** A member deleted a collaboration Note in the watched thread. */
export type CollaborationNoteSubjectNoteDeleted = {
  __typename?: 'CollaborationNoteSubjectNoteDeleted';
  /** The deleted Note ID. */
  noteId: Scalars['NoteId']['output'];
};

/**
 * Error returned when a Note is created in a thread that accepts no new Notes.
 * Existing Notes in the thread stay readable.
 */
export type CollaborationNoteThreadClosedError = MutationError & {
  __typename?: 'CollaborationNoteThreadClosedError';
  /** Error message */
  message: Scalars['String']['output'];
};

/** The state of one Notes thread for the current account. */
export type CollaborationNoteThreadSummary = {
  __typename?: 'CollaborationNoteThreadSummary';
  /**
   * Whether the current account can create a Note in the thread now. False when
   * the thread is closed.
   */
  canCreate: Scalars['Boolean']['output'];
  /** Whether the thread accepts no new Notes. Existing Notes stay readable. */
  isClosed: Scalars['Boolean']['output'];
  /** The number of Notes in the thread. */
  totalCount: Scalars['Int']['output'];
  /** The number of Notes in the thread that the current account has not read. */
  unreadCount: Scalars['Int']['output'];
};

/** A member edited a collaboration Note. */
export type CollaborationNoteUpdated = {
  __typename?: 'CollaborationNoteUpdated';
  /** The Note after the edit. */
  note: CollaborationNote;
  /** The Post the Note belongs to. */
  post: Post;
};

/** One change to the collaboration Notes of a Post. */
export type CollaborationNotesChange = CollaborationNoteCreated | CollaborationNoteDeleted | CollaborationNoteUpdated;

/** Which Posts' collaboration Notes to watch. */
export type CollaborationNotesChangesInput = {
  /** The organization whose Posts the reader watches. */
  organizationId: Scalars['OrganizationId']['input'];
};

/** A page of authorized Notes. */
export type CollaborationNotesConnection = {
  __typename?: 'CollaborationNotesConnection';
  /** The Notes in this page. */
  edges: Array<CollaborationNoteEdge>;
  /** The pagination information for this page. */
  pageInfo: PaginationPageInfo;
};

/** The Notes thread to read. */
export type CollaborationNotesInput = {
  /** The entity whose Notes thread to read. */
  subject: CollaborationNoteSubjectInput;
};

/** The current account's read position for a Post's collaboration Notes. */
export type CollaborationNotesReadState = {
  __typename?: 'CollaborationNotesReadState';
  /** The first unread Note, if any. */
  firstUnreadNoteId?: Maybe<Scalars['NoteId']['output']>;
  /** The last Note included in the read position, if any. */
  readThroughNoteId?: Maybe<Scalars['NoteId']['output']>;
  /** The number of unread Notes. */
  unreadNoteCount: Scalars['Int']['output'];
};

/** The Post whose Notes read position to return. */
export type CollaborationNotesReadStateInput = {
  /** The Post ID. */
  postId: Scalars['PostId']['input'];
};

/**
 * The Notes on a Post: their total, and the current account's unread Notes.
 *
 * A Note is unread when it comes after the account's read-through position on
 * the Post, whoever wrote it. Writing a Note moves that position past it only
 * when nothing on the Post was unread at the time. The unread counts are
 * relative to the current account. Every count is null when the account cannot
 * read the Post's Notes.
 */
export type CollaborationNotesSummary = {
  __typename?: 'CollaborationNotesSummary';
  /**
   * The number of Notes on the Post, whoever wrote them and whether or not they
   * are read.
   */
  noteCount?: Maybe<Scalars['Int']['output']>;
  /**
   * The number of unread Notes containing a mention of the current account.
   * A Note with several matching mentions counts once.
   */
  unreadMentionCount?: Maybe<Scalars['Int']['output']>;
  /** The number of unread Notes on the Post. */
  unreadNoteCount?: Maybe<Scalars['Int']['output']>;
};

/**
 * Organization role for the Roles management API.
 * Use allowedActions on the target entity for authorization.
 */
export enum CollaborationRole {
  /** Administrator role. */
  Admin = 'admin',
  /** Collaborator role. */
  Collaborator = 'collaborator',
  /** Creator role. */
  Creator = 'creator',
  /** Viewer role. */
  Viewer = 'viewer'
}

/** A comment-shaped engagement — a direct reply to a Buffer-managed post. */
export type Comment = Engagement & {
  __typename?: 'Comment';
  /** Media attached to the comment. */
  assets: Array<Asset>;
  /** Author of the comment. */
  author: EngagementAuthor;
  /** Channel (Buffer-managed social account) this comment was left on. */
  channelId: Scalars['ChannelId']['output'];
  /** Content format of this comment. */
  contentType: EngagementContentType;
  /** When this comment was first ingested into Buffer. */
  createdAt: Scalars['DateTime']['output'];
  /** When the user dismissed this comment. */
  dismissedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier of this comment. */
  id: Scalars['EngagementId']['output'];
  /** `true` when this comment was sent by the user via Buffer or natively; `false` when it's a third-party comment. */
  isOwnEngagement: Scalars['Boolean']['output'];
  /** AI-generated labels for the comment. Empty when labelling hasn't run yet or AI features are disabled. */
  labels: Array<Scalars['String']['output']>;
  /** Network-specific extra fields for the comment (e.g. star rating on Google Business reviews). */
  metadata?: Maybe<CommentMetadata>;
  /** Organization this comment belongs to. */
  organizationId: Scalars['OrganizationId']['output'];
  /** Parent engagement id when this item is a reply to another comment. Null for top-level comments. */
  parentId?: Maybe<Scalars['EngagementId']['output']>;
  /** Type of the post: post, reel, story, short, etc. */
  postContentType: PostType;
  /** Buffer post ID of the post this comment belongs to. */
  postId: Scalars['PostId']['output'];
  /** Publication timestamp of the post this comment lives under. */
  postPublishedAt: Scalars['DateTime']['output'];
  /** Public URL of this comment on the network. Falls back to the channel URL when unavailable. */
  publicUrl: Scalars['String']['output'];
  /** When the comment was published on the network. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Buffer publishing status. Only set when this comment is a Buffer-sent reply. */
  publishingStatus?: Maybe<PublishingStatus>;
  /** Reactions received on this comment. */
  reactions: Array<Reaction>;
  /** When the user replied to this comment. */
  repliedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Seconds elapsed between the comment being published and the user first replying. */
  responseTimeDiffInSeconds: Scalars['Int']['output'];
  /** Network this comment lives on (instagram, facebook, threads, …). */
  serviceType: Service;
  /** Current lifecycle status of the comment. */
  status: EngagementStatus;
  /** AI-generated quick-reply suggestions. Null when suggestions haven't been generated yet. */
  suggestions: Array<Suggestion>;
  /** Text body of the comment. Null for media-only comments. */
  text?: Maybe<Scalars['String']['output']>;
  /** Last time the comment record was updated (re-ingestion, status change, etc.). */
  updatedAt: Scalars['DateTime']['output'];
};

/** Represents the author of a comment. */
export type CommentAuthor = {
  __typename?: 'CommentAuthor';
  /** The avatar URL of the author. */
  avatar: Scalars['String']['output'];
  /** The default avatar settings of the author. */
  defaultAvatarSettings?: Maybe<DefaultAvatarSettings>;
  /** The name of the author. */
  name?: Maybe<Scalars['String']['output']>;
  /** The username of the author. */
  username: Scalars['String']['output'];
};

/**
 * The kind of content carried by a comment. Mirrors what the third-party
 * service exposed to us: most comments are plain text, some carry media
 * attachments, and some (e.g. TikTok sticker-only comments) carry content
 * the third-party API doesn't expose to us — those land as `unsupported`.
 */
export enum CommentContentType {
  /** The comment carries an audio attachment. */
  Audio = 'audio',
  /** The comment carries multiple media attachments. */
  Carousel = 'carousel',
  /** The comment is an animated GIF. */
  Gif = 'gif',
  /** The comment carries an image attachment. */
  Image = 'image',
  /** A regular text comment. */
  Text = 'text',
  /**
   * The comment carries content the third-party API does not expose to us
   * (e.g. TikTok sticker-only comments). Clients should render a placeholder.
   */
  Unsupported = 'unsupported',
  /** The comment carries a video attachment. */
  Video = 'video'
}

/** Input for the comment context query */
export type CommentContextInput = {
  /** The comment id to fetch context for */
  commentId: Scalars['CommentId']['input'];
};

/** Response for the comment context query */
export type CommentContextResponse = {
  __typename?: 'CommentContextResponse';
  /** Original comment */
  comment: CommentData;
  /**
   * Array of comments parents of the input comment.
   * Empty array if the input comment is a root comment.
   */
  context?: Maybe<Array<CommentData>>;
};

/** A Comment can be a Comment received from a Third Party or a Comment sent by Buffer */
export type CommentData = CommentFromBuffer | CommentFromThirdParty;

/** The different status for a comment sent by Buffer */
export enum CommentEngagementStatusTypes {
  /** Comment created but not sent yet to the third party */
  Draft = 'draft',
  /** The publishing process failed */
  Error = 'error',
  /** The publishing process is in progress */
  Processing = 'processing',
  /** The publishing process succeded */
  Published = 'published'
}

/**
 * Describes a comment sent by Buffer where we need to track the publishing
 * process status.
 * publishedAt and publicUrl are optional as the publishing process could fail.
 */
export type CommentFromBuffer = BaseComment & {
  __typename?: 'CommentFromBuffer';
  /** BaseComment: Media attachments associated with the comment. */
  assets: Array<Asset>;
  /** BaseComment: Information about the author of the comment. */
  author: CommentAuthor;
  /** BaseComment: The ID of the channel that the comment belongs to. */
  channelId: Scalars['ChannelId']['output'];
  /** BaseComment: The kind of content carried by the comment. */
  contentType: CommentContentType;
  /** BaseComment:  The timestamp when the comment was created in the system. */
  createdAt: Scalars['DateTime']['output'];
  /** BaseComment: The ID of the comment */
  id: Scalars['CommentId']['output'];
  /** Whether the comment is deleted by the third party. */
  isDeleted: Scalars['Boolean']['output'];
  /** BaseComment: Whether the comment is hidden. */
  isHidden: Scalars['Boolean']['output'];
  /**
   * BaseComment: Whether this comment is an own reply. The comment has been
   * sent by the user using Buffer or natively.
   */
  isOwnReply: Scalars['Boolean']['output'];
  /** BaseComment: Replies to this comment. */
  lastReplies?: Maybe<Array<LastReply>>;
  /** BaseComment: Service-specific metadata for the comment (e.g., Google Business review details). */
  metadata?: Maybe<CommentMetadata>;
  /** BaseComment: The ID of the organization that owns the comment. */
  organizationId: Scalars['OrganizationId']['output'];
  /**
   * BaseComment: The ID of the parent comment, if applicable.
   * We set this value in replies to comments as the id of the replied comment.
   * For top-level comments (replies to post) will be null.
   */
  parentId?: Maybe<Scalars['CommentId']['output']>;
  /** BaseComment: Refers to the post the comment belongs to. */
  post: Post;
  /** BaseComment: The timestamp when the related post was published on the third-party service. */
  postPublishedAt: Scalars['DateTime']['output'];
  /**
   * BaseComment: URL of the comment on the third-party service. It could be undefined
   * if the comment hasn't be published yet.
   */
  publicUrl?: Maybe<Scalars['String']['output']>;
  /**
   * BaseComment: The timestamp when this comment was created on the third-party service. It could be undefined
   * if the comment hasn't be published yet.
   */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Describes the status of a comment sent by Buffer to third party
   * and potential errors.
   */
  publishingStatus: PublishingStatus;
  /** BaseComment: Reactions to the comment. */
  reactions: Array<Reaction>;
  /**
   * BaseComment: The time difference in seconds between the comment's publication and a response.
   * For top-level comments is the difference between post's publication and this
   * comment's creation, calculated even if the comment fails to be sent.
   */
  responseTimeDiffInSeconds: Scalars['Int']['output'];
  /** BaseComment: The type of service the comment belongs to: threads, facebook, etc */
  serviceType: Service;
  /** BaseComment: The status of the comment (e.g., unreplied, replied, dismissed). */
  status: CommentStatus;
  /**
   * BaseComment: The text content of the comment. It could be empty. Comments could have
   * text and/or assets and we're making them both mandatory to avoid the case
   * where none of them could be provided.
   */
  text: Scalars['String']['output'];
  /** BaseComment: The timestamp when the comment was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /**
   * BaseComment: User rating for review-based platforms (e.g., Google Business star ratings).
   * Integer value typically 1-5. Only applicable for platforms that support reviews with ratings.
   * @deprecated Use metadata { ... on GoogleBusinessCommentMetadata { userRating } }
   */
  userRating?: Maybe<Scalars['Int']['output']>;
};

/**
 * Describes a comment received from a third-party. We'll add labels, sentimentAnalysis
 * and suggestions during the ingestion process.
 */
export type CommentFromThirdParty = BaseComment & {
  __typename?: 'CommentFromThirdParty';
  /** BaseComment: Media attachments associated with the comment. */
  assets: Array<Asset>;
  /** BaseComment: Information about the author of the comment. */
  author: CommentAuthor;
  /** BaseComment: The ID of the channel that the comment belongs to. */
  channelId: Scalars['ChannelId']['output'];
  /** BaseComment: The kind of content carried by the comment. */
  contentType: CommentContentType;
  /** BaseComment:  The timestamp when the comment was created in the system. */
  createdAt: Scalars['DateTime']['output'];
  /** BaseComment: The ID of the comment */
  id: Scalars['CommentId']['output'];
  /** Whether the comment is deleted by the third party. */
  isDeleted: Scalars['Boolean']['output'];
  /** BaseComment: Whether the comment is hidden. */
  isHidden: Scalars['Boolean']['output'];
  /**
   * BaseComment: Whether this comment is an own reply. The comment has been
   * sent by the user using Buffer or natively.
   */
  isOwnReply: Scalars['Boolean']['output'];
  /** Labels assigned to the comment. e.g. question, negativity */
  labels: Array<CommentLabel>;
  /** BaseComment: Replies to this comment. */
  lastReplies?: Maybe<Array<LastReply>>;
  /** BaseComment: Service-specific metadata for the comment (e.g., Google Business review details). */
  metadata?: Maybe<CommentMetadata>;
  /** BaseComment: The ID of the organization that owns the comment. */
  organizationId: Scalars['OrganizationId']['output'];
  /**
   * BaseComment: The ID of the parent comment, if applicable.
   * We set this value in replies to comments as the id of the replied comment.
   * For top-level comments (replies to post) will be null.
   */
  parentId?: Maybe<Scalars['CommentId']['output']>;
  /** BaseComment: Refers to the post the comment belongs to. */
  post: Post;
  /** BaseComment: The timestamp when the related post was published on the third-party service. */
  postPublishedAt: Scalars['DateTime']['output'];
  /**
   * BaseComment: URL of the comment on the third-party service. It could be undefined
   * if the comment hasn't be published yet.
   */
  publicUrl?: Maybe<Scalars['String']['output']>;
  /**
   * BaseComment: The timestamp when this comment was created on the third-party service. It could be undefined
   * if the comment hasn't be published yet.
   */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** BaseComment: Reactions to the comment. */
  reactions: Array<Reaction>;
  /**
   * BaseComment: The time difference in seconds between the comment's publication and a response.
   * For top-level comments is the difference between post's publication and this
   * comment's creation, calculated even if the comment fails to be sent.
   */
  responseTimeDiffInSeconds: Scalars['Int']['output'];
  /**
   * Sentiment analysis results for the comment. It could contain detailed
   * information related to the label assigned to the comment.
   * It is optional because it won't calculated in all the cases.
   */
  sentimentAnalysis?: Maybe<Array<SentimentAnalysis>>;
  /** BaseComment: The type of service the comment belongs to: threads, facebook, etc */
  serviceType: Service;
  /** BaseComment: The status of the comment (e.g., unreplied, replied, dismissed). */
  status: CommentStatus;
  /** Suggested actions or responses for the comment. */
  suggestions: Array<Suggestion>;
  /**
   * BaseComment: The text content of the comment. It could be empty. Comments could have
   * text and/or assets and we're making them both mandatory to avoid the case
   * where none of them could be provided.
   */
  text: Scalars['String']['output'];
  /** BaseComment: The timestamp when the comment was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /**
   * BaseComment: User rating for review-based platforms (e.g., Google Business star ratings).
   * Integer value typically 1-5. Only applicable for platforms that support reviews with ratings.
   * @deprecated Use metadata { ... on GoogleBusinessCommentMetadata { userRating } }
   */
  userRating?: Maybe<Scalars['Int']['output']>;
};

/** Labels that can be assigned to a comment. */
export enum CommentLabel {
  /** The comment contains negative sentiment. */
  Negative = 'negative',
  /** The comment doesn't contain negative or positive sentiment. */
  Neutral = 'neutral',
  /** The comment contains positive sentiment. */
  Positive = 'positive',
  /** The comment is a question. */
  Question = 'question',
  /** The author of the comment is a super fan */
  Superfan = 'superfan'
}

/** Comment metadata union type. Contains all possible types of comment metadata. */
export type CommentMetadata = GoogleBusinessCommentMetadata;

/** We support only the "rich" type for now. */
export type CommentOEmbed = OEmbedRich;

/** The comments score broken down to its individual score metrics, responseRate, responseSpeed, consistency */
export type CommentScoreDetailed = {
  __typename?: 'CommentScoreDetailed';
  /**
   * The consistency of comments
   * maximum value is 20
   */
  consistency: CommentsScoreMetric;
  /**
   * The response rate of comments
   * maximum value is 50
   */
  responseRate: CommentsScoreMetric;
  /**
   * The response speed of comments
   * maximum value is 30
   */
  responseSpeed: CommentsScoreMetric;
  /** The total value of the comments score. Maximum value is 100. */
  totalValue: Scalars['Int']['output'];
};

/** Fields that can be used to sort comments. */
export enum CommentSortableKey {
  /** Sort comments based on their published timestamp. */
  PublishedAt = 'publishedAt',
  /**
   * Sort comments based on their status bucket.
   * Descending order uses: unreplied, dismissed, replied, replying.
   */
  Status = 'status'
}

/** Possible statuses of a comment. */
export enum CommentStatus {
  /** The comment has been dismissed. */
  Dismissed = 'dismissed',
  /**
   * new is not a real status but it's considered as a status here for simplicity
   * a new comment is an unreplied one received in the last 48 hours and not seen by the user
   */
  New = 'new',
  /** The comment has received a reply. */
  Replied = 'replied',
  /** The comment is being replied to. */
  Replying = 'replying',
  /** The comment has not been replied to. */
  Unreplied = 'unreplied'
}

/**
 * Suggestions source: currently, they could be generated by AI or from a kind
 * of template
 */
export enum CommentSuggestionSource {
  /** Suggestions generated by AI */
  Ai = 'ai',
  /** Suggestions selected from a file with fixed suggestions */
  Template = 'template'
}

/** Input for the commentSuggestions query */
export type CommentSuggestionsInput = {
  /** The comment id to fetch suggestions for */
  commentId: Scalars['CommentId']['input'];
  /** Whether to regenerate the suggestions, false by default */
  regenerate?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Response for the quick replies generated by the AI */
export type CommentSuggestionsResponse = {
  __typename?: 'CommentSuggestionsResponse';
  /** List of suggestions for the comment */
  suggestions: Array<Suggestion>;
};

/** Input for the comment thread query */
export type CommentThreadInput = {
  /** The comment id to fetch thread for */
  commentId: Scalars['CommentId']['input'];
};

/** Response for the comment thread query */
export type CommentThreadResponse = {
  __typename?: 'CommentThreadResponse';
  /** The thread of the comment */
  thread: Array<CommentData>;
};

/** Configuration for channels */
export type CommentsChannelConfiguration = {
  __typename?: 'CommentsChannelConfiguration';
  /** Whether the channel supports user ratings (e.g., star ratings for reviews). */
  hasUserRating: Scalars['Boolean']['output'];
  /** Configuration for liking comments on this channel. */
  liking: Liking;
  /** The type of mention to use for the channel. */
  mentionType?: Maybe<MentionType>;
  /** Configuration for oEmbed support on this channel. */
  oEmbed: OEmbed;
  /** A permanent informational note to display for this channel (e.g., media limitations). */
  permanentNote?: Maybe<Scalars['String']['output']>;
  /** Whether the channel supports AI features (suggestions, insights, etc.). */
  supportAIFeatures: Scalars['Boolean']['output'];
  /** The service (e.g., Facebook, Twitter) and specific type of channel (e.g., group, page, profile). */
  supportedChannel: SupportedChannel;
  /**
   * Whether the channel supports AI-generated suggestions for comments.
   * @deprecated Use supportAIFeatures instead
   */
  supportsSuggestions: Scalars['Boolean']['output'];
  /** Specific configuration for the sync type. It could be null. */
  syncConfiguration?: Maybe<SyncConfiguration>;
  /** Synchronization strategy for fetching comments from this channel. */
  syncType: ChannelSyncType;
};

/** Input for the comments configuration query */
export type CommentsConfigurationInput = {
  /** The organization id to fetch comments configuration for */
  organizationId: Scalars['OrganizationId']['input'];
};

/** Comments configuration. */
export type CommentsConfigurationResponse = {
  __typename?: 'CommentsConfigurationResponse';
  /** The feature access status per channel */
  channelAuthorizationStatus: Array<ChannelAuthorizationStatus>;
  /** The character limit for each channel supporting Community. */
  channelCharacterLimits: Array<ChannelCharacterLimit>;
  /** The specific configuration for each channel supporting Community. */
  channelsSettings: Array<CommentsChannelConfiguration>;
};

/** Comments Count for a channel */
export type CommentsCount = {
  __typename?: 'CommentsCount';
  /** The id of the channel if a channelId list was provided as input */
  channelId: Scalars['ChannelId']['output'];
  /** The count of comments that satisfies the filters */
  count: Scalars['Int']['output'];
  /**
   * This field is used by the BE to limit the results in the DB query
   * when the query fails due to a time out.
   * BE will return the used limit to the FE and the FE will have to handle it
   * to get the remaining data.
   */
  limit: Scalars['Int']['output'];
};

/** Aggregated comment status counts for a post. */
export type CommentsCountsByPost = {
  __typename?: 'CommentsCountsByPost';
  /** Per-status counts grouped by comment status. */
  comments: CommentsCountsByStatus;
  /** The id of the post associated with these counts. */
  postId: Scalars['PostId']['output'];
};

/** Optional filters for the commentsCountsByPost query. */
export type CommentsCountsByPostFiltersInput = {
  /** Filters comments by the date they were published. */
  publishedAt?: InputMaybe<DateTimeComparator>;
};

/** Input for the commentsCountsByPost query. */
export type CommentsCountsByPostInput = {
  /** Optional filters applied to the counts query. */
  filters?: InputMaybe<CommentsCountsByPostFiltersInput>;
  /** The list of posts to retrieve counts for. */
  postIds: Array<Scalars['PostId']['input']>;
};

/** Response returned by commentsCountsByPost. */
export type CommentsCountsByPostResponse = {
  __typename?: 'CommentsCountsByPostResponse';
  /** Counts for each requested post. */
  counts: Array<CommentsCountsByPost>;
};

/** Detailed counts for each comment status. */
export type CommentsCountsByStatus = {
  __typename?: 'CommentsCountsByStatus';
  /** Number of comments dismissed by the customer. */
  dismissed: Scalars['Int']['output'];
  /** Number of comments that have been marked as replied. */
  replied: Scalars['Int']['output'];
  /** Number of comments that have not been replied to. */
  unreplied: Scalars['Int']['output'];
};

/** Filters for the comments count query */
export type CommentsCountsFiltersInput = {
  /**
   * When set, it will filter comments by channel.
   * If not provided, query will return count for the organization
   */
  channelIds?: InputMaybe<Array<Scalars['ChannelId']['input']>>;
  /**
   * When set, it will filter comments by whether they are own replies.
   * Own replies are comments sent by the user using Buffer or natively.
   */
  isOwnReply?: InputMaybe<Scalars['Boolean']['input']>;
  /** The sentiment of comments to return: Labels are question, negativity, etc. */
  label?: InputMaybe<CommentLabel>;
  /** The postId to fetch comments for */
  postId?: InputMaybe<Array<Scalars['PostId']['input']>>;
  /**
   * When set, it will filter comments by the date they were published.
   * DateTimeComprator is a range filter with a start and end date.
   */
  publishedAt?: InputMaybe<DateTimeComparator>;
  /**
   * When set, it will filter comments by status: new, replied, unreplied, dismissed
   * new is not a real status but it's considered as a status here for simplicity
   */
  status?: InputMaybe<Array<CommentStatus>>;
};

/** Input for the comments count query */
export type CommentsCountsInput = {
  /** The filters to apply to the comments query */
  filters?: InputMaybe<CommentsCountsFiltersInput>;
  /** Optional limit to cap the count results. If not provided, no limit will be applied. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** The Organization id to fetch comments counts for */
  organizationId: Scalars['OrganizationId']['input'];
};

/** Query Response */
export type CommentsCountsResponse = {
  __typename?: 'CommentsCountsResponse';
  /** list of counts */
  counts: Array<CommentsCount>;
};

/** Represents a single comment and its pagination cursor. */
export type CommentsEdge = {
  __typename?: 'CommentsEdge';
  /** A unique identifier (cursor) for pagination. */
  cursor: Scalars['String']['output'];
  /** The actual comment data. */
  node: CommentData;
};

/** Fields that can be used to filter comments. */
export type CommentsFiltersInput = {
  /** The channel(s) ids to fetch comments for */
  channelIds?: InputMaybe<Array<Scalars['ChannelId']['input']>>;
  /** The sentiment of comments to return */
  label?: InputMaybe<CommentLabel>;
  /** The postId to fetch comments for */
  postId?: InputMaybe<Array<Scalars['PostId']['input']>>;
  /** When set, it will filter comments by the date they were published */
  publishedAt?: InputMaybe<DateTimeComparator>;
  /** When set, it will filter comments by status: new, replied, unreplied, dismissed */
  status?: InputMaybe<Array<CommentStatus>>;
};

/** Input for the comments query */
export type CommentsInput = {
  /** The filters to apply to the comments query */
  filters?: InputMaybe<CommentsFiltersInput>;
  /** The Organization id to fetch comments for */
  organizationId: Scalars['OrganizationId']['input'];
  /**
   * The preferred option to sort the comments query results.
   *    default: newestFirst if no provided
   */
  sort?: InputMaybe<Array<CommentsSortInput>>;
};

/** Input for the comments insights query */
export type CommentsInsightsInput = {
  /** The channel id to fetch comments for */
  channelId: Scalars['ChannelId']['input'];
  /** The call to action for the insights - place from where the insights are requested */
  cta?: InputMaybe<Scalars['String']['input']>;
  /** The prompt to fetch comments for */
  prompt: Scalars['String']['input'];
};

/** Response for the comments insights query */
export type CommentsInsightsResponse = {
  __typename?: 'CommentsInsightsResponse';
  /** The insights for the given channel and prompt */
  insights: Scalars['String']['output'];
};

/** Input based on the oEmbed specification plus a required channelId for internal use. */
export type CommentsOEmbedInput = {
  /** ID of the channel making the request. */
  channelId: Scalars['ChannelId']['input'];
  /** The maximum height of the embedded resource (in pixels). */
  maxheight?: InputMaybe<Scalars['Int']['input']>;
  /** The maximum width of the embedded resource (in pixels). */
  maxwidth?: InputMaybe<Scalars['Int']['input']>;
  /** The URL to retrieve the oEmbed representation for. */
  url: Scalars['String']['input'];
};

/** The oEmbed response */
export type CommentsOEmbedResponse = {
  __typename?: 'CommentsOEmbedResponse';
  /** The oEmbed response object as specified by https://oembed.com/. */
  oEmbed: CommentOEmbed;
};

/** Represents a paginated list of comments. */
export type CommentsResults = {
  __typename?: 'CommentsResults';
  /** List of comment edges (each containing a comment and its cursor). */
  edges: Array<CommentsEdge>;
  /** Information about pagination, such as whether more results are available. */
  pageInfo: PaginationPageInfo;
};

/** Achievement level for the comments score */
export type CommentsScoreAchievement = {
  __typename?: 'CommentsScoreAchievement';
  /** The id of the achievement level, defined in the CommentsScoreAchievementLevel enum */
  id: CommentsScoreAchievementLevel;
  /** The human friendly label of the achievement level */
  label: Scalars['String']['output'];
};

/** Achievement levels based on comments engagement score */
export enum CommentsScoreAchievementLevel {
  /** Community Champion - Highest level of engagement */
  CommunityLeader = 'CommunityLeader',
  /** Replying Regularly - Consistent comment engagement */
  Conversationalist = 'Conversationalist',
  /** Conversing Consistently - High level of engagement */
  EngagementPro = 'EngagementPro',
  /** Getting Started - Initial level for new users */
  Newcomer = 'Newcomer',
  /** Finding Your Voice - Beginning to engage with comments */
  Responder = 'Responder'
}

/** Input for the comments score query */
export type CommentsScoreForChannelsInput = {
  /** The list of channel ids to fetch comments for */
  channelIds: Array<Scalars['ChannelId']['input']>;
  /** The Organization id to fetch comments for */
  organizationId: Scalars['OrganizationId']['input'];
};

/**
 * The response for the comments score query for multiple channels, containing individual channel scores
 * and a summary with averaged scores across all channels.
 */
export type CommentsScoreForChannelsResponse = {
  __typename?: 'CommentsScoreForChannelsResponse';
  /** List of individual scores for each requested channel */
  channelsScores: Array<ChannelScore>;
  /** Summary containing averaged scores across all channels */
  summary: CommentsScoreSummary;
};

/** Input for the comments score query */
export type CommentsScoreInput = {
  /** The channel id to fetch comments for */
  channelId: Scalars['ChannelId']['input'];
  /** The Organization id to fetch comments for */
  organizationId: Scalars['OrganizationId']['input'];
};

/** The score metric for comments */
export type CommentsScoreMetric = {
  __typename?: 'CommentsScoreMetric';
  /** The percentage of the value for the given metric */
  percentage: Scalars['Int']['output'];
  /** The score value of the metric */
  value: Scalars['Int']['output'];
};

/**
 * The response for the comments score query containing the detailed score for the current week,
 * the previous week and the achievement level label for the current week.
 */
export type CommentsScoreResponse = {
  __typename?: 'CommentsScoreResponse';
  /** An achievement level based on the current week score. */
  currentAchievementLevel: Scalars['String']['output'];
  /** The score of comments for the current week */
  currentWeekScore: CommentScoreDetailed;
  /** The score of comments for the previous week */
  previousWeekScore: CommentScoreDetailed;
};

/** Summary of scores averaged across all channels */
export type CommentsScoreSummary = {
  __typename?: 'CommentsScoreSummary';
  /** An achievement level based on the current period score. */
  currentAchievementLevel: CommentsScoreAchievement;
  /** The averaged score of comments for the current period across all channels */
  currentPeriodScore: CommentScoreDetailed;
  /** The averaged score of comments for the previous period across all channels */
  previousPeriodScore: CommentScoreDetailed;
};

/** Fields and direction that can be used to sort comments. */
export type CommentsSortInput = {
  /** The direction to sort by. */
  direction: SortDirection;
  /** The field to sort by. */
  field: CommentSortableKey;
};

export type CommonError = {
  __typename?: 'CommonError';
  code: Scalars['String']['output'];
  error: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type CommonMutationError = MutationResponse & {
  __typename?: 'CommonMutationError';
  code: Scalars['String']['output'];
  error: Scalars['String']['output'];
  message: Scalars['String']['output'];
  mutation: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type CommonMutationResponse = MutationResponse & {
  __typename?: 'CommonMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  mutation: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

/** Common properties for all post metadata types */
export type CommonPostMetadata = {
  /** Annotations representing entities in the text */
  annotations: Array<Annotation>;
  /** The channel-specific type of the post, eg, post, story, reel for Instagram */
  type: PostType;
};

export type CommonTrackingProperties = {
  __typename?: 'CommonTrackingProperties';
  atEventBillingCycle: BillingInterval;
  atEventBillingGateway: BillingGateway;
  atEventBillingPlan: Scalars['String']['output'];
  atEventBillingState: BillingState;
  atEventChannelQty: Scalars['Int']['output'];
  atEventIsNewBuffer: Scalars['Boolean']['output'];
};

/** Community-specific display preferences. */
export type CommunityPreferences = {
  __typename?: 'CommunityPreferences';
  /**
   * How the mentions indicator is displayed. Always populated by the server
   * (storage absence is normalized to `counter`).
   */
  mentionsCounter: MentionsCounterDisplay;
};

/** Input for the completeEmailVerification mutation */
export type CompleteEmailVerificationInput = {
  /** JWT for new email to be verified, as a string */
  emailVerificationJWT: Scalars['String']['input'];
};

/** completeEmailVerification response payload */
export type CompleteEmailVerificationPayload = CompleteEmailVerificationSuccess | UnexpectedError;

/** success response for completeEmailVerification mutation */
export type CompleteEmailVerificationSuccess = {
  __typename?: 'CompleteEmailVerificationSuccess';
  /** Action which was triggered to start complete email verification */
  action: Scalars['String']['output'];
};

/** Input for the completeLoginVerification mutation */
export type CompleteLoginVerificationInput = {
  /** JWT to be verified, as a string */
  loginVerificationJWT: Scalars['String']['input'];
};

/** Input for the completeOnboardingStep mutation. */
export type CompleteOnboardingStepInput = {
  /** The organization the onboarding belongs to. */
  organizationId: Scalars['OrganizationId']['input'];
  /** The option slugs the user selected, if any. */
  selectedOptions?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Whether the user is skipping this step. */
  skipped: Scalars['Boolean']['input'];
  /** The slug of the step being completed. */
  stepSlug: Scalars['String']['input'];
  /** Free-form text value, if the step collects text input. */
  textValue?: InputMaybe<Scalars['String']['input']>;
};

/** Payload returned by the completeOnboardingStep mutation. */
export type CompleteOnboardingStepPayload = CompleteOnboardingStepResponse | OnboardingAlreadyCompletedError;

/** Successful result of completing an onboarding step. */
export type CompleteOnboardingStepResponse = {
  __typename?: 'CompleteOnboardingStepResponse';
  /** Previously selected options for the next step, if any. */
  existingSelectedOptions?: Maybe<Array<Scalars['String']['output']>>;
  /** Previously entered text value for the next step, if any. */
  existingTextValue?: Maybe<Scalars['String']['output']>;
  /** The slug identifying which flow definition is active. */
  flowSlug: Scalars['String']['output'];
  /** The next step to display, or null if the flow is completed. */
  nextStep?: Maybe<OnboardingStep>;
  /** Current status of the onboarding flow. */
  status: OnboardingFlowStatus;
  /** The version of the flow definition. */
  version: Scalars['Int']['output'];
};

/** The signup result and the organization connecting the WhatsApp phone. */
export type CompleteWhatsAppConnectionInput = {
  /** An existing WhatsApp Channel. Valid reconnects skip creation limits. */
  channelId?: InputMaybe<Scalars['ChannelId']['input']>;
  /** The authorization code returned by Embedded Signup. */
  code: Scalars['String']['input'];
  /** The organization connecting the phone. */
  organizationId: Scalars['OrganizationId']['input'];
  /** Meta's ID for the business phone. */
  phoneNumberId: Scalars['String']['input'];
  /** The WhatsApp Business Account that owns the phone. */
  wabaId: Scalars['String']['input'];
};

/** The saved Channel or an input, capacity, or ownership error before saving. */
export type CompleteWhatsAppConnectionPayload = ChannelConnectionCannotStealChannelError | CompleteWhatsAppConnectionResponse | InvalidInputError | LimitReachedError | NotFoundError;

/** The saved WhatsApp Channel. Setup can still need repair. */
export type CompleteWhatsAppConnectionResponse = {
  __typename?: 'CompleteWhatsAppConnectionResponse';
  /** The saved Channel with its WhatsApp details and setup state. */
  channel: Channel;
};

/**
 * Organization configuration. `channels` carries the per-connected-channel config
 * the actor can view (including per-`Feature` `authorizationStatus`); `services`
 * carries the service-level capability catalog — the engagement and content config
 * for every supported `service` + `channelType`, independent of which channels are
 * connected (e.g. for composing before a channel is connected).
 */
export type Configuration = {
  __typename?: 'Configuration';
  /** Per-connected-channel config for every channel the actor can view. */
  channels: Array<ChannelConfiguration>;
  /** Service-level capability catalog for every supported service + channel type. */
  services: Array<ServiceConfiguration>;
};

/** The kinds of content a channel can compose. Grows additively. */
export enum ConfigurationContentType {
  Comment = 'comment',
  Post = 'post',
  Reel = 'reel',
  Story = 'story'
}

/** Input for the configuration query. */
export type ConfigurationInput = {
  /** The organization to return configuration for. */
  organizationId: Scalars['OrganizationId']['input'];
};

/**
 * Channel information returned from the service with connection availability.
 * TODO: create a base interface to avoid duplication with type Channel for common fields
 */
export type ConnectableChannel = {
  __typename?: 'ConnectableChannel';
  /** The avatar URL of the channel */
  avatar: Scalars['String']['output'];
  /** The connection availability of the channel */
  connectionAvailability: ConnectionAvailability;
  /** The display name of the channel - nullable (reason?) */
  displayName?: Maybe<Scalars['String']['output']>;
  /**
   * Indicates if the channel is locked - Locked channels can't be used for posting.
   * A channel can be locked when the organization downgrades and reduces the channel quantity of their plan.
   */
  isLocked: Scalars['Boolean']['output'];
  /**
   * Metadata about the location of the business associated with the channel. Only available for Facebook and GPB
   * @deprecated Use metadata instead
   */
  locationData?: Maybe<LocationData>;
  /** The name of the channel - the handle name, username, etc. */
  name: Scalars['String']['output'];
  /** The instance of mastodon of the channel */
  serverUrl?: Maybe<Scalars['String']['output']>;
  /** Represents the external ID of the channel on social network API */
  serviceId: Scalars['String']['output'];
  /** The type of the channel - Page, Profile, Business, Group, Account, etc. */
  type: ChannelType;
};

/** A service that can be connected to an Organization */
export type ConnectableService = {
  __typename?: 'ConnectableService';
  /** The target audience whose content that this service is intended for */
  audience?: Maybe<Scalars['String']['output']>;
  /**
   * Whether the service can be connected by the Organization.
   * @deprecated deprecated in favor of status
   */
  canConnect: Scalars['Boolean']['output'];
  /** Categories that define how the service should be grouped, this is used for filtering between grouped services */
  categories: Array<ChannelCategory>;
  /** The types of content that can be shared to this service */
  contentTypes: Array<ContentType>;
  /** Descriptive points about the service and its offerings (e.g what the service is used for) */
  description: Array<Scalars['String']['output']>;
  /**
   * Whether the service is new to the platform.
   * @deprecated deprecated in favor of serviceStatus
   */
  isNew: Scalars['Boolean']['output'];
  /** Support links related to connecting this service */
  links?: Maybe<Array<HelpCenterLink>>;
  /**
   * The products this service belongs to.
   * @deprecated all services belong to a single product
   */
  products: Array<Product>;
  /** The corresponding service that is being connected */
  service: Service;
  /** A remote URL representing the service logo */
  serviceIconUrl: Scalars['String']['output'];
  /** Global status for the service, defining it's availability within the Buffer product */
  serviceStatus: ServiceStatus;
  /** Other services that are similar to this one (such as similar content types being shared) */
  similarNetworks?: Maybe<Array<Service>>;
  /** Social proof (such as statistic) that demonstrate the success of this service */
  socialProof?: Maybe<Scalars['String']['output']>;
  /** Organization-level status for the service, defining it's availability for the current Organization */
  status: ChannelConnectionStatus;
  /** The subtitle, which will generally consist of the channel types or service offerings */
  subtitle: Scalars['String']['output'];
  /** An optional tag associated with the service. */
  tag?: Maybe<Scalars['String']['output']>;
  /** The title represents the name of the service being connected */
  title: Scalars['String']['output'];
  /** The type of channels that can be connected via this service */
  types: Array<ChannelType>;
};

/** The error response for connectable services */
export type ConnectableServicesError = {
  __typename?: 'ConnectableServicesError';
  /** The underlying cause of the error. */
  cause: Scalars['String']['output'];
  /** A user-friendly error message to display. */
  userFriendlyMessage: Scalars['String']['output'];
};

/**
 * The input provided when requesting connectable services.
 * Note: This will be made non-optional soon, please migrate to provide it
 */
export type ConnectableServicesInput = {
  /**
   * The client the services are being connected from.
   * Deprecated: the resolver now derives the client from the x-buffer-client-name
   * HTTP header instead of this field. Any value sent here is silently ignored.
   * This field is kept for backwards compatibility only and will be removed in a future release.
   * @deprecated Client is now derived from the x-buffer-client-name HTTP header. This field is ignored.
   */
  client?: InputMaybe<ClientPlatform>;
  /**
   * The organization ID that is to be connecting the services
   * Note: This will be made non-optional soon, please migrate to provide it
   */
  organization?: InputMaybe<Scalars['ID']['input']>;
};

/** The payload returned when requesting connectable services */
export type ConnectableServicesPayload = ConnectableServicesError | ConnectableServicesResponse;

/** The success response for connectable services */
export type ConnectableServicesResponse = {
  __typename?: 'ConnectableServicesResponse';
  /**
   * A list of services for connection.
   * Not all of these will be available for connection - use the ConnectableService to determine which services
   * can be connected by the Organization.
   */
  services: Array<ConnectableService>;
};

/** Connected App */
export type ConnectedApp = {
  __typename?: 'ConnectedApp';
  /** The category of the connected app, when known. */
  category?: Maybe<ConnectedAppCategory>;
  /** The id of the connectedApp. */
  clientId: Scalars['ID']['output'];
  /** The date and time when the connected app was created. */
  createdAt: Scalars['DateTime']['output'];
  /** A brief description of the connected app. */
  description: Scalars['String']['output'];
  /** The name of the connected app. */
  name: Scalars['String']['output'];
  /**
   * The access scopes granted to this connection for Buffer's public API
   * resources. Empty when the connection holds none.
   */
  scopes: Array<Scalars['String']['output']>;
  /** The id of the user that has granted access to the app. */
  userId: Scalars['ID']['output'];
  /** The website URL of the connected app. */
  website: Scalars['String']['output'];
};

/** The category of a connected app. */
export enum ConnectedAppCategory {
  /** An MCP client connection. */
  Mcp = 'mcp'
}

/**
 * Represents whether a channel can be connected or not.
 * - Available: can be connected (or stolen from the organization that owns it now).
 * - Unavailable: can not be connected because it's owned by an organization that we can't steal it from.
 * - Already connected: the current organization owns this channel already.
 */
export enum ConnectionAvailability {
  AlreadyConnected = 'alreadyConnected',
  Available = 'available',
  Unavailable = 'unavailable'
}

/** The connection status of a service */
export enum ConnectionStatus {
  /** The service is available for connection and should be shown in the UI */
  Available = 'available',
  /** The service cannot be connected. It should still be shown in the UI, using the message from ChannelConnectionStatus to communicate why it is unavailable when the service is clicked. */
  Disabled = 'disabled',
  /**
   * The service is not available for connection and should not be shown to the user.
   * This would be due to the user not being on the split, or not having the entitlement to that service.
   */
  Unavailable = 'unavailable'
}

/**
 * One piece of an organization's content: a content item draft with no channel,
 * or a post on a channel in any status. The two have different shapes, so both
 * types stay in one ordered list.
 *
 * A content item that became posts never appears here. Its posts appear one by
 * one, so the group would count the same content twice.
 */
export type Content = ContentItem | Post;

/**
 * Config for one or more content types that share the same properties
 * and rules. Grouping several `configurationContentTypes` in one entry avoids
 * duplicating an identical config (e.g. story + reel).
 */
export type ContentConfiguration = {
  __typename?: 'ContentConfiguration';
  /** The content type(s) this config applies to (grouped when rules are identical). */
  configurationContentTypes: Array<ConfigurationContentType>;
  /** Validation rules that decide whether a draft is valid. */
  rules: Array<ValidationRule>;
  /** The properties these content types support; absence means unsupported. */
  supportedProperties: Array<ContentProperty>;
};

/** One row in a content page. */
export type ContentEdge = {
  __typename?: 'ContentEdge';
  /** The pagination cursor for this row. */
  cursor: Scalars['String']['output'];
  /**
   * `targetDate` for a content item, `dueAt` for a post. Null when neither is
   * set. Read it to group by day without testing the node's type.
   */
  date?: Maybe<Scalars['DateTime']['output']>;
  /** The content item or the post. */
  node: Content;
};

/** Error returned when article content could not be extracted from a URL. */
export type ContentExtractionFailedError = {
  __typename?: 'ContentExtractionFailedError';
  /** Human-readable error message with guidance on what to do instead. */
  message: Scalars['String']['output'];
};

/** The type of content feed */
export enum ContentFeedType {
  /** News search */
  NewsSearch = 'NewsSearch',
  /** RSS or Atom feed */
  RssAtom = 'RSSAtom'
}

/** Input Types */
export type ContentGenerationInput = {
  cta?: InputMaybe<Scalars['String']['input']>;
  previousGeneration?: InputMaybe<Scalars['String']['input']>;
  prompt: Scalars['String']['input'];
  service?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
  tone?: InputMaybe<Scalars['String']['input']>;
  variations?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * A piece of content in Buffer. It starts as a channel-less draft and can later
 * become a set of channel-specific posts, or it can be created with its posts
 * directly.
 *
 * This API is an early preview and can change without a deprecation period.
 */
export type ContentItem = {
  __typename?: 'ContentItem';
  /** Account that owns this content item. */
  accountId: Scalars['AccountId']['output'];
  /**
   * Actions the calling actor can take on this content item. A client reads this
   * set instead of deriving the authorization rules itself.
   */
  allowedActions: Array<ContentItemAction>;
  /**
   * The person who created this content item. Null when that person's account
   * no longer exists.
   */
  author?: Maybe<Author>;
  /**
   * The current content of this item: either a channel-less draft or the
   * channel-specific posts created from it.
   */
  body: ContentItemBody;
  /** When this content item was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier for this content item. */
  id: Scalars['ContentItemId']['output'];
  /**
   * The content item's own Notes thread. Null, with no error, when Notes are
   * unavailable to the actor. Fetch it in its own query: an unexpected failure
   * returns an error.
   */
  notesSummary?: Maybe<CollaborationNoteThreadSummary>;
  /** Organization that owns this content item. */
  organizationId: Scalars['OrganizationId']['output'];
  /**
   * Tags applied to this content item, in the order they were set. A tag
   * applies to the item as a whole, so it survives the move from a
   * channel-less draft to channel-specific posts.
   */
  tags: Array<Tag>;
  /**
   * Optional date indicating when this piece of content should go out.
   * This is a planning aid only and does not schedule any posts.
   */
  targetDate?: Maybe<Scalars['DateTime']['output']>;
  /** Optional title describing what this piece of content is about. */
  title?: Maybe<Scalars['String']['output']>;
  /**
   * Channel-specific post variants, in the same order as the request.
   * @deprecated Use body instead.
   */
  variants: Array<Post>;
};

/**
 * Actions the calling actor can take on a `ContentItem`. The server computes
 * this set from the same rules the content item mutations enforce. A client
 * reads it to drive UI affordances instead of deriving the rules itself.
 *
 * The set carries an action only when a client can offer it on this one item.
 * An action whose answer is the same for every item in a response drives no
 * affordance, so it stays out. Read access is one of those: the API returns
 * only a content item the actor may read.
 */
export enum ContentItemAction {
  /**
   * The actor can delete this content item. An item that holds channel-specific
   * posts gets a second check. The mutation checks each post, so a delete can
   * still fail.
   */
  DeleteContentItem = 'deleteContentItem',
  /**
   * The actor can change this content item's title and target date. The actor
   * can also change the tags and the draft text while the item holds a
   * channel-less draft.
   */
  UpdateContentItem = 'updateContentItem'
}

/**
 * A content item's content: its channel-less draft while it is a draft, or its
 * channel-specific posts once it holds posts. The body shows one or the other,
 * never both, although a content item keeps its draft after it becomes posts.
 */
export type ContentItemBody = DraftContent | PostContent;

/** An edge in a content item connection. */
export type ContentItemEdge = {
  __typename?: 'ContentItemEdge';
  /** A cursor for pagination. */
  cursor: Scalars['String']['output'];
  /** The content item node at the end of the edge. */
  node: ContentItem;
};

/** Input for fetching a single content item by id. */
export type ContentItemInput = {
  /** The unique identifier of the content item to fetch. */
  id: Scalars['ContentItemId']['input'];
};

/** Field to sort content items by. */
export enum ContentItemSortableKey {
  /** Sort by the date the content item was created. */
  CreatedAt = 'createdAt',
  /**
   * Sort by the content item's target date, the date it is planned for. Content
   * items with no target date sort first in ascending order.
   */
  TargetDate = 'targetDate'
}

/**
 * updateContentItemDraft and promoteContentItemDraftToPosts need a
 * channel-less draft. They report this error when the item already holds
 * channel-specific posts. Another request can put the item in that state while
 * this one runs.
 */
export type ContentItemStateError = MutationError & {
  __typename?: 'ContentItemStateError';
  /** Error message. */
  message: Scalars['String']['output'];
};

/** The status of a content item's body. */
export enum ContentItemStatus {
  /** The content item holds a channel-less draft. */
  DraftContent = 'draftContent',
  /** The content item holds channel-specific posts. */
  PostContent = 'postContent'
}

/** A paginated connection of content items. */
export type ContentItemsConnection = {
  __typename?: 'ContentItemsConnection';
  /** The list of content item edges. */
  edges: Array<ContentItemEdge>;
  /** Pagination information for the connection. */
  pageInfo: PaginationPageInfo;
  /** The total number of content items matching the request. */
  totalCount: Scalars['Int']['output'];
};

/** Filters for listing content items. Omitted fields do not filter. */
export type ContentItemsFilter = {
  /**
   * Only return content items with this content status. When omitted, content
   * items in every status are returned.
   */
  contentStatus?: InputMaybe<ContentItemStatus>;
  /**
   * Only return content items carrying one of these tags, or, with `isEmpty`,
   * content items with no tags at all. Matches the tags applied to the content
   * item itself, not tags applied later to an individual post.
   */
  tags?: InputMaybe<TagComparator>;
  /** Only return content items matching this target date filter. */
  targetDate?: InputMaybe<ContentItemsTargetDateFilter>;
};

/** Input for listing an organization's content items. */
export type ContentItemsInput = {
  /**
   * Filters to apply. When omitted, all of the organization's content items
   * are returned.
   */
  filter?: InputMaybe<ContentItemsFilter>;
  /**
   * Organization to list content items for. The caller must be a member of
   * this organization.
   */
  organizationId: Scalars['OrganizationId']['input'];
  /**
   * Sorting to apply, each entry breaking ties in the one before it. Defaults to
   * newest first. A pagination cursor is only valid for the sort that produced
   * it, so reset `after` to null whenever the sort changes.
   */
  sort?: InputMaybe<Array<ContentItemsSortInput>>;
};

/** One sorting criterion for the content items query. List several to break ties. */
export type ContentItemsSortInput = {
  /** The direction to sort by. */
  direction: SortDirection;
  /** The field to sort by. */
  field: ContentItemSortableKey;
};

/**
 * Filter for a content item's target date. Provide exactly one field
 * (enforced by @oneOf).
 */
export type ContentItemsTargetDateFilter =
  /**
   * Only return content items by whether a target date is set: `present`
   * returns only dated items, `absent` only undated ones.
   */
  { presence: DateTimePresence; range?: never; }
  |  /**
   * Only return content items whose target date falls within this range.
   * A range with no bounds returns every content item that has a target date.
   */
  { presence?: never; range: DateTimeComparator; };

/**
 * A property a content type can carry. Support is expressed by inclusion in
 * `supportedProperties` — there are no exclusion lists. Grows additively.
 */
export enum ContentProperty {
  Board = 'board',
  Document = 'document',
  FirstComment = 'firstComment',
  Gif = 'gif',
  Image = 'image',
  ImageAltText = 'imageAltText',
  LinkAttachment = 'linkAttachment',
  RetweetAttachment = 'retweetAttachment',
  Text = 'text',
  Thread = 'thread',
  Video = 'video'
}

/** A field to sort content by. */
export enum ContentSortableKey {
  /** The date someone created the content. */
  CreatedAt = 'createdAt',
  /** `targetDate` on a content item, `dueAt` on a post. */
  Date = 'date'
}

export enum ContentType {
  Analytics = 'analytics',
  AudienceInsights = 'audience_insights',
  Engagement = 'engagement',
  Image = 'image',
  LinkTracking = 'link_tracking',
  PageAnalytics = 'page_analytics',
  Pdf = 'pdf',
  PostAnalytics = 'post_analytics',
  Reels = 'reels',
  Shorts = 'shorts',
  Stories = 'stories',
  Text = 'text',
  Threads = 'threads',
  Video = 'video'
}

/** A filter on the channel. The two fields combine. */
export type ContentsChannelFilter = {
  /**
   * Return posts on these channels. A content item has no channel, so this drops
   * content items. `includeChannellessContent` adds them back. Send an empty
   * list with that flag to get channel-less content alone.
   */
  channelIds: Array<Scalars['ChannelId']['input']>;
  /**
   * Also return content items, which carry no channel. Omitting this whole
   * filter already returns them, so the flag has no effect there.
   */
  includeChannellessContent?: Scalars['Boolean']['input'];
};

/** One page of an organization's content. */
export type ContentsConnection = {
  __typename?: 'ContentsConnection';
  /** The rows in this page. */
  edges: Array<ContentEdge>;
  /** The cursors for the next page. */
  pageInfo: PaginationPageInfo;
  /** How many items match the filter, up to 2000. Read 2000 as "2000 or more". */
  totalCount: Scalars['Int']['output'];
};

/** A filter on the content date. Send exactly one field. */
export type ContentsDateFilter =
  /** Match content by whether it has a date at all. */
  { presence: DateTimePresence; range?: never; }
  |  /**
   * Match content with a date inside this range. A range with no bounds matches
   * every dated item.
   */
  { presence?: never; range: DateTimeComparator; };

/** Filters for a content list. An omitted field filters nothing. */
export type ContentsFilter = {
  /**
   * Match this channel filter. Omitted, every channel's posts come back,
   * alongside channel-less content items.
   */
  channel?: InputMaybe<ContentsChannelFilter>;
  /** Match this date filter. */
  date?: InputMaybe<ContentsDateFilter>;
  /**
   * Return posts in these statuses. Omitted, every status comes back. A content
   * item holds no posts, so content items come back only when you omit this
   * field or name `draft`. An empty list matches no post, so omit the field
   * instead.
   */
  status?: InputMaybe<Array<PostStatus>>;
  /** Match one of these tags, or, with `isEmpty`, match content with no tags. */
  tags?: InputMaybe<TagComparator>;
};

/** Input for a content list. */
export type ContentsInput = {
  /**
   * Filters to apply. Omitted, the query returns all of the organization's
   * content.
   */
  filter?: InputMaybe<ContentsFilter>;
  /** The organization to list content for. The caller must belong to it. */
  organizationId: Scalars['OrganizationId']['input'];
  /**
   * Sort criteria, each one breaking ties in the one before it. Defaults to
   * the latest `date` first. A cursor belongs to the sort that made it, so reset
   * `after` when the sort changes.
   */
  sort?: InputMaybe<Array<ContentsSortInput>>;
};

/** One sort criterion for the `contents` query. */
export type ContentsSortInput = {
  /** The sort direction. */
  direction: SortDirection;
  /** The field to sort by. */
  field: ContentSortableKey;
};

/**
 * A group of engagement items that belong together: one DM chat, one comment
 * thread, one mention thread. The inbox row only — a conversation never carries
 * its items. Use `__typename` or inline fragments to branch on the concrete type.
 */
export type Conversation = {
  /** Our connected channel the conversation happens on. */
  channelId: Scalars['ChannelId']['output'];
  /** Unique identifier of the conversation. Not an EngagementId. */
  id: Scalars['ConversationId']['output'];
  /** Muted: no notifications are sent for this conversation. */
  isMuted: Scalars['Boolean']['output'];
  /** Marked as spam. Set by a teammate by hand today; nothing derives it. */
  isSpam: Scalars['Boolean']['output'];
  /** Starred by a teammate. */
  isStarred: Scalars['Boolean']['output'];
  /** Newest item in the conversation, inbound or outbound. */
  lastActivityAt: Scalars['DateTime']['output'];
  /** Newest item not authored by us. Null until the counterpart writes. */
  lastInboundAt?: Maybe<Scalars['DateTime']['output']>;
  /** Organization the conversation belongs to. */
  organizationId: Scalars['OrganizationId']['output'];
  /** Everyone who has authored an item, plus the owning channel. */
  participants: Array<ConversationParticipant>;
  /** One-line summary for the card. Null while there is no renderable item. */
  preview?: Maybe<ConversationPreview>;
  /** Organization-wide read state. */
  readState: ConversationReadState;
  /**
   * The conversation key, unique per channel:
   *
   *   DM, 1:1   urn:buffer:ext:instagram:user:<igsid>
   *   DM, group urn:buffer:ext:instagram:thread:<threadId>
   */
  rootUrn: Scalars['URN']['output'];
  /** Network of the channel. */
  serviceType: Service;
  /** Workflow state of the conversation. */
  status: ConversationStatus;
};

/**
 * The caller is signed in but may not reply on the conversation's channel. Ask
 * an admin of the organization for access.
 */
export type ConversationChannelPermissionError = MutationError & {
  __typename?: 'ConversationChannelPermissionError';
  /** Channel the caller may not reply on. */
  channelId: Scalars['ChannelId']['output'];
  /** Error message, safe to show the user. */
  message: Scalars['String']['output'];
};

/**
 * What a conversation item's content is. A reader renders an unrecognised value
 * as `unsupported`, which is what lets the enum grow without a breaking change.
 */
export enum ConversationContentType {
  /** An audio file or voice message. */
  Audio = 'audio',
  /** A multi-image or mixed-media carousel. */
  Carousel = 'carousel',
  /** A file attachment. */
  File = 'file',
  /** An animated GIF. */
  Gif = 'gif',
  /** A single image. */
  Image = 'image',
  /** A shared post or link. */
  Share = 'share',
  /** A sticker. */
  Sticker = 'sticker',
  /** A story reply or story mention. */
  Story = 'story',
  /** Text only. */
  Text = 'text',
  /** Content the network sent that we cannot render. */
  Unsupported = 'unsupported',
  /** A single video. */
  Video = 'video'
}

/** A conversation count for one channel. The query says what is counted. */
export type ConversationCountByChannel = {
  __typename?: 'ConversationCountByChannel';
  /** The channel these counts belong to. */
  channelId: Scalars['ChannelId']['output'];
  /**
   * Conversations in this channel that satisfy the query, capped at the applied
   * limit.
   */
  count: Scalars['Int']['output'];
  /**
   * The per-channel cap the BE finally applied. When `count` reaches this value
   * the result is truncated and the client should treat the count as "at least".
   */
  limit: Scalars['Int']['output'];
};

/** One conversation in the inbox, with its pagination cursor. */
export type ConversationEdge = {
  __typename?: 'ConversationEdge';
  /** Opaque cursor. Pass it as `after` to fetch the next page. */
  cursor: Scalars['String']['output'];
  /** The conversation. Per-kind fields need an inline fragment. */
  node: Conversation;
};

/** Optional refinements for the conversations inbox. Purely narrowing. */
export type ConversationFilters = {
  /** Muting is presentation only, so the working inbox shows both. */
  isMuted?: InputMaybe<FlagFilter>;
  /** Spam is hidden from the working inbox. */
  isSpam?: InputMaybe<FlagFilter>;
  /** Starring is not a hiding rule, so the working inbox shows both. */
  isStarred?: InputMaybe<FlagFilter>;
  /** Range over `lastActivityAt`, the key the inbox sorts on. */
  lastActivityAt?: InputMaybe<DateTimeRange>;
  /** Status of the conversation, not of its items. Omitted returns every status. */
  status?: InputMaybe<ConversationStatus>;
};

/** One message in a DM chat, inbound or outbound. */
export type ConversationMessage = {
  __typename?: 'ConversationMessage';
  /** Media and other attachments, in the order sent. Empty for text. */
  assets: Array<ConversationMessageAsset>;
  /** Who wrote the message. */
  author: EngagementAuthor;
  /** What the message's content is. */
  contentType: ConversationContentType;
  /** Conversation the message belongs to. */
  conversationId: Scalars['ConversationId']['output'];
  /** Unique identifier of the message. */
  id: Scalars['EngagementId']['output'];
  /** The author edited it on the network. */
  isEdited: Scalars['Boolean']['output'];
  /** `true` means we sent it. */
  isOwnMessage: Scalars['Boolean']['output'];
  /** The author deleted it on the network. Render a placeholder. */
  isServiceDeleted: Scalars['Boolean']['output'];
  /**
   * When the message was published on the network. Null for our own messages the
   * network hasn't confirmed (`send.state` is `draft`, `processing` or `error`);
   * `send.sentAt` says when we sent it.
   */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The message this one replies to. Null when it is not a reply. */
  quote?: Maybe<ConversationMessageQuote>;
  /** Reactions on the message, oldest first. */
  reactions: Array<ConversationMessageReaction>;
  /** How we sent it. Null for inbound messages and for ours sent outside Buffer. */
  send?: Maybe<ConversationMessageSend>;
  /** Null for non-text content; render from `contentType` instead. */
  text?: Maybe<Scalars['String']['output']>;
};

/** One attachment of a message. */
export type ConversationMessageAsset = {
  __typename?: 'ConversationMessageAsset';
  /** Network id of the attachment, when the network gives one. */
  assetId?: Maybe<Scalars['String']['output']>;
  /** When the network stops serving `url`. Null when it does not expire. */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** Height in pixels, for visual media. */
  height?: Maybe<Scalars['Int']['output']>;
  /** What the attachment is. */
  type: ConversationMessageAssetType;
  /** Where to load the attachment from. Null once the network has dropped it. */
  url?: Maybe<Scalars['String']['output']>;
  /** Width in pixels, for visual media. */
  width?: Maybe<Scalars['Int']['output']>;
};

/** What a message attachment is. */
export enum ConversationMessageAssetType {
  /** An audio file or voice message. */
  Audio = 'audio',
  /** A file attachment. */
  File = 'file',
  /** A single image. */
  Image = 'image',
  /** A shared reel. */
  Reel = 'reel',
  /** A shared post or link. */
  Share = 'share',
  /** A sticker. */
  Sticker = 'sticker',
  /** A story reply or story mention. */
  Story = 'story',
  /** A single video. */
  Video = 'video'
}

/** One message in a conversation, with its pagination cursor. */
export type ConversationMessageEdge = {
  __typename?: 'ConversationMessageEdge';
  /** Opaque cursor. Pass it as `after` to fetch the next, older page. */
  cursor: Scalars['String']['output'];
  /** The message. */
  node: ConversationMessage;
};

/**
 * The message a reply quotes, copied when the reply was stored. Fields are null
 * when we don't hold the quoted message, e.g. it predates the backfill: render a
 * generic "replied to a message" rather than a deleted one.
 */
export type ConversationMessageQuote = {
  __typename?: 'ConversationMessageQuote';
  /** Who wrote the quoted message. */
  author?: Maybe<EngagementAuthor>;
  /** What the quoted message's content is. */
  contentType?: Maybe<ConversationContentType>;
  /** Id of the quoted message, when we hold it. */
  messageId?: Maybe<Scalars['EngagementId']['output']>;
  /** Null for non-text content; render from `contentType` instead. */
  text?: Maybe<Scalars['String']['output']>;
};

/** One reaction on a message. */
export type ConversationMessageReaction = {
  __typename?: 'ConversationMessageReaction';
  /** When the reaction was added. */
  createdAt: Scalars['DateTime']['output'];
  /** The reaction, as an emoji. */
  emoji: Scalars['String']['output'];
};

/** How a message we sent from Buffer went out. */
export type ConversationMessageSend = {
  __typename?: 'ConversationMessageSend';
  /** Buffer account that sent it. */
  accountId: Scalars['AccountId']['output'];
  /**
   * Why the network rejected it. Set only when `state` is `error`. One of
   * `reauthRequired`, `accountActionRequired`, `recipientUnavailable`,
   * `windowClosed`, `rateLimited` or `unknown`; new values can be added, so treat
   * anything else as `unknown`.
   */
  failureCode?: Maybe<Scalars['String']['output']>;
  /** When we handed it to the network. */
  sentAt: Scalars['DateTime']['output'];
  /** Where it is on its way to the network. */
  state: ConversationMessageSendState;
};

/** Where a message we sent from Buffer is on its way to the network. */
export enum ConversationMessageSendState {
  /** Stored but not handed to the network yet. */
  Draft = 'draft',
  /** The network rejected it. `failureCode` says why. */
  Error = 'error',
  /** Handed to the network, not confirmed yet. */
  Processing = 'processing',
  /** The network accepted it. */
  Published = 'published'
}

/**
 * Paginated messages of one conversation, newest first: by `publishedAt`, or by
 * `send.sentAt` for our own messages the network hasn't confirmed.
 */
export type ConversationMessagesConnection = {
  __typename?: 'ConversationMessagesConnection';
  /** One edge per message, newest first. */
  edges: Array<ConversationMessageEdge>;
  /** Pagination info for the next, older page. */
  pageInfo: PaginationPageInfo;
};

/** Input for the conversationMessages query. */
export type ConversationMessagesInput = {
  /** Conversation whose messages to read. */
  conversationId: Scalars['ConversationId']['input'];
};

/** Success type shared by every conversation mutation's payload union. */
export type ConversationMutationSuccess = {
  __typename?: 'ConversationMutationSuccess';
  /** The conversation after the write. */
  conversation: Conversation;
};

/** Someone who takes part in a conversation, or the owning channel. */
export type ConversationParticipant = {
  __typename?: 'ConversationParticipant';
  /** Display identity of the participant. */
  author: EngagementAuthor;
  /** `false` when the participant left a group conversation. */
  isActive: Scalars['Boolean']['output'];
  /** `true` for our own channel. Exactly one participant is the owner. */
  isOwner: Scalars['Boolean']['output'];
  /** Platform-scoped id (PSID / IGSID / handle). */
  serviceId: Scalars['String']['output'];
};

/** Newest item in the conversation, whoever sent it, flattened for the card. */
export type ConversationPreview = {
  __typename?: 'ConversationPreview';
  /** Who wrote the item. */
  author: EngagementAuthor;
  /** What the item's content is. */
  contentType: ConversationContentType;
  /** `true` means we sent it, which is what lets a row read "You: …". */
  isOwnMessage: Scalars['Boolean']['output'];
  /** Id of the item this was built from. */
  itemId: Scalars['EngagementId']['output'];
  /**
   * When the item was published on the network. Null for our own items the
   * network hasn't confirmed (`send.state` is `draft`, `processing` or `error`).
   */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * How we sent the item from Buffer. Null for inbound items and for ours sent
   * outside Buffer.
   */
  send?: Maybe<ConversationPreviewSend>;
  /** Null for non-text content; render from `contentType` instead. */
  text?: Maybe<Scalars['String']['output']>;
};

/** How the item a preview was built from went out from Buffer. */
export type ConversationPreviewSend = {
  __typename?: 'ConversationPreviewSend';
  /** Where it is on its way to the network. */
  state: ConversationMessageSendState;
};

/**
 * Organization-wide read state. Read state does not change the status: a
 * conversation with unread messages is still `unreplied`, `replied` or
 * `resolved`.
 */
export type ConversationReadState = {
  __typename?: 'ConversationReadState';
  /** When the counterpart read our items. Null when the network does not report it. */
  counterpartReadAt?: Maybe<Scalars['DateTime']['output']>;
  /** Moved by any teammate action that implies reading: open, reply, resolve. */
  lastReadAt?: Maybe<Scalars['DateTime']['output']>;
  /** Display only. Eventually consistent and can understate. */
  unreadCount: Scalars['Int']['output'];
};

/**
 * The network rejected the reply. The reply is stored with `send.state: error`;
 * `conversationMessage.send.failureCode` says why.
 */
export type ConversationReplySendFailedError = MutationError & {
  __typename?: 'ConversationReplySendFailedError';
  /** The conversation after the failed reply. */
  conversation: Conversation;
  /** The stored reply, in `error` state. */
  conversationMessage: ConversationMessage;
  /** Error message, safe to show the user. */
  message: Scalars['String']['output'];
};

/**
 * The conversation's reply window closed before we sent (see
 * `replyWindow.expiresAt`). Nothing is stored.
 */
export type ConversationReplyWindowClosedError = MutationError & {
  __typename?: 'ConversationReplyWindowClosedError';
  /** When the window closed. */
  expiredAt: Scalars['DateTime']['output'];
  /** Error message, safe to show the user. */
  message: Scalars['String']['output'];
};

/**
 * One sort key for the conversations inbox. Set exactly one field: each key takes
 * the kind of order that means something for it.
 */
export type ConversationSortInput =
  /** Newest item in the conversation, inbound or outbound. */
  { lastActivityAt: SortDirection; status?: never; }
  |  /** Workflow state of the conversation. */
  { lastActivityAt?: never; status: ConversationStatusOrder; };

/**
 * Workflow state of a conversation. Exactly one value at a time. Independent of
 * the statuses of the items inside it.
 */
export enum ConversationStatus {
  /** Seen and answered, still live. */
  Replied = 'replied',
  /** Manually resolved by a teammate. */
  Resolved = 'resolved',
  /** The newest inbound item has no answer from us yet, read or not. */
  Unreplied = 'unreplied'
}

/**
 * Order of the status key in the conversations inbox sort. Named for what comes
 * first rather than asc/desc, because a status has no natural direction.
 */
export enum ConversationStatusOrder {
  /** unreplied, replied, resolved. */
  UnrepliedFirst = 'unrepliedFirst'
}

/** Paginated conversations inbox. */
export type ConversationsConnection = {
  __typename?: 'ConversationsConnection';
  /** One edge per conversation — per thread, never per message. */
  edges: Array<ConversationEdge>;
  /** Pagination info for the next page. */
  pageInfo: PaginationPageInfo;
};

/** Input for the conversations query. */
export type ConversationsInput = {
  /**
   * Channels to read. Omitted returns every channel the actor may read. The actor
   * needs permission to view messages on every listed channel, or the whole call
   * fails.
   */
  channelIds?: InputMaybe<Array<Scalars['ChannelId']['input']>>;
  /** Optional filters to narrow down results. */
  filters?: InputMaybe<ConversationFilters>;
  /** Organization whose inbox to query. */
  organizationId: Scalars['OrganizationId']['input'];
  /**
   * Optional sort order. List several keys to break ties, first key first.
   * Defaults to the `unrepliedFirst` status order, then `{ lastActivityAt: desc }`,
   * when omitted: unreplied first, then newest activity first.
   */
  sort?: InputMaybe<Array<ConversationSortInput>>;
};

/** Input for converting custom channels, like Bluesky or FB Group */
export type ConvertCustomChannelInput = {
  /** Avatar of this channel */
  avatar: Scalars['String']['input'];
  /** ChannelId for the channel being converted */
  channelId: Scalars['ID']['input'];
  /** Display name for this channel */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Name for this channel */
  name: Scalars['String']['input'];
  /** Organization this channel will be connected to */
  organizationId: Scalars['ID']['input'];
  /** Service to convert to */
  service: ChannelThirdPartyService;
  /** ServiceId for the channelConnection that we convert to */
  serviceId: Scalars['String']['input'];
  /** Timezone used for this channel */
  timezone?: InputMaybe<Scalars['String']['input']>;
  /** Channel type to convert to */
  type: ChannelType;
};

/** Payload for convertCustomChannel mutation */
export type ConvertCustomChannelPayload = ConvertCustomChannelResponse | CustomChannelError;

/** The response for custom channel conversion */
export type ConvertCustomChannelResponse = {
  __typename?: 'ConvertCustomChannelResponse';
  /** Converted channel */
  channel: Channel;
};

/** Common error type to be used whenever no custom Error type needs to be created */
export type CoreWebAppCommonError = CoreWebAppError & {
  __typename?: 'CoreWebAppCommonError';
  /** A code to describe the status eg 200 for success, 404 for not found */
  code: Scalars['String']['output'];
  /** A raw error message to describe the error to the client. Should not be displayed to customers. */
  error: Scalars['String']['output'];
  /** A user friendly message to describe the status to the client */
  message: Scalars['String']['output'];
  /** A boolean representing success of the entire mutation */
  success: Scalars['Boolean']['output'];
};

/** Base error interface used to implement custom error types */
export type CoreWebAppError = {
  /** A code to describe the status eg 200 for success, 404 for not found */
  code: Scalars['String']['output'];
  /** A raw error message to describe the error to the client. Should not be displayed to customers. */
  error: Scalars['String']['output'];
  /** A user friendly message to describe the status to the client */
  message: Scalars['String']['output'];
  /** A boolean representing success of the entire mutation */
  success: Scalars['Boolean']['output'];
};

/** Base mutation response interface used to implement custom mutation response types */
export type CoreWebAppMutationResponse = {
  /** A code to describe the status eg 200 for success, 404 for not found */
  code: Scalars['String']['output'];
  /** A user friendly message to describe the status to the client */
  message: Scalars['String']['output'];
  /** A boolean representing success of the entire mutation */
  success: Scalars['Boolean']['output'];
};

/**
 * Bounds how many of a property are allowed. `min` null/absent = no lower bound
 * (optional); `min: 1` = required. `max` null = unlimited. At least one of `min`
 * or `max` is always present — a rule that bounds neither is never emitted.
 */
export type CountRule = ValidationRule & {
  __typename?: 'CountRule';
  /** Maximum allowed count. Null = unlimited. */
  max?: Maybe<Scalars['Int']['output']>;
  /** Minimum allowed count. Null = no lower bound (optional). */
  min?: Maybe<Scalars['Int']['output']>;
  /** The content property this rule constrains. */
  property: ContentProperty;
};

/** Bluesky-specific metadata for custom channel creation */
export type CreateBlueskyMetadata = {
  /** Bluesky account App Password */
  appPassword: Scalars['String']['input'];
  /** Should follow Buffer official profile on Bluesky */
  followBuffer: Scalars['Boolean']['input'];
  /** Bluesky account Handle (username) */
  handle: Scalars['String']['input'];
  /**
   * The server to be used for connection
   * @deprecated extracted from passed handle
   */
  server?: InputMaybe<Scalars['String']['input']>;
};

/** Input to pass when creating a Changelog Entry. */
export type CreateChangelogEntryInput = {
  /** The audience of the changelog entry. */
  audience: ChangelogEntryAudience;
  /** The content of the changelog entry. */
  content: Scalars['String']['input'];
  /** The cover image URL of the changelog entry. */
  coverImageUrl?: InputMaybe<Scalars['URL']['input']>;
  /** Optional call-to-action buttons for a modal-display entry (max 2). */
  ctas?: InputMaybe<Array<ChangelogEntryCtaInput>>;
  /** Optional display type. Defaults to `popover` when omitted. */
  displayType?: InputMaybe<ChangelogEntryDisplayType>;
  /** Optional auto-retire date (applies to popover or modal entries). Omit for no expiry. */
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * Optional publish date. Defaults to the current time when omitted. Can be set
   * in the past to backdate an entry or in the future to schedule it.
   */
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * Optional URL-safe slug. When omitted the backend derives one from the title;
   * when provided it is re-normalized server-side and suffixed (-2, -3, …) on
   * collision with another entry.
   */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** Optional short, plain-text intro shown under the title in modal display. */
  summary?: InputMaybe<Scalars['String']['input']>;
  /** The title of the changelog entry. */
  title: Scalars['String']['input'];
};

/** Mutation Response: Success and errors */
export type CreateChangelogEntryPayload = ChangelogEntry | VoidMutationError;

/** Input for creating a channel analytics export job. */
export type CreateChannelAnalyticsExportInput = {
  /**
   * The channel-metric columns, in display order, selected on the All Channels
   * performance table (mirrors its column picker). Applied to the PDF channel
   * summary table. When omitted, the table falls back to the first-seen union.
   */
  channelColumns?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The channels to include in the export */
  channelIds: Array<Scalars['ChannelId']['input']>;
  /**
   * Orders the per-channel sections of a multi-channel export to mirror the
   * All Channels performance table's active sort. Drives the channel summary
   * table, the per-channel detail sections, and which channels survive the
   * PDF channel cap. Ignored by single-channel exports (only one channel) and
   * by CSV/Markdown (no per-channel table). When omitted, channels are ordered
   * by post count descending — the table's default.
   */
  channelSort?: InputMaybe<InsightsExportChannelSortInput>;
  /**
   * A custom logo to render on the PDF report cover. Must be a persistent Buffer
   * asset URL (the `assetUrl` returned by the S3 pre-sign flow); URLs on other
   * hosts are rejected. When omitted, the report uses Buffer's default branding.
   * Ignored by CSV/Markdown.
   */
  customLogoUrl?: InputMaybe<Scalars['String']['input']>;
  /**
   * A custom report name shown in the PDF header in place of the organization
   * name. When omitted (or blank), the organization name is used. Ignored by
   * CSV/Markdown.
   */
  customReportName?: InputMaybe<Scalars['String']['input']>;
  /** End of the date range (inclusive) */
  endDate: Scalars['DateTime']['input'];
  /**
   * Report sections to omit from a PDF export (a deny-list). Every section is
   * included by default, so omitting this field — or passing an empty list —
   * renders the full report. Each listed section is suppressed wherever it
   * renders. Ignored by CSV/Markdown (flat formats have no notion of sections).
   * See `InsightsExportSection` for what each value controls.
   */
  excludedSections?: InputMaybe<Array<InsightsExportSection>>;
  /** The output format */
  format: ChannelAnalyticsExportFormat;
  /** The organization to export analytics for */
  organizationId: Scalars['OrganizationId']['input'];
  /**
   * The post-metric columns, in display order, selected on the single-channel
   * page's Top Posts table (mirrors its column picker). Each entry is a
   * PostMetricType value (e.g. `reactions`, `engagementRate`). Applied to the
   * posts tables every format renders. When omitted, each format uses its own
   * default post columns.
   */
  postColumns?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Orders the posts in the export to mirror the single-channel page's active
   * Top Posts sort. Applies to every format (the posts table/list each format
   * renders). When omitted, posts are ordered by reactions descending.
   */
  postSort?: InputMaybe<InsightsExportPostSortInput>;
  /**
   * Filter the export to posts of specific formats. Same rules as
   * `InsightsFilterInput.postTypes`. When omitted or empty, every format is
   * included.
   *
   * Narrows every post-derived section. Follower, reach and view sections read
   * channel-level daily snapshots rather than posts, so no post filter can narrow
   * them — they keep covering every format.
   */
  postTypes?: InputMaybe<Array<PostType>>;
  /** Start of the date range (inclusive) */
  startDate: Scalars['DateTime']['input'];
  /**
   * Filter to posts with specific tags.
   * When omitted, all posts are included regardless of tags.
   */
  tags?: InputMaybe<TagComparator>;
};

/**
 * Result of creating a channel analytics export. Either the job is already
 * processing, a cached result is returned immediately, or the input was invalid.
 */
export type CreateChannelAnalyticsExportPayload = ChannelAnalyticsExportProcessing | ChannelAnalyticsExportSuccess | InvalidInputError;

/** Input for createChannelGroup mutation */
export type CreateChannelGroupInput = {
  /** The account for which the user creates the Channel Group */
  accountId: Scalars['AccountId']['input'];
  /** The channels to be added to the group */
  channelIds?: InputMaybe<Array<Scalars['ChannelId']['input']>>;
  /** The name of the channel group */
  name: Scalars['String']['input'];
  /** The organization for which the user creates the Channel Group */
  organizationId: Scalars['OrganizationId']['input'];
};

/** Mutation Response: Success and errors */
export type CreateChannelGroupPayload = ChannelGroup | UnauthorizedError | UnexpectedError;

/** Input parameters required to create a new Checkout session */
export type CreateCheckoutSessionInput = {
  /** The attribution for the subscription */
  attribution?: InputMaybe<AttributionInput>;
  /** The interval of the plan to create the checkout session for */
  interval: BillingInterval;
  /** The ID of the organization for which to create the checkout session */
  organizationId: Scalars['OrganizationId']['input'];
  /** The plan to create the checkout session for */
  plan: ObPlanId;
  /** The quantity of the plan to create the checkout session for */
  quantity: Scalars['Int']['input'];
  /** The redirect URL for the checkout session */
  redirectUrl: Scalars['String']['input'];
};

/** Union type representing either a successful response with a checkout session URL or a billing error */
export type CreateCheckoutSessionPayload = BillingError | CreateCheckoutSessionResponse;

/** Response type for creating a Stripe Checkout session */
export type CreateCheckoutSessionResponse = {
  __typename?: 'CreateCheckoutSessionResponse';
  /** The url returned by Stripe as a redirect for success, failed, or cancelled session */
  redirectUrl: Scalars['String']['output'];
};

/** The content for a new collaboration Note. */
export type CreateCollaborationNoteInput = {
  /** The annotations for the Note. Omit or pass null to use an empty list. */
  annotations?: InputMaybe<Array<AnnotationInput>>;
  /** The entity whose Notes thread gets the Note. */
  subject: CollaborationNoteSubjectInput;
  /** The Note text. */
  text: Scalars['String']['input'];
};

/** The possible results from collaboration Note creation. */
export type CreateCollaborationNotePayload = CollaborationNoteThreadClosedError | CreateCollaborationNoteSuccess | InvalidInputError | LimitReachedError;

/** The result of a successful collaboration Note creation. */
export type CreateCollaborationNoteSuccess = {
  __typename?: 'CreateCollaborationNoteSuccess';
  /** The new Note and its cursor. */
  edge: CollaborationNoteEdge;
};

/**
 * createContentItemDraft failure. When any part of the input is invalid,
 * nothing is created.
 */
export type CreateContentItemDraftFailure = MutationError & {
  __typename?: 'CreateContentItemDraftFailure';
  /** The recoverable errors behind this failure. */
  errors: Array<InvalidInputError>;
  /** Summary error message. */
  message: Scalars['String']['output'];
};

/** Input for createContentItemDraft. */
export type CreateContentItemDraftInput = {
  /**
   * Client-generated UUID that makes draft creation idempotent. A retry with the
   * same UUID in the same organization returns the first content item in its
   * current state.
   */
  correlationId?: InputMaybe<Scalars['Uuid']['input']>;
  /** The channel-less draft content to start with. */
  draft: DraftContentInput;
  /** Organization that will own the content item. */
  organizationId: Scalars['OrganizationId']['input'];
  /** Tags to apply to this content item. Omit to create it with no tags. */
  tagIds?: InputMaybe<Array<Scalars['TagId']['input']>>;
  /**
   * Optional date indicating when this piece of content should go out. This is
   * a planning aid only and does not schedule any posts.
   */
  targetDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Optional title describing what this piece of content is about. */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** All possible responses for createContentItemDraft. */
export type CreateContentItemDraftPayload = CreateContentItemDraftFailure | CreateContentItemDraftSuccess;

/** Successful createContentItemDraft response. */
export type CreateContentItemDraftSuccess = {
  __typename?: 'CreateContentItemDraftSuccess';
  /** The content item first created for this request, including its current state. */
  contentItem: ContentItem;
};

/**
 * A recoverable error that prevented a content item from being created. Variant
 * errors identify the specific channel they apply to; the others apply to the
 * request as a whole.
 */
export type CreateContentItemError = CreateContentItemVariantInvalidInputError | CreateContentItemVariantLimitReachedError | CreateContentItemVariantNotFoundError | InvalidInputError | LimitReachedError | NotFoundError;

/**
 * createContentItem failure. Every recoverable error is reported together so the
 * caller can surface them all at once. When the input fails validation, no
 * content item and no variants are created. When one or more variants fail while
 * being processed after creation, the content item and all of its variants
 * already exist; the per-channel errors identify the variants that need
 * attention.
 */
export type CreateContentItemFailure = MutationError & {
  __typename?: 'CreateContentItemFailure';
  /** The recoverable errors behind this failure. */
  errors: Array<CreateContentItemError>;
  /** Summary error message. */
  message: Scalars['String']['output'];
};

/** Input for createContentItem. */
export type CreateContentItemInput = {
  /** Organization that owns the content item and all variants created in it. */
  organizationId: Scalars['OrganizationId']['input'];
  /**
   * The channel-specific post variants to create, one per channel. Provide at
   * least one variant, and at most one variant per channel.
   */
  posts: Array<CreatePostInput>;
  /** Tags to apply to this content item. Omit to create it with no tags. */
  tagIds?: InputMaybe<Array<Scalars['TagId']['input']>>;
  /**
   * Optional date indicating when this piece of content should go out. This is
   * a planning aid only and does not schedule any posts.
   */
  targetDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Optional title describing what this piece of content is about. */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** All possible responses for createContentItem. */
export type CreateContentItemPayload = CreateContentItemFailure | CreateContentItemSuccess;

/** Successful createContentItem response. */
export type CreateContentItemSuccess = {
  __typename?: 'CreateContentItemSuccess';
  /** The content item created by this mutation. */
  content: ContentItem;
};

/** Invalid input for a single post variant in the createContentItem input list. */
export type CreateContentItemVariantInvalidInputError = MutationError & {
  __typename?: 'CreateContentItemVariantInvalidInputError';
  /** Channel targeted by the failing variant. */
  channelId: Scalars['ChannelId']['output'];
  /** Error message. */
  message: Scalars['String']['output'];
};

/** Limit reached for a single post variant in the createContentItem input list. */
export type CreateContentItemVariantLimitReachedError = MutationError & {
  __typename?: 'CreateContentItemVariantLimitReachedError';
  /** Channel targeted by the failing variant. */
  channelId: Scalars['ChannelId']['output'];
  /** Error message. */
  message: Scalars['String']['output'];
};

/**
 * The channel targeted by a single post variant in the createContentItem input
 * list was not found or is not accessible.
 */
export type CreateContentItemVariantNotFoundError = MutationError & {
  __typename?: 'CreateContentItemVariantNotFoundError';
  /** Channel targeted by the failing variant. */
  channelId: Scalars['ChannelId']['output'];
  /** Error message. */
  message: Scalars['String']['output'];
};

/** Channel-specific metadata for custom channel creation */
export type CreateCustomChannelMetadata = {
  /** Bluesky-specific metadata */
  blueskyMetadata?: InputMaybe<CreateBlueskyMetadata>;
  /** FB Group-specific metadata */
  facebookGroupMetadata?: InputMaybe<CreateFacebookGroupMetadata>;
  /** Instagram Personal Profiles-specific metada */
  instagramPersonalProfileMetadata?: InputMaybe<CreateInstagramPersonalProfileMetadata>;
};

/** Input for creating a custom channel */
export type CreateCustomChannelSingleInput = {
  /** Channel-specific metadata to use during creation */
  customChannelMetadata: CreateCustomChannelMetadata;
  /** Organization ID for channel connection */
  organizationId: Scalars['OrganizationId']['input'];
  /** Service for custom channel connection */
  service: ChannelThirdPartyService;
  /** Timezone to be used for this channel */
  timezone?: InputMaybe<Scalars['String']['input']>;
  /** Channel type for custom channel connection */
  type: ChannelType;
};

/** Input for creating custom channels, like Bluesky or FB Group */
export type CreateCustomChannelsInput = {
  /** List of channels to create */
  channels: Array<CreateCustomChannelSingleInput>;
};

/** Payload for createCustomChannels mutation */
export type CreateCustomChannelsPayload = CreateCustomChannelsResponse | CustomChannelError;

/** The response for custom channel connection */
export type CreateCustomChannelsResponse = {
  __typename?: 'CreateCustomChannelsResponse';
  /** Created channels */
  channels: Array<Channel>;
};

/** Input parameters required to create a new Customer Portal session */
export type CreateCustomerPortalSessionInput = {
  /**
   * Identifier of the CTA the user clicked to open the billing portal. Forwarded
   * to the server-side `Billing Portal Session Created` Segment event so success
   * attribution is captured even when the frontend can't see the Stripe customerId.
   */
  cta?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the organization for which to create the portal session */
  organizationId: Scalars['OrganizationId']['input'];
  /** The URL where the customer will be redirected after they complete their session in the portal */
  returnURL: Scalars['String']['input'];
};

/** Union type representing either a successful response with a portal URL or a billing error */
export type CreateCustomerPortalSessionPayload = BillingError | CreateCustomerPortalSessionResponse;

/** Response type for creating a Stripe Customer Portal session */
export type CreateCustomerPortalSessionResponse = {
  __typename?: 'CreateCustomerPortalSessionResponse';
  /**
   * The customer session url returned by Stripe.
   * This URL provides direct access to the Stripe Customer Portal where users can manage their billing settings.
   */
  customerPortalSessionUrl: Scalars['String']['output'];
};

/** Facebook Group-specific metadata for custom channel creation */
export type CreateFacebookGroupMetadata = {
  /** Avatar URL of this FB Group */
  avatar?: InputMaybe<Scalars['String']['input']>;
  /** Name of this FB Group */
  name: Scalars['String']['input'];
  /** URL to FB Group's page */
  url: Scalars['String']['input'];
};

/** Input for createFeedCollection mutation */
export type CreateFeedCollectionInput = {
  /**
   * Feeds to subscribe to in this feed
   * @deprecated Use moveFeed mutation to manage feed associations
   */
  feedIds?: InputMaybe<Array<Scalars['FeedId']['input']>>;
  /** The name of the feed collection. */
  name: Scalars['String']['input'];
  /** The organization that the feed collection will belong to */
  organizationId: Scalars['OrganizationId']['input'];
};

/**
 * Input for createFeed mutation
 * Contains feed creation details to connect
 */
export type CreateFeedInput = {
  /** The collection the feed should be stored in. If null, the feed will be a top level feed. */
  collectionId?: InputMaybe<Scalars['FeedCollectionId']['input']>;
  /** Input for creating a news search feed */
  newsSearch?: InputMaybe<NewsSearchFeedCreation>;
  /** The organization that the feed will belong to */
  organizationId: Scalars['OrganizationId']['input'];
  /** Insert the feed after the feed with the given id. If null, the feed will be inserted at the start of the collection. */
  placeAfterId?: InputMaybe<Scalars['String']['input']>;
  /** Input for creating an RSS/Atom feed */
  rssAtom?: InputMaybe<RssAtomFeedCreationInput>;
};

/** Input type for creating an idea group. */
export type CreateIdeaGroupInput = {
  /** The name of the idea group. */
  name: Scalars['String']['input'];
  /** Unique identifier for the organization. */
  organizationId: Scalars['ID']['input'];
};

/** Union type representing possible payloads for creating an idea group. */
export type CreateIdeaGroupPayload = IdeaGroup | InvalidInputError | UnauthorizedError | UnexpectedError;

/** createIdea input type */
export type CreateIdeaInput = {
  /** Content and metadata for the new idea */
  content: IdeaContentInput;
  /** Call-to-action identifier for analytics tracking */
  cta?: InputMaybe<Scalars['String']['input']>;
  /** Group placement (null for unassigned group) */
  group?: InputMaybe<IdeaGroupInput>;
  /** Organization ID that will own the idea */
  organizationId: Scalars['ID']['input'];
  /** Template ID used to create the idea */
  templateId?: InputMaybe<Scalars['String']['input']>;
};

/** createIdea response (including errors) */
export type CreateIdeaPayload = Idea | IdeaResponse | InvalidInputError | LimitReachedError | UnauthorizedError | UnexpectedError;

/** Instagram Personal Profile-specific metadata for custom channel creation */
export type CreateInstagramPersonalProfileMetadata = {
  /** Avatar URL for this channel */
  avatar?: InputMaybe<Scalars['String']['input']>;
  /** Name of this IG Profile */
  name: Scalars['String']['input'];
};

/**
 * Input for creating a Buffer-managed post template. All core fields are
 * required.
 */
export type CreateManagedPostTemplateInput = {
  /** The main content body of the template. */
  body: Scalars['String']['input'];
  /** A short user-facing description of the template. */
  description: Scalars['String']['input'];
  /** The emoji associated with the template. */
  emoji: Scalars['String']['input'];
  /** Whether this template is featured. Defaults to false. */
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  /** The goal or intent behind the template. */
  goal: PostTemplateGoal;
  /** The organization this template belongs to. */
  organizationId: Scalars['OrganizationId']['input'];
  /** The structural format of the template. */
  structure: PostTemplateStructure;
  /** Tags to apply to the template. Defaults to none. */
  tags?: InputMaybe<Array<PostTemplateTag>>;
  /** The title of the template. */
  title: Scalars['String']['input'];
  /** The type or category of the template. */
  type: PostTemplateType;
  /** The target user types for this template. */
  userTypes: Array<PostTemplateUserType>;
  /**
   * The visibility level of the template. `public` is accepted on the
   * manager surface (rejected by the end-user `createPostTemplate`).
   */
  visibility: PostTemplateVisibility;
};

/** Result of creating a Buffer-managed post template. */
export type CreateManagedPostTemplatePayload = CreateManagedPostTemplateSuccess | VoidMutationError;

/** Successful result of creating a Buffer-managed post template. */
export type CreateManagedPostTemplateSuccess = {
  __typename?: 'CreateManagedPostTemplateSuccess';
  /** The newly created post template. */
  postTemplate: PostTemplate;
};

/** All possible response types that can be returned by updateFeedCollection or createFeedCollection mutation. */
export type CreateOrUpdateFeedCollectionPayload = FeedCollectionActionSuccess | NotFoundError | UnauthorizedError | UnexpectedError;

/** All possible response types that can be returned by updateFeedCollection or createFeedCollection mutation. */
export type CreateOrUpdateFeedPayload = FeedActionSuccess | FeedConnectionError | NotFoundError | UnauthorizedError | UnexpectedError;

/**
 * Input for createPostGroup. A post group bundles posts created in the
 * same composer session so they can be tracked together.
 */
export type CreatePostGroupInput = {
  /**
   * Client-generated UUID used to correlate posts created in the same
   * composer session with this group. Unique across the system. Reusing
   * the same correlationId returns the existing post group (idempotent).
   */
  correlationId: Scalars['Uuid']['input'];
  /** Organization that owns the post group. */
  organizationId: Scalars['OrganizationId']['input'];
};

/** All possible response types for the createPostGroup mutation. */
export type CreatePostGroupPayload = CreatePostGroupSuccess | InvalidInputError;

/**
 * Successful createPostGroup response. Returned for both newly created
 * groups and idempotent reads of an existing one.
 */
export type CreatePostGroupSuccess = {
  __typename?: 'CreatePostGroupSuccess';
  /** The post group for this correlationId. */
  postGroup: PostGroup;
};

/**
 * Create post's request input.
 *
 * Note: `metadata.{service}.linkAttachment` is mutually exclusive with a non-empty `assets`
 * array. Input providing both is rejected.
 */
export type CreatePostInput = {
  /** If this post was created with the help of AI */
  aiAssisted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Ordered list of assets on this post. */
  assets?: Array<AssetInput>;
  /** Channel's Id for which we want to create the post */
  channelId: Scalars['ChannelId']['input'];
  /** Is set when the Post is generated from a Draft */
  draftId?: InputMaybe<Scalars['DraftId']['input']>;
  /** Date when the post is scheduled to be published */
  dueAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Is set when the Post is generated from an Idea */
  ideaId?: InputMaybe<Scalars['IdeaId']['input']>;
  /** Metadata of the post which differs based on the social network/service */
  metadata?: InputMaybe<PostInputMetaData>;
  /** How the post is being scheduled. */
  mode: ShareMode;
  /**
   * Submit the post for approval instead of scheduling it. A post submitted for
   * approval is always a draft, so this conflicts with turning `saveToDraft` off.
   *
   * Only valid when your posting policy on the target channel requires approval.
   */
  needsApproval?: Scalars['Boolean']['input'];
  /**
   * If true, saves the post as a draft instead of scheduling it.
   * When saving as draft:
   * - Post status will be 'draft' instead of 'buffer'
   * - Posting limits are not checked
   * - The post will not be published until explicitly scheduled
   */
  saveToDraft?: InputMaybe<Scalars['Boolean']['input']>;
  /** Scheduling type to indicate notification publishing or automatic publishing */
  schedulingType: SchedulingType;
  /** source where the composer was initiated from, used for tracking. */
  source?: InputMaybe<Scalars['String']['input']>;
  /** List of tag IDs */
  tagIds?: InputMaybe<Array<Scalars['TagId']['input']>>;
  /**
   * Text content of the Post.
   *
   * Note: for threaded posts, this needs to match the first item in the `thread` array.
   */
  text?: InputMaybe<Scalars['String']['input']>;
};

/** Create recurrence on an existing scheduled post */
export type CreatePostRecurrenceInput = {
  /** Cadence configuration */
  cadence: PostRecurrenceCadenceInput;
  /** Post ID to create recurrence on */
  id: Scalars['PostId']['input'];
  /** Maximum number of recurring posts */
  maxRecurrentPosts: Scalars['Int']['input'];
};

/** Result of creating recurrence on a post. */
export type CreatePostRecurrencePayload = PostActionSuccess | VoidMutationError;

/** Input for creating a new post template campaign. */
export type CreatePostTemplateCampaignInput = {
  /** A banner color. Optional. */
  bannerColor?: InputMaybe<Scalars['HexColorCode']['input']>;
  /** The type of campaign. */
  campaignType: PostCampaignType;
  /** A description of the campaign. Optional. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The end date of the campaign. Must be after startDate. */
  endDate: Scalars['DateTime']['input'];
  /** The heading displayed on the campaign. */
  heading: Scalars['String']['input'];
  /** An illustration URL. Optional. */
  illustration?: InputMaybe<Scalars['String']['input']>;
  /** The internal name of the campaign. */
  name: Scalars['String']['input'];
  /** The organization this campaign belongs to. */
  organizationId: Scalars['OrganizationId']['input'];
  /** Whether templates are shown after the campaign end date. */
  showTemplatesAfterEndDate: Scalars['Boolean']['input'];
  /** The URL-friendly slug for the campaign. */
  slug: Scalars['String']['input'];
  /** The start date of the campaign. */
  startDate: Scalars['DateTime']['input'];
  /** The initial status of the campaign. */
  status: PostCampaignStatus;
  /** Whether the campaign supports a banner display. */
  supportsBanner: Scalars['Boolean']['input'];
  /** The IDs of post templates to include in this campaign. Defaults to empty. */
  templateIds?: InputMaybe<Array<Scalars['PostTemplateId']['input']>>;
  /** The user-facing title. Optional. */
  title?: InputMaybe<Scalars['String']['input']>;
  /** An optional tooltip for the campaign toggle. */
  toggleTip?: InputMaybe<CampaignToggleTipInput>;
};

/** Result of creating a post template campaign. */
export type CreatePostTemplateCampaignPayload = CreatePostTemplateCampaignSuccess | InvalidInputError;

/** Successful result of creating a post template campaign. */
export type CreatePostTemplateCampaignSuccess = {
  __typename?: 'CreatePostTemplateCampaignSuccess';
  /** The newly created campaign. */
  postTemplateCampaign: PostTemplateCampaign;
};

/**
 * Input for an end user creating a post template. Buffer-curated
 * taxonomy fields are server-defaulted; setting them is only available
 * to official Buffer clients.
 */
export type CreatePostTemplateInput = {
  /** The main content body of the template, may contain {{placeholders}}. */
  body: Scalars['String']['input'];
  /**
   * A short user-facing description of the template. Nullable for
   * backwards-compat at the GraphQL boundary — the resolver rejects
   * null/empty values with a clear input error so the underlying
   * storage contract (non-empty string) is still honored.
   */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The emoji associated with the template. */
  emoji?: InputMaybe<Scalars['String']['input']>;
  /** Server-defaulted for non-manager actors. Honored by `createManagedPostTemplate`. */
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  /** Server-defaulted for non-manager actors. Honored by `createManagedPostTemplate`. */
  goal?: InputMaybe<PostTemplateGoal>;
  /**
   * Organization the template belongs to. The caller must be a member of
   * this organization. For `internal` visibility this is the team scope;
   * for `private` it's recorded on the template but does not affect
   * visibility.
   */
  organizationId: Scalars['OrganizationId']['input'];
  /**
   * Tracking metadata: how this create was initiated. `scratch` is the
   * default (an empty new-template dialog); `duplicate` is the dialog
   * seeded by copying an existing template's body. Read only by the
   * `Template Created` analytics event — not persisted on the template.
   */
  source?: InputMaybe<PostTemplateCreateSource>;
  /** Server-defaulted for non-manager actors. Honored by `createManagedPostTemplate`. */
  structure?: InputMaybe<PostTemplateStructure>;
  /** Server-defaulted for non-manager actors. Honored by `createManagedPostTemplate`. */
  tags?: InputMaybe<Array<PostTemplateTag>>;
  /** The title of the template. */
  title: Scalars['String']['input'];
  /** Server-defaulted for non-manager actors. Honored by `createManagedPostTemplate`. */
  type?: InputMaybe<PostTemplateType>;
  /** Server-defaulted for non-manager actors. Honored by `createManagedPostTemplate`. */
  userTypes?: InputMaybe<Array<PostTemplateUserType>>;
  /**
   * Defaults to `private` if omitted. `public` is rejected — it is only
   * available to official Buffer clients.
   */
  visibility?: InputMaybe<PostTemplateVisibility>;
};

/** Result of an end user creating a post template. */
export type CreatePostTemplatePayload = CreatePostTemplateSuccess | VoidMutationError;

/** Successful result of an end user creating a post template. */
export type CreatePostTemplateSuccess = {
  __typename?: 'CreatePostTemplateSuccess';
  /** The newly created post template. */
  postTemplate: PostTemplate;
};

/** Input type for adding a new saved reply. */
export type CreateSavedReplyInput = {
  /** The organization that owns this saved reply. */
  organizationId: Scalars['OrganizationId']['input'];
  /** The saved reply to create. */
  savedReply: SavedReplyToCreateInput;
};

/**
 * Response type for the createSavedReply mutation.
 * It can return either success or an error.
 */
export type CreateSavedReplyPayload = DuplicateError | InvalidInputError | LimitReachedError | NotFoundError | SavedReplyActionSuccess | UnauthorizedError | UnexpectedError;

/** Input for creating a saved view */
export type CreateSavedViewInput = {
  /** Identity color — one of the fixed palette tokens */
  color?: InputMaybe<Scalars['String']['input']>;
  /** Filter state to apply to this saved view */
  filters: Scalars['FilterJSON']['input'];
  /** Identity icon — a registry key resolved by the client icon registry */
  icon?: InputMaybe<Scalars['String']['input']>;
  /** Display name for the saved view */
  name: Scalars['String']['input'];
  /** The organization to create the saved view in */
  organizationId: Scalars['OrganizationId']['input'];
  /** The section of the app this saved view belongs to */
  section: SavedViewSection;
  /** The specific view within the section (e.g. queue, sent, drafts) */
  view?: InputMaybe<Scalars['String']['input']>;
};

/** Create Saved View Payload: Success and errors */
export type CreateSavedViewPayload = InvalidInputError | LimitReachedError | SavedView;

/** Input for the createSnippet mutation. */
export type CreateSnippetInput = {
  /** Display name of the snippet. */
  name: Scalars['String']['input'];
  /** The organization that owns the snippet. */
  organizationId: Scalars['OrganizationId']['input'];
  /** The hashtags, as the text that is inserted into a post. */
  text: Scalars['String']['input'];
};

/**
 * All possible responses for createSnippet. VoidMutationError reports an
 * empty or too long name or text.
 */
export type CreateSnippetPayload = CreateSnippetSuccess | VoidMutationError;

/** Success response of the createSnippet mutation. */
export type CreateSnippetSuccess = {
  __typename?: 'CreateSnippetSuccess';
  /** The snippet that was created. */
  snippet: Snippet;
};

/** Input for creating a tag. */
export type CreateTagInput = {
  /**
   * Organization to create the tag in. The caller must be an administrator of
   * this organization.
   */
  organizationId: Scalars['OrganizationId']['input'];
  /** The name and color to give the new tag. */
  tag: TagToCreateInput;
};

/**
 * The result of `createTag`: the tag that was created, or the reason it was
 * refused.
 *
 * **Members on the way out.** `RestProxyError`, `NotFoundError`,
 * `UnauthorizedError` and `UnexpectedError` are being removed from this union. No
 * new operation should select them by name.
 *
 * `RestProxyError` is never returned. The other three describe situations a caller
 * cannot correct — the tag not existing, the caller not being permitted, an
 * unexpected fault — and will be reported in the response's top-level `errors`
 * array instead of here.
 *
 * Select `... on MutationError { message }` rather than naming concrete error
 * types. Every error member implements that interface, so the selection keeps
 * working across the change.
 */
export type CreateTagPayload = DuplicateError | InvalidInputError | LimitReachedError | NotFoundError | RestProxyError | TagActionSuccess | UnauthorizedError | UnexpectedError;

export type CredentialsForChannelsError = {
  __typename?: 'CredentialsForChannelsError';
  /** A raw error message to help developers understand the root cause of the issue. */
  cause: Scalars['String']['output'];
  /** An enum representing the type of error that occurred. */
  errorType: ChannelAuthorizationErrorType;
  /** A user-friendly message that is safe to be displayed to users. */
  userFriendlyMessage: Scalars['String']['output'];
};

export type CredentialsForChannelsInput = {
  code: Scalars['String']['input'];
  codeVerifier?: InputMaybe<Scalars['String']['input']>;
  followBuffer?: InputMaybe<Scalars['Boolean']['input']>;
  mastodonServer?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  redirectUri: Scalars['String']['input'];
  service: Service;
};

export type CredentialsForChannelsPayload = CredentialsForChannelsError | CredentialsForChannelsResponse;

export type CredentialsForChannelsResponse = {
  __typename?: 'CredentialsForChannelsResponse';
  connectableChannels: Array<Maybe<ConnectableChannel>>;
};

export type CreditCard = {
  __typename?: 'CreditCard';
  brand: Scalars['String']['output'];
  expMonth: Scalars['String']['output'];
  expYear: Scalars['String']['output'];
  last4: Scalars['String']['output'];
};

/** Cross-channel takeaways query input */
export type CrossChannelsTakeawaysInput = {
  /**
   * The channels to return takeaways for. Omit to request every channel the actor
   * can view insights for. An empty list selects no channels, and returns no
   * takeaways. The server authorizes the selection, and returns takeaways only for
   * the channels that survive it.
   */
  channelIds?: InputMaybe<Array<Scalars['ChannelId']['input']>>;
  /** The organization ID */
  organizationId: Scalars['OrganizationId']['input'];
};

export type CustomChannelCreateInput = {
  avatar?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  service: ChannelThirdPartyService;
  timezone?: InputMaybe<Scalars['String']['input']>;
  type: ChannelType;
  url: Scalars['String']['input'];
};

/** Error thrown for custom channel mutations */
export type CustomChannelError = MutationError & {
  __typename?: 'CustomChannelError';
  /** An error message of the issue */
  message: Scalars['String']['output'];
};

export type CustomChannelUpdateInput = {
  avatar?: InputMaybe<Scalars['String']['input']>;
  channelId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type CustomChannelUpdatePayload = CustomChannelUpdateResponse | CustomChannelsError;

export type CustomChannelUpdateResponse = {
  __typename?: 'CustomChannelUpdateResponse';
  channel: Channel;
};

export type CustomChannelsCreatePayload = CustomChannelsCreateResponse | CustomChannelsError;

export type CustomChannelsCreateResponse = {
  __typename?: 'CustomChannelsCreateResponse';
  channels: Array<Channel>;
};

/** Error thrown for custom channel mutations */
export type CustomChannelsError = {
  __typename?: 'CustomChannelsError';
  /** A raw error message to help developers understand the root cause of the issue. */
  cause: Scalars['String']['output'];
  /** A user-friendly message that is safe to be displayed to users. */
  userFriendlyMessage: Scalars['String']['output'];
};

/**
 * Custom Link
 *
 * This type represents a custom link in the shop grid.
 */
export type CustomLink = {
  __typename?: 'CustomLink';
  /** Date of the creation of the link */
  createdAt: Scalars['DateTime']['output'];
  /** ID of the link */
  id: Scalars['ShopGridLinkId']['output'];
  /** Text of the link */
  text: Scalars['String']['output'];
  /** Date of the last update of the link */
  updatedAt: Scalars['DateTime']['output'];
  /** URL of the link */
  url: Scalars['URL']['output'];
};

/** Customer attributes from Customer.io */
export type CustomerIoAttributes = {
  __typename?: 'CustomerIOAttributes';
  /**
   * Whether daily comment notifications are enabled.
   * We'll add more attributes here as we need them.
   */
  commentsDaily: Scalars['Boolean']['output'];
  /** Whether the Hourly Comment Alerts cover comments. */
  commentsHourly: Scalars['Boolean']['output'];
  /** Whether the Daily Community Recap covers comments. */
  communityCommentsDaily: Scalars['Boolean']['output'];
  /** Whether the Daily Community Recap covers mentions. */
  communityMentionsDaily: Scalars['Boolean']['output'];
  /** Whether the Daily Community Recap covers posts. */
  communityPostsDaily: Scalars['Boolean']['output'];
  /** Whether daily mention notifications are enabled. */
  mentionsDaily: Scalars['Boolean']['output'];
  /** Whether the Hourly Comment Alerts cover mentions. */
  mentionsHourly: Scalars['Boolean']['output'];
  /** Whether the daily recap covers published posts and their stats. */
  postsDaily: Scalars['Boolean']['output'];
  /**
   * Whether the account is globally unsubscribed from all Customer.io messaging.
   * When true, Customer.io blocks all subscription messaging (email, push, SMS)
   * regardless of per-topic preferences.
   */
  unsubscribed: Scalars['Boolean']['output'];
};

/** Customer attributes for Customer.io */
export type CustomerIoAttributesInput = {
  /**
   * Whether to enable daily comment notifications.
   * Optional so a single attribute can be updated without affecting the others.
   */
  commentsDaily?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Whether the Hourly Comment Alerts cover comments.
   * Optional so a single attribute can be updated without affecting the others.
   */
  commentsHourly?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Whether the Daily Community Recap covers comments.
   * Optional so a single attribute can be updated without affecting the others.
   */
  communityCommentsDaily?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Whether the Daily Community Recap covers mentions.
   * Optional so a single attribute can be updated without affecting the others.
   */
  communityMentionsDaily?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Whether the Daily Community Recap covers posts.
   * Optional so a single attribute can be updated without affecting the others.
   */
  communityPostsDaily?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Whether to enable daily mention notifications.
   * Optional so a single attribute can be updated without affecting the others.
   */
  mentionsDaily?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Whether the Hourly Comment Alerts cover mentions.
   * Optional so a single attribute can be updated without affecting the others.
   */
  mentionsHourly?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Whether the daily recap covers published posts and their stats.
   * Optional so a single attribute can be updated without affecting the others.
   */
  postsDaily?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Whether the account is globally unsubscribed from all Customer.io messaging.
   * Optional so a single attribute can be updated without affecting the others.
   */
  unsubscribed?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Status of daily posting limits for a channel on a given day. */
export type DailyPostingLimitStatus = {
  __typename?: 'DailyPostingLimitStatus';
  /** The channel ID this status refers to. */
  channelId: Scalars['ChannelId']['output'];
  /** Whether the channel has reached its daily posting limit. */
  isAtLimit: Scalars['Boolean']['output'];
  /** The network daily posting limit. Null means unlimited. */
  limit?: Maybe<Scalars['Int']['output']>;
  /** Number of posts scheduled for this day. */
  scheduled: Scalars['Int']['output'];
  /** Number of posts already sent on this day. */
  sent: Scalars['Int']['output'];
};

/** Input for the dailyPostingLimits query. */
export type DailyPostingLimitsInput = {
  /** List of channel IDs to check limits for. All channels must belong to the same organization. */
  channelIds: Array<Scalars['ChannelId']['input']>;
  /** The date to check limits for. Defaults to today if not provided. */
  date?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Comparator for filtering by date */
export type DateTimeComparator = {
  /**
   * Include results with dates equal to or before
   * the specified date
   */
  end?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * Include results with dates equal to or after
   * the specified date
   */
  start?: InputMaybe<Scalars['DateTime']['input']>;
};

/**
 * Presence filter for nullable date fields.
 * When filtering the same field, absent dates cannot also match a date comparator range.
 */
export enum DateTimePresence {
  /** Include results where the date field is missing or null */
  Absent = 'absent',
  /** Include results where the date field exists and is not null */
  Present = 'present'
}

/** Date range filter for engagement timestamps. */
export type DateTimeRange = {
  /** Include results with dates equal to or after this date. */
  from?: InputMaybe<Scalars['DateTime']['input']>;
  /** Include results with dates equal to or before this date. */
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Day = {
  campaigns?: Maybe<Array<PublishingCampaign>>;
  dayName: DayName;
  dayOfMonth: Scalars['Int']['output'];
  monthName: MonthName;
  startTimestamp: Scalars['Int']['output'];
};

export enum DayName {
  Friday = 'Friday',
  Monday = 'Monday',
  Saturday = 'Saturday',
  Sunday = 'Sunday',
  Thursday = 'Thursday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday'
}

/** Day of the week. */
export enum DayOfWeek {
  Fri = 'fri',
  Mon = 'mon',
  Sat = 'sat',
  Sun = 'sun',
  Thu = 'thu',
  Tue = 'tue',
  Wed = 'wed'
}

/** Represents the default avatar settings of an author. */
export type DefaultAvatarSettings = {
  __typename?: 'DefaultAvatarSettings';
  /** The consistent text color for the specific author the default avatar (HEX code). */
  backgroundColor: Scalars['String']['output'];
  /** The letter of the author. */
  letter: Scalars['String']['output'];
  /** The consistent text color for the specific author of the default avatar (HEX code). */
  textColor: Scalars['String']['output'];
};

/** A default/generic reaction (used by Twitter, Bluesky, Mastodon, TikTok, etc.) */
export type DefaultReaction = {
  __typename?: 'DefaultReaction';
  /** The generic icon used to represent the reaction. */
  icon: LikingIcon;
  /** The type of reaction. */
  reactionType: ReactionType;
};

/** Input for deleteAPIClient mutation */
export type DeleteApiClientInput = {
  /** The client ID of the API Client to delete */
  clientId: Scalars['String']['input'];
};

/** Response for deleteAPIClient mutation */
export type DeleteApiClientPayload = DeleteApiClientSuccess | NotFoundError;

/** Success response for deleteAPIClient mutation */
export type DeleteApiClientSuccess = {
  __typename?: 'DeleteAPIClientSuccess';
  /** The client ID of the deleted API Client */
  clientId: Scalars['String']['output'];
};

/** input for deleteAccount mutation */
export type DeleteAccountInput = {
  /** Account id of account to delete. */
  accountId: Scalars['AccountId']['input'];
};

/** deleteAccount response payload. */
export type DeleteAccountPayload = DeleteAccountSuccess | InvalidInputError | NotFoundError | UnexpectedError;

/** success response for deleteAccount mutation */
export type DeleteAccountSuccess = MutationSuccess & {
  __typename?: 'DeleteAccountSuccess';
  /**
   * The value is always an empty string ''
   * Note: GraphQL doesn't allow types with no fields, so we have to add this field
   */
  _empty: Scalars['String']['output'];
};

/** input for deleteAdminComment mutation */
export type DeleteAdminCommentInput = {
  /** ID of the account that will have the comment delete */
  accountId: Scalars['AccountId']['input'];
};

/** deleteAdminComment response payload */
export type DeleteAdminCommentPayload = EmptySuccess | NotFoundError | UnauthorizedError | UnexpectedError;

/** Input for deleteChangelogEntry mutation */
export type DeleteChangelogEntryInput = {
  /** The id of the changelog entry to delete */
  id: Scalars['ChangelogEntryId']['input'];
};

/** Mutation Response: Success and errors */
export type DeleteChangelogEntryPayload = DeleteChangelogEntrySuccess | VoidMutationError;

/** Success response for deleteChangelogEntry mutation */
export type DeleteChangelogEntrySuccess = {
  __typename?: 'DeleteChangelogEntrySuccess';
  /** The id of the deleted changelog entry */
  id: Scalars['ChangelogEntryId']['output'];
};

/** Input for deleteChannelGroup mutation */
export type DeleteChannelGroupInput = {
  /** The id of the channel group */
  id: Scalars['ChannelGroupId']['input'];
};

/** Mutation Response: Success and errors */
export type DeleteChannelGroupPayload = DeleteChannelGroupSuccess | NotFoundError | UnauthorizedError | UnexpectedError;

/** Success response for deleteChannelGroup mutation */
export type DeleteChannelGroupSuccess = {
  __typename?: 'DeleteChannelGroupSuccess';
  /** The id of the deleted channel group */
  id: Scalars['ChannelGroupId']['output'];
};

/** The collaboration Note to delete. */
export type DeleteCollaborationNoteInput = {
  /** The Note ID. */
  noteId: Scalars['NoteId']['input'];
};

/** The possible results from collaboration Note deletion. */
export type DeleteCollaborationNotePayload = DeleteCollaborationNoteSuccess | VoidMutationError;

/** The result of a successful collaboration Note deletion. */
export type DeleteCollaborationNoteSuccess = {
  __typename?: 'DeleteCollaborationNoteSuccess';
  /** The deleted Note ID. */
  noteId: Scalars['NoteId']['output'];
};

/**
 * deleteContentItem failure. When any post cannot be deleted, nothing is
 * deleted: the content item and all of its posts remain unchanged. Every
 * blocked post is reported together so the caller can surface them all at
 * once.
 */
export type DeleteContentItemFailure = MutationError & {
  __typename?: 'DeleteContentItemFailure';
  /** The recoverable errors behind this failure. */
  errors: Array<PostNotDeletableError>;
  /** Summary error message. */
  message: Scalars['String']['output'];
};

/** Input for deleteContentItem. */
export type DeleteContentItemInput = {
  /** The content item to delete. */
  id: Scalars['ContentItemId']['input'];
};

/** All possible responses for deleteContentItem. */
export type DeleteContentItemPayload = DeleteContentItemFailure | EmptySuccess;

export type DeleteEntityNoteInput = {
  entityId: Scalars['String']['input'];
  entityType: EntityWithNotes;
  noteId: Scalars['String']['input'];
};

export type DeleteEntityNotePayload = CoreWebAppCommonError | DeleteEntityNoteResponse;

export type DeleteEntityNoteResponse = {
  __typename?: 'DeleteEntityNoteResponse';
  entityId: Scalars['String']['output'];
  entityType: EntityWithNotes;
  noteId: Scalars['String']['output'];
};

/** Input for deleting a feed collection */
export type DeleteFeedCollectionInput = {
  /** The ids of the feeds to delete. */
  feedCollectionId: Scalars['FeedId']['input'];
  /** The organization that the feed collection will belong to */
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
};

/** All possible response types that can be returned by deleteFeedCollection mutation. */
export type DeleteFeedCollectionPayload = FeedCollectionDeleteSuccess | NotFoundError | UnauthorizedError | UnexpectedError;

/** Input for deleting a feed */
export type DeleteFeedInput = {
  /** The feed to delete */
  id: Scalars['FeedId']['input'];
  /** The organization that the feed collection will belong to */
  organizationId: Scalars['OrganizationId']['input'];
};

/** All possible response types for feed deletion */
export type DeleteFeedPayload = DeleteFeedResponse | UnexpectedError;

/** Response for deleting a feed */
export type DeleteFeedResponse = {
  __typename?: 'DeleteFeedResponse';
  /** The ID of the deleted feed */
  id: Scalars['FeedId']['output'];
};

/** Input type for deleting an idea group. */
export type DeleteIdeaGroupInput = {
  /** Unique identifier for the idea group. */
  id: Scalars['ID']['input'];
};

/** Union type representing possible payloads for deleting an idea group. */
export type DeleteIdeaGroupPayload = DeleteIdeaGroupResponse | InvalidInputError | NotFoundError | UnauthorizedError | UnexpectedError;

/** Response type for deleting an idea group. */
export type DeleteIdeaGroupResponse = {
  __typename?: 'DeleteIdeaGroupResponse';
  /** The ideas that were updated as a result of deleting the idea group. */
  updatedIdeas: Array<Idea>;
};

/** Input for deleting a Buffer-managed post template. */
export type DeleteManagedPostTemplateInput = {
  /** The ID of the template to delete. */
  id: Scalars['PostTemplateId']['input'];
};

/** Result of deleting a Buffer-managed post template. */
export type DeleteManagedPostTemplatePayload = EmptySuccess | VoidMutationError;

/** Input to pass when deleting a note from a post */
export type DeleteNoteFromPostInput = {
  /** The id of note to delete */
  noteId: Scalars['NoteId']['input'];
  /** The id of post */
  postId: Scalars['PostId']['input'];
};

/** Delete note request response payload. */
export type DeleteNoteFromPostPayload = DeleteNoteFromPostSuccess | InvalidInputError | LimitReachedError | NotFoundError | UnauthorizedError | UnexpectedError;

/** Success response */
export type DeleteNoteFromPostSuccess = {
  __typename?: 'DeleteNoteFromPostSuccess';
  /** the full up-to-date post from after the note was deleted */
  post: Post;
};

/** deletePost mutation deletes a post by id. */
export type DeletePostInput = {
  /** Post id to delete. */
  id: Scalars['PostId']['input'];
};

/** deletePostV2 mutation deletes a post by id. */
export type DeletePostInputV2 = {
  /** Post id to delete. */
  id: Scalars['PostId']['input'];
};

/** All possible response types for the deletePost mutation. */
export type DeletePostPayload = DeletePostSuccess | VoidMutationError;

/** All possible response types that can be returned by deletePostV2 mutation. */
export type DeletePostResult = DeletePostSuccess | NotFoundError | RestProxyError | UnauthorizedError | UnexpectedError;

/** deletePost success response returns the post id that was deleted. */
export type DeletePostSuccess = {
  __typename?: 'DeletePostSuccess';
  /** Post id that was delete. */
  id: Scalars['PostId']['output'];
};

/** Input for deleting a post template campaign. */
export type DeletePostTemplateCampaignInput = {
  /** The ID of the campaign to delete. */
  id: Scalars['PostTemplateCampaignId']['input'];
};

/** Result of deleting a post template campaign. */
export type DeletePostTemplateCampaignPayload = EmptySuccess | VoidMutationError;

/** Input for an end user deleting a post template. */
export type DeletePostTemplateInput = {
  /** The ID of the template to delete. */
  id: Scalars['PostTemplateId']['input'];
};

/** Result of an end user deleting a post template. */
export type DeletePostTemplatePayload = EmptySuccess | VoidMutationError;

/** Input type for deleting a saved reply. */
export type DeleteSavedReplyInput = {
  /** Id of the saved reply to delete. */
  id: Scalars['SavedReplyId']['input'];
};

/**
 * Response type for the deleteSavedReply mutation.
 * It can return either success or an error.
 */
export type DeleteSavedReplyPayload = DeleteSavedReplySuccess | InvalidInputError | NotFoundError | UnauthorizedError | UnexpectedError;

/** Successful response for deleting a saved reply. */
export type DeleteSavedReplySuccess = {
  __typename?: 'DeleteSavedReplySuccess';
  /** Id of the deleted saved reply. */
  id: Scalars['SavedReplyId']['output'];
};

/** Input for deleting a saved view */
export type DeleteSavedViewInput = {
  /** The ID of the saved view to delete */
  id: Scalars['SavedViewId']['input'];
  /** The organization the saved view belongs to */
  organizationId: Scalars['OrganizationId']['input'];
};

/** Delete Saved View Payload: Success and errors */
export type DeleteSavedViewPayload = DeleteSavedViewSuccess | NotFoundError;

/** Success response for deleting a saved view */
export type DeleteSavedViewSuccess = {
  __typename?: 'DeleteSavedViewSuccess';
  /** The ID of the deleted saved view */
  id: Scalars['SavedViewId']['output'];
};

/** Input for the mutation to delete a shop grid custom link */
export type DeleteShopGridCustomLinkInput = {
  /** The ID of the channel */
  channelId: Scalars['ChannelId']['input'];
  /** The ID of the custom link to be deleted */
  id: Scalars['ShopGridLinkId']['input'];
};

/** Input for the deleteSnippet mutation. */
export type DeleteSnippetInput = {
  /** The snippet to delete. */
  id: Scalars['SnippetId']['input'];
  /** The organization that owns the snippet. */
  organizationId: Scalars['OrganizationId']['input'];
};

/** All possible responses for deleteSnippet. */
export type DeleteSnippetPayload = DeleteSnippetSuccess | VoidMutationError;

/** Success response of the deleteSnippet mutation. */
export type DeleteSnippetSuccess = {
  __typename?: 'DeleteSnippetSuccess';
  /** The id of the deleted snippet. */
  id: Scalars['SnippetId']['output'];
};

/** Returned when a tag was deleted successfully. */
export type DeleteTagActionSuccess = {
  __typename?: 'DeleteTagActionSuccess';
  /** The id of the tag that was deleted. */
  id: Scalars['TagId']['output'];
};

/** Input for deleting a tag. */
export type DeleteTagInput = {
  /**
   * The tag to delete. Its organization is taken from the tag itself, and the
   * caller must be an administrator of that organization.
   */
  id: Scalars['TagId']['input'];
};

/**
 * The result of `deleteTag`: the id of the deleted tag, or the reason the delete
 * was refused.
 *
 * **Members on the way out.** `RestProxyError`, `NotFoundError`,
 * `UnauthorizedError` and `UnexpectedError` are being removed from this union. No
 * new operation should select them by name.
 *
 * `RestProxyError` is never returned. The other three describe situations a caller
 * cannot correct — the tag not existing, the caller not being permitted, an
 * unexpected fault — and will be reported in the response's top-level `errors`
 * array instead of here.
 *
 * Select `... on MutationError { message }` rather than naming concrete error
 * types. Every error member implements that interface, so the selection keeps
 * working across the change.
 */
export type DeleteTagPayload = DeleteTagActionSuccess | InvalidInputError | NotFoundError | RestProxyError | UnauthorizedError | UnexpectedError;

/** How the difference between current and previous period is expressed */
export enum DifferenceMode {
  Absolute = 'absolute',
  Percentage = 'percentage'
}

/** Input for disabling Two Factor Authentication with password verification */
export type DisableTwoFactorWithPasswordInput = {
  /** The account password for verification */
  password: Scalars['String']['input'];
};

/** The payload of the response from DisableTwoFactorWithPassword */
export type DisableTwoFactorWithPasswordPayload = EmptySuccess | InvalidInputError;

export type Discount = {
  __typename?: 'Discount';
  duration: DiscountDuration;
  durationInMonths?: Maybe<Scalars['Int']['output']>;
  gatewayId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type: DiscountType;
  value: Scalars['Float']['output'];
};

/** Defines how long a discount remains active */
export enum DiscountDuration {
  /** Discount is permanent and never expires */
  Forever = 'forever',
  /** Discount is applied only once at the next billing cycle */
  Once = 'once',
  /** Discount repeats for a specified number of months */
  Repeating = 'repeating'
}

/** Defines the scope of a discount application */
export enum DiscountScope {
  /** Discount applies to the entire customer account across all subscriptions. */
  Customer = 'customer',
  /** Discount applies only to the active subscription. */
  Subscription = 'subscription'
}

/** Defines the type of discount calculation */
export enum DiscountType {
  /** Fixed amount discount (e.g., $10 off) */
  Amount = 'amount',
  /** Percentage-based discount (e.g., 25% off) */
  Percent = 'percent'
}

/** Input type for dismissing all comments for a channel. */
export type DismissAllCommentsByChannelIdInput = {
  /** Id of the channel whose comments should be dismissed. */
  channelId: Scalars['ChannelId']['input'];
  /**
   * The date from which comments published at and older should be dismissed.
   * If not provided all comments for the provided channels will be dismissed.
   */
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Input type for dismissing all comments for a  organization. */
export type DismissAllCommentsByOrganizationIdInput = {
  /** Id of the organization whose comments should be dismissed. */
  organizationId: Scalars['OrganizationId']['input'];
};

/** Input type for dismissing all comments for a post. */
export type DismissAllCommentsByPostIdInput = {
  /** Id of the post whose comments should be dismissed. */
  postId: Scalars['PostId']['input'];
};

/** Input type for dismissing all comments for a list of channel. */
export type DismissAllCommentsForChannelsInput = {
  /** List of channel ids whose comments should be dismissed. */
  channelIds: Array<Scalars['ChannelId']['input']>;
  /**
   * The date from which comments published at and older should be dismissed.
   * If not provided all comments for the provided channels will be dismissed.
   */
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Mutation Response for Dismissing all comments for a list of channels */
export type DismissAllCommentsForChannelsPayload = DismissAllCommentsForChannelsSuccess | InvalidInputError | NotFoundError | UnauthorizedError | UnexpectedError;

/** Successful dismiss response for a list of channels. */
export type DismissAllCommentsForChannelsSuccess = {
  __typename?: 'DismissAllCommentsForChannelsSuccess';
  /** The list of channels with their comments dismissed or failed to be dismissed. */
  channels?: Maybe<Array<DismissedChannelCommentsPayload>>;
};

/** Mutation Response: Success and errors */
export type DismissAllCommentsPayload = DismissAllCommentsSuccess | InvalidInputError | NotFoundError | UnauthorizedError | UnexpectedError;

/** Successful dismiss response. */
export type DismissAllCommentsSuccess = {
  __typename?: 'DismissAllCommentsSuccess';
  /** The number of comments that were dismissed or enqueued */
  affectedCommentCount: Scalars['Int']['output'];
  /** The operation status: processed or enqueued. */
  status: DismissAllStatus;
};

/** Input for the dismissAllEngagementsByChannelIds mutation. */
export type DismissAllEngagementsByChannelIdsInput = {
  /**
   * Channels to dismiss engagements for. When omitted, dismisses across all
   * channels in the org the actor has privileges for.
   */
  channelIds?: InputMaybe<Array<Scalars['ChannelId']['input']>>;
  /** Engagement type to dismiss. Only mention is supported at M1. */
  engagementType: EngagementType;
  /** Organization whose engagements should be dismissed. */
  organizationId: Scalars['OrganizationId']['input'];
  /**
   * Upper bound on publishedAt. When provided, only engagements published on
   * or before this date are dismissed.
   */
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Result of the dismissAllEngagementsByChannelIds mutation. */
export type DismissAllEngagementsByChannelIdsPayload = DismissAllEngagementsByChannelIdsSuccess | VoidMutationError;

/** Returned when the bulk dismissal completed (possibly with per-channel errors). */
export type DismissAllEngagementsByChannelIdsSuccess = {
  __typename?: 'DismissAllEngagementsByChannelIdsSuccess';
  /** Per-channel results. */
  channels: Array<DismissedChannelEngagements>;
};

/** Successful dismiss response. We're using an enum to make room to different statuses in the future. */
export enum DismissAllStatus {
  /** The operation was enqueeued and will be processed asynchronously. */
  Enqueued = 'enqueued',
  /** The operation was completed successfully and the comments were dismissed. */
  Processed = 'processed'
}

export type DismissBannerError = {
  __typename?: 'DismissBannerError';
  cause: Scalars['String']['output'];
};

export type DismissBannerPayload = DismissBannerError | DismissBannerResponse;

export type DismissBannerResponse = {
  __typename?: 'DismissBannerResponse';
  success: Scalars['Boolean']['output'];
};

/** Input for `Mutation.dismissBufferHomeTask`. */
export type DismissBufferHomeTaskInput = {
  /** The organization whose task is being dismissed. */
  organizationId: Scalars['OrganizationId']['input'];
  /** The task being dismissed. */
  taskKey: BufferHomeTaskKey;
};

/** All possible response types for the `dismissBufferHomeTask` mutation. */
export type DismissBufferHomeTaskPayload = DismissBufferHomeTaskSuccess | VoidMutationError;

/**
 * Successful result of `Mutation.dismissBufferHomeTask`. Returns the updated
 * checklist so Apollo's cache merges naturally.
 */
export type DismissBufferHomeTaskSuccess = {
  __typename?: 'DismissBufferHomeTaskSuccess';
  /** The full checklist for the organization after the mutation. */
  bufferHomeChecklist: BufferHomeChecklist;
};

/**
 * Input type for the `dismissComment` mutation.
 * Defines the comment being dismissed.
 */
export type DismissCommentInput = {
  /** ID of the comment being dismissed. */
  commentId: Scalars['CommentId']['input'];
};

/** Mutation Response: Success and errors */
export type DismissCommentPayload = DismissCommentSuccess | InvalidInputError | NotFoundError | UnauthorizedError | UnexpectedError;

/** Successful dismiss response. */
export type DismissCommentSuccess = {
  __typename?: 'DismissCommentSuccess';
  /** The comment that was successfully dismissed. */
  comment: CommentData;
};

/** Input for the dismissEngagement mutation. */
export type DismissEngagementInput = {
  /** Unique identifier of the engagement to dismiss. */
  engagementId: Scalars['EngagementId']['input'];
  /** Type of engagement to dismiss (mention or comment). */
  engagementType: EngagementType;
};

/** Result of the dismissEngagement mutation. */
export type DismissEngagementPayload = DismissEngagementSuccess | VoidMutationError;

/** Returned when the engagement was successfully dismissed. */
export type DismissEngagementSuccess = {
  __typename?: 'DismissEngagementSuccess';
  /** The dismissed engagement item. */
  engagement: Engagement;
};

/** Payload for a dismissed channel comments. */
export type DismissedChannelCommentsPayload = {
  __typename?: 'DismissedChannelCommentsPayload';
  /** The id of the channel. */
  id: Scalars['ChannelId']['output'];
  /** The status of the operation. */
  status: DismissedChannelCommentsPayloadStatus;
};

/** Enum for the status of the operation for a channel related to the dismissal of comments. */
export enum DismissedChannelCommentsPayloadStatus {
  /** The operation has failed for the channel. */
  Error = 'error',
  /** The operation was completed successfully and the comments were dismissed for the channel. */
  Success = 'success'
}

/** Per-channel outcome of the dismissAllEngagementsByChannelIds mutation. */
export type DismissedChannelEngagements = {
  __typename?: 'DismissedChannelEngagements';
  /** Number of engagements dismissed for this channel. */
  dismissed: Scalars['Int']['output'];
  /** The channel whose engagements were dismissed. */
  id: Scalars['ChannelId']['output'];
  /** Whether the dismissal succeeded or failed for this channel. */
  status: DismissedEngagementsStatus;
};

/** Outcome status for a single channel in a bulk-dismiss operation. */
export enum DismissedEngagementsStatus {
  /** The dismissal failed for this channel. */
  Error = 'error',
  /** All eligible engagements in the channel were dismissed. */
  Success = 'success'
}

export type DismissedObject = {
  __typename?: 'DismissedObject';
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
};

export type DismissedObjectInput = {
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['String']['input'];
};

/** Document asset */
export type DocumentAsset = Asset & {
  __typename?: 'DocumentAsset';
  /** Document specific metadata */
  document: DocumentMetadata;
  /** The ID of the asset in the database */
  id?: Maybe<Scalars['ID']['output']>;
  /** The MIME type of the asset */
  mimeType: Scalars['String']['output'];
  /** URL to the file source */
  source: Scalars['String']['output'];
  /** URL to the static thumbnail of the asset */
  thumbnail: Scalars['String']['output'];
  /** The type of the asset */
  type: AssetType;
};

/** Document asset */
export type DocumentAssetInput = {
  /** Document thumbnail URL */
  thumbnailUrl: Scalars['String']['input'];
  /** Document title */
  title: Scalars['String']['input'];
  /** Document URL */
  url: Scalars['String']['input'];
};

/** Document metadata */
export type DocumentMetadata = {
  __typename?: 'DocumentMetadata';
  /** Document fileSize in bytes */
  filesize?: Maybe<Scalars['Int']['output']>;
  /** Number of pages in the document */
  numPages: Scalars['Int']['output'];
  /** URLs to the static thumbnails of the document pages */
  thumbnails: Array<Scalars['String']['output']>;
  /** Document title */
  title?: Maybe<Scalars['String']['output']>;
};

/** Input for the downgradeToFree mutation. */
export type DowngradeToFreeInput = {
  /** Optional attribution metadata for the downgrade. */
  attribution?: InputMaybe<AttributionInput>;
  /**
   * The channel IDs the user wants to keep active on the free plan. Must
   * contain at most the free plan channel limit. An empty array falls back
   * to the default auto-lock by channel type.
   */
  channelsToKeep: Array<Scalars['ChannelId']['input']>;
  /** The ID of the organization whose subscription is being downgraded. */
  organizationId: Scalars['OrganizationId']['input'];
};

/** The payload response of the downgrade-to-free mutation. */
export type DowngradeToFreePayload = UpdateBillingSubscriptionPlanResponse | VoidMutationError;

/**
 * A draft is either a channel-less content item draft or a channel-specific post
 * in draft status. The two have different shapes, so they stay distinct types in
 * one ordered list.
 */
export type Draft = ContentItem | Post;

/**
 * A content draft that is not attached to any channel yet. Because no channel
 * is selected, no network-specific rules apply, including media type
 * restrictions.
 */
export type DraftContent = {
  __typename?: 'DraftContent';
  /** True when the draft content was written with the help of AI. */
  aiAssisted: Scalars['Boolean']['output'];
  /** Images, videos, or documents attached to the draft, in display order. */
  assets: Array<Asset>;
  /** Unique identifier for this draft. */
  id: Scalars['DraftContentId']['output'];
  /** The written content of the draft. Empty when the draft holds only assets. */
  text: Scalars['String']['output'];
};

/** A channel-less draft to save on a content item. */
export type DraftContentInput = {
  /** Set to true when the draft content was written with the help of AI. */
  aiAssisted?: Scalars['Boolean']['input'];
  /** Images, videos, or documents to attach to the draft, in display order. */
  assets?: Array<AssetInput>;
  /**
   * The written content of the draft. Can be empty when the draft holds at
   * least one asset.
   */
  text: Scalars['String']['input'];
};

/** An edge in a draft connection. */
export type DraftEdge = {
  __typename?: 'DraftEdge';
  /** A cursor for pagination. */
  cursor: Scalars['String']['output'];
  /**
   * The content date for this draft: `targetDate` for a content item, `dueAt`
   * for a post. Null when the draft has no date. Read this to group by day
   * without knowing which type the node is.
   */
  date?: Maybe<Scalars['DateTime']['output']>;
  /** The draft node at the end of the edge. */
  node: Draft;
};

/** Field to sort drafts by. */
export enum DraftSortableKey {
  /** The date the draft was created. */
  CreatedAt = 'createdAt',
  /** The content date: `targetDate` on content items, `dueAt` on posts. */
  Date = 'date'
}

/**
 * Filter for a draft's channel. `channelIds` and `includeChannellessDrafts` can
 * be combined — e.g. channel-less drafts alongside drafts on specific channels.
 */
export type DraftsChannelFilter = {
  /**
   * Only return posts on these channels. Content item drafts have no channel,
   * so this excludes them by default — see `includeChannellessDrafts` to
   * include them alongside the channel match. Leave empty to match no specific
   * channel, e.g. to return only channel-less drafts with
   * `includeChannellessDrafts`.
   */
  channelIds: Array<Scalars['ChannelId']['input']>;
  /**
   * Include channel-less content item drafts alongside a `channelIds` match.
   * Has no effect when this whole filter is omitted, since content item
   * drafts are already included in that case. With `channelIds` empty, this
   * flag decides between returning nothing and returning channel-less drafts
   * only.
   */
  includeChannellessDrafts?: Scalars['Boolean']['input'];
};

/** A paginated connection of drafts. */
export type DraftsConnection = {
  __typename?: 'DraftsConnection';
  /** The list of draft edges. */
  edges: Array<DraftEdge>;
  /** Pagination information for the connection. */
  pageInfo: PaginationPageInfo;
  /**
   * The number of drafts matching the filter. The posts in this count stop at
   * 2000, so an organization with more draft posts than that reports 2000 for
   * them. Read it as a lower bound once it reaches 2000.
   */
  totalCount: Scalars['Int']['output'];
};

/** Filter for a draft's content date. Provide exactly one field. */
export type DraftsDateFilter =
  /** Only return drafts by whether a content date is set. */
  { presence: DateTimePresence; range?: never; }
  |  /**
   * Only return drafts whose content date falls within this range. A range with
   * no bounds returns every draft that has a content date.
   */
  { presence?: never; range: DateTimeComparator; };

/** Filters for listing drafts. Omitted fields do not filter. */
export type DraftsFilter = {
  /**
   * Only return drafts matching this channel filter. Omitted, every channel's
   * drafts are returned, alongside channel-less content item drafts. Takes
   * priority over `channelIds`/`includeChannellessDrafts` when both are sent.
   */
  channel?: InputMaybe<DraftsChannelFilter>;
  /**
   * Only return posts on these channels. Content item drafts have no channel,
   * so this excludes them by default — see `includeChannellessDrafts` to
   * include them alongside the channel match.
   * @deprecated Use 'channel' field with DraftsChannelFilter instead
   */
  channelIds?: InputMaybe<Array<Scalars['ChannelId']['input']>>;
  /** Only return drafts matching this content date filter. */
  date?: InputMaybe<DraftsDateFilter>;
  /**
   * Include channel-less content item drafts alongside a `channelIds` match.
   * Has no effect when `channelIds` is omitted, since content item drafts are
   * already included in that case.
   * @deprecated Use 'channel' field with DraftsChannelFilter instead
   */
  includeChannellessDrafts?: Scalars['Boolean']['input'];
  /**
   * Only return posts in these statuses. Omitted, the query returns draft posts
   * and excludes posts that await approval; name `needs_approval` to include
   * those. A content item holds no posts, so content items are returned only
   * when this field is omitted or names `draft`. An empty list matches no post
   * at all, so omit this field rather than sending an empty one.
   */
  status?: InputMaybe<Array<PostStatus>>;
  /**
   * Only return drafts carrying one of these tags, or, with `isEmpty`, drafts
   * with no tags at all.
   */
  tags?: InputMaybe<TagComparator>;
};

/** Input for listing an organization's drafts. */
export type DraftsInput = {
  /**
   * Filters to apply. When omitted, all of the organization's drafts are
   * returned.
   */
  filter?: InputMaybe<DraftsFilter>;
  /**
   * Organization to list drafts for. The caller must be a member of this
   * organization.
   */
  organizationId: Scalars['OrganizationId']['input'];
  /**
   * Sorting to apply, each entry breaking ties in the one before it. Defaults to
   * newest first. A pagination cursor is only valid for the sort that produced
   * it, so reset `after` to null whenever the sort changes.
   */
  sort?: InputMaybe<Array<DraftsSortInput>>;
};

/** One sorting criterion for the drafts query. List several to break ties. */
export type DraftsSortInput = {
  /** The direction to sort by. */
  direction: SortDirection;
  /** The field to sort by. */
  field: DraftSortableKey;
};

/** Drop post's request input. */
export type DropPostInput = {
  /** New dueAt date */
  dueAt: Scalars['DateTime']['input'];
  /** ID of post to update */
  id: Scalars['PostId']['input'];
  /** By default true so it would pin to slot. */
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Drop post's request response payload. */
export type DropPostPayload = NotFoundError | PostActionSuccess | RestProxyError | UnauthorizedError | UnexpectedError;

/** Error returned when a unique constraint is violated */
export type DuplicateError = MutationError & {
  __typename?: 'DuplicateError';
  /** Error message */
  message: Scalars['String']['output'];
};

/** Caps the duration of a time-based media property. */
export type DurationRule = ValidationRule & {
  __typename?: 'DurationRule';
  /** Maximum allowed duration in seconds. */
  maxDurationSeconds: Scalars['Int']['output'];
  /** The content property this rule constrains. */
  property: ContentProperty;
};

export type EditEntityNoteInput = {
  entityId: Scalars['String']['input'];
  entityType: EntityWithNotes;
  noteId: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type EditEntityNotePayload = CoreWebAppCommonError | EditEntityNoteResponse;

export type EditEntityNoteResponse = {
  __typename?: 'EditEntityNoteResponse';
  entityId: Scalars['String']['output'];
  entityType: EntityWithNotes;
  noteId: Scalars['String']['output'];
};

/**
 * Edit post's request input.
 *
 * Note: `metadata.{service}.linkAttachment` is mutually exclusive with a non-empty `assets`
 * array. Input providing both is rejected.
 */
export type EditPostInput = {
  /** If this post was edited with the help of AI */
  aiAssisted?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Change the post's approval state alongside this edit. Leave unset to keep the
   * post's current approval state.
   *
   * Only valid when your posting policy on the post's channel requires approval,
   * and only on your own drafts. Asking for the state the post is already in does
   * nothing.
   */
  approvalChange?: InputMaybe<PostApprovalChange>;
  /**
   * Ordered list of assets on this post. Omit to preserve the existing list,
   * pass an empty array to clear it
   */
  assets?: InputMaybe<Array<AssetInput>>;
  /** Is set when the Post is generated from a Draft */
  draftId?: InputMaybe<Scalars['DraftId']['input']>;
  /** Date when the post is scheduled to be published */
  dueAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** ID of the post to edit */
  id: Scalars['PostId']['input'];
  /** Is set when the Post is generated from an Idea */
  ideaId?: InputMaybe<Scalars['IdeaId']['input']>;
  /** Metadata of the post which differs based on the social network/service */
  metadata?: InputMaybe<PostInputMetaData>;
  /**
   * How the post is being scheduled. Omit the field or pass null to make no
   * scheduling change — null does not clear or reset the schedule: a scheduled post
   * keeps its current share mode, queue slot, and any custom time, and the edit
   * applies only the other provided fields. Pass a non-null ShareMode to apply that
   * mode.
   */
  mode?: InputMaybe<ShareMode>;
  /**
   * If true, saves the post as a draft instead of keeping it scheduled.
   * When saving as draft:
   * - Post status will be 'draft' instead of 'buffer'
   * - The post will not be published until explicitly scheduled
   */
  saveToDraft?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Scheduling type to indicate notification publishing or automatic publishing.
   *
   * Omit it, or send null, to leave the post publishing the way it already does.
   */
  schedulingType?: InputMaybe<SchedulingType>;
  /** source where the composer was initiated from, used for tracking. */
  source?: InputMaybe<Scalars['String']['input']>;
  /** tags */
  tagIds?: InputMaybe<Array<Scalars['TagId']['input']>>;
  /**
   * Text content of the Post. Omit the field to keep the current text; pass an
   * empty string or null to clear it.
   *
   * Note: for threaded posts, this needs to match the first item in the `thread` array.
   */
  text?: InputMaybe<Scalars['String']['input']>;
};

/** Edit recurrence on a post that already has recurrence */
export type EditPostRecurrenceInput = {
  /** Updated cadence configuration */
  cadence?: InputMaybe<PostRecurrenceCadenceInput>;
  /** Post ID to edit recurrence on */
  id: Scalars['PostId']['input'];
  /**
   * Updated maximum number of recurring posts
   * @deprecated Use recurrentPostsLeft instead
   */
  maxRecurrentPosts?: InputMaybe<Scalars['Int']['input']>;
  /** Updated number of remaining re-posts in this recurrence series */
  recurrentPostsLeft?: InputMaybe<Scalars['Int']['input']>;
};

/** Result of editing recurrence on a post. */
export type EditPostRecurrencePayload = PostActionSuccess | VoidMutationError;

/** Error when email is already a member of the organization */
export type EmailAlreadyMemberError = MutationError & {
  __typename?: 'EmailAlreadyMemberError';
  /** Human-readable error message. */
  message: Scalars['String']['output'];
};

/** A user's email notification preference for a specific topic. */
export type EmailNotificationPreference = {
  __typename?: 'EmailNotificationPreference';
  /** Identifier of the associated Customer.io topic. */
  cioTopicId?: Maybe<Scalars['String']['output']>;
  /** Human-readable description of the notification preference. */
  description: Scalars['String']['output'];
  /** Unique identifier for the email notification preference. */
  id: Scalars['String']['output'];
  /** Display name of the notification preference. */
  name: Scalars['String']['output'];
  /** Whether the user is subscribed to this notification preference. */
  subscribed: Scalars['Boolean']['output'];
};

/** Returned when email notification preferences cannot be fetched or updated. */
export type EmailNotificationPreferenceError = {
  __typename?: 'EmailNotificationPreferenceError';
  /** Human-readable error message. */
  message: Scalars['String']['output'];
};

/** Input for updating an email notification preference. */
export type EmailNotificationPreferenceInput = {
  /** Unique identifier for the email notification preference. */
  id: Scalars['String']['input'];
  /** Whether the user is subscribed to this notification preference. */
  subscribed: Scalars['Boolean']['input'];
};

/** Result of fetching or updating email notification preferences. */
export type EmailNotificationPreferencePayload = EmailNotificationPreferenceError | EmailNotificationPreferencesResponse;

/** Successful response containing the user's email notification preferences. */
export type EmailNotificationPreferencesResponse = {
  __typename?: 'EmailNotificationPreferencesResponse';
  /** The user's email notification preferences. */
  preferences: Array<EmailNotificationPreference>;
};

/**
 * Empty mutation success response used when client doesn't need any data back
 * or simply needs to respond to a success or error.
 */
export type EmptySuccess = MutationSuccess & {
  __typename?: 'EmptySuccess';
  /**
   * The value is always an empty string ''
   * Note: GraphQL doesn't allow types with no fields, so we have to add this field
   */
  _empty: Scalars['String']['output'];
};

/**
 * Shared fields across all engagement types.
 * Both `Mention` and `Comment` implement this interface.
 * Use `__typename` or the inline fragments to branch on the concrete type.
 */
export type Engagement = {
  /** Media attached to the engagement (images, videos, …). */
  assets: Array<Asset>;
  /** Author of this engagement item. */
  author: EngagementAuthor;
  /** Channel (Buffer-managed social account) this engagement was received on. */
  channelId: Scalars['ChannelId']['output'];
  /** Content format of this engagement item. */
  contentType: EngagementContentType;
  /** When this engagement was first ingested into Buffer. */
  createdAt: Scalars['DateTime']['output'];
  /** When the user dismissed this engagement. */
  dismissedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier of this engagement item. */
  id: Scalars['EngagementId']['output'];
  /** `true` when this engagement was sent by the user via Buffer or natively; `false` when it's a third-party item. */
  isOwnEngagement: Scalars['Boolean']['output'];
  /** Organization this engagement belongs to. */
  organizationId: Scalars['OrganizationId']['output'];
  /**
   * We set this value in replies to comments or mentions as the id of the
   * replied item. For top-level comments or mentions will be null.
   */
  parentId?: Maybe<Scalars['EngagementId']['output']>;
  /** It contains the channel's URL if the engagement doesn't provide any */
  publicUrl: Scalars['String']['output'];
  /** When the engagement was published on the network. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Publishing status. Set only on Buffer-sent engagements. */
  publishingStatus?: Maybe<PublishingStatus>;
  /** Reactions received on this engagement item. */
  reactions: Array<Reaction>;
  /** When the user replied to this engagement. */
  repliedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Time between the engagement being published on the network and the user replying. Always populated, by default 0. */
  responseTimeDiffInSeconds: Scalars['Int']['output'];
  /** Network this engagement lives on (instagram, facebook, twitter, …). */
  serviceType: Service;
  /** Current lifecycle status of the engagement. */
  status: EngagementStatus;
  /** AI-generated quick replies. Null on own engagements and on third-party engagements where suggestions haven't been generated yet. */
  suggestions: Array<Suggestion>;
  /** Text body of the engagement. Null for media-only items. */
  text?: Maybe<Scalars['String']['output']>;
  /** Last time the engagement was updated (re-ingestion, status change, etc.). */
  updatedAt: Scalars['DateTime']['output'];
};

/** Author of an engagement item (comment, mention, or reply). */
export type EngagementAuthor = {
  __typename?: 'EngagementAuthor';
  /** URL to the author's profile picture. Falls back to a generated avatar when unavailable. */
  avatar: Scalars['String']['output'];
  /** Letter-based avatar settings used when no real avatar is available. */
  letterAvatar?: Maybe<DefaultAvatarSettings>;
  /** Display name of the author. May be absent for anonymous or deleted accounts. */
  name?: Maybe<Scalars['String']['output']>;
  /** Network handle / username of the author (e.g. @handle on Twitter). */
  username: Scalars['String']['output'];
};

/**
 * One direction of a conversation. Same edges + pageInfo shape as the inbox
 * connection, so clients can reuse the same pagination components.
 */
export type EngagementConnection = {
  __typename?: 'EngagementConnection';
  /** List of engagement edges for the current page. */
  edges: Array<EngagementEdge>;
  /** Pagination metadata (hasNextPage, endCursor, …). */
  pageInfo: PaginationPageInfo;
};

/** Content format of an engagement item (text, image, video, …). */
export enum EngagementContentType {
  /** An audio file or voice message. */
  Audio = 'audio',
  /** A multi-image or mixed-media carousel. */
  Carousel = 'carousel',
  /** A document (e.g. a PDF carousel). */
  Document = 'document',
  /** An animated GIF. */
  Gif = 'gif',
  /** A single image. */
  Image = 'image',
  /** Text-only content with no media. */
  Text = 'text',
  /** Format could not be determined. */
  Unknown = 'unknown',
  /** A video. */
  Video = 'video'
}

/** Input for the engagementConversationById query. */
export type EngagementConversationByIdInput = {
  /** The engagement to fetch the conversation for. */
  engagementId: Scalars['EngagementId']['input'];
  /** Which engagement kind to return context for. Only mention is supported at M1. */
  engagementType: EngagementType;
};

/**
 * Conversation response for a single engagement. Carries the root post plus two
 * independent connections so a single call returns context on both sides.
 */
export type EngagementConversationByIdResponse = {
  __typename?: 'EngagementConversationByIdResponse';
  /**
   * Items preceding the engagement — earlier replies and surrounding context
   * linked via parentId. Defaults to the 20 nearest ancestors; after paginates
   * further back toward older items.
   */
  ancestors: EngagementConnection;
  /**
   * Items following the engagement — own reply and any third-party items the
   * network exposes, newest first. Defaults to the 20 nearest descendants.
   */
  descendants: EngagementConnection;
  /** The engagement the conversation was requested for */
  engagement: Engagement;
  /** Root of the thread (Post or Mention). Null when not found. */
  post?: Maybe<EngagementConversationPost>;
};


/**
 * Conversation response for a single engagement. Carries the root post plus two
 * independent connections so a single call returns context on both sides.
 */
export type EngagementConversationByIdResponseAncestorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Conversation response for a single engagement. Carries the root post plus two
 * independent connections so a single call returns context on both sides.
 */
export type EngagementConversationByIdResponseDescendantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ownershipScope?: InputMaybe<OwnershipScope>;
};

/**
 * Root of a mention thread — a Post (when the mention lives under a social post)
 * or a Mention (when the root item is itself a mention).
 * For commments, the root are only Posts. For a mention, the roots will be always mentions themselves.
 */
export type EngagementConversationPost = Mention | Post;

/**
 * Latest thread context for one engagement. Capped at 20 items per direction.
 * For paginated single-engagement access use `engagementConversationById`.
 */
export type EngagementConversationResults = {
  __typename?: 'EngagementConversationResults';
  /**
   * Up to 20 most recent context items (preceding the engagement), newest first.
   * Always returned in full — never ownership-filtered.
   */
  ancestors: Array<Engagement>;
  /**
   * Up to 20 most recent reply items (following the engagement), newest first.
   * `ownershipScope` restricts items by authorship and applies uniformly to
   * every conversation in the batch response; defaults to `own`.
   */
  descendants: Array<Engagement>;
  /** The engagement these context items belong to. */
  engagementId: Scalars['EngagementId']['output'];
  /** Root of the thread (`Post` / `Mention (mentionTYpe: post)`). */
  post?: Maybe<EngagementConversationPost>;
};


/**
 * Latest thread context for one engagement. Capped at 20 items per direction.
 * For paginated single-engagement access use `engagementConversationById`.
 */
export type EngagementConversationResultsDescendantsArgs = {
  ownershipScope?: InputMaybe<OwnershipScope>;
};

/** Input for the engagementConversations batch query. */
export type EngagementConversationsInput = {
  /** IDs of the engagements to fetch conversation context for. */
  engagementIds: Array<Scalars['EngagementId']['input']>;
  /** Which engagement kind to return context for. Only `mention` is supported at M1. */
  engagementType: EngagementType;
  /**
   * Deprecated and ignored. Pass `ownershipScope` on the `descendants` field instead.
   * @deprecated Ignored. Pass ownershipScope as an argument on the descendants field instead.
   */
  ownershipScope?: InputMaybe<OwnershipScope>;
};

/**
 * Batch threads query response — one entry per requested `engagementId`,
 * in the same order as the input.
 */
export type EngagementConversationsResponse = {
  __typename?: 'EngagementConversationsResponse';
  /** One conversation bucket per requested engagementId, in input order. */
  conversations: Array<EngagementConversationResults>;
};

/**
 * One count entry per channel, for a fixed (engagementType, status) scoped by the
 * input filters.
 */
export type EngagementCountByChannel = {
  __typename?: 'EngagementCountByChannel';
  /** The channel these counts belong to. */
  channelId: Scalars['ChannelId']['output'];
  /** The count of engagements that satisfy the filters, capped at the applied limit. */
  count: Scalars['Int']['output'];
  /**
   * The per-channel cap the BE finally applied. When `count` reaches this value the
   * result is truncated and the client should treat the count as "at least".
   */
  limit: Scalars['Int']['output'];
};

/** Input for the engagementCountsByChannelIds query. */
export type EngagementCountsByChannelIdsInput = {
  /**
   * One or more channel IDs to scope the counts to. If not provided, the query
   * returns counts for all the channels in the organization where the user has
   * enough permissions.
   */
  channelIds?: InputMaybe<Array<Scalars['ChannelId']['input']>>;
  /**
   * Which engagement kind to count. Required. Only `mention` is supported today —
   * passing `comment` returns an error (use `commentsCounts` until comments
   * migrate to the Engagement API).
   */
  engagementType: EngagementType;
  /** Optional filters to narrow down the counts. */
  filters?: InputMaybe<EngagementCountsFilters>;
  /**
   * Optional cap on the per-channel count. If not provided, a default cap is
   * applied. The cap finally applied is echoed back on each `EngagementCountByChannel`.
   */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Organization whose counts to query. */
  organizationId: Scalars['OrganizationId']['input'];
};

/** Response for the engagementCountsByChannelIds query. */
export type EngagementCountsByChannelIdsResponse = {
  __typename?: 'EngagementCountsByChannelIdsResponse';
  /** One entry per channel the user can access within the requested scope. */
  counts: Array<EngagementCountByChannel>;
};

/** Optional refinements shared across the engagement counts queries. */
export type EngagementCountsFilters = {
  /** Filter by the timestamp on the third-party network. */
  publishedAt?: InputMaybe<DateTimeComparator>;
  /**
   * Restrict counts to a single lifecycle status (unreplied / replied / replying /
   * dismissed). Pass `unreplied` for the unanswered-engagement count.
   */
  status?: InputMaybe<EngagementStatus>;
};

/**
 * A single edge shared by the engagementConversationById ancestor and descendant
 * connections.
 */
export type EngagementEdge = {
  __typename?: 'EngagementEdge';
  /** Opaque cursor for this edge. */
  cursor: Scalars['String']['output'];
  /** The engagement item. */
  node: Engagement;
};

/** Optional filter set applied when querying engagement items. */
export type EngagementFilters = {
  /** Filter by the timestamp on the third-party network. */
  publishedAt?: InputMaybe<DateTimeRange>;
  /** Restrict results to a single lifecycle status (unreplied / replied / replying / dismissed). */
  status?: InputMaybe<EngagementStatus>;
};

/** Paginated result set for the engagementInboxByChannelIds query. */
export type EngagementInboxByChannelIdsConnection = {
  __typename?: 'EngagementInboxByChannelIdsConnection';
  /** List of engagement edges for the current page. */
  edges: Array<EngagementInboxByChannelIdsEdge>;
  /** Pagination metadata (hasNextPage, endCursor, …). */
  pageInfo: PaginationPageInfo;
};

/** A single edge in the engagementInboxByChannelIds connection. */
export type EngagementInboxByChannelIdsEdge = {
  __typename?: 'EngagementInboxByChannelIdsEdge';
  /** Opaque cursor for this edge, used in `after` for the next page. */
  cursor: Scalars['String']['output'];
  /** The engagement item. */
  node: Engagement;
};

/** Input for the engagement inbox query. */
export type EngagementInboxByChannelIdsInput = {
  /**
   * One or more channel IDs to scope the inbox to. If not provided,
   * the query will return the engagements for all the channels for the
   * organization where the user has enough permissions.
   */
  channelIds?: InputMaybe<Array<Scalars['ChannelId']['input']>>;
  /** Which engagement kind to return (comment OR mention). Required — one inbox call returns one kind. */
  engagementType: EngagementType;
  /** Optional filters to narrow down results. */
  filters?: InputMaybe<EngagementFilters>;
  /** Organization whose inbox to query. */
  organizationId: Scalars['OrganizationId']['input'];
  /** Optional sort order. Defaults to descending `publishedAt` when omitted. */
  sort?: InputMaybe<Array<EngagementSortInput>>;
};

/**
 * Network-specific engagement metadata. Single-member union for now; grows
 * additively as more networks contribute their own shape.
 */
export type EngagementMetadata = GoogleBusinessEngagementMetadata;

/** Sorting strategies for engagement items. */
export enum EngagementSortField {
  /** Sort by the timestamp the item was published on the third-party network. */
  PublishedAt = 'publishedAt',
  /** Sort by lifecycle status (unreplied, replied, replying, dismissed). */
  Status = 'status'
}

/** Sorting criterion for an engagement list. */
export type EngagementSortInput = {
  /** Ascending or descending order. */
  direction: SortDirection;
  /** Field to sort by. */
  field: EngagementSortField;
};

/** Lifecycle status of an engagement from the user's perspective. */
export enum EngagementStatus {
  /** The engagement was dismissed without a reply. */
  Dismissed = 'dismissed',
  /** A reply has been sent by the user. */
  Replied = 'replied',
  /** A reply is currently being composed or is in-flight. */
  Replying = 'replying',
  /** No reply has been sent yet. */
  Unreplied = 'unreplied'
}

/**
 * A supported reaction. `reactionType` is the opaque identity echoed back on the
 * react mutation; `visual` carries everything needed to render it.
 */
export type EngagementSupportedReaction = {
  __typename?: 'EngagementSupportedReaction';
  /**
   * The kind of reaction a user can apply (e.g. like, love, celebrate). This is
   * the identifier the client sends back to the react mutation when the user picks
   * this reaction; treat it as an opaque value rather than parsing it.
   */
  reactionType: ReactionType;
  /** How to render this reaction (built-in icon or network image). */
  visual: ReactionVisual;
};

/** Discriminator used in inputs/filters to scope a query to specific types. */
export enum EngagementType {
  /** Fetch comments (direct replies to Buffer-managed posts). */
  Comment = 'comment',
  /** Fetch mentions (references to the account across the network). */
  Mention = 'mention'
}

/**
 * Per-engagement-type configuration. One entry per kind; `engagementType`
 * discriminates. Adding a kind is additive — a new `EngagementType` value, not a
 * new type.
 */
export type EngagementTypeConfiguration = {
  __typename?: 'EngagementTypeConfiguration';
  /** The kind of engagement this entry configures (comment / mention). */
  engagementType: EngagementType;
  /**
   * Media configuration. Always present; `supportsMedia: false` = the platform
   * doesn't deliver attached media to Buffer, so none can be shown.
   */
  media: MediaConfiguration;
  /**
   * Optional network-specific engagement metadata (e.g. Google Business).
   * null when none applies.
   */
  metadata?: Maybe<EngagementMetadata>;
  /**
   * Reactions. Always present; empty `supportedReactions` = reacting via Buffer
   * isn't supported.
   */
  reactions: ReactionsConfiguration;
  /**
   * Reply configuration. Always present; `supportsReplying: false` = replying via
   * Buffer not supported.
   */
  replying: ReplyingConfiguration;
  /** AI features supported for this engagement type. Empty when none. */
  supportedAiFeatures: Array<AiFeature>;
  /** Sync configuration — realTime/polling mechanism plus optional forced-sync detail. */
  syncData: SyncDataConfiguration;
};

/** Selects the organization to enroll in the referral program. */
export type EnrollInReferralProgramInput = {
  /** Organization the authenticated account must be allowed to administer. */
  organizationId: Scalars['OrganizationId']['input'];
};

/** Outcomes of an explicit referral-program enrollment attempt. */
export type EnrollInReferralProgramPayload = EnrollInReferralProgramSuccess | EnrollInReferralProgramUnavailableError;

/** Successful enrollment carrying the same state returned by status reads. */
export type EnrollInReferralProgramSuccess = {
  __typename?: 'EnrollInReferralProgramSuccess';
  /** Enrolled participant's customer-visible state. */
  referralProgram: ReferralProgramEnrolled;
};

/** Returned when the referral program is not accepting new enrollments. */
export type EnrollInReferralProgramUnavailableError = MutationError & {
  __typename?: 'EnrollInReferralProgramUnavailableError';
  /** Generic customer-safe explanation of the unavailable state. */
  message: Scalars['String']['output'];
};

/** Representation of a feature that a user has access to. */
export enum Entitlement {
  Analytics = 'analytics',
  AnalyticsOnPosts = 'analyticsOnPosts',
  ApprovalFlow = 'approvalFlow',
  Base = 'base',
  Bluesky = 'bluesky',
  Calendar = 'calendar',
  Campaigns = 'campaigns',
  ChannelCapabilities = 'channelCapabilities',
  ChannelGroupsInComposer = 'channelGroupsInComposer',
  ChannelSearchBar = 'channelSearchBar',
  CollaborationNotes = 'collaborationNotes',
  Content = 'content',
  CustomBitly = 'customBitly',
  CustomVideoThumbnailInstagram = 'customVideoThumbnailInstagram',
  CustomizeUtmParam = 'customizeUTMParam',
  Drafts = 'drafts',
  Engagement = 'engagement',
  ExportInsights = 'exportInsights',
  Feeds = 'feeds',
  FinishLater = 'finishLater',
  FirstComment = 'firstComment',
  FirstCommentLinkedin = 'firstCommentLinkedin',
  HashtagManager = 'hashtagManager',
  InstagramPersonalProfile = 'instagramPersonalProfile',
  Mastodon = 'mastodon',
  MobileOverview = 'mobileOverview',
  Notes = 'notes',
  OfflinePosts = 'offlinePosts',
  Pinterest = 'pinterest',
  PostGroups = 'postGroups',
  PostTemplates = 'postTemplates',
  Publishing = 'publishing',
  SavedViews = 'savedViews',
  SentPosts30Days = 'sentPosts30Days',
  ShareNext = 'shareNext',
  ShopGrid = 'shopGrid',
  Snippets = 'snippets',
  StartPage = 'startPage',
  Stories = 'stories',
  TagUsersInImages = 'tagUsersInImages',
  Tags = 'tags',
  TeamsPanel = 'teamsPanel',
  Threads = 'threads',
  Tiktok = 'tiktok',
  TwitterImpressions = 'twitterImpressions',
  TwitterLongContent = 'twitterLongContent',
  UnlimitedUploads = 'unlimitedUploads',
  ViewInsights = 'viewInsights',
  Youtube = 'youtube'
}

export enum EntityWithNotes {
  Idea = 'idea',
  Post = 'post'
}

/** Basic mutation error */
export type Error = {
  __typename?: 'Error';
  /** A raw error message to help developpers understand the root cause of the issue. */
  cause: Scalars['String']['output'];
};

/** `property` cannot be combined with any of `conflictsWith`. */
export type ExclusiveRule = ValidationRule & {
  __typename?: 'ExclusiveRule';
  /** Properties that `property` cannot be combined with. */
  conflictsWith: Array<ContentProperty>;
  /** The content property this rule constrains. */
  property: ContentProperty;
};

/** Input for the executeFreeToolContent mutation. */
export type ExecuteFreeToolContentInput = {
  /** Input for the AI hashtag generator tool. */
  aiHashtagGenerator?: InputMaybe<FreeToolAiHashtagGeneratorInput>;
  /** Input for the blog to social media post repurposer tool. */
  blogToSocialMediaPostRepurposer?: InputMaybe<FreeToolBlogToSocialMediaPostRepurposerInput>;
  /** Input for the hook generator tool. */
  hookGenerator?: InputMaybe<FreeToolHookGeneratorInput>;
  /** Input for the Instagram bio generator tool. */
  instagramBioGenerator?: InputMaybe<FreeToolInstagramBioGeneratorInput>;
  /** Input for the Instagram name generator tool. */
  instagramNameGenerator?: InputMaybe<FreeToolInstagramNameGeneratorInput>;
  /** Input for the LinkedIn headline generator tool. */
  linkedInHeadlineGenerator?: InputMaybe<FreeToolLinkedInHeadlineGeneratorInput>;
  /** Optional marketing tracking ID for rate limiting and analytics. */
  marketingId?: InputMaybe<Scalars['String']['input']>;
  /** Input for the Substack to social media post repurposer tool. */
  substackToSocialMediaPostRepurposer?: InputMaybe<FreeToolSubstackToSocialMediaPostRepurposerInput>;
  /** The tool template to execute. */
  template: FreeToolTemplate;
  /** Input for the TikTok username generator tool. */
  tiktokUsernameGenerator?: InputMaybe<FreeToolTiktokUsernameGeneratorInput>;
  /** Input for the username generator tool. */
  usernameGenerator?: InputMaybe<FreeToolUsernameGeneratorInput>;
  /** Input for the YouTube name generator tool. */
  youtubeNameGenerator?: InputMaybe<FreeToolYoutubeNameGeneratorInput>;
};

/** Result of executing a free tool content generation. */
export type ExecuteFreeToolContentPayload = ContentExtractionFailedError | ExecuteFreeToolContentSuccess | InvalidInputError | LimitReachedError;

/** Successful execution result with typed output. */
export type ExecuteFreeToolContentSuccess = {
  __typename?: 'ExecuteFreeToolContentSuccess';
  /** The typed output from the tool. */
  output: FreeToolOutput;
  /** The tool template that was executed. */
  template: FreeToolTemplate;
};

export enum ExternalServiceDomain {
  Analytics = 'analytics',
  Broadcasting = 'broadcasting',
  Engagement = 'engagement',
  Publish = 'publish'
}

export type FacebookEntity = {
  __typename?: 'FacebookEntity';
  content: Scalars['String']['output'];
  indices: Array<Scalars['Int']['output']>;
  text: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/** Facebook metadata */
export type FacebookMetadata = {
  __typename?: 'FacebookMetadata';
  /** Metadata about the location of the business associated with the channel. Only available for Facebook and GPB */
  locationData?: Maybe<LocationData>;
};

/** Facebook post metadata */
export type FacebookPostMetadata = CommonPostMetadata & {
  __typename?: 'FacebookPostMetadata';
  /** Annotations representing entities in the text */
  annotations: Array<Annotation>;
  /** Facebook post's first comment */
  firstComment?: Maybe<Scalars['String']['output']>;
  /** Link attachment */
  linkAttachment?: Maybe<LinkAttachment>;
  /** Title of Facebook reel */
  title?: Maybe<Scalars['String']['output']>;
  /** The channel-specific type of the post, eg, post, story, reel for Instagram */
  type: PostType;
};

/** Facebook post metadata */
export type FacebookPostMetadataInput = {
  /** Annotations representing entities in the text */
  annotations?: InputMaybe<Array<AnnotationInputFacebook>>;
  /** Facebook post's first comment */
  firstComment?: InputMaybe<Scalars['String']['input']>;
  /** Link attachment. Mutually exclusive with a non-empty `assets` array — input providing both is rejected. */
  linkAttachment?: InputMaybe<LinkAttachmentInput>;
  /** The channel-specific type of the post, eg, post, story, reel for Facebook */
  type: PostTypeFacebook;
};

/** Details about a failed subscription payment, surfaced when the subscription is past due. */
export type FailedPayment = {
  __typename?: 'FailedPayment';
  /**
   * A human-readable description of why the payment failed
   * (e.g. "Your card was declined", "Your card has insufficient funds").
   * Null if Stripe did not provide an error message.
   */
  reason?: Maybe<Scalars['String']['output']>;
  /**
   * A Stripe-hosted URL where the customer can update their payment method and
   * retry the failed payment. Expires 30 days after the invoice due date.
   * Null if the hosted invoice page is unavailable or expired.
   */
  retryUrl?: Maybe<Scalars['String']['output']>;
};

/**
 * A capability a channel can expose, spanning every domain. The shared key for
 * per-channel `authorizationStatus`. Grows additively.
 */
export enum Feature {
  Comment = 'comment',
  DirectMessage = 'directMessage',
  EngagementReaction = 'engagementReaction',
  Insights = 'insights',
  Mention = 'mention',
  Posting = 'posting'
}

/** Why a feature is currently blocked on a channel. */
export enum FeatureAccessDisabledReason {
  /**
   * The channel's token lacks the scope the feature requires. Re-evaluated on the
   * next OAuth connect/reconnect.
   */
  MissingScope = 'missingScope',
  /**
   * The platform revoked the permission at runtime. Self-heals on the next
   * successful collection.
   */
  PermissionRevoked = 'permissionRevoked'
}

/** The blocked state of a single feature on a channel. */
export type FeatureAccessState = {
  __typename?: 'FeatureAccessState';
  /** Why the feature is blocked. */
  reason: FeatureAccessDisabledReason;
  /**
   * Scopes that would re-enable the feature. Populated when reason is
   * missingScope; empty otherwise (e.g. permissionRevoked).
   */
  requiredScopes: Array<Scalars['String']['output']>;
  /** When the feature first entered this blocked state. */
  since: Scalars['DateTime']['output'];
};

export enum FeatureAction {
  ExpandText = 'expandText',
  GenerateAltText = 'generateAltText',
  GenerateIdeas = 'generateIdeas',
  GenerateSuggestions = 'generateSuggestions',
  GenerateText = 'generateText',
  RephraseText = 'rephraseText',
  SummarizeText = 'summarizeText'
}

/**
 * Pairs a feature with the channel's authorization status for it (token/scope
 * level). One entry per authorization-gated feature the channel exposes.
 */
export type FeatureAuthorizationStatus = {
  __typename?: 'FeatureAuthorizationStatus';
  /**
   * The feature this status describes — a capability a channel can expose, e.g.
   * posting, commenting, mentions, insights, reacting to engagements (see the
   * `Feature` enum).
   */
  feature: Feature;
  /**
   * Why the feature is in its current `status`, when a specific cause is known
   * (e.g. the connected platform user lacks rights on the account that owns
   * webhook subscriptions). Informative text for display/support — not a stable
   * machine key, so clients must not parse or switch on it. Null when the
   * status needs no explanation (`ok`) or no specific cause was identified.
   */
  reason?: Maybe<Scalars['String']['output']>;
  /**
   * Whether the channel is currently authorized to use `feature`: `ok` (usable),
   * `needsRefresh` (token refresh required), `notEnoughData` (missing scopes /
   * webhook metadata), `needsUpgrade` (client below the minimum version —
   * applies only to the mobile apps), or `notEnoughRights` (the connected
   * platform user's role is insufficient — reconnecting cannot fix it). See the
   * `AuthorizationStatus` enum.
   */
  status: AuthorizationStatus;
};

export type FeatureFlip = {
  __typename?: 'FeatureFlip';
  id: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export enum FeaturePlatform {
  Android = 'android',
  Ios = 'ios',
  Mobile = 'mobile',
  Web = 'web'
}

/**
 * A feed is a collection of feed items owned by a single organization.
 * An example of a feed is a RSS feed.
 */
export type Feed = {
  __typename?: 'Feed';
  /**
   * The collection this feed belongs to. If null, this is a top level feed
   * and does not belong to any collections
   */
  collection?: Maybe<FeedCollection>;
  /** Metadata used to connect to the feed. */
  connectionMetadata: FeedConnectionMetadata;
  /**
   * The browsable view of the feed (when applicable), eg the youtube channel,
   * News category page, Blog, etc
   */
  homepage?: Maybe<Scalars['String']['output']>;
  /** The unique identifier for the feed. */
  id: Scalars['FeedId']['output'];
  /** The last time we refreshed the feed. */
  lastRefreshed: Scalars['DateTime']['output'];
  /** The name of the feed, typically defined by the feed itself. */
  name: Scalars['String']['output'];
  /** The organization that owns this feed. */
  organizationId: Scalars['OrganizationId']['output'];
  /** Float value for ordering among sibling feeds. */
  sortPosition: Scalars['Float']['output'];
  /** The type of content feed */
  type: ContentFeedType;
};

/** Successful response following an update to an RSS feed */
export type FeedActionSuccess = {
  __typename?: 'FeedActionSuccess';
  /** Feed on which the action was successfully performed. */
  feed: Feed;
};

/** A feed collection is a collection of feeds created by a single organization. */
export type FeedCollection = {
  __typename?: 'FeedCollection';
  /**
   * The feeds in the feed collection.
   * @deprecated Use Feed.collection instead to query feed associations
   */
  feeds: Array<Feed>;
  /** The unique identifier for the feed collection. */
  id: Scalars['FeedCollectionId']['output'];
  /** The name of the feed collection. */
  name: Scalars['String']['output'];
  /** The organization that owns the feed collection. */
  organizationId: Scalars['OrganizationId']['output'];
  /** Float value for ordering among feed collections at the same level. */
  sortPosition: Scalars['Float']['output'];
};

/** Successful response following an update to an RSS feed collection */
export type FeedCollectionActionSuccess = {
  __typename?: 'FeedCollectionActionSuccess';
  /** Feed Group on which the action was successfully performed. */
  feedCollection: FeedCollection;
};

/** Results for the feed collections query. */
export type FeedCollectionConnection = {
  __typename?: 'FeedCollectionConnection';
  /** The list of feed collections that match the query. */
  edges: Array<FeedCollectionEdge>;
  /** Information to aid in pagination. */
  pageInfo: PaginationPageInfo;
};

/** Successful response following a deletion of feed collections */
export type FeedCollectionDeleteSuccess = {
  __typename?: 'FeedCollectionDeleteSuccess';
  /** Feed Group ID which was deleted */
  feedCollectionId: Scalars['FeedCollectionId']['output'];
};

/** Represent a node in the pagination result using the Connect Relay convention. */
export type FeedCollectionEdge = {
  __typename?: 'FeedCollectionEdge';
  /** Opaque cursor to be used in pagination to fetch from current node. */
  cursor: Scalars['String']['output'];
  /** Represents the current feed collection in the list. */
  node: FeedCollection;
};

/** Query input to load a single feed collection */
export type FeedCollectionInput = {
  /** The feed collection ID */
  id: Scalars['FeedCollectionId']['input'];
  /** The organization ID to fetch the feed collection for */
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
};

/** Query input to load a list of feed collections */
export type FeedCollectionsInput = {
  /** The organization ID to fetch feed collections for */
  organizationId: Scalars['OrganizationId']['input'];
};

/** Error connecting to source feed - this is most often due to typos in RSS feeds */
export type FeedConnectionError = {
  __typename?: 'FeedConnectionError';
  /** The type of error that occured */
  error: FeedConnectionErrorType;
  /** Human readable error message */
  message: Scalars['String']['output'];
  /** Feed suggestions that the user is likely looking for */
  suggestions: Array<FeedConnectionSuggestion>;
};

/** Error type from connection attempt */
export enum FeedConnectionErrorType {
  /** Response from server was not valid atom/RSS */
  MalformedResponse = 'MalformedResponse',
  /** Server sent a 4** response, indicating the user is not allowed to access */
  NotAllowed = 'NotAllowed',
  /** The server took too long to respond */
  Timeout = 'Timeout',
  /** An uncategorized error occured */
  Unknown = 'Unknown'
}

/** Abstact union type representing RSS Feeds */
export type FeedConnectionMetadata = NewsSearchConnectionMetadata | RssFeedConnectionMetadata;

/** Feed data provided as a suggestion */
export type FeedConnectionSuggestion = {
  __typename?: 'FeedConnectionSuggestion';
  /** Metadata used to connect to the feed. */
  connectionMetadata: FeedConnectionMetadata;
  /**
   * The browsable view of the feed (when applicable), eg the youtube channel,
   * News category page, Blog, etc
   */
  homepage?: Maybe<Scalars['String']['output']>;
  /** The name of the feed, typically defined by the feed itself. */
  name: Scalars['String']['output'];
  /** The type of content feed */
  type: ContentFeedType;
};

/** Query input to load a single feed */
export type FeedInput = {
  /** The feed ID */
  id: Scalars['FeedId']['input'];
  /** The organization ID to fetch the feed for */
  organizationId: Scalars['OrganizationId']['input'];
};

/**
 * An individual feed item. Feed items are shared amongst all users.
 * An example of a feed item is a news article from an RSS feed.
 */
export type FeedItem = {
  __typename?: 'FeedItem';
  /** The URL for the feed item. */
  articleUrl: Scalars['String']['output'];
  /** The date the feed item was published. */
  contentTextPreview: Scalars['String']['output'];
  /** The date the feed item was created/published. */
  createdAt: Scalars['DateTime']['output'];
  /** The feed that the item belongs to. */
  feed: Feed;
  /** The unique identifier for the feed item. */
  id: Scalars['FeedItemId']['output'];
  /** The title of the feed item. */
  title: Scalars['String']['output'];
};

/** Results for the feed contents query. */
export type FeedItemConnection = {
  __typename?: 'FeedItemConnection';
  /** The list of feed items that match the query. */
  edges: Array<FeedItemEdge>;
  /** Information to aid in pagination. */
  pageInfo: PaginationPageInfo;
};

/** An edge in a connection. */
export type FeedItemEdge = {
  __typename?: 'FeedItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: FeedItem;
};

/** Query input to load feed items */
export type FeedItemsFiltersInput = {
  /** The feed collection ID. When set, it will return feed items for the given feed collection */
  feedCollectionIds?: InputMaybe<Array<Scalars['FeedCollectionId']['input']>>;
  /** The feed IDs. When set, it will return feed items for the given feeds. */
  feedIds?: InputMaybe<Array<Scalars['FeedId']['input']>>;
};

/** Input to fetch feed items */
export type FeedItemsInput = {
  /** The filters to apply to the feed items query */
  filter?: InputMaybe<FeedItemsFiltersInput>;
  /** The Organization id to fetch feed items for */
  organizationId: Scalars['OrganizationId']['input'];
};

/** All possible response types for feed move operations */
export type FeedMoveUpdatesPayload = FeedMoveUpdatesResponse | UnexpectedError;

/** Response containing updated feeds and collections after a move operation */
export type FeedMoveUpdatesResponse = {
  __typename?: 'FeedMoveUpdatesResponse';
  /** Feed collections that have updated due to move */
  updatedFeedCollections: Array<FeedCollection>;
  /** Feeds that have updated due to move */
  updatedFeeds: Array<Feed>;
};

/** Query input to load a list of feeds */
export type FeedsInput = {
  /** The organization ID to fetch feeds for */
  organizationId: Scalars['OrganizationId']['input'];
};

/** Caps the byte size of a media property. */
export type FileSizeRule = ValidationRule & {
  __typename?: 'FileSizeRule';
  /** Maximum allowed size in megabytes (MB). */
  maxMegabytes: Scalars['Int']['output'];
  /** The content property this rule constrains. */
  property: ContentProperty;
};

export type FilterBy = {
  by: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

/** How one flag narrows the conversations inbox. */
export enum FlagFilter {
  /** Only conversations WITHOUT the flag. */
  Excluded = 'excluded',
  /** Both. The flag does not narrow anything. */
  Included = 'included',
  /** Only conversations WITH the flag. */
  Only = 'only'
}

/** Input for forcing comments backfill for channels */
export type ForceCommentsBackfillForChannelInput = {
  /** The channel ids to force comments backfill for */
  channelIds: Array<Scalars['ChannelId']['input']>;
  /** The organization id that owns the channels */
  organizationId: Scalars['OrganizationId']['input'];
  /** Optional flag to indicate the user manually forced the backfilling */
  userForced?: InputMaybe<Scalars['Boolean']['input']>;
};

/** ForceCommentsBackfillForChannel possible responses */
export type ForceCommentsBackfillForChannelPayload = ForceCommentsBackfillForChannelSuccess | LimitReachedError | VoidMutationError;

/** Success response for forceCommentsBackfillForChannel mutation */
export type ForceCommentsBackfillForChannelSuccess = {
  __typename?: 'ForceCommentsBackfillForChannelSuccess';
  /** The channel ids that were force backfilled */
  channelIds: Array<Scalars['ChannelId']['output']>;
};

/**
 * Forced-sync detail. Present only when the kind's sync mechanism supports a
 * forced (manual) sync.
 */
export type ForcedSyncConfiguration = {
  __typename?: 'ForcedSyncConfiguration';
  /**
   * Rate limit for forced syncs. `null` when forced sync is unthrottled. Reuses
   * the `ForcedSyncRateLimit` type defined by the comment schema.
   */
  forcedSyncRateLimit?: Maybe<ForcedSyncRateLimit>;
  /** How often, in seconds, the channel is automatically polled for new items. */
  pollInterval: Scalars['Int']['output'];
};

/** Rate limit configuration for forced sync operations. */
export type ForcedSyncRateLimit = {
  __typename?: 'ForcedSyncRateLimit';
  /** Number of allowed forced backfill attempts within the period. */
  allowedAttempts: Scalars['Int']['output'];
  /** Rate limit period in seconds for forced backfill operations. */
  period: Scalars['Int']['output'];
};

/** Restricts a media property to specific formats (allow-list). */
export type FormatRule = ValidationRule & {
  __typename?: 'FormatRule';
  /** The formats `property` is allowed to use. */
  allowedFormats: Array<MediaFormat>;
  /** The content property this rule constrains. */
  property: ContentProperty;
};

/** A free tool with metadata and field definitions for dynamic form rendering. */
export type FreeTool = {
  __typename?: 'FreeTool';
  /** Description of what the tool does. */
  description: Scalars['String']['output'];
  /** FAQ items for the tool's landing page. */
  faq: Array<FreeToolFaqItem>;
  /** The tool's input fields for form rendering. */
  fields: Array<FreeToolField>;
  /** The tool's template key identifier. */
  id: Scalars['String']['output'];
  /** Human-readable name of the tool. */
  name: Scalars['String']['output'];
  /** Configuration version number. */
  version: Scalars['Int']['output'];
};

/** Number of hashtags to generate. */
export enum FreeToolAiHashtagGeneratorHashtagCount {
  Five = 'five',
  One = 'one',
  Ten = 'ten',
  Three = 'three'
}

/** Input fields for the AI hashtag generator. */
export type FreeToolAiHashtagGeneratorInput = {
  /** Optional number of hashtags to generate. */
  hashtagCount?: InputMaybe<FreeToolAiHashtagGeneratorHashtagCount>;
  /** Optional niche or industry to tailor hashtags to. */
  niche?: InputMaybe<Scalars['String']['input']>;
  /** The social media platform to tailor hashtags for. */
  platform: FreeToolAiHashtagGeneratorPlatform;
  /** The topic or post content to generate hashtags for. */
  topic: Scalars['String']['input'];
};

/** Output from the AI hashtag generator. */
export type FreeToolAiHashtagGeneratorOutput = {
  __typename?: 'FreeToolAiHashtagGeneratorOutput';
  /** All hashtags as a single space-joined string for one-click copy. */
  copyAll: Scalars['String']['output'];
  /** The generated hashtags as a flat list. */
  hashtags: Array<Scalars['String']['output']>;
};

/** Platform options for the AI hashtag generator. */
export enum FreeToolAiHashtagGeneratorPlatform {
  Facebook = 'facebook',
  Instagram = 'instagram',
  Linkedin = 'linkedin',
  Tiktok = 'tiktok',
  X = 'x',
  Youtube = 'youtube'
}

/** Target channel options for the blog to social media post repurposer. */
export enum FreeToolBlogToSocialMediaPostRepurposerChannel {
  Bluesky = 'bluesky',
  Facebook = 'facebook',
  Linkedin = 'linkedin',
  Mastodon = 'mastodon',
  Threads = 'threads',
  X = 'x'
}

/** Emoji toggle options for the blog to social media post repurposer. */
export enum FreeToolBlogToSocialMediaPostRepurposerEmoji {
  Off = 'off',
  On = 'on'
}

/** Hashtag toggle options for the blog to social media post repurposer. */
export enum FreeToolBlogToSocialMediaPostRepurposerHashtags {
  Off = 'off',
  On = 'on'
}

/** Input fields for the blog to social media post repurposer. */
export type FreeToolBlogToSocialMediaPostRepurposerInput = {
  /** The social media channel to generate posts for. */
  channel: FreeToolBlogToSocialMediaPostRepurposerChannel;
  /** The full text of the blog post or article to repurpose (fallback when URL extraction fails). */
  content?: InputMaybe<Scalars['String']['input']>;
  /** Whether to include emoji in the generated posts. */
  includeEmoji?: InputMaybe<FreeToolBlogToSocialMediaPostRepurposerEmoji>;
  /** Whether to include hashtags in the generated posts. */
  includeHashtags?: InputMaybe<FreeToolBlogToSocialMediaPostRepurposerHashtags>;
  /** The desired tone for the generated posts. */
  tone?: InputMaybe<FreeToolBlogToSocialMediaPostRepurposerTone>;
  /** The URL of the blog post or article to repurpose. */
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Output from the blog to social media post repurposer. */
export type FreeToolBlogToSocialMediaPostRepurposerOutput = {
  __typename?: 'FreeToolBlogToSocialMediaPostRepurposerOutput';
  /** The generated post variations. */
  posts: Array<FreeToolBlogToSocialMediaPostRepurposerPost>;
};

/** A single repurposed social media post variation. */
export type FreeToolBlogToSocialMediaPostRepurposerPost = {
  __typename?: 'FreeToolBlogToSocialMediaPostRepurposerPost';
  /** The angle used for this variation (hook-led, summary, or takeaway-led). */
  angle: Scalars['String']['output'];
  /** The character count of the generated post. */
  charCount: Scalars['Int']['output'];
  /** Whether the post is formatted as a thread (X only). */
  isThread: Scalars['Boolean']['output'];
  /** The character limit for the target channel. */
  limit: Scalars['Int']['output'];
  /** The generated post text. */
  text: Scalars['String']['output'];
  /** The individual thread parts if the post is a thread, empty array otherwise. */
  threadParts: Array<Scalars['String']['output']>;
};

/** Tone options for the blog to social media post repurposer. */
export enum FreeToolBlogToSocialMediaPostRepurposerTone {
  Bold = 'bold',
  Conversational = 'conversational',
  MatchSource = 'matchSource',
  Professional = 'professional',
  Punchy = 'punchy'
}

/** An edge in a free-tools connection. */
export type FreeToolEdge = {
  __typename?: 'FreeToolEdge';
  /** Opaque cursor. Pass back as `after` to fetch the next page. */
  cursor: Scalars['String']['output'];
  /** The free tool at this position in the page. */
  node: FreeTool;
};

/** A single FAQ item with question and answer. */
export type FreeToolFaqItem = {
  __typename?: 'FreeToolFAQItem';
  /** The FAQ answer. */
  answer: Scalars['String']['output'];
  /** The FAQ question. */
  question: Scalars['String']['output'];
};

/** A field in a free tool's input form. */
export type FreeToolField = {
  __typename?: 'FreeToolField';
  /** Helper text displayed below the input. */
  helperText?: Maybe<Scalars['String']['output']>;
  /** Human-readable label for display. */
  label: Scalars['String']['output'];
  /** The field name used as the input key. */
  name: Scalars['String']['output'];
  /** Available options for select, radio, or checkbox fields. */
  options: Array<FreeToolFieldOption>;
  /** Display order of the field. */
  order: Scalars['Int']['output'];
  /** Placeholder text for the input. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** Number of rows for textarea fields. */
  rows?: Maybe<Scalars['Int']['output']>;
  /** The type of form control to render. */
  type: FreeToolFieldType;
  /** Validation constraints for the field. */
  validation: FreeToolFieldValidation;
};

/** An option for select, radio, or checkbox fields. */
export type FreeToolFieldOption = {
  __typename?: 'FreeToolFieldOption';
  /** Optional description providing additional context. */
  description?: Maybe<Scalars['String']['output']>;
  /** Human-readable label for display. */
  label: Scalars['String']['output'];
  /** The option value submitted in the mutation input. */
  value: Scalars['String']['output'];
};

/** Field type for free tool form rendering. */
export enum FreeToolFieldType {
  Checkbox = 'checkbox',
  Radio = 'radio',
  Select = 'select',
  Text = 'text',
  Textarea = 'textarea',
  Url = 'url'
}

/** Validation constraints for a free tool field. */
export type FreeToolFieldValidation = {
  __typename?: 'FreeToolFieldValidation';
  /** Maximum character length for text fields. */
  maxLength?: Maybe<Scalars['Int']['output']>;
  /** Minimum character length for text fields. */
  minLength?: Maybe<Scalars['Int']['output']>;
  /** Whether the field is required. */
  required: Scalars['Boolean']['output'];
};

/** Input parameters for generating hashtags based on a post's content */
export type FreeToolHashtagGeneratorTemplateInput = {
  /** Content of a post to generate hashtags for */
  content: Scalars['String']['input'];
  /** The service to generate hashtags for. Defaults to instagram */
  service: Service;
};

/** A single hook suggestion from the hook generator. */
export type FreeToolHookGeneratorHook = {
  __typename?: 'FreeToolHookGeneratorHook';
  /** The generated hook text. */
  hook: Scalars['String']['output'];
  /** The hook pattern used (e.g. curiosity gap, contrarian). */
  pattern: Scalars['String']['output'];
  /** The full post expanding on the hook, if output type is fullPost. */
  post?: Maybe<Scalars['String']['output']>;
  /** A one-line explanation of why this hook works. */
  whyItWorks: Scalars['String']['output'];
};

/** Input fields for the hook generator. */
export type FreeToolHookGeneratorInput = {
  /** The hook style or pattern to use. */
  hookStyle: FreeToolHookGeneratorStyle;
  /** Whether to return hooks only or hooks with full posts. */
  outputType: FreeToolHookGeneratorOutputType;
  /** The social media platform to tailor hooks for. */
  platform: FreeToolHookGeneratorPlatform;
  /** The desired tone of the hooks. */
  tone: FreeToolHookGeneratorTone;
  /** The topic or idea to generate hooks for. */
  topic: Scalars['String']['input'];
};

/** Output from the hook generator. */
export type FreeToolHookGeneratorOutput = {
  __typename?: 'FreeToolHookGeneratorOutput';
  /** The generated hook suggestions. */
  hooks: Array<FreeToolHookGeneratorHook>;
};

/** Output type options for the hook generator. */
export enum FreeToolHookGeneratorOutputType {
  FullPost = 'fullPost',
  HooksOnly = 'hooksOnly'
}

/** Platform options for the hook generator. */
export enum FreeToolHookGeneratorPlatform {
  Instagram = 'instagram',
  Linkedin = 'linkedin',
  Tiktok = 'tiktok',
  X = 'x',
  Youtube = 'youtube'
}

/** Hook style options for the hook generator. */
export enum FreeToolHookGeneratorStyle {
  Contrarian = 'contrarian',
  CuriosityGap = 'curiosityGap',
  HowTo = 'howTo',
  Listicle = 'listicle',
  Question = 'question',
  ShockStat = 'shockStat',
  Story = 'story',
  SurpriseMe = 'surpriseMe',
  TrendFomo = 'trendFomo'
}

/** Tone options for the hook generator. */
export enum FreeToolHookGeneratorTone {
  BoldProvocative = 'boldProvocative',
  Casual = 'casual',
  Educational = 'educational',
  Inspirational = 'inspirational',
  Professional = 'professional',
  Witty = 'witty'
}

/** Input for querying a single free tool. */
export type FreeToolInput = {
  /** The template key of the tool to retrieve. */
  template: FreeToolTemplate;
};

/** A single Instagram bio variant with metadata. */
export type FreeToolInstagramBioGeneratorBio = {
  __typename?: 'FreeToolInstagramBioGeneratorBio';
  /** Number of characters in the bio. */
  characterCount: Scalars['Int']['output'];
  /** The bio text. */
  content: Scalars['String']['output'];
  /** Suggested emojis that could enhance the bio. */
  emojis: Array<Scalars['String']['output']>;
};

/** Input fields for generating Instagram bios. */
export type FreeToolInstagramBioGeneratorInput = {
  /** The name or brand the bio is about. */
  brandName: Scalars['String']['input'];
  /** The type of Instagram profile. */
  profileType: FreeToolInstagramBioGeneratorProfileType;
  /** The desired tone for the generated bios. */
  tone: FreeToolInstagramBioGeneratorTone;
  /** Optional description of what you or your brand does. */
  whatYouDo?: InputMaybe<Scalars['String']['input']>;
};

/** Output from the Instagram bio generator. */
export type FreeToolInstagramBioGeneratorOutput = {
  __typename?: 'FreeToolInstagramBioGeneratorOutput';
  /** The generated bio variants. */
  bios: Array<FreeToolInstagramBioGeneratorBio>;
};

/** Profile type options for the Instagram bio generator. */
export enum FreeToolInstagramBioGeneratorProfileType {
  Business = 'business',
  Creator = 'creator',
  Personal = 'personal'
}

/** Tone options for the Instagram bio generator. */
export enum FreeToolInstagramBioGeneratorTone {
  Casual = 'casual',
  Minimal = 'minimal',
  Professional = 'professional',
  Witty = 'witty'
}

/** Input fields for generating Instagram usernames. */
export type FreeToolInstagramNameGeneratorInput = {
  /** The brand, business, or personal name to base usernames on. */
  brandName: Scalars['String']['input'];
  /** Optional descriptive keywords to incorporate. */
  keywords?: InputMaybe<Scalars['String']['input']>;
  /** The desired tone for the generated names. */
  tone: FreeToolInstagramNameGeneratorTone;
};

/** Output from the Instagram name generator. */
export type FreeToolInstagramNameGeneratorOutput = {
  __typename?: 'FreeToolInstagramNameGeneratorOutput';
  /** The generated name suggestions. */
  suggestions: Array<FreeToolInstagramNameGeneratorSuggestion>;
};

/** A single Instagram name suggestion with reasoning and style tags. */
export type FreeToolInstagramNameGeneratorSuggestion = {
  __typename?: 'FreeToolInstagramNameGeneratorSuggestion';
  /** Why this name works for Instagram. */
  reasoning: Scalars['String']['output'];
  /** Short style descriptors for the suggestion. */
  styleTags: Array<Scalars['String']['output']>;
  /** The suggested username. */
  username: Scalars['String']['output'];
};

/** Tone options for the Instagram name generator. */
export enum FreeToolInstagramNameGeneratorTone {
  Creative = 'creative',
  Minimal = 'minimal',
  Playful = 'playful',
  Professional = 'professional'
}

/** Goal options for the LinkedIn headline generator. */
export enum FreeToolLinkedInHeadlineGeneratorGoal {
  FreelanceClientWork = 'freelanceClientWork',
  General = 'general',
  JobSeeking = 'jobSeeking',
  SalesFounder = 'salesFounder',
  ThoughtLeadership = 'thoughtLeadership'
}

/** Input fields for the LinkedIn headline generator. */
export type FreeToolLinkedInHeadlineGeneratorInput = {
  /** Who the headline should resonate with. */
  audience?: InputMaybe<Scalars['String']['input']>;
  /** Primary goal the headline should serve. */
  goal?: InputMaybe<FreeToolLinkedInHeadlineGeneratorGoal>;
  /** Industry or niche. */
  industry?: InputMaybe<Scalars['String']['input']>;
  /** Current or target job title / role. */
  role: Scalars['String']['input'];
  /** Comma-separated key skills or specialties. */
  skills?: InputMaybe<Scalars['String']['input']>;
  /** Headline format: pipe-delimited keywords or full sentence. */
  style?: InputMaybe<FreeToolLinkedInHeadlineGeneratorStyle>;
  /** Desired tone for the headline. */
  tone?: InputMaybe<FreeToolLinkedInHeadlineGeneratorTone>;
};

/** Output from the LinkedIn headline generator. */
export type FreeToolLinkedInHeadlineGeneratorOutput = {
  __typename?: 'FreeToolLinkedInHeadlineGeneratorOutput';
  /** The generated headline suggestions. */
  suggestions: Array<FreeToolLinkedInHeadlineSuggestion>;
};

/** Style options for the LinkedIn headline generator. */
export enum FreeToolLinkedInHeadlineGeneratorStyle {
  FullSentence = 'fullSentence',
  PipeDelimited = 'pipeDelimited'
}

/** Tone options for the LinkedIn headline generator. */
export enum FreeToolLinkedInHeadlineGeneratorTone {
  Bold = 'bold',
  Friendly = 'friendly',
  KeywordLed = 'keywordLed',
  Professional = 'professional',
  Punchy = 'punchy'
}

/** A single LinkedIn headline suggestion. */
export type FreeToolLinkedInHeadlineSuggestion = {
  __typename?: 'FreeToolLinkedInHeadlineSuggestion';
  /** Character count of the headline. */
  characterCount: Scalars['Int']['output'];
  /** The generated headline text (max 220 characters). */
  headline: Scalars['String']['output'];
  /** Why this headline works. */
  reasoning: Scalars['String']['output'];
};

/** Union of all per-tool output types. */
export type FreeToolOutput = FreeToolAiHashtagGeneratorOutput | FreeToolBlogToSocialMediaPostRepurposerOutput | FreeToolHookGeneratorOutput | FreeToolInstagramBioGeneratorOutput | FreeToolInstagramNameGeneratorOutput | FreeToolLinkedInHeadlineGeneratorOutput | FreeToolSubstackToSocialMediaPostRepurposerOutput | FreeToolTiktokUsernameGeneratorOutput | FreeToolUsernameGeneratorOutput | FreeToolYoutubeNameGeneratorOutput;

/** Target channel options for the Substack to social media post repurposer. */
export enum FreeToolSubstackToSocialMediaPostRepurposerChannel {
  Bluesky = 'bluesky',
  Facebook = 'facebook',
  Linkedin = 'linkedin',
  Mastodon = 'mastodon',
  Threads = 'threads',
  X = 'x'
}

/** Emoji toggle options for the Substack to social media post repurposer. */
export enum FreeToolSubstackToSocialMediaPostRepurposerEmoji {
  Off = 'off',
  On = 'on'
}

/** Hashtag toggle options for the Substack to social media post repurposer. */
export enum FreeToolSubstackToSocialMediaPostRepurposerHashtags {
  Off = 'off',
  On = 'on'
}

/** Input fields for the Substack to social media post repurposer. */
export type FreeToolSubstackToSocialMediaPostRepurposerInput = {
  /** The social media channel to generate posts for. */
  channel: FreeToolSubstackToSocialMediaPostRepurposerChannel;
  /** The full text of the Substack newsletter to repurpose (fallback when URL extraction fails). */
  content?: InputMaybe<Scalars['String']['input']>;
  /** Whether to include emoji in the generated posts. */
  includeEmoji?: InputMaybe<FreeToolSubstackToSocialMediaPostRepurposerEmoji>;
  /** Whether to include hashtags in the generated posts. */
  includeHashtags?: InputMaybe<FreeToolSubstackToSocialMediaPostRepurposerHashtags>;
  /** The desired tone for the generated posts. */
  tone?: InputMaybe<FreeToolSubstackToSocialMediaPostRepurposerTone>;
  /** The URL of the Substack newsletter to repurpose. */
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Output from the Substack to social media post repurposer. */
export type FreeToolSubstackToSocialMediaPostRepurposerOutput = {
  __typename?: 'FreeToolSubstackToSocialMediaPostRepurposerOutput';
  /** The generated post variations. */
  posts: Array<FreeToolSubstackToSocialMediaPostRepurposerPost>;
};

/** A single repurposed social media post variation. */
export type FreeToolSubstackToSocialMediaPostRepurposerPost = {
  __typename?: 'FreeToolSubstackToSocialMediaPostRepurposerPost';
  /** The angle used for this variation (hook-led, summary, or takeaway-led). */
  angle: Scalars['String']['output'];
  /** The character count of the generated post. */
  charCount: Scalars['Int']['output'];
  /** Whether the post is formatted as a thread (X only). */
  isThread: Scalars['Boolean']['output'];
  /** The character limit for the target channel. */
  limit: Scalars['Int']['output'];
  /** The generated post text. */
  text: Scalars['String']['output'];
  /** The individual thread parts if the post is a thread, empty array otherwise. */
  threadParts: Array<Scalars['String']['output']>;
};

/** Tone options for the Substack to social media post repurposer. */
export enum FreeToolSubstackToSocialMediaPostRepurposerTone {
  Bold = 'bold',
  Conversational = 'conversational',
  MatchSource = 'matchSource',
  Professional = 'professional',
  Punchy = 'punchy'
}

/** Available free tool templates. */
export enum FreeToolTemplate {
  AiHashtagGenerator = 'aiHashtagGenerator',
  BlogToSocialMediaPostRepurposer = 'blogToSocialMediaPostRepurposer',
  HookGenerator = 'hookGenerator',
  InstagramBioGenerator = 'instagramBioGenerator',
  InstagramNameGenerator = 'instagramNameGenerator',
  LinkedInHeadlineGenerator = 'linkedInHeadlineGenerator',
  SubstackToSocialMediaPostRepurposer = 'substackToSocialMediaPostRepurposer',
  TiktokUsernameGenerator = 'tiktokUsernameGenerator',
  UsernameGenerator = 'usernameGenerator',
  YoutubeNameGenerator = 'youtubeNameGenerator'
}

/** Input fields for generating TikTok usernames. */
export type FreeToolTiktokUsernameGeneratorInput = {
  /** The brand, creator name, or theme to base usernames on. */
  brandName: Scalars['String']['input'];
  /** Optional descriptive keywords to incorporate. */
  keywords?: InputMaybe<Scalars['String']['input']>;
  /** The desired tone for the generated usernames. */
  tone: FreeToolTiktokUsernameGeneratorTone;
};

/** Output from the TikTok username generator. */
export type FreeToolTiktokUsernameGeneratorOutput = {
  __typename?: 'FreeToolTiktokUsernameGeneratorOutput';
  /** The generated username suggestions. */
  suggestions: Array<FreeToolTiktokUsernameGeneratorSuggestion>;
};

/** A single TikTok username suggestion with reasoning and style tags. */
export type FreeToolTiktokUsernameGeneratorSuggestion = {
  __typename?: 'FreeToolTiktokUsernameGeneratorSuggestion';
  /** Why this username works for TikTok. */
  reasoning: Scalars['String']['output'];
  /** Short style descriptors for the suggestion. */
  styleTags: Array<Scalars['String']['output']>;
  /** The suggested username. */
  username: Scalars['String']['output'];
};

/** Tone options for the TikTok username generator. */
export enum FreeToolTiktokUsernameGeneratorTone {
  Creative = 'creative',
  Minimal = 'minimal',
  Playful = 'playful',
  Professional = 'professional'
}

/** Input fields for generating social media usernames. */
export type FreeToolUsernameGeneratorInput = {
  /** The brand, business, or personal name to base usernames on. */
  brandName: Scalars['String']['input'];
  /** Optional descriptive keywords to incorporate. */
  keywords?: InputMaybe<Scalars['String']['input']>;
  /** The social network to generate usernames for. */
  network: FreeToolUsernameGeneratorNetwork;
  /** The desired tone for the generated usernames. */
  tone: FreeToolUsernameGeneratorTone;
};

/** Social network options for the username generator. */
export enum FreeToolUsernameGeneratorNetwork {
  FacebookGroup = 'facebookGroup',
  FacebookPage = 'facebookPage',
  GoogleBusinessProfile = 'googleBusinessProfile',
  Instagram = 'instagram',
  LinkedInPage = 'linkedInPage',
  LinkedInProfile = 'linkedInProfile',
  Mastodon = 'mastodon',
  Pinterest = 'pinterest',
  Threads = 'threads',
  Tiktok = 'tiktok',
  X = 'x',
  Youtube = 'youtube'
}

/** Output from the username generator. */
export type FreeToolUsernameGeneratorOutput = {
  __typename?: 'FreeToolUsernameGeneratorOutput';
  /** The generated username suggestions. */
  suggestions: Array<FreeToolUsernameGeneratorSuggestion>;
};

/** A single username suggestion with reasoning and style tags. */
export type FreeToolUsernameGeneratorSuggestion = {
  __typename?: 'FreeToolUsernameGeneratorSuggestion';
  /** Why this username works for the given network and brand. */
  reasoning: Scalars['String']['output'];
  /** Short style descriptors for the suggestion. */
  styleTags: Array<Scalars['String']['output']>;
  /** The suggested username. */
  username: Scalars['String']['output'];
};

/** Tone options for the username generator. */
export enum FreeToolUsernameGeneratorTone {
  Creative = 'creative',
  Minimal = 'minimal',
  Playful = 'playful',
  Professional = 'professional'
}

/** Input fields for generating YouTube channel names. */
export type FreeToolYoutubeNameGeneratorInput = {
  /** The brand, channel theme, or creator name to base channel names on. */
  brandName: Scalars['String']['input'];
  /** Optional descriptive keywords to incorporate. */
  keywords?: InputMaybe<Scalars['String']['input']>;
  /** The desired tone for the generated names. */
  tone: FreeToolYoutubeNameGeneratorTone;
};

/** Output from the YouTube name generator. */
export type FreeToolYoutubeNameGeneratorOutput = {
  __typename?: 'FreeToolYoutubeNameGeneratorOutput';
  /** The generated channel name suggestions. */
  suggestions: Array<FreeToolYoutubeNameGeneratorSuggestion>;
};

/** A single YouTube channel name suggestion with reasoning and style tags. */
export type FreeToolYoutubeNameGeneratorSuggestion = {
  __typename?: 'FreeToolYoutubeNameGeneratorSuggestion';
  /** The suggested channel name. */
  channelName: Scalars['String']['output'];
  /** Why this name works for a YouTube channel. */
  reasoning: Scalars['String']['output'];
  /** Short style descriptors for the suggestion. */
  styleTags: Array<Scalars['String']['output']>;
};

/** Tone options for the YouTube name generator. */
export enum FreeToolYoutubeNameGeneratorTone {
  Creative = 'creative',
  Minimal = 'minimal',
  Playful = 'playful',
  Professional = 'professional'
}

/** A paginated connection of free tools. */
export type FreeToolsConnection = {
  __typename?: 'FreeToolsConnection';
  /** The list of free-tool edges for this page. */
  edges: Array<FreeToolEdge>;
  /** Pagination metadata. */
  pageInfo: PaginationPageInfo;
  /** Total number of tools matching the current filters. */
  totalCount: Scalars['Int']['output'];
};

/**
 * Input for the `freeTools` query. Stable across paginated requests —
 * clients must reset `after` to null when `input` changes.
 */
export type FreeToolsInput = {
  /** Optional template key to filter by. */
  template?: InputMaybe<FreeToolTemplate>;
};

export type GatewayDetails = {
  __typename?: 'GatewayDetails';
  gatewayId?: Maybe<Scalars['String']['output']>;
  /** This is available only on the paid plans and will have the values android, apple and web when the plan is purchased via the play_store, app_store or web (stripe) respectively. */
  gatewayPlatform?: Maybe<BillingGatewayPlatform>;
  gatewayType: BillingGateway;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Input for generateAccessToken mutation */
export type GenerateAccessTokenInput = {
  /** Client ID */
  clientId: Scalars['String']['input'];
  /** Client Secret */
  clientSecret: Scalars['String']['input'];
};

/** All possible response types that can be returned by generateAccessToken mutation. */
export type GenerateAccessTokenPayload = GenerateAccessTokenSuccess | InvalidCredentialsError;

/** Successful response for generateAccessToken mutation */
export type GenerateAccessTokenSuccess = {
  __typename?: 'GenerateAccessTokenSuccess';
  /** Generated access token */
  accessToken: Scalars['String']['output'];
  /** Seconds before the token expires */
  expiresIn: Scalars['Int']['output'];
};

export type GenerateAltTextInput = {
  /** Publicly-accessible URL of the image to describe. */
  imageUrl: Scalars['String']['input'];
  /**
   * BCP-47 language tag (e.g. "en-US", "es") the description should be written in.
   * Typically the user's browser language. Falls back to English when omitted or unrecognized.
   */
  locale?: InputMaybe<Scalars['String']['input']>;
};

/** Input for generating a signed S3 upload form for anonymous media. */
export type GenerateAnonymousMediaUploadFormInput = {
  /** Original file name. */
  fileName: Scalars['String']['input'];
  /**
   * Size of the file in bytes. Images must not exceed 10 MB. GIFs must not
   * exceed 15 MB.
   */
  fileSize: Scalars['Int']['input'];
  /**
   * MIME type of the file. Supported types: image/jpeg, image/png, image/gif,
   * and image/webp.
   */
  mimeType: Scalars['String']['input'];
  /** Cloudflare Turnstile CAPTCHA token for bot protection. */
  turnstileToken: Scalars['String']['input'];
};

/** Result of the generateAnonymousMediaUploadForm mutation. */
export type GenerateAnonymousMediaUploadFormPayload = GenerateAnonymousMediaUploadFormSuccess | InvalidInputError | LimitReachedError;

/** Successful result for a signed anonymous media upload form. */
export type GenerateAnonymousMediaUploadFormSuccess = {
  __typename?: 'GenerateAnonymousMediaUploadFormSuccess';
  /** Stable identifier URL for the uploaded file. */
  assetUrl: Scalars['String']['output'];
  /** Fixed time when the uploaded file expires. */
  expiresAt: Scalars['DateTime']['output'];
  /** Form fields that the client must send with the file. */
  uploadFields: Array<AnonymousMediaUploadField>;
  /**
   * S3 form target URL for the client to upload the file directly.
   * Expires after 5 minutes.
   */
  uploadUrl: Scalars['String']['output'];
};

/** Input for generatePersonalAccessToken mutation */
export type GeneratePersonalAccessTokenInput = {
  /** Token expiration in seconds */
  expiresIn?: InputMaybe<Scalars['Int']['input']>;
  /** Custom name for the token */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * OIDC scope strings (e.g. 'posts:read') to grant to the token. When omitted,
   * the token is granted all scopes available to Personal API Keys.
   */
  scopes?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * All possible response types that can be returned by
 * generatePersonalAccessToken mutation.
 */
export type GeneratePersonalAccessTokenPayload = GeneratePersonalAccessTokenSuccess | InvalidInputError | LimitReachedError;

/** Successful response for generatePersonalAccessToken mutation */
export type GeneratePersonalAccessTokenSuccess = {
  __typename?: 'GeneratePersonalAccessTokenSuccess';
  /** The generated personal access token. */
  personalAccessToken: PersonalAccessToken;
};

/** Main input for generating templated completions */
export type GenerateTemplatedCompletionInput = {
  /**
   * Token, required for free tools, to validate usage of API via
   * Free tools
   */
  captchaToken?: InputMaybe<Scalars['String']['input']>;
  /** Optional call-to-action text to include in the completion */
  cta?: InputMaybe<Scalars['String']['input']>;
  /** Parameters for the selected template */
  freeToolHashtagGenerator?: InputMaybe<FreeToolHashtagGeneratorTemplateInput>;
  /** Marketing id to be used when using completions via free tools */
  marketingId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the organization requesting the completion */
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
  /** Selected template for completion generation */
  template: GenerateTemplatedCompletionTemplate;
  /** Number of different variations to generate */
  variations?: InputMaybe<Scalars['Int']['input']>;
};

/** Union type for possible completion mutation responses */
export type GenerateTemplatedCompletionPayload = GenerateTemplatedCompletionSuccess | LimitReachedError | UnexpectedError;

/** Successful completion generation response */
export type GenerateTemplatedCompletionSuccess = {
  __typename?: 'GenerateTemplatedCompletionSuccess';
  /** Array of generated completion suggestions */
  suggestions: Array<GenerateTemplatedCompletionSuggestion>;
};

/** Individual completion suggestion container */
export type GenerateTemplatedCompletionSuggestion = {
  __typename?: 'GenerateTemplatedCompletionSuggestion';
  /** Generated completion text content */
  content: Scalars['String']['output'];
};

/** Available templates for AI text completion generation */
export enum GenerateTemplatedCompletionTemplate {
  /** Generates a list of hashtags based on a post's content */
  FreeToolHashtagGenerator = 'freeToolHashtagGenerator'
}

/** A recoverable Threaded Posts option-generation failure. */
export type GenerateThreadedPostOptionsError = MutationError & {
  __typename?: 'GenerateThreadedPostOptionsError';
  /** Stable failure code. */
  code: GenerateThreadedPostOptionsErrorCode;
  /** Human-readable failure message. */
  message: Scalars['String']['output'];
};

/** Stable codes for recoverable Threaded Posts option-generation failures. */
export enum GenerateThreadedPostOptionsErrorCode {
  /** The input is malformed or outside the accepted bounds. */
  InvalidInput = 'invalidInput',
  /** A protected text element cannot fit within one thread item. */
  ProtectedEntityTooLong = 'protectedEntityTooLong',
  /** The source text exceeds the request-size limit. */
  SourceTooLarge = 'sourceTooLarge',
  /** The generated option needs more items than remain in the thread. */
  ThreadCapacityExceeded = 'threadCapacityExceeded',
  /** The capability or requested channel is unavailable to the caller. */
  Unavailable = 'unavailable',
  /** The channel and post-type combination is not supported. */
  UnsupportedContext = 'unsupportedContext'
}

/** Input for generating typed Threaded Posts options for one composer item. */
export type GenerateThreadedPostOptionsInput = {
  /** Number of items already in the thread, including the item being split. */
  existingThreadItemCount: Scalars['Int']['input'];
  /** Post type of the item being split. */
  postType: PostType;
  /**
   * Authenticated channel or preview context whose server-side limits should
   * apply. Callers must provide this field with exactly one target member.
   */
  target: GenerateThreadedPostOptionsTargetInput;
  /** Exact source text of the item being split. */
  text: Scalars['String']['input'];
};

/** All possible responses from generateThreadedPostOptions. */
export type GenerateThreadedPostOptionsPayload = GenerateThreadedPostOptionsError | GenerateThreadedPostOptionsSuccess;

/** Organization-scoped service defaults used by the new-user preview experience. */
export type GenerateThreadedPostOptionsPreviewTargetInput = {
  /** Organization that owns the new-user preview experience. */
  organizationId: Scalars['OrganizationId']['input'];
  /** Social service whose standard character limits should apply. */
  service: Service;
};

/** Successfully generated Threaded Posts options. */
export type GenerateThreadedPostOptionsSuccess = {
  __typename?: 'GenerateThreadedPostOptionsSuccess';
  /** Typed options available to the caller. */
  options: Array<ThreadedPostSourcePreservingOption>;
  /** Identifier of the option recommended for initial selection. */
  recommendedOptionId: Scalars['String']['output'];
};

/** Selects exactly one authenticated or preview generation context. */
export type GenerateThreadedPostOptionsTargetInput =
  /** Authenticated channel whose capabilities and character limits should apply. */
  { channelId: Scalars['ChannelId']['input']; preview?: never; }
  |  /** Preview context for an organization without a connected channel. */
  { channelId?: never; preview: GenerateThreadedPostOptionsPreviewTargetInput; };

export type GenericSubscription = {
  interval: BillingInterval;
  trial?: Maybe<Trial>;
};

export type GeoLocation = {
  __typename?: 'GeoLocation';
  id?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

/** Input for getAccessTokenForChannel query */
export type GetAccessTokensForChannelInput = {
  /** ID of channel */
  channelId: Scalars['ChannelId']['input'];
  /** TFA code to verify. */
  tfaCode?: InputMaybe<Scalars['String']['input']>;
  /**
   * JWT token to verify instead of TFA code. This token is used to allow advocates a short window of time
   * to perform sensitive actions without needing to enter a TFA code again.
   */
  tfaToken?: InputMaybe<Scalars['String']['input']>;
};

/** getAccessTokenForChannel response payload. */
export type GetAccessTokensForChannelPayload = AccessTokens | NotFoundError | UnauthorizedError | UnexpectedError | UnsupportedChannelError;

/**
 * Input parameters for previewing the annual upgrade invoice.
 * Only requires the organization ID since the plan, quantity, and interval
 * are derived from the current subscription.
 */
export type GetAnnualUpgradePreviewInvoiceInput = {
  /** The unique identifier of the organization to preview the annual upgrade for */
  organizationId: Scalars['OrganizationId']['input'];
};

/** Input for the getCustomerAttributes query */
export type GetCustomerIoAttributesInput = {
  /** The account ID to get customer attributes for. */
  accountId: Scalars['AccountId']['input'];
};

/** The result union for the getCustomerAttributes query */
export type GetCustomerIoAttributesResponse = {
  __typename?: 'GetCustomerIOAttributesResponse';
  /** The customer attributes from Customer.io */
  attributes: CustomerIoAttributes;
};

/** Input parameters for previewing invoice costs for a subscription change */
export type GetPreviewInvoiceInput = {
  /** The billing interval to preview the invoice for */
  interval: BillingInterval;
  /** The unique identifier of the organization to preview invoice for */
  organizationId: Scalars['OrganizationId']['input'];
  /** The plan to preview the invoice for */
  plan: ObPlanId;
  /** The quantity to preview the invoice for */
  quantity: Scalars['Int']['input'];
};

/** Union type representing either a successful invoice preview response or a void error */
export type GetPreviewInvoicePayload = GetPreviewInvoiceResponse | VoidMutationError;

/** Response type for previewing upcoming invoice costs */
export type GetPreviewInvoiceResponse = {
  __typename?: 'GetPreviewInvoiceResponse';
  /** The amount that will be charged to the customer, in cents */
  chargeAmount: Scalars['Int']['output'];
  /** The amount of credit that will be applied, in cents */
  creditAmount: Scalars['Int']['output'];
  /** Whether this preview represents a scheduled change or immediate change */
  isScheduledChange: Scalars['Boolean']['output'];
  /** The next billing date for the subscription */
  nextBillingDate: Scalars['DateTime']['output'];
};

/** Input for getRecommendedTimesForChannel query */
export type GetRecommendedTimesForChannelInput = {
  /** ID of the channel */
  channelId: Scalars['ChannelId']['input'];
  /** Starting Date for the query (default and minimum: now + delta) */
  startingAt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Response for successful getRecommendedTimesForChannel query */
export type GetRecommendedTimesForChannelResponse = {
  __typename?: 'GetRecommendedTimesForChannelResponse';
  /** The best time to Post */
  recommendedTime: RecommendedTime;
  /** Recommended times for channels */
  recommendedTimes: Array<RecommendedTime>;
};

/** Input for querying most recently used Threads topics */
export type GetThreadsMostRecentlyUsedTopicsInput = {
  /** Channel IDs for the Threads channels to query topics for */
  channelIds: Array<Scalars['ChannelId']['input']>;
  /** Maximum number of topics to return (default: 20, max: 50) */
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Payload returned when querying most recently used Threads topics */
export type GetThreadsMostRecentlyUsedTopicsPayload = GetThreadsMostRecentlyUsedTopicsResponse | InvalidInputError | NotFoundError;

/** Success response for querying most recently used Threads topics */
export type GetThreadsMostRecentlyUsedTopicsResponse = {
  __typename?: 'GetThreadsMostRecentlyUsedTopicsResponse';
  /** List of previously used topics, sorted by most recently used first */
  topics: Array<Scalars['String']['output']>;
};

/** Input for querying trending topics */
export type GetTrendingTopicsInput = {
  /** Channel to query trending topics for (currently only 'threads' supported) */
  channel: ChannelThirdPartyService;
  /** Location code for trending topics */
  locationCode: TrendingTopicLocationCode;
};

/** Payload returned when querying trending topics */
export type GetTrendingTopicsPayload = GetTrendingTopicsResponse | InvalidInputError | UnexpectedError;

/** Success response for querying trending topics */
export type GetTrendingTopicsResponse = {
  __typename?: 'GetTrendingTopicsResponse';
  /** List of trending topics */
  trends: Array<TrendingTopic>;
  /**
   * When the trending topics data was last synced/updated.
   * Null if no trending topics data exists.
   */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/**
 * Google Business Profile comment metadata.
 * Contains review-specific fields like star ratings.
 */
export type GoogleBusinessCommentMetadata = {
  __typename?: 'GoogleBusinessCommentMetadata';
  /**
   * User rating for review-based platforms (e.g., Google Business star ratings).
   * Integer value typically 1-5.
   */
  userRating?: Maybe<Scalars['Int']['output']>;
};

export type GoogleBusinessData = {
  __typename?: 'GoogleBusinessData';
  code?: Maybe<Scalars['String']['output']>;
  end_date?: Maybe<Scalars['Int']['output']>;
  end_time?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use updateType field on PublishingPost */
  post_type: Scalars['String']['output'];
  start_date?: Maybe<Scalars['Int']['output']>;
  start_time?: Maybe<Scalars['String']['output']>;
  terms?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/**
 * Google Business-specific engagement metadata. Distinct from the channel-level
 * `GoogleBusinessMetadata` (which carries location data) — this is the engagement
 * surface's rating/note metadata.
 */
export type GoogleBusinessEngagementMetadata = {
  __typename?: 'GoogleBusinessEngagementMetadata';
  /** Whether engagements on this channel carry a user star rating. */
  hasUserRating: Scalars['Boolean']['output'];
  /**
   * A permanent note surfaced to the user about this channel's engagements.
   * Empty when there is nothing to tell the user.
   */
  permanentNote: Scalars['String']['output'];
};

/** Metadata for a GBP post that is an event */
export type GoogleBusinessEventMetaData = {
  __typename?: 'GoogleBusinessEventMetaData';
  /** Action button */
  button: GoogleBusinessPostActionType;
  /** End date of the event */
  endDate: Scalars['DateTime']['output'];
  /**
   * End time of the event
   * @deprecated get time from the endDate
   */
  endTime?: Maybe<Scalars['String']['output']>;
  /** Indicate whether the event has a start or end time. */
  isFullDayEvent: Scalars['Boolean']['output'];
  /** Link to the action */
  link?: Maybe<Scalars['String']['output']>;
  /** Start date of the event */
  startDate: Scalars['DateTime']['output'];
  /**
   * Start time of the event
   * @deprecated get time from the startDate
   */
  startTime?: Maybe<Scalars['String']['output']>;
  /** Title of the event */
  title: Scalars['String']['output'];
};

/** Metadata for a GBP post that is an event */
export type GoogleBusinessEventMetaDataInput = {
  /** Action button. Optional: a post with no button, or `none`, publishes without a call-to-action. On edit, omitting it preserves the existing value. */
  button?: InputMaybe<GoogleBusinessPostActionType>;
  /** End date of the event. Required on create; optional on edit (omitted preserves existing value). */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Indicate whether the event has a start or end time. */
  isFullDayEvent: Scalars['Boolean']['input'];
  /** Link to the action */
  link?: InputMaybe<Scalars['String']['input']>;
  /** Start date of the event. Required on create; optional on edit (omitted preserves existing value). */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Title of the event. Required on create; optional on edit (omitted preserves existing value). */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Google Business metadata */
export type GoogleBusinessMetadata = {
  __typename?: 'GoogleBusinessMetadata';
  /** Metadata about the location of the business associated with the channel. Only available for Facebook and GPB */
  locationData?: Maybe<LocationData>;
};

/** Metadata for a GBP post that is an offer */
export type GoogleBusinessOfferMetaData = {
  __typename?: 'GoogleBusinessOfferMetaData';
  /** Coupon code for the offer */
  code?: Maybe<Scalars['String']['output']>;
  /** End date of the offer */
  endDate: Scalars['DateTime']['output'];
  /** Link to the offer */
  link?: Maybe<Scalars['String']['output']>;
  /** Start date of the offer */
  startDate: Scalars['DateTime']['output'];
  /** Terms and Conditions */
  terms?: Maybe<Scalars['String']['output']>;
  /** Title of the offer */
  title: Scalars['String']['output'];
};

/** Metadata for a GBP post that is an offer */
export type GoogleBusinessOfferMetaDataInput = {
  /** Coupon code for the offer */
  code?: InputMaybe<Scalars['String']['input']>;
  /** End date of the offer. Required on create; optional on edit (omitted preserves existing value). */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Link to the offer */
  link?: InputMaybe<Scalars['String']['input']>;
  /** Start date of the offer. Required on create; optional on edit (omitted preserves existing value). */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Terms and Conditions */
  terms?: InputMaybe<Scalars['String']['input']>;
  /** Title of the offer. Required on create; optional on edit (omitted preserves existing value). */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** List of possible types for GBP cta */
export enum GoogleBusinessPostActionType {
  Book = 'book',
  Call = 'call',
  LearnMore = 'learn_more',
  None = 'none',
  Order = 'order',
  Shop = 'shop',
  Signup = 'signup'
}

/** GoogleBusiness Metadata details */
export type GoogleBusinessPostDetails = GoogleBusinessEventMetaData | GoogleBusinessOfferMetaData | GoogleBusinessWhatsNewMetaData;

/**
 * Google Business Profile post metadata
 * @deprecated: pending proposal for specific GBP post types: update, offer and event metadata types
 */
export type GoogleBusinessPostMetadata = CommonPostMetadata & {
  __typename?: 'GoogleBusinessPostMetadata';
  /** Annotations representing entities in the text */
  annotations: Array<Annotation>;
  /** Details of the metadata */
  details?: Maybe<GoogleBusinessPostDetails>;
  /** Title if available in the given GBP post type: event and offer */
  title?: Maybe<Scalars['String']['output']>;
  /** The channel-specific type of the post, eg, post, story, reel for Instagram */
  type: PostType;
};

/**
 * Google Business Profile post metadata
 * @deprecated: pending proposal for specific GBP post types: update, offer and event metadata types
 */
export type GoogleBusinessPostMetadataInput = {
  /** Details of the Event metadata */
  detailsEvent?: InputMaybe<GoogleBusinessEventMetaDataInput>;
  /** Details of the Offer metadata */
  detailsOffer?: InputMaybe<GoogleBusinessOfferMetaDataInput>;
  /** Details of the Whats new metadata */
  detailsWhatsNew?: InputMaybe<GoogleBusinessWhatsNewMetaDataInput>;
  /** Title if available in the given GBP post type: event and offer */
  title?: InputMaybe<Scalars['String']['input']>;
  /** The channel-specific type of the post, eg, post, offer, event for Google Business Profile */
  type: PostTypeGoogleBusiness;
};

/** Metadata for a GBP post of type Whats new */
export type GoogleBusinessWhatsNewMetaData = {
  __typename?: 'GoogleBusinessWhatsNewMetaData';
  /** Action button */
  button: GoogleBusinessPostActionType;
  /** Link to the action */
  link?: Maybe<Scalars['String']['output']>;
};

/** Metadata for a GBP post of type Whats new */
export type GoogleBusinessWhatsNewMetaDataInput = {
  /** Action button. Optional: a post with no button, or `none`, publishes without a call-to-action. On edit, omitting it preserves the existing value. */
  button?: InputMaybe<GoogleBusinessPostActionType>;
  /** Link to the action */
  link?: InputMaybe<Scalars['String']['input']>;
};

export type HealthStatus = {
  __typename?: 'HealthStatus';
  ok: Scalars['Boolean']['output'];
};

export type HellonextSsoMutationResponse = Error | HellonextSsoResponse | UnverifiedEmailAddressError;

export type HellonextSsoResponse = {
  __typename?: 'HellonextSsoResponse';
  ssoToken: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type HelpCenterLink = {
  __typename?: 'HelpCenterLink';
  text: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type HexColor = {
  __typename?: 'HexColor';
  value?: Maybe<Scalars['String']['output']>;
};

/** Render from the built-in client icon set. */
export type IconVisual = {
  __typename?: 'IconVisual';
  /** The built-in icon to render. */
  icon: ReactionIcon;
};

/** Ideas are the main entity in the create space */
export type Idea = {
  __typename?: 'Idea';
  /** The actual content and metadata of the idea */
  content: IdeaContent;
  /** Unix timestamp of when the idea was created */
  createdAt: Scalars['Int']['output'];
  /** ID of the group this idea belongs to (if any) */
  groupId?: Maybe<Scalars['ID']['output']>;
  /** Unique identifier for the idea */
  id: Scalars['ID']['output'];
  /** ID of the organization that owns this idea */
  organizationId: Scalars['ID']['output'];
  /** Numerical position for ordering within a group */
  position?: Maybe<Scalars['Float']['output']>;
  /** Unix timestamp of when the idea was last modified */
  updatedAt: Scalars['Int']['output'];
};

/** Content of an idea */
export type IdeaContent = {
  __typename?: 'IdeaContent';
  /** Indicates whether AI tools were used in creating this idea */
  aiAssisted: Scalars['Boolean']['output'];
  /** DateTime set by user associated with the idea - this often reflects a target publish date. */
  date?: Maybe<Scalars['DateTime']['output']>;
  /** List of media items attached to the idea */
  media?: Maybe<Array<IdeaMedia>>;
  /** Services tagged by the user - this is typically used to annotate ideas with their target services */
  services: Array<Service>;
  /** Tags used to categorize and organize the idea */
  tags: Array<PublishingTag>;
  /** Main body text or description of the idea */
  text?: Maybe<Scalars['String']['output']>;
  /** Title or headline of the idea */
  title?: Maybe<Scalars['String']['output']>;
};

/** content input for creating/updating an idea */
export type IdeaContentInput = {
  /** Whether AI tools were used in creation */
  aiAssisted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Target date for the idea, often used for planning publish schedules */
  date?: InputMaybe<Scalars['DateTime']['input']>;
  /** List of media items to attach */
  media?: InputMaybe<Array<IdeaMediaInput>>;
  /** Services associated with the idea for targeting specific platforms */
  services?: InputMaybe<Array<Service>>;
  /** Tags to categorize the idea */
  tags?: InputMaybe<Array<TagInput>>;
  /** Main body text or description */
  text?: InputMaybe<Scalars['String']['input']>;
  /** Title or headline of the idea */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type IdeaCreationInput = {
  content: IdeaContentInput;
  cta?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['String']['input'];
  /** @deprecated Use input.cta instead */
  source?: InputMaybe<Scalars['String']['input']>;
};

/** Pagination type for Ideas */
export type IdeaEdge = {
  __typename?: 'IdeaEdge';
  /** Opaque cursor for pagination, used to fetch subsequent pages */
  cursor: Scalars['String']['output'];
  /** The idea object */
  node: Idea;
};

/** Idea groups are used to organize ideas in the board */
export type IdeaGroup = {
  __typename?: 'IdeaGroup';
  /** Unique identifier for the idea group. */
  id: Scalars['ID']['output'];
  /** Whether the idea group is locked. */
  isLocked: Scalars['Boolean']['output'];
  /** The name of the idea group. */
  name: Scalars['String']['output'];
};

/** idea group input for create/update */
export type IdeaGroupInput = {
  /** Target group ID (null for unassigned group) */
  groupId?: InputMaybe<Scalars['ID']['input']>;
  /** ID of idea to place after (null for top position) */
  placeAfterId?: InputMaybe<Scalars['ID']['input']>;
};

/** Named buckets for filtering ideas by their group membership. */
export enum IdeaGroupMembership {
  /** Only ideas that are assigned to a group. */
  Grouped = 'grouped',
  /** Only ideas that are not assigned to any group. */
  Ungrouped = 'ungrouped'
}

/** Input type for retrieving idea groups by organization ID. */
export type IdeaGroupsInput = {
  /** Unique identifier for the organization. */
  organizationId: Scalars['ID']['input'];
};

export type IdeaIdInput = {
  id: Scalars['String']['input'];
};

/** Media attached to an idea */
export type IdeaMedia = {
  __typename?: 'IdeaMedia';
  /** Alternative text description for accessibility */
  alt?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the media in Buffer's upload system */
  id: Scalars['ID']['output'];
  /** File size in bytes */
  size?: Maybe<Scalars['Int']['output']>;
  /** Source platform information for the media */
  source?: Maybe<IdeaMediaSource>;
  /** URL to a smaller version of the media for preview purposes */
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  /** Type of media (e.g., image, video, gif) */
  type: MediaType;
  /** Direct URL to access the media file */
  url: Scalars['String']['output'];
};

export type IdeaMediaInput = {
  /** Alternative text for the media */
  alt?: InputMaybe<Scalars['String']['input']>;
  /** Internal upload id - not exposed to public API */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The size of the media in bytes */
  size?: InputMaybe<Scalars['Int']['input']>;
  /** Source information for the media */
  source?: InputMaybe<IdeaMediaSourceInput>;
  /** Thumbnail URL for the media */
  thumbnailUrl?: InputMaybe<Scalars['String']['input']>;
  /** The type of media (image, gif, video, link, document, unsupported). Note: 'video' is not supported via public API */
  type: MediaType;
  /** The URL of the media */
  url: Scalars['String']['input'];
};

/** Media source for the idea, e.g. Unsplash, Gifphy, etc. */
export type IdeaMediaSource = {
  __typename?: 'IdeaMediaSource';
  /** Name of the content creator/author */
  author?: Maybe<Scalars['String']['output']>;
  /** URL to the author's profile on the source platform */
  authorUrl?: Maybe<Scalars['String']['output']>;
  /** Unique identifier from the source platform */
  id?: Maybe<Scalars['String']['output']>;
  /** Name of the media source platform (e.g., 'Unsplash', 'Giphy') */
  name: Scalars['String']['output'];
};

/** Input type for the source information of media attached to an idea */
export type IdeaMediaSourceInput = {
  /** for unsplash only */
  author?: InputMaybe<Scalars['String']['input']>;
  authorUrl?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  trigger?: InputMaybe<Scalars['String']['input']>;
};

export type IdeaMutationPayload = CoreWebAppCommonError | IdeaMutationSuccess;

export type IdeaMutationSuccess = CoreWebAppMutationResponse & {
  __typename?: 'IdeaMutationSuccess';
  code: Scalars['String']['output'];
  /** The created ideas */
  idea: Idea;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type IdeaPayload = CoreWebAppCommonError | Idea;

/** createIdea response type */
export type IdeaResponse = {
  __typename?: 'IdeaResponse';
  /** The affected idea */
  idea?: Maybe<Idea>;
  /** If true, the client should refresh the ideas list because other ideas might have been moved */
  refreshIdeas: Scalars['Boolean']['output'];
};

export type IdeaUpdateInput = {
  content: IdeaContentInput;
  cta?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['String']['input'];
};

/** Relay connection for paginated ideas. */
export type IdeasConnection = {
  __typename?: 'IdeasConnection';
  /** List of idea edges containing the ideas and their cursors */
  edges: Array<IdeaEdge>;
  /** Pagination metadata including hasNextPage and endCursor */
  pageInfo: PaginationPageInfo;
};

export type IdeasCount = {
  __typename?: 'IdeasCount';
  count: Scalars['Int']['output'];
};

export type IdeasCountByTag = {
  __typename?: 'IdeasCountByTag';
  count: Scalars['Int']['output'];
  tagId: Scalars['String']['output'];
};

export type IdeasCountByTagInput = {
  organizationId: Scalars['String']['input'];
  tagId: Scalars['String']['input'];
};

export type IdeasCountByTags = {
  __typename?: 'IdeasCountByTags';
  counts: Array<IdeasCountByTag>;
};

export type IdeasCountByTagsPayload = CoreWebAppCommonError | IdeasCountByTags;

export type IdeasCountPayload = CoreWebAppCommonError | IdeasCount;

export type IdeasDeletionInput = {
  cta?: InputMaybe<Scalars['String']['input']>;
  ids: Array<Scalars['String']['input']>;
};

export type IdeasDeletionPayload = CoreWebAppCommonError | IdeasDeletionSuccess;

export type IdeasDeletionSuccess = CoreWebAppMutationResponse & {
  __typename?: 'IdeasDeletionSuccess';
  code: Scalars['String']['output'];
  /** The deleted ideas */
  ideas: Array<Idea>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

/**
 * Selects which ideas to return by group membership. Exactly one field must be
 * provided (enforced by @oneOf). To return ideas from all groups, omit
 * `groupFilter` on IdeasInput rather than setting a field here.
 */
export type IdeasGroupFilter =
  /** Return only ideas that belong to these specific groups (union/OR). */
  { groups: Array<Scalars['ID']['input']>; membership?: never; }
  |  /** Return ideas by a group-membership bucket rather than by specific group IDs. */
  { groups?: never; membership: IdeaGroupMembership; };

/** Filtering criteria for the ideas list. */
export type IdeasInput = {
  /**
   * Filter ideas by group membership. Omit this field entirely to return ideas
   * across all groups.
   */
  groupFilter?: InputMaybe<IdeasGroupFilter>;
  /** The organization to fetch ideas from. */
  organizationId: Scalars['OrganizationId']['input'];
  /** Filter ideas by tags using TagComparator. */
  tagsFilter?: InputMaybe<TagComparator>;
};

/** Input to filter ideas */
export type IdeasListInputV2 = {
  /**
   * Legacy filter argument - deprecated in favor of tags
   * @deprecated Use the tagsFilter input
   */
  filter?: InputMaybe<FilterBy>;
  /** Filter by idea groups: null means no filtering, null ID in array includes unassigned ideas */
  groups?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** The organization ID to fetch ideas from */
  organizationId: Scalars['ID']['input'];
  /**
   * Filter by tags: null means no filtering, null ID in array includes untagged ideas
   * @deprecated Use 'tagsFilter' field with TagComparator instead
   */
  tags?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Filter ideas by tags using TagComparator. */
  tagsFilter?: InputMaybe<TagComparator>;
};

export type Image = {
  __typename?: 'Image';
  author?: Maybe<Scalars['String']['output']>;
  authorUrl?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  downloadUrl?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  regularUrl?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
};

/** Image asset */
export type ImageAsset = Asset & {
  __typename?: 'ImageAsset';
  /** The ID of the asset in the database */
  id?: Maybe<Scalars['ID']['output']>;
  /** Image specific metadata */
  image: ImageMetadata;
  /** The MIME type of the asset */
  mimeType: Scalars['String']['output'];
  /** URL to the file source */
  source: Scalars['String']['output'];
  /** URL to the static thumbnail of the asset */
  thumbnail: Scalars['String']['output'];
  /** The type of the asset */
  type: AssetType;
};

/** Image asset */
export type ImageAssetInput = {
  /** Image specific metadata */
  metadata?: InputMaybe<ImageMetadataInput>;
  /** URL to the static thumbnail of the asset */
  thumbnailUrl?: InputMaybe<Scalars['String']['input']>;
  /** URL to the file source */
  url: Scalars['String']['input'];
};

/** Image dimensions */
export type ImageDimensionsInput = {
  /** Image height in pixels */
  height: Scalars['Int']['input'];
  /** Image width in pixels */
  width: Scalars['Int']['input'];
};

/** Image metadata */
export type ImageMetadata = {
  __typename?: 'ImageMetadata';
  /** Alternative text for accessibility */
  altText: Scalars['String']['output'];
  /** Animated thumbnail URL */
  animatedThumbnail?: Maybe<Scalars['String']['output']>;
  /** Image height in pixels */
  height: Scalars['Int']['output'];
  /** Is the image animated? */
  isAnimated: Scalars['Boolean']['output'];
  /** User tags in the image */
  userTags?: Maybe<Array<UserTag>>;
  /** Image width in pixels */
  width: Scalars['Int']['output'];
};

/** Image metadata */
export type ImageMetadataInput = {
  /** Alternative text for accessibility */
  altText: Scalars['String']['input'];
  /** Animated thumbnail URL */
  animatedThumbnail?: InputMaybe<Scalars['String']['input']>;
  /**
   * Ignored — the API resolves image dimensions itself.
   * @deprecated Ignored — the API resolves image dimensions itself.
   */
  dimensions?: InputMaybe<ImageDimensionsInput>;
  /** Accounts to tag at specific points on the image. Each tag's x/y position uses normalized 0.0-1.0 coordinates - see UserTagInput. */
  userTags?: InputMaybe<Array<UserTagInput>>;
};

export type ImageResultInfo = {
  __typename?: 'ImageResultInfo';
  count: Scalars['Int']['output'];
  currentPage: Scalars['Int']['output'];
  query?: Maybe<Scalars['String']['output']>;
};

export type ImageSearchError = MutationBasicError & {
  __typename?: 'ImageSearchError';
  /** A raw error message to help developers understand the root cause of the issue. */
  cause: Scalars['String']['output'];
  /** A user-friendly message that is safe to be displayed to users. */
  userFriendlyMessage: Scalars['String']['output'];
};

export type ImageSearchPayload = ImageSearchError | ImageSearchResponse;

export type ImageSearchResponse = {
  __typename?: 'ImageSearchResponse';
  images: Array<Maybe<Image>>;
  info: ImageResultInfo;
};

/** Render a network-supplied image (e.g. LinkedIn-branded reactions). */
export type ImageVisual = {
  __typename?: 'ImageVisual';
  /** URL of the network-supplied reaction image. */
  url: Scalars['String']['output'];
};

export type ImpersonationResponse = Error | Response;

/** Input parameters required to increase subscription quantity by unlocking specific channels */
export type IncreaseSubscriptionQuantityByChannelIdsInput = {
  /** The attribution for the subscription quantity increase */
  attribution?: InputMaybe<AttributionInput>;
  /** The channel IDs to unlock by increasing the subscription quantity */
  channelIds: Array<Scalars['ChannelId']['input']>;
  /** The ID of the organization to increase the subscription quantity for */
  organizationId: Scalars['OrganizationId']['input'];
};

/** The payload response of the increase subscription quantity by channel IDs mutation */
export type IncreaseSubscriptionQuantityByChannelIdsPayload = UpdateBillingSubscriptionPlanResponse | VoidMutationError;

/** input for initiateEmailUpdateRequest mutation */
export type InitiateEmailUpdateRequestInput = {
  /** Account id to change email address. */
  accountId: Scalars['AccountId']['input'];
  /** New email address to set. */
  newEmail: Scalars['String']['input'];
};

/** initiateEmailUpdateRequest response payload. */
export type InitiateEmailUpdateRequestPayload = InitiateEmailUpdateRequestSuccess | InvalidInputError | NotFoundError | UnexpectedError;

/** success response for setPasswordForAccount mutation */
export type InitiateEmailUpdateRequestSuccess = MutationSuccess & {
  __typename?: 'InitiateEmailUpdateRequestSuccess';
  /**
   * The value is always an empty string ''
   * Note: GraphQL doesn't allow types with no fields, so we have to add this field
   */
  _empty: Scalars['String']['output'];
};

/** Input for the initiateOnboarding mutation. */
export type InitiateOnboardingInput = {
  /** The organization to initiate onboarding for. */
  organizationId: Scalars['OrganizationId']['input'];
};

/** Payload returned by the initiateOnboarding mutation. */
export type InitiateOnboardingPayload = InitiateOnboardingResponse | OnboardingAlreadyCompletedError;

/** Successful result of initiating an onboarding flow. */
export type InitiateOnboardingResponse = {
  __typename?: 'InitiateOnboardingResponse';
  /** Previously saved answers for the returned step, if any. */
  existingSelectedOptions: Array<Scalars['String']['output']>;
  /** The slug identifying which flow definition is active. */
  flowSlug: Scalars['String']['output'];
  /** Current status of the onboarding flow. */
  status: OnboardingFlowStatus;
  /**
   * The current step of the onboarding flow. First step if the flow is just started,
   * or the next step if the flow is in progress.
   */
  step: OnboardingStep;
  /** The number of survey steps in this flow, used to drive progress indicators. */
  totalSurveySteps: Scalars['Int']['output'];
  /** The version of the flow definition. */
  version: Scalars['Int']['output'];
};

/** Input for the updateEmail mutation */
export type InitiateUpdateEmailInput = {
  /** Account id of account to update email of. */
  accountId: Scalars['AccountId']['input'];
  /** Indicate whether it is a backup email */
  isBackupEmail?: InputMaybe<Scalars['Boolean']['input']>;
  /** New email to update Account with */
  newEmail: Scalars['String']['input'];
  /** Password for Account to verify if we allow updating the email */
  password: Scalars['String']['input'];
};

/** updateEmail response payload */
export type InitiateUpdateEmailPayload = EmptySuccess | InvalidInputError | NotFoundError | UnexpectedError;

/** Sort configuration for ordering channels in a multi-channel analytics export. */
export type InsightsExportChannelSortInput = {
  /** Sort direction. */
  direction: SortDirection;
  /**
   * The channel-level metric to order channels by — any `PostMetricType` value
   * (e.g. `postCount`, `reactions`, `engagementRate`). Free-form to mirror
   * `InsightsSummaryMetric.type`; a channel missing the metric sorts last.
   */
  metric: Scalars['String']['input'];
};

/**
 * Sort configuration for ordering the posts rendered in an analytics export.
 * Dedicated to this mutation rather than sharing the `topPosts` query's input.
 */
export type InsightsExportPostSortInput = {
  /** Sort direction. */
  direction: SortDirection;
  /**
   * The metric to rank posts by. Reuses the shared `TopPostsSortBy` vocabulary
   * (reactions, comments, engagement rate).
   */
  field: TopPostsSortBy;
};

/**
 * A toggleable container in a PDF analytics report. Used as a deny-list in
 * `CreateChannelAnalyticsExportInput.excludedSections`. Two scopes: the
 * channel-level values (`summary`…`visibility`) govern the single-channel report
 * and every per-channel breakdown in an all-channels report; the aggregate values
 * (`aggregate*`, `channelSummaryTable`, `perChannelBreakdown`) govern the
 * all-channels report's own top-level containers. The cover identity always
 * renders; only the summary metrics grid is toggleable.
 */
export enum InsightsExportSection {
  /** All-channels only: the aggregate "Followers" chart. */
  AggregateFollowersChart = 'aggregateFollowersChart',
  /** All-channels only: the aggregate "Posts" chart. */
  AggregatePostsChart = 'aggregatePostsChart',
  /** All-channels only: the aggregate summary metrics grid. */
  AggregateSummary = 'aggregateSummary',
  /** All-channels only: the aggregated Top 5 posts. */
  AggregateTopPosts = 'aggregateTopPosts',
  /** Channel-level: the "Audience Growth" narrative chart (followers + net-new). */
  AudienceGrowth = 'audienceGrowth',
  /** All-channels only: the cross-channel performance (channel summary) table. */
  ChannelSummaryTable = 'channelSummaryTable',
  /** Channel-level: the "Content Impact" narrative chart (posts + followers). */
  ContentImpact = 'contentImpact',
  /** Channel-level: the "Followers" time-series chart. */
  FollowersChart = 'followersChart',
  /**
   * All-channels only: the per-channel breakdown sections as a whole (master
   * on/off). Channel-level toggles further refine what each breakdown shows.
   */
  PerChannelBreakdown = 'perChannelBreakdown',
  /** Channel-level: the channel's Performance Per Post (posts) table. */
  PerformancePerPost = 'performancePerPost',
  /** Channel-level: the "Posts" time-series chart. */
  PostsChart = 'postsChart',
  /** Channel-level: the "Reach" time-series chart. */
  ReachChart = 'reachChart',
  /** Channel-level: the channel's summary metrics grid. */
  Summary = 'summary',
  /** Channel-level: the "Profile Views" time-series chart. */
  ViewsChart = 'viewsChart',
  /** Channel-level: the "Visibility" narrative chart (profile views + followers). */
  Visibility = 'visibility'
}

/**
 * Shared filter input for insights queries across all channels.
 * Used by `topPosts` and intended to be the canonical shape for any future
 * internal insights query that needs the same date range + channel + tag
 * filtering. Mirrors the filter fields of `AllChannelsPostInsightsInput`;
 * keep them in sync until that input is consolidated to reference this type.
 *
 * Note: this input is intentionally NOT marked `@public`. Public-facing
 * queries (e.g. `aggregatedPostMetrics`) declare their own dedicated input
 * types per Joe's schema-review feedback — avoid sharing input types across
 * queries/mutations so each operation can evolve independently.
 */
export type InsightsFilterInput = {
  /** Optional list of channel IDs to filter by */
  channelIds?: InputMaybe<Array<Scalars['ChannelId']['input']>>;
  /** The end date */
  endDate: Scalars['DateTime']['input'];
  /** The organization ID */
  organizationId: Scalars['OrganizationId']['input'];
  /**
   * Filter insights to posts of specific formats.
   * When omitted or empty, all posts are included regardless of format.
   *
   * Matches the format stored on the post, which the `Post.metadata.type` badge
   * also reads. The two disagree on Google Business, where an unlabelled post
   * shows a `whats_new` badge but matches a `post` filter.
   *
   * `carousel` and `thread` are rejected rather than matching nothing: no stored
   * value resolves to either, and a LinkedIn carousel comes from its media shape.
   */
  postTypes?: InputMaybe<Array<PostType>>;
  /** The start date */
  startDate: Scalars['DateTime']['input'];
  /**
   * Filter insights to posts with specific tags.
   * When omitted, all posts are included regardless of tags.
   */
  tags?: InputMaybe<TagComparator>;
};

/**
 * An aggregated summary metric that can represent both post-level and channel-level metrics.
 * This is the convergence type used in cross-channel summaries.
 */
export type InsightsSummaryMetric = {
  __typename?: 'InsightsSummaryMetric';
  /** The metric description */
  description: Scalars['String']['output'];
  /** The difference compared to the previous period */
  difference: Scalars['Float']['output'];
  /** How the difference is expressed (percentage or absolute) */
  differenceMode: DifferenceMode;
  /** The displayable metric name */
  name: Scalars['String']['output'];
  /**
   * The metric type identifier — any value from PostMetricType (e.g. postCount, reactions,
   * comments, reach, impressions, engagementRate) or ChannelMetricType (followers).
   */
  type: Scalars['String']['output'];
  /** The metric unit */
  unit: PostMetricUnit;
  /** The metric value for the current period */
  value: Scalars['Float']['output'];
};

/** An Instagram music track or original sound that can be attached to a Reel. */
export type InstagramAudio = {
  __typename?: 'InstagramAudio';
  /** Temporary artwork URL from Meta. May be null. */
  coverArtworkUrl?: Maybe<Scalars['URL']['output']>;
  /** Creator username for original sounds */
  creatorUsername?: Maybe<Scalars['String']['output']>;
  /** Artist name for licensed music */
  displayArtist?: Maybe<Scalars['String']['output']>;
  /** Duration of the audio in milliseconds */
  duration: Scalars['Int']['output'];
  /** Meta audio asset ID */
  id: Scalars['String']['output'];
  /** Temporary preview URL from Meta. May be null. */
  previewUrl?: Maybe<Scalars['URL']['output']>;
  /** Display title for the audio */
  title: Scalars['String']['output'];
  /** Whether this asset is licensed music or an original sound */
  type: InstagramAudioType;
};

/** Input for browsing trending music and original sounds. */
export type InstagramAudioCatalogInput = {
  /** Instagram channel used to authorize the catalog request. */
  channelId: Scalars['ChannelId']['input'];
};

/** Combined Instagram audio results or a request to refresh the channel. */
export type InstagramAudioCatalogPayload = ChannelRefreshRequired | InstagramAudioCatalogSuccess;

/** Combined music and original sound results, with duplicate audio IDs removed. */
export type InstagramAudioCatalogSuccess = {
  __typename?: 'InstagramAudioCatalogSuccess';
  /**
   * Available tracks, with duplicate audio IDs removed. Meta's order within each
   * catalog is preserved.
   *
   * Browsing returns music first, then original sounds. Search returns original
   * sounds first, then music, to better reflect the search text: creators write
   * original sound titles, so they usually contain the words people search for,
   * while music results often don't match the query.
   */
  audio: Array<InstagramAudio>;
  /**
   * Catalogs that failed to load. Results from successful catalogs are still returned,
   * including an empty list if that catalog has no available tracks.
   * If both catalogs fail, the query returns an error instead.
   */
  failedAudioTypes: Array<InstagramAudioType>;
};

/** Input for refreshing a single Instagram audio asset */
export type InstagramAudioInput = {
  /** Meta audio asset ID */
  audioId: Scalars['String']['input'];
  /** Instagram channel used to authorize the refresh */
  channelId: Scalars['ChannelId']['input'];
};

/** Payload returned when refreshing Instagram audio metadata */
export type InstagramAudioPayload = ChannelRefreshRequired | InstagramAudioSuccess;

/** Input for fetching a playable Instagram audio preview */
export type InstagramAudioPreviewInput = {
  /** Meta audio asset ID */
  audioId: Scalars['String']['input'];
  /** Instagram channel used to authorize the preview fetch */
  channelId: Scalars['ChannelId']['input'];
  /**
   * Optional temporary preview URL from search results.
   * When present, Buffer downloads this URL instead of re-querying Meta metadata.
   */
  previewUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Payload returned when fetching a playable Instagram audio preview */
export type InstagramAudioPreviewPayload = ChannelRefreshRequired | InstagramAudioPreviewSuccess;

/** Playable audio preview fetched server-side from Meta's temporary download URL. */
export type InstagramAudioPreviewSuccess = {
  __typename?: 'InstagramAudioPreviewSuccess';
  /** Data URL suitable for HTMLAudioElement. Do not persist. */
  dataUrl: Scalars['String']['output'];
};

/**
 * Selected Instagram audio for automatic Reel publishing.
 * Mutually exclusive with stickerFields.music.
 */
export type InstagramAudioSelectionInput = {
  /** Meta audio asset ID */
  audioId: Scalars['String']['input'];
  /** Volume for the selected audio (0-100). Defaults to 100. */
  audioVolume?: InputMaybe<Scalars['Int']['input']>;
  /** Creator username for original sounds */
  creatorUsername?: InputMaybe<Scalars['String']['input']>;
  /** Artist name for licensed music */
  displayArtist?: InputMaybe<Scalars['String']['input']>;
  /** Duration of the audio in milliseconds */
  duration: Scalars['Int']['input'];
  /** Display title for the audio */
  title: Scalars['String']['input'];
  /** Whether this asset is licensed music or an original sound */
  type: InstagramAudioType;
  /** Volume for the original video audio (0-100). Defaults to 100. */
  videoVolume?: InputMaybe<Scalars['Int']['input']>;
};

/** Refreshed metadata for one Instagram audio asset. */
export type InstagramAudioSuccess = {
  __typename?: 'InstagramAudioSuccess';
  /** Refreshed audio metadata. */
  audio: InstagramAudio;
};

/** Instagram audio catalog type from Meta's Audio API. */
export enum InstagramAudioType {
  /** Licensed music from Meta's audio catalog. */
  Music = 'music',
  /** Audio created by an Instagram account. */
  OriginalSound = 'originalSound'
}

export type InstagramData = {
  __typename?: 'InstagramData';
  comment_text?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use updateType field on PublishingPost */
  post_type: Scalars['String']['output'];
  service_geolocation_id?: Maybe<Scalars['String']['output']>;
  service_geolocation_name?: Maybe<Scalars['String']['output']>;
};

/** Instagram Geolocation */
export type InstagramGeolocation = {
  __typename?: 'InstagramGeolocation';
  /** The id of this location */
  id?: Maybe<Scalars['String']['output']>;
  /** The name of this location */
  text?: Maybe<Scalars['String']['output']>;
};

/** Instagram Geolocation */
export type InstagramGeolocationInput = {
  /** The id of this location */
  id?: InputMaybe<Scalars['String']['input']>;
  /** The name of this location */
  text?: InputMaybe<Scalars['String']['input']>;
};

/** Instagram metadata */
export type InstagramMetadata = {
  __typename?: 'InstagramMetadata';
  /**
   * Indicates if we should default to reminder for Instagram
   * Source: field resolver: profile.default_to_reminders
   */
  defaultToReminders: Scalars['Boolean']['output'];
};

/** Instagram post metadata */
export type InstagramPostMetadata = CommonPostMetadata & {
  __typename?: 'InstagramPostMetadata';
  /** Annotations representing entities in the text */
  annotations: Array<Annotation>;
  /** Validated audio for automatic Reel publishing. Mutually exclusive with stickerFields.music. */
  audio?: Maybe<InstagramSelectedAudio>;
  /** Instagram usernames invited as collaborators */
  collaborators: Array<Scalars['String']['output']>;
  /** Instagram post's first comment */
  firstComment?: Maybe<Scalars['String']['output']>;
  /** Geolocation of the post */
  geolocation?: Maybe<InstagramGeolocation>;
  /** Whether the post discloses AI-generated content */
  isAiGenerated: Scalars['Boolean']['output'];
  /** Shop Grid link for the post */
  link?: Maybe<Scalars['String']['output']>;
  /** Indicates whether post should be shared to feed */
  shouldShareToFeed: Scalars['Boolean']['output'];
  /** Sticker fields for reminder-based publishing */
  stickerFields?: Maybe<InstagramStickerFields>;
  /** The strategy that shares a trial Reel with followers */
  trialReelGraduationStrategy?: Maybe<InstagramTrialReelGraduationStrategy>;
  /** The channel-specific type of the post, eg, post, story, reel for Instagram */
  type: PostType;
};

/** Instagram post metadata */
export type InstagramPostMetadataInput = {
  /**
   * Validated audio for automatic Reel publishing.
   * Omit to preserve on edit; pass null to remove; object replaces.
   * Mutually exclusive with stickerFields.music.
   */
  audio?: InputMaybe<InstagramAudioSelectionInput>;
  /** Instagram accounts to invite as collaborators */
  collaborators?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Instagram post's first comment */
  firstComment?: InputMaybe<Scalars['String']['input']>;
  /** Geolocation of the post */
  geolocation?: InputMaybe<InstagramGeolocationInput>;
  /** Whether the post discloses AI-generated content */
  isAiGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  /** Shop Grid link for the post */
  link?: InputMaybe<Scalars['String']['input']>;
  /** Indicates whether post should be shared to feed */
  shouldShareToFeed: Scalars['Boolean']['input'];
  /** Sticker fields for reminder-based publishing */
  stickerFields?: InputMaybe<InstagramStickerFieldsInput>;
  /** The strategy that shares a trial Reel with followers */
  trialReelGraduationStrategy?: InputMaybe<InstagramTrialReelGraduationStrategy>;
  /** The channel-specific type of the post, eg, post, story, reel for Instagram */
  type: PostType;
};

/**
 * Validated Instagram audio attached for automatic Reel publishing.
 * Does not include temporary Meta preview URLs.
 */
export type InstagramSelectedAudio = {
  __typename?: 'InstagramSelectedAudio';
  /** Volume for the selected audio (0-100) */
  audioVolume: Scalars['Int']['output'];
  /** Creator username for original sounds */
  creatorUsername?: Maybe<Scalars['String']['output']>;
  /** Artist name for licensed music */
  displayArtist?: Maybe<Scalars['String']['output']>;
  /** Duration of the audio in milliseconds */
  duration: Scalars['Int']['output'];
  /** Meta audio asset ID */
  id: Scalars['String']['output'];
  /** Display title for the audio */
  title: Scalars['String']['output'];
  /** Whether this asset is licensed music or an original sound */
  type: InstagramAudioType;
  /** Volume for the original video audio (0-100) */
  videoVolume: Scalars['Int']['output'];
};

/**
 * Instagram fields for reminder-based publishing. Upon the reminder for publishing, the user
 * is prompted to copy and paste these fields into the Instagram app to complete the post.
 */
export type InstagramStickerFields = {
  __typename?: 'InstagramStickerFields';
  /** Placeholder text for the post's music */
  music?: Maybe<Scalars['String']['output']>;
  /** Additional field for any other post content */
  other?: Maybe<Scalars['String']['output']>;
  /** Placeholder text for the post's linked products */
  products?: Maybe<Scalars['String']['output']>;
  /** Text for the Story or Reel */
  text?: Maybe<Scalars['String']['output']>;
  /** Placeholder text for the post's topics (Reels only) */
  topics?: Maybe<Scalars['String']['output']>;
};

/**
 * Instagram fields for reminder-based publishing. Upon the reminder for publishing, the user
 * is prompted to copy and paste these fields into the Instagram app to complete the post.
 */
export type InstagramStickerFieldsInput = {
  /** Placeholder text for the post's music */
  music?: InputMaybe<Scalars['String']['input']>;
  /** Additional field for any other post content */
  other?: InputMaybe<Scalars['String']['input']>;
  /** Placeholder text for the post's linked products */
  products?: InputMaybe<Scalars['String']['input']>;
  /** Text for the Story or Reel */
  text?: InputMaybe<Scalars['String']['input']>;
  /** Placeholder text for the post's topics (Reels only) */
  topics?: InputMaybe<Scalars['String']['input']>;
};

/** The strategy that shares a trial Reel with followers */
export enum InstagramTrialReelGraduationStrategy {
  Automatic = 'automatic',
  Manual = 'manual'
}

export enum IntervalSize {
  OneHour = 'oneHour',
  ThirtyMinutes = 'thirtyMinutes',
  TwoHours = 'twoHours'
}

/** An introductory welcome step displayed at the start of the onboarding flow. */
export type IntroductionStep = {
  __typename?: 'IntroductionStep';
  /** Label for the call-to-action button. */
  buttonText: Scalars['String']['output'];
  /** Whether the user can skip this step. */
  isSkippable: Scalars['Boolean']['output'];
  /** Unique identifier for the step within its flow. */
  slug: Scalars['String']['output'];
  /** Optional subtitle displayed below the title. */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Title displayed to the user. */
  title: Scalars['String']['output'];
};

/** Error returned when the user provides invalid credentials */
export type InvalidCredentialsError = MutationError & {
  __typename?: 'InvalidCredentialsError';
  /** Error message */
  message: Scalars['String']['output'];
};

/** Error when email format is invalid */
export type InvalidEmailError = MutationError & {
  __typename?: 'InvalidEmailError';
  /** Human-readable error message. */
  message: Scalars['String']['output'];
};

/** Error returned when the input is invalid */
export type InvalidInputError = MutationError & {
  __typename?: 'InvalidInputError';
  /** Error message */
  message: Scalars['String']['output'];
};

/** Error returned when one or more of the redirect Uris are invalid */
export type InvalidRedirectUrisError = MutationError & {
  __typename?: 'InvalidRedirectUrisError';
  /** Error message */
  message: Scalars['String']['output'];
};

/**
 * A pending invitation to join an organization.
 *
 * Existence of an Invitation document means it is pending. Accepted and
 * revoked invitations are deleted; expired invitations are removed by a
 * TTL. The accompanying account, if one exists for the invited email,
 * is nullable — it's set once the invitee signs up, or pre-populated
 * when the email already has a Buffer account.
 */
export type Invitation = {
  __typename?: 'Invitation';
  /**
   * The invitee's Buffer account. `null` when no Buffer account yet
   * exists for the invited email (the common pre-signup case), or when
   * the invitee has since deleted their account — the invitation
   * document outlives the invitee's account. The publish UI uses
   * presence/absence here to decide whether to show an "account pending"
   * vs "linked account" hint; the auth screens use it for the
   * signup-vs-login routing decision (account exists ⇒ login).
   */
  account?: Maybe<Account>;
  /**
   * Channel-level access the invitee will receive on accept, keyed by
   * product, as accept would grant it right now. An Admin invitation on an
   * organization with Roles enabled lists every channel of the organization at
   * `fullPosting` on both products. Any other invitation lists the stored
   * assignments that grant at least one product; a stored assignment with
   * `none` on every product is left out, as accept creates no row for it.
   * Empty when the invitation grants no channel access.
   */
  channelPermissions: Array<ChannelProductPermission>;
  /**
   * The Roles role the invitee will hold once they accept.
   * Reads as `viewer`, the lowest role, when the organization does not have Roles
   * enabled, or when the invitation has no stored role.
   * Should only be used for displaying to the user, not for authorization
   * purposes. For authorization purposes, use the `allowedActions` field on the
   * entity being acted on (e.g. `Organization.allowedActions`).
   */
  collaborationRole: CollaborationRole;
  /** The invited email address (lowercased, normalized). */
  email: Scalars['String']['output'];
  /** When the invitation will expire (and be removed by TTL). */
  expiresAt: Scalars['DateTime']['output'];
  /** The invitation document ID. */
  id: Scalars['InvitationId']['output'];
  /**
   * The canonical accept link for this invitation — the same
   * `/signup?invite=<JWT>&…&redirect=/invite/accept?invite=<JWT>` URL the
   * invitation email carries. Built on read (a fresh JWT is signed each
   * query, reflecting the current `expiresAt`). The admin UI exposes a
   * "Copy invite link" action off this so invites can be shared directly
   * while the transactional email is still being wired up (CORE-5218).
   */
  inviteLink: Scalars['String']['output'];
  /** When the invitation was created. */
  invitedAt: Scalars['DateTime']['output'];
  /**
   * The team admin who created the invitation. `null` if that admin has
   * since deleted their Buffer account — the invitation document outlives
   * the inviter's account.
   */
  invitedBy?: Maybe<Account>;
  /** Display name supplied by the admin at invite time. */
  name: Scalars['String']['output'];
  /**
   * The inviting organization, hydrated. The auth screens use this to
   * render "You've been invited to join {organization.name}" context above
   * the signup / login form; the publish UI uses it for the post-accept
   * banner. Raises if the org has been deleted between invite and read
   * (the cleanup job ought to have removed the invitation too — that
   * catch-up work is tracked in EPD-1025).
   */
  organization: Organization;
  /** The organization the invitee is being invited to. */
  organizationId: Scalars['OrganizationId']['output'];
  /**
   * Role the invitee will hold once they accept.
   * Should only be used for displaying to the user, not for authorization
   * purposes. For authorization purposes, use the `allowedActions` field on the
   * entity being acted on (e.g. `Organization.allowedActions`).
   */
  role: TeamMemberRole;
};

/**
 * Error when an invitation is already pending for this (organization, email).
 * Distinct from EmailAlreadyMemberError (which fires for active members).
 */
export type InvitationAlreadyPendingError = MutationError & {
  __typename?: 'InvitationAlreadyPendingError';
  /** Human-readable error message. */
  message: Scalars['String']['output'];
};

/** Input for the invitationByToken query. */
export type InvitationByTokenInput = {
  /** The signed JWT from the invite link. */
  jwt: Scalars['String']['input'];
};

/**
 * Error when the authenticated user's email doesn't match the invited
 * email. v1: accepting with a different account is not allowed.
 */
export type InvitationEmailMismatchError = MutationError & {
  __typename?: 'InvitationEmailMismatchError';
  /** Human-readable error message. */
  message: Scalars['String']['output'];
};

/**
 * A single invitation inside an `InviteTeamMembers` batch. The org is
 * supplied once at the batch level (`InviteTeamMembersInput.organizationId`),
 * so it is intentionally absent here — every item is invited to the same
 * organization.
 */
export type InviteTeamMemberItemInput = {
  /** Initial channel assignments, keyed by product per channel. */
  channelAssignments: Array<ChannelProductAssignmentInput>;
  /**
   * The channels to give the new member on an organization with Roles enabled.
   * Each is stored with the access level `collaborationRole` implies on every
   * product (`creator` posts freely, `collaborator` needs approval, `viewer`
   * is read-only), so `channelAssignments` is ignored there. An `admin`
   * invitation stores no channels: an admin gets every channel on accept.
   * Ignored on an organization without Roles, which reads `channelAssignments`.
   */
  channelIds?: InputMaybe<Array<Scalars['ChannelId']['input']>>;
  /**
   * The Roles role to give the new member. Required when the organization has
   * Roles enabled: it is stored on the invitation and the legacy `role` is
   * derived from it (`admin` stays admin, every other role becomes `member`),
   * so `role` is ignored there. Ignored on an organization without Roles, so
   * clients can send it without checking the organization first.
   */
  collaborationRole?: InputMaybe<CollaborationRole>;
  /** Email address of the person to invite */
  email: Scalars['String']['input'];
  /** Display name for the new member */
  name: Scalars['String']['input'];
  /**
   * The legacy role to assign to the new member (admin or member). Required on
   * an organization without Roles and ignored on one with Roles enabled, where
   * `collaborationRole` is required instead. An invitation missing the role its
   * organization requires fails as a per-email `failed` row.
   */
  role?: InputMaybe<TeamMemberRole>;
};

/** Per-email failure inside an `InviteTeamMembers` batch. */
export type InviteTeamMembersFailure = {
  __typename?: 'InviteTeamMembersFailure';
  /** The email address that could not be invited. */
  email: Scalars['String']['output'];
  /** Human-readable reason the invitation failed. */
  reason: Scalars['String']['output'];
};

/**
 * Input for inviting one or more team members in a single batch.
 * Pairs with the comma-separated UX in the publish-frontend invite dialog.
 */
export type InviteTeamMembersInput = {
  /**
   * One entry per invitation. Per-email failures don't abort the batch.
   * All entries are invited to `organizationId`.
   */
  invitations: Array<InviteTeamMemberItemInput>;
  /** The organization to invite the members to. */
  organizationId: Scalars['OrganizationId']['input'];
};

/** Result of inviting one or more team members. */
export type InviteTeamMembersPayload = InviteTeamMembersSuccess | TeamMemberLimitReachedError;

/**
 * Success payload for `inviteTeamMembers` (batch). Per-email failures are
 * returned as a sibling array; success and partial-success share the same
 * payload type. Returns the newly created `Invitation` rows so the admin
 * UI can render the new pending entries in place.
 */
export type InviteTeamMembersSuccess = {
  __typename?: 'InviteTeamMembersSuccess';
  /** The pending invitations created by this batch. */
  created: Array<Invitation>;
  /** Per-email failures (invalid email, already member, already pending). */
  failed: Array<InviteTeamMembersFailure>;
};

export type Invoice = {
  __typename?: 'Invoice';
  amount: Scalars['Float']['output'];
  chargeId?: Maybe<Scalars['String']['output']>;
  currency: Scalars['String']['output'];
  date: Scalars['DateTime']['output'];
  downloadUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  status: InvoiceStatus;
};

export type InvoiceConnection = {
  __typename?: 'InvoiceConnection';
  edges: Array<Maybe<InvoiceNode>>;
  pageInfo: PageInfo;
};

export type InvoiceDetails = {
  __typename?: 'InvoiceDetails';
  amountTax?: Maybe<Scalars['Float']['output']>;
  amountWithoutTax?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
};

export type InvoiceNode = {
  __typename?: 'InvoiceNode';
  cursor: Scalars['String']['output'];
  node: Invoice;
};

export enum InvoiceStatus {
  Open = 'open',
  Paid = 'paid'
}

/** Input parameters for reverting a pending subscription cancellation. */
export type KeepSubscriptionActiveInput = {
  /** The ID of the organization whose pending cancellation should be removed. */
  organizationId: Scalars['OrganizationId']['input'];
};

/** Union type representing either a successful cancellation reversion or an error. */
export type KeepSubscriptionActivePayload = KeepSubscriptionActiveSuccess | VoidMutationError;

/** Successful response when a pending subscription cancellation is removed. */
export type KeepSubscriptionActiveSuccess = {
  __typename?: 'KeepSubscriptionActiveSuccess';
  /** Confirmation that the cancellation was reverted. */
  success: Scalars['Boolean']['output'];
};

/**
 * The landing page the user has chosen to see when entering the product.
 *
 * `default` is a sentinel meaning the user has not explicitly opted in — the
 * client decides where to route them using its current default (which can vary
 * by client and change over time). Storage absence is normalized to `default` by
 * the server.
 */
export enum LandingPage {
  /**
   * The user has not opted into a specific landing page; the client uses its
   * current default route.
   */
  Default = 'default',
  /** Route the user to Buffer Home. */
  Home = 'home'
}

/** Error when trying to demote the last admin */
export type LastAdminError = MutationError & {
  __typename?: 'LastAdminError';
  /** Human-readable error message. */
  message: Scalars['String']['output'];
};

/** The last reply to the comment */
export type LastReply = {
  __typename?: 'LastReply';
  /** Media attachments associated with the comment. */
  assets: Array<Asset>;
  /** Information about the author of the comment. */
  author: CommentAuthor;
  /** The ID of the channel that the comment belongs to. */
  channelId: Scalars['ChannelId']['output'];
  /** The kind of content carried by the comment. */
  contentType: CommentContentType;
  /** The timestamp when the comment was created in the system. */
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the comment */
  id: Scalars['CommentId']['output'];
  /** Whether the comment is deleted by the third party. */
  isDeleted: Scalars['Boolean']['output'];
  /** Whether the comment is hidden. */
  isHidden: Scalars['Boolean']['output'];
  /**
   * Whether this comment is an own reply. The comment has been
   * sent by the user using Buffer or natively.
   */
  isOwnReply: Scalars['Boolean']['output'];
  /** Service-specific metadata for the comment (e.g., Google Business review details). */
  metadata?: Maybe<CommentMetadata>;
  /** The ID of the organization that owns the comment. */
  organizationId: Scalars['OrganizationId']['output'];
  /**
   * The ID of the parent comment, if applicable.
   * We set this value in replies to comments as the id of the replied comment.
   * For top-level comments (replies to post) will be null.
   */
  parentId?: Maybe<Scalars['CommentId']['output']>;
  /** The timestamp when the related post was published on the third-party service. */
  postPublishedAt: Scalars['DateTime']['output'];
  /**
   * URL of the comment on the third-party service. It could be undefined
   * if the comment hasn't be published yet.
   */
  publicUrl?: Maybe<Scalars['String']['output']>;
  /**
   * The timestamp when this comment was created on the third-party service. It could be undefined
   *   if the comment hasn't be published yet.
   */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Describes the status of a comment sent by Buffer to third party
   * and potential errors.
   * It is optional because the reply could be sent by the user using Buffer or natively.
   */
  publishingStatus?: Maybe<PublishingStatus>;
  /** Reactions to the comment. */
  reactions: Array<Reaction>;
  /**
   * The time difference in seconds between the comment's publication and a response.
   * For top-level comments is the difference between post's publication and this
   * comment's creation, calculated even if the comment fails to be sent.
   */
  responseTimeDiffInSeconds: Scalars['Int']['output'];
  /** The type of service the comment belongs to: threads, facebook, etc */
  serviceType: Service;
  /** The status of the comment (e.g., unreplied, replied, dismissed). */
  status: CommentStatus;
  /**
   * The text content of the comment. It could be empty. Comments could have
   * text and/or assets and we're making them both mandatory to avoid the case
   * where none of them could be provided.
   */
  text: Scalars['String']['output'];
  /** The timestamp when the comment was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /**
   * User rating for review-based platforms (e.g., Google Business star ratings).
   * Integer value typically 1-5. Only applicable for platforms that support reviews with ratings.
   * @deprecated Use metadata { ... on GoogleBusinessCommentMetadata { userRating } }
   */
  userRating?: Maybe<Scalars['Int']['output']>;
};

/** Caps the character length of a text-like property (e.g. 280 for X post text). */
export type LengthRule = ValidationRule & {
  __typename?: 'LengthRule';
  /** Maximum allowed character length. */
  maxLength: Scalars['Int']['output'];
  /** The content property this rule constrains. */
  property: ContentProperty;
};

export type LifetimeConnectedChannelCount = {
  __typename?: 'LifetimeConnectedChannelCount';
  service?: Maybe<Service>;
  serviceIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** A cumulative metric representing lifetime activity for an organization. */
export type LifetimeUsageMetric = {
  __typename?: 'LifetimeUsageMetric';
  /** The lifetime total. */
  total: Scalars['Int']['output'];
};

/** Configuration for liking comments */
export type Liking = {
  __typename?: 'Liking';
  /**
   * The generic icon for the resting state reaction button.
   * @deprecated Use reactionsConfiguration for full reaction support.
   */
  icon: LikingIcon;
  /**
   * Network-specific reaction configuration.
   * Null for channels that don't support reactions.
   * When present, clients should use this instead of icon + supportLiking.
   */
  reactionsConfiguration?: Maybe<ReactionConfiguration>;
  /** Whether the channel supports liking comments */
  supportLiking: Scalars['Boolean']['output'];
};

/** Icon options for liking comments */
export enum LikingIcon {
  /** Heart icon */
  Heart = 'heart',
  /** Star icon */
  Star = 'star',
  /** Thumbs up icon */
  ThumbsUp = 'thumbsUp'
}

/** Error returned when the limit is reached */
export type LimitReachedError = MutationError & {
  __typename?: 'LimitReachedError';
  /** Error message */
  message: Scalars['String']['output'];
};

/** Link attached to the post */
export type LinkAssetInput = {
  /** Description of the link */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Thumbnail URL of the link */
  thumbnailUrl?: InputMaybe<Scalars['String']['input']>;
  /** Title of the link */
  title?: InputMaybe<Scalars['String']['input']>;
  /** URL to the link */
  url: Scalars['String']['input'];
};

/** Link attachment */
export type LinkAttachment = ScrapedLink & {
  __typename?: 'LinkAttachment';
  /** Full URL that the link asset has been built from */
  expandedUrl?: Maybe<Scalars['String']['output']>;
  /** Description for the scraped link */
  text: Scalars['String']['output'];
  /** Selected thumbnail for this link preview */
  thumbnail?: Maybe<Scalars['String']['output']>;
  /** Thumbnails of media available in the link */
  thumbnails: Array<Scalars['String']['output']>;
  /** Title for the link attachment */
  title: Scalars['String']['output'];
  /** URL that the link asset has been built from */
  url: Scalars['String']['output'];
};

/** Link attachment */
export type LinkAttachmentInput = {
  /** Description shown on the link card */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Thumbnail shown on the link card */
  thumbnail?: InputMaybe<LinkAttachmentThumbnailInput>;
  /** Title shown on the link card */
  title?: InputMaybe<Scalars['String']['input']>;
  /** URL that the link asset has been built from */
  url: Scalars['String']['input'];
};

/** Thumbnail of a link attachment */
export type LinkAttachmentThumbnailInput = {
  /** URL of the thumbnail image */
  url: Scalars['String']['input'];
};

export type LinkInput = {
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<MediaInput>;
  order?: InputMaybe<Scalars['Int']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** A Stripe Link payment method. */
export type LinkPaymentMethodDetails = {
  __typename?: 'LinkPaymentMethodDetails';
  /** A human-readable description of the Link account. */
  displayName: Scalars['String']['output'];
  /** The email address associated with the Link account. */
  email: Scalars['String']['output'];
};

/** Input to configure link shortening domain */
export type LinkShortenerConfigInput = {
  /**
   * The domain of the link shortening service. Either buff.ly, dub.co,
   * or a user defined shortener based on an integration
   */
  domain: Scalars['String']['input'];
  /** The human readable name of the shortener */
  name: Scalars['String']['input'];
};

/** Link Shortening Configuration */
export type LinkShorteningConfig = {
  __typename?: 'LinkShorteningConfig';
  /**
   * Domain of the link shortener - eg buff.ly, dub.co,
   * or the user's custom domain.
   */
  domain: Scalars['String']['output'];
  /**
   * Human readable string to describe the link shortening
   * service.
   */
  name: Scalars['String']['output'];
};

/** Input to configure link shortening */
export type LinkShorteningSettingsInput = {
  /** Channel to update settings for */
  channelId: Scalars['ChannelId']['input'];
  /**
   * Configuration for the link shortener service. Leave blank
   * if shortening is not enabled
   */
  config?: InputMaybe<LinkShortenerConfigInput>;
  /** Setting to control if user links should be shortened or not */
  isEnabled: Scalars['Boolean']['input'];
  /** Organization to update settings for */
  organizationId: Scalars['OrganizationId']['input'];
};

export type LinkedInAnnotation = {
  __typename?: 'LinkedInAnnotation';
  entity: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  length: Scalars['Int']['output'];
  link: Scalars['String']['output'];
  localizedName: Scalars['String']['output'];
  start: Scalars['Int']['output'];
  vanityName: Scalars['String']['output'];
};

/** LinkedIn metadata */
export type LinkedInMetadata = {
  __typename?: 'LinkedInMetadata';
  /** Property parsed from scopes indicating whether the client should show the LinkedIn analytics refresh banner */
  shouldShowLinkedinAnalyticsRefreshBanner: Scalars['Boolean']['output'];
};

/** LinkedIn post metadata */
export type LinkedInPostMetadata = CommonPostMetadata & {
  __typename?: 'LinkedInPostMetadata';
  /** Annotations representing entities in the text */
  annotations: Array<Annotation>;
  /** LinkedIn post's first comment */
  firstComment?: Maybe<Scalars['String']['output']>;
  /** Link attachment */
  linkAttachment?: Maybe<LinkAttachment>;
  /** The channel-specific type of the post, eg, post, story, reel for Instagram */
  type: PostType;
};

/** LinkedIn post metadata */
export type LinkedInPostMetadataInput = {
  /** Annotations representing entities in the text */
  annotations?: InputMaybe<Array<AnnotationInputLinkedIn>>;
  /** LinkedIn post's first comment */
  firstComment?: InputMaybe<Scalars['String']['input']>;
  /** Link attachment. Mutually exclusive with a non-empty `assets` array — input providing both is rejected. */
  linkAttachment?: InputMaybe<LinkAttachmentInput>;
};

/** A claimed LinkedIn Premium promo code */
export type LinkedInPremiumPromoCode = {
  __typename?: 'LinkedInPremiumPromoCode';
  /** The promo code string */
  code: Scalars['String']['output'];
  /** LinkedIn redemption URL where user can activate the promo */
  linkedInRedemptionUrl: Scalars['URL']['output'];
};

/** LinkedIn Premium promo code eligibility response */
export type LinkedInPremiumPromoCodeEligibility = {
  __typename?: 'LinkedInPremiumPromoCodeEligibility';
  /** Whether the user is eligible to claim a promo code */
  isEligible: Scalars['Boolean']['output'];
};

/** Input for checking LinkedIn Premium promo code eligibility */
export type LinkedInPremiumPromoCodeEligibilityInput = {
  /** The accountId of the account to check promo code eligibility */
  accountId: Scalars['AccountId']['input'];
};

/** A LinkedIn-branded reaction. Clients should render the image URL directly. */
export type LinkedInReaction = {
  __typename?: 'LinkedInReaction';
  /** URL of the reaction image to render directly. */
  image: Scalars['String']['output'];
  /** The type of reaction. */
  reactionType: ReactionType;
};

export type LinkedinData = {
  __typename?: 'LinkedinData';
  comment_text?: Maybe<Scalars['String']['output']>;
};

/** Location data about the channel */
export type LocationData = {
  __typename?: 'LocationData';
  /** Google Account Id of the business */
  googleAccountId?: Maybe<Scalars['String']['output']>;
  /** Location of the business associated with the channel */
  location?: Maybe<Scalars['String']['output']>;
  /** Link to the map */
  mapsLink?: Maybe<Scalars['String']['output']>;
};

export type LocationDataInput = {
  googleAccountId?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  mapsLink?: InputMaybe<Scalars['String']['input']>;
};

export type LocationPayload = {
  __typename?: 'LocationPayload';
  country?: Maybe<Scalars['String']['output']>;
};

/** Allowed values for the login verification method */
export enum LoginVerificationMethod {
  Email = 'email',
  Push = 'push'
}

/** completeLoginVerification response payload */
export type LoginVerificationResponsePayload = EmptySuccess | UnexpectedError;

/**
 * Deprecated in favor of WebBillingDetails / MobileBillingDetails.
 * Retained for legacy web + mobile consumers and will be removed once they migrate off.
 */
export type MpBilling = Billing & {
  __typename?: 'MPBilling';
  /** Describes the billing address of the customer */
  address?: Maybe<Address>;
  /** Any credit (negative balance) or debit (positive balance) a customer might have */
  balance: Scalars['Float']['output'];
  /** This URL is used to redirect the user to the appropriate billing page, when the OB plan selector is triggered. */
  billingRedirectUrl: Scalars['String']['output'];
  /** @deprecated Use `Organization.entitlements` and check for `analytics` instead. This field is computed from the same entitlement set. */
  canAccessAnalytics: Scalars['Boolean']['output'];
  /** @deprecated Use `Organization.entitlements` and check for `engagement` instead. This field is computed from the same entitlement set. */
  canAccessEngagement: Scalars['Boolean']['output'];
  /** @deprecated Use `Organization.entitlements` and check for `publishing` instead. This field is computed from the same entitlement set. */
  canAccessPublishing: Scalars['Boolean']['output'];
  canGenerateContent: Scalars['Boolean']['output'];
  /** Describes any discount coupon a customer might have */
  discount?: Maybe<Discount>;
  gateway: GatewayDetails;
  /** Organization ID for which these billing details belong to */
  id: Scalars['String']['output'];
  /** Describes whether the customer is eligible for automatic tax collection in Stripe */
  isAutomaticTaxEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Describes whether the customer's subscription is eligible for automatic tax collection in Stripe */
  isSubscriptionTaxEnabled?: Maybe<Scalars['Boolean']['output']>;
  paymentDetails: PaymentDetails;
  previousGateway?: Maybe<GatewayDetails>;
  subscriptions: Array<MpSubscription>;
  /** Describes tax details for the Stripe customer */
  taxDetails?: Maybe<TaxDetails>;
  /** Describes customer's tax exemption status */
  taxExempt?: Maybe<Scalars['String']['output']>;
  /** Describes tax ids customer might have */
  taxIds?: Maybe<Array<Maybe<TaxId>>>;
  upcomingInvoice?: Maybe<InvoiceDetails>;
  upcomingInvoiceAmount?: Maybe<Scalars['Float']['output']>;
};

export type MpSubscription = GenericSubscription & {
  __typename?: 'MPSubscription';
  interval: BillingInterval;
  /** Indicates if a subscription is going to be canceled at the end of its period */
  isCanceledAtPeriodEnd: Scalars['Boolean']['output'];
  /** The UTC DateTime of the subscription period end */
  periodEnd?: Maybe<Scalars['DateTime']['output']>;
  plan: Scalars['String']['output'];
  product: Product;
  trial?: Maybe<Trial>;
};

/**
 * Filters for the Template Manager CMS list. All filters are optional and
 * combined with AND logic.
 */
export type ManagedPostTemplatesFilterInput = {
  /** Filter by the goal or intent of the template. */
  goal?: InputMaybe<PostTemplateGoal>;
  /** Filter by the structural format of the template. */
  structure?: InputMaybe<PostTemplateStructure>;
  /** Filter by the type or category of the template. */
  type?: InputMaybe<PostTemplateType>;
  /** Filter by the target user type. */
  userType?: InputMaybe<PostTemplateUserType>;
  /** Filter by the visibility level of the template. */
  visibility?: InputMaybe<PostTemplateVisibility>;
};

/**
 * Input for fetching a paginated list of post templates for the
 * Buffer-internal Template Manager CMS. Callers must be authorized via
 * `assertCanManagePostTemplates`; the optional `organizationId` narrows
 * the result to one org, otherwise managers see templates across all
 * orgs.
 */
export type ManagedPostTemplatesInput = {
  /** Optional filters to narrow the template list. */
  filter?: InputMaybe<ManagedPostTemplatesFilterInput>;
  /**
   * Organization to scope the result to. When provided, filters by
   * `template.organizationId` regardless of visibility (managers see
   * every template created within that org). When omitted, returns
   * templates from all orgs — used for cross-org moderation flows.
   */
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
};

/** Input for `Mutation.markBufferHomeTaskComplete`. */
export type MarkBufferHomeTaskCompleteInput = {
  /** The organization whose task is being marked complete. */
  organizationId: Scalars['OrganizationId']['input'];
  /** The task being marked complete. */
  taskKey: BufferHomeTaskKey;
};

/** All possible response types for the `markBufferHomeTaskComplete` mutation. */
export type MarkBufferHomeTaskCompletePayload = MarkBufferHomeTaskCompleteSuccess | VoidMutationError;

/**
 * Successful result of `Mutation.markBufferHomeTaskComplete`. Returns the
 * updated checklist so Apollo's cache for the same root query merges
 * naturally.
 */
export type MarkBufferHomeTaskCompleteSuccess = {
  __typename?: 'MarkBufferHomeTaskCompleteSuccess';
  /** The full checklist for the organization after the mutation. */
  bufferHomeChecklist: BufferHomeChecklist;
};

/** Input for markChangelogEntryAsSeen mutation */
export type MarkChangelogEntryAsSeenInput = {
  /** The id of the changelog entry to mark as seen */
  id: Scalars['ChangelogEntryId']['input'];
};

/** Mutation Response: Success and errors */
export type MarkChangelogEntryAsSeenPayload = MarkChangelogEntryAsSeenSuccess | VoidMutationError;

/** Success response for markChangelogEntryAsSeen mutation */
export type MarkChangelogEntryAsSeenSuccess = {
  __typename?: 'MarkChangelogEntryAsSeenSuccess';
  /** The id of the marked changelog entry */
  id: Scalars['ChangelogEntryId']['output'];
};

/** Advance the current account's read position through a Note on a Post. */
export type MarkCollaborationNotesReadInput = {
  /** The Post whose Notes to mark as read. */
  postId: Scalars['PostId']['input'];
  /** The last Note to mark as read. */
  throughNoteId: Scalars['NoteId']['input'];
};

/** The possible results from marking collaboration Notes as read. */
export type MarkCollaborationNotesReadPayload = MarkCollaborationNotesReadSuccess | VoidMutationError;

/** The result of marking collaboration Notes as read. */
export type MarkCollaborationNotesReadSuccess = {
  __typename?: 'MarkCollaborationNotesReadSuccess';
  /** The Post with its updated Note summary. */
  post: Post;
  /** The updated read position. */
  readState: CollaborationNotesReadState;
};

/** Move the current account's read position before a Note on a Post. */
export type MarkCollaborationNotesUnreadInput = {
  /** The first Note to mark as unread. */
  fromNoteId: Scalars['NoteId']['input'];
  /** The Post whose Notes to mark as unread. */
  postId: Scalars['PostId']['input'];
};

/** The possible results from marking collaboration Notes as unread. */
export type MarkCollaborationNotesUnreadPayload = MarkCollaborationNotesUnreadSuccess | VoidMutationError;

/** The result of marking collaboration Notes as unread. */
export type MarkCollaborationNotesUnreadSuccess = {
  __typename?: 'MarkCollaborationNotesUnreadSuccess';
  /** The Post with its updated Note summary. */
  post: Post;
  /** The updated read position. */
  readState: CollaborationNotesReadState;
};

export type MarkNoteAuthorAsDeletedForOrganizationError = {
  __typename?: 'MarkNoteAuthorAsDeletedForOrganizationError';
  cause: Scalars['String']['output'];
};

export type MarkNoteAuthorAsDeletedForOrganizationResponse = MarkNoteAuthorAsDeletedForOrganizationError | MarkNoteAuthorAsDeletedForOrganizationSuccessResponse;

export type MarkNoteAuthorAsDeletedForOrganizationSuccessResponse = {
  __typename?: 'MarkNoteAuthorAsDeletedForOrganizationSuccessResponse';
  success: Scalars['Boolean']['output'];
};

/** Mastodon metadata */
export type MastodonMetadata = {
  __typename?: 'MastodonMetadata';
  /** Maximum character limit allowed for this channel's server instance */
  maxCharacters: Scalars['Int']['output'];
  /** The instance of mastodon of the channel */
  serverUrl: Scalars['String']['output'];
};

/** Mastodon post metadata */
export type MastodonPostMetadata = CommonPostMetadata & ThreadedPostMetadata & {
  __typename?: 'MastodonPostMetadata';
  /** Annotations representing entities in the text */
  annotations: Array<Annotation>;
  /** Spoiler text hiding the root text of this post */
  spoilerText?: Maybe<Scalars['String']['output']>;
  /** The list of threaded posts (not paginated) */
  thread: Array<ThreadedPost>;
  /** The number of threaded posts */
  threadCount: Scalars['Int']['output'];
  /** The channel-specific type of the post, eg, post, story, reel for Instagram */
  type: PostType;
};

/** Mastodon post metadata */
export type MastodonPostMetadataInput = {
  /** Spoiler text hiding the root text of this post */
  spoilerText?: InputMaybe<Scalars['String']['input']>;
  /**
   * The ordered list of posts that make up the thread (not paginated). This
   * array is the source of truth for what gets published: every post in the
   * thread, including the root post, must be provided here. Posts are
   * published in order, each replying to the previous one. The first item is
   * the root post and should match the top-level `text` on the post input.
   */
  thread?: InputMaybe<Array<ThreadedPostInput>>;
};

/**
 * Media configuration for an engagement type — whether media attached to an
 * engagement reaches Buffer and can therefore be shown to the user.
 */
export type MediaConfiguration = {
  __typename?: 'MediaConfiguration';
  /**
   * User-facing explanation of what the client can do about the missing media,
   * worded for the platform (e.g. "Instagram doesn't send media with mentions to
   * Buffer. Open the mention natively to see the full content."). Display text
   * only — not a stable machine key, so clients must not parse or switch on it.
   * Null when `supportsMedia` is true.
   */
  additionalInformation?: Maybe<Scalars['String']['output']>;
  /**
   * User-facing explanation of why media isn't shown. Display text only — not a
   * stable machine key, so clients must not parse or switch on it. Null when
   * `supportsMedia` is true.
   */
  disclaimer?: Maybe<Scalars['String']['output']>;
  /**
   * Whether media attached to this engagement type is delivered by the platform
   * and can be shown.
   */
  supportsMedia: Scalars['Boolean']['output'];
};

/** Media formats a `FormatRule` can allow-list. Grows additively. */
export enum MediaFormat {
  Gif = 'gif',
  Jpeg = 'jpeg',
  Mov = 'mov',
  Mp4 = 'mp4',
  Pdf = 'pdf',
  Png = 'png',
  Webm = 'webm'
}

export type MediaInput = {
  altText?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** The type of media attached to a post */
export enum MediaType {
  Document = 'document',
  Gif = 'gif',
  Image = 'image',
  Link = 'link',
  Unsupported = 'unsupported',
  Video = 'video'
}

/** Input for a member's per-product channel permission */
export type MemberChannelPermissionInput = {
  /** The Account ID of the team member */
  accountId: Scalars['AccountId']['input'];
  /**
   * Per-product access levels to grant for this member on the channel. An
   * assignment whose every product is `none` removes the member's access to
   * the channel. The FE maps the current single-dropdown UI onto `publish`
   * and sends `comments: none` until the per-product UI lands.
   */
  productAccessLevels: ChannelProductAccessLevelsInput;
};

/** Represents the members connection edge. Later, we can add the list of members with the page info to follow our connection edge pattern. */
export type MemberConnection = {
  __typename?: 'MemberConnection';
  /** The total count of team members counting the org owner and team members from the Publish DB. */
  totalCount: Scalars['Int']['output'];
};

/**
 * A mention-shaped engagement. Covers third-party mentions, surrounding
 * context items inside a mention thread, and Buffer-sent replies.
 * Use `isOwnEngagement` (from the `Engagement` interface) to branch on own/others.
 */
export type Mention = Engagement & {
  __typename?: 'Mention';
  /** Media attached to the mention. */
  assets: Array<Asset>;
  /** Author of the mention. */
  author: EngagementAuthor;
  /** Channel (Buffer-managed social account) this mention was received on. */
  channelId: Scalars['ChannelId']['output'];
  /** Content format of this mention. */
  contentType: EngagementContentType;
  /** When this mention was first ingested into Buffer. */
  createdAt: Scalars['DateTime']['output'];
  /** When the user dismissed this mention. */
  dismissedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier of this mention. */
  id: Scalars['EngagementId']['output'];
  /** `true` when this mention was sent by the user via Buffer or natively; `false` when it's a third-party mention. */
  isOwnEngagement: Scalars['Boolean']['output'];
  /** What network item the mention is on (post / comment / story). */
  mentionType: MentionContextType;
  /** Organization this mention belongs to. */
  organizationId: Scalars['OrganizationId']['output'];
  /** Parent engagement id when this item is a reply inside a thread. Null for root-level mentions. */
  parentId?: Maybe<Scalars['EngagementId']['output']>;
  /** Public URL of this mention on the network. Falls back to the channel URL when unavailable. */
  publicUrl: Scalars['String']['output'];
  /** When the mention was published on the network. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Buffer publishing status. Only set when this mention is a Buffer-sent reply. */
  publishingStatus?: Maybe<PublishingStatus>;
  /** Reactions received on this mention. */
  reactions: Array<Reaction>;
  /** When the user replied to this mention. */
  repliedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Seconds elapsed between the mention being published and the user first replying. */
  responseTimeDiffInSeconds: Scalars['Int']['output'];
  /** Network this mention lives on (instagram, facebook, twitter, …). */
  serviceType: Service;
  /** Current lifecycle status of the mention. */
  status: EngagementStatus;
  /** AI-generated quick-reply suggestions. Null for own mentions or when suggestions haven't been generated yet. */
  suggestions: Array<Suggestion>;
  /** Text body of the mention. Null for media-only mentions. */
  text?: Maybe<Scalars['String']['output']>;
  /** Last time the mention record was updated (re-ingestion, status change, etc.). */
  updatedAt: Scalars['DateTime']['output'];
};

/** What kind of network item this mention lives on. */
export enum MentionContextType {
  /** The mention was made on a comment. */
  Comment = 'comment',
  /** The mention was made on a post. */
  Post = 'post',
  /** The mention was made on a story (ephemeral content, e.g. Instagram/Facebook stories). */
  Story = 'story'
}

/** The type of mention to use for the channel. */
export enum MentionType {
  /** The mention is a handler. E.g. a user mention in LinkedIn. */
  Handler = 'handler',
  /** The mention is a text. E.g. a user mention in Threads or Instagram. */
  Text = 'text'
}

/**
 * How the Community mentions indicator is displayed. `counter` shows the exact
 * number of unread mentions; `dot` shows a lightweight indicator without a count,
 * which keeps the indicator manageable for large accounts.
 */
export enum MentionsCounterDisplay {
  Counter = 'counter',
  Dot = 'dot'
}

/** One DM chat. */
export type MessageConversation = Conversation & {
  __typename?: 'MessageConversation';
  /** Our connected channel the conversation happens on. */
  channelId: Scalars['ChannelId']['output'];
  /** Unique identifier of the conversation. Not an EngagementId. */
  id: Scalars['ConversationId']['output'];
  /** `true` for a group chat, `false` for a 1:1 chat. */
  isGroup: Scalars['Boolean']['output'];
  /** Muted: no notifications are sent for this conversation. */
  isMuted: Scalars['Boolean']['output'];
  /** Marked as spam. Set by a teammate by hand today; nothing derives it. */
  isSpam: Scalars['Boolean']['output'];
  /** Starred by a teammate. */
  isStarred: Scalars['Boolean']['output'];
  /** Newest item in the conversation, inbound or outbound. */
  lastActivityAt: Scalars['DateTime']['output'];
  /** Newest item not authored by us. Null until the counterpart writes. */
  lastInboundAt?: Maybe<Scalars['DateTime']['output']>;
  /** Organization the conversation belongs to. */
  organizationId: Scalars['OrganizationId']['output'];
  /** Everyone who has authored an item, plus the owning channel. */
  participants: Array<ConversationParticipant>;
  /** One-line summary for the card. Null while there is no renderable item. */
  preview?: Maybe<ConversationPreview>;
  /** Organization-wide read state. */
  readState: ConversationReadState;
  /** Time left to reply. Non-null: every network we support imposes a window on DMs. */
  replyWindow: ReplyWindow;
  /**
   * The conversation key, unique per channel: the counterpart for a 1:1 chat,
   * the thread for a group.
   */
  rootUrn: Scalars['URN']['output'];
  /** Network of the channel. */
  serviceType: Service;
  /** Workflow state of the conversation. */
  status: ConversationStatus;
};

export enum MigrationMarketingFeature {
  AdvancedInstagramFeatures = 'advancedInstagramFeatures',
  BestTimeToPost = 'bestTimeToPost',
  CampaignAnalytics = 'campaignAnalytics',
  ComprehensiveAnalytics = 'comprehensiveAnalytics',
  CustomisableReports = 'customisableReports',
  EngagementTools = 'engagementTools',
  HashtagManager = 'hashtagManager',
  OrganicAndBoostedPosts = 'organicAndBoostedPosts',
  PerChannelPricing = 'perChannelPricing',
  PublishingTools = 'publishingTools'
}

export type MigrationMarketingFeaturesCopy = {
  __typename?: 'MigrationMarketingFeaturesCopy';
  id: MigrationMarketingFeature;
  tagline: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type MigrationPlan = {
  __typename?: 'MigrationPlan';
  interval: BillingInterval;
  name: Scalars['String']['output'];
  /** The UTC DateTime of the MP subscription period end. Suggested plan does not have periodEnd */
  periodEnd?: Maybe<Scalars['DateTime']['output']>;
  supportedFeatures: Array<Maybe<MigrationMarketingFeature>>;
};

export type MigrationSummary = {
  __typename?: 'MigrationSummary';
  baseMonthlyPrice?: Maybe<Scalars['Float']['output']>;
  basePlanPrice?: Maybe<Scalars['Float']['output']>;
  channelCount?: Maybe<Scalars['Int']['output']>;
  details?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  migrationPreview?: Maybe<PlanMigrationPreview>;
  totalPrice?: Maybe<Scalars['Float']['output']>;
};

/**
 * Billing information for organizations on mobile gateways (RevenueCat, Apple, Android).
 * Subscription management happens through the respective app store; detailed payment
 * and tax information is not available from mobile platforms.
 */
export type MobileBillingDetails = BillingDetails & {
  __typename?: 'MobileBillingDetails';
  /**
   * The email address used for billing notifications (invoices, payment failures, etc.).
   * Returns the custom billing email if set, otherwise the organization owner's email.
   */
  billingEmail: Scalars['String']['output'];
  /** Whether this organization is eligible to start a free trial. */
  canStartTrial: Scalars['Boolean']['output'];
  /** The current billing gateway processing payments for this organization. */
  gateway: BillingGatewayDetails;
  /** Whether this organization has ever had a paid subscription, across any gateway. */
  hasEverBeenPayingCustomer: Scalars['Boolean']['output'];
  /**
   * The mobile platform this subscription was purchased on.
   * Used by mobile apps to determine store-specific messaging
   * (e.g. "Manage in App Store" vs "Google Play Store") and upgrade eligibility.
   */
  platform: BillingGatewayPlatform;
  /**
   * The previous billing gateway, if the organization has migrated between platforms.
   * Null if no migration has occurred.
   */
  previousGateway?: Maybe<BillingGatewayDetails>;
  /** The organization's current subscription, including plan, billing cycle, and trial status. */
  subscription: BufferSubscription;
};

export enum MonthName {
  April = 'April',
  August = 'August',
  December = 'December',
  February = 'February',
  January = 'January',
  July = 'July',
  June = 'June',
  March = 'March',
  May = 'May',
  November = 'November',
  October = 'October',
  September = 'September'
}

/** Input for moving a feed collection */
export type MoveFeedCollectionInput = {
  /** Feed Collection that is being moved */
  id: Scalars['FeedCollectionId']['input'];
  /** The organization that the feed collection will belong to */
  organizationId: Scalars['OrganizationId']['input'];
  /** Feed or FeedCollection the feed should come after. If null, it will be placed at the start */
  placeAfterId?: InputMaybe<Scalars['String']['input']>;
};

/** Input for moving a feed */
export type MoveFeedInput = {
  /** FeedCollection the Feed should be stored in */
  collectionId?: InputMaybe<Scalars['FeedCollectionId']['input']>;
  /** Feed that is being moved */
  id: Scalars['FeedId']['input'];
  /** The organization that the feed collection will belong to */
  organizationId: Scalars['OrganizationId']['input'];
  /** Feed or FeedCollection the feed should come after. If null, it will be placed at the start */
  placeAfterId?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for moving an idea group. */
export type MoveIdeaGroupInput = {
  /** Unique identifier for the idea group. */
  id: Scalars['ID']['input'];
  /** Unique identifier of the idea group to place this group after. */
  placeAfterId?: InputMaybe<Scalars['ID']['input']>;
};

/** Union type representing possible payloads for moving an idea group. */
export type MoveIdeaGroupPayload = InvalidInputError | MoveIdeaGroupResponse | NotFoundError | UnauthorizedError | UnexpectedError;

/** Response type for moving an idea group. */
export type MoveIdeaGroupResponse = {
  __typename?: 'MoveIdeaGroupResponse';
  /** The reordered idea groups. */
  ideaGroups: Array<IdeaGroup>;
};

/** moveIdea input type */
export type MoveIdeaInput = {
  /** Call-to-action identifier for analytics tracking */
  cta?: InputMaybe<Scalars['String']['input']>;
  /** Target group ID (null moves to unassigned) */
  groupId?: InputMaybe<Scalars['ID']['input']>;
  /** ID of the idea to move */
  ideaId: Scalars['ID']['input'];
  /** ID of the idea to place this idea after (null places at top) */
  placeAfterId?: InputMaybe<Scalars['ID']['input']>;
};

/** moveIdea response (including errors) */
export type MoveIdeaPayload = MoveIdeaResponse | UnexpectedError;

/** moveIdea response type */
export type MoveIdeaResponse = {
  __typename?: 'MoveIdeaResponse';
  /** List of ideas that were affected by the move operation */
  updatedIdeas: Array<Idea>;
};

/** movePostInQueue mutation moves a queued post to the top or bottom of its channel's queue. */
export type MovePostInQueueInput = {
  /** ID of the post to move. */
  id: Scalars['PostId']['input'];
  /** Target position within the channel's queue. */
  position: QueuePosition;
};

/** All possible response types that can be returned by movePostInQueue mutation. */
export type MovePostInQueuePayload = PostActionSuccess | VoidMutationError;

/** All possible response types that can be returned by movePostToDraftsV2 mutation. */
export type MovePostToDraftsResult = NotFoundError | PostActionSuccess | RestProxyError | UnauthorizedError | UnexpectedError;

/** movePostToDraftsV2 mutation moves a post to drafts by id. */
export type MovePostToDraftsV2Input = {
  /** Post id to move to drafts. */
  id: Scalars['PostId']['input'];
};

/** Root mutation type for team management operations. */
export type Mutation = {
  __typename?: 'Mutation';
  /**
   * Accept a pending invitation. Verifies the JWT, requires the authed
   * user's email to match the invited email, writes permissions, sets the
   * user's currentOrganization to the inviting org, and deletes the
   * invitation document. When the inviting org enforces two-factor
   * authentication and the accepter hasn't enabled it, returns
   * `TwoFactorSetupRequiredError` so the client can run 2FA setup and
   * retry.
   */
  acceptInvitation: AcceptInvitationPayload;
  accountCompleteEmailVerification: AccountCompleteEmailVerification;
  accountInitiateEmailVerification: AccountInitiateEmailVerificationPayload;
  accountRemove: AccountRemovePayload;
  accountSetAvatar: Scalars['Boolean']['output'];
  accountSetCurrentOrganization: Scalars['Boolean']['output'];
  accountSetSettings: AccountSetSettingsPayload;
  accountSuspend: AccountSuspendResponse;
  accountUnsuspend: AccountUnsuspendResponse;
  /**
   * Changes account role for a given account. Can be either "customer" or "admin",
   * with "admin" only being set for Buffer employees.
   */
  accountUpdateRole: AccountUpdateRoleResponse;
  addBlock?: Maybe<BlockMutationResponse>;
  addBlocks?: Maybe<BlockMutationResponse>;
  addChildBlock?: Maybe<BlockMutationResponse>;
  /** @deprecated Use the new addNoteToPost mutation */
  addEntityNote: AddEntityNotePayload;
  /** Add a note on a post */
  addNoteToPost: AddNoteToPostPayload;
  addOrUpdateDismissedObject: AddOrUpdateDismissedObjectPayload;
  addOrganizationToBetaProgram: MutationBasicPayload;
  /**
   * Add a post that already exists to a content item. The mutation creates no
   * post. To add a new post, call createPost first.
   */
  addPostToContentItem: AddPostToContentItemPayload;
  /** Schedule the post to the next available slot. */
  addPostToQueue: AddPostToQueuePayload;
  /** Add Shop Grid Custom link */
  addShopGridCustomLink: ShopGridCustomLinksMutationPayload;
  /** Approve post request. */
  approvePost: ApprovePostPayload;
  /** @deprecated deprecated in favor of channelsConnectionRefresh */
  authorizeChannels: AuthorizeChannelsPayload;
  /** Backfill channel posts and analytics data */
  backfillChannelAnalytics: BackfillChannelAnalyticsPayload;
  /**
   * Backfills channel analytics, posts and post analytics, were applicable.
   * It takes care of triggering both the new ingestion pipeline (buffer-mono) and
   * the legacy one (buffer-analytics).
   */
  backfillChannelPostsAndAnalytics: BackfillChannelPostsAndAnalyticsPayload;
  /** @deprecated Use `backfillChannelPostsAndAnalytics` instead. */
  backfillChannelUpdates: BackfillChannelUpdatesResponse;
  /**
   * Backfill natively posted updates for the grid preview.
   * Accessible only for internal clients, and rate-limited mutation.
   */
  backfillUpdatesForGrid: BackfillUpdatesForGridPayload;
  banStartPagesForOrg?: Maybe<StartPageMutationResponse>;
  /** @deprecated Use the createCustomerPortalSession mutation instead */
  billingCreateCustomerPortalSession: BillingCreateCustomerPortalSessionPayload;
  /** @deprecated This endpoint has been deprecated */
  billingCreateSetupIntent: BillingCreatedSetupIntentPayload;
  /** @deprecated deprecated in favor of startTrial */
  billingStartTrial: BillingStartTrialPayload;
  /** @deprecated This endpoint has been deprecated */
  billingUpdateCustomerPaymentMethod: BillingUpdateCustomerPaymentMethodPayload;
  /** @deprecated deprecated in favor of updateBillingSubscriptionPlan */
  billingUpdateSubscriptionPlan: BillingUpdateSubscriptionPlanPayload;
  /** Cancel recurrence on a post */
  cancelPostRecurrence: CancelPostRecurrencePayload;
  /** Cancel a trial for an organization. */
  cancelTrial: CancelTrialPayload;
  /** List the channels from a service */
  channelConnectionList: ChannelConnectionListPayload;
  /** Reconnect the channels of a service */
  channelConnectionRefresh: ChannelConnectionRefreshPayload;
  channelCreateOrUpdateNativeChannel: ChannelMutationResponse;
  channelStoreTemporaryCredentials: ChannelStoreTemporaryCredentialsResponse;
  channelUpdateLockedStatus: ChannelUpdateLockedStatusResponse;
  /** @deprecated deprecated in favor of authorizeChannels > channelsConnectionRefresh */
  channelsAuthorization: ChannelAuthorizationPayload;
  /** @deprecated deprecated in favor of channelsConnectWithResponse */
  channelsConnect?: Maybe<Scalars['Boolean']['output']>;
  channelsConnectWithResponse: ChannelsConnectPayload;
  /** @deprecated deprecated in favor of channelConnectionList */
  channelsForConnection: CredentialsForChannelsPayload;
  channelsLock?: Maybe<Scalars['Boolean']['output']>;
  channelsLockAllForOrganization?: Maybe<Array<Channel>>;
  /** Recalculate channel lock states for an organization */
  channelsLockForOrganization?: Maybe<Array<Channel>>;
  channelsRemove?: Maybe<Scalars['Boolean']['output']>;
  channelsSetRecommendations: ChannelsSetRecommendationsPayload;
  channelsUpdateCredentials: ChannelsUpdateCredentialsResponse;
  /**
   * Trigger an on-demand evaluation of a channel's verified capabilities
   * (currently LinkedIn profiles only), so a member can see which capabilities
   * they have earned. Rate limited per channel; returns LimitReachedError when
   * the allowance is exhausted.
   */
  checkChannelCapabilities: CheckChannelCapabilitiesPayload;
  /**
   * Claim a LinkedIn Premium promo code
   * Idempotent: returns existing code if user already claimed one
   */
  claimLinkedInPremiumPromoCode: ClaimLinkedInPremiumPromoCodePayload;
  /** Verify an email update by verifying the JWT */
  completeEmailVerification: CompleteEmailVerificationPayload;
  /** Verify a suspicious login attempt by verifying the JWT */
  completeLoginVerification: LoginVerificationResponsePayload;
  /** Record a completed (or skipped) step and advance the flow. */
  completeOnboardingStep: CompleteOnboardingStepPayload;
  /** Complete signup for a new or existing WhatsApp Channel. */
  completeWhatsAppConnection: CompleteWhatsAppConnectionPayload;
  /** Convert custom channel to API-enabled channel (e.g. IG Personal Profile to IG Business) */
  convertCustomChannel: ConvertCustomChannelPayload;
  /** Create a new changelog entry. */
  createChangelogEntry: CreateChangelogEntryPayload;
  /**
   * Request an export of channel analytics data. Returns immediately with a job
   * ID for polling, or a cached result if the same export was recently completed.
   * Duplicate requests for the same filters are deduplicated automatically.
   */
  createChannelAnalyticsExport: CreateChannelAnalyticsExportPayload;
  /** Create a new channel group */
  createChannelGroup: CreateChannelGroupPayload;
  /**
   * Creates a new Stripe Checkout session for creating a subscription.
   * Returns either a success response with a checkout session URL or a billing error.
   */
  createCheckoutSession: CreateCheckoutSessionPayload;
  /** Creates a collaboration Note on a Post. */
  createCollaborationNote: CreateCollaborationNotePayload;
  /**
   * Create a content item together with all of its channel-specific post variants
   * in a single operation. Validation is all-or-nothing: if any variant fails
   * validation, no content item and no variants are created. Variants that fail
   * while being processed after creation are reported per channel in the failure
   * payload; the content item and its variants are still created in that case.
   *
   * This API is an early preview and can change without a deprecation period.
   */
  createContentItem: CreateContentItemPayload;
  /**
   * Create a content item holding a channel-less draft, before any channels
   * are selected. No network-specific validation applies to the draft content.
   * The draft needs text or at least one asset.
   *
   * This API is an early preview and can change without a deprecation period.
   */
  createContentItemDraft: CreateContentItemDraftPayload;
  /** Connect a custom channel (e.g. FB Group or Bluesky) */
  createCustomChannels: CreateCustomChannelsPayload;
  /**
   * Creates a new Stripe Customer Portal session for managing billing settings.
   * Returns either a success response with a portal URL or a billing error.
   */
  createCustomerPortalSession: CreateCustomerPortalSessionPayload;
  /** Create a new feed */
  createFeed: CreateOrUpdateFeedPayload;
  /** Add a create a feed collection */
  createFeedCollection: CreateOrUpdateFeedCollectionPayload;
  /** Create a new idea with the given content and metadata */
  createIdea: CreateIdeaPayload;
  /** Creates a new idea group with the provided input parameters. */
  createIdeaGroup: CreateIdeaGroupPayload;
  /**
   * Create a Buffer-managed post template (CMS). Requires manager
   * authorization via `assertCanManagePostTemplates`.
   */
  createManagedPostTemplate: CreateManagedPostTemplatePayload;
  /** Create post for channel */
  createPost: PostActionPayload;
  /**
   * Create a new post group scoped to an organization, or return the
   * existing one if correlationId is already in use. Authorization is
   * enforced by the underlying use case in @buffer-mono/core-modules.
   */
  createPostGroup: CreatePostGroupPayload;
  /** Create recurrence on a scheduled post */
  createPostRecurrence: CreatePostRecurrencePayload;
  /**
   * Create a post template visible only to the caller (`private`) or to
   * the caller's organization (`internal`).
   */
  createPostTemplate: CreatePostTemplatePayload;
  /** Create a new post template campaign. Requires Account actor. */
  createPostTemplateCampaign: CreatePostTemplateCampaignPayload;
  /** Mutation for adding a saved reply */
  createSavedReply: CreateSavedReplyPayload;
  /** Create a new saved view */
  createSavedView: CreateSavedViewPayload;
  /** Creates a snippet in an organization. */
  createSnippet: CreateSnippetPayload;
  createStartPage?: Maybe<StartPageMutationResponse>;
  /**
   * Create a tag for an organization.
   *
   * The name must be unique within the organization; a duplicate is refused with
   * `DuplicateError`. Creation is refused with `LimitReachedError` once the
   * organization already holds as many tags as its plan allows.
   *
   * This API is an early preview and can change without a deprecation period.
   */
  createTag: CreateTagPayload;
  /** @deprecated deprecated in favor of updateCustomChannel */
  customChannelUpdate: CustomChannelUpdatePayload;
  /** @deprecated deprecated in favor of createCustomChannels */
  customChannelsCreate: CustomChannelsCreatePayload;
  /** Delete an API Client and all associated credentials and grants */
  deleteAPIClient: DeleteApiClientPayload;
  /** Delete an account (by a Buffer Admin) */
  deleteAccount: DeleteAccountPayload;
  /** Delete an internal comment from an account */
  deleteAdminComment: DeleteAdminCommentPayload;
  deleteBlock?: Maybe<BlocksMutationResponse>;
  /** Delete a changelog entry */
  deleteChangelogEntry: DeleteChangelogEntryPayload;
  /** Delete a channel group */
  deleteChannelGroup: DeleteChannelGroupPayload;
  /** Deletes a collaboration Note. */
  deleteCollaborationNote: DeleteCollaborationNotePayload;
  /**
   * Delete a content item: the item itself and any posts created from it.
   * Deletion is all-or-nothing. Every post must be deletable on its own, or
   * nothing is deleted and every blocked post is reported at once. A post can
   * only be deleted while it is a draft, awaiting approval, scheduled, or
   * failed, so an item cannot be deleted while any of its posts is publishing
   * or already published. An item still holding a channel-less draft has no
   * posts, so nothing blocks it. An error can also be reported when a post
   * could not be fully processed after the deletion already took effect;
   * re-fetch before retrying.
   *
   * Deleting a content item also deletes the team notes on the item and on its
   * posts. The notes are removed shortly after the item is deleted.
   *
   * This API is an early preview and can change without a deprecation period.
   */
  deleteContentItem: DeleteContentItemPayload;
  /** @deprecated Use the new deleteNoteFromPost mutation */
  deleteEntityNote: DeleteEntityNotePayload;
  /** Delete a feed */
  deleteFeed: DeleteFeedPayload;
  /** Delete a feed collection */
  deleteFeedCollection: DeleteFeedCollectionPayload;
  /** Deletes an existing idea group based on the provided input parameters. */
  deleteIdeaGroup: DeleteIdeaGroupPayload;
  /** Delete a Buffer-managed post template (soft-delete). */
  deleteManagedPostTemplate: DeleteManagedPostTemplatePayload;
  /** Delete a note from a post */
  deleteNoteFromPost: DeleteNoteFromPostPayload;
  /** Delete a post by id. */
  deletePost: DeletePostPayload;
  /**
   * Delete a post template owned by the caller (or an internal template
   * in the caller's organization, if the caller is an org admin/owner).
   */
  deletePostTemplate: DeletePostTemplatePayload;
  /** Delete a post template campaign (soft-delete). Requires Account actor. */
  deletePostTemplateCampaign: DeletePostTemplateCampaignPayload;
  /**
   * Delete a post by id.
   * @deprecated Use deletePost instead
   */
  deletePostV2: DeletePostResult;
  /** Deletes an existing saved reply. */
  deleteSavedReply: DeleteSavedReplyPayload;
  /** Delete a saved view */
  deleteSavedView: DeleteSavedViewPayload;
  /** Delete Shop Grid Custom link */
  deleteShopGridCustomLink: ShopGridCustomLinksMutationPayload;
  /** Deletes a snippet. */
  deleteSnippet: DeleteSnippetPayload;
  /**
   * Delete a tag.
   *
   * The tag is removed from every post, idea and content item carrying it; those
   * items are otherwise untouched. A locked tag can be deleted, and deleting an
   * unlocked tag frees a slot for the oldest locked one. See `Tag.isLocked`.
   *
   * This API is an early preview and can change without a deprecation period.
   */
  deleteTag: DeleteTagPayload;
  /** Disable Two Factor Authentication with password verification */
  disableTwoFactorWithPassword: DisableTwoFactorWithPasswordPayload;
  /** Mutation for dismissing all comments for a given channel */
  dismissAllCommentsByChannelId: DismissAllCommentsPayload;
  /** Mutation for dismissing all comments for a given organization */
  dismissAllCommentsByOrganizationId: DismissAllCommentsPayload;
  /** Mutation for dismissing all comments for a given post */
  dismissAllCommentsByPostId: DismissAllCommentsPayload;
  /** Mutation for dismissing all comments for a given channel */
  dismissAllCommentsForChannels: DismissAllCommentsForChannelsPayload;
  /**
   * Bulk-dismiss all unreplied engagements across one or more channels.
   * Only mention engagements are supported at M1.
   */
  dismissAllEngagementsByChannelIds: DismissAllEngagementsByChannelIdsPayload;
  dismissBanner: DismissBannerPayload;
  /**
   * Dismiss a Buffer Home first-steps task. Idempotent in the same-state
   * case; transitions a previously-completed task to dismissed (latest
   * action wins).
   */
  dismissBufferHomeTask: DismissBufferHomeTaskPayload;
  /** Dismisses a comment, marking it as read or no longer relevant. */
  dismissComment: DismissCommentPayload;
  /** Dismiss an engagement item (mention or comment) without replying to it. */
  dismissEngagement: DismissEngagementPayload;
  /**
   * Downgrades the organization to the free plan and locks every channel
   * that is not in `channelsToKeep`. When `channelsToKeep` is empty, falls
   * back to the default auto-lock.
   */
  downgradeToFree: DowngradeToFreePayload;
  /** Update post dueAt date. We named it drop because it is called when a user drop a post on an empty slot during drag-and-drop. */
  dropPost: DropPostPayload;
  editBlock?: Maybe<BlockMutationResponse>;
  /** @deprecated Use the new updateNoteOnPost mutation */
  editEntityNote: EditEntityNotePayload;
  /** Edit post for channel */
  editPost: PostActionPayload;
  /** Edit recurrence on a post */
  editPostRecurrence: EditPostRecurrencePayload;
  /** Update the current user's email notification preferences. */
  emailNotificationPreferences: EmailNotificationPreferencePayload;
  /** Explicitly and idempotently enrolls one organization with a native URL. */
  enrollInReferralProgram: EnrollInReferralProgramPayload;
  /**
   * Exchange a Publish access token for a JWT. Used by legacy clients wishing to communicate with the API gateway.
   * [See this document for more information](https://www.notion.so/buffer/Exchanging-an-Access-Token-for-a-JWT-28d4f5dd3ec9401194f1490bc336ce17).
   */
  exchangeAccessTokenForJwt: Scalars['String']['output'];
  exchangeGoogleTokenForBufferAdminJwt: Scalars['String']['output'];
  /** Execute a free tool content generation. */
  executeFreeToolContent: ExecuteFreeToolContentPayload;
  expandPost?: Maybe<TextGenerationResponse>;
  expandText?: Maybe<TextGenerationResponse>;
  /**
   * Force comments backfill for specific channels.
   * This operation triggers a backfill of comments data for the specified channels
   * if they meet certain criteria (supported service types and time thresholds).
   */
  forceCommentsBackfillForChannel: ForceCommentsBackfillForChannelPayload;
  /** Generate access token for a given app using client credentials grant */
  generateAccessToken: GenerateAccessTokenPayload;
  generateAltText?: Maybe<TextGenerationResponse>;
  /**
   * Generates a signed S3 upload form for anonymous media uploads.
   * Uses CAPTCHA validation and IP-based rate limiting.
   */
  generateAnonymousMediaUploadForm: GenerateAnonymousMediaUploadFormPayload;
  generateHellonextSsoTokenForAccount: HellonextSsoMutationResponse;
  generateIdeas?: Maybe<TextGenerationResponse>;
  /** Autogenerate personal access token */
  generatePersonalAccessToken: GeneratePersonalAccessTokenPayload;
  generatePost?: Maybe<TextGenerationResponse>;
  /**
   * Generates AI text completions based on pre-defined templates.
   * Returns either successful completion suggestions or an error.
   */
  generateTemplatedCompletion: GenerateTemplatedCompletionPayload;
  generateText?: Maybe<TextGenerationResponse>;
  /**
   * Generate server-validated options for splitting one composer item into a
   * thread. Product exposure is controlled by the Composer feature gate; this
   * authenticated mutation always enforces organization and channel access.
   */
  generateThreadedPostOptions: GenerateThreadedPostOptionsPayload;
  getAuthorizationJwt: Scalars['String']['output'];
  hideOrShowBlock?: Maybe<BlockMutationResponse>;
  /** @deprecated Use createIdea */
  ideaCreate: IdeaMutationPayload;
  /** @deprecated Use updateIdea */
  ideaUpdate: IdeaMutationPayload;
  ideasRemove: IdeasDeletionPayload;
  /**
   * Increases the subscription quantity by unlocking specific channels.
   * This mutation validates the channels, increases the subscription quantity,
   * and unlocks the channels that were previously locked.
   */
  increaseSubscriptionQuantityByChannelIds: IncreaseSubscriptionQuantityByChannelIdsPayload;
  /** Initiate request flow for updating an account's email address */
  initiateEmailUpdateRequest: InitiateEmailUpdateRequestPayload;
  /** Start a new onboarding flow for the given organization. */
  initiateOnboarding: InitiateOnboardingPayload;
  /** Update Account email */
  initiateUpdateEmail: InitiateUpdateEmailPayload;
  /**
   * Invite one or more team members to the organization in a single
   * batch. Per-email failures are surfaced as `failed` rows in the
   * success payload; only batch-level failures (e.g. team-member-limit
   * reached) collapse to a typed error. The frontend uses this for the
   * single-invite UX too (with a 1-element `invitations` array).
   * Only admins can invite team members.
   */
  inviteTeamMembers: InviteTeamMembersPayload;
  /**
   * Reverts a pending subscription cancellation by setting
   * `cancel_at_period_end: false` on the active Stripe subscription. Only
   * valid when the subscription is currently scheduled to cancel and no
   * Stripe subscription schedule is attached — use removeSubscriptionSchedule
   * for schedule-driven plan changes.
   */
  keepSubscriptionActive: KeepSubscriptionActivePayload;
  /**
   * Explicitly mark a Buffer Home first-steps task as completed. Idempotent
   * in the same-state case; transitions a previously-dismissed task to
   * completed (latest action wins).
   */
  markBufferHomeTaskComplete: MarkBufferHomeTaskCompletePayload;
  /** Mark a changelog entry as seen */
  markChangelogEntryAsSeen: MarkChangelogEntryAsSeenPayload;
  /** Marks collaboration Notes through the selected Note as read. */
  markCollaborationNotesRead: MarkCollaborationNotesReadPayload;
  /** Marks collaboration Notes from the selected Note as unread. */
  markCollaborationNotesUnread: MarkCollaborationNotesUnreadPayload;
  markNoteAuthorAsDeletedForOrganization: MarkNoteAuthorAsDeletedForOrganizationResponse;
  /** Move a feed to a new position and/or collection */
  moveFeed: FeedMoveUpdatesPayload;
  /** Move a feed collection to a new position */
  moveFeedCollection: FeedMoveUpdatesPayload;
  /** Move an idea to a new position within or between groups */
  moveIdea: MoveIdeaPayload;
  /** Moves an existing idea group within the organization based on the provided input parameters. */
  moveIdeaGroup: MoveIdeaGroupPayload;
  /**
   * Move a queued post to the top or bottom of its channel's queue. Unlike editPost, this
   * is a scheduling-only operation that never re-validates the post's content.
   */
  movePostInQueue: MovePostInQueuePayload;
  /** @deprecated Use the new movePostToDraftsV2 mutation */
  movePostToDrafts: PostUpdatedPayload;
  /** Move a post to drafts by id. */
  movePostToDraftsV2: MovePostToDraftsResult;
  /**
   * Optimizes a channel's posting schedule using Buffer's best time to post recommendations
   * This mutation applies Buffer's intelligent scheduling recommendations, with options
   * to either add to or override the existing schedule.
   */
  optimizePostingSchedule: OptimizePostingSchedulePayload;
  /** Reorders a channel for an account by placing it after another channel */
  orderChannelForAccount: OrderChannelForAccountPayload;
  organizationSetName?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Promotes an anonymous upload to the authenticated user's permanent S3 storage.
   * Copies the image from the anonymous bucket to the user's upload path.
   */
  promoteAnonymousUpload: PromoteAnonymousUploadPayload;
  /**
   * Promote a channel-less draft into channel-specific posts. One-way: once
   * promoted, the content item can no longer be edited as a draft. If any post
   * fails validation, none are created. A failure can also be reported when a
   * post could not be fully processed after the promotion already took effect;
   * re-fetch the content item to check its state before retrying.
   *
   * This API is an early preview and can change without a deprecation period.
   */
  promoteContentItemDraftToPosts: PromoteContentItemDraftToPostsPayload;
  /** Publish a post now without adding it to the queue. */
  publishPostNow: PublishPostNowPayload;
  publishStartPage?: Maybe<StartPageMutationResponse>;
  /** Updates push notification preferences for the current account. */
  pushNotificationPreferences: PushNotificationPreferencePayload;
  /** Updates push notification preferences for a specific account. */
  pushNotificationPreferencesForAccount: PushNotificationPreferencePayload;
  reOrderBlock?: Maybe<BlocksMutationResponse>;
  /**
   * Adds or removes the current account's emoji reaction on a collaboration
   * Note. Repeating either action leaves the reaction unchanged.
   */
  reactToCollaborationNote: ReactToCollaborationNotePayload;
  /** Reacts to a comment by liking/unliking it on the third-party service. */
  reactToComment: ReactToCommentPayload;
  /**
   * React to an engagement item (mention or comment) by liking/unliking it
   * on the third-party network.
   */
  reactToEngagement: ReactToEngagementPayload;
  /**
   * Force-regenerate AI takeaway cards for a channel, replacing the currently
   * shown batch. For internal/developer use — gated by the developer-data flag
   * on the client.
   */
  refreshChannelTakeaways: RefreshChannelTakeawaysPayload;
  /**
   * Force-regenerate scoped takeaway cards for an All Channels selection. For
   * internal use through the client developer-data gate.
   */
  refreshCrossChannelsTakeaways: RefreshCrossChannelsTakeawaysPayload;
  /** Refresh a feed */
  refreshFeed: RefreshFeedPayload;
  /** Refresh a feed collection */
  refreshFeedCollection: RefreshFeedCollectionPayload;
  /** Register a new API Client */
  registerAPIClient: RegisterApiClientPayload;
  /** Reject approval request. */
  rejectPost: RejectPostPayload;
  /** Delete an account by a user from the account */
  removeAccount: RemoveAccountPayload;
  /** Removes feature flip from account in DB */
  removeLegacyGlobalFeatureFlip: RemoveLegacyGlobalFeatureFlipPayload;
  removeOrganizationFromBetaProgram: MutationBasicPayload;
  /**
   * Remove a post from a content item. The post survives on its own channel
   * and keeps its schedule, text, status, and tags. Only the link to the
   * content item goes away. To delete a post, call deletePost.
   *
   * A second call with a post that belongs to no content item changes nothing,
   * and the mutation reports success.
   */
  removePostFromContentItem: RemovePostFromContentItemPayload;
  /** Remove the scheduled time from a post. */
  removePostScheduledTime: RemovePostScheduledTimePayload;
  /** Removes a scheduled subscription update for an organization. */
  removeSubscriptionSchedule: RemoveSubscriptionSchedulePayload;
  removeTagFromIdea: IdeaMutationPayload;
  removeTagFromIdeas: TagActionInIdeasPayload;
  /**
   * Remove a team member from the organization.
   * Removes both org-level and all channel-level permissions.
   * Only admins can remove team members. Cannot remove the owner or last admin.
   */
  removeTeamMember: RemoveTeamMemberPayload;
  /** Reorder the post, moving it from it's current position to another. */
  reorderPosts: ReorderPostsPayload;
  /** Reorder saved views by providing a complete ordered list of view IDs */
  reorderSavedViews: ReorderSavedViewsPayload;
  rephrasePost?: Maybe<TextGenerationResponse>;
  rephraseText?: Maybe<TextGenerationResponse>;
  /** Replies to a comment with a text */
  replyToComment: ReplyToCommentPayload;
  /**
   * Reply to a conversation, optionally responding to one of its messages. Sends
   * to the network before returning.
   *
   * Serves the mock inbox conversation with the given id, without channel or
   * permission checks and without sending or storing anything, until DM storage
   * lands: the reply comes back already `published`. An id the mock inbox did
   * not build is not found, and a `messageId` outside its thread is invalid input.
   * The reply is not kept, so later reads of the thread do not include it, and
   * `clientRef` is ignored, so a retry returns a new reply with a new id.
   */
  replyToConversation: ReplyToConversationPayload;
  /** Reply to an engagement item (mention or comment). */
  replyToEngagement: ReplyToEngagementPayload;
  /** Request post approval. */
  requestPostApproval: RequestPostApprovalPayload;
  /**
   * Resend a pending invitation. Keeps the same InvitationId and pushes
   * `expiresAt` forward by the default expiry window, so the admin UI sees
   * one row per invitee — not a stale row + a new one.
   * Only admins can resend invitations.
   */
  resendInvitation: ResendInvitationPayload;
  /** Resend login verification */
  resendLoginVerificationNotification: ResendLoginVerificationNotificationPayload;
  /** Reset all rate-limit usage counters for an API Client */
  resetAPIClientUsage: ResetApiClientUsagePayload;
  /** Reset the onboarding flow for the given organization (internal service only). */
  resetOnboardingFlow: ResetOnboardingFlowPayload;
  /**
   * Resolve a conversation. Also moves `lastReadAt` to now. Idempotent.
   *
   * Serves the mock conversation for any conversation id, without channel or
   * permission checks and without storing anything, until DM storage lands.
   */
  resolveConversation: ResolveConversationPayload;
  /** Revert approval request. */
  revertPostApprovalRequest: RevertPostApprovalRequestPayload;
  /** Revoke access to a connectedApp */
  revokeAccessConnectedApp: RevokeAccessConnectedAppPayload;
  /** Revoke all personal access tokens issued by a specific client */
  revokeClientPersonalAccessTokens: RevokeClientPersonalAccessTokensPayload;
  /**
   * Revoke a pending invitation. Old invite links stop resolving.
   * Only admins can revoke invitations.
   */
  revokeInvitation: RevokeInvitationPayload;
  /** Revoke personal access token */
  revokePersonalAccessToken: RevokePersonalAccessTokenPayload;
  saveStartPageName?: Maybe<StartPageMutationResponse>;
  saveTheme?: Maybe<StartPageMutationResponse>;
  /** Schedule a post to a specific time. */
  schedulePost: SchedulePostPayload;
  /** Send test notification */
  sendTestNotification: SendTestNotificationPayload;
  /** Set the state of a beta feature for an organization. */
  setBetaFeatureState: SetBetaFeatureStatePayload;
  /**
   * Set which single verified capability a channel displays on the connected
   * platform's profile (currently LinkedIn). The platform only allows one at a
   * time, so this replaces any previous choice; pass a null capabilityKey to stop
   * displaying any.
   */
  setChannelCapabilityToDisplayOnNetwork: SetChannelCapabilityToDisplayOnNetworkPayload;
  /** Set password for account by id */
  setPasswordForAccount: SetPasswordForAccountPayload;
  /** Set posting schedule for Channel by id */
  setPostingScheduleForChannel: SetPostingScheduleForChannelPayload;
  /**
   * Record the current user's helpful/unhelpful vote on a takeaway, or clear it
   * by passing null feedback. Returns the updated takeaway.
   */
  setTakeawayFeedback: SetTakeawayFeedbackPayload;
  /** Set the trusted partner status of an organization. BufferAdmin only. */
  setTrustedPartner: SetTrustedPartnerPayload;
  startImpersonation: ImpersonationResponse;
  /** Start a trial for an organization. */
  startTrial: StartTrialPayload;
  stopImpersonation: ImpersonationResponse;
  /** Files in-product feedback on behalf of the signed-in account. */
  submitProductFeedback: SubmitProductFeedbackPayload;
  summarizePost?: Maybe<TextGenerationResponse>;
  summarizeText?: Maybe<TextGenerationResponse>;
  /** Swap posts in queue - It is called when a user drags a post and drops it on a slot containing another post. */
  swapPostsInQueue: SwapPostsInQueuePayload;
  /** Swap Shop Grid Custom links */
  swapShopGridCustomLinks: ShopGridCustomLinksMutationPayload;
  /** Changes the billing gateway of an organization */
  switchBillingGateway: SwitchBillingGatewayPayload;
  /**
   * Toggle whether a channel's chosen verified capability is synchronized to the
   * connected platform's profile (currently LinkedIn). Enabling syncs the chosen
   * earned capability as a credibility signal; disabling removes it. A
   * capability's earned status is never changed.
   */
  toggleChannelCapabilitySynchronization: ToggleChannelCapabilitySynchronizationPayload;
  trackExternalServiceUsageForChannel: TrackExternalServiceUsageResponse;
  trackExternalServiceUsageForOrganization: TrackExternalServiceUsageResponse;
  /**
   * Track Onboarding Survey being completed and the last answers for questions in db
   * @deprecated Use completeOnboardingStep mutation instead
   */
  trackOnboardingSurveyCompleted: TrackActionOnboardingSurveyPayload;
  /**
   * Track Onboarding Survey being skipped in db
   * @deprecated Use completeOnboardingStep mutation with skipped: true instead
   */
  trackOnboardingSurveySkipped: TrackActionOnboardingSurveyPayload;
  /**
   * Track Onboarding Survey being viewed in db
   * @deprecated Use initiateOnboarding mutation instead
   */
  trackOnboardingSurveyViewed: TrackActionOnboardingSurveyPayload;
  /** Transfer the ownership of an organization to a new account. */
  transferOrganizationOwnership: TransferOrganizationOwnershipPayload;
  /** Confirm Two Factor Authentication */
  twoFactorConfirm: TwoFactorConfirmPayload;
  /**
   * Disable Two Factor Authentication for an account
   * This is used for Buffer Admin to disable Two Factor Authentication for an account
   */
  twoFactorDisableByAccountId: TwoFactorDisablePayload;
  /** Requests a One-Time Password for Two Factor Authentication */
  twoFactorRequestOneTimePassword: TwoFactorRequestOneTimePasswordPayload;
  /** Set up Two Factor Authentication */
  twoFactorSetup: TwoFactorSetupPayload;
  unPublishStartPage?: Maybe<StartPageMutationResponse>;
  /** Undismisses a comment, marking it as unreplied, meaning it needs attention. */
  undismissComment: UndismissCommentPayload;
  /**
   * Undismiss an engagement item (mention or comment), restoring it to unreplied
   * so it resurfaces in the inbox.
   */
  undismissEngagement: UndismissEngagementPayload;
  /**
   * Take a conversation back out of `resolved`. Recomputes the status rather than
   * restoring one.
   *
   * Serves the mock inbox conversation with the given id, without channel or
   * permission checks and without storing anything, until DM storage lands. An
   * id the mock inbox did not build is rejected as not found.
   */
  unresolveConversation: UnresolveConversationPayload;
  /** Update an existing API Client */
  updateAPIClient: UpdateApiClientPayload;
  /** Update suspension status of an API Client */
  updateAPIClientSuspensionStatus: UpdateApiClientSuspensionStatusPayload;
  /** update the avatar url for an account */
  updateAccountAvatar: UpdateAccountAvatarPayload;
  /** update the name of an account with the name provided */
  updateAccountName: UpdateAccountNamePayload;
  /** Update account preferences */
  updateAccountPreferences: UpdateAccountPreferencesPayload;
  /** Update account timezone */
  updateAccountTimezone: UpdateAccountTimezonePayload;
  /** Create or edit an internal comment that will be displayed in User Hub */
  updateAdminComment: UpdateAdminCommentPayload;
  /**
   * Temporary mutation to update the last updated at timestamps for analytics
   * This will be called by the Analyze workers. This will be removed once
   * the Analyze workers are migrated to monorepo or deprecated.
   */
  updateAnalyticsLastUpdatedAtByIngestionType: ChannelAnalyticsLastUpdateAtPayload;
  /** Updates the subscription plan of an organization */
  updateBillingSubscriptionPlan: UpdateBillingSubscriptionPlanPayload;
  /** Update a changelog entry */
  updateChangelogEntry: UpdateChangelogEntryPayload;
  /** Update a channel group */
  updateChannelGroup: UpdateChannelGroupPayload;
  /**
   * Update multiple team members' permissions for a single channel.
   * Updates permissions for each specified member on the given channel.
   * Only admins can update channel permissions.
   */
  updateChannelMemberPermissions: UpdateChannelMemberPermissionsPayload;
  /**
   * Update channel permissions for a team member.
   * Replaces all existing channel permissions with the provided list.
   * Only admins can update channel permissions.
   */
  updateChannelPermissions: UpdateChannelPermissionsPayload;
  /** Update posting goal for Channel by id */
  updateChannelPostingGoal: UpdateChannelPostingGoalPayload;
  /** Updates a collaboration Note. */
  updateCollaborationNote: UpdateCollaborationNotePayload;
  /**
   * Update a content item's title or target date. Fields that are
   * omitted keep their current value.
   *
   * This API is an early preview and can change without a deprecation period.
   */
  updateContentItem: UpdateContentItemPayload;
  /**
   * Replace a channel-less draft's content in full, and optionally set the
   * content item's target date in the same write. The draft needs text or at
   * least one asset. Only valid while the content item is still a draft.
   *
   * This API is an early preview and can change without a deprecation period.
   */
  updateContentItemDraft: UpdateContentItemDraftPayload;
  /** Update custom channel data */
  updateCustomChannel: UpdateCustomChannelPayload;
  /** Update custom links colors for a channel */
  updateCustomLinksColors: UpdateCustomLinksColorsPayload;
  /** Update customer attributes in Customer.io */
  updateCustomerIOAttributes: UpdateCustomerIoAttributesPayload;
  updateFeatureTokenUsageForOrganization: OrganizationFeatureUsageUpdateResponse;
  /** Update a feed */
  updateFeed: UpdateFeedPayload;
  /** Update a feed collection */
  updateFeedCollection: CreateOrUpdateFeedCollectionPayload;
  /** Update an existing idea with new content and metadata */
  updateIdea: UpdateIdeaPayload;
  /** Updates an existing idea group with the provided input parameters. */
  updateIdeaGroup: UpdateIdeaGroupPayload;
  /** Update lastActivityAt for a channel by id */
  updateLastActivityAtForChannel: UpdateLastActivityAtForChannelPayload;
  /** Update settings for a channel */
  updateLinkShorteningSettings: ChannelLinkShorteningPayload;
  /** Update a Buffer-managed post template. */
  updateManagedPostTemplate: UpdateManagedPostTemplatePayload;
  /** Updates a note on a post and returns the result */
  updateNoteOnPost: UpdateNoteOnPostPayload;
  /**
   * Update the billing email address for an organization.
   * Only organization administrators with billing management permissions can update this.
   *
   * The billing email is used for:
   * - Invoice payment success notifications
   * - Invoice payment failure notifications
   * - Payment refund notifications
   * - Subscription change notifications
   *
   * When cleared (set to null), billing emails revert to the organization owner's email.
   */
  updateOrganizationBillingEmail: UpdateOrganizationBillingEmailPayload;
  /** Toggle 2FA enforcement for every member of an organization. Admin-only. */
  updateOrganizationEnforce2FA: UpdateOrganizationEnforce2FaPayload;
  /** Update Account password */
  updatePassword: UpdatePasswordPayload;
  /** @todo: change response to use the generic PostUpdatedPayload */
  updatePostDueAt: UpdatePostDueAtMutationResponse;
  /** Assign tags to a post. Can also be used to remove all tags by passing an empty array. */
  updatePostTags: UpdatePostTagsPayload;
  /**
   * Update a post template owned by the caller (or an internal template
   * in the caller's organization, if the caller is an org admin/owner).
   */
  updatePostTemplate: UpdatePostTemplatePayload;
  /** Update an existing post template campaign. Requires Account actor. */
  updatePostTemplateCampaign: UpdatePostTemplateCampaignPayload;
  /** Modifies an existing saved reply. */
  updateSavedReply: UpdateSavedReplyPayload;
  /** Update an existing saved view */
  updateSavedView: UpdateSavedViewPayload;
  /** Update Shop Grid Custom link */
  updateShopGridCustomLink: ShopGridCustomLinksMutationPayload;
  /** Update Shop Grid Post link */
  updateShopGridPostLink: UpdateShopGridPostLinkPayload;
  /** Replaces the name and text of a snippet. */
  updateSnippet: UpdateSnippetPayload;
  /** Update account start of week preference */
  updateStartOfWeekPreference: UpdateStartOfWeekPreferencePayload;
  /** Updates the subscription quantity of an organization */
  updateSubscriptionQuantity: UpdateSubscriptionQuantityPayload;
  /**
   * Update a tag's name and color.
   *
   * Both values are replaced, so send the current value for the one you are not
   * changing. The new name must still be unique within the organization; a
   * duplicate is refused with `DuplicateError`.
   *
   * A locked tag cannot be edited and the update is refused. See `Tag.isLocked`.
   *
   * This API is an early preview and can change without a deprecation period.
   */
  updateTag: UpdateTagPayload;
  updateTagInIdeas: TagActionInIdeasPayload;
  /**
   * Update a team member's organization role.
   * Only admins can update roles. Cannot demote the last admin.
   */
  updateTeamMemberRole: UpdateTeamMemberRolePayload;
  /** Update account time format preference */
  updateTimeFormatPreference: UpdateTimeFormatPreferencePayload;
  /** Update timezone for Channel by id */
  updateTimezoneForChannel: UpdateTimezoneForChannelPayload;
  /** Update trending topic suggestions visibility for a channel */
  updateTrendingTopicSuggestionsVisibility: UpdateTrendingTopicSuggestionsVisibilityPayload;
  /**
   * Upgrades an organization's subscription from monthly to annual billing,
   * keeping the same plan and quantity.
   */
  upgradePlanToAnnualBilling: UpgradePlanToAnnualBillingPayload;
  /**
   * Create a feed if it does not yet exist
   * @deprecated Use createFeed mutation instead
   */
  upsertFeed: CreateOrUpdateFeedPayload;
  /** Verify login for account */
  verifyAccountLogin: VerifyAccountLoginPayload;
  /** Verify account by checking the password in DB */
  verifyPassword: VerifyPasswordPayload;
  /** Verify TFA code for account */
  verifyTfaCode: VerifyTfaCodePayload;
  voteForFeatureOnFeatureOS: VoteForFeatureMutationResponse;
};


/** Root mutation type for team management operations. */
export type MutationAcceptInvitationArgs = {
  input: AcceptInvitationInput;
};


/** Root mutation type for team management operations. */
export type MutationAccountCompleteEmailVerificationArgs = {
  emailVerificationJWT: Scalars['String']['input'];
};


/** Root mutation type for team management operations. */
export type MutationAccountInitiateEmailVerificationArgs = {
  channelId?: InputMaybe<Scalars['String']['input']>;
  isBackupEmail?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root mutation type for team management operations. */
export type MutationAccountSetAvatarArgs = {
  avatar?: InputMaybe<Scalars['String']['input']>;
};


/** Root mutation type for team management operations. */
export type MutationAccountSetCurrentOrganizationArgs = {
  organizationId?: InputMaybe<Scalars['String']['input']>;
};


/** Root mutation type for team management operations. */
export type MutationAccountSetSettingsArgs = {
  settings: SettingsInput;
};


/** Root mutation type for team management operations. */
export type MutationAccountSuspendArgs = {
  accountId: Scalars['String']['input'];
  shouldForceOperation?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root mutation type for team management operations. */
export type MutationAccountUnsuspendArgs = {
  accountId: Scalars['String']['input'];
  shouldForceOperation?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root mutation type for team management operations. */
export type MutationAccountUpdateRoleArgs = {
  accountRole: AccountUpdateRoleInput;
};


/** Root mutation type for team management operations. */
export type MutationAddBlockArgs = {
  config?: InputMaybe<BlockConfigInput>;
  organizationId: Scalars['String']['input'];
  pageId: Scalars['String']['input'];
};


/** Root mutation type for team management operations. */
export type MutationAddBlocksArgs = {
  config?: InputMaybe<Array<InputMaybe<BlockConfigInput>>>;
  organizationId: Scalars['String']['input'];
  pageId: Scalars['String']['input'];
};


/** Root mutation type for team management operations. */
export type MutationAddChildBlockArgs = {
  accountId: Scalars['String']['input'];
  config?: InputMaybe<ChildBlockConfigInput>;
  organizationId: Scalars['String']['input'];
  pageId: Scalars['String']['input'];
};


/** Root mutation type for team management operations. */
export type MutationAddEntityNoteArgs = {
  input: AddEntityNoteInput;
};


/** Root mutation type for team management operations. */
export type MutationAddNoteToPostArgs = {
  input: AddNoteToPostInput;
};


/** Root mutation type for team management operations. */
export type MutationAddOrUpdateDismissedObjectArgs = {
  dismissedObject: DismissedObjectInput;
  organizationId: Scalars['String']['input'];
};


/** Root mutation type for team management operations. */
export type MutationAddOrganizationToBetaProgramArgs = {
  bufferAdminAccountId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
};


/** Root mutation type for team management operations. */
export type MutationAddPostToContentItemArgs = {
  input: AddPostToContentItemInput;
};


/** Root mutation type for team management operations. */
export type MutationAddPostToQueueArgs = {
  input: AddPostToQueueInput;
};


/** Root mutation type for team management operations. */
export type MutationAddShopGridCustomLinkArgs = {
  input: AddShopGridCustomLinkInput;
};


/** Root mutation type for team management operations. */
export type MutationApprovePostArgs = {
  input: ApprovePostInput;
};


/** Root mutation type for team management operations. */
export type MutationAuthorizeChannelsArgs = {
  channelAuthorization: ChannelAuthorizationInput;
};


/** Root mutation type for team management operations. */
export type MutationBackfillChannelAnalyticsArgs = {
  input: BackfillChannelAnalyticsInput;
};


/** Root mutation type for team management operations. */
export type MutationBackfillChannelPostsAndAnalyticsArgs = {
  input: ChannelBackfillInput;
};


/** Root mutation type for team management operations. */
export type MutationBackfillChannelUpdatesArgs = {
  channelId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};


/** Root mutation type for team management operations. */
export type MutationBackfillUpdatesForGridArgs = {
  input: BackfillUpdatesForGridInput;
};


/** Root mutation type for team management operations. */
export type MutationBanStartPagesForOrgArgs = {
  organizationId: Scalars['String']['input'];
};


/** Root mutation type for team management operations. */
export type MutationBillingCreateCustomerPortalSessionArgs = {
  organizationId: Scalars['String']['input'];
  returnURL?: InputMaybe<Scalars['String']['input']>;
};


/** Root mutation type for team management operations. */
export type MutationBillingCreateSetupIntentArgs = {
  organizationId?: InputMaybe<Scalars['String']['input']>;
};


/** Root mutation type for team management operations. */
export type MutationBillingStartTrialArgs = {
  attribution?: InputMaybe<AttributionInput>;
  interval?: InputMaybe<BillingInterval>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  plan?: InputMaybe<ObPlanId>;
};


/** Root mutation type for team management operations. */
export type MutationBillingUpdateCustomerPaymentMethodArgs = {
  attribution?: InputMaybe<AttributionInput>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
};


/** Root mutation type for team management operations. */
export type MutationBillingUpdateSubscriptionPlanArgs = {
  attribution?: InputMaybe<AttributionInput>;
  interval?: InputMaybe<BillingInterval>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  plan?: InputMaybe<ObPlanId>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
};


/** Root mutation type for team management operations. */
export type MutationCancelPostRecurrenceArgs = {
  input: CancelPostRecurrenceInput;
};


/** Root mutation type for team management operations. */
export type MutationCancelTrialArgs = {
  input: CancelTrialInput;
};


/** Root mutation type for team management operations. */
export type MutationChannelConnectionListArgs = {
  input: ChannelConnectionListInput;
};


/** Root mutation type for team management operations. */
export type MutationChannelConnectionRefreshArgs = {
  input: ChannelConnectionRefreshInput;
};


/** Root mutation type for team management operations. */
export type MutationChannelCreateOrUpdateNativeChannelArgs = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  channel: NativeChannelInput;
};


/** Root mutation type for team management operations. */
export type MutationChannelStoreTemporaryCredentialsArgs = {
  channelConnections?: InputMaybe<Array<ChannelConnectionInput>>;
};


/** Root mutation type for team management operations. */
export type MutationChannelUpdateLockedStatusArgs = {
  input: ChannelUpdateLockedStatusInput;
};


/** Root mutation type for team management operations. */
export type MutationChannelsAuthorizationArgs = {
  channelAuthorization: ChannelAuthorizationInput;
};


/** Root mutation type for team management operations. */
export type MutationChannelsConnectArgs = {
  channels?: InputMaybe<Array<ChannelWithCredentialsInput>>;
};


/** Root mutation type for team management operations. */
export type MutationChannelsConnectWithResponseArgs = {
  channels?: InputMaybe<Array<ChannelWithCredentialsInput>>;
};


/** Root mutation type for team management operations. */
export type MutationChannelsForConnectionArgs = {
  credentialsForChannels: CredentialsForChannelsInput;
};


/** Root mutation type for team management operations. */
export type MutationChannelsLockArgs = {
  channelIdsToLock?: InputMaybe<Array<Scalars['ID']['input']>>;
  channelIdsToUnlock?: InputMaybe<Array<Scalars['ID']['input']>>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
};


/** Root mutation type for team management operations. */
export type MutationChannelsLockAllForOrganizationArgs = {
  organizationId?: InputMaybe<Scalars['String']['input']>;
};


/** Root mutation type for team management operations. */
export type MutationChannelsLockForOrganizationArgs = {
  organizationId?: InputMaybe<Scalars['String']['input']>;
};


/** Root mutation type for team management operations. */
export type MutationChannelsRemoveArgs = {
  channelIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Root mutation type for team management operations. */
export type MutationChannelsSetRecommendationsArgs = {
  channels: Array<InputMaybe<Scalars['String']['input']>>;
  organizationId: Scalars['String']['input'];
};


/** Root mutation type for team management operations. */
export type MutationChannelsUpdateCredentialsArgs = {
  channelsUpdatedCredentials: ChannelUpdateCredentialsInput;
};


/** Root mutation type for team management operations. */
export type MutationCheckChannelCapabilitiesArgs = {
  input: CheckChannelCapabilitiesInput;
};


/** Root mutation type for team management operations. */
export type MutationClaimLinkedInPremiumPromoCodeArgs = {
  input: ClaimLinkedInPremiumPromoCodeInput;
};


/** Root mutation type for team management operations. */
export type MutationCompleteEmailVerificationArgs = {
  input: CompleteEmailVerificationInput;
};


/** Root mutation type for team management operations. */
export type MutationCompleteLoginVerificationArgs = {
  input: CompleteLoginVerificationInput;
};


/** Root mutation type for team management operations. */
export type MutationCompleteOnboardingStepArgs = {
  input: CompleteOnboardingStepInput;
};


/** Root mutation type for team management operations. */
export type MutationCompleteWhatsAppConnectionArgs = {
  input: CompleteWhatsAppConnectionInput;
};


/** Root mutation type for team management operations. */
export type MutationConvertCustomChannelArgs = {
  input: ConvertCustomChannelInput;
};


/** Root mutation type for team management operations. */
export type MutationCreateChangelogEntryArgs = {
  input: CreateChangelogEntryInput;
};


/** Root mutation type for team management operations. */
export type MutationCreateChannelAnalyticsExportArgs = {
  input: CreateChannelAnalyticsExportInput;
};


/** Root mutation type for team management operations. */
export type MutationCreateChannelGroupArgs = {
  input: CreateChannelGroupInput;
};


/** Root mutation type for team management operations. */
export type MutationCreateCheckoutSessionArgs = {
  input: CreateCheckoutSessionInput;
};


/** Root mutation type for team management operations. */
export type MutationCreateCollaborationNoteArgs = {
  input: CreateCollaborationNoteInput;
};


/** Root mutation type for team management operations. */
export type MutationCreateContentItemArgs = {
  input: CreateContentItemInput;
};


/** Root mutation type for team management operations. */
export type MutationCreateContentItemDraftArgs = {
  input: CreateContentItemDraftInput;
};


/** Root mutation type for team management operations. */
export type MutationCreateCustomChannelsArgs = {
  input: CreateCustomChannelsInput;
};


/** Root mutation type for team management operations. */
export type MutationCreateCustomerPortalSessionArgs = {
  input: CreateCustomerPortalSessionInput;
};


/** Root mutation type for team management operations. */
export type MutationCreateFeedArgs = {
  input: CreateFeedInput;
};


/** Root mutation type for team management operations. */
export type MutationCreateFeedCollectionArgs = {
  input: CreateFeedCollectionInput;
};


/** Root mutation type for team management operations. */
export type MutationCreateIdeaArgs = {
  input: CreateIdeaInput;
};


/** Root mutation type for team management operations. */
export type MutationCreateIdeaGroupArgs = {
  input: CreateIdeaGroupInput;
};


/** Root mutation type for team management operations. */
export type MutationCreateManagedPostTemplateArgs = {
  input: CreateManagedPostTemplateInput;
};


/** Root mutation type for team management operations. */
export type MutationCreatePostArgs = {
  input: CreatePostInput;
};


/** Root mutation type for team management operations. */
export type MutationCreatePostGroupArgs = {
  input: CreatePostGroupInput;
};


/** Root mutation type for team management operations. */
export type MutationCreatePostRecurrenceArgs = {
  input: CreatePostRecurrenceInput;
};


/** Root mutation type for team management operations. */
export type MutationCreatePostTemplateArgs = {
  input: CreatePostTemplateInput;
};


/** Root mutation type for team management operations. */
export type MutationCreatePostTemplateCampaignArgs = {
  input: CreatePostTemplateCampaignInput;
};


/** Root mutation type for team management operations. */
export type MutationCreateSavedReplyArgs = {
  input: CreateSavedReplyInput;
};


/** Root mutation type for team management operations. */
export type MutationCreateSavedViewArgs = {
  input: CreateSavedViewInput;
};


/** Root mutation type for team management operations. */
export type MutationCreateSnippetArgs = {
  input: CreateSnippetInput;
};


/** Root mutation type for team management operations. */
export type MutationCreateStartPageArgs = {
  config?: InputMaybe<StartPageConfigInput>;
  organizationId: Scalars['String']['input'];
};


/** Root mutation type for team management operations. */
export type MutationCreateTagArgs = {
  input: CreateTagInput;
};


/** Root mutation type for team management operations. */
export type MutationCustomChannelUpdateArgs = {
  channel: CustomChannelUpdateInput;
};


/** Root mutation type for team management operations. */
export type MutationCustomChannelsCreateArgs = {
  channels?: InputMaybe<Array<CustomChannelCreateInput>>;
};


/** Root mutation type for team management operations. */
export type MutationDeleteApiClientArgs = {
  input: DeleteApiClientInput;
};


/** Root mutation type for team management operations. */
export type MutationDeleteAccountArgs = {
  input: DeleteAccountInput;
};


/** Root mutation type for team management operations. */
export type MutationDeleteAdminCommentArgs = {
  input: DeleteAdminCommentInput;
};


/** Root mutation type for team management operations. */
export type MutationDeleteBlockArgs = {
  blockId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};


/** Root mutation type for team management operations. */
export type MutationDeleteChangelogEntryArgs = {
  input: DeleteChangelogEntryInput;
};


/** Root mutation type for team management operations. */
export type MutationDeleteChannelGroupArgs = {
  input: DeleteChannelGroupInput;
};


/** Root mutation type for team management operations. */
export type MutationDeleteCollaborationNoteArgs = {
  input: DeleteCollaborationNoteInput;
};


/** Root mutation type for team management operations. */
export type MutationDeleteContentItemArgs = {
  input: DeleteContentItemInput;
};


/** Root mutation type for team management operations. */
export type MutationDeleteEntityNoteArgs = {
  input: DeleteEntityNoteInput;
};


/** Root mutation type for team management operations. */
export type MutationDeleteFeedArgs = {
  input: DeleteFeedInput;
};


/** Root mutation type for team management operations. */
export type MutationDeleteFeedCollectionArgs = {
  input: DeleteFeedCollectionInput;
};


/** Root mutation type for team management operations. */
export type MutationDeleteIdeaGroupArgs = {
  input: DeleteIdeaGroupInput;
};


/** Root mutation type for team management operations. */
export type MutationDeleteManagedPostTemplateArgs = {
  input: DeleteManagedPostTemplateInput;
};


/** Root mutation type for team management operations. */
export type MutationDeleteNoteFromPostArgs = {
  input: DeleteNoteFromPostInput;
};


/** Root mutation type for team management operations. */
export type MutationDeletePostArgs = {
  input: DeletePostInput;
};


/** Root mutation type for team management operations. */
export type MutationDeletePostTemplateArgs = {
  input: DeletePostTemplateInput;
};


/** Root mutation type for team management operations. */
export type MutationDeletePostTemplateCampaignArgs = {
  input: DeletePostTemplateCampaignInput;
};


/** Root mutation type for team management operations. */
export type MutationDeletePostV2Args = {
  input: DeletePostInputV2;
};


/** Root mutation type for team management operations. */
export type MutationDeleteSavedReplyArgs = {
  input: DeleteSavedReplyInput;
};


/** Root mutation type for team management operations. */
export type MutationDeleteSavedViewArgs = {
  input: DeleteSavedViewInput;
};


/** Root mutation type for team management operations. */
export type MutationDeleteShopGridCustomLinkArgs = {
  input: DeleteShopGridCustomLinkInput;
};


/** Root mutation type for team management operations. */
export type MutationDeleteSnippetArgs = {
  input: DeleteSnippetInput;
};


/** Root mutation type for team management operations. */
export type MutationDeleteTagArgs = {
  input: DeleteTagInput;
};


/** Root mutation type for team management operations. */
export type MutationDisableTwoFactorWithPasswordArgs = {
  input: DisableTwoFactorWithPasswordInput;
};


/** Root mutation type for team management operations. */
export type MutationDismissAllCommentsByChannelIdArgs = {
  input: DismissAllCommentsByChannelIdInput;
};


/** Root mutation type for team management operations. */
export type MutationDismissAllCommentsByOrganizationIdArgs = {
  input: DismissAllCommentsByOrganizationIdInput;
};


/** Root mutation type for team management operations. */
export type MutationDismissAllCommentsByPostIdArgs = {
  input: DismissAllCommentsByPostIdInput;
};


/** Root mutation type for team management operations. */
export type MutationDismissAllCommentsForChannelsArgs = {
  input: DismissAllCommentsForChannelsInput;
};


/** Root mutation type for team management operations. */
export type MutationDismissAllEngagementsByChannelIdsArgs = {
  input: DismissAllEngagementsByChannelIdsInput;
};


/** Root mutation type for team management operations. */
export type MutationDismissBannerArgs = {
  banner: Scalars['String']['input'];
};


/** Root mutation type for team management operations. */
export type MutationDismissBufferHomeTaskArgs = {
  input: DismissBufferHomeTaskInput;
};


/** Root mutation type for team management operations. */
export type MutationDismissCommentArgs = {
  input: DismissCommentInput;
};


/** Root mutation type for team management operations. */
export type MutationDismissEngagementArgs = {
  input: DismissEngagementInput;
};


/** Root mutation type for team management operations. */
export type MutationDowngradeToFreeArgs = {
  input: DowngradeToFreeInput;
};


/** Root mutation type for team management operations. */
export type MutationDropPostArgs = {
  input: DropPostInput;
};


/** Root mutation type for team management operations. */
export type MutationEditBlockArgs = {
  blockId: Scalars['String']['input'];
  data?: InputMaybe<BlockDataInput>;
  organizationId: Scalars['String']['input'];
};


/** Root mutation type for team management operations. */
export type MutationEditEntityNoteArgs = {
  input: EditEntityNoteInput;
};


/** Root mutation type for team management operations. */
export type MutationEditPostArgs = {
  input: EditPostInput;
};


/** Root mutation type for team management operations. */
export type MutationEditPostRecurrenceArgs = {
  input: EditPostRecurrenceInput;
};


/** Root mutation type for team management operations. */
export type MutationEmailNotificationPreferencesArgs = {
  input: Array<EmailNotificationPreferenceInput>;
};


/** Root mutation type for team management operations. */
export type MutationEnrollInReferralProgramArgs = {
  input: EnrollInReferralProgramInput;
};


/** Root mutation type for team management operations. */
export type MutationExchangeGoogleTokenForBufferAdminJwtArgs = {
  googleToken?: InputMaybe<Scalars['String']['input']>;
};


/** Root mutation type for team management operations. */
export type MutationExecuteFreeToolContentArgs = {
  input: ExecuteFreeToolContentInput;
};


/** Root mutation type for team management operations. */
export type MutationExpandPostArgs = {
  config: ContentGenerationInput;
  marketingId: Scalars['String']['input'];
};


/** Root mutation type for team management operations. */
export type MutationExpandTextArgs = {
  config: ContentGenerationInput;
  organizationId: Scalars['String']['input'];
};


/** Root mutation type for team management operations. */
export type MutationForceCommentsBackfillForChannelArgs = {
  input: ForceCommentsBackfillForChannelInput;
};


/** Root mutation type for team management operations. */
export type MutationGenerateAccessTokenArgs = {
  input: GenerateAccessTokenInput;
};


/** Root mutation type for team management operations. */
export type MutationGenerateAltTextArgs = {
  config: GenerateAltTextInput;
  organizationId: Scalars['String']['input'];
};


/** Root mutation type for team management operations. */
export type MutationGenerateAnonymousMediaUploadFormArgs = {
  input: GenerateAnonymousMediaUploadFormInput;
};


/** Root mutation type for team management operations. */
export type MutationGenerateHellonextSsoTokenForAccountArgs = {
  accountId: Scalars['String']['input'];
};


/** Root mutation type for team management operations. */
export type MutationGenerateIdeasArgs = {
  config: ContentGenerationInput;
  organizationId: Scalars['String']['input'];
};


/** Root mutation type for team management operations. */
export type MutationGeneratePersonalAccessTokenArgs = {
  input: GeneratePersonalAccessTokenInput;
};


/** Root mutation type for team management operations. */
export type MutationGeneratePostArgs = {
  config: ContentGenerationInput;
  marketingId: Scalars['String']['input'];
};


/** Root mutation type for team management operations. */
export type MutationGenerateTemplatedCompletionArgs = {
  input: GenerateTemplatedCompletionInput;
};


/** Root mutation type for team management operations. */
export type MutationGenerateTextArgs = {
  config: ContentGenerationInput;
  organizationId: Scalars['String']['input'];
};


/** Root mutation type for team management operations. */
export type MutationGenerateThreadedPostOptionsArgs = {
  input: GenerateThreadedPostOptionsInput;
};


/** Root mutation type for team management operations. */
export type MutationGetAuthorizationJwtArgs = {
  product?: InputMaybe<Product>;
};


/** Root mutation type for team management operations. */
export type MutationHideOrShowBlockArgs = {
  blockId: Scalars['String']['input'];
  hide?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['String']['input'];
};


/** Root mutation type for team management operations. */
export type MutationIdeaCreateArgs = {
  input: IdeaCreationInput;
};


/** Root mutation type for team management operations. */
export type MutationIdeaUpdateArgs = {
  input: IdeaUpdateInput;
};


/** Root mutation type for team management operations. */
export type MutationIdeasRemoveArgs = {
  input: IdeasDeletionInput;
};


/** Root mutation type for team management operations. */
export type MutationIncreaseSubscriptionQuantityByChannelIdsArgs = {
  input: IncreaseSubscriptionQuantityByChannelIdsInput;
};


/** Root mutation type for team management operations. */
export type MutationInitiateEmailUpdateRequestArgs = {
  input: InitiateEmailUpdateRequestInput;
};


/** Root mutation type for team management operations. */
export type MutationInitiateOnboardingArgs = {
  input: InitiateOnboardingInput;
};


/** Root mutation type for team management operations. */
export type MutationInitiateUpdateEmailArgs = {
  input: InitiateUpdateEmailInput;
};


/** Root mutation type for team management operations. */
export type MutationInviteTeamMembersArgs = {
  input: InviteTeamMembersInput;
};


/** Root mutation type for team management operations. */
export type MutationKeepSubscriptionActiveArgs = {
  input: KeepSubscriptionActiveInput;
};


/** Root mutation type for team management operations. */
export type MutationMarkBufferHomeTaskCompleteArgs = {
  input: MarkBufferHomeTaskCompleteInput;
};


/** Root mutation type for team management operations. */
export type MutationMarkChangelogEntryAsSeenArgs = {
  input: MarkChangelogEntryAsSeenInput;
};


/** Root mutation type for team management operations. */
export type MutationMarkCollaborationNotesReadArgs = {
  input: MarkCollaborationNotesReadInput;
};


/** Root mutation type for team management operations. */
export type MutationMarkCollaborationNotesUnreadArgs = {
  input: MarkCollaborationNotesUnreadInput;
};


/** Root mutation type for team management operations. */
export type MutationMarkNoteAuthorAsDeletedForOrganizationArgs = {
  email: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};


/** Root mutation type for team management operations. */
export type MutationMoveFeedArgs = {
  input: MoveFeedInput;
};


/** Root mutation type for team management operations. */
export type MutationMoveFeedCollectionArgs = {
  input: MoveFeedCollectionInput;
};


/** Root mutation type for team management operations. */
export type MutationMoveIdeaArgs = {
  input: MoveIdeaInput;
};


/** Root mutation type for team management operations. */
export type MutationMoveIdeaGroupArgs = {
  input: MoveIdeaGroupInput;
};


/** Root mutation type for team management operations. */
export type MutationMovePostInQueueArgs = {
  input: MovePostInQueueInput;
};


/** Root mutation type for team management operations. */
export type MutationMovePostToDraftsArgs = {
  input: PostIdInput;
};


/** Root mutation type for team management operations. */
export type MutationMovePostToDraftsV2Args = {
  input: MovePostToDraftsV2Input;
};


/** Root mutation type for team management operations. */
export type MutationOptimizePostingScheduleArgs = {
  input: OptimizePostingScheduleInput;
};


/** Root mutation type for team management operations. */
export type MutationOrderChannelForAccountArgs = {
  input: OrderChannelForAccountInput;
};


/** Root mutation type for team management operations. */
export type MutationOrganizationSetNameArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
};


/** Root mutation type for team management operations. */
export type MutationPromoteAnonymousUploadArgs = {
  input: PromoteAnonymousUploadInput;
};


/** Root mutation type for team management operations. */
export type MutationPromoteContentItemDraftToPostsArgs = {
  input: PromoteContentItemDraftToPostsInput;
};


/** Root mutation type for team management operations. */
export type MutationPublishPostNowArgs = {
  input: PublishPostNowInput;
};


/** Root mutation type for team management operations. */
export type MutationPublishStartPageArgs = {
  data?: InputMaybe<PublishStartPageInput>;
  organizationId: Scalars['String']['input'];
  pageId: Scalars['String']['input'];
};


/** Root mutation type for team management operations. */
export type MutationPushNotificationPreferencesArgs = {
  input: Array<PushNotificationPreferenceInput>;
};


/** Root mutation type for team management operations. */
export type MutationPushNotificationPreferencesForAccountArgs = {
  input: PushNotificationPreferencesForAccountInput;
};


/** Root mutation type for team management operations. */
export type MutationReOrderBlockArgs = {
  blockId: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['String']['input'];
};


/** Root mutation type for team management operations. */
export type MutationReactToCollaborationNoteArgs = {
  input: ReactToCollaborationNoteInput;
};


/** Root mutation type for team management operations. */
export type MutationReactToCommentArgs = {
  input: ReactToCommentInput;
};


/** Root mutation type for team management operations. */
export type MutationReactToEngagementArgs = {
  input: ReactToEngagementInput;
};


/** Root mutation type for team management operations. */
export type MutationRefreshChannelTakeawaysArgs = {
  input: RefreshChannelTakeawaysInput;
};


/** Root mutation type for team management operations. */
export type MutationRefreshCrossChannelsTakeawaysArgs = {
  input: RefreshCrossChannelsTakeawaysInput;
};


/** Root mutation type for team management operations. */
export type MutationRefreshFeedArgs = {
  input: RefreshFeedInput;
};


/** Root mutation type for team management operations. */
export type MutationRefreshFeedCollectionArgs = {
  input: RefreshFeedCollectionInput;
};


/** Root mutation type for team management operations. */
export type MutationRegisterApiClientArgs = {
  input: RegisterApiClientInput;
};


/** Root mutation type for team management operations. */
export type MutationRejectPostArgs = {
  input: RejectPostInput;
};


/** Root mutation type for team management operations. */
export type MutationRemoveAccountArgs = {
  input: RemoveAccountInput;
};


/** Root mutation type for team management operations. */
export type MutationRemoveLegacyGlobalFeatureFlipArgs = {
  input: RemoveLegacyGlobalFeatureFlipInput;
};


/** Root mutation type for team management operations. */
export type MutationRemoveOrganizationFromBetaProgramArgs = {
  bufferAdminAccountId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
};


/** Root mutation type for team management operations. */
export type MutationRemovePostFromContentItemArgs = {
  input: RemovePostFromContentItemInput;
};


/** Root mutation type for team management operations. */
export type MutationRemovePostScheduledTimeArgs = {
  input: RemovePostScheduledTimeInput;
};


/** Root mutation type for team management operations. */
export type MutationRemoveSubscriptionScheduleArgs = {
  organizationId: Scalars['OrganizationId']['input'];
};


/** Root mutation type for team management operations. */
export type MutationRemoveTagFromIdeaArgs = {
  input: TagRemovalFromIdeaInput;
};


/** Root mutation type for team management operations. */
export type MutationRemoveTagFromIdeasArgs = {
  input: TagRemovalFromIdeasInput;
};


/** Root mutation type for team management operations. */
export type MutationRemoveTeamMemberArgs = {
  input: RemoveTeamMemberInput;
};


/** Root mutation type for team management operations. */
export type MutationReorderPostsArgs = {
  input: ReorderPostsInput;
};


/** Root mutation type for team management operations. */
export type MutationReorderSavedViewsArgs = {
  input: ReorderSavedViewsInput;
};


/** Root mutation type for team management operations. */
export type MutationRephrasePostArgs = {
  config: ContentGenerationInput;
  marketingId: Scalars['String']['input'];
};


/** Root mutation type for team management operations. */
export type MutationRephraseTextArgs = {
  config: ContentGenerationInput;
  organizationId: Scalars['String']['input'];
};


/** Root mutation type for team management operations. */
export type MutationReplyToCommentArgs = {
  input: ReplyToCommentInput;
};


/** Root mutation type for team management operations. */
export type MutationReplyToConversationArgs = {
  input: ReplyToConversationInput;
};


/** Root mutation type for team management operations. */
export type MutationReplyToEngagementArgs = {
  input: ReplyToEngagementInput;
};


/** Root mutation type for team management operations. */
export type MutationRequestPostApprovalArgs = {
  input: RequestPostApprovalInput;
};


/** Root mutation type for team management operations. */
export type MutationResendInvitationArgs = {
  input: ResendInvitationInput;
};


/** Root mutation type for team management operations. */
export type MutationResendLoginVerificationNotificationArgs = {
  input: ResendLoginVerificationNotificationInput;
};


/** Root mutation type for team management operations. */
export type MutationResetApiClientUsageArgs = {
  input: ResetApiClientUsageInput;
};


/** Root mutation type for team management operations. */
export type MutationResetOnboardingFlowArgs = {
  input: ResetOnboardingFlowInput;
};


/** Root mutation type for team management operations. */
export type MutationResolveConversationArgs = {
  input: ResolveConversationInput;
};


/** Root mutation type for team management operations. */
export type MutationRevertPostApprovalRequestArgs = {
  input: RevertPostApprovalRequestInput;
};


/** Root mutation type for team management operations. */
export type MutationRevokeAccessConnectedAppArgs = {
  input: RevokeAccessConnectedAppInput;
};


/** Root mutation type for team management operations. */
export type MutationRevokeClientPersonalAccessTokensArgs = {
  input: RevokeClientPersonalAccessTokensInput;
};


/** Root mutation type for team management operations. */
export type MutationRevokeInvitationArgs = {
  input: RevokeInvitationInput;
};


/** Root mutation type for team management operations. */
export type MutationRevokePersonalAccessTokenArgs = {
  input: RevokePersonalAccessTokenInput;
};


/** Root mutation type for team management operations. */
export type MutationSaveStartPageNameArgs = {
  name: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  pageId: Scalars['String']['input'];
};


/** Root mutation type for team management operations. */
export type MutationSaveThemeArgs = {
  organizationId: Scalars['String']['input'];
  pageId: Scalars['String']['input'];
  theme?: InputMaybe<StartPageThemeInput>;
};


/** Root mutation type for team management operations. */
export type MutationSchedulePostArgs = {
  input: SchedulePostInput;
};


/** Root mutation type for team management operations. */
export type MutationSetBetaFeatureStateArgs = {
  input: SetBetaFeatureStateInput;
};


/** Root mutation type for team management operations. */
export type MutationSetChannelCapabilityToDisplayOnNetworkArgs = {
  input: SetChannelCapabilityToDisplayOnNetworkInput;
};


/** Root mutation type for team management operations. */
export type MutationSetPasswordForAccountArgs = {
  input: SetPasswordForAccountInput;
};


/** Root mutation type for team management operations. */
export type MutationSetPostingScheduleForChannelArgs = {
  input: SetPostingScheduleForChannelInput;
};


/** Root mutation type for team management operations. */
export type MutationSetTakeawayFeedbackArgs = {
  input: SetTakeawayFeedbackInput;
};


/** Root mutation type for team management operations. */
export type MutationSetTrustedPartnerArgs = {
  input: SetTrustedPartnerInput;
};


/** Root mutation type for team management operations. */
export type MutationStartImpersonationArgs = {
  input: StartImpersonationInput;
};


/** Root mutation type for team management operations. */
export type MutationStartTrialArgs = {
  input: StartTrialInput;
};


/** Root mutation type for team management operations. */
export type MutationStopImpersonationArgs = {
  input: StopImpersonationInput;
};


/** Root mutation type for team management operations. */
export type MutationSubmitProductFeedbackArgs = {
  input: SubmitProductFeedbackInput;
};


/** Root mutation type for team management operations. */
export type MutationSummarizePostArgs = {
  config: ContentGenerationInput;
  marketingId: Scalars['String']['input'];
};


/** Root mutation type for team management operations. */
export type MutationSummarizeTextArgs = {
  config: ContentGenerationInput;
  organizationId: Scalars['String']['input'];
};


/** Root mutation type for team management operations. */
export type MutationSwapPostsInQueueArgs = {
  input: SwapPostsInQueueInput;
};


/** Root mutation type for team management operations. */
export type MutationSwapShopGridCustomLinksArgs = {
  input: SwapShopGridCustomLinksInput;
};


/** Root mutation type for team management operations. */
export type MutationSwitchBillingGatewayArgs = {
  input: SwitchBillingGatewayInput;
};


/** Root mutation type for team management operations. */
export type MutationToggleChannelCapabilitySynchronizationArgs = {
  input: ToggleChannelCapabilitySynchronizationInput;
};


/** Root mutation type for team management operations. */
export type MutationTrackExternalServiceUsageForChannelArgs = {
  action: Scalars['String']['input'];
  channelServiceId: Scalars['String']['input'];
  domain: ExternalServiceDomain;
  endpoint: Scalars['String']['input'];
  service: ChannelThirdPartyService;
  source: Scalars['String']['input'];
};


/** Root mutation type for team management operations. */
export type MutationTrackExternalServiceUsageForOrganizationArgs = {
  action: Scalars['String']['input'];
  domain: ExternalServiceDomain;
  endpoint: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  service: ChannelThirdPartyService;
  source: Scalars['String']['input'];
};


/** Root mutation type for team management operations. */
export type MutationTrackOnboardingSurveyCompletedArgs = {
  input: OnboardingSurveyCompletedInput;
};


/** Root mutation type for team management operations. */
export type MutationTrackOnboardingSurveySkippedArgs = {
  input: OnboardingSurveyActionInput;
};


/** Root mutation type for team management operations. */
export type MutationTrackOnboardingSurveyViewedArgs = {
  input: OnboardingSurveyActionInput;
};


/** Root mutation type for team management operations. */
export type MutationTransferOrganizationOwnershipArgs = {
  input: TransferOrganizationOwnershipInput;
};


/** Root mutation type for team management operations. */
export type MutationTwoFactorConfirmArgs = {
  input: TwoFactorConfirmInput;
};


/** Root mutation type for team management operations. */
export type MutationTwoFactorDisableByAccountIdArgs = {
  input: TwoFactorDisableByAccountIdInput;
};


/** Root mutation type for team management operations. */
export type MutationTwoFactorSetupArgs = {
  input: TwoFactorSetupInput;
};


/** Root mutation type for team management operations. */
export type MutationUnPublishStartPageArgs = {
  organizationId: Scalars['String']['input'];
  pageId: Scalars['String']['input'];
};


/** Root mutation type for team management operations. */
export type MutationUndismissCommentArgs = {
  input: UndismissCommentInput;
};


/** Root mutation type for team management operations. */
export type MutationUndismissEngagementArgs = {
  input: UndismissEngagementInput;
};


/** Root mutation type for team management operations. */
export type MutationUnresolveConversationArgs = {
  input: UnresolveConversationInput;
};


/** Root mutation type for team management operations. */
export type MutationUpdateApiClientArgs = {
  input: UpdateApiClientInput;
};


/** Root mutation type for team management operations. */
export type MutationUpdateApiClientSuspensionStatusArgs = {
  input: UpdateApiClientSuspensionStatusInput;
};


/** Root mutation type for team management operations. */
export type MutationUpdateAccountAvatarArgs = {
  input: UpdateAccountAvatarInput;
};


/** Root mutation type for team management operations. */
export type MutationUpdateAccountNameArgs = {
  input: UpdateAccountNameInput;
};


/** Root mutation type for team management operations. */
export type MutationUpdateAccountPreferencesArgs = {
  input: UpdateAccountPreferencesInput;
};


/** Root mutation type for team management operations. */
export type MutationUpdateAccountTimezoneArgs = {
  input: UpdateAccountTimezoneInput;
};


/** Root mutation type for team management operations. */
export type MutationUpdateAdminCommentArgs = {
  input: UpdateAdminCommentInput;
};


/** Root mutation type for team management operations. */
export type MutationUpdateAnalyticsLastUpdatedAtByIngestionTypeArgs = {
  input: AnalyticsLastUpdatedAtInput;
};


/** Root mutation type for team management operations. */
export type MutationUpdateBillingSubscriptionPlanArgs = {
  input: UpdateBillingSubscriptionPlanInput;
};


/** Root mutation type for team management operations. */
export type MutationUpdateChangelogEntryArgs = {
  input: UpdateChangelogEntryInput;
};


/** Root mutation type for team management operations. */
export type MutationUpdateChannelGroupArgs = {
  input: UpdateChannelGroupInput;
};


/** Root mutation type for team management operations. */
export type MutationUpdateChannelMemberPermissionsArgs = {
  input: UpdateChannelMemberPermissionsInput;
};


/** Root mutation type for team management operations. */
export type MutationUpdateChannelPermissionsArgs = {
  input: UpdateChannelPermissionsInput;
};


/** Root mutation type for team management operations. */
export type MutationUpdateChannelPostingGoalArgs = {
  input: UpdateChannelPostingGoalInput;
};


/** Root mutation type for team management operations. */
export type MutationUpdateCollaborationNoteArgs = {
  input: UpdateCollaborationNoteInput;
};


/** Root mutation type for team management operations. */
export type MutationUpdateContentItemArgs = {
  input: UpdateContentItemInput;
};


/** Root mutation type for team management operations. */
export type MutationUpdateContentItemDraftArgs = {
  input: UpdateContentItemDraftInput;
};


/** Root mutation type for team management operations. */
export type MutationUpdateCustomChannelArgs = {
  input: UpdateCustomChannelInput;
};


/** Root mutation type for team management operations. */
export type MutationUpdateCustomLinksColorsArgs = {
  input: UpdateCustomLinksColorsInput;
};


/** Root mutation type for team management operations. */
export type MutationUpdateCustomerIoAttributesArgs = {
  input: UpdateCustomerIoAttributesInput;
};


/** Root mutation type for team management operations. */
export type MutationUpdateFeatureTokenUsageForOrganizationArgs = {
  organizationId: Scalars['String']['input'];
  tokenUsageInput?: InputMaybe<TokenUsageInput>;
};


/** Root mutation type for team management operations. */
export type MutationUpdateFeedArgs = {
  input: UpdateFeedInput;
};


/** Root mutation type for team management operations. */
export type MutationUpdateFeedCollectionArgs = {
  input: UpdateFeedCollectionInput;
};


/** Root mutation type for team management operations. */
export type MutationUpdateIdeaArgs = {
  input: UpdateIdeaInput;
};


/** Root mutation type for team management operations. */
export type MutationUpdateIdeaGroupArgs = {
  input: UpdateIdeaGroupInput;
};


/** Root mutation type for team management operations. */
export type MutationUpdateLastActivityAtForChannelArgs = {
  input: UpdateLastActivityAtForChannelInput;
};


/** Root mutation type for team management operations. */
export type MutationUpdateLinkShorteningSettingsArgs = {
  input: LinkShorteningSettingsInput;
};


/** Root mutation type for team management operations. */
export type MutationUpdateManagedPostTemplateArgs = {
  input: UpdateManagedPostTemplateInput;
};


/** Root mutation type for team management operations. */
export type MutationUpdateNoteOnPostArgs = {
  input: UpdateNoteOnPostInput;
};


/** Root mutation type for team management operations. */
export type MutationUpdateOrganizationBillingEmailArgs = {
  input: UpdateOrganizationBillingEmailInput;
};


/** Root mutation type for team management operations. */
export type MutationUpdateOrganizationEnforce2FaArgs = {
  input: UpdateOrganizationEnforce2FaInput;
};


/** Root mutation type for team management operations. */
export type MutationUpdatePasswordArgs = {
  input: UpdatePasswordInput;
};


/** Root mutation type for team management operations. */
export type MutationUpdatePostDueAtArgs = {
  input: UpdatePostDueAtInput;
};


/** Root mutation type for team management operations. */
export type MutationUpdatePostTagsArgs = {
  input: UpdatePostTagsInput;
};


/** Root mutation type for team management operations. */
export type MutationUpdatePostTemplateArgs = {
  input: UpdatePostTemplateInput;
};


/** Root mutation type for team management operations. */
export type MutationUpdatePostTemplateCampaignArgs = {
  input: UpdatePostTemplateCampaignInput;
};


/** Root mutation type for team management operations. */
export type MutationUpdateSavedReplyArgs = {
  input: UpdateSavedReplyInput;
};


/** Root mutation type for team management operations. */
export type MutationUpdateSavedViewArgs = {
  input: UpdateSavedViewInput;
};


/** Root mutation type for team management operations. */
export type MutationUpdateShopGridCustomLinkArgs = {
  input: UpdateShopGridCustomLinkInput;
};


/** Root mutation type for team management operations. */
export type MutationUpdateShopGridPostLinkArgs = {
  input: UpdateShopGridPostLinkInput;
};


/** Root mutation type for team management operations. */
export type MutationUpdateSnippetArgs = {
  input: UpdateSnippetInput;
};


/** Root mutation type for team management operations. */
export type MutationUpdateStartOfWeekPreferenceArgs = {
  input: UpdateStartOfWeekPreferenceInput;
};


/** Root mutation type for team management operations. */
export type MutationUpdateSubscriptionQuantityArgs = {
  input: UpdateSubscriptionQuantityInput;
};


/** Root mutation type for team management operations. */
export type MutationUpdateTagArgs = {
  input: UpdateTagInput;
};


/** Root mutation type for team management operations. */
export type MutationUpdateTagInIdeasArgs = {
  input: UpdateTagInIdeasInput;
};


/** Root mutation type for team management operations. */
export type MutationUpdateTeamMemberRoleArgs = {
  input: UpdateTeamMemberRoleInput;
};


/** Root mutation type for team management operations. */
export type MutationUpdateTimeFormatPreferenceArgs = {
  input: UpdateTimeFormatPreferenceInput;
};


/** Root mutation type for team management operations. */
export type MutationUpdateTimezoneForChannelArgs = {
  input: UpdateTimezoneForChannelInput;
};


/** Root mutation type for team management operations. */
export type MutationUpdateTrendingTopicSuggestionsVisibilityArgs = {
  input: UpdateTrendingTopicSuggestionsVisibilityInput;
};


/** Root mutation type for team management operations. */
export type MutationUpgradePlanToAnnualBillingArgs = {
  input: UpgradePlanToAnnualBillingInput;
};


/** Root mutation type for team management operations. */
export type MutationUpsertFeedArgs = {
  input: CreateFeedInput;
};


/** Root mutation type for team management operations. */
export type MutationVerifyAccountLoginArgs = {
  input: VerifyAccountLoginInput;
};


/** Root mutation type for team management operations. */
export type MutationVerifyPasswordArgs = {
  input: VerifyPasswordInput;
};


/** Root mutation type for team management operations. */
export type MutationVerifyTfaCodeArgs = {
  input: VerifyTfaCodeInput;
};


/** Root mutation type for team management operations. */
export type MutationVoteForFeatureOnFeatureOsArgs = {
  accountId: Scalars['String']['input'];
  featureId: Scalars['Int']['input'];
};

export type MutationBasicError = {
  /** A raw error message to help developers understand the root cause of the issue. */
  cause: Scalars['String']['output'];
  /** A user-friendly message that is safe to be displayed to users. */
  userFriendlyMessage: Scalars['String']['output'];
};

export type MutationBasicPayload = BasicError | MutationBasicResponse;

export type MutationBasicResponse = {
  __typename?: 'MutationBasicResponse';
  /** Temporary because we need to declare a type for the union returned by the mutation. Ideally, we should evolve it with more meaningful data for the frontend. */
  success: Scalars['Boolean']['output'];
};

/** Base Mutation Error type */
export type MutationError = {
  /** Error message */
  message: Scalars['String']['output'];
};

export type MutationResponse = {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  mutation: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

/**
 * Base Mutation Success type
 * Used when we have a success response with no data, we return this type with empty string
 */
export type MutationSuccess = {
  /**
   * The value is alwaus an empty string ''
   * Note: GraphQL doesn't allow types with no fields, so we have to add this field
   */
  _empty: Scalars['String']['output'];
};

export type NativeChannelInput = {
  avatar: Scalars['String']['input'];
  /** channelId is only necessary for update operation: omitting the channeId will result in channel creation */
  channelId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  service: ChannelNativeService;
  type: ChannelType;
};

/** Connection metadata for RSS feeds */
export type NewsSearchConnectionMetadata = {
  __typename?: 'NewsSearchConnectionMetadata';
  /** Search query */
  query?: Maybe<Scalars['String']['output']>;
};

/** Create a live news search feed by query string */
export type NewsSearchFeedCreation = {
  /** The query string to use for news search */
  query: Scalars['String']['input'];
};

/** Represents the next invoice for a subscription */
export type NextInvoice = {
  __typename?: 'NextInvoice';
  /** The currency for the amount as an uppercase, three-letter ISO 4217 currency code (e.g., "USD", "EUR"). */
  currency: Scalars['String']['output'];
  /** The amount of tax that will be charged to the customer, in cents */
  taxAmount: Scalars['Int']['output'];
  /** The total amount that will be charged to the customer, in cents */
  totalAmount: Scalars['Int']['output'];
};

/** Error returned when the resource is not found */
export type NotFoundError = MutationError & {
  __typename?: 'NotFoundError';
  /** Error message */
  message: Scalars['String']['output'];
};

/** Note entity */
export type Note = {
  __typename?: 'Note';
  /** The allowed actions a user can perform on the note. */
  allowedActions: Array<NoteAction>;
  /** The author of the note - null if the user is deleted or left the organization. */
  author: Author;
  /** The date and time when the note was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The unique identifier of the note. */
  id: Scalars['NoteId']['output'];
  /** The content of the note. */
  text: Scalars['String']['output'];
  /** The type of the note. */
  type: NoteType;
  /** The date and time when the note was last edited. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** List of possible actions that can be performed on a note */
export enum NoteAction {
  /** The user can delete the note. */
  DeleteNote = 'deleteNote',
  /** The user can add or remove their emoji reactions on the note. */
  ReactToNote = 'reactToNote',
  /** The user can update the note. */
  UpdateNote = 'updateNote'
}

export type NoteAuthor = {
  __typename?: 'NoteAuthor';
  avatar: Scalars['String']['output'];
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

/** The type of a note. */
export enum NoteType {
  /** A note that was generated by our AI system. */
  AiGenerated = 'aiGenerated',
  /** A note that was generated by our internal system. Can be used for approval flows notifications or other automated processes. */
  BufferGenerated = 'bufferGenerated',
  /** A note that was manually written by a user. */
  UserGenerated = 'userGenerated'
}

/** List of possible statuses for a notification */
export enum NotificationStatus {
  MarkedAsPublished = 'markedAsPublished',
  Notified = 'notified'
}

/** Represents an OAuth scope that can be requested by API clients. */
export type OAuthScope = {
  __typename?: 'OAuthScope';
  /** Whether this scope grants read or write access */
  access: OAuthScopeAccess;
  /** Description of what this scope grants access to */
  description: Scalars['String']['output'];
  /** The resource group this scope belongs to (e.g., 'Posts', 'Ideas', 'Account') */
  group: Scalars['String']['output'];
  /** The scope identifier (e.g., 'posts:read', 'account:write') */
  name: Scalars['String']['output'];
  /** A human-readable description of what this scope grants access to */
  userFriendlyDescription: Scalars['String']['output'];
};

/** The access level of a scope */
export enum OAuthScopeAccess {
  Read = 'read',
  Write = 'write'
}

/** Input for oauthScopes query */
export type OAuthScopesInput = {
  /** Placeholder for future filtering options */
  _placeholder?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Response for oauthScopes query */
export type OAuthScopesResponse = {
  __typename?: 'OAuthScopesResponse';
  /** The list of available OAuth scopes */
  scopes: Array<OAuthScope>;
};

export type ObBilling = Billing & {
  __typename?: 'OBBilling';
  /** Describes the billing address of the customer */
  address?: Maybe<Address>;
  /** Any credit (negative balance) or debit (positive balance) a customer might have */
  balance: Scalars['Float']['output'];
  /** @deprecated Use `Organization.entitlements` and check for `analytics` instead. This field is computed from the same entitlement set. */
  canAccessAnalytics: Scalars['Boolean']['output'];
  /** @deprecated Use `Organization.entitlements` and check for `engagement` instead. This field is computed from the same entitlement set. */
  canAccessEngagement: Scalars['Boolean']['output'];
  /** @deprecated Use `Organization.entitlements` and check for `publishing` instead. This field is computed from the same entitlement set. */
  canAccessPublishing: Scalars['Boolean']['output'];
  canGenerateContent: Scalars['Boolean']['output'];
  canStartTrial: Scalars['Boolean']['output'];
  /** @deprecated Use `planSelectorData` for plan options. To start a trial, call `startTrial` without a plan; the server selects the trial plan. */
  changePlanOptions: Array<Maybe<ObPlanOption>>;
  /** @deprecated Use `subscription.plan.pricing` on the modern `billing` / `planSelectorData` queries (see `Plan.pricing: [PlanPricingTier!]!`). Whether pricing is tiered is exposed as `isTieredPricing` on `BillingInformation`. */
  channelSlotDetails: ChannelSlotDetails;
  /** Describes any discount coupon a customer might have */
  discount?: Maybe<Discount>;
  gateway: GatewayDetails;
  generateContentTokensLeft: Scalars['Int']['output'];
  hasNeverBeenPayingCustomer: Scalars['Boolean']['output'];
  /** Organization ID for which these billing details belong to */
  id: Scalars['String']['output'];
  /** Describes whether the customer is eligible for automatic tax collection in Stripe */
  isAutomaticTaxEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Describes whether the customer's subscription is eligible for automatic tax collection in Stripe */
  isSubscriptionTaxEnabled?: Maybe<Scalars['Boolean']['output']>;
  paymentDetails: PaymentDetails;
  previousGateway?: Maybe<GatewayDetails>;
  /** A set of price details that support tiers, used to calculate the total cost on the client. Non-tiered plans will only contain one PricingTier */
  pricingTiers: Array<PricingTier>;
  /** The amount of channels that can be refunded */
  refundableChannels: Scalars['Int']['output'];
  subscription: ObSubscription;
  /** Describes tax details for the Stripe customer */
  taxDetails?: Maybe<TaxDetails>;
  /** Describes customer's tax exemption status */
  taxExempt?: Maybe<Scalars['String']['output']>;
  /** Describes tax ids customer might have */
  taxIds?: Maybe<Array<Maybe<TaxId>>>;
  upcomingInvoice?: Maybe<InvoiceDetails>;
  upcomingInvoiceAmount?: Maybe<Scalars['Float']['output']>;
};

export type ObPlan = {
  __typename?: 'OBPlan';
  id: ObPlanId;
  interval: BillingInterval;
  limits: PlanLimits;
  name: Scalars['String']['output'];
  prices: PlanPrices;
};

export enum ObPlanId {
  Agency = 'agency',
  Essentials = 'essentials',
  Free = 'free',
  Team = 'team'
}

export type ObPlanOption = {
  __typename?: 'OBPlanOption';
  /** A message that displays the savings between, yearly and monthly. e.g. 'Save $24/year' when monthly plan selected or 'Saving $24/year' when yearly plan selected. For Free plans the value is empty string '' */
  absoluteSavings: Scalars['String']['output'];
  basePrice: Scalars['Float']['output'];
  /**
   * A set of values per plan option to be used for calculating the 'Slot Based' price on the client side.
   * @deprecated Use `PlanOption.pricing` on `planSelectorData.availablePlans` (see `PlanOption.pricing: [PlanPricingTier!]!`).
   */
  channelSlotDetails?: Maybe<ChannelSlotDetails>;
  currency: Scalars['String']['output'];
  description: Scalars['String']['output'];
  /**
   * A message that will be displayed when the subscription is to be canceled at the period end.
   * e.g. Your plan was recently changed to Free. You can continue using the Essentials plan features until the end of your billing cycle on April 24, 2021.
   */
  downgradedMessage: Scalars['String']['output'];
  highlights: Array<Maybe<Scalars['String']['output']>>;
  highlightsHeading: Scalars['String']['output'];
  isCurrentPlan: Scalars['Boolean']['output'];
  /** @deprecated Always marks the Team plan for free and trialing subscriptions. To start a trial, call `startTrial` without a plan. */
  isRecommended: Scalars['Boolean']['output'];
  planId: ObPlanId;
  planInterval: BillingInterval;
  planName: Scalars['String']['output'];
  priceNote: Scalars['String']['output'];
  /** A set of price details that support tiers, used to calculate the total cost on the client. Non-tiered plans will only contain one PricingTierÏ */
  pricingTiers: Array<PricingTier>;
  summary: ObPlanOptionSummary;
  totalPrice: Scalars['Float']['output'];
};

export type ObPlanOptionSummary = {
  __typename?: 'OBPlanOptionSummary';
  details: Array<Maybe<Scalars['String']['output']>>;
};

export type ObSubscription = GenericSubscription & {
  __typename?: 'OBSubscription';
  /** The UTC DateTime of the cancelation */
  canceledAt?: Maybe<Scalars['DateTime']['output']>;
  gatewayId?: Maybe<Scalars['String']['output']>;
  interval: BillingInterval;
  /** Indicates if a subscription is going to be canceled at the end of the its period */
  isCanceledAtPeriodEnd: Scalars['Boolean']['output'];
  /**
   * Indicates whether the customer's current subscription payment is past due. Used by the frontend to display a past due banner to the customer.
   * This field is not for the purpose of determining subscription status (see the Billing interface instead)
   */
  isPaymentPastDue?: Maybe<Scalars['Boolean']['output']>;
  /** The UTC DateTime of the subscription period end. Free plan does not have periodEnd */
  periodEnd?: Maybe<Scalars['DateTime']['output']>;
  plan: ObPlan;
  quantity: Scalars['Int']['output'];
  scheduledUpdate?: Maybe<ScheduledSubscriptionUpdate>;
  /** The UTC DateTime of when the subscription was originally created */
  startDate?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The true subscription value before any discounts are applied, in dollars.
   * This represents what the customer would pay if they had no discounts (e.g., coupons, promotions).
   */
  subscriptionValueBeforeDiscount?: Maybe<Scalars['Float']['output']>;
  trial?: Maybe<Trial>;
};

/** Configuration for oEmbed support */
export type OEmbed = {
  __typename?: 'OEmbed';
  /** Whether the channel supports oEmbed */
  supportOembed: Scalars['Boolean']['output'];
};

/** The oEmbed response object as specified by https://oembed.com/. */
export type OEmbedRich = {
  __typename?: 'OEmbedRich';
  /** The name of the author/owner of the resource. */
  authorName?: Maybe<Scalars['String']['output']>;
  /** A URL for the author/owner of the resource. */
  authorUrl?: Maybe<Scalars['String']['output']>;
  /** Suggested cache lifetime for the resource (in seconds). */
  cacheAge?: Maybe<Scalars['Int']['output']>;
  /**
   * The height of the embedded resource in pixels.
   * Regarding the specification this field should be mandatory but Threads at least
   * is not sending us this field, so we'll keep optional by now.
   */
  height?: Maybe<Scalars['Int']['output']>;
  /** The HTML required to embed the resource. */
  html: Scalars['String']['output'];
  /** The name of the resource provider. */
  providerName?: Maybe<Scalars['String']['output']>;
  /** The URL of the resource provider. */
  providerUrl?: Maybe<Scalars['String']['output']>;
  /** The height of the thumbnail image in pixels. */
  thumbnailHeight?: Maybe<Scalars['Int']['output']>;
  /** A URL to a thumbnail image representing the resource. */
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  /** The width of the thumbnail image in pixels. */
  thumbnailWidth?: Maybe<Scalars['Int']['output']>;
  /** A text title, describing the resource. */
  title?: Maybe<Scalars['String']['output']>;
  /** The type of content. Always "rich". */
  type: Scalars['String']['output'];
  /** The oEmbed version number. Currently, only "1.0" is supported. */
  version: Scalars['String']['output'];
  /** The width of the embedded resource in pixels. */
  width: Scalars['Int']['output'];
};

/** The onboarding flow has already been completed for this organization. */
export type OnboardingAlreadyCompletedError = MutationError & {
  __typename?: 'OnboardingAlreadyCompletedError';
  /** Human-readable error message. */
  message: Scalars['String']['output'];
};

/** The full onboarding state for an organization. */
export type OnboardingData = {
  __typename?: 'OnboardingData';
  /** The slug identifying which flow definition is active. */
  flowSlug: Scalars['String']['output'];
  /** Responses recorded so far. */
  responses: Array<OnboardingResponse>;
  /** Current status of the onboarding flow. */
  status: OnboardingFlowStatus;
  /** The version of the flow definition. */
  version: Scalars['Int']['output'];
};

/** The status of an onboarding flow. */
export enum OnboardingFlowStatus {
  Completed = 'completed',
  InProgress = 'inProgress',
  NotStarted = 'notStarted'
}

/** A recorded response to an onboarding step. */
export type OnboardingResponse = {
  __typename?: 'OnboardingResponse';
  /** The option slugs the user selected. */
  selectedOptions: Array<Scalars['String']['output']>;
  /** Whether the user skipped this step. */
  skipped: Scalars['Boolean']['output'];
  /** The slug of the step this response is for. */
  stepSlug: Scalars['String']['output'];
  /** Free-form text value if the step was a text input. */
  textValue?: Maybe<Scalars['String']['output']>;
};

/** A single step in an onboarding flow. */
export type OnboardingStep = IntroductionStep | SurveyStep | TourStep;

/** Onboarding Survey Input Type for tracking an action */
export type OnboardingSurveyActionInput = {
  /** organizationId of the organization that the survey is being taken for */
  organizationId: Scalars['OrganizationId']['input'];
  /** surveyId of the survey that is being tracked */
  surveyId: Scalars['String']['input'];
};

/** Onboarding Survey Action Taken */
export type OnboardingSurveyActionTaken = {
  __typename?: 'OnboardingSurveyActionTaken';
  /** action that was taken */
  action: OnboardingSurveyActionTakenType;
  /** timestamp when the action was taken */
  date: Scalars['String']['output'];
};

/** Onboarding Survey: 3 different types of actions can be taken */
export enum OnboardingSurveyActionTakenType {
  Completed = 'completed',
  Skipped = 'skipped',
  Viewed = 'viewed'
}

/** Input for saving a completed onboarding survey with its answers. */
export type OnboardingSurveyCompletedInput = {
  /** organizationId of the organization that the survey has been completed */
  organizationId: Scalars['OrganizationId']['input'];
  /** answers to the survey questions */
  questions: Array<OnboardingSurveyQuestionInput>;
  /** surveyId of the survey that is being taken */
  surveyId: Scalars['String']['input'];
};

/** OnboardingSurveyQuestion Input Type */
export type OnboardingSurveyQuestionInput = {
  /** answer options for the question */
  answers: Array<Scalars['String']['input']>;
  /** questionId of the question */
  questionId: Scalars['String']['input'];
};

/** Input parameters for optimizing a channel's posting schedule with Buffer's recommendations */
export type OptimizePostingScheduleInput = {
  /** The ID of the channel to optimize the schedule for */
  channelId: Scalars['ChannelId']['input'];
  /** Target number of posts per week (1-168) */
  postsPerWeek: Scalars['Int']['input'];
  /** How to apply recommendations to the existing schedule (override or add) */
  updateMode: OptimizeScheduleMode;
};

/** The result of optimizing a posting schedule */
export type OptimizePostingSchedulePayload = InvalidInputError | NotFoundError | OptimizePostingScheduleResponse | UnauthorizedError | UnexpectedError;

/** Response for successful schedule optimization */
export type OptimizePostingScheduleResponse = {
  __typename?: 'OptimizePostingScheduleResponse';
  /** The updated posting schedule */
  postingSchedule: Array<ScheduleV2>;
};

/** The mode for updating the posting schedule: override or add */
export enum OptimizeScheduleMode {
  Add = 'add',
  Override = 'override'
}

/** Input for optimize strategy - uses Buffer's research-based optimal times */
export type OptimizeStrategyInput = {
  /** Target number of posts per week (1-168) */
  postsPerWeek: Scalars['Int']['input'];
  /** How to apply optimization (reuses existing OptimizeScheduleMode enum) */
  updateMode: OptimizeScheduleMode;
};

/** Input for ordering a channel for an account */
export type OrderChannelForAccountInput = {
  /**
   * ID of the channel after which the target channel should be positioned.
   * If set to null, the channel to order will go to the first position of the list
   */
  afterChannelId?: InputMaybe<Scalars['ChannelId']['input']>;
  /** ID of the channel to be ordered */
  channelId: Scalars['ChannelId']['input'];
  /** ID of the organization to be ordered */
  organizationId: Scalars['OrganizationId']['input'];
};

/** Possible responses when ordering a channel for an account */
export type OrderChannelForAccountPayload = EmptySuccess | NotFoundError | UnexpectedError;

/** Organization is a representation of a Buffer Organization. */
export type Organization = {
  __typename?: 'Organization';
  /** Indicates what actions the current account can perform on the organization */
  allowedActions: Array<OrganizationAction>;
  /** The billing information of the organization. */
  billing: Billing;
  /** The billing notifications of the organization. Can be used to check if the organization has certain billing notifications. */
  billingNotifications: BillingNotificationSet;
  /** Whether the organization is within the rate limit to add payment details. */
  canAddPaymentDetails: Scalars['Boolean']['output'];
  /**
   * Whether the current account can edit the organization.
   * @deprecated deprecated in favor of allowedActions field
   */
  canEdit: Scalars['Boolean']['output'];
  /**
   * Whether the current account can manage billing for the organization.
   * @deprecated deprecated in favor of allowedActions field
   */
  canManageBilling?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the organization can migrate to Buffer via Hub. */
  canMigrateToBufferViaHub: CanMigrateToOneBuffer;
  /** Whether the organization can migrate to One Buffer. */
  canMigrateToOneBuffer: CanMigrateToOneBuffer;
  /** The total number of channels connected to the organization. */
  channelCount: Scalars['Int']['output'];
  /**
   * The channel limit of the organization.
   * @deprecated deprecated in favor of field 'limits'
   */
  channelLimit: Scalars['Int']['output'];
  /** The channel recommendations for the organization. */
  channelRecommendations: Array<Scalars['String']['output']>;
  /** Fetch all channels for the organization taking into account the current's user permissions */
  channels: Array<Channel>;
  /**
   * The Roles role of the current account in this organization.
   * Reads as `viewer`, the lowest role, when the organization does not have Roles
   * enabled, or when the account has no stored role yet.
   * Should only be used for displaying to the user, not for authorization purposes.
   * For authorization purposes, use the allowedActions field.
   */
  collaborationRole: CollaborationRole;
  /** The tracking properties of the organization for frontend tracking */
  commonTrackingProperties: CommonTrackingProperties;
  /** The owner account ID of the organization. */
  contactAccountId: Scalars['AccountId']['output'];
  /** The date and time the organization was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The list of dismissed notifications for the organization. */
  dismissedObjects: Array<DismissedObject>;
  /** The entitlements of the organization. Can be used to check if the organization has access to certain features. */
  entitlements: Array<Entitlement>;
  /**
   * Feature flips belonging to the organization admin account.
   * In the future, we might want to start creating feature flips in the
   * organization object itself.
   */
  featureFlips: Array<Scalars['String']['output']>;
  /** The latest high-scale qualification verdict, or null when no verdict has been recorded. */
  highScaleQualification?: Maybe<OrganizationHighScaleQualification>;
  /** The ID of the organization. */
  id: Scalars['OrganizationId']['output'];
  /** Is the organization enrolled in the alpha program? */
  isAlphaEnabled: Scalars['Boolean']['output'];
  /** Is the organization enrolled in the beta program? */
  isBetaEnabled: Scalars['Boolean']['output'];
  /** Whether this organization is the current organization for the requesting account. */
  isCurrentOrganization: Scalars['Boolean']['output'];
  /** Whether the organization is on One Buffer billing plan. */
  isOneBufferOrganization: Scalars['Boolean']['output'];
  /**
   * Whether the organization is on the Roles permission model. Organizations that
   * have not been migrated are on the legacy permission levels and report false.
   */
  isRolesEnabled: Scalars['Boolean']['output'];
  /** Whether this organization has trusted partner status for elevated API rate limits. */
  isTrustedPartner: Scalars['Boolean']['output'];
  /** The list of connected channels per service for the organization. */
  lifetimeConnectedChannelsCount: Array<LifetimeConnectedChannelCount>;
  /** The limits of the organization. Can be used to check if the organization has reached the limit of channels, members, etc. */
  limits: OrganizationLimits;
  /** The members of the organization. Can be used to check the total number of members in the organization. In the future, it might contain more information about the members. */
  members: MemberConnection;
  /** The name of the organization. */
  name: Scalars['String']['output'];
  /** The onboarding state for this organization, or null if onboarding has not been initiated. */
  onboarding?: Maybe<OnboardingData>;
  /** The owner email of the organization. */
  ownerEmail: Scalars['String']['output'];
  /**
   * Represents what actions the current account can perform in the organization.
   * @deprecated deprecated in favor of allowedActions field
   */
  privileges: AccountPrivileges;
  /**
   * The role of the current account in this organization.
   * Derives from the organization's team member data for the current account.
   * On organizations with Roles enabled, only the Admin role reads as `admin`;
   * every other role reads as `member`.
   * Should only be used for displaying to the user, not for authorization purposes.
   * For authorization purposes, use the allowedActions field.
   * @deprecated deprecated in favor of collaborationRole field
   */
  role: TeamMemberRole;
  /** Organization-level settings (e.g. 2FA enforcement). */
  settings: OrganizationSettings;
  /**
   * We display the invite CTA when the organization account is an admin and when there are no more
   * members in the organization than the admin.
   */
  shouldDisplayInviteCTA: Scalars['Boolean']['output'];
  /**
   * Whether the requesting actor should be sent through 2FA setup before they
   * can use this organization. Derived: true only when the org has
   * `settings.enforce2FA` ON and the actor has no 2FA configured on their own
   * account.
   *
   * This is the single source of truth for the forced-2FA gate; app-shell and
   * publish-frontend redirect to the setup flow when it's true. Exposed to the
   * API gateway so any stitched consumer reads the same value.
   */
  shouldEnforce2FASetup: Scalars['Boolean']['output'];
  /** Whether we should show the team member organization downgraded banner for the organization. */
  shouldShowTeamMemberOrganizationDowngradedBanner: Scalars['Boolean']['output'];
  /**
   * Team member counts for the Roles Team Members page. Members are counted by
   * their stored CollaborationRole. Organizations still on legacy permissions
   * return empty counts — query this only where isRolesEnabled is true.
   */
  teamMemberCounts: TeamMemberCounts;
  /** Fetch all accounts that can be new owners for this organization */
  validNewOwners: Array<Account>;
};


/** Organization is a representation of a Buffer Organization. */
export type OrganizationChannelsArgs = {
  input?: InputMaybe<OrganizationChannelsInput>;
  product?: InputMaybe<Product>;
};

/** List of possible actions that can be performed on a Organization */
export enum OrganizationAction {
  CreatePostGroup = 'createPostGroup',
  CreatePostTemplate = 'createPostTemplate',
  Edit = 'edit',
  ManageAllNotes = 'manageAllNotes',
  ManageBilling = 'manageBilling',
  ManageChannelGroups = 'manageChannelGroups',
  ManageChannels = 'manageChannels',
  ManageFeeds = 'manageFeeds',
  ManageIdeas = 'manageIdeas',
  ManageIntegrations = 'manageIntegrations',
  ManageSavedReplies = 'manageSavedReplies',
  ManageSecurityTfaEnforcement = 'manageSecurityTFAEnforcement',
  ManageSnippets = 'manageSnippets',
  ManageTags = 'manageTags',
  ManageTeamMembers = 'manageTeamMembers',
  ManageTemplates = 'manageTemplates',
  ManageTrustedPartnerStatus = 'manageTrustedPartnerStatus',
  ManageUploads = 'manageUploads',
  PublishStartPages = 'publishStartPages',
  ReadUploads = 'readUploads',
  ReceiveOrganizationOwnership = 'receiveOrganizationOwnership',
  TransferOwnership = 'transferOwnership',
  View = 'view',
  ViewFeeds = 'viewFeeds',
  ViewIdeas = 'viewIdeas',
  ViewSnippets = 'viewSnippets',
  ViewTags = 'viewTags',
  ViewTeamMembers = 'viewTeamMembers',
  ViewTemplates = 'viewTemplates'
}

/**
 * Aggregate usage data for an organization, used by surfaces that want to
 * remind a user how much value they've gotten from Buffer (e.g. the
 * cancellation deflection flow).
 *
 * Every metric is nullable. The server returns `null` when a metric falls
 * below a low-signal threshold so consumers can simply omit it rather than
 * applying that logic themselves.
 */
export type OrganizationActivitySummary = {
  __typename?: 'OrganizationActivitySummary';
  /**
   * Lifetime count of comment replies sent from this organization. Null when
   * below the surfacing threshold or if the underlying query times out for
   * high-volume organizations.
   */
  commentReplies?: Maybe<LifetimeUsageMetric>;
  /**
   * Total engagement (reactions + comments) across the organization's
   * connected channels for a rolling 30-day window, with the signed
   * period-over-period change. Null when below the surfacing threshold.
   */
  engagement?: Maybe<WindowedUsageMetric>;
  /**
   * Total followers across the organization's connected channels, with the
   * absolute change over a rolling 30-day window. Null when below the
   * surfacing threshold. The window is capped at 30 days because
   * ChannelAnalytics backfill is bounded; longer windows would conflate
   * "no data" with zero growth.
   */
  followers?: Maybe<WindowedUsageMetric>;
  /**
   * Lifetime count of ideas created in this organization. Null when below
   * the surfacing threshold.
   */
  ideasCreated?: Maybe<LifetimeUsageMetric>;
  /**
   * Lifetime count of posts published from this organization across all
   * channels. Null when below the surfacing threshold.
   */
  postsPublished?: Maybe<LifetimeUsageMetric>;
  /**
   * Current weekly posting streak for the organization, plus the longest
   * streak it has reached. Null when the current streak is below the
   * surfacing threshold or if the underlying lookup fails.
   */
  weeklyPostingStreak?: Maybe<StreakUsageMetric>;
};

/**
 * Signals that the consumer should render its default-state UI with no
 * backend metrics. Returned when the organization is too new or has too
 * little posting history to surface meaningful activity numbers.
 */
export type OrganizationActivitySummaryDefaultState = {
  __typename?: 'OrganizationActivitySummaryDefaultState';
  /**
   * Human-readable description of the state. Carries no metric data —
   * consumers should discriminate on `__typename`.
   */
  message: Scalars['String']['output'];
};

/** Input for organizationActivitySummary. */
export type OrganizationActivitySummaryInput = {
  /** The organization for which to retrieve activity data. */
  organizationId: Scalars['OrganizationId']['input'];
};

/**
 * Result of `organizationActivitySummary`. Discriminated on `__typename`:
 *
 * - `OrganizationActivitySummary` — the organization has enough history to
 *   surface metrics; consumers render the activity panel (individual fields
 *   may still be null when they fall below per-metric surfacing thresholds).
 * - `OrganizationActivitySummaryDefaultState` — the organization is too new
 *   or has too little posting history to render meaningful numbers;
 *   consumers should render their default-state UI without any metric data.
 */
export type OrganizationActivitySummaryPayload = OrganizationActivitySummary | OrganizationActivitySummaryDefaultState;

/** Input for the channels field on Account */
export type OrganizationChannelsInput = {
  /** Query's filter. */
  filter?: InputMaybe<ChannelsFiltersInput>;
};

export type OrganizationFeatureUsageUpdateResponse = Error | Response;

/** Allow retrieving a specific Organization */
export type OrganizationFilterInput = {
  organizationId: Scalars['String']['input'];
};

/** The latest high-scale qualification verdict for an organization. */
export type OrganizationHighScaleQualification = {
  __typename?: 'OrganizationHighScaleQualification';
  /** The organization's classified business archetype. */
  archetype: Scalars['String']['output'];
  /** When the latest qualification verdict was recorded. */
  evaluatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Whether the organization qualified for the high-scale motion. */
  isQualified: Scalars['Boolean']['output'];
};

export type OrganizationIdInput = {
  organizationId: Scalars['String']['input'];
};

/** Resource limits for an organization including channels, members, and content limits */
export type OrganizationLimits = {
  __typename?: 'OrganizationLimits';
  /** The maximum number of channels allowed for the organization. */
  channels: Scalars['Int']['output'];
  /** The maximum number of content generations allowed for the organization. */
  generateContent: Scalars['Int']['output'];
  /** The maximum number of idea groups allowed for the organization. */
  ideaGroups: Scalars['Int']['output'];
  /** The maximum number of ideas allowed for the organization. */
  ideas: Scalars['Int']['output'];
  /** The maximum number of members allowed for the organization. */
  members: Scalars['Int']['output'];
  /** The maximum number of post templates allowed for the organization. */
  postTemplates: Scalars['Int']['output'];
  /** The maximum number of saved replies allowed for the organization. */
  savedReplies: Scalars['Int']['output'];
  /** The maximum number of scheduled posts allowed for the organization. */
  scheduledPosts: Scalars['Int']['output'];
  /** The maximum number of scheduled stories allowed per channel. */
  scheduledStoriesPerChannel: Scalars['Int']['output'];
  /** The maximum number of scheduled threads allowed per channel. */
  scheduledThreadsPerChannel: Scalars['Int']['output'];
  /** The maximum number of tags allowed for the organization. */
  tags: Scalars['Int']['output'];
};

/**
 * Aggregate posting goal progress for an organization, used by the Buffer
 * Home posting goals module. Powers a roll-up like
 * "2 of 3 posting goals achieved" plus an optional per-channel breakdown;
 * consumers derive the achieved count from `postingGoal.status == Hit`.
 *
 * Only channels that have a posting goal configured are included; channels
 * without a goal are filtered out at the resolver so consumers don't have
 * to.
 */
export type OrganizationPostingGoalsSummary = {
  __typename?: 'OrganizationPostingGoalsSummary';
  /**
   * Per-channel posting goal status. Omits channels without a configured
   * goal. Order is not guaranteed; consumers should sort as needed.
   */
  channelGoals: Array<ChannelPostingGoalSummary>;
};

/** Input for organizationPostingGoalsSummary. */
export type OrganizationPostingGoalsSummaryInput = {
  /** The organization for which to retrieve posting goal progress. */
  organizationId: Scalars['OrganizationId']['input'];
};

export type OrganizationReferralCodeResponse = {
  __typename?: 'OrganizationReferralCodeResponse';
  referralCode: Scalars['String']['output'];
};

/** Organization-level settings that apply to all members. */
export type OrganizationSettings = {
  __typename?: 'OrganizationSettings';
  /** Whether all members of the organization must have 2FA configured. */
  enforce2FA: Scalars['Boolean']['output'];
};

export type OrganizationsInput = {
  ids: Array<Scalars['OrganizationId']['input']>;
};

/**
 * Ownership filter for conversation items. Controls whether the result includes
 * own engagements (authored by the Buffer account), third-party engagements, or both.
 */
export enum OwnershipScope {
  /**
   * Return all engagements regardless of authorship. Each field argument using
   * this enum declares its own default (`all` on engagementConversationById
   * descendants, `own` on engagementConversations descendants).
   */
  All = 'all',
  /**
   * Return only replies the Buffer account sent directly to the engagement
   * (items authored by the account with the engagement as their parent).
   */
  Own = 'own',
  /** Return only engagements authored by third parties (not the Buffer account). */
  ThirdParty = 'thirdParty'
}

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor: Scalars['String']['output'];
  hasNextPage: Scalars['Boolean']['output'];
  startCursor: Scalars['String']['output'];
};

/** Pagination connection for Ideas */
export type PaginatedIdeasV2 = {
  __typename?: 'PaginatedIdeasV2';
  /** List of idea edges containing the ideas and their cursors */
  edges: Array<IdeaEdge>;
  /** Pagination metadata including hasNextPage and endCursor */
  pageInfo: PaginationPageInfo;
};

export type PaginatedPosts = {
  __typename?: 'PaginatedPosts';
  edges?: Maybe<Array<PublishingPostEdge>>;
  pageInfo: PostPageInfo;
};

/** Information to aid in pagination. */
export type PaginationPageInfo = {
  __typename?: 'PaginationPageInfo';
  /** The last cursor in the list. It can be used to fetch the next page. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When set to true, it means there is a next page available. */
  hasNextPage: Scalars['Boolean']['output'];
  /** When set to true, it means there is a previous page available. Will always return false for now as we only support forward pagination. */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** The first cursor in the list. It can be used to fetch the previous page. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** Payment action requirements for completing subscription updates that require Strong Customer Authentication */
export type PaymentActionRequired = {
  __typename?: 'PaymentActionRequired';
  /**
   * Stripe PaymentIntent client secret for completing 3D Secure authentication.
   * Use with stripe.confirmPayment() - see: https://docs.stripe.com/js/payment_intents/confirm_payment
   */
  clientSecret: Scalars['String']['output'];
  /** Stripe PaymentMethod ID for the associated PaymentIntent. Required with confirmPayment for authorization retry attempts. */
  paymentMethodId?: Maybe<Scalars['String']['output']>;
};

/** The payment details for the customer's current subscription on their current billing gateway */
export type PaymentDetails = {
  __typename?: 'PaymentDetails';
  /** The credit card information for the customer, if applicable */
  creditCard?: Maybe<CreditCard>;
  /** Whether the customer has payment details stored in the billing gateway */
  hasPaymentDetails?: Maybe<Scalars['Boolean']['output']>;
  /** The payment method used by the customer to pay for their current subscription */
  paymentMethod?: Maybe<Scalars['String']['output']>;
};

/**
 * The customer's payment method on file. Each payment method type
 * carries its own relevant display fields.
 */
export type PaymentMethodDetails = AlipayPaymentMethodDetails | AmazonPayPaymentMethodDetails | BankPaymentMethodDetails | CardPaymentMethodDetails | CashAppPaymentMethodDetails | LinkPaymentMethodDetails;

/** Input for pendingInvitations query. */
export type PendingInvitationsInput = {
  /** The organization whose pending invitations should be returned. */
  organizationId: Scalars['OrganizationId']['input'];
};

/** Represents a percentage-based discount. */
export type PercentDiscount = BaseDiscount & {
  __typename?: 'PercentDiscount';
  /** How long the discount should remain active */
  duration: DiscountDuration;
  /**
   * For repeating discounts, specifies the number of months the discount repeats for.
   * Only applicable when duration is 'repeating'.
   */
  durationInMonths?: Maybe<Scalars['Int']['output']>;
  /** External identifier from the payment gateway (e.g., Stripe discount ID) */
  gatewayId?: Maybe<Scalars['String']['output']>;
  /** Human-readable name for the discount */
  name: Scalars['String']['output'];
  /** The scope of the discount - whether it applies to the entire customer or just a specific subscription */
  scope: DiscountScope;
  /** The percentage of the discount (e.g., 25.0 for 25%) */
  value: Scalars['Float']['output'];
};

/** A personal access token used to authenticate against the API. */
export type PersonalAccessToken = {
  __typename?: 'PersonalAccessToken';
  /** Generated access token */
  accessToken: Scalars['String']['output'];
  /** The OIDC client ID associated with this token */
  clientId: Scalars['String']['output'];
  /** Token expiry time */
  expiresAt: Scalars['DateTime']['output'];
  /** Time the token was generated */
  generatedAt: Scalars['DateTime']['output'];
  /** Custom name for the token */
  name?: Maybe<Scalars['String']['output']>;
  /** OIDC scope strings (e.g. 'posts:read') granted to this token */
  scopes: Array<Scalars['String']['output']>;
};

/** Input for personalAccessTokenScopes query */
export type PersonalAccessTokenScopesInput = {
  /** Placeholder for future filtering options */
  _placeholder?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Response for personalAccessTokens query */
export type PersonalAccessTokensResponse = {
  __typename?: 'PersonalAccessTokensResponse';
  /** The access tokens */
  accessTokens: Array<PersonalAccessToken>;
  /** Whether upgrading the plan would increase the token limit */
  canUpgradeForMore: Scalars['Boolean']['output'];
  /** The maximum number of personal access tokens allowed for this account's plan */
  maxTokens: Scalars['Int']['output'];
};

/** A Pinterest board */
export type PinterestBoard = {
  __typename?: 'PinterestBoard';
  /** The board avatar */
  avatar?: Maybe<Scalars['String']['output']>;
  /** The board description */
  description?: Maybe<Scalars['String']['output']>;
  /** The ID of the board */
  id: Scalars['String']['output'];
  /** The board name */
  name: Scalars['String']['output'];
  /** The ID of the service */
  serviceId: Scalars['String']['output'];
  /** The board URL */
  url: Scalars['String']['output'];
};

export type PinterestData = {
  __typename?: 'PinterestData';
  is_repin?: Maybe<Scalars['Boolean']['output']>;
};

/** Pinterest metadata */
export type PinterestMetadata = {
  __typename?: 'PinterestMetadata';
  /** The list of boards the user has on Pinterest */
  boards: Array<PinterestBoard>;
};

/** Pinterest post metadata */
export type PinterestPostMetadata = CommonPostMetadata & {
  __typename?: 'PinterestPostMetadata';
  /** Annotations representing entities in the text */
  annotations: Array<Annotation>;
  /** The board the Pin is saved to */
  board?: Maybe<PinterestBoard>;
  /** The title of the Pin */
  title?: Maybe<Scalars['String']['output']>;
  /** The channel-specific type of the post, eg, post, story, reel for Instagram */
  type: PostType;
  /** The Pin destination link */
  url?: Maybe<Scalars['String']['output']>;
};

/** Pinterest post metadata */
export type PinterestPostMetadataInput = {
  /**
   * The board ID of the Pin, can be obtained when fetching the channel details with the following query:
   * ```
   * query GetChannelWithSubprofiles {
   *   channel(input: { id: "[CHANNEL_ID_HERE]" }) {
   *     metadata {
   *       ... on PinterestMetadata {
   *         boards {
   *           serviceId
   *         }
   *       }
   *     }
   *   }
   * }
   * ```
   * Required on create; optional on edit (omitted preserves existing board).
   */
  boardServiceId?: InputMaybe<Scalars['String']['input']>;
  /** The title of the Pin */
  title?: InputMaybe<Scalars['String']['input']>;
  /** The Pin destination link */
  url?: InputMaybe<Scalars['String']['input']>;
};

export type PlaceholderIdeasCreatedPayload = CoreWebAppCommonError | PlaceholderIdeasMutationSuccess;

/** Query / Mutation responses */
export type PlaceholderIdeasMutationSuccess = CoreWebAppMutationResponse & {
  __typename?: 'PlaceholderIdeasMutationSuccess';
  code: Scalars['String']['output'];
  /** The created ideas */
  ideas: Array<Idea>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

/** Represents a Buffer plan with its associated pricing, limits, and billing information */
export type Plan = {
  __typename?: 'Plan';
  /**
   * External identifier from the payment gateway (e.g., Stripe plan/price ID).
   * This field is restricted to internal services and Buffer admins.
   */
  gatewayId?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the plan (e.g., free, essentials, team) */
  id: ObPlanId;
  /** The billing cycle interval for this plan (month or year) */
  interval: BillingInterval;
  /** Feature limits and quotas associated with this plan */
  limits: PlanLimits;
  /** Human-readable display name of the plan (e.g., Free, Essentials, Team) */
  name: Scalars['String']['output'];
  /**
   * Tiered pricing structure for this plan. Non-tiered plans will have a single tier.
   * For tiered pricing, the array is ordered from lowest to highest tier.
   */
  pricing: Array<PlanPricingTier>;
  /** Metadata describing how this plan's pricing is structured */
  pricingMetadata: PricingMetadata;
};

/** Represents a discount that can be applied to a plan. */
export type PlanDiscount = AmountDiscount | PercentDiscount;

export type PlanLimits = {
  __typename?: 'PlanLimits';
  channels: Scalars['Int']['output'];
  members: Scalars['Int']['output'];
  scheduledPosts: Scalars['Int']['output'];
};

export type PlanMigrationPreview = {
  __typename?: 'PlanMigrationPreview';
  chargeAmount: Scalars['Float']['output'];
  creditAmount: Scalars['Float']['output'];
  intervalAmount?: Maybe<Scalars['Float']['output']>;
};

export type PlanMigrationPreviewDetails = {
  __typename?: 'PlanMigrationPreviewDetails';
  currentPlan: MigrationPlan;
  migrationSummary?: Maybe<MigrationSummary>;
  planFeatures: Array<Maybe<MigrationMarketingFeaturesCopy>>;
  suggestedPlan: MigrationPlan;
};

export type PlanMigrationPreviewResponse = {
  __typename?: 'PlanMigrationPreviewResponse';
  preview?: Maybe<PlanMigrationPreviewDetails>;
  showPreview: Scalars['Boolean']['output'];
};

/** Represents a single plan option available for selection */
export type PlanOption = {
  __typename?: 'PlanOption';
  /** The unique identifier for the plan (free, essentials, team) */
  planId: ObPlanId;
  /** The billing cycle for this plan option (month or year) */
  planInterval: BillingInterval;
  /** The display name of the plan */
  planName: Scalars['String']['output'];
  /**
   * Pricing information for calculating total cost based on channel quantity.
   * Non-tiered plans will contain a single pricing tier in the array.
   * For tiered prices, the array will be ordered starting with the lowest tier.
   */
  pricing: Array<PlanPricingTier>;
  /** Metadata describing how this plan's pricing is structured */
  pricingMetadata: PricingMetadata;
};

export type PlanPrices = {
  __typename?: 'PlanPrices';
  /**
   * Describes the monthly amount of a Plan, in dollars, without the quantity multipliers and any customer or subscription discounts.
   * This value differs from the "upcomingInvoiceAmount" that describes the exact amount that the customer is paying.
   */
  baseMonthlyPrice?: Maybe<Scalars['Float']['output']>;
  /**
   * Describes Plan amount, in dollars, without the quantity multipliers and any customer or subscription discounts.
   * This value differs from the "upcomingInvoiceAmount" that describes the exact amount that the customer is paying.
   */
  basePlanPrice?: Maybe<Scalars['Float']['output']>;
  /**
   * The amount of channels up to that are covered by the flat Fee.
   * Used for tiered pricing plans only.
   */
  channelTierUnit?: Maybe<Scalars['Int']['output']>;
  /**
   * The monthly channel price a customer pays for every channel above the channelTierUnit.
   * Used for tiered pricing plans only.
   */
  monthlyChannelPrice?: Maybe<Scalars['Float']['output']>;
  /**
   * The monthly amount (calculated as monthly for yearly subscriptions as well) a customer pays, irrelevant to the amount of channels connected.
   * Used for tiered pricing plans only.
   */
  monthlyFlatFee?: Maybe<Scalars['Float']['output']>;
};

/**
 * Represents the pricing for a plan option, using tiered pricing.
 * For non-tiered plans, there will be a single pricing tier.
 */
export type PlanPricingTier = {
  __typename?: 'PlanPricingTier';
  /** The currency for the unitPrice as an uppercase, three-letter ISO 4217 currency code (e.g., "USD", "EUR"). */
  currency: Scalars['String']['output'];
  /** Fixed flat fee in cents applied to this tier. Returns 0 for plans without a flat fee component. */
  flatFee: Scalars['Int']['output'];
  /** The price that a customer will pay for each unit (e.g. channel) within this tier, in cents (or smallest currency unit). */
  unitPrice: Scalars['Int']['output'];
  /** The upper bound for this tier. This is the maximum number of units (e.g. channels) that the customer will pay for in this tier. */
  upperBound: Scalars['Int']['output'];
};

/** Data needed for the Plan Selector */
export type PlanSelectorData = {
  __typename?: 'PlanSelectorData';
  /** List of all available plans the customer can switch to, with pricing for each */
  availablePlans: Array<PlanOption>;
  /**
   * The customer's account balance with currency. A negative amount is credit
   * that the payment gateway applies automatically to the next invoice.
   */
  balance: AccountBalance;
  /**
   * Ordered array of all discounts applicable to this organization's plan.
   * In Stripe, this can be a customer or subscription-level discount, as indicated
   * in each item's discount scope. If multiple discounts exist, they must be applied
   * in order from first to last (e.g. apply the 50% off first, then the $10 off)
   */
  discounts: Array<PlanDiscount>;
  /** The billing gateway being used for this organization's subscription. */
  gateway: BillingGateway;
  /**
   * Indicates if the customer has a default payment method configured in Stripe.
   * If true, we do not need to route the customer through Stripe Checkout.
   * This is used to determine if the customer has a default payment method configured in Stripe.
   */
  hasDefaultStripePaymentMethod: Scalars['Boolean']['output'];
  /** Indicates if the customer has ever paid for a subscription */
  hasEverBeenPayingCustomer: Scalars['Boolean']['output'];
  /** Information about the next invoice for the subscription */
  nextInvoice: NextInvoice;
  /** The unique identifier of the organization this data belongs to */
  organizationId: Scalars['OrganizationId']['output'];
  /** Whether this customer must contact Support to change their subscription. */
  requiresAssistedBilling: Scalars['Boolean']['output'];
  /** Current subscription details including plan, billing cycle, and trial status */
  subscription: BufferSubscription;
};

/** Input parameters for fetching plan selector data */
export type PlanSelectorDataInput = {
  /** The unique identifier of the organization to fetch billing data for */
  organizationId: Scalars['OrganizationId']['input'];
};

/** Represents an active trial for a subscription */
export type PlanTrial = {
  __typename?: 'PlanTrial';
  /** The end date of the trial */
  endDate: Scalars['DateTime']['output'];
  /** The start date of the trial */
  startDate: Scalars['DateTime']['output'];
};

/** Configuration for pulling sync. */
export type PollingSyncConfiguration = {
  __typename?: 'PollingSyncConfiguration';
  /** Rate limit configuration for forcing sync, containing period and allowed attempts. */
  forcedSyncRateLimit?: Maybe<ForcedSyncRateLimit>;
  /** Polling frequency in hours, for example, every 12 hours. */
  pollInterval: Scalars['Int']['output'];
};

/** Post entity */
export type Post = {
  __typename?: 'Post';
  /** Indicates what actions the current account can perform on the post */
  allowedActions: Array<PostAction>;
  /** assets */
  assets: Array<Asset>;
  /** Represents the user who created the post */
  author?: Maybe<Author>;
  /** channel */
  channel: Channel;
  /** channel ID (faster than resolving the channnel.id) */
  channelId: Scalars['ChannelId']['output'];
  /** channel service (faster than resolving the channnel.service) */
  channelService: Service;
  /** The Notes on this Post: their total, and the current account's unread Notes. */
  collaborationNotesSummary?: Maybe<CollaborationNotesSummary>;
  /**
   * The content item this post belongs to. Null when the post belongs to no
   * content item.
   */
  contentItemId?: Maybe<Scalars['ContentItemId']['output']>;
  /** Date when the post was created */
  createdAt: Scalars['DateTime']['output'];
  /** Date when the post is scheduled to be published */
  dueAt?: Maybe<Scalars['DateTime']['output']>;
  /** error */
  error?: Maybe<PostPublishingError>;
  /** The external URL of the post at the destination service */
  externalLink?: Maybe<Scalars['String']['output']>;
  /** The ID of the post */
  id: Scalars['PostId']['output'];
  /** Is set when the Post is generated from an Idea */
  ideaId?: Maybe<Scalars['IdeaId']['output']>;
  /** Indicates whether time to publish was manually selected by the user */
  isCustomScheduled: Scalars['Boolean']['output'];
  /** flags */
  isPinned: Scalars['Boolean']['output'];
  /**
   * Metadata of the post which differs based on the social network/service
   * @see post.metadata.graphql
   */
  metadata?: Maybe<PostMetadata>;
  /** Metrics for the sent post. If post is not yet sent, this field will be null */
  metrics?: Maybe<Array<PostMetric>>;
  /**
   * Timestamp of when `metrics` were last refreshed from the network. Null
   * until the daily ingestion job has processed the post. Buffer pulls
   * fresh metrics once per day, so this can lag the network value by ~24h.
   */
  metricsUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** notes */
  notes: Array<Note>;
  /** notificationStatus: notified or markedAsPublished */
  notificationStatus?: Maybe<NotificationStatus>;
  /** The group this post belongs to, if any. Resolved via DataLoader. */
  postGroup?: Maybe<PostGroup>;
  /** Recurrence metadata, present only if the post is part of a recurrence series */
  recurrence?: Maybe<PostRecurrence>;
  /** ID linking sibling posts in a recurrence series */
  recurringPostsId?: Maybe<Scalars['PostId']['output']>;
  /**
   * How the post publishes: `notification` for a reminder that asks someone to
   * publish it by hand, `automatic` for one the publishing workers send.
   */
  schedulingType?: Maybe<SchedulingType>;
  /** Date when the post is published */
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  /** Indicates the share mode of the post (e.g., addToQueue, shareNext, shareNow, customScheduled) */
  shareMode: ShareMode;
  /** Indicates whether the post was shared via publish now action */
  sharedNow: Scalars['Boolean']['output'];
  /** status */
  status: PostStatus;
  /** tags - sorted by name in ascending order */
  tags: Array<Tag>;
  /** Text content of the Post */
  text: Scalars['String']['output'];
  /** Date when the post was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** Indicates if the post is created from Buffer or the API */
  via: PostVia;
};

/** List of possible actions that can be performed on a Post */
export enum PostAction {
  AddPostNote = 'addPostNote',
  AddPostToQueue = 'addPostToQueue',
  ApprovePost = 'approvePost',
  CancelPostRecurrence = 'cancelPostRecurrence',
  CopyPostLink = 'copyPostLink',
  CreatePostRecurrence = 'createPostRecurrence',
  DeletePost = 'deletePost',
  DuplicatePost = 'duplicatePost',
  EditPostRecurrence = 'editPostRecurrence',
  MovePostToDraft = 'movePostToDraft',
  PublishPostNext = 'publishPostNext',
  PublishPostNow = 'publishPostNow',
  RejectPost = 'rejectPost',
  RemovePostScheduledTime = 'removePostScheduledTime',
  RequestPostApproval = 'requestPostApproval',
  RevertPostApprovalRequest = 'revertPostApprovalRequest',
  SharePostLink = 'sharePostLink',
  UpdatePost = 'updatePost',
  UpdatePostSchedule = 'updatePostSchedule',
  UpdatePostTags = 'updatePostTags',
  UpdateShopGridLink = 'updateShopGridLink',
  ViewPost = 'viewPost'
}

/** Create post's request response payload. */
export type PostActionPayload = InvalidInputError | LimitReachedError | NotFoundError | PostActionSuccess | RestProxyError | UnauthorizedError | UnexpectedError;

/** Success response returns the full up-to-date post from after the action was performed. */
export type PostActionSuccess = {
  __typename?: 'PostActionSuccess';
  /** Post on which the action was successfully performed. */
  post: Post;
};

/** A change to a post's approval state, for a post that is already a draft. */
export enum PostApprovalChange {
  /** Submit the draft for approval. */
  Request = 'request',
  /** Withdraw a pending approval request, returning the post to a plain draft. */
  Revert = 'revert'
}

/** The status of a post template campaign. */
export enum PostCampaignStatus {
  /** Campaign is active and visible. */
  Active = 'active',
  /** Campaign is in draft and not yet visible. */
  Draft = 'draft',
  /** Campaign has ended. */
  Ended = 'ended'
}

/** The type of a post template campaign. */
export enum PostCampaignType {
  /** A curated collection of templates. */
  Collection = 'collection',
  /** A creator camp campaign. */
  CreatorCamp = 'creatorCamp',
  /** A scheduled drip campaign of templates. */
  DripCampaign = 'dripCampaign'
}

/**
 * The channel targeted by a single post in the promoteContentItemDraftToPosts
 * input list was not found or is not accessible.
 */
export type PostChannelNotFoundError = MutationError & {
  __typename?: 'PostChannelNotFoundError';
  /** Channel targeted by the failing post. */
  channelId: Scalars['ChannelId']['output'];
  /** Error message. */
  message: Scalars['String']['output'];
};

/**
 * The fixed set of channel-specific posts created from a content item. Each
 * post targets a single channel and follows that channel's network rules.
 */
export type PostContent = {
  __typename?: 'PostContent';
  /**
   * The posts created for this content item, one per channel. Individual posts
   * are edited through their own mutations.
   */
  posts: Array<Post>;
};

/** Filters for the posts count query */
export type PostCountsFiltersInput = {
  /** When set, it will filter posts by channel */
  channelIds?: InputMaybe<Array<Scalars['ChannelId']['input']>>;
  /**
   * When set, it will filter posts by format.
   * @see PostsFiltersInput.postTypes for the semantics.
   */
  postTypes?: InputMaybe<Array<PostType>>;
  /** When set, it will filter posts by status */
  status?: InputMaybe<Array<PostStatus>>;
  /**
   * When set, it will filter posts by tag
   * @deprecated Use 'tags' field with TagComparator instead
   */
  tagIds?: InputMaybe<Array<Scalars['TagId']['input']>>;
  /** Filter posts by tags. Supports specific tags, untagged posts, or union of both. */
  tags?: InputMaybe<TagComparator>;
};

/** Input for the posts count query */
export type PostCountsInput = {
  /** The filters to apply to the posts query */
  filter?: InputMaybe<PostCountsFiltersInput>;
  /** The Organization id to fetch posts for */
  organizationId: Scalars['OrganizationId']['input'];
};

/** Response for the post counts query */
export type PostCountsResponse = {
  __typename?: 'PostCountsResponse';
  /** The list of counts for the given organization */
  counts: Array<PostsCount>;
};

export type PostFiltersInput = {
  /** The channel(s) ids to fetch posts for */
  channelIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The oldest date of posts to return, a unix timestamp (in seconds) */
  endDate?: InputMaybe<Scalars['Int']['input']>;
  /** The start date of posts to return, a unix timestamp (in seconds) */
  startDate?: InputMaybe<Scalars['Int']['input']>;
  /** The status of posts to return */
  status?: InputMaybe<Array<PublishingPostStatus>>;
  /** The tag(s) ids of posts to return */
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * A post group bundles posts created in the same composer session.
 * Phase 1: created empty via createPostGroup, posts attached later via the
 * legacy buffer-web RPC carrying postGroupId.
 */
export type PostGroup = {
  __typename?: 'PostGroup';
  /**
   * Client-generated UUID supplied at creation time. Lets clients verify
   * they got back the group they intended on idempotent retry.
   */
  correlationId: Scalars['Uuid']['output'];
  /** The date and time the post group was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier. */
  id: Scalars['PostGroupId']['output'];
  /** Organization that owns the group. */
  organizationId: Scalars['OrganizationId']['output'];
  /**
   * Posts associated with this group, resolved via the postGroup.id
   * foreign key on each post.
   */
  posts: Array<Post>;
  /** Group title. User editing is deferred. */
  title: Scalars['String']['output'];
  /** The date and time the post group was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Input for fetching a post group by id. */
export type PostGroupInput = {
  /** Unique identifier for the post group. */
  id: Scalars['PostGroupId']['input'];
};

export type PostIdInput = {
  postId: Scalars['String']['input'];
};

/** Input for the post query */
export type PostInput = {
  /** The ID of the post to be retrieved */
  id: Scalars['PostId']['input'];
};

/** Metadata of the post which differs based on the social network/service */
export type PostInputMetaData = {
  /** Metadata for Bluesky post */
  bluesky?: InputMaybe<BlueskyPostMetadataInput>;
  /** Metadata for Facebook post */
  facebook?: InputMaybe<FacebookPostMetadataInput>;
  /** Metadata for Google Business Profile post */
  google?: InputMaybe<GoogleBusinessPostMetadataInput>;
  /** Metadata for Instagram post */
  instagram?: InputMaybe<InstagramPostMetadataInput>;
  /** Metadata for LinkedIn post */
  linkedin?: InputMaybe<LinkedInPostMetadataInput>;
  /** Metadata for Mastodon post */
  mastodon?: InputMaybe<MastodonPostMetadataInput>;
  /** Metadata for Pinterest post */
  pinterest?: InputMaybe<PinterestPostMetadataInput>;
  /** Metadata for Start Page post */
  startPage?: InputMaybe<StartPagePostMetadataInput>;
  /** Metadata for Substack post */
  substack?: InputMaybe<SubstackPostMetadataInput>;
  /** Metadata for Threads post */
  threads?: InputMaybe<ThreadsPostMetadataInput>;
  /** Metadata for TikTok post */
  tiktok?: InputMaybe<TikTokPostMetadataInput>;
  /** Metadata for Twitter post */
  twitter?: InputMaybe<TwitterPostMetadataInput>;
  /** Metadata for Youtube post */
  youtube?: InputMaybe<YoutubePostMetadataInput>;
};

/** Insights summary metric */
export type PostInsightsSummaryMetric = {
  __typename?: 'PostInsightsSummaryMetric';
  /** The metric description */
  description: Scalars['String']['output'];
  /** The difference between the metric value and the previous period */
  difference?: Maybe<Scalars['Float']['output']>;
  /** The displayable metric name */
  displayName: Scalars['String']['output'];
  /** The metric type */
  type: PostMetricType;
  /** The metric unit */
  unit: PostMetricUnit;
  /** The metric value */
  value: Scalars['Float']['output'];
};

/**
 * Invalid input for a single post in the promoteContentItemDraftToPosts input
 * list.
 */
export type PostInvalidInputError = MutationError & {
  __typename?: 'PostInvalidInputError';
  /** Channel targeted by the failing post. */
  channelId: Scalars['ChannelId']['output'];
  /** Error message. */
  message: Scalars['String']['output'];
};

/**
 * Limit reached for a single post in the promoteContentItemDraftToPosts input
 * list.
 */
export type PostLimitReachedError = MutationError & {
  __typename?: 'PostLimitReachedError';
  /** Channel targeted by the failing post. */
  channelId: Scalars['ChannelId']['output'];
  /** Error message. */
  message: Scalars['String']['output'];
};

/** Post metadata union type. Contains all possible types of post metadata. */
export type PostMetadata = BlueskyPostMetadata | FacebookPostMetadata | GoogleBusinessPostMetadata | InstagramPostMetadata | LinkedInPostMetadata | MastodonPostMetadata | PinterestPostMetadata | StartPagePostMetadata | SubstackPostMetadata | ThreadsPostMetadata | TiktokPostMetadata | TwitterPostMetadata | YoutubePostMetadata;

/** A single metric for a post (or an entry in an aggregated metrics response). */
export type PostMetric = {
  __typename?: 'PostMetric';
  /** A human-readable description of what the metric represents. */
  description: Scalars['String']['output'];
  /**
   * Deprecated: use `name` instead.
   * @deprecated Use name instead
   */
  displayName: Scalars['String']['output'];
  /** The human-readable name of the metric (e.g. "Reactions", "Eng. Rate"). */
  name: Scalars['String']['output'];
  /** The raw metric value, or null when the network did not report it. Internal — public consumers should use `value`. */
  nullableValue?: Maybe<Scalars['Float']['output']>;
  /**
   * The type of metric. Cross-network metrics use unified naming (`reactions`,
   * `comments`, etc.); network-specific metrics retain their network's
   * vocabulary (`saves`, `quotes`, etc.). See `PostMetricType` for the full
   * catalog including deprecated values.
   */
  type: PostMetricType;
  /** The unit (count vs percentage) of `value`. */
  unit: PostMetricUnit;
  /** The metric value. Defaults to 0 when the network did not report the metric. */
  value: Scalars['Float']['output'];
};

export type PostMetricLegacy = {
  __typename?: 'PostMetricLegacy';
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
  unit?: Maybe<Scalars['String']['output']>;
  value: Scalars['Float']['output'];
};

export type PostMetricObject = {
  __typename?: 'PostMetricObject';
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
  values?: Maybe<Array<PostMetricLegacy>>;
};

/**
 * List of possible metrics available for a Post.
 *
 * Values fall into three groups:
 * - **Cross-network normalized** (reactions, comments, shares, reposts, reach, impressions, views, clicks, engagementRate): Used wherever a concept maps cleanly across networks. Per-network adapters normalize their native names (e.g., Instagram `likes` → `reactions`, Twitter `retweets` → `reposts`).
 * - **Network-specific** (saves, follows, quotes, viewers, totalTimeWatched, averageTimeWatched, likes, freeSubscriptions, paidSubscriptions): Real metrics that don't have a cross-network equivalent. `likes` is intentionally distinct from `reactions` on Facebook — Facebook's Graph API surfaces them separately. `freeSubscriptions` and `paidSubscriptions` are Substack's per-Note subscription attribution; no other network reports it.
 * - **Aggregation-only** (postCount): Meaningful only on aggregate endpoints; never emitted per-post.
 *
 * Deprecated values are pre-normalization legacy or tied to features being removed. They're kept in the enum for backwards compatibility until clients migrate.
 */
export enum PostMetricType {
  /** Average time watched, in seconds, for video-style posts (TikTok, Instagram Reels). */
  AverageTimeWatched = 'averageTimeWatched',
  /** How many times people clicked on your post. */
  Clicks = 'clicks',
  /** The count of comments and replies on your post. Unified across networks (Threads `replies` maps here). */
  Comments = 'comments',
  /** The percentage of people who interacted with your post compared to how many saw it. Unit: percentage. */
  EngagementRate = 'engagementRate',
  /**
   * Deprecated: not emitted by any per-network definition. Use `reactions` instead — Twitter and Mastodon favorites normalize into `reactions`. Will be removed on 2026-12-01.
   * @deprecated Not emitted by any per-network definition; use `reactions` instead. Will be removed on 2026-12-01.
   */
  Favorites = 'favorites',
  /** The number of new followers gained from this post (Instagram). */
  Follows = 'follows',
  /** The number of free subscriptions Substack attributes to this Note. */
  FreeSubscriptions = 'freeSubscriptions',
  /** How many times your post was shown on screen. May include multiple views by the same person — useful for spotting how often the content gets surfaced. */
  Impressions = 'impressions',
  /** The Like-reaction subcount on Facebook. Distinct from `reactions` (which is the total of all reaction types — Like, Love, Care, Haha, Wow, Sad, Angry); Facebook's Graph API reports them separately and we mirror that. */
  Likes = 'likes',
  /**
   * Deprecated: StartPage link-clicks metric. StartPage is being deprecated as a product. Will be removed on 2026-12-01.
   * @deprecated StartPage is being deprecated as a product. Will be removed on 2026-12-01.
   */
  LinkClicks = 'link_clicks',
  /**
   * Deprecated catch-all from pre-normalization. Never emitted. Will be removed on 2026-12-01.
   * @deprecated Catch-all from pre-normalization; never emitted. Will be removed on 2026-12-01.
   */
  Other = 'other',
  /** The number of paid subscriptions Substack attributes to this Note. */
  PaidSubscriptions = 'paidSubscriptions',
  /** The count of posts included in an aggregated response. Only meaningful on aggregate endpoints — never emitted per-post. */
  PostCount = 'postCount',
  /** How many times your post was quoted (Threads). */
  Quotes = 'quotes',
  /** The number of unique people who saw your post. */
  Reach = 'reach',
  /** How many people reacted to your post. Unified across networks: Instagram/Twitter `likes`, Mastodon `favorites`, etc. all map to this value. */
  Reactions = 'reactions',
  /**
   * Deprecated: not emitted by any per-network definition. Use `reposts` instead — Mastodon reblogs normalize into `reposts`. Will be removed on 2026-12-01.
   * @deprecated Not emitted by any per-network definition; use `reposts` instead. Will be removed on 2026-12-01.
   */
  Reblogs = 'reblogs',
  /**
   * Deprecated: not emitted by any per-network definition. Pre-normalization legacy from the Pinterest era. Will be removed on 2026-12-01.
   * @deprecated Not emitted by any per-network definition. Will be removed on 2026-12-01.
   */
  Repins = 'repins',
  /**
   * Deprecated: not emitted by any per-network definition. Use `comments` instead — replies are normalized into `comments` on the networks that distinguish them (Threads). Will be removed on 2026-12-01.
   * @deprecated Not emitted by any per-network definition; use `comments` instead. Will be removed on 2026-12-01.
   */
  Replies = 'replies',
  /** How many times your post was reposted by others. Twitter `retweets`, Mastodon `reblogs`, Threads `reposts` all normalize to this value. */
  Reposts = 'reposts',
  /**
   * Deprecated: not emitted by any per-network definition. Use `reposts` instead — Twitter retweets normalize into `reposts`. Will be removed on 2026-12-01.
   * @deprecated Not emitted by any per-network definition; use `reposts` instead. Will be removed on 2026-12-01.
   */
  Retweets = 'retweets',
  /** How many times people saved your post (Instagram, Pinterest). A strong signal that the content is worth revisiting. */
  Saves = 'saves',
  /** How many times your post was shared or forwarded by others. */
  Shares = 'shares',
  /** Total time watched, in minutes, for video-style posts (LinkedIn, TikTok, Instagram Reels). */
  TotalTimeWatched = 'totalTimeWatched',
  /** Unique viewer count for video-style posts (LinkedIn). */
  Viewers = 'viewers',
  /** How many times your post was viewed. Used for video-style posts and on networks that report views distinctly from impressions. */
  Views = 'views'
}

/** The unit representing the value of a PostMetric. */
export enum PostMetricUnit {
  /** An integer count (e.g. number of reactions, impressions, reach). */
  Count = 'count',
  /** A percentage value between 0 and 100 (e.g. engagement rate). */
  Percentage = 'percentage'
}

/**
 * A post in this content item cannot be deleted, so the item cannot be
 * deleted either. Either the post is publishing or has already published,
 * and posts in those states can no longer be deleted, or this account is
 * not allowed to delete posts on that channel.
 */
export type PostNotDeletableError = MutationError & {
  __typename?: 'PostNotDeletableError';
  /** Channel targeted by the post that cannot be deleted. */
  channelId: Scalars['ChannelId']['output'];
  /** Error message. */
  message: Scalars['String']['output'];
};

export type PostNotFound = CoreWebAppMutationResponse & {
  __typename?: 'PostNotFound';
  /** A code to describe the status eg 200 for success, 404 for not found */
  code: Scalars['String']['output'];
  /** A user friendly message to describe the status to the client */
  message: Scalars['String']['output'];
  /** The ID of the post that could not be found */
  postId: Scalars['String']['output'];
  /** A boolean representing success of the entire mutation */
  success: Scalars['Boolean']['output'];
};

export type PostNotUpdated = CoreWebAppMutationResponse & {
  __typename?: 'PostNotUpdated';
  /** A code to describe the status eg 200 for success, 404 for not found */
  code: Scalars['String']['output'];
  /** A user friendly message to describe the status to the client */
  message: Scalars['String']['output'];
  /** The ID of the post that could not be found */
  postId: Scalars['String']['output'];
  /** A boolean representing success of the entire mutation */
  success: Scalars['Boolean']['output'];
};

export type PostPageInfo = {
  __typename?: 'PostPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** Post publishing error */
export type PostPublishingError = {
  __typename?: 'PostPublishingError';
  /** Error message to display */
  message: Scalars['String']['output'];
  /** The original error from the publishing service (internal use only) */
  rawError?: Maybe<Scalars['String']['output']>;
  /** Link to a help center article to help resolve the error */
  supportUrl?: Maybe<Scalars['String']['output']>;
};

/** Recurrence metadata for a recurring post */
export type PostRecurrence = {
  __typename?: 'PostRecurrence';
  /** The cadence configuration */
  cadence: PostRecurrenceCadence;
  /** Maximum number of recurring posts in this series */
  maxRecurrentPosts: Scalars['Int']['output'];
  /** The parent post ID that started this recurrence series */
  parentPostId?: Maybe<Scalars['PostId']['output']>;
  /** The position of this post in the recurrence series (1-based) */
  postNumber: Scalars['Int']['output'];
  /** Number of remaining re-posts in this recurrence series */
  recurrentPostsLeft: Scalars['Int']['output'];
};

/** Cadence configuration for recurring posts */
export type PostRecurrenceCadence = {
  __typename?: 'PostRecurrenceCadence';
  /** The frequency unit */
  frequency: PostRecurrenceFrequency;
  /** How many frequency units between each recurrence (e.g., 2 = every 2 weeks) */
  frequencyStep: Scalars['Int']['output'];
};

/** Cadence input for creating or editing post recurrence */
export type PostRecurrenceCadenceInput = {
  /** The frequency unit */
  frequency: PostRecurrenceFrequency;
  /** How many frequency units between each recurrence */
  frequencyStep: Scalars['Int']['input'];
};

/** Frequency of post recurrence */
export enum PostRecurrenceFrequency {
  Day = 'day',
  Month = 'month',
  Week = 'week',
  Year = 'year'
}

/** Represents the number of posts for a service during some span of time */
export type PostServiceCount = {
  __typename?: 'PostServiceCount';
  hasAutoApprovedDrafts: Scalars['Boolean']['output'];
  hasDraftsAwaitingApproval: Scalars['Boolean']['output'];
  service: Service;
  value: Scalars['Int']['output'];
};

/** Sort order of post results. List multiple to create tie-breaking order. */
export type PostSortInput = {
  /** The direction to sort by. */
  direction: SortDirection;
  /** The field to sort by. */
  field: PostSortableKey;
};

/** Key of collection to use for sorting */
export enum PostSortableKey {
  /**
   * Sort by the post's createdAt field.
   * Created at is the date when the post was created.
   */
  CreatedAt = 'createdAt',
  /**
   * Sort by the post's dueAt field.
   * Due at is the date when the post is scheduled to be published.
   */
  DueAt = 'dueAt'
}

export type PostStatistics = {
  __typename?: 'PostStatistics';
  clicks?: Maybe<Scalars['Int']['output']>;
  comments?: Maybe<Scalars['Int']['output']>;
  dislikes?: Maybe<Scalars['Int']['output']>;
  favorites?: Maybe<Scalars['Int']['output']>;
  impressions?: Maybe<Scalars['Int']['output']>;
  likes?: Maybe<Scalars['Int']['output']>;
  linkClicks?: Maybe<Scalars['Int']['output']>;
  mentions?: Maybe<Scalars['Int']['output']>;
  quotes?: Maybe<Scalars['Int']['output']>;
  reach?: Maybe<Scalars['Int']['output']>;
  reach_twitter?: Maybe<Scalars['Int']['output']>;
  reactions?: Maybe<Scalars['Int']['output']>;
  repins?: Maybe<Scalars['Int']['output']>;
  replies?: Maybe<Scalars['Int']['output']>;
  reposts?: Maybe<Scalars['Int']['output']>;
  reshares?: Maybe<Scalars['Int']['output']>;
  retweets?: Maybe<Scalars['Int']['output']>;
  saves?: Maybe<Scalars['Int']['output']>;
  shares?: Maybe<Scalars['Int']['output']>;
  views?: Maybe<Scalars['Int']['output']>;
};

export type PostStatisticsV2 = PostMetricLegacy | PostMetricObject;

/** List of possible statuses for a Post */
export enum PostStatus {
  Draft = 'draft',
  Error = 'error',
  NeedsApproval = 'needs_approval',
  Scheduled = 'scheduled',
  Sending = 'sending',
  Sent = 'sent'
}

/** A post template used for content inspiration. */
export type PostTemplate = {
  __typename?: 'PostTemplate';
  /**
   * Actions the calling actor can take on this template. Powers UI
   * affordances (Edit / Delete) without re-deriving the visibility +
   * ownership + role rules on the frontend.
   */
  allowedActions: Array<PostTemplateAction>;
  /** The main content body of the template, may contain {{placeholders}}. */
  body: Scalars['String']['output'];
  /** The date and time the template was created. */
  createdAt: Scalars['DateTime']['output'];
  /** A short user-facing description of the template. */
  description: Scalars['String']['output'];
  /** The emoji associated with the template. */
  emoji: Scalars['String']['output'];
  /** Whether this template is featured. */
  featured: Scalars['Boolean']['output'];
  /** The goal or intent behind the template. */
  goal: PostTemplateGoal;
  /** The unique identifier for the template. */
  id: Scalars['PostTemplateId']['output'];
  /** The organization that owns this template. */
  organizationId: Scalars['OrganizationId']['output'];
  /** The structural format of the template. */
  structure: PostTemplateStructure;
  /** Tags applied to the template. */
  tags: Array<PostTemplateTag>;
  /** The title of the template. */
  title: Scalars['String']['output'];
  /** The type or category of the template. */
  type: PostTemplateType;
  /** The date and time the template was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The target user types for this template. */
  userTypes: Array<PostTemplateUserType>;
  /**
   * The visibility level of the template. `public` is returned for
   * Buffer-managed templates.
   */
  visibility: PostTemplateVisibility;
};

/**
 * Actions the calling actor can take on a `PostTemplate`. Computed
 * server-side from the template's visibility, the actor's relationship to
 * the template (creator? same org? org admin?), and the actor's
 * `PostTemplates` entitlement. Lets clients drive Edit / Delete affordances
 * off the read without re-implementing the rule.
 */
export enum PostTemplateAction {
  /** The actor can delete this template. */
  Delete = 'delete',
  /** The actor can edit this template. */
  Edit = 'edit',
  /** The actor can view this template. */
  View = 'view'
}

/** A campaign that groups post templates together. */
export type PostTemplateCampaign = {
  __typename?: 'PostTemplateCampaign';
  /** A banner color for the campaign. May be null. */
  bannerColor?: Maybe<Scalars['HexColorCode']['output']>;
  /** The type of campaign. */
  campaignType: PostCampaignType;
  /** The date and time the campaign was created. */
  createdAt: Scalars['DateTime']['output'];
  /** A description of the campaign. May be null. */
  description?: Maybe<Scalars['String']['output']>;
  /** The end date of the campaign. Must be after startDate. */
  endDate: Scalars['DateTime']['output'];
  /** The heading displayed on the campaign. */
  heading: Scalars['String']['output'];
  /** The unique identifier for the campaign. */
  id: Scalars['PostTemplateCampaignId']['output'];
  /** An illustration URL for the campaign. May be null. */
  illustration?: Maybe<Scalars['String']['output']>;
  /** The internal name of the campaign. */
  name: Scalars['String']['output'];
  /** Whether templates are shown after the campaign end date. */
  showTemplatesAfterEndDate: Scalars['Boolean']['output'];
  /** The URL-friendly slug for the campaign. */
  slug: Scalars['String']['output'];
  /** The start date of the campaign. */
  startDate: Scalars['DateTime']['output'];
  /** The current status of the campaign. */
  status: PostCampaignStatus;
  /** Whether the campaign supports a banner display. */
  supportsBanner: Scalars['Boolean']['output'];
  /** The post templates associated with this campaign. Resolved from templateIds. */
  templates: Array<PostTemplate>;
  /** The user-facing title of the campaign. May be null. */
  title?: Maybe<Scalars['String']['output']>;
  /** An optional tooltip for the campaign toggle. */
  toggleTip?: Maybe<CampaignToggleTip>;
};

/** A single edge in a paginated campaign list. */
export type PostTemplateCampaignEdge = {
  __typename?: 'PostTemplateCampaignEdge';
  /** Cursor for this edge. */
  cursor: Scalars['String']['output'];
  /** The campaign at this edge. */
  node: PostTemplateCampaign;
};

/** Input for fetching a single post template campaign by ID. */
export type PostTemplateCampaignInput = {
  /** The ID of the campaign to fetch. */
  id: Scalars['PostTemplateCampaignId']['input'];
};

/** A paginated connection of post template campaigns. */
export type PostTemplateCampaignsConnection = {
  __typename?: 'PostTemplateCampaignsConnection';
  /** The edges in the current page. */
  edges: Array<PostTemplateCampaignEdge>;
  /** Pagination info. */
  pageInfo: PaginationPageInfo;
  /** Total number of campaigns matching the filters. */
  totalCount: Scalars['Int']['output'];
};

/** Filters for listing post template campaigns. */
export type PostTemplateCampaignsFilterInput = {
  /** Filter by campaign type. */
  campaignType?: InputMaybe<PostCampaignType>;
  /** Filter by campaign status. */
  status?: InputMaybe<PostCampaignStatus>;
};

/** Input for listing post template campaigns. */
export type PostTemplateCampaignsInput = {
  /** Optional filters to narrow results. */
  filter?: InputMaybe<PostTemplateCampaignsFilterInput>;
};

/**
 * How a custom post-template create was initiated, used by analytics.
 * Not persisted on the template.
 */
export enum PostTemplateCreateSource {
  /** Dialog seeded by copying an existing template's body. */
  Duplicate = 'duplicate',
  /** Empty new-template dialog (the default). */
  Scratch = 'scratch'
}

/** An edge in a post template connection. */
export type PostTemplateEdge = {
  __typename?: 'PostTemplateEdge';
  /** A cursor for pagination. */
  cursor: Scalars['String']['output'];
  /** The post template node at the end of the edge. */
  node: PostTemplate;
};

/** The goal or intent behind a post template. Curated taxonomy. */
export enum PostTemplateGoal {
  /** Celebrates achievements or milestones. */
  Celebration = 'celebration',
  /** Aims to foster connection with followers. */
  Connection = 'connection',
  /** Educates the audience on a topic. */
  Education = 'education',
  /** Designed to drive audience engagement. */
  Engagement = 'engagement',
  /** Showcases expertise or knowledge. */
  Expertise = 'expertise',
  /** Promotes a product, service, or event. */
  Promotion = 'promotion',
  /** Encourages reflection or introspection. */
  Reflection = 'reflection'
}

/** Input for fetching a single post template by ID. */
export type PostTemplateInput = {
  /** The unique identifier of the template to fetch. */
  id: Scalars['PostTemplateId']['input'];
};

/** The structural format of a post template. */
export enum PostTemplateStructure {
  /** A single text post format. */
  SingleText = 'singleText',
  /** A threaded or multi-part post format. */
  Threaded = 'threaded'
}

/** Tags that can be applied to a post template. */
export enum PostTemplateTag {
  /** Featured or highlighted template. */
  Featured = 'featured',
  /** Newly added template. */
  New = 'new'
}

/**
 * The type or category of a post template. Curated taxonomy controlled by
 * the Buffer-managed Template CMS; defaulted server-side for end-user
 * creations.
 */
export enum PostTemplateType {
  /** A behind-the-scenes or process post. */
  BehindTheScenes = 'behindTheScenes',
  /** A case study or example post. */
  CaseStudy = 'caseStudy',
  /** A how-to or instructional post. */
  HowTo = 'howTo',
  /** A list or roundup post. */
  List = 'list',
  /** An opinion or thought leadership post. */
  Opinion = 'opinion',
  /** A question to prompt discussion. */
  Question = 'question',
  /** A story or narrative post. */
  Story = 'story',
  /** A tip or advice post. */
  Tip = 'tip'
}

/** The target user type for a post template. */
export enum PostTemplateUserType {
  /** Templates intended for business users. */
  Business = 'business',
  /** Templates intended for individual users. */
  Individual = 'individual'
}

/**
 * The visibility level of a post template. `public` is reserved for
 * Buffer-curated templates; setting it is only available to official
 * Buffer clients.
 */
export enum PostTemplateVisibility {
  /** All members of the template's organization can access this template. */
  Internal = 'internal',
  /** Only the creator can access this template. */
  Private = 'private',
  /**
   * Anyone across all organizations can access this template. Reserved
   * for Buffer-curated templates — `createPostTemplate` and
   * `updatePostTemplate` reject this value; setting it is only available
   * to official Buffer clients. It appears in read results.
   */
  Public = 'public'
}

/** A paginated connection of post templates. */
export type PostTemplatesConnection = {
  __typename?: 'PostTemplatesConnection';
  /** The list of post template edges. */
  edges: Array<PostTemplateEdge>;
  /** Pagination information for the connection. */
  pageInfo: PaginationPageInfo;
  /** The total number of templates matching the filters. */
  totalCount: Scalars['Int']['output'];
};

/**
 * Filters for the template library. Visibility narrows the actor-scoped
 * result set; it can never widen it.
 */
export type PostTemplatesFilterInput = {
  /** Filter by the goal or intent of the template. */
  goal?: InputMaybe<PostTemplateGoal>;
  /**
   * Case-insensitive substring match against a template's title,
   * description, and body. Whitespace-only values are treated as absent.
   * Combined with the other filters using AND; only ever narrows the
   * actor-scoped result set.
   */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Filter by the structural format of the template. */
  structure?: InputMaybe<PostTemplateStructure>;
  /** Filter by the type or category of the template. */
  type?: InputMaybe<PostTemplateType>;
  /** Filter by the target user type. */
  userType?: InputMaybe<PostTemplateUserType>;
  /**
   * Narrow the result to a single visibility scope. Omit to receive the
   * union of: public templates, internal templates from the supplied
   * organization, and private templates from the actor's account.
   */
  visibility?: InputMaybe<PostTemplateVisibility>;
};

/**
 * Input for fetching templates accessible to the current actor for the
 * template library. A caller can never reach templates outside their own
 * scope — the server pins `private` to the actor's account and `internal`
 * to the supplied `organizationId` regardless of input.
 */
export type PostTemplatesInput = {
  /** Optional filters to narrow the template list. */
  filter?: InputMaybe<PostTemplatesFilterInput>;
  /**
   * Organization to scope `internal`-visibility templates to. The caller
   * must be a member of this organization.
   */
  organizationId: Scalars['OrganizationId']['input'];
};

/** List of possible types for a Post. Some services may have different types (e.g., Instagram has story, reel, post but Twitter has only post) */
export enum PostType {
  Carousel = 'carousel',
  Event = 'event',
  GhostPost = 'ghost_post',
  Offer = 'offer',
  Post = 'post',
  Reel = 'reel',
  Short = 'short',
  Story = 'story',
  Thread = 'thread',
  WhatsNew = 'whats_new'
}

/** List of specific post types available for Facebook */
export enum PostTypeFacebook {
  Post = 'post',
  Reel = 'reel',
  Story = 'story'
}

/** List of specific post types available for Google Business profiles */
export enum PostTypeGoogleBusiness {
  Event = 'event',
  Offer = 'offer',
  WhatsNew = 'whats_new'
}

export type PostUpdated = CoreWebAppMutationResponse & {
  __typename?: 'PostUpdated';
  /** A code to describe the status eg 200 for success, 404 for not found */
  code: Scalars['String']['output'];
  /** A user friendly message to describe the status to the client */
  message: Scalars['String']['output'];
  /** The updated post */
  post: PublishingPost;
  /** A boolean representing success of the entire mutation */
  success: Scalars['Boolean']['output'];
};

export type PostUpdatedPayload = CoreWebAppCommonError | PostNotFound | PostNotUpdated | PostUpdated;

/** List of possible ways to create a Post */
export enum PostVia {
  Api = 'api',
  Buffer = 'buffer',
  Network = 'network'
}

/** Represents a posting goal for a channel, including target, progress, and status information. */
export type PostingGoal = {
  __typename?: 'PostingGoal';
  /** The target number of posts for this goal. */
  goal: Scalars['Int']['output'];
  /** The end date of the period for this posting goal. */
  periodEnd: Scalars['DateTime']['output'];
  /** The start date of the period for this posting goal. */
  periodStart: Scalars['DateTime']['output'];
  /** The number of posts that are scheduled to be sent for this goal. */
  scheduledCount: Scalars['Int']['output'];
  /** The number of posts that have been sent (published or ingested) for this goal. */
  sentCount: Scalars['Int']['output'];
  /** The current status of the posting goal. */
  status: PostingGoalStatus;
};

/** PostingGoalStatus is used to track the status of a posting goal. */
export enum PostingGoalStatus {
  AtRisk = 'AtRisk',
  Hit = 'Hit',
  OnTrack = 'OnTrack'
}

export type PostingSchedule = {
  __typename?: 'PostingSchedule';
  schedules: Array<Schedule>;
};

/**
 * Differences between current and proposed schedules.
 * Shows exactly what will change if the proposed schedule is applied.
 */
export type PostingScheduleDiff = {
  __typename?: 'PostingScheduleDiff';
  /** Posting times that would be added */
  added: Array<ScheduleTime>;
  /** Posting times that would be removed */
  removed: Array<ScheduleTime>;
  /** Posting times that would remain unchanged */
  unchanged: Array<ScheduleTime>;
};

/** Input for calculating posting schedule preview with different strategies */
export type PostingSchedulePreviewInput = {
  /** The channel to calculate posting schedule for */
  channelId: Scalars['ChannelId']['input'];
  /** The strategy to use for calculating posting schedule */
  strategy: PostingScheduleStrategyInput;
};

/**
 * Preview result showing proposed changes without persisting.
 * Includes both the full schedules and a diff for easy comparison.
 */
export type PostingSchedulePreviewResult = {
  __typename?: 'PostingSchedulePreviewResult';
  /** The current posting schedule (reuses existing ScheduleV2 type) */
  current: Array<ScheduleV2>;
  /** Diff showing what would change */
  diff: PostingScheduleDiff;
  /** The proposed new posting schedule (reuses existing ScheduleV2 type) */
  proposed: Array<ScheduleV2>;
};

/**
 * Strategy for calculating posting schedule (discriminated union pattern).
 * Only ONE strategy should be provided. Providing multiple or zero strategies will result in an error.
 */
export type PostingScheduleStrategyInput = {
  /** Channel ID to copy posting times from (must be in same organization) */
  copyFromChannel?: InputMaybe<Scalars['ChannelId']['input']>;
  /** Optimize using Buffer's recommendations */
  optimize?: InputMaybe<OptimizeStrategyInput>;
};

/** Counts for a given channel */
export type PostsCount = {
  __typename?: 'PostsCount';
  /** The channel the counts are for */
  channelId: Scalars['ChannelId']['output'];
  /** The count of posts matching the filters and channel */
  count: Scalars['Int']['output'];
  /**
   * This field is used by the BE to limit the results in the DB query
   * when the query fails due to a time out.
   * BE will return the used limit to the FE and the FE will have to handle it
   * to get the remaining data.
   */
  limit?: Maybe<Scalars['Int']['output']>;
};

/** Represent a node in the pagination result using the Connect Relay convention. */
export type PostsEdge = {
  __typename?: 'PostsEdge';
  /** Opaque cursor to be used in pagination to fetch from current node. */
  cursor: Scalars['String']['output'];
  /** Represents the current post in the list. */
  node: Post;
};

/** Filter to apply to the posts query */
export type PostsFiltersInput = {
  /** When set, it will filter posts by channel */
  channelIds?: InputMaybe<Array<Scalars['ChannelId']['input']>>;
  /** When set, it will filter posts by the date they were created */
  createdAt?: InputMaybe<DateTimeComparator>;
  /** When set, it will filter posts by their scheduled posting date */
  dueAt?: InputMaybe<DateTimeComparator>;
  /**
   * When set, it will filter posts by whether their scheduled posting date exists.
   * `absent` cannot be combined with `dueAt`, because absent dates cannot also match a date range.
   */
  dueAtPresence?: InputMaybe<DateTimePresence>;
  /**
   * When set, it will return posts with createdAt or dueAt date before endDate
   * @deprecated Use field specific filters instead (e.g. dueAt, createdAt, sentAt)
   */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * When set, it will filter posts by format.
   *
   * `post` is a fallback bucket rather than one stored format: it matches every
   * post the other formats do not claim, which is what `Post.metadata.type`
   * reports for the same post. `carousel` and `thread` are rejected, because no
   * stored value resolves to them.
   */
  postTypes?: InputMaybe<Array<PostType>>;
  /**
   * When set, it will return posts with createdAt or dueAt date after startDate
   * @deprecated Use field specific filters instead (e.g. dueAt, createdAt, sentAt)
   */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** When set, it will filter posts by status */
  status?: InputMaybe<Array<PostStatus>>;
  /**
   * When set, it will filter posts by tag
   * @deprecated Use 'tags' field with TagComparator instead
   */
  tagIds?: InputMaybe<Array<Scalars['TagId']['input']>>;
  /** Filter posts by tags. Supports specific tags, untagged posts, or union of both. */
  tags?: InputMaybe<TagComparator>;
};

/** Input for the posts query */
export type PostsInput = {
  /** The filters to apply to the posts query */
  filter?: InputMaybe<PostsFiltersInput>;
  /** The Organization id to fetch posts for */
  organizationId: Scalars['OrganizationId']['input'];
  /** The sort to apply to the posts results */
  sort?: InputMaybe<Array<PostSortInput>>;
};

export type PostsLegacyInput = {
  /** The cursor to start returning posts from */
  after?: InputMaybe<Scalars['String']['input']>;
  /** The filters to apply to the posts query */
  filters?: InputMaybe<PostFiltersInput>;
  /** The amount of posts to return */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** The Organization id to fetch posts for */
  organizationId: Scalars['ID']['input'];
};

/** Results for the posts query. */
export type PostsResults = {
  __typename?: 'PostsResults';
  /** The list of posts that match the query. */
  edges?: Maybe<Array<PostsEdge>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationPageInfo;
  /**
   * The total number of posts that match the query.
   * @deprecated Use postsCount instead
   */
  totalCount: Scalars['Int']['output'];
};

/** Edge type for postsWithComments pagination. */
export type PostsWithCommentEdge = {
  __typename?: 'PostsWithCommentEdge';
  /** Cursor for pagination. */
  cursor: Scalars['String']['output'];
  /** The post that has comments. */
  node: Post;
};

/** Filters for the postsWithComments query. */
export type PostsWithCommentFiltersInput = {
  /**
   * Required. Only posts from these channels are returned.
   * Ensures efficient index usage on the comments collection.
   */
  channelIds: Array<Scalars['ChannelId']['input']>;
  /**
   * Filter comments by their published date range.
   * Only comments within this range contribute to counts and post inclusion.
   */
  publishedAt?: InputMaybe<DateTimeComparator>;
  /**
   * Filter which posts are returned based on their comment status.
   * Defaults to all (posts with any comments).
   */
  status?: InputMaybe<PostsWithCommentStatus>;
};

/** Input for the postsWithComments query. */
export type PostsWithCommentInput = {
  /** Filters applied to determine which posts are returned. */
  filters: PostsWithCommentFiltersInput;
  /** The organization to query posts for. */
  organizationId: Scalars['OrganizationId']['input'];
  /** Sort configuration. Default: publishedAt descending. */
  sort?: InputMaybe<PostsWithCommentSortInput>;
};

/** Paginated result for postsWithComments. */
export type PostsWithCommentResults = {
  __typename?: 'PostsWithCommentResults';
  /** List of post edges. */
  edges: Array<PostsWithCommentEdge>;
  /** Pagination information. */
  pageInfo: PaginationPageInfo;
};

/** Sort configuration for the postsWithComments query. */
export type PostsWithCommentSortInput = {
  /** The direction to sort by. Default: desc. */
  direction: SortDirection;
  /** The field to sort by. */
  field: PostsWithCommentSortableKey;
};

/** Fields that can be used to sort postsWithComments results. */
export enum PostsWithCommentSortableKey {
  /** Sort by the published date of the post's comments. */
  PublishedAt = 'publishedAt'
}

/** Post-level comment status filter for postsWithComments. */
export enum PostsWithCommentStatus {
  /** Posts with any comments regardless of status. */
  All = 'all',
  /** Posts with at least one dismissed comment. */
  Dismissed = 'dismissed',
  /** Posts with at least one replied comment. */
  Replied = 'replied',
  /** Posts with at least one unreplied comment. */
  Unreplied = 'unreplied'
}

/** Account preferences */
export type Preferences = {
  __typename?: 'Preferences';
  community: CommunityPreferences;
  defaultScheduleOption: ScheduleOption;
  /**
   * The user's landing-page choice. `home` means route to Buffer Home;
   * `default` means the user hasn't opted in and the client should use its
   * current default route. Always populated by the server (storage absence is
   * normalized to `default`).
   */
  landingPage: LandingPage;
  startOfWeek?: Maybe<Scalars['String']['output']>;
  timeFormat?: Maybe<Scalars['String']['output']>;
};

/** Metadata describing how pricing is structured for a plan */
export type PricingMetadata = {
  __typename?: 'PricingMetadata';
  /** Indicates what the subscription quantity represents. Determines how pricing scales when quantity changes. */
  quantityType: QuantityType;
};

/** Represents a pricing tier for a plan option */
export type PricingTier = {
  __typename?: 'PricingTier';
  /** Fixed amount for the tier in dollars, if applicable. */
  flatFee: Scalars['Float']['output'];
  /** The price that a customer will pay for each unit (e.g. channel) within this tier, in dollars. */
  unitPrice: Scalars['Float']['output'];
  /** The upper bound for this tier. */
  upperBound: Scalars['Int']['output'];
};

/** Buffer products, buffer is used as all products */
export enum Product {
  Analyze = 'analyze',
  Buffer = 'buffer',
  Comments = 'comments',
  Engage = 'engage',
  Publish = 'publish',
  StartPage = 'startPage'
}

export type ProductLink = {
  __typename?: 'ProductLink';
  name: Product;
  userId?: Maybe<Scalars['ID']['output']>;
};

/** Input for the promoteAnonymousUpload mutation. */
export type PromoteAnonymousUploadInput = {
  /** The full URL of the anonymously uploaded asset (from the anonymous uploads bucket) */
  anonymousAssetUrl: Scalars['String']['input'];
};

/** Result of promoting an anonymous upload. */
export type PromoteAnonymousUploadPayload = InvalidInputError | PromoteAnonymousUploadSuccess;

/** Successful result of promoting an anonymous upload. */
export type PromoteAnonymousUploadSuccess = {
  __typename?: 'PromoteAnonymousUploadSuccess';
  /** The permanent URL of the promoted asset in the user's storage */
  assetUrl: Scalars['String']['output'];
};

/**
 * A recoverable error that prevented a content item draft from being
 * promoted. Post errors identify the specific channel they apply to; the
 * others apply to the request as a whole.
 */
export type PromoteContentItemDraftToPostsError = ContentItemStateError | InvalidInputError | PostChannelNotFoundError | PostInvalidInputError | PostLimitReachedError;

/**
 * promoteContentItemDraftToPosts failure. Every recoverable error is reported
 * together so the caller can surface them all at once — for example, every
 * post that failed validation across every targeted channel. A failure does
 * not always mean nothing changed: post-processing errors are reported after
 * the promotion has taken effect.
 */
export type PromoteContentItemDraftToPostsFailure = MutationError & {
  __typename?: 'PromoteContentItemDraftToPostsFailure';
  /** The recoverable errors behind this failure. */
  errors: Array<PromoteContentItemDraftToPostsError>;
  /** Summary error message. */
  message: Scalars['String']['output'];
};

/** Input for promoteContentItemDraftToPosts. */
export type PromoteContentItemDraftToPostsInput = {
  /** The content item to promote. */
  id: Scalars['ContentItemId']['input'];
  /**
   * The channel-specific posts to create, one per channel. Provide at least
   * one post, and at most one post per channel.
   */
  posts: Array<CreatePostInput>;
  /**
   * Tags to apply to this content item. Omit to keep the current tags. An
   * empty list or null removes them all.
   */
  tagIds?: InputMaybe<Array<Scalars['TagId']['input']>>;
};

/** All possible responses for promoteContentItemDraftToPosts. */
export type PromoteContentItemDraftToPostsPayload = PromoteContentItemDraftToPostsFailure | PromoteContentItemDraftToPostsSuccess;

/** Successful promoteContentItemDraftToPosts response. */
export type PromoteContentItemDraftToPostsSuccess = {
  __typename?: 'PromoteContentItemDraftToPostsSuccess';
  /** The promoted content item. */
  contentItem: ContentItem;
};

/** The cross-channel summary, per-channel rows, and chart series. */
export type PublicInsightsSampleAllChannelsPostInsights = {
  __typename?: 'PublicInsightsSampleAllChannelsPostInsights';
  /** The per-channel performance rows. */
  channelInsights: Array<PublicInsightsSampleChannelInsights>;
  /** The followers, posts, reach, and views series for each channel. */
  channelTimeSeries: Array<PublicInsightsSampleChannelTimeSeries>;
  /** The cross-channel summary metrics. */
  summary: Array<InsightsSummaryMetric>;
};

/** The display fields of a post attachment. */
export type PublicInsightsSampleAsset = {
  __typename?: 'PublicInsightsSampleAsset';
  /** A stable public key. */
  id: Scalars['ID']['output'];
  /** The thumbnail URL. */
  thumbnail: Scalars['String']['output'];
  /** The asset type. */
  type: AssetType;
};

/** The display fields of one of Buffer's channels. */
export type PublicInsightsSampleChannel = {
  __typename?: 'PublicInsightsSampleChannel';
  /** The channel avatar URL. */
  avatar: Scalars['String']['output'];
  /** A stable public key. It is not a production ChannelId. */
  id: Scalars['ID']['output'];
  /** The channel name. */
  name: Scalars['String']['output'];
  /** The channel service. */
  service: Service;
};

/** One channel's current-period metrics. */
export type PublicInsightsSampleChannelInsights = {
  __typename?: 'PublicInsightsSampleChannelInsights';
  /** The channel. */
  channel: PublicInsightsSampleChannel;
  /** The metrics, calculated as on the authenticated Insights page. */
  metrics: Array<PostInsightsSummaryMetric>;
};

/** One channel's daily chart series. */
export type PublicInsightsSampleChannelTimeSeries = {
  __typename?: 'PublicInsightsSampleChannelTimeSeries';
  /** The channel. */
  channel: PublicInsightsSampleChannel;
  /** The comparison-period series. Null unless the input names a comparison period. */
  comparison?: Maybe<ChannelInsightsTimeSeriesData>;
  /** The first date with stored channel analytics. */
  firstChannelDataCollectedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The current-period series. */
  primary: ChannelInsightsTimeSeriesData;
};

/** An inclusive UTC date window. */
export type PublicInsightsSampleDateRange = {
  __typename?: 'PublicInsightsSampleDateRange';
  /** The last included instant. */
  end: Scalars['DateTime']['output'];
  /** The first included instant. */
  start: Scalars['DateTime']['output'];
};

/**
 * Filters for the public Insights sample. The sample shows the current Insights
 * of Buffer's own channels. Dates are whole UTC days.
 */
export type PublicInsightsSampleInput = {
  /** Public channel ids from `availableChannels`. Omit to include every channel. */
  channelIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * The last day of the comparison period. Provide with `comparisonStartDate`.
   * Omit both to compare with the equal-length period before `startDate`.
   */
  comparisonEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The first day of the comparison period. Provide with `comparisonEndDate`. */
  comparisonStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The last day of the period. The period covers at most 93 days. */
  endDate: Scalars['DateTime']['input'];
  /** The first day of the period. */
  startDate: Scalars['DateTime']['input'];
};

/** The input names an unknown channel or an unsupported period. */
export type PublicInsightsSampleInvalidInput = {
  __typename?: 'PublicInsightsSampleInvalidInput';
  /** A safe description for the caller. */
  message: Scalars['String']['output'];
};

/** The result of the public Insights sample query. */
export type PublicInsightsSamplePayload = LimitReachedError | PublicInsightsSampleInvalidInput | PublicInsightsSampleSuccess | PublicInsightsSampleUnavailable;

/** The display fields of one of Buffer's sent posts. */
export type PublicInsightsSamplePost = {
  __typename?: 'PublicInsightsSamplePost';
  /** The attachment previews. */
  assets: Array<PublicInsightsSampleAsset>;
  /** The channel that sent the post. */
  channel: PublicInsightsSampleChannel;
  /** The public key of the channel that sent the post. */
  channelId: Scalars['ID']['output'];
  /** The channel service. */
  channelService: Service;
  /** The URL of the post on the network. */
  externalLink?: Maybe<Scalars['String']['output']>;
  /** A stable public key. It is not a production PostId. */
  id: Scalars['ID']['output'];
  /** The post format. */
  metadata: PublicInsightsSamplePostMetadata;
  /** The post metrics. Null when the network reported none. */
  metrics?: Maybe<Array<PostMetric>>;
  /** When the network published the post. */
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  /** The post text. */
  text: Scalars['String']['output'];
};

/** The post format the Insights display uses. */
export type PublicInsightsSamplePostMetadata = {
  __typename?: 'PublicInsightsSamplePostMetadata';
  /** The post format. */
  type: PostType;
};

/** The current Insights of Buffer's channels for the requested period. */
export type PublicInsightsSampleSuccess = {
  __typename?: 'PublicInsightsSampleSuccess';
  /** The summary, per-channel rows, and chart series for the selected channels. */
  allChannelsPostInsights: PublicInsightsSampleAllChannelsPostInsights;
  /** Every channel the sample can show, for the channel filter. */
  availableChannels: Array<PublicInsightsSampleChannel>;
  /** When the API calculated this result. Results refresh on a short interval. */
  calculatedAt: Scalars['DateTime']['output'];
  /** The resolved period. */
  currentPeriod: PublicInsightsSampleDateRange;
  /** The resolved comparison period. */
  previousPeriod: PublicInsightsSampleDateRange;
  /**
   * The top posts of the selected channels in the period.
   * The ranking uses opaque offset cursors because computed metrics can change
   * and many posts can have the same value. Reset `after` when a filter or the
   * sort changes.
   */
  topPosts: PublicInsightsSampleTopPostsConnection;
};


/** The current Insights of Buffer's channels for the requested period. */
export type PublicInsightsSampleSuccessTopPostsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort: PublicInsightsSampleTopPostsSortInput;
};

/** A page of the public top posts ranking. The ranking serves at most fifty posts. */
export type PublicInsightsSampleTopPostsConnection = {
  __typename?: 'PublicInsightsSampleTopPostsConnection';
  /** The posts on this page. */
  edges: Array<PublicInsightsSampleTopPostsEdge>;
  /** Pagination metadata. */
  pageInfo: PaginationPageInfo;
  /** The number of ranked posts in the period. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in the public top posts ranking. */
export type PublicInsightsSampleTopPostsEdge = {
  __typename?: 'PublicInsightsSampleTopPostsEdge';
  /** An opaque cursor. */
  cursor: Scalars['String']['output'];
  /** The post. */
  node: PublicInsightsSamplePost;
};

/** Sort configuration for the public top posts ranking. */
export type PublicInsightsSampleTopPostsSortInput = {
  /** Sort direction. */
  direction: SortDirection;
  /** The metric to sort by. */
  field: TopPostsSortBy;
};

/** The sample has no channel to show. */
export type PublicInsightsSampleUnavailable = {
  __typename?: 'PublicInsightsSampleUnavailable';
  /** A safe description for the caller. */
  message: Scalars['String']['output'];
};

/**
 * A Buffer-curated post template visible to anonymous visitors of buffer.com
 * (e.g. the Template Library marketing page). Returned by the free-tools
 * `publicPostTemplates` query.
 */
export type PublicPostTemplate = {
  __typename?: 'PublicPostTemplate';
  /** The main content body of the template, may contain {{placeholders}}. */
  body: Scalars['String']['output'];
  /** The date and time the template was created. */
  createdAt: Scalars['DateTime']['output'];
  /** A short user-facing description of the template. */
  description: Scalars['String']['output'];
  /** The emoji associated with the template. */
  emoji: Scalars['String']['output'];
  /** The goal or intent behind the template. */
  goal: PostTemplateGoal;
  /** The unique identifier for the template. */
  id: Scalars['PostTemplateId']['output'];
  /** Tags applied to the template. */
  tags: Array<PostTemplateTag>;
  /** The title of the template. */
  title: Scalars['String']['output'];
  /** The type or category of the template. */
  type: PostTemplateType;
};

/** Represents a node in the pagination result using the Relay convention. */
export type PublicPostTemplatesEdge = {
  __typename?: 'PublicPostTemplatesEdge';
  /** Opaque cursor to be used in pagination to fetch from current node. */
  cursor: Scalars['String']['output'];
  /** The current public post template in the list. */
  node: PublicPostTemplate;
};

/**
 * Optional filter applied to the `publicPostTemplates` query within the public set.
 * Cannot widen visibility — the resolver always scopes to public templates.
 */
export type PublicPostTemplatesFilterInput = {
  /** Narrow to a single template goal. */
  goal?: InputMaybe<PostTemplateGoal>;
  /** Narrow to a single template type. */
  type?: InputMaybe<PostTemplateType>;
};

/** Input for fetching Buffer-curated public post templates. */
export type PublicPostTemplatesInput = {
  /** Optional filter applied within the public set. Cannot widen visibility. */
  filter?: InputMaybe<PublicPostTemplatesFilterInput>;
};

/** Response for the `publicPostTemplates` query. */
export type PublicPostTemplatesResponse = {
  __typename?: 'PublicPostTemplatesResponse';
  /** The list of public post templates that match the query. */
  edges: Array<PublicPostTemplatesEdge>;
  /** Information to aid in pagination. */
  pageInfo: PaginationPageInfo;
};

/** publishPostNow mutation publish now a post by id. */
export type PublishPostNowInput = {
  /** Post id to publish now. */
  id: Scalars['PostId']['input'];
};

/** All possible response types that can be returned by publishPostNow mutation. */
export type PublishPostNowPayload = NotFoundError | PostActionSuccess | RestProxyError | UnauthorizedError | UnexpectedError | VideoProcessingError;

export type PublishStartPageInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
};

export type PublishingCampaign = {
  __typename?: 'PublishingCampaign';
  color: HexColor;
  endDate?: Maybe<Scalars['Int']['output']>;
  /** Human readable date of campaign. E.g., 'Oct 11-13' */
  formattedDateRange?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  startDate?: Maybe<Scalars['Int']['output']>;
};

export type PublishingChannel = {
  __typename?: 'PublishingChannel';
  avatar?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  locationData?: Maybe<ChannelLocationData>;
  serverUrl?: Maybe<Scalars['String']['output']>;
  service: Service;
  timezone?: Maybe<Scalars['String']['output']>;
  username: Scalars['String']['output'];
};

export type PublishingError = {
  __typename?: 'PublishingError';
  /** A raw error message to help developpers understand the root cause of the issue. */
  cause: Scalars['String']['output'];
  /** A code to describe the status eg 200 for success, 404 for not found */
  code?: Maybe<Scalars['String']['output']>;
  /** A user-friendly message that is safe to be displayed to users. */
  userFriendlyMessage: Scalars['String']['output'];
};

export type PublishingNote = {
  __typename?: 'PublishingNote';
  author: NoteAuthor;
  createdAt: Scalars['Int']['output'];
  editedAt?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  text: Scalars['String']['output'];
  type: NoteType;
};

export type PublishingPost = {
  __typename?: 'PublishingPost';
  /** LinkedIn mentions, referred to as annotations */
  annotations?: Maybe<Array<LinkedInAnnotation>>;
  /** Attachments such as retweet, link, etc. for this post */
  attachments?: Maybe<Array<Maybe<PublishingPostAttachment>>>;
  /** The author of the post */
  author: Author;
  /** The campaign this post is associated with */
  campaign?: Maybe<PublishingCampaign>;
  /** The channel to which this post will be (or is) published */
  channel: PublishingChannel;
  /** Channel specific data */
  channelData?: Maybe<ChannelData>;
  /** Id of the user who created the post */
  createdBy: Scalars['ID']['output'];
  /** The unix timestamp of when the post was (or will be) sent */
  dueAt?: Maybe<Scalars['Int']['output']>;
  /** Facebook mentions, referred to as entities */
  entities?: Maybe<Array<FacebookEntity>>;
  /** Details of the post error, if present */
  error?: Maybe<PublishingPostError>;
  /** A human readable timestamp of when the post is (or will be) sent, e.g., '2:10 PM' or '14:10' */
  formattedTime?: Maybe<Scalars['String']['output']>;
  /** The location for the post */
  geoLocation?: Maybe<GeoLocation>;
  id: Scalars['ID']['output'];
  /** Flag to check if the post was created via Blueprints */
  isBlueprint?: Maybe<Scalars['Boolean']['output']>;
  /** Whether this post is (or was) scheduled for a specific date and time */
  isCustomScheduled: Scalars['Boolean']['output'];
  /** Whether this post is (or was) specifically scheduled into one of the channel's schedule time slots */
  isPinned: Scalars['Boolean']['output'];
  /** Is the profile queue paused */
  isQueuePaused: Scalars['Boolean']['output'];
  /** Whether this post is (or will be) sent as an Instagram reminder */
  isReminder: Scalars['Boolean']['output'];
  /** Whether this post is a retweet */
  isRetweet: Scalars['Boolean']['output'];
  /** Media items (images, videos) attached to this post */
  media?: Maybe<Array<PublishingPostMedia>>;
  /** Whether a post needs approval before being scheduled */
  needsApproval?: Maybe<Scalars['Boolean']['output']>;
  /** The list of notes added to the post */
  notes?: Maybe<Array<Maybe<PublishingNote>>>;
  /** The direct URL to the post */
  serviceLink?: Maybe<Scalars['String']['output']>;
  /** Pinterest source url */
  sourceUrl?: Maybe<Scalars['String']['output']>;
  /** Post analytics */
  statistics?: Maybe<PostStatistics>;
  /** Post analytics V2 - supports filtering of Premium analytics */
  statisticsV2: Array<PostStatisticsV2>;
  /** The current state of the post */
  status: PublishingPostStatus;
  /** The subprofile is currently only used for Pinterest Boards */
  subprofile?: Maybe<PublishingSubprofile>;
  /** Attachments such as retweet, link, etc. for this post */
  tags: Array<PublishingTag>;
  /** The text content of the post */
  text?: Maybe<Scalars['String']['output']>;
  /** Number of threaded updates, including the parent update */
  threadCount?: Maybe<Scalars['Int']['output']>;
  /** The post title, this is currently only used for Pinterest */
  title?: Maybe<Scalars['String']['output']>;
  /** The type of post, always 'post' for now, but could be 'story' in a future version */
  type: PublishingPostType;
  /** Type of the update (e.g. Reel or Feed for IG) */
  updateType?: Maybe<Scalars['String']['output']>;
  /** Source of the post */
  via?: Maybe<Scalars['String']['output']>;
};

export type PublishingPostAttachment = PublishingPostDestinationUrl | PublishingPostFirstComment | PublishingPostLink | PublishingPostRetweet;

export type PublishingPostDestinationUrl = {
  __typename?: 'PublishingPostDestinationUrl';
  url: Scalars['String']['output'];
};

export type PublishingPostEdge = {
  __typename?: 'PublishingPostEdge';
  cursor: Scalars['String']['output'];
  node: PublishingPost;
};

export type PublishingPostError = {
  __typename?: 'PublishingPostError';
  actionType?: Maybe<PublishingPostErrorAction>;
  code?: Maybe<Scalars['Int']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  rawError?: Maybe<Scalars['String']['output']>;
};

export enum PublishingPostErrorAction {
  Refresh = 'refresh',
  Verify = 'verify'
}

export type PublishingPostFirstComment = {
  __typename?: 'PublishingPostFirstComment';
  text: Scalars['String']['output'];
};

export type PublishingPostLink = {
  __typename?: 'PublishingPostLink';
  description?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type PublishingPostMedia = {
  __typename?: 'PublishingPostMedia';
  original: Scalars['String']['output'];
  thumbnail?: Maybe<Scalars['String']['output']>;
  type: MediaType;
};

export type PublishingPostRetweet = {
  __typename?: 'PublishingPostRetweet';
  accountName: Scalars['String']['output'];
  avatar?: Maybe<Scalars['String']['output']>;
  /** The unix timestamp of when the tweet was sent to retweets */
  sentAt: Scalars['Int']['output'];
  text: Scalars['String']['output'];
  /** The tweet url */
  url: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export enum PublishingPostStatus {
  Draft = 'draft',
  Error = 'error',
  Pending = 'pending',
  PendingApproval = 'pending_approval',
  PendingTiktok = 'pending_tiktok',
  Scheduled = 'scheduled',
  Sent = 'sent'
}

export enum PublishingPostType {
  Draft = 'draft',
  Post = 'post',
  Story = 'story'
}

/** Represents the publishing status of a comment. */
export type PublishingStatus = {
  __typename?: 'PublishingStatus';
  /** Error message, if the reply failed and the status is Error */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The current status of the reply (e.g. error, published, processing). */
  status: CommentEngagementStatusTypes;
};

export type PublishingSubprofile = {
  __typename?: 'PublishingSubprofile';
  avatar?: Maybe<Scalars['String']['output']>;
  channelId: Scalars['ID']['output'];
  createdAt: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isShared: Scalars['Boolean']['output'];
  layout?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  service: Scalars['String']['output'];
  serviceId: Scalars['String']['output'];
  updatedAt: Scalars['Int']['output'];
  url: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};

/** Tag snapshot associated with content */
export type PublishingTag = {
  __typename?: 'PublishingTag';
  /** Hex color for tag e.g #F523F1 */
  color: Scalars['String']['output'];
  /**
   * Stable Buffer palette identifier derived from `color`.
   * Clients should map this value to platform- and theme-specific presentation,
   * falling back to `color` when this field is null or unsupported.
   * Returns null for custom or unrecognized colors.
   */
  colorName?: Maybe<TagColorName>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** An account's subscription preference for a push notification topic. */
export type PushNotificationPreference = {
  __typename?: 'PushNotificationPreference';
  /** Identifier of the associated topic in the notification provider. */
  cioTopicId?: Maybe<Scalars['String']['output']>;
  /** Human-readable description of the notification preference. */
  description: Scalars['String']['output'];
  /** Unique identifier for the push notification preference. */
  id: Scalars['String']['output'];
  /** Display name of the notification preference. */
  name: Scalars['String']['output'];
  /** Whether the account is subscribed to this notification. */
  subscribed: Scalars['Boolean']['output'];
};

/** Returned when push notification preferences cannot be retrieved or updated. */
export type PushNotificationPreferenceError = {
  __typename?: 'PushNotificationPreferenceError';
  /** Human-readable error message. */
  message: Scalars['String']['output'];
};

/** Input for a single push notification preference. */
export type PushNotificationPreferenceInput = {
  /** Unique identifier for the push notification preference. */
  id: Scalars['String']['input'];
  /** Whether the account is subscribed to this notification. */
  subscribed: Scalars['Boolean']['input'];
};

/** Result of a push notification preferences operation. */
export type PushNotificationPreferencePayload = PushNotificationPreferenceError | PushNotificationPreferencesResponse;

/** Input for updating push notification preferences for a specific account. */
export type PushNotificationPreferencesForAccountInput = {
  /** Unique identifier for the account. */
  accountId: Scalars['String']['input'];
  /** The push notification preferences to set for the account. */
  preferences: Array<PushNotificationPreferenceInput>;
};

/** Successful push notification preferences result. */
export type PushNotificationPreferencesResponse = {
  __typename?: 'PushNotificationPreferencesResponse';
  /** The push notification preferences. */
  preferences: Array<PushNotificationPreference>;
};

export type PusherAuth = {
  __typename?: 'PusherAuth';
  auth?: Maybe<Scalars['String']['output']>;
};

export type PusherAuthenticationInput = {
  organizationId: Scalars['String']['input'];
  pusherChannel: Scalars['String']['input'];
  socketId: Scalars['String']['input'];
};

/** Defines what the subscription quantity represents for the plan. */
export enum QuantityType {
  /** Pricing scales based on number of channels */
  Channels = 'channels',
  /** Pricing scales based on number of users/team members */
  Users = 'users'
}

/** Root query type for team management operations. */
export type Query = {
  __typename?: 'Query';
  /** Retrieves the authenticated user's account information */
  account: Account;
  /** Fetch a Buffer account by its associated email address */
  accountByEmail: Account;
  /** Fetch a Buffer account by its account Id */
  accountById: Account;
  /** Fetch a Buffer account by a product name and foreign key */
  accountByProductLink: Account;
  /** Information about the authenticated user's affiliate program data */
  affiliateData: AffiliateData;
  /**
   * Aggregate normalized post metrics across a filtered post set. Useful
   * for yearly summaries, channel-level rollups, and BI exports without
   * paginating through thousands of posts.
   *
   * For per-post metrics, use `posts(input)` or `post(input)` with a
   * `metrics { … }` selection — this query is purely for aggregation.
   *
   * The result always contains a baseline trio of entries: `postCount`
   * (number of matched posts in the window), `reactions`, and `comments`.
   * Posts on networks that don't track reactions or comments contribute 0
   * to those totals.
   *
   * Beyond the baseline, additional metric types are returned only when
   * every channel in the filter set supports them. A single-network filter
   * surfaces that network's richer metrics (e.g. impressions, reach,
   * engagementRate on LinkedIn); a mixed-network filter trims the extras
   * to those common to every network in the set.
   */
  aggregatedPostMetrics: AggregatedPostMetrics;
  /** Fetches aggregated post insights across all channels */
  allChannelsPostInsights: AllChannelsPostInsights;
  alphaFeatures: Array<AlphaFeature>;
  analyticsAnswers: AnalyticsAnswers;
  analyticsDailies: Array<Maybe<AnalyticsDaily>>;
  analyticsHashtags: Array<Maybe<AnalyticsHashtag>>;
  analyticsPosts: Array<Maybe<AnalyticsPost>>;
  analyticsPostsTotals: AnalyticsPostsTotals;
  analyticsTotals: AnalyticsTotals;
  /** Generates a short-lived URL for anonymous media preview or download. */
  anonymousMediaAccess: AnonymousMediaAccessPayload;
  /** Fetch an API Client */
  apiClient: ApiClientPayload;
  /** Fetch usage statistics for an API Client */
  apiClientUsageStatistics: ApiClientUsageStatisticsPayload;
  /** Fetch the current account's API clients. */
  apiClients: ApiClientsResponse;
  /** Fetch API clients for a specific account. */
  apiClientsForAccount: ApiClientsForAccountResponse;
  /**
   * Fetch all channels available for assignment to a team member.
   * Returns all organization channels with the member's current per-product
   * access levels.
   * Only admins can view assignable channels.
   */
  assignableChannels: Array<AssignableChannel>;
  betaFeatures: Array<BetaFeature>;
  /**
   * Query billing details for an organization.
   * This is the top-level entry point for all billing-related data.
   * Use inline fragments to access platform-specific fields.
   */
  billing: BillingDetails;
  /**
   * Fetch the Buffer Home first-steps checklist for the given organization.
   * Powers the FirstSteps section on the Home page.
   */
  bufferHomeChecklist: BufferHomeChecklist;
  /** Fetch a calendar for a given channel and time period */
  calendar?: Maybe<CalendarsPayload>;
  /** Fetch a single post by id */
  calendarPost?: Maybe<PublishingPost>;
  canConnectChannels?: Maybe<Array<ChannelConnectionAvailability>>;
  /** Fetches all changelog entries for an account in the organization */
  changelogEntries: ChangelogEntriesResponse;
  /** Fetches a single changelog entry */
  changelogEntry: ChangelogEntryResponse;
  /** Fetches a single channel using the provided ID */
  channel: Channel;
  /**
   * Check the status of a channel analytics export job.
   * Returns the current state: processing, success with download URL, or failure.
   */
  channelAnalyticsExportStatus: ChannelAnalyticsExportStatus;
  /** Get the authorization URL for a network. */
  channelAuthorizationInfo: ChannelAuthorizationInfoResponse;
  channelAuthorizationUrl: ChannelAuthorizationUrlPayload;
  /**
   * Benchmarks for an organization's channels over a date range. Each
   * channel returns only the benchmarks applicable to its network and
   * channel type. Use a single-month range for a point-in-time value;
   * use a wider range for monthly history. Months past the most recent
   * settled benchmark month are omitted.
   */
  channelBenchmarks: ChannelBenchmarksPayload;
  /**
   * Fetch a channel by its channel Id
   * @deprecated Use the new channel query instead
   */
  channelById?: Maybe<Channel>;
  channelGetByServiceAndServiceId?: Maybe<Channel>;
  channelGetTemporaryCredentials: ChannelCredentials;
  /** Fetches a single channel group */
  channelGroup: ChannelGroupPayload;
  /** Fetches all channel groups for an account in the organization */
  channelGroups: ChannelGroupsPayload;
  /** Fetches takeaways for a channel based on the last 4 weeks of data */
  channelTakeaways: Array<Takeaway>;
  /** Fetch all channels for the organization taking into account the current's user permissions */
  channels: Array<Channel>;
  chargeById?: Maybe<Charge>;
  checklists: ChecklistsPayload;
  /** Retrieve information for an API client based on the provided arguments (such as the client platform) */
  client: ClientPayload;
  /** The authorized Notes in a thread, in descending creation order. */
  collaborationNotes: CollaborationNotesConnection;
  /** Returns the current account's collaboration Notes read position for a Post. */
  collaborationNotesReadState: CollaborationNotesReadState;
  /**
   * Returns the comments' context menaning the parent comments of the input comment, the parent of the parent and so on
   * until the root comment
   * @deprecated Use commentThread instead
   */
  commentContext: CommentContextResponse;
  /** Returns the suggestions for a given comment generated by the AI */
  commentSuggestions: CommentSuggestionsResponse;
  /**
   * Returns the comments' thread meaning the parent comments of the input comment, the parent of the parent and so on
   * until the root comment, the comment and the reply to the comment (if comment has been replied)
   */
  commentThread: CommentThreadResponse;
  /**
   * Fetches comments for the given organization and filters.
   * The results are sorted by the option in sort.
   * first and after can be set for forward pagination using Relay convention.
   * Index in DB: { organizationId: 1 , channelId: 1, status: 1, publishedAt: 1)
   */
  comments: CommentsResults;
  /** Returns the comments configuration for the given organization */
  commentsConfiguration: CommentsConfigurationResponse;
  /** Query to fetch the counts for comments in the organization */
  commentsCounts: CommentsCountsResponse;
  /** Returns comment status counts grouped by post. */
  commentsCountsByPost: CommentsCountsByPostResponse;
  /** Returns the insights for a given channelID and prompt extracted from the last comments and posts using AI */
  commentsInsights: CommentsInsightsResponse;
  /** Retrieve the oEmbed representation of a URL for a given channel. */
  commentsOEmbed?: Maybe<CommentsOEmbedResponse>;
  /**
   * Returns the comments' score for a given channel for the current and previous week
   * @deprecated Use `commentsScoreForChannels` instead.
   */
  commentsScore: CommentsScoreResponse;
  /** Returns the comments' score for a list of one or more channels for the current and previous period */
  commentsScoreForChannels: CommentsScoreForChannelsResponse;
  /**
   * Global, per-organization configuration: the connected `channels` the actor can
   * view (with per-feature authorization) plus the service-level capability
   * catalog (`services`). One round trip for every capability domain; clients
   * select only what they need.
   */
  configuration: Configuration;
  /** Provides a list of services, with properties based on the provided organization and client information */
  connectableServices: ConnectableServicesPayload;
  /**
   * Fetch a single content item by id. Errors if no content item with that id
   * exists.
   *
   * This API is an early preview and can change without a deprecation period.
   */
  contentItem: ContentItem;
  /**
   * Fetch an organization's content items in the requested order, newest first
   * by default. Uses standard cursor pagination: pass the previous page's
   * `pageInfo.endCursor` as `after` to fetch the next page. Requesting more than
   * 100 items in a single page is rejected.
   *
   * This API is an early preview and can change without a deprecation period.
   */
  contentItems: ContentItemsConnection;
  /**
   * Lists an organization's content items and posts in one ordered stream,
   * across every post status, the latest `date` first by default. Pass the
   * previous page's `pageInfo.endCursor` as `after` to get the next page.
   */
  contents: ContentsConnection;
  /**
   * The messages of one conversation, newest first: a thread opens at its latest
   * message and pages back in time with `after`. Only DM conversations have
   * messages today.
   *
   * Serves one mock DM thread for any conversation id, without channel or
   * permission checks, until DM storage lands.
   */
  conversationMessages: ConversationMessagesConnection;
  /**
   * One row per conversation across one or more channels: one DM chat, never one
   * row per message. Opening a conversation is a separate call. Only
   * `MessageConversation` exists today, so this returns DMs.
   *
   * Serves mock DM conversations until DM storage lands.
   */
  conversations: ConversationsConnection;
  /**
   * Fetches a curated set of takeaways across a selection of channels. Returns at
   * most one takeaway per category, and spreads them across the selected channels
   * where the candidates allow.
   */
  crossChannelsTakeaways: Array<Takeaway>;
  /** Returns daily posting limit status for the given channels on the specified date. */
  dailyPostingLimits: Array<DailyPostingLimitStatus>;
  /**
   * Fetch an organization's drafts of both kinds in one ordered stream, newest
   * first by default. Uses standard cursor pagination: pass the previous page's
   * `pageInfo.endCursor` as `after` to fetch the next page. Requesting more than
   * 100 drafts in a single page is rejected.
   */
  drafts: DraftsConnection;
  /** Fetch the current user's email notification preferences. */
  emailNotificationPreferences: EmailNotificationPreferencePayload;
  /**
   * Returns the conversation around the given engagement in both directions:
   * up to 20 ancestors (context preceding it) and up to 20 descendants (items
   * following it) in a single round trip. Each side is its own connection —
   * paginate further by passing first / after on the ancestors or descendants
   * field directly. Same cursor-pagination shape as the inbox queries.
   */
  engagementConversationById: EngagementConversationByIdResponse;
  /**
   * Batch-fetch up to 20 conversation items per engagement. Returns one entry per
   * requested engagementId in input order. No pagination — for paginated
   * single-engagement access use engagementConversationById.
   */
  engagementConversations: EngagementConversationsResponse;
  /**
   * Per-channel engagement counts for a fixed engagementType, scoped by the input
   * filters. Mentions only today — passing
   * `comment` returns an error.
   */
  engagementCountsByChannelIds: EngagementCountsByChannelIdsResponse;
  /**
   * Paginated engagements across one or more channels. Default
   * inbox view used by the Community surface.
   */
  engagementInboxByChannelIds: EngagementInboxByChannelIdsConnection;
  featureFlips?: Maybe<Array<FeatureFlip>>;
  /** Fetches a (single) feed by FeedID */
  feed?: Maybe<Feed>;
  /** Fetches a (single) feed collection by FeedCollectionID */
  feedCollection: FeedCollection;
  /** Fetches (lists) feed collections for the given organization */
  feedCollections: FeedCollectionConnection;
  /** Fetches (lists) feed items for the given feed collection */
  feedItems: FeedItemConnection;
  /** Fetches all feeds for the given organization */
  feeds: Array<Feed>;
  /** Get a single free tool's metadata and field definitions. */
  freeTool: FreeTool;
  /**
   * List available free tools, optionally filtered by template.
   * Returns a Relay-shaped connection. Cursors encode the tool id of the
   * last edge on the previous page; page order matches the registry's
   * static declaration order, not a sort on id.
   *
   * Page size defaults to 10 and is capped at 25 in the resolver
   * (enforced server-side because `free-tools-api` is not behind the
   * api-gateway shield and doesn't enable GraphQL Armor).
   */
  freeTools: FreeToolsConnection;
  /** Fetches an  access token for a channel */
  getAccessTokensForChannel: GetAccessTokensForChannelPayload;
  /**
   * Previews the costs of upgrading from monthly to annual billing.
   * Unlike getPreviewInvoice, this always calculates as an immediate change
   * (matching the behavior of the upgradePlanToAnnualBilling mutation).
   */
  getAnnualUpgradePreviewInvoice: GetPreviewInvoicePayload;
  /** Get customer attributes from Customer.io for the specified account or current user's account */
  getCustomerIOAttributes: GetCustomerIoAttributesResponse;
  /**
   * Previews the costs and details of an upcoming invoice for a potential subscription change.
   * Returns a preview of charges, credits, and billing dates before applying changes.
   */
  getPreviewInvoice: GetPreviewInvoicePayload;
  /** Get recommended times for a channel */
  getRecommendedTimesForChannel: GetRecommendedTimesForChannelResponse;
  /**
   * Query most recently used Threads topics.
   * Results are sorted by most recently used first.
   */
  getThreadsMostRecentlyUsedTopics: GetThreadsMostRecentlyUsedTopicsPayload;
  /**
   * Query trending topics for a channel.
   * Returns trending topics for the specified channel and location.
   */
  getTrendingTopics: GetTrendingTopicsPayload;
  healthStatus?: Maybe<HealthStatus>;
  idea?: Maybe<IdeaPayload>;
  /** Retrieves idea groups based on the provided input parameters. */
  ideaGroups: Array<IdeaGroup>;
  /** Fetch a paginated list of ideas with optional filtering */
  ideas: IdeasConnection;
  ideasCount: IdeasCountPayload;
  ideasCountByTag: IdeasCountPayload;
  ideasCountByTags: IdeasCountByTagsPayload;
  /**
   * Deprecated internal alias kept during migration. Use 'ideas'.
   * @deprecated Use 'ideas'
   */
  ideasV2: PaginatedIdeasV2;
  imagesTrackDownload: MutationBasicPayload;
  /**
   * Refresh metadata and preview availability for one Instagram audio asset.
   * Requires Facebook Login. Instagram Login channels return ChannelRefreshRequired.
   */
  instagramAudio: InstagramAudioPayload;
  /**
   * Return trending music and original sounds in a single request.
   * Requires Facebook Login. Instagram Login channels return ChannelRefreshRequired.
   */
  instagramAudioCatalog: InstagramAudioCatalogPayload;
  /**
   * Fetch a short-lived playable preview for one Instagram audio asset.
   * Requires Facebook Login. Instagram Login channels return ChannelRefreshRequired.
   */
  instagramAudioPreview: InstagramAudioPreviewPayload;
  /**
   * Look up a pending invitation by its JWT. Used by the auth screens to
   * render "You've been invited to join {orgName}" context above the
   * signup / login form, and by the `/invite/accept` page.
   *
   * Returns the `Invitation` entity directly — the auth screens read
   * `invitation.invitedBy`, `invitation.email`, `invitation.account` (for
   * the accountExists check), and friends through the standard
   * `Invitation` field resolvers.
   *
   * Errors propagate as `data.errors`: a bad/forged JWT, an expired
   * token, a missing invitation, or a missing inviting org throws and
   * the client renders the "invitation expired or revoked" UX from the
   * error payload.
   */
  invitationByToken: Invitation;
  invoicesByOrganization: InvoiceConnection;
  /** @deprecated Use `isSplitEnabledForOrganization` instead. */
  isNewRemindersEnabledForOrganization: SplitEnabledResponse;
  isSplitEnabledForOrganization: SplitEnabledResponse;
  /**
   * Check eligibility for claiming a LinkedIn Premium promo code
   * Returns eligibility status and additional context.
   * Can be used by authenticated accounts or internal services (with accountId/organizationId).
   */
  linkedInPremiumPromoCodeEligibility: LinkedInPremiumPromoCodeEligibility;
  location: LocationPayload;
  /**
   * Fetch a single post template by ID for the Buffer-internal Template
   * Manager CMS; authorization is enforced by the use case
   * (`assertCanManagePostTemplates`), so a manager can open any template
   * regardless of its creator or visibility. Returns null if not found. For
   * the user-facing template library, use `postTemplate` instead.
   */
  managedPostTemplate?: Maybe<PostTemplate>;
  /**
   * Fetch a paginated list of post templates for the Buffer-internal
   * Template Manager CMS; authorization is enforced by the use case
   * (`assertCanManagePostTemplates`). For the user-facing template
   * library, use `postTemplates` instead.
   */
  managedPostTemplates: PostTemplatesConnection;
  /** Fetch all available OAuth scopes for API clients */
  oauthScopes: OAuthScopesResponse;
  organization?: Maybe<Organization>;
  /**
   * Aggregate activity summary for an organization.
   *
   * Returns one of two states (see `OrganizationActivitySummaryPayload`):
   * an `OrganizationActivitySummary` with metrics (each metric is
   * independently nullable when it falls below its surfacing threshold),
   * or `OrganizationActivitySummaryDefaultState` when the org doesn't have
   * enough history for any metric to be meaningful.
   */
  organizationActivitySummary: OrganizationActivitySummaryPayload;
  /**
   * Posting goal progress aggregated across the organization's channels.
   * Powers the Buffer Home posting goals module.
   */
  organizationPostingGoalsSummary: OrganizationPostingGoalsSummary;
  /** Retrieve the Referral Code for a particular organization */
  organizationReferralCode: OrganizationReferralCodeResponse;
  organizations: Array<Maybe<Organization>>;
  /**
   * Fetch pending invitations for an organization. Returns one
   * `Invitation` per pending row; the admin UI uses this to render the
   * "Pending invites" section alongside the active team-members list.
   * Only admins can view pending invitations.
   */
  pendingInvitations: Array<Invitation>;
  /**
   * Fetch all OAuth scopes selectable when generating a Personal API Key.
   * Unlike `oauthScopes`, this includes restricted scopes (e.g. 'insights:read')
   * that App Clients cannot request but Personal API Keys may hold.
   */
  personalAccessTokenScopes: OAuthScopesResponse;
  /** Fetch personal access tokens */
  personalAccessTokens: PersonalAccessTokensResponse;
  /**
   * This is a new previewPlanMigration query which is focusing on the
   * Migration Hub summary only.
   */
  planMigrationSummaryViaHub: PlanMigrationPreview;
  /**
   * Fetches billing and plan data specifically for the Plan Selector.
   * This query returns only the essential data needed for plan selection and pricing display.
   */
  planSelectorData: PlanSelectorData;
  /** Fetches a post by PostID for the given organization: first and last can be set for forward pagination using Relay convention */
  post: Post;
  /** Returns the counts by channel for the given organization */
  postCounts: PostCountsResponse;
  /** Fetch one post group by id. Posts resolve lazily through PostGroup.posts. */
  postGroup: PostGroup;
  /** Fetch a single post template by ID. Returns null if not found. */
  postTemplate?: Maybe<PostTemplate>;
  /** Fetch a single post template campaign by ID. Returns null if not found. */
  postTemplateCampaign?: Maybe<PostTemplateCampaign>;
  /** List post template campaigns with optional filters and cursor-based pagination. */
  postTemplateCampaigns: PostTemplateCampaignsConnection;
  /**
   * Fetch the templates visible to the current actor for the template
   * library: public templates, plus internal templates from the supplied
   * `organizationId`, plus private templates owned by the actor's
   * account. The visibility scope is always pinned to the actor and the
   * supplied organization — the input filter can only narrow within that
   * scope, never widen it.
   */
  postTemplates: PostTemplatesConnection;
  /**
   * Calculate posting schedule preview using specified strategy without persisting changes.
   * This is a read-only operation that returns proposed changes for user review.
   *
   * Authorization: Requires canManageChannels privilege for the specified channel.
   *
   * Strategies Available:
   * - optimize: Use Buffer's research-based best times
   * - copyFromChannel: Copy schedule from another channel
   */
  postingSchedulePreview: PostingSchedulePreviewResult;
  /** Fetches posts for the given organization: first and last can be set for forward pagination using Relay convention */
  posts: PostsResults;
  /** @deprecated Use the new posts query */
  postsLegacy: PaginatedPosts;
  /**
   * Returns a paginated list of posts that have comments matching the given filters.
   * Pagination follows the Relay cursor convention (forward-only).
   */
  postsWithComments: PostsWithCommentResults;
  /**
   * Querying the plan migration preview will result into a null preview
   * if the canMigrateToOneBuffer flag is false or if the account is on a Free plan
   */
  previewPlanMigration: PlanMigrationPreviewResponse;
  /** Returns the current Insights of Buffer's own channels for anonymous callers. */
  publicInsightsSample: PublicInsightsSamplePayload;
  /**
   * Fetches Buffer-curated, publicly visible post templates. Returns only
   * `visibility: public` templates regardless of caller. Available via
   * free-tools-api (anonymous) and core-api (any authenticated actor) — the
   * marketing Template Library and any signed-in surface can both use this.
   * Complementary to `postTemplates`, which scopes to a caller's organization.
   */
  publicPostTemplates: PublicPostTemplatesResponse;
  /** Returns the push notification preferences for the current account. */
  pushNotificationPreferences: PushNotificationPreferencePayload;
  pusherAuthentication: PusherAuth;
  /**
   * Curated content recommendations for general use across the product —
   * powering the Buffer Home content carousel today, and reusable anywhere in
   * the product or via the API. v1 personalises by the services of the
   * organization's connected channels, falling back to universal evergreen items
   * when no channels are connected. The recommendation rules live behind the use
   * case so clients don't need to know how items are picked.
   */
  recommendedContent: RecommendedContentConnection;
  /** Get the recovery code for Two Factor Authentication */
  recoveryCode: TwoFactorRecoveryCodePayload;
  /** Returns referral-program state without enrolling or calling providers. */
  referralProgramStatus: ReferralProgramStatus;
  /**
   * Get an S3 pre-signed URL for the given filename and mime-type.
   * The S3 pre-signed URL can be used to directly upload the file to S3 from the client application.
   */
  s3PreSignedURL: S3PreSigneUrlResult;
  /** Returns the saved replies for a given organization */
  savedReplies: SavedRepliesResponse;
  /** Fetches all saved views for the current user in the organization */
  savedViews: SavedViewsResponse;
  schedules: SchedulesPayload;
  searchImages: ImageSearchPayload;
  /**
   * Search Instagram audio for one channel.
   * Requires Facebook Login. Instagram Login channels return ChannelRefreshRequired.
   */
  searchInstagramAudio: SearchInstagramAudioPayload;
  /**
   * Search music and original sounds in a single request.
   * Requires Facebook Login. Instagram Login channels return ChannelRefreshRequired.
   */
  searchInstagramAudioCatalog: InstagramAudioCatalogPayload;
  /**
   * Search for Threads locations that can be tagged in posts.
   * Requires at least 2 characters in the search query.
   */
  searchThreadsLocations: SearchThreadsLocationsPayload;
  /**
   * The team members the requesting account may offer for selection, ordered by
   * display name and then by account ID. Locked members are excluded from both
   * scopes. Backs the @-mention picker in Notes and is reusable for any other
   * member picker.
   *
   * The list is live rather than snapshotted, and the sort key is a display
   * name, so a member renamed while a client is paging can arrive twice or be
   * missed. Merge pages by node ID if that matters.
   */
  selectableTeamMembers: SelectableTeamMembersConnection;
  /** Retrieves a list of service tags based on the provided input. */
  serviceMentions: Array<ServiceMention>;
  /** Get Shop Grid Custom Links */
  shopGridCustomLinks: ShopGridCustomLinksPayload;
  /**
   * Fetch the public shop grid page for an Instagram username.
   *
   * Shop Grid is currently Instagram-only. The schema avoids baking
   * `instagram` into type names so the API can evolve to support other
   * services without a breaking change.
   */
  shopGridPage: ShopGridPage;
  /**
   * Returns the snippets of an organization, sorted by name. Uses
   * standard cursor pagination: pass the previous page's `pageInfo.endCursor`
   * as `after` to fetch the next page. Requesting more than 100 snippets
   * in a single page is rejected. A cursor whose snippet was deleted
   * reports a BAD_USER_INPUT error. Fetch again from the first page.
   */
  snippets: SnippetsConnection;
  startPage?: Maybe<StartPageResponse>;
  startPageBlock?: Maybe<StartPageBlock>;
  startPageTemplates?: Maybe<StartPageTemplatesResponse>;
  startPageThemes?: Maybe<StartPageThemesResponse>;
  /** @deprecated Use `startPage`. */
  startPageV2?: Maybe<StartPageResponse>;
  startPages?: Maybe<StartPagesResponse>;
  /**
   * Fetch a single tag by id.
   *
   * Resolves to null with a NOT_FOUND error when no tag has that id, and with an
   * UNAUTHORIZED error when the tag belongs to an organization the caller cannot
   * read. Both are reported in the errors array.
   *
   * This API is an early preview and can change without a deprecation period.
   */
  tag?: Maybe<Tag>;
  /**
   * Fetch all tags for the organization sorted by name in ascending order.
   *
   * This API is an early preview and can change without a deprecation period.
   * @deprecated Use `tagsV2`, which paginates. This field returns every tag in a single response, which does not scale if tag limits rise, and it cannot signal that more remain. It stays until existing clients have migrated.
   */
  tags: Array<Tag>;
  /**
   * Fetch a page of the organization's tags, sorted by name in ascending order.
   * Uses standard cursor pagination: pass the previous page's `pageInfo.endCursor`
   * as `after` to fetch the next page. Requesting more than 100 tags in a single
   * page is rejected.
   *
   * This API is an early preview and can change without a deprecation period.
   */
  tagsV2: TagsConnection;
  /**
   * Fetch *active* team members for an organization. Pending invitations
   * are surfaced separately via `pendingInvitations` — the two streams no
   * longer share the TeamMember shape.
   * Only admins can view the full team member list.
   * When pagination parameters (first, after) are omitted in the input,
   * returns all team members.
   */
  teamMembers: TeamMembersResults;
  /**
   * Fetch all team members with their per-product access for a specific channel.
   * Returns all organization members, including those with no access (all
   * productAccessLevels values are `none`).
   * Only admins can view team member channel permissions.
   */
  teamMembersForChannel: Array<TeamMemberWithChannelAccess>;
  /**
   * Dummy query for testing the new BufferAdmin actor during Retool development.
   * Will be removed later.
   */
  testAdminRestrictedQuery: Scalars['String']['output'];
  /** This query can be called to check how the server handles error reporting. It will always thrown a BufferError in the resolver. */
  testErrorReporting: Scalars['Boolean']['output'];
  /** This query can be called to check how the server handles scalar errors. */
  testScalarErrors: ScalarErrors;
  /** This query returns an array to test how the server handles scalar errors inside a list. */
  testScalarErrorsArray: Array<ScalarErrors>;
  /**
   * Fetches top-performing posts across all channels, sorted by the chosen metric.
   *
   * Follows our standard paginated query shape: `first`/`after` alongside `input`,
   * returning a Connection with `edges` + `pageInfo` + `totalCount`. Cursors are
   * opaque — internally they encode the item's absolute offset in the sorted
   * result set, which the server decodes back to offset/limit for the underlying
   * database query.
   *
   * Metric-sorted aggregation over multi-network data doesn't support seek-based
   * cursors, which is why the internal implementation is offset-based even though
   * the external contract is Relay-shaped. Clients should reset `after` to null
   * when filters or sort
   * change. If we later persist and index aggregation results, we can switch to
   * seek-based pagination without changing this contract.
   */
  topPosts: TopPostsConnection;
  /**
   * Return Meta trending Instagram audio for one channel.
   * Requires Facebook Login. Instagram Login channels return ChannelRefreshRequired.
   */
  trendingInstagramAudio: SearchInstagramAudioPayload;
  /**
   * Counts of unreplied conversations across one or more channels, for the
   * Community badge and the per-channel breakdown: conversations whose status is
   * `unreplied`. Spam and muted conversations are never counted.
   *
   * Serves counts of the mock DM conversations until DM storage lands.
   */
  unrepliedConversationCounts: UnrepliedConversationCountsResponse;
  upload?: Maybe<UploadPayload>;
  /**
   * Validate an API client name.
   * Checks minimum length, forbidden names, and uniqueness.
   */
  validateAPIClientName: ValidateApiClientNamePayload;
  /**
   * Returns the weekly posting streak for the given organization.
   * Null means, the streak widget should not be shown.
   * It checks that the actor is an owner of the organization, otherwise it returns null.
   */
  weeklyPostingStreak?: Maybe<Streak>;
  /** Returns read-only weekly posting streak history for an owned organization. */
  weeklyPostingStreakHistory: WeeklyPostingStreakHistoryConnection;
  /** Get signup settings after checking access and Channel limits. */
  whatsAppConnectionInfo: WhatsAppConnectionInfoPayload;
  /** Retrieve categories for youtube videos. Categories are hardcoded for now. */
  youtubeCategories: Array<YoutubeCategory>;
};


/** Root query type for team management operations. */
export type QueryAccountByEmailArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
};


/** Root query type for team management operations. */
export type QueryAccountByIdArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


/** Root query type for team management operations. */
export type QueryAccountByProductLinkArgs = {
  foreignKey?: InputMaybe<Scalars['String']['input']>;
  product?: InputMaybe<Product>;
};


/** Root query type for team management operations. */
export type QueryAggregatedPostMetricsArgs = {
  input: AggregatedPostMetricsInput;
};


/** Root query type for team management operations. */
export type QueryAllChannelsPostInsightsArgs = {
  input: AllChannelsPostInsightsInput;
};


/** Root query type for team management operations. */
export type QueryAnalyticsAnswersArgs = {
  endDate: Scalars['Date']['input'];
  serviceId: Scalars['String']['input'];
  serviceType: Scalars['String']['input'];
  startDate: Scalars['Date']['input'];
};


/** Root query type for team management operations. */
export type QueryAnalyticsDailiesArgs = {
  endDate: Scalars['Date']['input'];
  getPreviousPeriod?: InputMaybe<Scalars['Boolean']['input']>;
  serviceId: Scalars['String']['input'];
  serviceType: Scalars['String']['input'];
  startDate: Scalars['Date']['input'];
};


/** Root query type for team management operations. */
export type QueryAnalyticsHashtagsArgs = {
  endDate: Scalars['Date']['input'];
  serviceId: Scalars['String']['input'];
  serviceType: Scalars['String']['input'];
  startDate: Scalars['Date']['input'];
};


/** Root query type for team management operations. */
export type QueryAnalyticsPostsArgs = {
  endDate: Scalars['Date']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy: AnalyticsOrderByField;
  searchTerms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  serviceId: Scalars['String']['input'];
  serviceType: Scalars['String']['input'];
  startDate: Scalars['Date']['input'];
};


/** Root query type for team management operations. */
export type QueryAnalyticsPostsTotalsArgs = {
  endDate: Scalars['Date']['input'];
  getPreviousPeriod?: InputMaybe<Scalars['Boolean']['input']>;
  serviceId: Scalars['String']['input'];
  serviceType: Scalars['String']['input'];
  startDate: Scalars['Date']['input'];
};


/** Root query type for team management operations. */
export type QueryAnalyticsTotalsArgs = {
  endDate: Scalars['Date']['input'];
  getPreviousPeriod?: InputMaybe<Scalars['Boolean']['input']>;
  serviceId: Scalars['String']['input'];
  serviceType: Scalars['String']['input'];
  startDate: Scalars['Date']['input'];
};


/** Root query type for team management operations. */
export type QueryAnonymousMediaAccessArgs = {
  input: AnonymousMediaAccessInput;
};


/** Root query type for team management operations. */
export type QueryApiClientArgs = {
  input: ApiClientInput;
};


/** Root query type for team management operations. */
export type QueryApiClientUsageStatisticsArgs = {
  input: ApiClientUsageStatisticsInput;
};


/** Root query type for team management operations. */
export type QueryApiClientsForAccountArgs = {
  input: ApiClientsForAccountInput;
};


/** Root query type for team management operations. */
export type QueryAssignableChannelsArgs = {
  input: AssignableChannelsInput;
};


/** Root query type for team management operations. */
export type QueryBillingArgs = {
  input: BillingInput;
};


/** Root query type for team management operations. */
export type QueryBufferHomeChecklistArgs = {
  input: BufferHomeChecklistInput;
};


/** Root query type for team management operations. */
export type QueryCalendarArgs = {
  input?: InputMaybe<CalendarInput>;
};


/** Root query type for team management operations. */
export type QueryCalendarPostArgs = {
  input: CalendarPostInput;
};


/** Root query type for team management operations. */
export type QueryCanConnectChannelsArgs = {
  channels?: InputMaybe<Array<CanConnectChannelsInput>>;
};


/** Root query type for team management operations. */
export type QueryChangelogEntriesArgs = {
  input: ChangelogEntriesInput;
};


/** Root query type for team management operations. */
export type QueryChangelogEntryArgs = {
  input: ChangelogEntryInput;
};


/** Root query type for team management operations. */
export type QueryChannelArgs = {
  input: ChannelInput;
};


/** Root query type for team management operations. */
export type QueryChannelAnalyticsExportStatusArgs = {
  input: ChannelAnalyticsExportStatusInput;
};


/** Root query type for team management operations. */
export type QueryChannelAuthorizationInfoArgs = {
  input: ChannelAuthorizationInfoInput;
};


/** Root query type for team management operations. */
export type QueryChannelAuthorizationUrlArgs = {
  channelAuthorizationUrl: ChannelAuthorizationUrlInput;
};


/** Root query type for team management operations. */
export type QueryChannelBenchmarksArgs = {
  input: ChannelBenchmarksInput;
};


/** Root query type for team management operations. */
export type QueryChannelByIdArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


/** Root query type for team management operations. */
export type QueryChannelGetByServiceAndServiceIdArgs = {
  service: Scalars['String']['input'];
  serviceId: Scalars['String']['input'];
};


/** Root query type for team management operations. */
export type QueryChannelGetTemporaryCredentialsArgs = {
  service: Scalars['String']['input'];
  serviceId: Service;
};


/** Root query type for team management operations. */
export type QueryChannelGroupArgs = {
  input: ChannelGroupInput;
};


/** Root query type for team management operations. */
export type QueryChannelGroupsArgs = {
  input: ChannelGroupsInput;
};


/** Root query type for team management operations. */
export type QueryChannelTakeawaysArgs = {
  input: ChannelTakeawaysInput;
};


/** Root query type for team management operations. */
export type QueryChannelsArgs = {
  input: ChannelsInput;
};


/** Root query type for team management operations. */
export type QueryChargeByIdArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


/** Root query type for team management operations. */
export type QueryChecklistsArgs = {
  input: OrganizationIdInput;
};


/** Root query type for team management operations. */
export type QueryClientArgs = {
  input: ClientInput;
};


/** Root query type for team management operations. */
export type QueryCollaborationNotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: CollaborationNotesInput;
};


/** Root query type for team management operations. */
export type QueryCollaborationNotesReadStateArgs = {
  input: CollaborationNotesReadStateInput;
};


/** Root query type for team management operations. */
export type QueryCommentContextArgs = {
  input: CommentContextInput;
};


/** Root query type for team management operations. */
export type QueryCommentSuggestionsArgs = {
  input: CommentSuggestionsInput;
};


/** Root query type for team management operations. */
export type QueryCommentThreadArgs = {
  input: CommentThreadInput;
};


/** Root query type for team management operations. */
export type QueryCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: CommentsInput;
};


/** Root query type for team management operations. */
export type QueryCommentsConfigurationArgs = {
  input: CommentsConfigurationInput;
};


/** Root query type for team management operations. */
export type QueryCommentsCountsArgs = {
  input: CommentsCountsInput;
};


/** Root query type for team management operations. */
export type QueryCommentsCountsByPostArgs = {
  input: CommentsCountsByPostInput;
};


/** Root query type for team management operations. */
export type QueryCommentsInsightsArgs = {
  input: CommentsInsightsInput;
};


/** Root query type for team management operations. */
export type QueryCommentsOEmbedArgs = {
  input: CommentsOEmbedInput;
};


/** Root query type for team management operations. */
export type QueryCommentsScoreArgs = {
  input: CommentsScoreInput;
};


/** Root query type for team management operations. */
export type QueryCommentsScoreForChannelsArgs = {
  input: CommentsScoreForChannelsInput;
};


/** Root query type for team management operations. */
export type QueryConfigurationArgs = {
  input: ConfigurationInput;
};


/** Root query type for team management operations. */
export type QueryConnectableServicesArgs = {
  input?: InputMaybe<ConnectableServicesInput>;
};


/** Root query type for team management operations. */
export type QueryContentItemArgs = {
  input: ContentItemInput;
};


/** Root query type for team management operations. */
export type QueryContentItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: ContentItemsInput;
};


/** Root query type for team management operations. */
export type QueryContentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: ContentsInput;
};


/** Root query type for team management operations. */
export type QueryConversationMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: ConversationMessagesInput;
};


/** Root query type for team management operations. */
export type QueryConversationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: ConversationsInput;
};


/** Root query type for team management operations. */
export type QueryCrossChannelsTakeawaysArgs = {
  input: CrossChannelsTakeawaysInput;
};


/** Root query type for team management operations. */
export type QueryDailyPostingLimitsArgs = {
  input: DailyPostingLimitsInput;
};


/** Root query type for team management operations. */
export type QueryDraftsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: DraftsInput;
};


/** Root query type for team management operations. */
export type QueryEngagementConversationByIdArgs = {
  input: EngagementConversationByIdInput;
};


/** Root query type for team management operations. */
export type QueryEngagementConversationsArgs = {
  input: EngagementConversationsInput;
};


/** Root query type for team management operations. */
export type QueryEngagementCountsByChannelIdsArgs = {
  input: EngagementCountsByChannelIdsInput;
};


/** Root query type for team management operations. */
export type QueryEngagementInboxByChannelIdsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: EngagementInboxByChannelIdsInput;
};


/** Root query type for team management operations. */
export type QueryFeedArgs = {
  input: FeedInput;
};


/** Root query type for team management operations. */
export type QueryFeedCollectionArgs = {
  input: FeedCollectionInput;
};


/** Root query type for team management operations. */
export type QueryFeedCollectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: FeedCollectionsInput;
};


/** Root query type for team management operations. */
export type QueryFeedItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: FeedItemsInput;
};


/** Root query type for team management operations. */
export type QueryFeedsArgs = {
  input: FeedsInput;
};


/** Root query type for team management operations. */
export type QueryFreeToolArgs = {
  input: FreeToolInput;
};


/** Root query type for team management operations. */
export type QueryFreeToolsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: FreeToolsInput;
};


/** Root query type for team management operations. */
export type QueryGetAccessTokensForChannelArgs = {
  input: GetAccessTokensForChannelInput;
};


/** Root query type for team management operations. */
export type QueryGetAnnualUpgradePreviewInvoiceArgs = {
  input: GetAnnualUpgradePreviewInvoiceInput;
};


/** Root query type for team management operations. */
export type QueryGetCustomerIoAttributesArgs = {
  input: GetCustomerIoAttributesInput;
};


/** Root query type for team management operations. */
export type QueryGetPreviewInvoiceArgs = {
  input: GetPreviewInvoiceInput;
};


/** Root query type for team management operations. */
export type QueryGetRecommendedTimesForChannelArgs = {
  input: GetRecommendedTimesForChannelInput;
};


/** Root query type for team management operations. */
export type QueryGetThreadsMostRecentlyUsedTopicsArgs = {
  input: GetThreadsMostRecentlyUsedTopicsInput;
};


/** Root query type for team management operations. */
export type QueryGetTrendingTopicsArgs = {
  input: GetTrendingTopicsInput;
};


/** Root query type for team management operations. */
export type QueryIdeaArgs = {
  input: IdeaIdInput;
};


/** Root query type for team management operations. */
export type QueryIdeaGroupsArgs = {
  input: IdeaGroupsInput;
};


/** Root query type for team management operations. */
export type QueryIdeasArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: IdeasInput;
};


/** Root query type for team management operations. */
export type QueryIdeasCountArgs = {
  input: OrganizationIdInput;
};


/** Root query type for team management operations. */
export type QueryIdeasCountByTagArgs = {
  input: IdeasCountByTagInput;
};


/** Root query type for team management operations. */
export type QueryIdeasCountByTagsArgs = {
  input: OrganizationIdInput;
};


/** Root query type for team management operations. */
export type QueryIdeasV2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: IdeasListInputV2;
};


/** Root query type for team management operations. */
export type QueryImagesTrackDownloadArgs = {
  trackUrl?: InputMaybe<Scalars['String']['input']>;
};


/** Root query type for team management operations. */
export type QueryInstagramAudioArgs = {
  input: InstagramAudioInput;
};


/** Root query type for team management operations. */
export type QueryInstagramAudioCatalogArgs = {
  input: InstagramAudioCatalogInput;
};


/** Root query type for team management operations. */
export type QueryInstagramAudioPreviewArgs = {
  input: InstagramAudioPreviewInput;
};


/** Root query type for team management operations. */
export type QueryInvitationByTokenArgs = {
  input: InvitationByTokenInput;
};


/** Root query type for team management operations. */
export type QueryInvoicesByOrganizationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['String']['input'];
};


/** Root query type for team management operations. */
export type QueryIsNewRemindersEnabledForOrganizationArgs = {
  organizationId?: InputMaybe<Scalars['String']['input']>;
  split?: InputMaybe<Scalars['String']['input']>;
};


/** Root query type for team management operations. */
export type QueryIsSplitEnabledForOrganizationArgs = {
  organizationId?: InputMaybe<Scalars['String']['input']>;
  split?: InputMaybe<Scalars['String']['input']>;
};


/** Root query type for team management operations. */
export type QueryLinkedInPremiumPromoCodeEligibilityArgs = {
  input: LinkedInPremiumPromoCodeEligibilityInput;
};


/** Root query type for team management operations. */
export type QueryManagedPostTemplateArgs = {
  input: PostTemplateInput;
};


/** Root query type for team management operations. */
export type QueryManagedPostTemplatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: ManagedPostTemplatesInput;
};


/** Root query type for team management operations. */
export type QueryOauthScopesArgs = {
  input: OAuthScopesInput;
};


/** Root query type for team management operations. */
export type QueryOrganizationArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


/** Root query type for team management operations. */
export type QueryOrganizationActivitySummaryArgs = {
  input: OrganizationActivitySummaryInput;
};


/** Root query type for team management operations. */
export type QueryOrganizationPostingGoalsSummaryArgs = {
  input: OrganizationPostingGoalsSummaryInput;
};


/** Root query type for team management operations. */
export type QueryOrganizationReferralCodeArgs = {
  organizationId: Scalars['String']['input'];
};


/** Root query type for team management operations. */
export type QueryOrganizationsArgs = {
  input: OrganizationsInput;
};


/** Root query type for team management operations. */
export type QueryPendingInvitationsArgs = {
  input: PendingInvitationsInput;
};


/** Root query type for team management operations. */
export type QueryPersonalAccessTokenScopesArgs = {
  input: PersonalAccessTokenScopesInput;
};


/** Root query type for team management operations. */
export type QueryPlanMigrationSummaryViaHubArgs = {
  interval?: InputMaybe<BillingInterval>;
  organizationId: Scalars['String']['input'];
  plan?: InputMaybe<ObPlanId>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
};


/** Root query type for team management operations. */
export type QueryPlanSelectorDataArgs = {
  input: PlanSelectorDataInput;
};


/** Root query type for team management operations. */
export type QueryPostArgs = {
  input: PostInput;
};


/** Root query type for team management operations. */
export type QueryPostCountsArgs = {
  input: PostCountsInput;
};


/** Root query type for team management operations. */
export type QueryPostGroupArgs = {
  input: PostGroupInput;
};


/** Root query type for team management operations. */
export type QueryPostTemplateArgs = {
  input: PostTemplateInput;
};


/** Root query type for team management operations. */
export type QueryPostTemplateCampaignArgs = {
  input: PostTemplateCampaignInput;
};


/** Root query type for team management operations. */
export type QueryPostTemplateCampaignsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: PostTemplateCampaignsInput;
};


/** Root query type for team management operations. */
export type QueryPostTemplatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: PostTemplatesInput;
};


/** Root query type for team management operations. */
export type QueryPostingSchedulePreviewArgs = {
  input: PostingSchedulePreviewInput;
};


/** Root query type for team management operations. */
export type QueryPostsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: PostsInput;
};


/** Root query type for team management operations. */
export type QueryPostsLegacyArgs = {
  input: PostsLegacyInput;
};


/** Root query type for team management operations. */
export type QueryPostsWithCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: PostsWithCommentInput;
};


/** Root query type for team management operations. */
export type QueryPreviewPlanMigrationArgs = {
  organizationId: Scalars['String']['input'];
};


/** Root query type for team management operations. */
export type QueryPublicInsightsSampleArgs = {
  input: PublicInsightsSampleInput;
};


/** Root query type for team management operations. */
export type QueryPublicPostTemplatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: PublicPostTemplatesInput;
};


/** Root query type for team management operations. */
export type QueryPusherAuthenticationArgs = {
  input: PusherAuthenticationInput;
};


/** Root query type for team management operations. */
export type QueryRecommendedContentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: RecommendedContentInput;
};


/** Root query type for team management operations. */
export type QueryRecoveryCodeArgs = {
  input: TwoFactorRecoveryCodeInput;
};


/** Root query type for team management operations. */
export type QueryReferralProgramStatusArgs = {
  input: ReferralProgramStatusInput;
};


/** Root query type for team management operations. */
export type QueryS3PreSignedUrlArgs = {
  input: S3PreSignedUrlInput;
};


/** Root query type for team management operations. */
export type QuerySavedRepliesArgs = {
  input: SavedRepliesInput;
};


/** Root query type for team management operations. */
export type QuerySavedViewsArgs = {
  input: SavedViewsInput;
};


/** Root query type for team management operations. */
export type QuerySchedulesArgs = {
  input: SchedulesInput;
};


/** Root query type for team management operations. */
export type QuerySearchImagesArgs = {
  orientation?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};


/** Root query type for team management operations. */
export type QuerySearchInstagramAudioArgs = {
  input: SearchInstagramAudioInput;
};


/** Root query type for team management operations. */
export type QuerySearchInstagramAudioCatalogArgs = {
  input: SearchInstagramAudioCatalogInput;
};


/** Root query type for team management operations. */
export type QuerySearchThreadsLocationsArgs = {
  input: SearchThreadsLocationsInput;
};


/** Root query type for team management operations. */
export type QuerySelectableTeamMembersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: SelectableTeamMembersInput;
};


/** Root query type for team management operations. */
export type QueryServiceMentionsArgs = {
  input: ServiceMentionsInput;
};


/** Root query type for team management operations. */
export type QueryShopGridCustomLinksArgs = {
  input: ShopGridCustomLinksInput;
};


/** Root query type for team management operations. */
export type QueryShopGridPageArgs = {
  input: ShopGridPageInput;
};


/** Root query type for team management operations. */
export type QuerySnippetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: SnippetsInput;
};


/** Root query type for team management operations. */
export type QueryStartPageArgs = {
  organizationId: Scalars['String']['input'];
  pageId?: InputMaybe<Scalars['String']['input']>;
};


/** Root query type for team management operations. */
export type QueryStartPageBlockArgs = {
  blockId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};


/** Root query type for team management operations. */
export type QueryStartPageV2Args = {
  organizationId: Scalars['String']['input'];
};


/** Root query type for team management operations. */
export type QueryStartPagesArgs = {
  organizationId: Scalars['String']['input'];
};


/** Root query type for team management operations. */
export type QueryTagArgs = {
  input: TagByIdInput;
};


/** Root query type for team management operations. */
export type QueryTagsArgs = {
  input: TagsInput;
};


/** Root query type for team management operations. */
export type QueryTagsV2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: TagsInput;
};


/** Root query type for team management operations. */
export type QueryTeamMembersArgs = {
  input: TeamMembersInput;
};


/** Root query type for team management operations. */
export type QueryTeamMembersForChannelArgs = {
  input: TeamMembersForChannelInput;
};


/** Root query type for team management operations. */
export type QueryTestAdminRestrictedQueryArgs = {
  email: Scalars['String']['input'];
};


/** Root query type for team management operations. */
export type QueryTopPostsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: TopPostsInput;
};


/** Root query type for team management operations. */
export type QueryTrendingInstagramAudioArgs = {
  input: TrendingInstagramAudioInput;
};


/** Root query type for team management operations. */
export type QueryUnrepliedConversationCountsArgs = {
  input: UnrepliedConversationCountsInput;
};


/** Root query type for team management operations. */
export type QueryUploadArgs = {
  input: UploadIdInput;
};


/** Root query type for team management operations. */
export type QueryValidateApiClientNameArgs = {
  input: ValidateApiClientNameInput;
};


/** Root query type for team management operations. */
export type QueryWeeklyPostingStreakArgs = {
  input: WeeklyPostingStreakInput;
};


/** Root query type for team management operations. */
export type QueryWeeklyPostingStreakHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: WeeklyPostingStreakHistoryInput;
};


/** Root query type for team management operations. */
export type QueryWhatsAppConnectionInfoArgs = {
  input: WhatsAppConnectionInfoInput;
};

/** Target position within a channel's queue that a post can be moved to. */
export enum QueuePosition {
  /** Move the post to the bottom of the queue, taking the last slot. */
  Bottom = 'bottom',
  /** Move the post to the top of the queue, taking the next available slot. */
  Top = 'top'
}

/** Create an RSS/Atom Feed by url */
export type RssAtomFeedCreationInput = {
  /** The url of the RSS/Atom feed */
  url: Scalars['String']['input'];
};

/** Connection metadata for RSS feeds */
export type RssFeedConnectionMetadata = {
  __typename?: 'RSSFeedConnectionMetadata';
  /** The last time we connected to the RSS feed */
  lastConnected: Scalars['DateTime']['output'];
  /** The URL of the RSS feed */
  url: Scalars['String']['output'];
};

/** The change to make to the current account's reaction. */
export enum ReactToCollaborationNoteAction {
  /** Add the reaction. */
  Add = 'add',
  /** Remove the reaction. */
  Remove = 'remove'
}

/** The reaction to add to or remove from a collaboration Note. */
export type ReactToCollaborationNoteInput = {
  /** Whether to add or remove the reaction. */
  action: ReactToCollaborationNoteAction;
  /** Exactly one emoji. */
  emoji: Scalars['String']['input'];
  /** The Note ID. */
  noteId: Scalars['NoteId']['input'];
};

/** The possible results from a collaboration Note reaction change. */
export type ReactToCollaborationNotePayload = InvalidInputError | LimitReachedError | ReactToCollaborationNoteSuccess;

/** The result of a successful collaboration Note reaction change. */
export type ReactToCollaborationNoteSuccess = {
  __typename?: 'ReactToCollaborationNoteSuccess';
  /** The Note with its updated reactions. */
  note: CollaborationNote;
};

/**
 * Input type for the `reactToComment` mutation.
 * Defines the comment being reacted to.
 */
export type ReactToCommentInput = {
  /** ID of the comment being reacted to. */
  commentId: Scalars['CommentId']['input'];
  /** Whether to add (true) or remove (false) the reaction. */
  isActiveReaction: Scalars['Boolean']['input'];
  /**
   * The type of reaction to apply. Optional — defaults to like when not provided.
   * Only supported for LinkedIn comments; other services will reject non-like reaction types.
   */
  reactionType?: InputMaybe<ReactionType>;
};

/** Mutation Response: Success and errors for reactToComment */
export type ReactToCommentPayload = InvalidInputError | NotFoundError | ReactToCommentSuccess | UnauthorizedError | UnexpectedError;

/** Successful reaction response. */
export type ReactToCommentSuccess = {
  __typename?: 'ReactToCommentSuccess';
  /** The comment that was successfully reacted to. */
  comment: CommentData;
};

/** Input for the reactToEngagement mutation. */
export type ReactToEngagementInput = {
  /** Whether to add or remove the reaction. */
  action: ReactionAction;
  /** Unique identifier of the engagement to react to. */
  engagementId: Scalars['EngagementId']['input'];
  /** Type of engagement to react to (mention or comment). */
  engagementType: EngagementType;
  /**
   * The type of reaction to apply. Non-like reaction types are rejected on
   * networks without multi-reaction support.
   */
  reactionType: ReactionType;
};

/** Result of the reactToEngagement mutation. */
export type ReactToEngagementPayload = ReactToEngagementSuccess | VoidMutationError;

/** Returned when the reaction was successfully applied or removed. */
export type ReactToEngagementSuccess = {
  __typename?: 'ReactToEngagementSuccess';
  /** The engagement item updated with the reaction change. */
  engagement: Engagement;
};

/** Represents a reaction on a comment. */
export type Reaction = {
  __typename?: 'Reaction';
  /** The type of reaction (e.g., like). */
  type: ReactionType;
};

/** The action to perform on a reaction when reacting to an engagement. */
export enum ReactionAction {
  /** Add the reaction. */
  Add = 'add',
  /** Remove the reaction. */
  Remove = 'remove'
}

/** Channel-specific reaction configuration — always an array of supported reactions. */
export type ReactionConfiguration = {
  __typename?: 'ReactionConfiguration';
  /** The reactions supported by the channel. */
  supportedReactions: Array<SupportedReaction>;
};

/** Standard reaction icon set used by `IconVisual`. Grows additively. */
export enum ReactionIcon {
  Heart = 'heart',
  Star = 'star',
  ThumbsUp = 'thumbsUp'
}

/** Types of reactions that can be applied to a comment. */
export enum ReactionType {
  /** A celebrate reaction. Supported only for LinkedIn comments. */
  Celebrate = 'celebrate',
  /** An external reaction on the comment, using an external link. */
  External = 'external',
  /** A funny reaction. Supported only for LinkedIn comments. */
  Funny = 'funny',
  /** An insightful reaction. Supported only for LinkedIn comments. */
  Insightful = 'insightful',
  /** A like reaction on the comment. */
  Like = 'like',
  /** A love reaction. Supported only for LinkedIn comments. */
  Love = 'love',
  /** A support reaction. Supported only for LinkedIn comments. */
  Support = 'support'
}

/**
 * How to render a reaction. The client switches on `__typename` purely as a
 * render strategy (built-in icon vs network image) — never on the network or the
 * reaction identity.
 */
export type ReactionVisual = IconVisual | ImageVisual;

/**
 * Reactions configuration. `restingIcon` is always populated; `supportedReactions`
 * empty = reacting via Buffer isn't supported, one = single-button liking, multiple
 * = a reaction set.
 */
export type ReactionsConfiguration = {
  __typename?: 'ReactionsConfiguration';
  /**
   * Whether reacting needs an OAuth scope beyond the ones a base connection
   * grants. When true, check the channel's `engagementReaction` entry in
   * `authorizationStatus` before offering the reaction — the channel may need a
   * reconnect to grant it. On the service-level catalog this is channel-agnostic
   * and may overstate the requirement, since it can vary with a channel's login
   * flow; the per-channel configuration resolves it exactly.
   */
  requiresAuthorization: Scalars['Boolean']['output'];
  /** The resting-state icon — the pre-reaction icon. */
  restingIcon: ReactionIcon;
  /** The reactions the user can apply. Empty when reacting via Buffer isn't supported. */
  supportedReactions: Array<EngagementSupportedReaction>;
};

/** A paginated connection of recommended content items. */
export type RecommendedContentConnection = {
  __typename?: 'RecommendedContentConnection';
  /** The list of recommended content edges. */
  edges: Array<RecommendedContentEdge>;
  /** Pagination information for the connection. */
  pageInfo: PaginationPageInfo;
  /**
   * Total number of items matching the request (after personalisation and
   * any content-type filter).
   */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a recommended content connection. */
export type RecommendedContentEdge = {
  __typename?: 'RecommendedContentEdge';
  /** Opaque cursor for pagination. */
  cursor: Scalars['String']['output'];
  /** The recommended content node at the end of the edge. */
  node: RecommendedContentItem;
};

/** Input for `Query.recommendedContent`. */
export type RecommendedContentInput = {
  /**
   * Optional include list of content types. When omitted, all supported
   * content types are returned.
   */
  contentTypes?: InputMaybe<Array<RecommendedContentType>>;
  /** The organization whose connected channels drive the personalisation. */
  organizationId: Scalars['OrganizationId']['input'];
};

/**
 * A single curated content recommendation for general use — surfaced on the
 * Buffer Home page today, and intended to be reused anywhere in the product or
 * via the API. The same type covers all content kinds (blog post, YouTube
 * video, etc.) — clients can key off `contentType` to render the right card.
 */
export type RecommendedContentItem = {
  __typename?: 'RecommendedContentItem';
  /**
   * When the recommended content itself was published (the blog post or video,
   * not this catalog row). Stored as a UTC calendar date. `null` when the
   * editor did not provide one.
   */
  contentPublishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Kind of content being recommended. Drives card rendering. */
  contentType: RecommendedContentType;
  /** Optional short description rendered alongside the title. */
  description?: Maybe<Scalars['String']['output']>;
  /** Stable identifier of the catalog row. */
  id: Scalars['ID']['output'];
  /**
   * Thumbnail URL for the recommendation. Always populated: when an editorial
   * item has no thumbnail of its own, the API substitutes a content-type
   * default so clients never have to reimplement the fallback.
   */
  thumbnailUrl: Scalars['String']['output'];
  /** Display title. */
  title: Scalars['String']['output'];
  /** External URL to open when the card is clicked. */
  url: Scalars['String']['output'];
};

/**
 * Kind of content surfaced through `recommendedContent`. New values are added
 * when editorial coverage expands; clients should handle unknown values
 * gracefully.
 */
export enum RecommendedContentType {
  BlogPost = 'blogPost',
  YoutubeVideo = 'youtubeVideo'
}

/** Recommended time to post for a channel */
export type RecommendedTime = {
  __typename?: 'RecommendedTime';
  /** Engagement Factor of the Recommended time */
  engagementFactor: Scalars['Float']['output'];
  /** Reason for the Recommended time */
  reason: Scalars['String']['output'];
  /** Recommended time for a channel */
  time: Scalars['DateTime']['output'];
};

/** Provides the native sharing URL and bounded summary for an enrollee. */
export type ReferralProgramEnrolled = {
  __typename?: 'ReferralProgramEnrolled';
  /** Friends whose signup was attributed to this participant, counted without a cap. */
  referralSummary: ReferralProgramReferralSummary;
  /** Buffer-owned URL that customers copy or share. */
  referralUrl: Scalars['String']['output'];
  /** Aggregate reward state, bounded by the participant's policy cap. */
  rewardSummary: ReferralProgramRewardSummary;
  /** Whether the URL can currently accept new referrals. */
  sharingStatus: ReferralProgramSharingStatus;
  /** Offer terms frozen under the participant's policy version. */
  terms: ReferralProgramTerms;
};

/** Friends whose signup was attributed to an enrolled participant. */
export type ReferralProgramReferralSummary = {
  __typename?: 'ReferralProgramReferralSummary';
  /** Attributed signups, including friends who already paid. */
  joinedCount: Scalars['Int']['output'];
  /** Unpaid attributed friends whose referral trial is inside its frozen length. A friend who cancels the trial still counts until that length ends. */
  trialingCount: Scalars['Int']['output'];
};

/** Small reward aggregate for an enrolled participant. */
export type ReferralProgramRewardSummary = {
  __typename?: 'ReferralProgramRewardSummary';
  /** Rewards already credited to the organization. */
  grantedCount: Scalars['Int']['output'];
  /** Rewards still validating or ready for delivery. */
  inProgressCount: Scalars['Int']['output'];
  /** Earliest expiry among rewards that need an eligible paid web plan. */
  nextExpiryAt?: Maybe<Scalars['DateTime']['output']>;
  /** Consumed cap slots whose reward is missing or already settled and waits for slot release. */
  reconcilingCount: Scalars['Int']['output'];
  /** Additional rewards available under the participant's policy cap. */
  remainingCount: Scalars['Int']['output'];
  /** Earned rewards that need an eligible paid web plan. */
  waitingForBillingCount: Scalars['Int']['output'];
};

/** Whether an existing participant's URL can currently accept new referrals. */
export enum ReferralProgramSharingStatus {
  /** The URL can accept eligible new referrals. */
  Available = 'available',
  /** The participant is no longer active. */
  ParticipantDeactivated = 'participantDeactivated',
  /** The referral program is not accepting referrals. */
  ProgramDisabled = 'programDisabled'
}

/** Customer-visible referral-program state for one organization. */
export type ReferralProgramStatus = ReferralProgramEnrolled | ReferralProgramUnavailable | ReferralProgramUnenrolled;

/** Selects the organization whose referral-program state is requested. */
export type ReferralProgramStatusInput = {
  /** Organization the authenticated account must be allowed to view. */
  organizationId: Scalars['OrganizationId']['input'];
};

/** Published offer terms shown before and after enrollment. */
export type ReferralProgramTerms = {
  __typename?: 'ReferralProgramTerms';
  /** Maximum number of rewards this participant can receive. */
  maxRewards: Scalars['Int']['output'];
  /** Policy version that defines these terms. */
  policyVersion: Scalars['String']['output'];
  /** Trial length offered to an eligible referred customer. */
  refereeTrialDays: Scalars['Int']['output'];
  /** Fixed referrer reward in the currency's minor unit. */
  rewardAmountInMinorUnits: Scalars['Int']['output'];
  /** ISO 4217 currency code for the referrer reward. */
  rewardCurrency: Scalars['String']['output'];
};

/** Signals that the organization cannot enroll in the referral program. */
export type ReferralProgramUnavailable = {
  __typename?: 'ReferralProgramUnavailable';
  /** Generic customer-safe explanation of the unavailable state. */
  message: Scalars['String']['output'];
};

/** Indicates that the organization can explicitly enroll. */
export type ReferralProgramUnenrolled = {
  __typename?: 'ReferralProgramUnenrolled';
  /** Offer terms that will be frozen when the organization enrolls. */
  terms: ReferralProgramTerms;
};

/** Input for regenerating takeaway cards for a channel. */
export type RefreshChannelTakeawaysInput = {
  /** The channel whose takeaways should be regenerated. */
  channelId: Scalars['ChannelId']['input'];
  /** The organization the channel belongs to. */
  organizationId: Scalars['OrganizationId']['input'];
};

/**
 * Result of refreshing channel takeaways. Returns freshly generated cards
 * on success, or an error when the input is invalid.
 */
export type RefreshChannelTakeawaysPayload = InvalidInputError | RefreshChannelTakeawaysSuccess;

/** Newly generated takeaways returned after a successful refresh. */
export type RefreshChannelTakeawaysSuccess = {
  __typename?: 'RefreshChannelTakeawaysSuccess';
  /** The freshly generated takeaways for the channel. */
  takeaways: Array<Takeaway>;
};

/** Input for regenerating the scoped takeaway cards for a channel selection. */
export type RefreshCrossChannelsTakeawaysInput = {
  /** The channels in the current All Channels selection. */
  channelIds: Array<Scalars['ChannelId']['input']>;
  /** The organization that owns the channels. */
  organizationId: Scalars['OrganizationId']['input'];
};

/** Result of refreshing scoped takeaway cards for a channel selection. */
export type RefreshCrossChannelsTakeawaysPayload = InvalidInputError | RefreshCrossChannelsTakeawaysSuccess;

/** The curated takeaway cards returned after a successful scoped refresh. */
export type RefreshCrossChannelsTakeawaysSuccess = {
  __typename?: 'RefreshCrossChannelsTakeawaysSuccess';
  /** The refreshed scoped cards mixed with unchanged channel cards. */
  takeaways: Array<Takeaway>;
};

/** Input for refreshing a single feed collection. */
export type RefreshFeedCollectionInput = {
  /** The ID of the feed collection to refresh. */
  feedCollectionId: Scalars['FeedCollectionId']['input'];
  /** The organization that the feed collection belongs to. */
  organizationId: Scalars['OrganizationId']['input'];
};

/** All possible response types for the refreshFeedCollection mutation. */
export type RefreshFeedCollectionPayload = FeedCollectionActionSuccess | NotFoundError | UnauthorizedError | UnexpectedError;

/** Input for refreshing a single feed. */
export type RefreshFeedInput = {
  /** The ID of the feed to refresh. */
  feedId: Scalars['FeedId']['input'];
  /** The organization that the feed belongs to. */
  organizationId: Scalars['OrganizationId']['input'];
};

/** All possible response types for the refreshFeed mutation. */
export type RefreshFeedPayload = FeedActionSuccess | FeedConnectionError | NotFoundError | UnauthorizedError | UnexpectedError;

/** Input for registerAPIClient mutation */
export type RegisterApiClientInput = {
  /** AccountId to which the API Client is tied */
  accountId?: InputMaybe<Scalars['AccountId']['input']>;
  /** The name of the API Client. */
  clientName: Scalars['String']['input'];
  /**
   * Whether this client is a public client (no client secret).
   * Public clients use PKCE for security instead of a client secret.
   * Defaults to false if not provided.
   */
  isPublicClient?: InputMaybe<Scalars['Boolean']['input']>;
  /** The logo URI for the API Client */
  logoUri?: InputMaybe<Scalars['String']['input']>;
  /** The privacy policy URI for the API Client */
  privacyPolicyUri?: InputMaybe<Scalars['String']['input']>;
  /** The uris to redirect to after authentication */
  redirectUris: Array<Scalars['String']['input']>;
  /** The scopes to request for */
  scopes?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** All possible response types that can be returned by registerAPIClient mutation. */
export type RegisterApiClientPayload = InvalidRedirectUrisError | LimitReachedError | NotFoundError | RegisterApiClientSuccess;

/** Successful response for registerAPIClient mutation */
export type RegisterApiClientSuccess = {
  __typename?: 'RegisterAPIClientSuccess';
  /** The newly registered API Client */
  client: ApiClient;
};

/** Reject approval request. */
export type RejectPostInput = {
  /** Post id to reject approval request. */
  id: Scalars['PostId']['input'];
};

/** Reject approval request response payload. */
export type RejectPostPayload = NotFoundError | PostActionSuccess | RestProxyError | UnauthorizedError | UnexpectedError;

/** Input for the removeAccount mutation */
export type RemoveAccountInput = {
  /** The password to be used to authorize deleting account */
  password?: InputMaybe<Scalars['String']['input']>;
  /** reason for the account to be deleted */
  reason?: InputMaybe<AccountDeletedReason>;
};

/** removeAccount response payload */
export type RemoveAccountPayload = InvalidInputError | NotFoundError | RemoveAccountSuccess | UnauthorizedError | UnexpectedError;

/** success response for removeAccount mutation */
export type RemoveAccountSuccess = MutationSuccess & {
  __typename?: 'RemoveAccountSuccess';
  /**
   * The value is always an empty string ''
   * Note: GraphQL doesn't allow types with no fields, so we have to add this field
   */
  _empty: Scalars['String']['output'];
};

/** input for removeLegacyGlobalFeatureFlip mutation. */
export type RemoveLegacyGlobalFeatureFlipInput = {
  /** Account id to remove feature flip from. */
  accountId: Scalars['AccountId']['input'];
  /** Feature flip to remove. */
  featureFlip: Scalars['String']['input'];
};

/** removeLegacyGlobalFeatureFlip response payload. */
export type RemoveLegacyGlobalFeatureFlipPayload = InvalidInputError | NotFoundError | RemoveLegacyGlobalFeatureFlipSuccess | UnexpectedError;

/** removeLegacyGlobalFeatureFlip success response. */
export type RemoveLegacyGlobalFeatureFlipSuccess = MutationSuccess & {
  __typename?: 'RemoveLegacyGlobalFeatureFlipSuccess';
  /**
   * The value is always an empty string ''
   * Note: GraphQL doesn't allow types with no fields, so we have to add this field
   */
  _empty: Scalars['String']['output'];
};

/** Input for removePostFromContentItem. */
export type RemovePostFromContentItemInput = {
  /** The content item to remove the post from. */
  id: Scalars['ContentItemId']['input'];
  /** The post to remove from a content item. */
  postId: Scalars['PostId']['input'];
};

/** All possible responses for removePostFromContentItem. */
export type RemovePostFromContentItemPayload = RemovePostFromContentItemSuccess | VoidMutationError;

/** Successful removePostFromContentItem response. */
export type RemovePostFromContentItemSuccess = {
  __typename?: 'RemovePostFromContentItemSuccess';
  /** The content item after the post left it. */
  contentItem: ContentItem;
  /** The post after the mutation removed it. It belongs to no content item. */
  post: Post;
};

/** Remove post's scheduled time request input. */
export type RemovePostScheduledTimeInput = {
  /** ID of post to update */
  id: Scalars['PostId']['input'];
};

/** Remove post's scheduled time response payload. */
export type RemovePostScheduledTimePayload = PostActionSuccess | RestProxyError | UnauthorizedError | UnexpectedError;

/** Returned when removing a scheduled subscription update fails. */
export type RemoveSubscriptionScheduleError = MutationError & {
  __typename?: 'RemoveSubscriptionScheduleError';
  /** Human-readable error message. */
  message: Scalars['String']['output'];
};

/** Result of removing a scheduled subscription update. */
export type RemoveSubscriptionSchedulePayload = RemoveSubscriptionScheduleError | RemoveSubscriptionScheduleResponse;

/** The successful response of removing a scheduled subscription update. */
export type RemoveSubscriptionScheduleResponse = {
  __typename?: 'RemoveSubscriptionScheduleResponse';
  /** Whether the scheduled subscription update was removed successfully. */
  success: Scalars['Boolean']['output'];
};

/** Input for removing a team member */
export type RemoveTeamMemberInput = {
  /** The Account ID of the team member to remove */
  accountId: Scalars['AccountId']['input'];
  /** The organization ID */
  organizationId: Scalars['OrganizationId']['input'];
};

/** Result of removing a team member. */
export type RemoveTeamMemberPayload = CannotRemoveOwnerError | EmptySuccess | LastAdminError | NotFoundError;

/** The input for the ReorderPosts mutation. */
export type ReorderPostsInput = {
  /** Channel ID for the posts to reorder. */
  channelId: Scalars['ChannelId']['input'];
  /** Ordered collection of Post IDs. */
  ids: Array<Scalars['PostId']['input']>;
};

/** ReorderPosts response payload */
export type ReorderPostsPayload = NotFoundError | ReorderPostsSuccess | RestProxyError | UnauthorizedError | UnexpectedError;

/** The ReorderPosts success response. */
export type ReorderPostsSuccess = {
  __typename?: 'ReorderPostsSuccess';
  /** Ordered collection of Post IDs. */
  ids: Array<Scalars['PostId']['output']>;
};

/** Input for reordering saved views */
export type ReorderSavedViewsInput = {
  /** The organization the saved views belong to */
  organizationId: Scalars['OrganizationId']['input'];
  /** Complete ordered list of saved view IDs */
  viewIds: Array<Scalars['SavedViewId']['input']>;
};

/** Reorder Saved Views Payload: Success and errors */
export type ReorderSavedViewsPayload = InvalidInputError | SavedViewsResponse;

/**
 * Input type for the `replyComment` mutation.
 * Defines the comment being replied to and the reply content.
 */
export type ReplyToCommentInput = {
  /** Id of the comment being replied to. */
  commentId: Scalars['CommentId']['input'];
  /** The content of the reply, currently only text is supported. */
  reply: ReplyToContent;
};

/** Mutation Reply To Comment Response: Success and errors */
export type ReplyToCommentPayload = InvalidInputError | NotFoundError | ReplyToCommentSuccess | UnauthorizedError | UnexpectedError;

/** Successful reply response to reply to comment */
export type ReplyToCommentSuccess = {
  __typename?: 'ReplyToCommentSuccess';
  /** The reply comment that was successfully sent to the service. */
  comment: CommentData;
};

/** The content of a reply. */
export type ReplyToContent = {
  /** The text content of the reply. */
  text: Scalars['String']['input'];
};

/** The content of a conversation reply. Text only for now. */
export type ReplyToConversationContentInput = {
  /** Text of the reply. */
  text: Scalars['String']['input'];
};

/** Input for the replyToConversation mutation. */
export type ReplyToConversationInput = {
  /**
   * Idempotency key, generated by the client per composed reply and sent again
   * on every retry of it. A retry with the same key returns the stored reply
   * instead of sending it twice.
   */
  clientRef: Scalars['String']['input'];
  /** What to send. */
  content: ReplyToConversationContentInput;
  /** Conversation to reply to. */
  conversationId: Scalars['ConversationId']['input'];
  /**
   * Message in the conversation this reply responds to. Only on networks that
   * support replying to a specific message (see the conversations
   * configuration); elsewhere the reply is rejected, never sent without it.
   */
  messageId?: InputMaybe<Scalars['EngagementId']['input']>;
};

/**
 * Result of the replyToConversation mutation. `ChannelRefreshRequired`: the
 * channel must be reconnected. `InvalidInputError`: the text, the `messageId`, or
 * a network without DMs. A conversation that does not exist is returned in the
 * errors array as `NOT_FOUND`.
 */
export type ReplyToConversationPayload = ChannelRefreshRequired | ConversationChannelPermissionError | ConversationReplySendFailedError | ConversationReplyWindowClosedError | InvalidInputError | ReplyToConversationSuccess | VoidMutationError;

/** Returned when the network accepted the reply. */
export type ReplyToConversationSuccess = {
  __typename?: 'ReplyToConversationSuccess';
  /** The conversation after the reply. */
  conversation: Conversation;
  /** The reply as stored. */
  conversationMessage: ConversationMessage;
};

/** Input for the replyToEngagement mutation. */
export type ReplyToEngagementInput = {
  /** Unique identifier of the engagement to reply to. */
  engagementId: Scalars['EngagementId']['input'];
  /** Type of engagement to reply to (mention or comment). */
  engagementType: EngagementType;
  /** Text content of the reply. */
  text: Scalars['String']['input'];
};

/** Result of the replyToEngagement mutation. */
export type ReplyToEngagementPayload = ReplyToEngagementSuccess | VoidMutationError;

/** Returned when the reply was successfully published. */
export type ReplyToEngagementSuccess = {
  __typename?: 'ReplyToEngagementSuccess';
  /** The engagement item updated with replied status. */
  engagement: Engagement;
};

/**
 * A network-imposed window after which we can no longer reply. There is no
 * `canReply` boolean: the client compares `expiresAt` to its own clock.
 */
export type ReplyWindow = {
  __typename?: 'ReplyWindow';
  /** When the window closes. Null while the counterpart has never written. */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
};

/**
 * Reply configuration for an engagement type. A rich object (not a bare boolean)
 * so reply metadata can be added later.
 */
export type ReplyingConfiguration = {
  __typename?: 'ReplyingConfiguration';
  /** Whether replies should be prefixed with the author's @mention. */
  prefixReplyWithMention: Scalars['Boolean']['output'];
  /** Whether replying to this engagement type via Buffer is supported. */
  supportsReplying: Scalars['Boolean']['output'];
};

/** Request post approval mutation. */
export type RequestPostApprovalInput = {
  /** Post id to request approval. */
  id: Scalars['PostId']['input'];
};

/** Request post approval possible responses. */
export type RequestPostApprovalPayload = NotFoundError | PostActionSuccess | RestProxyError | UnauthorizedError | UnexpectedError;

/** `property` requires all of `requires` to also be present. */
export type RequiresRule = ValidationRule & {
  __typename?: 'RequiresRule';
  /** The content property this rule constrains. */
  property: ContentProperty;
  /** Properties that must also be present when `property` is used. */
  requires: Array<ContentProperty>;
};

/**
 * Input for resending a pending invitation.
 *
 * `organizationId` is intentionally omitted (see `RevokeInvitationInput`).
 */
export type ResendInvitationInput = {
  /** The invitation to resend. */
  invitationId: Scalars['InvitationId']['input'];
};

/** Result of resending a pending invitation. */
export type ResendInvitationPayload = NotFoundError | ResendInvitationSuccess;

/**
 * Success payload for resending an invitation. Returns the updated
 * `Invitation` so the admin UI can refresh `expiresAt` in place.
 */
export type ResendInvitationSuccess = {
  __typename?: 'ResendInvitationSuccess';
  /** The resent invitation with its refreshed expiry. */
  invitation: Invitation;
};

/** Input for the resendLoginVerification mutation */
export type ResendLoginVerificationNotificationInput = {
  /** Account id to resend the login verification notification to. */
  accountId: Scalars['AccountId']['input'];
  /** Method for sending the login verification notification */
  via: LoginVerificationMethod;
};

/** resendLoginVerification response payload */
export type ResendLoginVerificationNotificationPayload = EmptySuccess | VoidMutationError;

/** Input for resetAPIClientUsage mutation */
export type ResetApiClientUsageInput = {
  /** The ID of the API Client whose usage counters should be reset */
  clientId: Scalars['String']['input'];
};

/** Response for resetAPIClientUsage mutation */
export type ResetApiClientUsagePayload = NotFoundError | ResetApiClientUsageSuccess;

/** Successful response for resetAPIClientUsage mutation */
export type ResetApiClientUsageSuccess = {
  __typename?: 'ResetAPIClientUsageSuccess';
  /** The client ID whose usage was reset */
  clientId: Scalars['String']['output'];
};

/** Input for the resetOnboardingFlow mutation. */
export type ResetOnboardingFlowInput = {
  /** The organization to reset onboarding for. */
  organizationId: Scalars['OrganizationId']['input'];
};

/** Payload returned by the resetOnboardingFlow mutation. */
export type ResetOnboardingFlowPayload = ResetOnboardingFlowResponse | VoidMutationError;

/** Successful result of resetting an onboarding flow. */
export type ResetOnboardingFlowResponse = {
  __typename?: 'ResetOnboardingFlowResponse';
  /** Whether the onboarding was successfully reset. */
  success: Scalars['Boolean']['output'];
};

/** Input for the resolveConversation mutation. */
export type ResolveConversationInput = {
  /** Conversation to resolve. */
  conversationId: Scalars['ConversationId']['input'];
};

/** Result of the resolveConversation mutation. */
export type ResolveConversationPayload = ConversationMutationSuccess | VoidMutationError;

/** Basic mutation response */
export type Response = {
  __typename?: 'Response';
  success: Scalars['Boolean']['output'];
};

/**
 * An error passed through from Buffer's legacy REST API.
 *
 * **On the way out.** This type exists only because some mutations still forward
 * to that API. It is never returned by the tag mutations, and will be removed from
 * their payloads. The post mutations can still return it, so keep handling it
 * there for now.
 *
 * Do not select it in new operations. Select `... on MutationError { message }`
 * instead, which every error type implements and which keeps working when this one
 * goes away.
 */
export type RestProxyError = MutationError & {
  __typename?: 'RestProxyError';
  /**
   * Error code from the REST API response - https://buffer.com/developers/api/errors
   * @deprecated Being retired along with Buffer's legacy REST API. Select `... on MutationError { message }` to handle errors generically, or the specific recoverable error members of the payload.
   */
  code?: Maybe<Scalars['Int']['output']>;
  /**
   * Link to our Help center from the REST API response
   * @deprecated Being retired along with Buffer's legacy REST API. Select `... on MutationError { message }` to handle errors generically, or the specific recoverable error members of the payload.
   */
  link?: Maybe<Scalars['String']['output']>;
  /**
   * An error message from the REST API response that we proxied here
   * @deprecated Being retired along with Buffer's legacy REST API. Select `... on MutationError { message }` to handle errors generically, or the specific recoverable error members of the payload.
   */
  message: Scalars['String']['output'];
};

/** Information about the initial Tweet that was retweeted */
export type RetweetMetadata = ScrapedLink & {
  __typename?: 'RetweetMetadata';
  /** Date when the original tweet was created */
  createdAt: Scalars['DateTime']['output'];
  /** Retweet ID */
  id: Scalars['String']['output'];
  /** Text of the original tweet */
  text: Scalars['String']['output'];
  /** Thumbnails to media available in the link */
  thumbnails: Array<Scalars['String']['output']>;
  /** Link to original tweet */
  url: Scalars['String']['output'];
  /** User who created the original tweet */
  user: RetweetUserMetadata;
};

/** Information about the initial Tweet that was retweeted */
export type RetweetMetadataInput = {
  /** Optional user comment shown above the embedded retweet */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Retweet ID */
  id: Scalars['String']['input'];
};

/** Information about the initial author of the Tweet that was retweeted */
export type RetweetUserMetadata = {
  __typename?: 'RetweetUserMetadata';
  /** Avatar of the user who created the original Tweet */
  avatar: Scalars['String']['output'];
  /** Name of the user who created the original Tweet */
  name: Scalars['String']['output'];
  /** Username of the user who created the original Tweet */
  username: Scalars['String']['output'];
};

/** Revert approval request mutation. */
export type RevertPostApprovalRequestInput = {
  /** Post id to revert approval request. */
  id: Scalars['PostId']['input'];
};

/** Revert approval request possible responses. */
export type RevertPostApprovalRequestPayload = NotFoundError | PostActionSuccess | RestProxyError | UnauthorizedError | UnexpectedError;

/** Input for the revokeAccessConnectedApp mutation */
export type RevokeAccessConnectedAppInput = {
  /** The id of the connectedApp to revoke access for. */
  clientId: Scalars['ID']['input'];
};

/** The payload for the revokeAccessConnectedApp mutation */
export type RevokeAccessConnectedAppPayload = EmptySuccess | UnexpectedError;

/** Input for revokeClientPersonalAccessTokens mutation */
export type RevokeClientPersonalAccessTokensInput = {
  /** The client ID for which to revoke all tokens */
  clientId: Scalars['String']['input'];
};

/** Response for revokeClientPersonalAccessTokens mutation */
export type RevokeClientPersonalAccessTokensPayload = NotFoundError | RevokeClientPersonalAccessTokensSuccess;

/** Success response for revokeClientPersonalAccessTokens mutation */
export type RevokeClientPersonalAccessTokensSuccess = {
  __typename?: 'RevokeClientPersonalAccessTokensSuccess';
  /** Number of tokens that were revoked */
  revokedCount: Scalars['Int']['output'];
};

/**
 * Input for revoking a pending invitation.
 *
 * `organizationId` is intentionally omitted — the framework resolves it
 * from the invitation document so we can't accidentally cross-route to
 * another org.
 */
export type RevokeInvitationInput = {
  /** The invitation to revoke. */
  invitationId: Scalars['InvitationId']['input'];
};

/** Result of revoking a pending invitation. */
export type RevokeInvitationPayload = EmptySuccess | NotFoundError;

/** Input for revokePersonalAccessToken mutation */
export type RevokePersonalAccessTokenInput = {
  /** Access token */
  accessToken: Scalars['String']['input'];
};

/** Response for revokePersonalAccessToken mutation */
export type RevokePersonalAccessTokenPayload = InvalidInputError | RevokePersonalAccessTokenSuccess;

/** Success response for revokePersonalAccessToken */
export type RevokePersonalAccessTokenSuccess = {
  __typename?: 'RevokePersonalAccessTokenSuccess';
  /** Boolean value to represent token status */
  active: Scalars['Boolean']['output'];
};

export type RolloutStatus = {
  __typename?: 'RolloutStatus';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** The result of the s3PreSignedURL query */
export type S3PreSigneUrlResult = {
  __typename?: 'S3PreSigneURLResult';
  /** The URL of the asset to use after it's uploaded to S3 */
  assetUrl: Scalars['String']['output'];
  /** The bucket where the file was saved */
  bucket: Scalars['String']['output'];
  /** The name/path of the file within the bucket */
  key: Scalars['String']['output'];
  /** The pre-signed URL for uploading the file to S3 */
  url: Scalars['String']['output'];
};

/** Input for the s3PreSignedURL query */
export type S3PreSignedUrlInput = {
  /** The full filename with the extension, e.g. puppy.png */
  fileName: Scalars['String']['input'];
  /** The mime type of the file, e.g. image/png */
  mimeType: Scalars['MimeType']['input'];
  /** The organization for which the pre-signed URL is being requested */
  organizationId: Scalars['OrganizationId']['input'];
  /**
   * Whether the asset will be used in the composer or as an account/channel avatar.
   * In the backend, this will decide which S3 bucket to use.
   */
  uploadType: UploadType;
};

/** Input for the saved replies query */
export type SavedRepliesInput = {
  /** The organization id to fetch saved replies for */
  organizationId: Scalars['OrganizationId']['input'];
};

/** Response for the saved replies query */
export type SavedRepliesResponse = {
  __typename?: 'SavedRepliesResponse';
  /** List of saved replies */
  savedReplies: Array<SavedReply>;
};

/**
 * Saved reply: it contains a text used to reply to a comment easily.
 * The keyboard hotkeys is used to access quickly to the saved reply.
 */
export type SavedReply = {
  __typename?: 'SavedReply';
  /** The content of the saved reply. */
  content: SavedReplyContent;
  /** The date and time when the saved reply was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Optional hotkeys to reply with the saved reply, i.e. Ctrl+a. */
  hotkeys?: Maybe<Array<Scalars['String']['output']>>;
  /** The id for the saved reply. */
  id: Scalars['SavedReplyId']['output'];
  /** The organization that owns this saved reply. */
  organizationId: Scalars['OrganizationId']['output'];
  /** The title of the saved reply. */
  title?: Maybe<Scalars['String']['output']>;
  /** The date and time when the saved reply was created or updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Successful response for adding a saved reply. */
export type SavedReplyActionSuccess = {
  __typename?: 'SavedReplyActionSuccess';
  /** The saved reply that was successfully created. */
  savedReply: SavedReply;
};

/**
 * The content of a saved reply.
 * Currently, only text is supported.
 * We could add other types of content in the future.
 */
export type SavedReplyContent = {
  __typename?: 'SavedReplyContent';
  /** The text content of the saved reply. */
  text: Scalars['String']['output'];
};

/**
 * The content of a saved reply to be created or updated.
 * Currently, only text is supported.
 * We could add other types of content in the future.
 */
export type SavedReplyContentInput = {
  /** The text content of the saved reply. */
  text: Scalars['String']['input'];
};

/** Input type for creating a saved reply. */
export type SavedReplyToCreateInput = {
  /** The content of the saved reply. */
  content: SavedReplyContentInput;
  /** Optional hotkeys to reply with the saved reply, i.e. Ctrl+a. */
  hotkeys?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The title of the saved reply. It could be null or empty. */
  title?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Input type for updating a saved reply.
 * All fields are optional. The user could update only the title or the content or the hotkeys.
 */
export type SavedReplyToUpdateInput = {
  /**
   * The content we want to update. It could be optional if we want to keep the same content
   * and update the title or the hotkeys.
   */
  content?: InputMaybe<SavedReplyContentInput>;
  /**
   * Optional hotkeys to reply with the saved reply, i.e. Ctrl+a.
   *   - Omit this field to leave the existing hotkeys unchanged.
   *   - Provide an empty array `[]` to clear all hotkeys.
   *   - Provide an array of strings to replace with new hotkeys.
   */
  hotkeys?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The title of the saved reply. Uses title: null to remove the title. */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** A saved view with custom filters for a specific section */
export type SavedView = {
  __typename?: 'SavedView';
  /**
   * Identity color — one of the fixed palette tokens. Null for saved views
   * created before the identity feature.
   */
  color?: Maybe<Scalars['String']['output']>;
  /** The date and time the saved view was created */
  createdAt: Scalars['DateTime']['output'];
  /** Filter state applied to this saved view */
  filters: Scalars['FilterJSON']['output'];
  /**
   * Identity icon — a registry key resolved by the client icon registry. Null for
   * saved views created before the identity feature.
   */
  icon?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the saved view */
  id: Scalars['SavedViewId']['output'];
  /** Display name of the saved view */
  name: Scalars['String']['output'];
  /** The section of the app this saved view belongs to */
  section: SavedViewSection;
  /** The date and time the saved view was last updated */
  updatedAt: Scalars['DateTime']['output'];
  /** The specific view within the section (e.g. queue, sent, drafts) */
  view?: Maybe<Scalars['String']['output']>;
};

/** The section of the app a saved view belongs to */
export enum SavedViewSection {
  Community = 'community',
  Create = 'create',
  Insights = 'insights',
  Publish = 'publish'
}

/** Input for fetching saved views */
export type SavedViewsInput = {
  /** The organization to fetch saved views for */
  organizationId: Scalars['OrganizationId']['input'];
};

/** Response containing a list of saved views */
export type SavedViewsResponse = {
  __typename?: 'SavedViewsResponse';
  /** The saved views for the user in the organization, ordered by position */
  savedViews: Array<SavedView>;
};

/** Fields that deliberately return invalid scalar values, used to test scalar error handling. */
export type ScalarErrors = {
  __typename?: 'ScalarErrors';
  /** This field will return a Float value instead of an Int. */
  floatAsNumberError: Scalars['Int']['output'];
  /** This field will return an invalid `OrganizationId` value "foo-bar". */
  invalidObjectId: Scalars['OrganizationId']['output'];
};

export type Schedule = {
  __typename?: 'Schedule';
  day: Scalars['String']['output'];
  paused: Scalars['Boolean']['output'];
  times: Array<Scalars['String']['output']>;
};

export enum ScheduleOption {
  FixedTime = 'FixedTime',
  Now = 'Now',
  Prioritize = 'Prioritize',
  Queue = 'Queue'
}

/** Schedule post's request input. */
export type SchedulePostInput = {
  /** New dueAt date */
  dueAt: Scalars['DateTime']['input'];
  /** ID of post to update */
  id: Scalars['PostId']['input'];
};

/** Schedule post's request response payload. */
export type SchedulePostPayload = LimitReachedError | NotFoundError | PostActionSuccess | RestProxyError | UnauthorizedError | UnexpectedError;

/** A specific posting time on a day of the week (output) */
export type ScheduleTime = {
  __typename?: 'ScheduleTime';
  /** Day of the week */
  day: DayOfWeek;
  /** Time in HH:MM format (24-hour) */
  time: Scalars['String']['output'];
};

/** The mode for updating the posting schedule: override, add, or none */
export enum ScheduleUpdateMode {
  Add = 'add',
  None = 'none',
  Override = 'override'
}

/** Posting schedule for a specific day of the week */
export type ScheduleV2 = {
  __typename?: 'ScheduleV2';
  /** The day of the week: mon, tue, wed, thu, fri, sat, sun */
  day: DayOfWeek;
  /** Indicates if this day is paused in the posting schedule. */
  paused: Scalars['Boolean']['output'];
  /** The times the channel is scheduled to post on the day: HH:MM */
  times: Array<Scalars['String']['output']>;
};

/** Posting Schedule input */
export type ScheduleV2Input = {
  /** The day of the week: mon, tue, wed, thu, fri, sat, sun */
  day: DayOfWeek;
  /** Indicates if this days is paused in the posting schedule. */
  paused: Scalars['Boolean']['input'];
  /** The times the channel is scheduled to post on the day: HH:MM */
  times: Array<Scalars['String']['input']>;
};

/** The scheduled subscription update for a subscription plan change. */
export type ScheduledSubscriptionUpdate = {
  __typename?: 'ScheduledSubscriptionUpdate';
  /** The effective date of the subscription update */
  effectiveDate: Scalars['DateTime']['output'];
  /** The new interval that the subscription will be updated to on the effective date */
  newInterval: BillingInterval;
  /** The new plan that the subscription will be updated to on the effective date */
  newPlan: Scalars['String']['output'];
  /** The new quantity that the subscription will be updated to on the effective date */
  newQuantity: Scalars['Int']['output'];
};

/**
 * The scheduled subscription update for a subscription plan change.
 * This is the same as the ScheduledSubscriptionUpdate type, but with the newPlan field as an OBPlanId.
 */
export type ScheduledSubscriptionUpdateV2 = {
  __typename?: 'ScheduledSubscriptionUpdateV2';
  /** The effective date of the subscription update */
  effectiveDate: Scalars['DateTime']['output'];
  /** The new interval that the subscription will be updated to on the effective date */
  newInterval: BillingInterval;
  /** The new plan id that the subscription will be updated to on the effective date */
  newPlan: ObPlanId;
  /** The new quantity that the subscription will be updated to on the effective date */
  newQuantity: Scalars['Int']['output'];
};

export type SchedulesError = {
  __typename?: 'SchedulesError';
  cause: Scalars['String']['output'];
};

export type SchedulesInput = {
  channelId: Scalars['String']['input'];
};

export type SchedulesPayload = SchedulesError | SchedulesResponse;

export type SchedulesResponse = {
  __typename?: 'SchedulesResponse';
  schedule: PostingSchedule;
};

/** Indicates whether the post was scheduled for notification publishing or automatic publishing */
export enum SchedulingType {
  /** Buffer's publishing workers send the post, with nobody having to act */
  Automatic = 'automatic',
  /** Buffer reminds someone to publish the post by hand */
  Notification = 'notification'
}

/** Link data for link preview */
export type ScrapedLink = {
  /** Description for the scraped link */
  text: Scalars['String']['output'];
  /** Thumbnails of media available in the link */
  thumbnails: Array<Scalars['String']['output']>;
  /** URL that the link asset has been built from */
  url: Scalars['String']['output'];
};

/** Input for searching both Instagram audio catalogs. */
export type SearchInstagramAudioCatalogInput = {
  /** Instagram channel used to authorize the search. */
  channelId: Scalars['ChannelId']['input'];
  /** Search text. Must not be blank. */
  query: Scalars['String']['input'];
};

/** Input for searching Instagram audio for one channel. */
export type SearchInstagramAudioInput = {
  /** Music or original sound catalog */
  audioType: InstagramAudioType;
  /** Instagram channel to search audio for */
  channelId: Scalars['ChannelId']['input'];
  /** Search text. Required. Use trendingInstagramAudio for trending results. */
  query: Scalars['String']['input'];
};

/** Payload returned when searching Instagram audio */
export type SearchInstagramAudioPayload = ChannelRefreshRequired | SearchInstagramAudioSuccess;

/** Success response for searching Instagram audio */
export type SearchInstagramAudioSuccess = {
  __typename?: 'SearchInstagramAudioSuccess';
  /** Matching or trending audio assets */
  audio: Array<InstagramAudio>;
};

/** Input for searching Threads locations */
export type SearchThreadsLocationsInput = {
  /** Channel IDs for the Threads channels to search locations for */
  channelIds: Array<Scalars['ChannelId']['input']>;
  /** Search query for locations (minimum 2 characters required) */
  query: Scalars['String']['input'];
};

/** Payload returned when searching for Threads locations */
export type SearchThreadsLocationsPayload = ChannelRefreshRequired | SearchThreadsLocationsResponse | TooShortQueryStringError;

/** Success response for searching Threads locations */
export type SearchThreadsLocationsResponse = {
  __typename?: 'SearchThreadsLocationsResponse';
  /** List of locations matching the search query */
  locations: Array<ThreadsLocation>;
};

/** A selectable team member and its pagination cursor. */
export type SelectableTeamMemberEdge = {
  __typename?: 'SelectableTeamMemberEdge';
  /** The opaque cursor for this team member. */
  cursor: Scalars['String']['output'];
  /** The team member. */
  node: Author;
};

/** A page of selectable team members. */
export type SelectableTeamMembersConnection = {
  __typename?: 'SelectableTeamMembersConnection';
  /** The team members in this page. */
  edges: Array<SelectableTeamMemberEdge>;
  /** The pagination information for this page. */
  pageInfo: PaginationPageInfo;
};

/** The team members to offer for selection. */
export type SelectableTeamMembersInput = {
  /** The scope to select team members from. */
  scope: TeamMemberSelectionScopeInput;
  /**
   * A case-insensitive substring to match against name or email. Omitted, null
   * or blank returns every member in scope. Reset `after` to null when this
   * changes, because the cursor is only meaningful within one filtered list.
   */
  search?: InputMaybe<Scalars['String']['input']>;
};

/** success response for sendTestNotification mutation */
export type SendTestNotificationError = {
  __typename?: 'SendTestNotificationError';
  /** Error code if the notification was not sent successfully. */
  code: Scalars['Int']['output'];
  /** Error message if the notification was not sent successfully. */
  message: Scalars['String']['output'];
};

/** SendTestNotification response payload. */
export type SendTestNotificationPayload = SendTestNotificationError | SendTestNotificationSuccess;

/** error response for sendTestNotification mutation */
export type SendTestNotificationSuccess = {
  __typename?: 'SendTestNotificationSuccess';
  /**
   * The value is always an empty string ''
   * Note: GraphQL doesn't allow types with no fields, so we have to add this field
   */
  _empty: Scalars['String']['output'];
};

/** Represents sentiment analysis results for a comment. */
export type SentimentAnalysis = {
  __typename?: 'SentimentAnalysis';
  /** The sentiment score indicating intensity. */
  score: Scalars['Int']['output'];
  /** The type of sentiment detected (e.g., positive, negative, neutral). */
  type: CommentLabel;
};

/** The list of services that can be authorized. */
export enum Service {
  Bluesky = 'bluesky',
  Facebook = 'facebook',
  Googlebusiness = 'googlebusiness',
  Instagram = 'instagram',
  Linkedin = 'linkedin',
  Mastodon = 'mastodon',
  Pinterest = 'pinterest',
  StartPage = 'startPage',
  Substack = 'substack',
  Threads = 'threads',
  Tiktok = 'tiktok',
  Twitter = 'twitter',
  Whatsapp = 'whatsapp',
  Youtube = 'youtube'
}

/**
 * Service-level configuration for one supported `service` + `channelType`: its
 * engagement capabilities and `content`. The channel-agnostic baseline — today
 * the same fields as `ChannelConfiguration` minus `channelId` and the per-channel
 * `authorizationStatus`. This overlap is incidental, not a contract: it is a
 * distinct type so the service-level catalog can evolve independently of the
 * per-channel config (either side may add fields the other doesn't share).
 */
export type ServiceConfiguration = {
  __typename?: 'ServiceConfiguration';
  /** The channel type within the service (e.g. profile, page, business). */
  channelType: ChannelType;
  /**
   * Content config — one entry per content type, or a single entry
   * grouping several types that share identical rules. Empty when none is exposed.
   */
  content: Array<ContentConfiguration>;
  /**
   * Engagement capabilities — one entry per engagement type. Empty when
   * engagement isn't supported for this service + channel type.
   */
  engagement: Array<EngagementTypeConfiguration>;
  /** The social service this config describes (e.g. twitter, instagram). */
  service: Service;
};

/** Indicates the type of subscription the user has on Twitter - Deprecated in favor of TwitterMetadata */
export type ServiceData = {
  __typename?: 'ServiceData';
  /** The type of subscription the user has on Twitter */
  subscriptionType?: Maybe<Scalars['String']['output']>;
};

/** Represents a tag associated with a specific service. */
export type ServiceMention = {
  __typename?: 'ServiceMention';
  /** The user-friendly name of the tag, to displayed in the UI. */
  displayName: Scalars['String']['output'];
  /** The entity that the tag represents within the given service. */
  entity: Scalars['String']['output'];
  /** The unique identifier of the service tag. */
  id: Scalars['String']['output'];
  /** Image representing the tag, used for display purposes. */
  image?: Maybe<Scalars['URL']['output']>;
  /** A link or URL associated with the tag. */
  link: Scalars['URL']['output'];
  /** A URL-friendly version of the tag's name. */
  vanityName: Scalars['String']['output'];
};

/** Input type for the `serviceTags` query. */
export type ServiceMentionsInput = {
  /** The unique identifier of the account querying for tags. */
  channelIds: Array<Scalars['ChannelId']['input']>;
  /** The search query string used to query for tags. */
  query: Scalars['String']['input'];
};

/** The current status of the connectable service */
export type ServiceStatus = {
  __typename?: 'ServiceStatus';
  /**
   * Details to be used when allowing users to upvote service functionality.
   * If `label: none`, details will be null
   */
  details?: Maybe<UpvoteDetails>;
  /** The label used to reflect the current status of a service */
  label: StatusLabel;
};

/** Input for setBetaFeatureState mutation */
export type SetBetaFeatureStateInput = {
  /** The state of the beta feature to set. */
  enabled: Scalars['Boolean']['input'];
  /** The name of the beta feature to set the state of. */
  name: Scalars['String']['input'];
  /** The ID of the organization to set the beta feature state for. */
  organizationId: Scalars['OrganizationId']['input'];
};

/** Mutation Response: Success (if an error happens it will be on the error field) */
export type SetBetaFeatureStatePayload = EmptySuccess;

/**
 * Input for choosing which single verified capability a channel displays on the
 * connected platform's profile.
 */
export type SetChannelCapabilityToDisplayOnNetworkInput = {
  /**
   * The capability to display on the platform profile, or null to stop displaying
   * any capability. Only one capability can be displayed at a time.
   */
  capabilityKey?: InputMaybe<ChannelCapabilityKey>;
  /** The channel whose displayed capability should be set. */
  channelId: Scalars['ChannelId']['input'];
};

/** Possible responses for the setChannelCapabilityToDisplayOnNetwork mutation. */
export type SetChannelCapabilityToDisplayOnNetworkPayload = EmptySuccess | VoidMutationError;

/** input for setPasswordForAccount mutation */
export type SetPasswordForAccountInput = {
  /** Account id to set password. */
  accountId: Scalars['AccountId']['input'];
  /** New password to set. */
  newPassword: Scalars['String']['input'];
};

/** setPasswordForAccount response payload. */
export type SetPasswordForAccountPayload = InvalidInputError | NotFoundError | SetPasswordSuccess | UnexpectedError;

/** success response for setPasswordForAccount mutation */
export type SetPasswordSuccess = MutationSuccess & {
  __typename?: 'SetPasswordSuccess';
  /**
   * The value is always an empty string ''
   * Note: GraphQL doesn't allow types with no fields, so we have to add this field
   */
  _empty: Scalars['String']['output'];
};

/** Input for setting up posting schedules for a Channel */
export type SetPostingScheduleForChannelInput = {
  /** The channel id to update the posting schedule */
  channelId: Scalars['ChannelId']['input'];
  /** The posting schedule to update for a Channel */
  postingSchedule: Array<InputMaybe<ScheduleV2Input>>;
};

/** The payload of the response from setPostingScheduleForChannel */
export type SetPostingScheduleForChannelPayload = InvalidInputError | NotFoundError | SetPostingScheduleForChannelResponse | UnauthorizedError | UnexpectedError;

/** The response for setting up posting schedules for a Channel */
export type SetPostingScheduleForChannelResponse = {
  __typename?: 'SetPostingScheduleForChannelResponse';
  /** The posting schedules updated from the Channel */
  postingSchedule: Array<ScheduleV2>;
};

/** Input for recording a user's helpful/unhelpful vote on a takeaway. */
export type SetTakeawayFeedbackInput = {
  /** The channel the takeaway belongs to. Used to authorize the actor. */
  channelId: Scalars['ChannelId']['input'];
  /** The vote to record. Pass null to clear any prior reaction. */
  feedback?: InputMaybe<TakeawayFeedback>;
  /** The organization the takeaway belongs to. */
  organizationId: Scalars['OrganizationId']['input'];
  /** The takeaway to record feedback on. */
  takeawayId: Scalars['TakeawayId']['input'];
};

/**
 * Result of recording takeaway feedback. Returns the updated takeaway on
 * success, or a generic error variant when the takeaway cannot be found
 * in the actor's scope or the actor is not authorized.
 */
export type SetTakeawayFeedbackPayload = SetTakeawayFeedbackSuccess | VoidMutationError;

/** The takeaway with its updated feedback after a successful write. */
export type SetTakeawayFeedbackSuccess = {
  __typename?: 'SetTakeawayFeedbackSuccess';
  /** The takeaway with its updated feedback. */
  takeaway: Takeaway;
};

/** Input for setTrustedPartner mutation */
export type SetTrustedPartnerInput = {
  /** Whether to enable or disable trusted partner status. */
  enabled: Scalars['Boolean']['input'];
  /** The ID of the organization to set the trusted partner state for. */
  organizationId: Scalars['OrganizationId']['input'];
};

/** Mutation Response: Success and errors for setTrustedPartner */
export type SetTrustedPartnerPayload = EmptySuccess | VoidMutationError;

/** Settings */
export type Settings = {
  __typename?: 'Settings';
  aiSettings?: Maybe<AiSettings>;
};

export type SettingsInput = {
  aiSettings?: InputMaybe<AiSettingsInput>;
};

/** How the post is being scheduled. */
export enum ShareMode {
  AddToQueue = 'addToQueue',
  CustomScheduled = 'customScheduled',
  ShareNext = 'shareNext',
  ShareNow = 'shareNow'
}

/** A custom CTA button link configured by the user. */
export type ShopGridCustomLink = {
  __typename?: 'ShopGridCustomLink';
  /** The link identifier. */
  id: Scalars['ShopGridLinkId']['output'];
  /** Button display text. */
  text: Scalars['String']['output'];
  /** Button destination URL. */
  url: Scalars['URL']['output'];
};

/** Custom link button configuration including colors. */
export type ShopGridCustomLinks = {
  __typename?: 'ShopGridCustomLinks';
  /** Background color for custom link buttons (hex). */
  color: Scalars['HexColorCode']['output'];
  /** Text/contrast color for custom link buttons (hex). */
  contrastColor: Scalars['HexColorCode']['output'];
  /** The custom link buttons. */
  links: Array<ShopGridCustomLink>;
};

/**
 * ShopGrid Custom Links
 * This query retrieves the custom links for the shop grid.
 * The response includes the color, contrast color, and a list of custom links.
 * The input requires the channel ID to fetch the specific links for that channel.
 */
export type ShopGridCustomLinksInput = {
  /** The ID of the channel */
  channelId: Scalars['ChannelId']['input'];
};

/** Mutation Payload for custom links: Success and errors */
export type ShopGridCustomLinksMutationPayload = NotFoundError | ShopGridCustomLinksPayload | UnauthorizedError | UnexpectedError;

/** Response payload for Shop Grid Custom Link */
export type ShopGridCustomLinksPayload = {
  __typename?: 'ShopGridCustomLinksPayload';
  /** Color for links */
  color?: Maybe<Scalars['HexColorCode']['output']>;
  /** Contrast color for links */
  contrastColor?: Maybe<Scalars['HexColorCode']['output']>;
  /** List of links */
  links?: Maybe<Array<CustomLink>>;
};

/** The complete shop grid page data for a given Instagram username. */
export type ShopGridPage = {
  __typename?: 'ShopGridPage';
  /** Custom CTA button links and their color configuration. */
  customLinks: ShopGridCustomLinks;
  /**
   * Paginated Instagram posts with shop grid links, sorted newest first.
   * Page size defaults to 24, capped at 99 server-side (both divisible
   * by 3 to align with the 3-column public viewer grid).
   */
  posts: ShopGridPostsConnection;
  /** Profile info (avatar, username). */
  profile: ShopGridProfile;
};

/** Input for fetching a shop grid page by Instagram username. */
export type ShopGridPageInput = {
  /** Cursor returned by a previous page, used to fetch the next page. */
  after?: InputMaybe<Scalars['String']['input']>;
  /** The number of posts to return (default 24, max 100). */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** The Instagram username to look up. */
  username: Scalars['String']['input'];
};

/** A sent Instagram post with a shop grid link. */
export type ShopGridPost = {
  __typename?: 'ShopGridPost';
  /** The post identifier. */
  id: Scalars['PostId']['output'];
  /** The custom link destination for this post. */
  link: Scalars['URL']['output'];
  /** The Instagram service update ID, used for image refresh. */
  serviceUpdateId: Scalars['String']['output'];
  /** CDN-ready thumbnail URL for the post image. */
  thumbnail: Scalars['URL']['output'];
};

/** Paginated list of shop-grid posts for a given page. */
export type ShopGridPostsConnection = {
  __typename?: 'ShopGridPostsConnection';
  /** Posts on this page, sorted by `sentAt` descending. */
  edges: Array<ShopGridPostsEdge>;
  /** Information to aid in pagination. */
  pageInfo: PaginationPageInfo;
};

/**
 * A page in the paginated shop-grid posts list, using the Relay Connection
 * convention.
 */
export type ShopGridPostsEdge = {
  __typename?: 'ShopGridPostsEdge';
  /** Opaque cursor used to fetch the next page starting after this post. */
  cursor: Scalars['String']['output'];
  /** The post at this position in the list. */
  node: ShopGridPost;
};

/** Public profile info displayed on the shop grid page. */
export type ShopGridProfile = {
  __typename?: 'ShopGridProfile';
  /** Profile avatar image URL. */
  avatar: Scalars['URL']['output'];
  /** Instagram username. */
  username: Scalars['String']['output'];
};

/** A named set of hashtags that a team member saves once and inserts into posts. */
export type Snippet = {
  __typename?: 'Snippet';
  /** Unique identifier of the snippet. */
  id: Scalars['SnippetId']['output'];
  /** Display name of the snippet. */
  name: Scalars['String']['output'];
  /** The hashtags, as the text that is inserted into a post. */
  text: Scalars['String']['output'];
};

/** An edge in a snippets connection. */
export type SnippetEdge = {
  __typename?: 'SnippetEdge';
  /** A cursor for pagination. */
  cursor: Scalars['String']['output'];
  /** The snippet at the end of the edge. */
  node: Snippet;
};

/** A paginated connection of snippets, sorted by name. */
export type SnippetsConnection = {
  __typename?: 'SnippetsConnection';
  /** The list of snippet edges. */
  edges: Array<SnippetEdge>;
  /** Pagination information for the connection. */
  pageInfo: PaginationPageInfo;
};

/** Input for the snippets query. */
export type SnippetsInput = {
  /** The organization whose snippets to return. */
  organizationId: Scalars['OrganizationId']['input'];
};

/** Direction to sort the results by. */
export enum SortDirection {
  /** Sort records in ascending order. */
  Asc = 'asc',
  /** Sort records in descending order. */
  Desc = 'desc'
}

export type SplitEnabledResponse = {
  __typename?: 'SplitEnabledResponse';
  isEnabled: Scalars['Boolean']['output'];
};

export type StartImpersonationInput = {
  bufferTeammateAccountId: Scalars['String']['input'];
  impersonatedCustomerAccountId: Scalars['String']['input'];
};

/** The start of week preference for the account. */
export enum StartOfWeek {
  /** The start of week is Monday. */
  Monday = 'monday',
  /** The start of week is Sunday. */
  Sunday = 'sunday'
}

export type StartPage = {
  __typename?: 'StartPage';
  blocks?: Maybe<Array<Maybe<StartPageBlock>>>;
  domain?: Maybe<Scalars['String']['output']>;
  hasUnPublishedChanges?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isNew?: Maybe<Scalars['Boolean']['output']>;
  isPublished?: Maybe<Scalars['Boolean']['output']>;
  migrationAsAChannel?: Maybe<StartPageMigrationAsAChannel>;
  organizationId: Scalars['ID']['output'];
  statistics?: Maybe<StartPageStats>;
  theme?: Maybe<StartPageThemeSaved>;
  title?: Maybe<Scalars['String']['output']>;
};

/** Output Types */
export type StartPageBlock = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  pageId: Scalars['ID']['output'];
};

export type StartPageBlockButtonLink = StartPageBlock & {
  __typename?: 'StartPageBlockButtonLink';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /** Button link specific data */
  label?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  pageId: Scalars['ID']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type StartPageBlockFeed = StartPageBlock & {
  __typename?: 'StartPageBlockFeed';
  /** Feed specific data */
  children?: Maybe<Array<Maybe<StartPageBlockFeedPost>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  pageId: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
};


export type StartPageBlockFeedChildrenArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type StartPageBlockFeedPost = StartPageBlock & {
  __typename?: 'StartPageBlockFeedPost';
  /**
   * Feed Post specific data
   * @deprecated deprecated, will be removed
   */
  caption?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  media?: Maybe<StartPageMedia>;
  order?: Maybe<Scalars['Int']['output']>;
  pageId: Scalars['ID']['output'];
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type StartPageBlockHeader = StartPageBlock & {
  __typename?: 'StartPageBlockHeader';
  backgroundMedia?: Maybe<StartPageMedia>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  layout?: Maybe<Scalars['String']['output']>;
  logoMedia?: Maybe<StartPageMedia>;
  order?: Maybe<Scalars['Int']['output']>;
  overlay?: Maybe<Scalars['Int']['output']>;
  pageId: Scalars['ID']['output'];
  /** Header specific data */
  title?: Maybe<Scalars['String']['output']>;
};

export type StartPageBlockIconLinks = StartPageBlock & {
  __typename?: 'StartPageBlockIconLinks';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /** Icon links specific data */
  links?: Maybe<Array<Maybe<StartPageIconLink>>>;
  order?: Maybe<Scalars['Int']['output']>;
  pageId: Scalars['ID']['output'];
};

export type StartPageBlockImageLink = StartPageBlock & {
  __typename?: 'StartPageBlockImageLink';
  /** Image link specific data */
  caption?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  media?: Maybe<StartPageMedia>;
  order?: Maybe<Scalars['Int']['output']>;
  pageId: Scalars['ID']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type StartPageBlockImageLinksGrid = StartPageBlock & {
  __typename?: 'StartPageBlockImageLinksGrid';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /** Links grid specific data */
  links?: Maybe<Array<Maybe<StartPageLinkGrid>>>;
  order?: Maybe<Scalars['Int']['output']>;
  pageId: Scalars['ID']['output'];
};

/** deprecated(reason: "Use StartPageBlockImageLinksGrid.") */
export type StartPageBlockInstagramLinksGrid = StartPageBlock & {
  __typename?: 'StartPageBlockInstagramLinksGrid';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /** Links grid specific data */
  links?: Maybe<Array<Maybe<StartPageLinkGrid>>>;
  order?: Maybe<Scalars['Int']['output']>;
  pageId: Scalars['ID']['output'];
};

export type StartPageBlockMailchimp = StartPageBlock & {
  __typename?: 'StartPageBlockMailchimp';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  /** Mailchimp specific data */
  htmlText?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  pageId: Scalars['ID']['output'];
};

export type StartPageBlockSpotify = StartPageBlock & {
  __typename?: 'StartPageBlockSpotify';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  layout?: Maybe<Scalars['String']['output']>;
  /** Spotify specific data */
  media?: Maybe<StartPageMedia>;
  order?: Maybe<Scalars['Int']['output']>;
  pageId: Scalars['ID']['output'];
};

export type StartPageBlockStyles = {
  __typename?: 'StartPageBlockStyles';
  backgroundColor?: Maybe<Scalars['String']['output']>;
  blockType?: Maybe<StartPageBlockTypes>;
  border?: Maybe<Scalars['String']['output']>;
  corners?: Maybe<Scalars['String']['output']>;
  fontFamily?: Maybe<Scalars['String']['output']>;
  secondaryBackgroundColor?: Maybe<Scalars['String']['output']>;
  secondaryFontFamily?: Maybe<Scalars['String']['output']>;
  secondaryTextColor?: Maybe<Scalars['String']['output']>;
  textAlign?: Maybe<StartPageTextAlign>;
  textColor?: Maybe<Scalars['String']['output']>;
};

export type StartPageBlockStylesInput = {
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  blockType?: InputMaybe<StartPageBlockTypes>;
  border?: InputMaybe<Scalars['String']['input']>;
  corners?: InputMaybe<Scalars['String']['input']>;
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  secondaryBackgroundColor?: InputMaybe<Scalars['String']['input']>;
  secondaryFontFamily?: InputMaybe<Scalars['String']['input']>;
  secondaryTextColor?: InputMaybe<Scalars['String']['input']>;
  textAlign?: InputMaybe<StartPageTextAlign>;
  textColor?: InputMaybe<Scalars['String']['input']>;
};

export type StartPageBlockSubHeading = StartPageBlock & {
  __typename?: 'StartPageBlockSubHeading';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  pageId: Scalars['ID']['output'];
  /** SubHeading specific data */
  text?: Maybe<Scalars['String']['output']>;
};

export type StartPageBlockText = StartPageBlock & {
  __typename?: 'StartPageBlockText';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  htmlJson?: Maybe<Scalars['String']['output']>;
  htmlText?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  pageId: Scalars['ID']['output'];
  /** Text specific data */
  text?: Maybe<Scalars['String']['output']>;
};

export enum StartPageBlockTypes {
  ButtonLink = 'BUTTON_LINK',
  Feed = 'FEED',
  FeedPost = 'FEED_POST',
  Header = 'HEADER',
  IconLinks = 'ICON_LINKS',
  ImageLink = 'IMAGE_LINK',
  ImageLinksGrid = 'IMAGE_LINKS_GRID',
  InstagramLinksGrid = 'INSTAGRAM_LINKS_GRID',
  Mailchimp = 'MAILCHIMP',
  Spotify = 'SPOTIFY',
  SubHeading = 'SUB_HEADING',
  Text = 'TEXT',
  Video = 'VIDEO'
}

export type StartPageBlockVideo = StartPageBlock & {
  __typename?: 'StartPageBlockVideo';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /** Video specific data */
  media?: Maybe<StartPageMedia>;
  order?: Maybe<Scalars['Int']['output']>;
  pageId: Scalars['ID']['output'];
};

/** Input Types */
export type StartPageConfigInput = {
  domain?: InputMaybe<Scalars['String']['input']>;
  /** deprecated(reason: "Use `template`.") */
  preset?: InputMaybe<Scalars['String']['input']>;
  template?: InputMaybe<Scalars['String']['input']>;
  theme?: InputMaybe<StartPageThemeInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type StartPageData = {
  __typename?: 'StartPageData';
  link?: Maybe<Scalars['String']['output']>;
};

/** Output Types */
export type StartPageGlobalStyles = {
  __typename?: 'StartPageGlobalStyles';
  backgroundColor?: Maybe<Scalars['String']['output']>;
  textColor?: Maybe<Scalars['String']['output']>;
};

export type StartPageGlobalStylesInput = {
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  textColor?: InputMaybe<Scalars['String']['input']>;
};

export type StartPageIconLink = {
  __typename?: 'StartPageIconLink';
  icon?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export enum StartPageIconType {
  Facebook = 'FACEBOOK',
  Instagram = 'INSTAGRAM',
  Messenger = 'MESSENGER',
  Pinterest = 'PINTEREST',
  Twitter = 'TWITTER',
  Whatsapp = 'WHATSAPP'
}

export type StartPageLinkGrid = {
  __typename?: 'StartPageLinkGrid';
  id?: Maybe<Scalars['ID']['output']>;
  media?: Maybe<StartPageMedia>;
  order?: Maybe<Scalars['Int']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type StartPageLinksClicks = {
  __typename?: 'StartPageLinksClicks';
  block?: Maybe<StartPageBlock>;
  clicks?: Maybe<Scalars['Int']['output']>;
  link?: Maybe<Scalars['String']['output']>;
};

export type StartPageMedia = {
  __typename?: 'StartPageMedia';
  altText?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type StartPageMigrationAsAChannel = {
  __typename?: 'StartPageMigrationAsAChannel';
  errorReason?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  wasAtLimit?: Maybe<Scalars['Boolean']['output']>;
  wasBilling?: Maybe<Scalars['String']['output']>;
  wasMobile?: Maybe<Scalars['Boolean']['output']>;
  wasPublished?: Maybe<Scalars['Boolean']['output']>;
  wasTrialist?: Maybe<Scalars['Boolean']['output']>;
};

export type StartPageMutationResponse = CommonError | StartPageMutationSuccess;

/** Query / Mutation responses */
export type StartPageMutationSuccess = MutationResponse & {
  __typename?: 'StartPageMutationSuccess';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  mutation: Scalars['String']['output'];
  startPage?: Maybe<StartPage>;
  startPages?: Maybe<Array<Maybe<StartPage>>>;
  success: Scalars['Boolean']['output'];
};

/** Start Page post metadata */
export type StartPagePostMetadata = CommonPostMetadata & {
  __typename?: 'StartPagePostMetadata';
  /** Annotations representing entities in the text */
  annotations: Array<Annotation>;
  /** Optional link in post */
  link?: Maybe<Scalars['String']['output']>;
  /** The channel-specific type of the post, eg, post, story, reel for Instagram */
  type: PostType;
};

/** Start Page post metadata */
export type StartPagePostMetadataInput = {
  /** Optional link in post */
  link?: InputMaybe<Scalars['String']['input']>;
};

export type StartPageResponse = CommonError | StartPage;

export type StartPageStats = {
  __typename?: 'StartPageStats';
  allTimeViews?: Maybe<Scalars['Int']['output']>;
  dailyViews?: Maybe<Scalars['Int']['output']>;
  linksClicks?: Maybe<Array<Maybe<StartPageLinksClicks>>>;
  weeklyViews?: Maybe<Scalars['Int']['output']>;
};

export type StartPageTemplate = {
  __typename?: 'StartPageTemplate';
  categories?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
};

export type StartPageTemplatesResponse = {
  __typename?: 'StartPageTemplatesResponse';
  categories?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  templates?: Maybe<Array<Maybe<StartPageTemplate>>>;
};

export enum StartPageTextAlign {
  Center = 'CENTER',
  Left = 'LEFT',
  Right = 'RIGHT'
}

export type StartPageTheme = {
  __typename?: 'StartPageTheme';
  blockStyles?: Maybe<Array<Maybe<StartPageBlockStyles>>>;
  globalStyles?: Maybe<StartPageGlobalStyles>;
  id?: Maybe<Scalars['String']['output']>;
};

export type StartPageThemeInput = {
  blockStyles?: InputMaybe<Array<InputMaybe<StartPageBlockStylesInput>>>;
  globalStyles?: InputMaybe<StartPageGlobalStylesInput>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type StartPageThemeSaved = {
  __typename?: 'StartPageThemeSaved';
  blockStyles?: Maybe<Array<Maybe<StartPageBlockStyles>>>;
  globalStyles?: Maybe<StartPageGlobalStyles>;
  id?: Maybe<Scalars['String']['output']>;
};

export type StartPageThemesResponse = {
  __typename?: 'StartPageThemesResponse';
  themes?: Maybe<Array<Maybe<StartPageTheme>>>;
};

export type StartPages = {
  __typename?: 'StartPages';
  startPages?: Maybe<Array<Maybe<StartPage>>>;
};

export type StartPagesResponse = CommonError | StartPages;

/** Input for startTrial mutation */
export type StartTrialInput = {
  /** Attribution metadata describing where the trial was initiated from. */
  attribution?: InputMaybe<AttributionInput>;
  /**
   * The billing interval of the trial. When omitted, the server uses the default trial plan.
   * @deprecated Omit this field. The server selects the trial plan.
   */
  interval?: InputMaybe<BillingInterval>;
  /** Id of the organization to start a trial for. */
  organizationId: Scalars['OrganizationId']['input'];
  /**
   * The plan to start the trial on. When omitted, the server uses the default trial plan.
   * @deprecated Omit this field. The server selects the trial plan.
   */
  plan?: InputMaybe<ObPlanId>;
};

/** startTrial response payload. */
export type StartTrialPayload = StartTrialResponse | VoidMutationError;

/** Response for successful startTrial mutation */
export type StartTrialResponse = MutationSuccess & {
  __typename?: 'StartTrialResponse';
  /**
   * The value is always an empty string ''
   * Note: GraphQL doesn't allow types with no fields, so we have to add this field
   */
  _empty: Scalars['String']['output'];
};

/** The label used to reflect the current status of a service */
export enum StatusLabel {
  /** The service is not yet available but will be soon */
  ComingSoon = 'coming_soon',
  /** The service is new to our platform */
  New = 'new',
  /** The service has no status, typically it is available and has been for some time */
  None = 'none'
}

export type StopImpersonationInput = {
  bufferTeammateAccountId: Scalars['String']['input'];
};

/** Represents a streak of consecutive actions or achievements */
export type Streak = {
  __typename?: 'Streak';
  /** The number of consecutive periods the streak goal has been met. */
  count: Scalars['Int']['output'];
  /** The longest streak. This value takes into account the current streak. */
  longestCount?: Maybe<Scalars['Int']['output']>;
  /**
   * Where this streak's count sits relative to other orgs on an active streak
   * (count > 0), on a 0–100 scale (100 = top). Null when no cohort snapshot
   * exists yet, the snapshot is empty, or the current streak count isn't eligible
   * for ranking.
   */
  percentileRank?: Maybe<Scalars['Int']['output']>;
  /**
   * The number of weeks ahead of the current streak
   * It currently returns either 0 or 1 because every period requires a DB call
   */
  periodsAhead?: Maybe<Scalars['Int']['output']>;
  /** Previous period streak count. If the current streak is the only one, it returns 0 */
  previousCount?: Maybe<Scalars['Int']['output']>;
  /** The current streak status */
  status: StreakStatus;
  /** The enum indicating which streak content to display on the client */
  userStreakState: UserStreakState;
};

/** Represents the current status of a user's streak */
export enum StreakStatus {
  /** There is a low chance the goal will be met in this period. */
  AtRisk = 'AtRisk',
  /** The goal for the period was hit */
  Hit = 'Hit',
  /** The streak has been reset (broken streak) */
  Missed = 'Missed',
  /** There is a good chance the goal will be met in this period. */
  OnTrack = 'OnTrack',
  /** Neutral value at the start of the period. This is the default value. */
  Started = 'Started'
}

/**
 * A consecutive-period streak metric. Reports the current run and the
 * longest run reached so consumers can render either ("you're on a 9-week
 * streak" / "your best run was 14 weeks").
 */
export type StreakUsageMetric = {
  __typename?: 'StreakUsageMetric';
  /** The longest run the organization has reached, in weeks. */
  longestWeeks: Scalars['Int']['output'];
  /** The current consecutive run, in weeks. */
  weeks: Scalars['Int']['output'];
};

/** In-product feedback from the Share Feedback widget. */
export type SubmitProductFeedbackInput = {
  /** Already-uploaded attachment URLs, rendered as links on the filed feedback. */
  attachmentUrls: Array<Scalars['URL']['input']>;
  /** What the person was trying to do. One of two sections in the description. */
  context: Scalars['String']['input'];
  /** Names the area the widget was rendered in. */
  source: Scalars['String']['input'];
  /** The page the person was on when they submitted. */
  sourceUrl: Scalars['URL']['input'];
  /** What would help. Becomes the title, and the first section of the description. */
  summary: Scalars['String']['input'];
  /** Identifies which of the widget's surfaces collected this. */
  widgetId: Scalars['String']['input'];
};

/** Mutation Response: Success and errors */
export type SubmitProductFeedbackPayload = SubmitProductFeedbackSuccess | VoidMutationError;

/** The feedback was filed. */
export type SubmitProductFeedbackSuccess = {
  __typename?: 'SubmitProductFeedbackSuccess';
  /** When the feedback was filed. */
  submittedAt: Scalars['DateTime']['output'];
};

/** Real-time changes to the collaboration Notes an actor may read. */
export type Subscription = {
  __typename?: 'Subscription';
  /**
   * Streams each Note change in one thread the reader may read, with no replay.
   * The stream ends when the reader loses access to the thread.
   */
  collaborationNoteSubjectChanges: CollaborationNoteSubjectChange;
  /** Streams each Note change on the Posts the reader may read, with no replay. */
  collaborationNotesChanges: CollaborationNotesChange;
};


/** Real-time changes to the collaboration Notes an actor may read. */
export type SubscriptionCollaborationNoteSubjectChangesArgs = {
  input: CollaborationNoteSubjectChangesInput;
};


/** Real-time changes to the collaboration Notes an actor may read. */
export type SubscriptionCollaborationNotesChangesArgs = {
  input: CollaborationNotesChangesInput;
};

/** Status of a subscription update operation */
export enum SubscriptionUpdateStatus {
  /** Payment requires additional user authentication (SCA/3D Secure) */
  RequiresAction = 'requiresAction',
  /** Update completed immediately */
  Success = 'success'
}

/** Substack post metadata */
export type SubstackPostMetadata = CommonPostMetadata & {
  __typename?: 'SubstackPostMetadata';
  /** Annotations representing entities in the text */
  annotations: Array<Annotation>;
  /** Link attachment */
  linkAttachment?: Maybe<LinkAttachment>;
  /** The channel-specific type of the post, eg, post, story, reel for Instagram */
  type: PostType;
};

/** Substack post metadata */
export type SubstackPostMetadataInput = {
  /** Link attachment. Mutually exclusive with a non-empty `assets` array — input providing both is rejected. */
  linkAttachment?: InputMaybe<LinkAttachmentInput>;
};

/** Represents a suggested response or action for a comment. */
export type Suggestion = {
  __typename?: 'Suggestion';
  /** The source of the suggestion (e.g., AI, predefined template). */
  source: CommentSuggestionSource;
  /** The suggested text to respond with. */
  text: Scalars['String']['output'];
};

/** Represents whether a client is currently supported by the API */
export enum SupportStatus {
  NotSupported = 'notSupported',
  Supported = 'supported'
}

/** Represents a supported channel, including its service and type. */
export type SupportedChannel = {
  __typename?: 'SupportedChannel';
  /** The service associated with this channel (e.g., Facebook, Twitter). */
  service: Service;
  /** The specific type of channel (e.g., group, page, profile). */
  type: ChannelType;
};

/** A single supported reaction entry. Clients use __typename to pick the right icon set. */
export type SupportedReaction = DefaultReaction | LinkedInReaction;

/** A survey-style step that collects user input. */
export type SurveyStep = {
  __typename?: 'SurveyStep';
  /** Optional description displayed to the user. */
  description?: Maybe<Scalars['String']['output']>;
  /** Whether the user can skip this step. */
  isSkippable: Scalars['Boolean']['output'];
  /** Available choices for the step. */
  options: Array<SurveyStepOption>;
  /** Unique identifier for the step within its flow. */
  slug: Scalars['String']['output'];
  /** The type of survey input. */
  surveyStepType: SurveyStepType;
  /** Title displayed to the user. */
  title: Scalars['String']['output'];
};

/** A selectable option within a survey step. */
export type SurveyStepOption = {
  __typename?: 'SurveyStepOption';
  /** Optional description of the option. */
  description?: Maybe<Scalars['String']['output']>;
  /** Display label for the option. */
  label: Scalars['String']['output'];
  /** Unique identifier for the option within its step. */
  slug: Scalars['String']['output'];
};

/** The type of input a survey step collects. */
export enum SurveyStepType {
  ChannelSelect = 'channelSelect',
  MultiSelect = 'multiSelect',
  SingleSelect = 'singleSelect',
  TextInput = 'textInput'
}

/** Swap post's request input. */
export type SwapPostsInQueueInput = {
  /** ID of the source post, i.e., the post that was dragged */
  sourceId: Scalars['PostId']['input'];
  /** ID of the target post, i.e., the post the source post was dropped on */
  targetId: Scalars['PostId']['input'];
};

/** Swap post's request response payload. */
export type SwapPostsInQueuePayload = NotFoundError | RestProxyError | SwapPostsInQueueSuccess | UnauthorizedError | UnexpectedError;

/** Swap post's request success response. */
export type SwapPostsInQueueSuccess = {
  __typename?: 'SwapPostsInQueueSuccess';
  /** Return the swapped posts - Order is not relevant. */
  posts: Array<Post>;
};

/** Input for the mutation to swap shop grid custom links */
export type SwapShopGridCustomLinksInput = {
  /** The ID of the channel */
  channelId: Scalars['ChannelId']['input'];
  /** The source ID of the custom link to be swapped */
  sourceId: Scalars['ShopGridLinkId']['input'];
  /** The target ID of the custom link to be swapped */
  targetId: Scalars['ShopGridLinkId']['input'];
};

/** Input parameters required to switch the billing gateway */
export type SwitchBillingGatewayInput = {
  /** The billing gateway to switch to */
  gateway: SwitchableBillingGateway;
  /** The ID of the organization to switch the billing gateway for */
  organizationId: Scalars['OrganizationId']['input'];
};

/** Union type representing either a successful response with a billing gateway switch or a billing error */
export type SwitchBillingGatewayPayload = InvalidInputError | SwitchBillingGatewayResponse;

/** Response type for switching the billing gateway */
export type SwitchBillingGatewayResponse = {
  __typename?: 'SwitchBillingGatewayResponse';
  /** The details of the new billing gateway */
  newGateway: GatewayDetails;
};

/** Allowable value for billing gateway switch. Only supports Stripe for now. */
export enum SwitchableBillingGateway {
  Stripe = 'stripe'
}

/**
 * Additional configuration depending on the sync type. We only need configuration
 * for the polling mechanism but by using an union we make room for further configurations.
 */
export type SyncConfiguration = PollingSyncConfiguration;

/**
 * Sync configuration for an engagement type — the realTime/polling
 * `syncDataMechanism` plus optional forced-sync detail.
 */
export type SyncDataConfiguration = {
  __typename?: 'SyncDataConfiguration';
  /**
   * Forced-sync detail. A forced sync is a user-triggered (manual) refresh that
   * fetches new items on demand instead of waiting for the next scheduled poll or
   * push. `null` when this kind's sync mechanism has no forced-sync support.
   */
  forcedSyncConfiguration?: Maybe<ForcedSyncConfiguration>;
  /**
   * How this engagement type syncs on this channel: `realTime` (push) or
   * `polling` (pull).
   */
  syncDataMechanism: SyncDataMechanism;
};

/**
 * How items of an engagement type are pulled / pushed. `realTime` covers push
 * (webhook / firehose); `polling` is pull.
 */
export enum SyncDataMechanism {
  Polling = 'polling',
  RealTime = 'realTime'
}

/** TFA information */
export type Tfa = {
  __typename?: 'TFA';
  /** The method of Two Factor Authentication */
  type: TwoFactorMethod;
};

/**
 * A label an organization applies to posts and ideas so they can be grouped and
 * filtered together. Tags belong to the organization and are shared by everyone
 * in it, rather than being per channel or per person.
 */
export type Tag = {
  __typename?: 'Tag';
  /**
   * The tag's color as a hex triplet, for example `#F523F1`. Use `colorName`
   * where you need a stable identifier rather than a literal color.
   */
  color: Scalars['String']['output'];
  /**
   * Stable Buffer palette identifier derived from `color`.
   * Clients should map this value to platform- and theme-specific presentation,
   * falling back to `color` when this field is null or unsupported.
   * Returns null for custom or unrecognized colors.
   */
  colorName?: Maybe<TagColorName>;
  /** The tag's unique identifier. */
  id: Scalars['TagId']['output'];
  /**
   * Whether the tag is locked.
   *
   * A tag locks when the organization holds more tags than its plan allows,
   * typically after a downgrade. Buffer locks the excess rather than deleting it,
   * so nothing is lost if the organization upgrades again.
   *
   * A locked tag **cannot be edited** — `updateTag` rejects it. It can still be
   * read, deleted, and applied to posts through the API. Buffer's own apps also
   * hide locked tags when picking a tag for a post; that is a client convention,
   * not something the API enforces.
   *
   * Locking is recalculated when the organization's plan changes, and deleting an
   * unlocked tag frees a slot for the oldest locked one.
   */
  isLocked: Scalars['Boolean']['output'];
  /** The tag's display name, for example `Summer sales`. */
  name: Scalars['String']['output'];
};

export type TagActionInIdeasPayload = CoreWebAppCommonError | TagActionInIdeasSuccess;

export type TagActionInIdeasSuccess = CoreWebAppMutationResponse & {
  __typename?: 'TagActionInIdeasSuccess';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

/** Returned when a tag was created or updated successfully. */
export type TagActionSuccess = {
  __typename?: 'TagActionSuccess';
  /** The tag as persisted, read back after the write. */
  tag: Tag;
};

/** Input for fetching a single tag by id. */
export type TagByIdInput = {
  /** The unique identifier of the tag to fetch. */
  id: Scalars['TagId']['input'];
};

/**
 * Stable Buffer identifiers for the supported tag color palette.
 * Clients map these values to platform- and theme-specific presentation.
 * Values ending in `Light` are lighter palette variants, not UI theme modes.
 */
export enum TagColorName {
  /** The standard blue palette color. */
  Blue = 'blue',
  /** The lighter blue palette color. */
  BlueLight = 'blueLight',
  /** The standard gray palette color. */
  Gray = 'gray',
  /** The lighter gray palette color. */
  GrayLight = 'grayLight',
  /** The standard green palette color. */
  Green = 'green',
  /** The lighter green palette color. */
  GreenLight = 'greenLight',
  /** The standard orange palette color. */
  Orange = 'orange',
  /** The lighter orange palette color. */
  OrangeLight = 'orangeLight',
  /** The standard pink palette color. */
  Pink = 'pink',
  /** The lighter pink palette color. */
  PinkLight = 'pinkLight',
  /** The standard purple palette color. */
  Purple = 'purple',
  /** The lighter purple palette color. */
  PurpleLight = 'purpleLight',
  /** The standard red palette color. */
  Red = 'red',
  /** The lighter red palette color. */
  RedLight = 'redLight',
  /** The standard teal palette color. */
  Teal = 'teal',
  /** The lighter teal palette color. */
  TealLight = 'tealLight',
  /** The standard yellow palette color. */
  Yellow = 'yellow',
  /** The lighter yellow palette color. */
  YellowLight = 'yellowLight'
}

/** Comparator for filtering by tags */
export type TagComparator = {
  /** Include results that have any of the specified tags (union/OR). */
  in: Array<Scalars['TagId']['input']>;
  /**
   * When true, include results that have no tags assigned.
   * Can be combined with 'in' for union filtering.
   * Defaults to false if not specified.
   */
  isEmpty?: Scalars['Boolean']['input'];
};

/** An edge in a tag connection. */
export type TagEdge = {
  __typename?: 'TagEdge';
  /** A cursor for pagination. */
  cursor: Scalars['String']['output'];
  /** The tag at the end of the edge. */
  node: Tag;
};

/** Input type for tag information used in idea creation */
export type TagInput = {
  color: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type TagRemovalFromIdeaInput = {
  ideaId: Scalars['ID']['input'];
  tagId: Scalars['ID']['input'];
};

export type TagRemovalFromIdeasInput = {
  organizationId: Scalars['ID']['input'];
  tagId: Scalars['ID']['input'];
};

/** The name and color to give a new tag. */
export type TagToCreateInput = {
  /**
   * The tag's color as a hex triplet: `#` followed by exactly six hex digits, for
   * example `#F523F1`. Shorthand such as `#F51` is rejected. Buffer maps
   * recognized palette colors onto `Tag.colorName`.
   */
  color: Scalars['String']['input'];
  /**
   * The tag's display name, for example `Summer sales`. Between 1 and 100
   * characters, and unique within the organization. Names are compared exactly,
   * so `Summer sales` and `summer sales` can coexist.
   */
  name: Scalars['String']['input'];
};

/**
 * The name and color to set on an existing tag. Both are replaced, so send the
 * current value for the one you are not changing.
 */
export type TagToUpdateInput = {
  /**
   * The tag's color as a hex triplet: `#` followed by exactly six hex digits, for
   * example `#F523F1`. Shorthand such as `#F51` is rejected. Buffer maps
   * recognized palette colors onto `Tag.colorName`.
   */
  color: Scalars['String']['input'];
  /**
   * The tag's display name, for example `Summer sales`. Between 1 and 100
   * characters, and unique within the organization. Names are compared exactly,
   * so `Summer sales` and `summer sales` can coexist.
   */
  name: Scalars['String']['input'];
};

/** A page of an organization's tags. */
export type TagsConnection = {
  __typename?: 'TagsConnection';
  /** The list of tag edges. */
  edges: Array<TagEdge>;
  /** Pagination information for the connection. */
  pageInfo: PaginationPageInfo;
  /** The total number of tags matching the request, across every page. */
  totalCount: Scalars['Int']['output'];
};

/** Filters for listing an organization's tags. Omitted fields do not filter. */
export type TagsFiltersInput = {
  /**
   * Return only locked tags when true, only unlocked tags when false. Omit to
   * return both. See `Tag.isLocked` for what locking means.
   */
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input for listing an organization's tags. */
export type TagsInput = {
  /** Filters to apply. When omitted, all of the organization's tags are returned. */
  filter?: InputMaybe<TagsFiltersInput>;
  /**
   * Organization to list tags for. The caller must be a member of this
   * organization.
   */
  organizationId: Scalars['OrganizationId']['input'];
};

/**
 * A single takeaway shown on the Insights page. Written either by the LLM or by
 * a deterministic builder that derives it from the channel's own data.
 */
export type Takeaway = {
  __typename?: 'Takeaway';
  /** The category for grouping and display */
  category: TakeawayCategory;
  /**
   * The channels this takeaway concerns. Holds one channel for a
   * single-channel takeaway, and every source channel for a cross-channel one.
   */
  channelIds: Array<Scalars['ChannelId']['output']>;
  /**
   * Short CTA button label for the takeaway card action.
   * @deprecated Use ctas instead
   */
  ctaLabel?: Maybe<Scalars['String']['output']>;
  /** Structured CTA buttons for this takeaway. Empty for categories without a defined action. */
  ctas: Array<TakeawayCta>;
  /** Actionable description explaining the takeaway and what to do about it */
  description: Scalars['String']['output'];
  /**
   * ID of a specific draft post to open in the composer when the CTA is clicked.
   * Only present when the takeaway relates to unposted drafts.
   * @deprecated Use metadata.draftId
   */
  draftId?: Maybe<Scalars['PostId']['output']>;
  /**
   * The user's quality vote on this takeaway. Null when no reaction has
   * been recorded. Independent of the takeaway's lifecycle status.
   */
  feedback?: Maybe<TakeawayFeedback>;
  /** Unique identifier for this takeaway */
  id: Scalars['TakeawayId']['output'];
  /**
   * Structured data about the subject of this takeaway (entity IDs, format classifications).
   * Always present; individual fields are nullable when not applicable.
   */
  metadata: TakeawayMetadata;
  /**
   * Identifies the channel selection a cross-channel batch was generated for.
   * Null on single-channel takeaways.
   */
  scopeKey?: Maybe<Scalars['String']['output']>;
  /** Short headline summarizing the takeaway */
  title: Scalars['String']['output'];
};

/** The category of a takeaway recommendation, used to group and display takeaways */
export enum TakeawayCategory {
  CommentEngagement = 'commentEngagement',
  CreatePost = 'createPost',
  EngageAudience = 'engageAudience',
  General = 'general',
  PostingFrequency = 'postingFrequency',
  PublishDraft = 'publishDraft',
  RepostPost = 'repostPost',
  UpdatePostingGoal = 'updatePostingGoal'
}

/** The media format subtype for a createPost takeaway */
export enum TakeawayCreatePostType {
  Carousel = 'carousel',
  Generic = 'generic',
  Reel = 'reel',
  StartWithAi = 'startWithAi',
  Template = 'template'
}

/** A structured CTA button on a takeaway card */
export type TakeawayCta = {
  __typename?: 'TakeawayCta';
  /** The action performed when this CTA is clicked */
  action: TakeawayCtaAction;
  /** Button label text */
  label: Scalars['String']['output'];
  /** The visual variant of the button */
  variant: TakeawayCtaVariant;
};

/** The action a CTA button performs when clicked */
export enum TakeawayCtaAction {
  AdjustPostingGoal = 'adjustPostingGoal',
  AdjustPostingSchedule = 'adjustPostingSchedule',
  CreatePost = 'createPost',
  EngageAudience = 'engageAudience',
  ExploreTemplates = 'exploreTemplates',
  LearnMoreAboutFormat = 'learnMoreAboutFormat',
  PublishDraft = 'publishDraft',
  RepostPost = 'repostPost'
}

/** The visual treatment of a CTA button */
export enum TakeawayCtaVariant {
  Primary = 'primary',
  Secondary = 'secondary'
}

/**
 * The user's quality vote on a takeaway. Decoupled from any UI affordance
 * (thumbs, face icons, text labels) — the values describe the signal,
 * not the widget. Independent of the takeaway's lifecycle status — a
 * completed takeaway can still be marked helpful, a dismissed one
 * unhelpful.
 */
export enum TakeawayFeedback {
  Helpful = 'helpful',
  Unhelpful = 'unhelpful'
}

/**
 * Structured data about the subject of a takeaway — entity references and
 * format classifications that CTA handlers use at runtime.
 */
export type TakeawayMetadata = {
  __typename?: 'TakeawayMetadata';
  /** The media format subtype for createPost takeaways. Present when category is createPost. */
  createPostType?: Maybe<TakeawayCreatePostType>;
  /**
   * ID of a specific draft post to open in the composer when a CTA is clicked.
   * Present when the takeaway relates to unposted drafts.
   */
  draftId?: Maybe<Scalars['PostId']['output']>;
  /**
   * ID of a specific sent post related to this insight. For repostPost CTA actions,
   * clients use this as the source to duplicate into the composer.
   */
  postId?: Maybe<Scalars['PostId']['output']>;
  /**
   * The recommended post template category for a createPost takeaway.
   * @deprecated This field always returns null. Use createPostType instead.
   */
  postTemplateType?: Maybe<TakeawayPostTemplateType>;
  /**
   * Customer-facing prompt to prefill AI Write when createPostType is startWithAi.
   * Only present when createPostType is startWithAi.
   */
  prefillAiPrompt?: Maybe<Scalars['String']['output']>;
};

/**
 * The recommended post template type for a createPost takeaway.
 * @deprecated — use createPostType on TakeawayMetadata instead.
 */
export enum TakeawayPostTemplateType {
  /** @deprecated Use TakeawayMetadata.createPostType instead */
  Story = 'story'
}

export type TaxDetails = {
  __typename?: 'TaxDetails';
  automaticTax?: Maybe<Scalars['String']['output']>;
  ipAddress?: Maybe<Scalars['String']['output']>;
  location?: Maybe<TaxLocation>;
};

export type TaxId = {
  __typename?: 'TaxId';
  country?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
  verification?: Maybe<TaxIdVerification>;
};

export type TaxIdVerification = {
  __typename?: 'TaxIdVerification';
  status?: Maybe<Scalars['String']['output']>;
  verifiedAddress?: Maybe<Scalars['String']['output']>;
  verifiedName?: Maybe<Scalars['String']['output']>;
};

export type TaxLocation = {
  __typename?: 'TaxLocation';
  country?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

/**
 * A team member in an organization with their permissions.
 * Represents an *active* member only — pending invitations are surfaced
 * via the separate `Invitation` type and the `pendingInvitations` query.
 */
export type TeamMember = {
  __typename?: 'TeamMember';
  /** The linked Buffer Account */
  account?: Maybe<Account>;
  /**
   * Per-product channel permissions for this member, keyed by product.
   * Resolved from the stored permission rows via the per-product access
   * resolver, so the `per-product-permissions` split rollout and legacy
   * (pre-per-product) rows surface consistently.
   */
  channelPermissions: Array<ChannelProductPermission>;
  /**
   * The member's Roles role in the organization.
   * Reads as `viewer`, the lowest role, when the organization does not have Roles
   * enabled, or when the member has no stored role yet.
   * Should only be used for displaying to the user, not for authorization
   * purposes. For authorization purposes, use the `allowedActions` field on the
   * entity being acted on (e.g. `Organization.allowedActions`).
   */
  collaborationRole: CollaborationRole;
  /** When the member was added to the organization. */
  createdAt: Scalars['DateTime']['output'];
  /** Email address */
  email: Scalars['String']['output'];
  /** The Account ID (stable identifier for the team member) */
  id: Scalars['AccountId']['output'];
  /** Whether the member's access is locked/revoked */
  isLocked: Scalars['Boolean']['output'];
  /** Whether this team member is the organization owner */
  isOwner: Scalars['Boolean']['output'];
  /** Display name for the team member */
  name: Scalars['String']['output'];
  /**
   * Role at organization level (admin or member).
   * Should only be used for displaying to the user, not for authorization
   * purposes. For authorization purposes, use the `allowedActions` field on the
   * entity being acted on (e.g. `Organization.allowedActions`).
   */
  organizationRole: TeamMemberRole;
};

/**
 * Team member counts for an organization, summarised for the Roles Team
 * Members page.
 *
 * Every count here is of *active* members. Locked members are excluded
 * throughout, even though the members table still lists them so an admin can
 * manage them — so these counts are deliberately smaller than the number of
 * rows the page shows, and the role cards do not sum to that number.
 */
export type TeamMemberCounts = {
  __typename?: 'TeamMemberCounts';
  /**
   * One entry per CollaborationRole, zero counts included, ordered admin,
   * creator, collaborator, viewer.
   */
  byRole: Array<TeamMemberRoleCount>;
  /** Seat limit for the organization. Null when the plan has no member limit. */
  limit?: Maybe<Scalars['Int']['output']>;
  /** Invitations not yet accepted, revoked or expired. */
  pendingInvitations: Scalars['Int']['output'];
  /**
   * Active members including the owner, excluding locked members: the sum of
   * the byRole counts. Zero when the organization is not on Roles.
   */
  total: Scalars['Int']['output'];
};

/** Edge type for paginated team members */
export type TeamMemberEdge = {
  __typename?: 'TeamMemberEdge';
  /** Opaque cursor for pagination */
  cursor: Scalars['String']['output'];
  /** The team member data */
  node: TeamMember;
};

/** Error when team member limit has been reached */
export type TeamMemberLimitReachedError = MutationError & {
  __typename?: 'TeamMemberLimitReachedError';
  /** Human-readable error message. */
  message: Scalars['String']['output'];
};

/**
 * Role at organization level for a team member.
 * Should only be used for displaying to the user, not for authorization
 * purposes. For authorization purposes, use the `allowedActions` field on the
 * entity being acted on (e.g. `Organization.allowedActions`).
 */
export enum TeamMemberRole {
  Admin = 'admin',
  Member = 'member'
}

/**
 * The number of active members holding one CollaborationRole. Locked members
 * are not counted.
 */
export type TeamMemberRoleCount = {
  __typename?: 'TeamMemberRoleCount';
  /**
   * Active members with this role, the owner included and locked members
   * excluded.
   */
  count: Scalars['Int']['output'];
  /** Reserved for per-role seat limits. Null until product defines them. */
  limit?: Maybe<Scalars['Int']['output']>;
  /** The role the count is for. */
  role: CollaborationRole;
};

/** The scope to select team members from. Provide exactly one field. */
export type TeamMemberSelectionScopeInput =
  /**
   * Select from the members who can view this channel. The organization is
   * derived from the channel.
   */
  { channelId: Scalars['ChannelId']['input']; organizationId?: never; }
  |  /** Select from the active members of this organization. */
  { channelId?: never; organizationId: Scalars['OrganizationId']['input']; };

/** Whether a team member's access is active or locked. */
export enum TeamMemberStatusFilter {
  /** Members whose access is not locked. */
  Active = 'active',
  /** Members whose access is locked. */
  Locked = 'locked'
}

/** A team member with their per-product access for a specific channel */
export type TeamMemberWithChannelAccess = {
  __typename?: 'TeamMemberWithChannelAccess';
  /**
   * The member's per-product access for the specific channel, keyed by
   * product (all `none` if not assigned). Resolved via the per-product
   * access resolver so the split rollout and legacy rows are consistent.
   */
  productAccessLevels: ChannelProductAccessLevels;
  /** The team member */
  teamMember: TeamMember;
};

/**
 * Filters for the teamMembers query, honoured only on organizations on Roles.
 * Every filter is optional; the ones given combine with AND. An empty list is
 * treated as omitted.
 */
export type TeamMembersFilterInput = {
  /**
   * Members assigned to any of these channels. A channel permission row is the
   * assignment, so a locked member still matches. Omit for all channels.
   */
  channelIds?: InputMaybe<Array<Scalars['ChannelId']['input']>>;
  /**
   * Members with any of these roles. A member without a stored role matches no
   * roles filter.
   */
  roles?: InputMaybe<Array<CollaborationRole>>;
  /** Omit for all. */
  status?: InputMaybe<TeamMemberStatusFilter>;
};

/** Input for teamMembersForChannel query */
export type TeamMembersForChannelInput = {
  /** The channel ID to get team member permissions for */
  channelId: Scalars['ChannelId']['input'];
  /** The organization ID */
  organizationId: Scalars['OrganizationId']['input'];
};

/** Input for teamMembers query */
export type TeamMembersInput = {
  /**
   * Cursor to start fetching from (for pagination).
   * Can only be provided when first is also specified.
   */
  after?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional filters for the Roles Team Members page. Applied together with
   * `search`, before sorting and pagination, so the first page is the first
   * page of the filtered set. Only applied to organizations on Roles
   * (Organization.isRolesEnabled); ignored for organizations still on legacy
   * permissions.
   */
  filter?: InputMaybe<TeamMembersFilterInput>;
  /**
   * Number of team members to return (for pagination).
   * Must be a positive integer when provided.
   */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** The organization to fetch team members for */
  organizationId: Scalars['OrganizationId']['input'];
  /** Optional search term to filter by name or email */
  search?: InputMaybe<Scalars['String']['input']>;
};

/** Paginated results for team members */
export type TeamMembersResults = {
  __typename?: 'TeamMembersResults';
  /** List of team member edges */
  edges: Array<TeamMemberEdge>;
  /** Pagination information */
  pageInfo: PaginationPageInfo;
};

/** Input Types */
export type TestIdeasInput = {
  number?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['String']['input'];
};

export type TextGenerated = {
  __typename?: 'TextGenerated';
  suggestions: Array<Maybe<TextSuggestionGenerated>>;
};

/** Query / Mutation responses */
export type TextGenerationResponse = CommonError | TextGenerated;

/** Output Types */
export type TextSuggestionGenerated = {
  __typename?: 'TextSuggestionGenerated';
  content: Scalars['String']['output'];
};

/** Bluesky fields on a single item of a thread */
export type ThreadItemBlueskyMetadata = {
  __typename?: 'ThreadItemBlueskyMetadata';
  /** Link attachment */
  linkAttachment?: Maybe<LinkAttachment>;
};

/** Bluesky fields on a single item of a thread */
export type ThreadItemBlueskyMetadataInput = {
  /** Link attachment. Mutually exclusive with a non-empty `assets` array — input providing both is rejected. */
  linkAttachment?: InputMaybe<LinkAttachmentInput>;
};

/**
 * Service-specific fields on a single item of a thread. The populated key matches
 * the post's service.
 */
export type ThreadItemMetadata = {
  __typename?: 'ThreadItemMetadata';
  /** Bluesky fields for this thread item */
  bluesky?: Maybe<ThreadItemBlueskyMetadata>;
  /** Threads fields for this thread item */
  threads?: Maybe<ThreadItemThreadsMetadata>;
};

/**
 * Service-specific fields on a single item of a thread. The key must match the
 * channel's service; input under any other key is rejected.
 */
export type ThreadItemMetadataInput = {
  /** Bluesky fields for this thread item */
  bluesky?: InputMaybe<ThreadItemBlueskyMetadataInput>;
  /** Threads fields for this thread item */
  threads?: InputMaybe<ThreadItemThreadsMetadataInput>;
};

/** Threads fields on a single item of a thread */
export type ThreadItemThreadsMetadata = {
  __typename?: 'ThreadItemThreadsMetadata';
  /** Link attachment */
  linkAttachment?: Maybe<LinkAttachment>;
};

/** Threads fields on a single item of a thread */
export type ThreadItemThreadsMetadataInput = {
  /** Link attachment. Mutually exclusive with a non-empty `assets` array — input providing both is rejected. */
  linkAttachment?: InputMaybe<LinkAttachmentInput>;
};

/**
 * A post authored by the user which is posted to a thread.
 * This is commonly used for long-format twitter and meta threads posts to
 * allow authored content to span multiple threads.
 * Threads are represented as a list of replies, each replying to the previous one.
 */
export type ThreadedPost = {
  __typename?: 'ThreadedPost';
  /** Media assets of the threaded post */
  assets: Array<Asset>;
  /**
   * Use metadata.{service}.linkAttachment on the thread item instead. This field will be removed on December 15, 2026.
   * @deprecated Use metadata.{service}.linkAttachment on the thread item instead. This field will be removed on December 15, 2026.
   */
  linkAttachment?: Maybe<LinkAttachment>;
  /** Service-specific fields for this threaded post */
  metadata?: Maybe<ThreadItemMetadata>;
  /** The text body content of the threaded post */
  text: Scalars['String']['output'];
};

/** How the boundaries for a Threaded Posts option were selected. */
export enum ThreadedPostBoundarySelection {
  /** AI selected an alternative set of deterministically generated boundaries. */
  AiSelected = 'aiSelected',
  /** AI reviewed the deterministic boundaries and confirmed them. */
  AiValidated = 'aiValidated',
  /** Deterministic splitting selected the boundaries. */
  Deterministic = 'deterministic',
  /**
   * Deterministic splitting supplied the boundaries after AI enrichment was
   * unavailable or unusable.
   */
  DeterministicFallback = 'deterministicFallback'
}

/**
 * A post authored by the user which is posted to a thread.
 * This is commonly used for long-format twitter and meta threads posts to
 * allow authored content to span multiple threads.
 * Threads are represented as a list of replies, each replying to the previous one.
 * The first item in the list is the root post of the thread and should match the
 * top-level `text` on the post input; the remaining items are replies.
 */
export type ThreadedPostInput = {
  /** Ordered list of assets on this threaded post */
  assets?: Array<AssetInput>;
  /** Service-specific fields for this threaded post */
  metadata?: InputMaybe<ThreadItemMetadataInput>;
  /** The text body content of the threaded post */
  text?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Common properties for all posts that support threaded replies.
 * See ThreadedPost for more details.
 */
export type ThreadedPostMetadata = {
  /** The list of threaded posts (not paginated) */
  thread: Array<ThreadedPost>;
  /** The number of threaded posts */
  threadCount: Scalars['Int']['output'];
};

/** A Threaded Posts option that preserves every source character exactly. */
export type ThreadedPostSourcePreservingOption = {
  __typename?: 'ThreadedPostSourcePreservingOption';
  /** How this option's boundaries were selected. */
  boundarySelection: ThreadedPostBoundarySelection;
  /** Stable identifier for selecting this option. */
  id: Scalars['String']['output'];
  /** Ordered contiguous slices of the source text. */
  segments: Array<ThreadedPostSourceSegment>;
};

/** A contiguous source-backed thread item produced without rewriting text. */
export type ThreadedPostSourceSegment = {
  __typename?: 'ThreadedPostSourceSegment';
  /** Network-aware character count for this item. */
  characterCount: Scalars['Int']['output'];
  /** Exclusive UTF-16 offset where this item ends in the source text. */
  endUtf16: Scalars['Int']['output'];
  /** Inclusive UTF-16 offset where this item begins in the source text. */
  startUtf16: Scalars['Int']['output'];
  /** Exact source slice covered by the offsets. */
  text: Scalars['String']['output'];
};

export type ThreadsData = {
  __typename?: 'ThreadsData';
  location_id?: Maybe<Scalars['String']['output']>;
  location_name?: Maybe<Scalars['String']['output']>;
  topic?: Maybe<Scalars['String']['output']>;
};

/** Represents a location that can be tagged in Threads posts */
export type ThreadsLocation = {
  __typename?: 'ThreadsLocation';
  /** Street address of the location (optional) */
  address?: Maybe<Scalars['String']['output']>;
  /** City where the location is situated (optional) */
  city?: Maybe<Scalars['String']['output']>;
  /** Country where the location is situated (optional) */
  country?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the location */
  id: Scalars['String']['output'];
  /** Latitude coordinate of the location (optional) */
  latitude?: Maybe<Scalars['Float']['output']>;
  /** Longitude coordinate of the location (optional) */
  longitude?: Maybe<Scalars['Float']['output']>;
  /** Display name of the location */
  name: Scalars['String']['output'];
  /** Postal code of the location (optional) */
  postalCode?: Maybe<Scalars['String']['output']>;
};

/** Threads post metadata */
export type ThreadsPostMetadata = CommonPostMetadata & ThreadedPostMetadata & {
  __typename?: 'ThreadsPostMetadata';
  /** Annotations representing entities in the text */
  annotations: Array<Annotation>;
  /** Link attachment */
  linkAttachment?: Maybe<LinkAttachment>;
  /** LocationId associated with the post */
  locationId?: Maybe<Scalars['String']['output']>;
  /** Location name associated with the post */
  locationName?: Maybe<Scalars['String']['output']>;
  /** The list of threaded posts (not paginated) */
  thread: Array<ThreadedPost>;
  /** The number of threaded posts */
  threadCount: Scalars['Int']['output'];
  /** Topic associated with the post */
  topic?: Maybe<Scalars['String']['output']>;
  /** The channel-specific type of the post, eg, post, story, reel for Instagram */
  type: PostType;
};

/** Threads post metadata */
export type ThreadsPostMetadataInput = {
  /** Link attachment. Mutually exclusive with a non-empty `assets` array — input providing both is rejected. */
  linkAttachment?: InputMaybe<LinkAttachmentInput>;
  /** LocationId associated with the post */
  locationId?: InputMaybe<Scalars['String']['input']>;
  /** Location name associated with the post */
  locationName?: InputMaybe<Scalars['String']['input']>;
  /**
   * The ordered list of posts that make up the thread (not paginated). This
   * array is the source of truth for what gets published: every post in the
   * thread, including the root post, must be provided here. Posts are
   * published in order, each replying to the previous one. The first item is
   * the root post and should match the top-level `text` on the post input.
   */
  thread?: InputMaybe<Array<ThreadedPostInput>>;
  /** Topic associated with the post */
  topic?: InputMaybe<Scalars['String']['input']>;
  /** The type of the post */
  type?: InputMaybe<PostType>;
};

/** TikTok post metadata */
export type TikTokPostMetadataInput = {
  /** Whether the post discloses AI-generated content (TikTok video only) */
  isAiGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  /** The title of the TikTok post (for photo posts) */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Tiktok metadata */
export type TiktokMetadata = {
  __typename?: 'TiktokMetadata';
  /**
   * Indicates if we should default to reminder for Tiktok
   * Source: field resolver: profile.default_to_reminders
   */
  defaultToReminders: Scalars['Boolean']['output'];
};

/** Tiktok post metadata */
export type TiktokPostMetadata = CommonPostMetadata & {
  __typename?: 'TiktokPostMetadata';
  /** Annotations representing entities in the text */
  annotations: Array<Annotation>;
  /** Whether the post discloses AI-generated content (TikTok video only) */
  isAiGenerated: Scalars['Boolean']['output'];
  /** The title of the TikTok post (for photo posts) */
  title?: Maybe<Scalars['String']['output']>;
  /** The channel-specific type of the post, eg, post, story, reel for Instagram */
  type: PostType;
};

/** The time format preference for the account. */
export enum TimeFormat {
  /** The time format in 12-hour format. */
  TwelveHour = 'twelveHour',
  /** The time format in 24-hour format. */
  TwentyFourHour = 'twentyFourHour'
}

/** A single data point in a time series (e.g., followers, reach, views) */
export type TimeSeriesDataPoint = {
  __typename?: 'TimeSeriesDataPoint';
  /** The date of the data point */
  date: Scalars['DateTime']['output'];
  /**
   * How this point's `value` was derived. Tooltips use it to explain whether the
   * value is a real reading (`observed`), carried forward from an earlier reading
   * (`computed`), or a genuine gap with nothing to carry forward (`missing`).
   */
  source: TimeSeriesPointSource;
  /** The metric value on this date (null if no data collected) */
  value?: Maybe<Scalars['Int']['output']>;
  /**
   * Percentage change vs the comparison-period value at the same positional
   * index, expressed as a decimal (e.g. `0.12` for +12%). Populated only on
   * points returned under `primary` when a comparison series is present AND
   * a comparison point exists at this index. Null on `comparison` points,
   * when no comparison was requested, when the comparison series has no
   * point at this index (mismatched lengths), or when the comparison value
   * is 0 or null.
   */
  variation?: Maybe<Scalars['Float']['output']>;
};

/**
 * How a time-series point's `value` was derived, so graph tooltips can explain
 * it. Series are returned for every day in the requested window; this field
 * distinguishes the three kinds of point that fills it.
 */
export enum TimeSeriesPointSource {
  /**
   * No value this day, but an earlier observed point exists in the series, so the
   * value is based on the last snapshot. `value` is null — clients carry the last
   * observed value forward and can label it "as of <last observed date>".
   */
  Computed = 'computed',
  /**
   * No value this day and no earlier observed point to carry forward (leading
   * edge of the series). `value` is null — clients show "no data yet".
   */
  Missing = 'missing',
  /**
   * A real value was stored/aggregated for this day. `value` is the number
   * (post counts are always observed — a zero-post day is a true 0).
   */
  Observed = 'observed'
}

/**
 * Input for toggling whether a channel's chosen verified capability is
 * synchronized to (displayed on) the connected platform's profile.
 */
export type ToggleChannelCapabilitySynchronizationInput = {
  /** The channel whose capability synchronization should be toggled. */
  channelId: Scalars['ChannelId']['input'];
  /** Whether the chosen capability should be synchronized to (shown on) the platform. */
  toggle: Scalars['Boolean']['input'];
};

/** Possible responses for the toggleChannelCapabilitySynchronization mutation. */
export type ToggleChannelCapabilitySynchronizationPayload = EmptySuccess | VoidMutationError;

export type TokenUsageInput = {
  featureAction: FeatureAction;
  usedTokens?: InputMaybe<Scalars['Int']['input']>;
};

/** Error returned when the input query string is too short */
export type TooShortQueryStringError = MutationError & {
  __typename?: 'TooShortQueryStringError';
  /** Error message */
  message: Scalars['String']['output'];
};

/** Paginated connection of top-performing posts across all channels. */
export type TopPostsConnection = {
  __typename?: 'TopPostsConnection';
  /** The list of top-post edges for this page. */
  edges: Array<TopPostsEdge>;
  /** Pagination metadata. */
  pageInfo: PaginationPageInfo;
  /** Total number of posts matching the current filters (for computing page count). */
  totalCount: Scalars['Int']['output'];
};

/** An edge in the `topPosts` connection. */
export type TopPostsEdge = {
  __typename?: 'TopPostsEdge';
  /**
   * Opaque cursor. Encodes the post's absolute offset in the current sorted
   * result set. Treat as a black box — pass back as `after` to fetch the
   * next page. Clients must reset `after` to null when filters or sort
   * change; a cursor constructed under one filter state has no meaningful
   * relationship to the ranking under a different filter state.
   */
  cursor: Scalars['String']['output'];
  /** The post at the current position. */
  node: Post;
};

/**
 * Input for the `topPosts` query. Combines shared insights filtering with
 * a required sort configuration — sort lives in `input` (not alongside it)
 * so it stays stable across paginated requests.
 */
export type TopPostsInput = {
  /**
   * Optional comparison period end date. Must be provided together with
   * `comparisonStartDate`.
   */
  comparisonEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * Optional comparison period start date. Must be provided together with
   * `comparisonEndDate`.
   *
   * A connection returns one list, so — unlike `allChannelsPostInsights`, which
   * returns the primary and comparison series side by side — providing these
   * switches the connection to the comparison window: the posts returned are the
   * ones sent within `[comparisonStartDate, comparisonEndDate]`. `filter` keeps
   * its usual meaning throughout, naming the primary window the comparison
   * belongs to, so the two windows stay distinguishable.
   *
   * That distinction is what the free-plan history cap reads: it is measured
   * against `filter.startDate` (the primary window) and never against the
   * comparison window, matching `allChannelsPostInsights`, which likewise serves
   * a comparison window without measuring it against the cap. Without it a free
   * organization's default "Previous Period" comparison — which reaches ~60 days
   * back from a 30-day primary range — was rejected outright (CORE-7746).
   *
   * Mismatched-length comparisons are allowed, as on `allChannelsPostInsights`:
   * a Month-to-Date primary range is deliberately compared against a full
   * previous month.
   */
  comparisonStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * Shared insights filter (organization, date range, channel filter, tag
   * filter). Always describes the primary window, even when the comparison
   * fields above switch which window's posts are returned.
   */
  filter: InsightsFilterInput;
  /** Sort configuration for the top posts ranking. */
  sort: TopPostsSortInput;
};

/** Sort order for top posts ranking */
export enum TopPostsSortBy {
  AverageTimeWatched = 'averageTimeWatched',
  Clicks = 'clicks',
  Comments = 'comments',
  EngagementRate = 'engagementRate',
  Follows = 'follows',
  Impressions = 'impressions',
  /** @deprecated Use reactions instead */
  Likes = 'likes',
  Quotes = 'quotes',
  Reach = 'reach',
  Reactions = 'reactions',
  /** @deprecated Use comments instead */
  Replies = 'replies',
  Reposts = 'reposts',
  Saves = 'saves',
  Shares = 'shares',
  TotalTimeWatched = 'totalTimeWatched',
  Viewers = 'viewers',
  Views = 'views'
}

/** Sort configuration for the `topPosts` query. */
export type TopPostsSortInput = {
  /** Sort direction. */
  direction: SortDirection;
  /** The metric to sort by. */
  field: TopPostsSortBy;
};

/** A guided-tour step that highlights product features. */
export type TourStep = {
  __typename?: 'TourStep';
  /** Optional description displayed to the user. */
  description?: Maybe<Scalars['String']['output']>;
  /** Whether the user can skip this step. */
  isSkippable: Scalars['Boolean']['output'];
  /** Items to display in the tour. */
  items: Array<TourStepItem>;
  /** Unique identifier for the step within its flow. */
  slug: Scalars['String']['output'];
  /** Title displayed to the user. */
  title: Scalars['String']['output'];
};

/** A single item displayed within a tour step. */
export type TourStepItem = {
  __typename?: 'TourStepItem';
  /** Description of the tour item. */
  description: Scalars['String']['output'];
  /** Optional link URL for the tour item. */
  link?: Maybe<Scalars['URL']['output']>;
  /** Optional link title for the tour item. */
  linkTitle?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the item within its step. */
  slug: Scalars['String']['output'];
  /** Title of the tour item. */
  title: Scalars['String']['output'];
};

/** Response type for track an action in a survey or saved a completed survey */
export type TrackActionOnboardingSurveySuccess = {
  __typename?: 'TrackActionOnboardingSurveySuccess';
  /** The actions taken during the onboarding survey. */
  actionsTaken: Array<OnboardingSurveyActionTaken>;
  /** onboarding survey saved in the DB */
  surveyId: Scalars['String']['output'];
};

export type TrackExternalServiceUsageResponse = Error | Response;

/** Error type for specific transfer-related issues. */
export type TransferError = MutationError & {
  __typename?: 'TransferError';
  /**
   * A human-readable message explaining why the transfer cannot happen.
   * E.g., the new owner is not an Admin, they have channels, or are not on the
   * Free plan
   */
  message: Scalars['String']['output'];
};

/** Input for transferOrganizationOwnership mutation */
export type TransferOrganizationOwnershipInput = {
  /** The ID of the account that will become the new owner. */
  newOwner: Scalars['AccountId']['input'];
  /** The ID of the organization for which ownership is being transferred. */
  organizationId: Scalars['OrganizationId']['input'];
};

/** Mutation Response: Success and errors for transferOrganizationOwnership */
export type TransferOrganizationOwnershipPayload = EmptySuccess | TransferError;

/** Input for trending Instagram audio for one channel. */
export type TrendingInstagramAudioInput = {
  /** Music or original sound catalog */
  audioType: InstagramAudioType;
  /** Instagram channel to load trending audio for */
  channelId: Scalars['ChannelId']['input'];
};

/** A single trending topic */
export type TrendingTopic = {
  __typename?: 'TrendingTopic';
  /** Optional description of the topic */
  description?: Maybe<Scalars['String']['output']>;
  /** External identifier for the topic from the source platform */
  externalId: Scalars['String']['output'];
  /** The topic title/name */
  title: Scalars['String']['output'];
};

/** Location codes supported for trending topics */
export enum TrendingTopicLocationCode {
  Jp = 'JP',
  Us = 'US'
}

export type Trial = {
  __typename?: 'Trial';
  endDate: Scalars['DateTime']['output'];
  isActive: Scalars['Boolean']['output'];
  /** Returns whether an admin need to take an action: it happens when the trial expires, we present the admin with a modal to decide if they want to start paying for Buffer */
  isAwaitingUserAction: Scalars['Boolean']['output'];
  remainingDays: Scalars['Int']['output'];
  startDate: Scalars['DateTime']['output'];
};

/** Twitter metadata */
export type TwitterMetadata = {
  __typename?: 'TwitterMetadata';
  /** Indicates the type of subscription the user has on Twitter */
  subscriptionType?: Maybe<Scalars['String']['output']>;
};

/** Twitter post metadata */
export type TwitterPostMetadata = CommonPostMetadata & ThreadedPostMetadata & {
  __typename?: 'TwitterPostMetadata';
  /** Annotations representing entities in the text */
  annotations: Array<Annotation>;
  /** Whether the post discloses AI-generated content */
  isAiGenerated: Scalars['Boolean']['output'];
  /** The details of the tweet being retweeted */
  retweet?: Maybe<RetweetMetadata>;
  /** The list of threaded posts (not paginated) */
  thread: Array<ThreadedPost>;
  /** The number of threaded posts */
  threadCount: Scalars['Int']['output'];
  /** The channel-specific type of the post, eg, post, story, reel for Instagram */
  type: PostType;
};

/** Twitter post metadata */
export type TwitterPostMetadataInput = {
  /** Whether the post discloses AI-generated content (original tweets only, never retweets) */
  isAiGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  /** The details of the tweet being retweeted */
  retweet?: InputMaybe<RetweetMetadataInput>;
  /**
   * The ordered list of posts that make up the thread (not paginated). This
   * array is the source of truth for what gets published: every post in the
   * thread, including the root post, must be provided here. Posts are
   * published in order, each replying to the previous one. The first item is
   * the root post and should match the top-level `text` on the post input.
   */
  thread?: InputMaybe<Array<ThreadedPostInput>>;
};

/** Input for confirming Two Factor Authentication */
export type TwoFactorConfirmInput = {
  /** Confirmation Code */
  code: Scalars['String']['input'];
  /**
   * Proof that the caller holds the Two Factor Authentication that is already on
   * the account. Give a one-time password from the current method, or the current
   * recovery code. The account must send this to change an existing method. First
   * time setup does not need it, because there is no method to prove yet.
   */
  currentCode?: InputMaybe<Scalars['String']['input']>;
  /** The Account with the Two Factor Authentication set up */
  key: Scalars['String']['input'];
  /** Method type */
  method: TwoFactorMethod;
};

/** The payload of the response from TwoFactorConfirm */
export type TwoFactorConfirmPayload = InvalidInputError | TwoFactorConfirmResponse | UnexpectedError;

/** The response for confirming Two Factor Authentication */
export type TwoFactorConfirmResponse = {
  __typename?: 'TwoFactorConfirmResponse';
  /** Recovery code */
  recoveryCode: Scalars['String']['output'];
};

/**
 * Input for disabling Two Factor Authentication with Account ID
 * This is used for Buffer Admin to disable Two Factor Authentication for an account
 */
export type TwoFactorDisableByAccountIdInput = {
  /** The Account ID */
  accountId: Scalars['AccountId']['input'];
};

/** The payload of the response from TwoFactorDisable */
export type TwoFactorDisablePayload = EmptySuccess | UnexpectedError;

/** The type of Two Factor Authentication method */
export enum TwoFactorMethod {
  App = 'app',
  Email = 'email'
}

/** The input for showing the Two Factor recovery code */
export type TwoFactorRecoveryCodeInput = {
  /** The one time password code */
  code: Scalars['String']['input'];
};

/** The Payload for Two Factor Recovery Code */
export type TwoFactorRecoveryCodePayload = InvalidInputError | TwoFactorRecoveryCodeResponse | UnexpectedError;

/** The response for showing the Two Factor recovery code */
export type TwoFactorRecoveryCodeResponse = {
  __typename?: 'TwoFactorRecoveryCodeResponse';
  /** The recovery code */
  recoveryCode: Scalars['String']['output'];
};

/** The Payload for Two Factor Request One-Time Password */
export type TwoFactorRequestOneTimePasswordPayload = EmptySuccess | UnexpectedError;

/** Input for setting up Two Factor Authentication */
export type TwoFactorSetupInput = {
  /** Method type */
  method: TwoFactorMethod;
};

/** The payload of the response from TwoFactorSetup */
export type TwoFactorSetupPayload = InvalidInputError | TwoFactorSetupResponse | UnexpectedError;

/**
 * Error when the inviting organization enforces two-factor authentication
 * and the accepting user hasn't enabled it yet. Directly user-actionable:
 * the client walks the user through 2FA setup, then retries the accept.
 */
export type TwoFactorSetupRequiredError = MutationError & {
  __typename?: 'TwoFactorSetupRequiredError';
  /** Human-readable error message. */
  message: Scalars['String']['output'];
};

/** The response for setting up Two Factor Authentication */
export type TwoFactorSetupResponse = {
  __typename?: 'TwoFactorSetupResponse';
  /** The Account with the Two Factor Authentication set up */
  key?: Maybe<Scalars['String']['output']>;
};

/** Error returned when the user is not authorized to perform the action */
export type UnauthorizedError = MutationError & {
  __typename?: 'UnauthorizedError';
  /** Error message */
  message: Scalars['String']['output'];
};

/**
 * Input type for the `undismissComment` mutation.
 * Defines the comment being undismissed.
 */
export type UndismissCommentInput = {
  /** ID of the comment being undismissed. */
  commentId: Scalars['CommentId']['input'];
};

/** Mutation Response: Success and errors */
export type UndismissCommentPayload = InvalidInputError | NotFoundError | UnauthorizedError | UndismissCommentSuccess | UnexpectedError;

/** Successful undismiss response. */
export type UndismissCommentSuccess = {
  __typename?: 'UndismissCommentSuccess';
  /** The comment that was successfully undismissed. */
  comment: CommentData;
};

/** Input for the undismissEngagement mutation. */
export type UndismissEngagementInput = {
  /** Unique identifier of the engagement to undismiss. */
  engagementId: Scalars['EngagementId']['input'];
  /** Type of engagement to undismiss (mention or comment). */
  engagementType: EngagementType;
};

/** Result of the undismissEngagement mutation. */
export type UndismissEngagementPayload = UndismissEngagementSuccess | VoidMutationError;

/** Returned when the engagement was successfully undismissed. */
export type UndismissEngagementSuccess = {
  __typename?: 'UndismissEngagementSuccess';
  /** The undismissed engagement item. */
  engagement: Engagement;
};

/** Error returned when unexpected error occurs */
export type UnexpectedError = MutationError & {
  __typename?: 'UnexpectedError';
  /** Error message */
  message: Scalars['String']['output'];
};

/** Optional refinements for the unreplied count. */
export type UnrepliedConversationCountsFilters = {
  /** Range over `lastActivityAt`, as on the inbox. */
  lastActivityAt?: InputMaybe<DateTimeRange>;
};

/** Input for the unrepliedConversationCounts query. */
export type UnrepliedConversationCountsInput = {
  /** Channels to count. Omitted counts every channel the actor may read. */
  channelIds?: InputMaybe<Array<Scalars['ChannelId']['input']>>;
  /** Optional filters to narrow down the count. */
  filters?: InputMaybe<UnrepliedConversationCountsFilters>;
  /**
   * Cap on the per-channel count, at most 1000. Defaults to 1000 when omitted or
   * not a positive integer; the cap applied is echoed back on each
   * `ConversationCountByChannel`.
   */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Organization whose inbox to count. */
  organizationId: Scalars['OrganizationId']['input'];
};

/** Response for the unrepliedConversationCounts query. */
export type UnrepliedConversationCountsResponse = {
  __typename?: 'UnrepliedConversationCountsResponse';
  /**
   * One entry per channel the user can access within the requested scope, zero
   * counts included.
   */
  counts: Array<ConversationCountByChannel>;
};

/** Input for the unresolveConversation mutation. */
export type UnresolveConversationInput = {
  /** Conversation to take back out of `resolved`. */
  conversationId: Scalars['ConversationId']['input'];
};

/** Result of the unresolveConversation mutation. */
export type UnresolveConversationPayload = ConversationMutationSuccess | VoidMutationError;

/** Error message returned when channel is a non-supported type */
export type UnsupportedChannelError = MutationError & {
  __typename?: 'UnsupportedChannelError';
  /** Error message returned when token is requested for unsupported channel */
  message: Scalars['String']['output'];
};

export type UnverifiedEmailAddressError = {
  __typename?: 'UnverifiedEmailAddressError';
  cause: Scalars['String']['output'];
};

export type UpcomingInvoiceCostsPreview = {
  __typename?: 'UpcomingInvoiceCostsPreview';
  chargeAmount: Scalars['Float']['output'];
  creditAmount: Scalars['Float']['output'];
  isScheduledChange: Scalars['Boolean']['output'];
  nextBillingDate: Scalars['DateTime']['output'];
};

/** Input for updateAPIClient mutation */
export type UpdateApiClientInput = {
  /** The client ID of the API Client to update */
  clientId: Scalars['String']['input'];
  /** The updated name of the API Client */
  clientName: Scalars['String']['input'];
  /** The updated logo URI */
  logoUri?: InputMaybe<Scalars['String']['input']>;
  /** The updated privacy policy URI */
  privacyPolicyUri?: InputMaybe<Scalars['String']['input']>;
  /** The updated redirect URIs */
  redirectUris: Array<Scalars['String']['input']>;
  /**
   * The scopes the client should have. Existing scopes cannot be removed; any new
   * scopes are added to the client's granted set.
   */
  scopes?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** All possible response types that can be returned by updateAPIClient mutation. */
export type UpdateApiClientPayload = InvalidInputError | InvalidRedirectUrisError | NotFoundError | UpdateApiClientSuccess;

/** Successful response for updateAPIClient mutation */
export type UpdateApiClientSuccess = {
  __typename?: 'UpdateAPIClientSuccess';
  /** The updated API Client */
  client: ApiClient;
};

/** Input for suspendAPIClient mutation */
export type UpdateApiClientSuspensionStatusInput = {
  /** The action to perform */
  action: ApiClientSuspensionAction;
  /** The id of the API Client */
  id: Scalars['String']['input'];
};

/** Response for updateAPIClientSuspensionStatus mutation */
export type UpdateApiClientSuspensionStatusPayload = NotFoundError | UpdateApiClientSuspensionStatusSuccess;

/** Successful response for updateAPIClientSuspensionStatus mutation */
export type UpdateApiClientSuspensionStatusSuccess = {
  __typename?: 'UpdateAPIClientSuspensionStatusSuccess';
  /** The updated API Client */
  client: ApiClient;
};

/** Input for the updateAccountAvatar mutation */
export type UpdateAccountAvatarInput = {
  /** new url for the account avatar */
  url: Scalars['String']['input'];
};

/** updateAccountAvatar response payload */
export type UpdateAccountAvatarPayload = InvalidInputError | NotFoundError | UnexpectedError | UpdateAccountAvatarSuccess;

/** success response for deleteAccount mutation */
export type UpdateAccountAvatarSuccess = MutationSuccess & {
  __typename?: 'UpdateAccountAvatarSuccess';
  /**
   * The value is always an empty string ''
   * Note: GraphQL doesn't allow types with no fields, so we have to add this field
   */
  _empty: Scalars['String']['output'];
};

/** Input for the updateAccountName mutation */
export type UpdateAccountNameInput = {
  /** new name for the account */
  name: Scalars['String']['input'];
};

/** updateAccountName response payload */
export type UpdateAccountNamePayload = InvalidInputError | NotFoundError | UnauthorizedError | UnexpectedError | UpdateAccountNameSuccess;

/** success response for updateName mutation */
export type UpdateAccountNameSuccess = MutationSuccess & {
  __typename?: 'UpdateAccountNameSuccess';
  /**
   * The value is always an empty string ''
   * Note: GraphQL doesn't allow types with no fields, so we have to add this field
   */
  _empty: Scalars['String']['output'];
};

/** Input for the updatePreferences mutation */
export type UpdateAccountPreferencesInput = {
  /** default schedule option, if not provided, the default schedule option will not be updated */
  defaultScheduleOption?: InputMaybe<ScheduleOption>;
  /**
   * The user's landing-page choice. Omit to leave unchanged. Set to `home` to
   * opt the user into Buffer Home; set to `default` to clear an explicit
   * choice and fall back to the client's current default route.
   */
  landingPage?: InputMaybe<LandingPage>;
  /** The Community mentions-counter display preference. Omit to leave unchanged. */
  mentionsCounter?: InputMaybe<MentionsCounterDisplay>;
  /** start of week, if not provided, the start of week will not be updated */
  startOfWeek?: InputMaybe<StartOfWeek>;
  /** time format, if not provided, the time format will not be updated */
  timeFormat?: InputMaybe<TimeFormat>;
};

/** updatePreferences response payload */
export type UpdateAccountPreferencesPayload = InvalidInputError | UpdateAccountPreferencesSuccess;

/** success response for updatePreferences mutation */
export type UpdateAccountPreferencesSuccess = {
  __typename?: 'UpdateAccountPreferencesSuccess';
  /**
   * The value is always an empty string ''
   * Note: GraphQL doesn't allow types with no fields, so we have to add this field
   */
  preferences: Preferences;
};

/** Input for updateAccountTimezone mutation */
export type UpdateAccountTimezoneInput = {
  /** New timezone to set */
  timezone: Scalars['String']['input'];
};

/** updateAccountTimezone response payload */
export type UpdateAccountTimezonePayload = InvalidInputError | NotFoundError | UnexpectedError | UpdateAccountTimezoneSuccess;

/** success response for updateAccountTimezone mutation */
export type UpdateAccountTimezoneSuccess = {
  __typename?: 'UpdateAccountTimezoneSuccess';
  /** The id of the updated account */
  accountId: Scalars['AccountId']['output'];
  /** The updated timezone for the account */
  timezone: Scalars['String']['output'];
};

/** input for updateAdminComment mutation */
export type UpdateAdminCommentInput = {
  /** ID of the account that will have the comment applied */
  accountId: Scalars['AccountId']['input'];
  /** Text to be applied as a comment to the account */
  message: Scalars['String']['input'];
};

/** updateAdminComment response payload */
export type UpdateAdminCommentPayload = NotFoundError | UnauthorizedError | UnexpectedError | UpdateAdminCommentSuccess;

/** success response for updateAdminComment mutation */
export type UpdateAdminCommentSuccess = {
  __typename?: 'UpdateAdminCommentSuccess';
  /** Returns the updated admin comment */
  adminComment: Scalars['String']['output'];
};

/** Input parameters required to update the subscription plan */
export type UpdateBillingSubscriptionPlanInput = {
  /** The attribution for the subscription */
  attribution?: InputMaybe<AttributionInput>;
  /** The interval to update the subscription plan for */
  interval: BillingInterval;
  /** The ID of the organization to update the subscription plan for */
  organizationId: Scalars['OrganizationId']['input'];
  /** The plan to update the subscription plan for */
  plan: ObPlanId;
  /** The quantity to update the subscription plan for */
  quantity: Scalars['Int']['input'];
};

/** The payload response of the update billing subscription plan mutation */
export type UpdateBillingSubscriptionPlanPayload = UpdateBillingSubscriptionPlanResponse | VoidMutationError;

/** Response type for updating the subscription plan */
export type UpdateBillingSubscriptionPlanResponse = {
  __typename?: 'UpdateBillingSubscriptionPlanResponse';
  /**
   * Payment action requirements for completing the subscription update.
   * Only populated when status is 'requiresAction' and Strong Customer Authentication is required.
   * Contains client secret needed for 3D Secure authentication flow.
   * Mutually exclusive with scheduledUpdate.
   */
  paymentAction?: Maybe<PaymentActionRequired>;
  /**
   * The scheduled update for the subscription plan, if applicable.
   * Only populated when the update is scheduled for a future date (e.g., downgrade at period end).
   * Mutually exclusive with paymentAction.
   */
  scheduledUpdate?: Maybe<ScheduledSubscriptionUpdateV2>;
  /**
   * Status of the subscription update operation.
   * - 'success': Update completed immediately
   * - 'requiresAction': Payment requires additional user authentication (SCA/3D Secure)
   */
  status: SubscriptionUpdateStatus;
};

/** Bluesky-specific metadata for custom channel update */
export type UpdateBlueskyMetadata = {
  /** Bluesky account App Password */
  appPassword?: InputMaybe<Scalars['String']['input']>;
  /** Bluesky account Handle (username) */
  handle?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updateChangelogEntry mutation */
export type UpdateChangelogEntryInput = {
  /** The audience of the changelog entry. */
  audience: ChangelogEntryAudience;
  /** The content of the changelog entry */
  content: Scalars['String']['input'];
  /** The cover image URL of the changelog entry */
  coverImageUrl?: InputMaybe<Scalars['URL']['input']>;
  /**
   * Optional call-to-action buttons for a modal-display entry (max 2). Omit to
   * leave the existing CTAs untouched; pass `null` to clear them.
   */
  ctas?: InputMaybe<Array<ChangelogEntryCtaInput>>;
  /**
   * Optional display type. Omit to leave the entry's existing display type
   * untouched (so editors without modal controls don't reset it).
   */
  displayType?: InputMaybe<ChangelogEntryDisplayType>;
  /**
   * Optional auto-retire date (applies to popover or modal entries). Omit to
   * leave unchanged; pass `null` to clear it (no expiry).
   */
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The id of the changelog entry */
  id: Scalars['ChangelogEntryId']['input'];
  /**
   * Optional publish date. When provided, updates the entry's publish date used
   * for ordering and visibility; left unchanged when omitted.
   */
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * Optional URL-safe slug. Omit to leave the existing slug untouched; provide
   * to overwrite it (the backend re-normalizes and resolves collisions).
   */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** Optional short, plain-text intro shown under the title in modal display. */
  summary?: InputMaybe<Scalars['String']['input']>;
  /** The title of the changelog entry */
  title: Scalars['String']['input'];
};

/** Mutation Response: Success and errors */
export type UpdateChangelogEntryPayload = ChangelogEntry | VoidMutationError;

/** Input for updateChannelGroup mutation */
export type UpdateChannelGroupInput = {
  /** The channels to be added to the group */
  channelIds?: InputMaybe<Array<Scalars['ChannelId']['input']>>;
  /** The id of the channel group */
  id: Scalars['ChannelGroupId']['input'];
  /** The name of the channel group */
  name: Scalars['String']['input'];
};

/** Mutation Response: Success and errors */
export type UpdateChannelGroupPayload = ChannelGroup | UnauthorizedError | UnexpectedError;

/** Input for updating multiple members' permissions for a single channel */
export type UpdateChannelMemberPermissionsInput = {
  /** The channel ID to update permissions for */
  channelId: Scalars['ChannelId']['input'];
  /** The member permissions to set (replaces existing permissions for specified members) */
  memberPermissions: Array<MemberChannelPermissionInput>;
  /** The organization ID */
  organizationId: Scalars['OrganizationId']['input'];
};

/** Result of updating multiple members' permissions for a single channel. */
export type UpdateChannelMemberPermissionsPayload = NotFoundError | UpdateChannelMemberPermissionsSuccess;

/** Success payload for updating channel member permissions */
export type UpdateChannelMemberPermissionsSuccess = {
  __typename?: 'UpdateChannelMemberPermissionsSuccess';
  /** The number of members whose permissions were updated */
  updatedCount: Scalars['Int']['output'];
};

/** Input for updating channel permissions */
export type UpdateChannelPermissionsInput = {
  /** The Account ID of the team member */
  accountId: Scalars['AccountId']['input'];
  /**
   * The new per-product channel assignments (replaces all existing channel
   * permissions). An assignment whose every product is `none` grants no
   * channel access. The FE maps the current single-dropdown UI onto
   * `publish` and sends `comments: none` until the per-product UI lands.
   */
  channelAssignments: Array<ChannelProductAssignmentInput>;
  /** The organization ID */
  organizationId: Scalars['OrganizationId']['input'];
};

/** Result of updating a team member's channel permissions. */
export type UpdateChannelPermissionsPayload = NotFoundError | UpdateChannelPermissionsSuccess;

/** Success payload for updating channel permissions */
export type UpdateChannelPermissionsSuccess = {
  __typename?: 'UpdateChannelPermissionsSuccess';
  /** The updated team member */
  teamMember: TeamMember;
};

/** Input for updating the posting goal for a Channel */
export type UpdateChannelPostingGoalInput = {
  /** The channel id to update the posting goal */
  channelId: Scalars['ChannelId']['input'];
  /** The posting goal */
  goal: Scalars['Int']['input'];
  /**
   * Indicates if the posting schedules should be overridden
   * @deprecated Use scheduleUpdateMode instead
   */
  overridePostingSchedules?: InputMaybe<Scalars['Boolean']['input']>;
  /** The mode for updating the posting schedule: override, add, or none */
  scheduleUpdateMode?: InputMaybe<ScheduleUpdateMode>;
};

/** The payload of the response from updateChannelPostingGoal */
export type UpdateChannelPostingGoalPayload = InvalidInputError | NotFoundError | UnauthorizedError | UnexpectedError | UpdateChannelPostingGoalResponse;

/** The response for updating the posting goal for a Channel */
export type UpdateChannelPostingGoalResponse = {
  __typename?: 'UpdateChannelPostingGoalResponse';
  /** The posting goal updated from the Channel */
  channel: Channel;
};

/** The content that replaces a collaboration Note. */
export type UpdateCollaborationNoteInput = {
  /** The annotations for the Note. Omit or pass null to replace them with an empty list. */
  annotations?: InputMaybe<Array<AnnotationInput>>;
  /** The Note ID. */
  noteId: Scalars['NoteId']['input'];
  /** The replacement Note text. */
  text: Scalars['String']['input'];
};

/** The possible results from collaboration Note update. */
export type UpdateCollaborationNotePayload = InvalidInputError | UpdateCollaborationNoteSuccess;

/** The result of a successful collaboration Note update. */
export type UpdateCollaborationNoteSuccess = {
  __typename?: 'UpdateCollaborationNoteSuccess';
  /** The updated Note. */
  note: CollaborationNote;
};

/** A recoverable error that prevented a content item draft from being updated. */
export type UpdateContentItemDraftError = ContentItemStateError | InvalidInputError;

/** updateContentItemDraft failure. */
export type UpdateContentItemDraftFailure = MutationError & {
  __typename?: 'UpdateContentItemDraftFailure';
  /** The recoverable errors behind this failure. */
  errors: Array<UpdateContentItemDraftError>;
  /** Summary error message. */
  message: Scalars['String']['output'];
};

/** Input for updateContentItemDraft. */
export type UpdateContentItemDraftInput = {
  /** The new draft content. Replaces the current draft in full. */
  draft: DraftContentInput;
  /** The content item whose channel-less draft is replaced. */
  id: Scalars['ContentItemId']['input'];
  /**
   * Tags to apply to this content item. Omit to keep the current tags. An
   * empty list or null removes them all.
   */
  tagIds?: InputMaybe<Array<Scalars['TagId']['input']>>;
  /**
   * Date indicating when this piece of content should go out. This is a
   * planning aid only and does not schedule any posts. Omit to preserve the
   * existing target date. Null clears it.
   */
  targetDate?: InputMaybe<Scalars['DateTime']['input']>;
};

/** All possible responses for updateContentItemDraft. */
export type UpdateContentItemDraftPayload = UpdateContentItemDraftFailure | UpdateContentItemDraftSuccess;

/** Successful updateContentItemDraft response. */
export type UpdateContentItemDraftSuccess = {
  __typename?: 'UpdateContentItemDraftSuccess';
  /** The updated content item. */
  contentItem: ContentItem;
};

/**
 * updateContentItem failure. When any part of the input is invalid, nothing is
 * changed.
 */
export type UpdateContentItemFailure = MutationError & {
  __typename?: 'UpdateContentItemFailure';
  /** The recoverable errors behind this failure. */
  errors: Array<InvalidInputError>;
  /** Summary error message. */
  message: Scalars['String']['output'];
};

/**
 * Input for updateContentItem. Only the fields provided are changed. Omitted
 * fields keep their current value.
 */
export type UpdateContentItemInput = {
  /** The content item to update. */
  id: Scalars['ContentItemId']['input'];
  /** Omit to preserve the existing target date. Null clears it. */
  targetDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Omit to preserve the existing title. Null clears it. */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** All possible responses for updateContentItem. */
export type UpdateContentItemPayload = UpdateContentItemFailure | UpdateContentItemSuccess;

/** Successful updateContentItem response. */
export type UpdateContentItemSuccess = {
  __typename?: 'UpdateContentItemSuccess';
  /** The content item after the update. */
  contentItem: ContentItem;
};

/** Input for updating custom channels, like Bluesky or FB Group */
export type UpdateCustomChannelInput = {
  /** Channel ID of updated channel */
  channelId: Scalars['ChannelId']['input'];
  /** Channel-specific metadata to use during creation */
  customChannelMetadata?: InputMaybe<UpdateCustomChannelMetadata>;
  /** Timezone to be used for this channel */
  timezone?: InputMaybe<Scalars['String']['input']>;
};

/** Channel-specific metadata for custom channel update */
export type UpdateCustomChannelMetadata = {
  /** Bluesky-specific metadata */
  blueskyMetadata?: InputMaybe<UpdateBlueskyMetadata>;
  /** FB Group-specific metadata */
  facebookGroupMetadata?: InputMaybe<UpdateFacebookGroupMetadata>;
  /** IG Personal Profile-specific metadata */
  instagramPersonalProfileMetadata?: InputMaybe<UpdateInstagramPersonalProfileMetadata>;
};

/** Payload for updateCustomChannel mutation */
export type UpdateCustomChannelPayload = CustomChannelError | UpdateCustomChannelResponse;

/** The response for custom channel refresh */
export type UpdateCustomChannelResponse = {
  __typename?: 'UpdateCustomChannelResponse';
  /** Updated channel */
  channel: Channel;
};

/** Input to update custom links colors for a channel */
export type UpdateCustomLinksColorsInput = {
  /** The channel id to update the custom links colors */
  channelId: Scalars['ChannelId']['input'];
  /** The color for the custom links */
  color: Scalars['HexColorCode']['input'];
  /** The contrast color for the custom links */
  contrastColor: Scalars['HexColorCode']['input'];
};

/** The response for updating custom links colors for a Channel */
export type UpdateCustomLinksColorsPayload = EmptySuccess | InvalidInputError | NotFoundError | UnauthorizedError | UnexpectedError;

/** Input for the updateCustomerIOAttributes mutation */
export type UpdateCustomerIoAttributesInput = {
  /** The account ID to update customer attributes for. */
  accountId: Scalars['AccountId']['input'];
  /** The customer attributes to update in Customer.io */
  attributes: CustomerIoAttributesInput;
};

/** updateCustomerIOAttributes response payload */
export type UpdateCustomerIoAttributesPayload = UpdateCustomerIoAttributesSuccess | VoidMutationError;

/** Success response for updateCustomerIOAttributes mutation */
export type UpdateCustomerIoAttributesSuccess = MutationSuccess & {
  __typename?: 'UpdateCustomerIOAttributesSuccess';
  /**
   * The value is always an empty string ''
   * Note: GraphQL doesn't allow types with no fields, so we have to add this field
   */
  _empty: Scalars['String']['output'];
};

/** Facebook Group-specific metadata for custom channel update */
export type UpdateFacebookGroupMetadata = {
  /** Avatar URL of this FB Group */
  avatar?: InputMaybe<Scalars['String']['input']>;
  /** Name of this FB Group */
  name?: InputMaybe<Scalars['String']['input']>;
  /** URL to FB Group's page */
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updateFeedCollection mutation */
export type UpdateFeedCollectionInput = {
  /** Id of the feed collection to update */
  feedCollectionId: Scalars['FeedCollectionId']['input'];
  /**
   * Feeds to subscribe to in this feed, if not set, will not update
   * @deprecated(reason: "Use moveFeed mutation to manage feed associations")
   */
  feedIds?: InputMaybe<Array<Scalars['FeedId']['input']>>;
  /** The name of the feed collection. If set, this will override the name of the feed. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The organization that the feed collection will belong to */
  organizationId?: InputMaybe<Scalars['OrganizationId']['input']>;
};

/** Input for updateFeed mutation */
export type UpdateFeedInput = {
  /** The feed to update */
  id: Scalars['FeedId']['input'];
  /** New name for the feed. If set, this overrides the name provided by the feed itself. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The organization that owns the feed */
  organizationId: Scalars['OrganizationId']['input'];
};

/** All possible response types for the updateFeed mutation. */
export type UpdateFeedPayload = FeedActionSuccess | NotFoundError | UnauthorizedError | UnexpectedError;

/** Input type for updating an idea group. */
export type UpdateIdeaGroupInput = {
  /** Unique identifier for the idea group. */
  id: Scalars['ID']['input'];
  /** The name of the idea group. */
  name: Scalars['String']['input'];
};

/** Union type representing possible payloads for updating an idea group. */
export type UpdateIdeaGroupPayload = IdeaGroup | InvalidInputError | NotFoundError | UnauthorizedError | UnexpectedError;

/** updateIdea input type */
export type UpdateIdeaInput = {
  /** New content and metadata for the idea */
  content: IdeaContentInput;
  /** Call-to-action identifier for analytics tracking */
  cta?: InputMaybe<Scalars['String']['input']>;
  /** New group ID (null for unassigned group) */
  groupId?: InputMaybe<Scalars['ID']['input']>;
  /** ID of the idea to update */
  id: Scalars['String']['input'];
};

/** updateIdea response (including errors) */
export type UpdateIdeaPayload = IdeaResponse | InvalidInputError | UnauthorizedError | UnexpectedError;

/** Instagram Personal Profile-specific metadata for custom channel update */
export type UpdateInstagramPersonalProfileMetadata = {
  /** Avatar URL for the channel */
  avatar?: InputMaybe<Scalars['String']['input']>;
  /** Name of this IG Profile */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating lastActivityAt for a channel */
export type UpdateLastActivityAtForChannelInput = {
  /** The channel id to update the lastActivityAt */
  channelId: Scalars['ChannelId']['input'];
};

/** UpdateChannelLastActivityAt possible responses */
export type UpdateLastActivityAtForChannelPayload = UnauthorizedError | UnexpectedError | UpdateLastActivityAtForChannelSuccess;

/** success response for updateLastActivityAtForChannel mutation */
export type UpdateLastActivityAtForChannelSuccess = MutationSuccess & {
  __typename?: 'UpdateLastActivityAtForChannelSuccess';
  /**
   * The value is always an empty string ''
   * Note: GraphQL doesn't allow types with no fields, so we have to add this field
   */
  _empty: Scalars['String']['output'];
};

/** Input for updating an existing Buffer-managed post template. */
export type UpdateManagedPostTemplateInput = {
  /** The main content body of the template. */
  body?: InputMaybe<Scalars['String']['input']>;
  /** A short user-facing description of the template. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The emoji associated with the template. */
  emoji?: InputMaybe<Scalars['String']['input']>;
  /** Whether this template is featured. */
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  /** The goal or intent behind the template. */
  goal?: InputMaybe<PostTemplateGoal>;
  /** The ID of the template to update. */
  id: Scalars['PostTemplateId']['input'];
  /** The structural format of the template. */
  structure?: InputMaybe<PostTemplateStructure>;
  /** Tags to apply to the template. */
  tags?: InputMaybe<Array<PostTemplateTag>>;
  /** The title of the template. */
  title?: InputMaybe<Scalars['String']['input']>;
  /** The type or category of the template. */
  type?: InputMaybe<PostTemplateType>;
  /** The target user types for this template. */
  userTypes?: InputMaybe<Array<PostTemplateUserType>>;
  /** The visibility level of the template. */
  visibility?: InputMaybe<PostTemplateVisibility>;
};

/** Result of updating a Buffer-managed post template. */
export type UpdateManagedPostTemplatePayload = UpdateManagedPostTemplateSuccess | VoidMutationError;

/** Successful result of updating a Buffer-managed post template. */
export type UpdateManagedPostTemplateSuccess = {
  __typename?: 'UpdateManagedPostTemplateSuccess';
  /** The updated post template. */
  postTemplate: PostTemplate;
};

/** Input type for updating a note on a post */
export type UpdateNoteOnPostInput = {
  /** The ID of the note */
  noteId: Scalars['NoteId']['input'];
  /** The ID of the post */
  postId: Scalars['PostId']['input'];
  /** The new text for the note */
  text: Scalars['String']['input'];
};

/** Union type representing the possible outcomes of the updateNoteOnPost mutation */
export type UpdateNoteOnPostPayload = InvalidInputError | LimitReachedError | NotFoundError | UnauthorizedError | UnexpectedError | UpdateNoteOnPostSuccess;

/** Type returned on successful update of a note on a post */
export type UpdateNoteOnPostSuccess = {
  __typename?: 'UpdateNoteOnPostSuccess';
  /** The post with the updated note */
  post: Post;
};

/** Input for updating an organization's billing email address */
export type UpdateOrganizationBillingEmailInput = {
  /**
   * The billing email address to set for invoice notifications.
   * Set to null or omit to clear and revert to using owner's email.
   * Must be a valid email format if provided.
   */
  billingEmail?: InputMaybe<Scalars['String']['input']>;
  /** The organization ID to update */
  organizationId: Scalars['OrganizationId']['input'];
};

/** Union of possible responses from updating billing email */
export type UpdateOrganizationBillingEmailPayload = BillingEmailValidationError | UpdateOrganizationBillingEmailSuccess;

/** Successful response when billing email is updated */
export type UpdateOrganizationBillingEmailSuccess = {
  __typename?: 'UpdateOrganizationBillingEmailSuccess';
  /** The updated billing email. This always returns a value: either the newly set custom billing email, or the organization owner's email if cleared. */
  billingEmail: Scalars['String']['output'];
  /** Confirmation that the operation succeeded */
  success: Scalars['Boolean']['output'];
};

/** Input for updateOrganizationEnforce2FA mutation */
export type UpdateOrganizationEnforce2FaInput = {
  /** Whether all members of the organization must have 2FA configured to use Buffer. */
  enforce2FA: Scalars['Boolean']['input'];
  /** The ID of the organization whose 2FA enforcement is being updated. */
  organizationId: Scalars['OrganizationId']['input'];
};

/** Mutation Response: Success and errors for updateOrganizationEnforce2FA */
export type UpdateOrganizationEnforce2FaPayload = EmptySuccess | VoidMutationError;

/** Input for the updatePassword mutation */
export type UpdatePasswordInput = {
  /** New Password to update Account with */
  newPassword: Scalars['String']['input'];
  /** Current Password for Account to verify if we allow updating the password */
  password: Scalars['String']['input'];
};

/** updatePassword response payload */
export type UpdatePasswordPayload = EmptySuccess | InvalidInputError | UnauthorizedError | UnexpectedError;

export type UpdatePostDueAtInput = {
  postId: Scalars['String']['input'];
  timestamp: Scalars['Int']['input'];
};

/** @deprecated: use the generic PostUpdatedPayload */
export type UpdatePostDueAtMutationResponse = CoreWebAppCommonError | PostNotFound | PostNotUpdated | PostUpdated;

/** Update post's tags request input. */
export type UpdatePostTagsInput = {
  /** Post id to update. */
  id: Scalars['PostId']['input'];
  /**
   * The entire list of tags to assign to the Post. This list will fully replace the existing one.
   * E.g., if a post has two tags and you call this mutation with a new tag, the Post will have only the new tag assigned and the two old tags will be removed.
   */
  tags: Array<Scalars['TagId']['input']>;
};

/** Update post's tags request response payload. */
export type UpdatePostTagsPayload = NotFoundError | PostActionSuccess | RestProxyError | UnauthorizedError | UnexpectedError;

/**
 * Input for updating an existing post template campaign. Only the ID is required;
 * all other fields are optional and only provided fields will be updated.
 */
export type UpdatePostTemplateCampaignInput = {
  /** A banner color. */
  bannerColor?: InputMaybe<Scalars['HexColorCode']['input']>;
  /** The type of campaign. */
  campaignType?: InputMaybe<PostCampaignType>;
  /** A description of the campaign. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The end date. Must be after startDate. */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The heading displayed on the campaign. */
  heading?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the campaign to update. */
  id: Scalars['PostTemplateCampaignId']['input'];
  /** An illustration URL. */
  illustration?: InputMaybe<Scalars['String']['input']>;
  /** The internal name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Whether templates are shown after the campaign end date. */
  showTemplatesAfterEndDate?: InputMaybe<Scalars['Boolean']['input']>;
  /** The URL-friendly slug. */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** The start date. */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The status of the campaign. */
  status?: InputMaybe<PostCampaignStatus>;
  /** Whether the campaign supports a banner display. */
  supportsBanner?: InputMaybe<Scalars['Boolean']['input']>;
  /** The IDs of post templates to include. Replaces the entire list. */
  templateIds?: InputMaybe<Array<Scalars['PostTemplateId']['input']>>;
  /** The user-facing title. */
  title?: InputMaybe<Scalars['String']['input']>;
  /** An optional tooltip for the campaign toggle. */
  toggleTip?: InputMaybe<CampaignToggleTipInput>;
};

/** Result of updating a post template campaign. */
export type UpdatePostTemplateCampaignPayload = InvalidInputError | NotFoundError | UpdatePostTemplateCampaignSuccess;

/** Successful result of updating a post template campaign. */
export type UpdatePostTemplateCampaignSuccess = {
  __typename?: 'UpdatePostTemplateCampaignSuccess';
  /** The updated campaign. */
  postTemplateCampaign: PostTemplateCampaign;
};

/**
 * Input for an end user updating a post template. Buffer-curated
 * taxonomy fields are ignored; setting them is only available to
 * official Buffer clients.
 */
export type UpdatePostTemplateInput = {
  /** The main content body of the template, may contain {{placeholders}}. */
  body?: InputMaybe<Scalars['String']['input']>;
  /** A short user-facing description of the template. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The emoji associated with the template. */
  emoji?: InputMaybe<Scalars['String']['input']>;
  /** Ignored for non-manager actors. Honored by `updateManagedPostTemplate`. */
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  /** Ignored for non-manager actors. Honored by `updateManagedPostTemplate`. */
  goal?: InputMaybe<PostTemplateGoal>;
  /** The ID of the template to update. */
  id: Scalars['PostTemplateId']['input'];
  /** Ignored for non-manager actors. Honored by `updateManagedPostTemplate`. */
  structure?: InputMaybe<PostTemplateStructure>;
  /** Ignored for non-manager actors. Honored by `updateManagedPostTemplate`. */
  tags?: InputMaybe<Array<PostTemplateTag>>;
  /** The title of the template. */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Ignored for non-manager actors. Honored by `updateManagedPostTemplate`. */
  type?: InputMaybe<PostTemplateType>;
  /** Ignored for non-manager actors. Honored by `updateManagedPostTemplate`. */
  userTypes?: InputMaybe<Array<PostTemplateUserType>>;
  /**
   * `public` is rejected — it is only available to official Buffer
   * clients.
   */
  visibility?: InputMaybe<PostTemplateVisibility>;
};

/** Result of an end user updating a post template. */
export type UpdatePostTemplatePayload = UpdatePostTemplateSuccess | VoidMutationError;

/** Successful result of an end user updating a post template. */
export type UpdatePostTemplateSuccess = {
  __typename?: 'UpdatePostTemplateSuccess';
  /** The updated post template. */
  postTemplate: PostTemplate;
};

/** Input type for updating a saved reply. */
export type UpdateSavedReplyInput = {
  /** Id of the saved reply to update. */
  id: Scalars['SavedReplyId']['input'];
  /** The new data for the saved reply. */
  savedReply: SavedReplyToUpdateInput;
};

/**
 * Response type for the updateSavedReply mutation.
 * It can return either success or an error.
 */
export type UpdateSavedReplyPayload = DuplicateError | InvalidInputError | NotFoundError | SavedReplyActionSuccess | UnauthorizedError | UnexpectedError;

/** Input for updating a saved view */
export type UpdateSavedViewInput = {
  /** Updated identity color — one of the fixed palette tokens */
  color?: InputMaybe<Scalars['String']['input']>;
  /** Updated filter state */
  filters?: InputMaybe<Scalars['FilterJSON']['input']>;
  /** Updated identity icon — a registry key resolved by the client icon registry */
  icon?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the saved view to update */
  id: Scalars['SavedViewId']['input'];
  /** Updated display name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The organization the saved view belongs to */
  organizationId: Scalars['OrganizationId']['input'];
  /** Updated view within the section */
  view?: InputMaybe<Scalars['String']['input']>;
};

/** Update Saved View Payload: Success and errors */
export type UpdateSavedViewPayload = InvalidInputError | NotFoundError | SavedView;

/** Input for the mutation to update a shop grid custom link */
export type UpdateShopGridCustomLinkInput = {
  /** The ID of the channel */
  channelId: Scalars['ChannelId']['input'];
  /** The ID of the custom link to be updated */
  id: Scalars['ShopGridLinkId']['input'];
  /** Link text to be saved */
  text: Scalars['String']['input'];
  /** URL to be saved */
  url: Scalars['String']['input'];
};

/** Input for the mutation to update a shop grid post link */
export type UpdateShopGridPostLinkInput = {
  /** The ID of the channel */
  channelId: Scalars['ChannelId']['input'];
  /** Link to be saved */
  link?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the post to be updated */
  postId: Scalars['PostId']['input'];
};

/** Mutation Payload for updating shop grid link: Success and errors */
export type UpdateShopGridPostLinkPayload = EmptySuccess | NotFoundError | UnauthorizedError | UnexpectedError;

/** Input for the updateSnippet mutation. Both name and text are replaced. */
export type UpdateSnippetInput = {
  /** The snippet to update. */
  id: Scalars['SnippetId']['input'];
  /** The new display name of the snippet. */
  name: Scalars['String']['input'];
  /** The organization that owns the snippet. */
  organizationId: Scalars['OrganizationId']['input'];
  /** The new hashtags, as the text that is inserted into a post. */
  text: Scalars['String']['input'];
};

/**
 * All possible responses for updateSnippet. VoidMutationError reports an
 * empty or too long name or text.
 */
export type UpdateSnippetPayload = UpdateSnippetSuccess | VoidMutationError;

/** Success response of the updateSnippet mutation. */
export type UpdateSnippetSuccess = {
  __typename?: 'UpdateSnippetSuccess';
  /** The snippet after the update. */
  snippet: Snippet;
};

/** Input for the updateStartOfWeekPreference mutation */
export type UpdateStartOfWeekPreferenceInput = {
  /** preferences to update */
  startOfWeek: StartOfWeek;
};

/** updateStartOfWeekPreference response payload */
export type UpdateStartOfWeekPreferencePayload = InvalidInputError | NotFoundError | UnauthorizedError | UnexpectedError | UpdateStartOfWeekPreferenceSuccess;

/** success response for updateStartOfWeekPreference mutation */
export type UpdateStartOfWeekPreferenceSuccess = MutationSuccess & {
  __typename?: 'UpdateStartOfWeekPreferenceSuccess';
  /**
   * The value is always an empty string ''
   * Note: GraphQL doesn't allow types with no fields, so we have to add this field
   */
  _empty: Scalars['String']['output'];
};

/** Input parameters required to update the subscription quantity */
export type UpdateSubscriptionQuantityInput = {
  /** The attribution for the subscription */
  attribution?: InputMaybe<AttributionInput>;
  /** The ID of the organization to update the subscription quantity for */
  organizationId: Scalars['OrganizationId']['input'];
  /** The new quantity for the subscription */
  quantity: Scalars['Int']['input'];
};

/** The payload response of the update subscription quantity mutation */
export type UpdateSubscriptionQuantityPayload = UpdateBillingSubscriptionPlanResponse | VoidMutationError;

export type UpdateTagInIdeasInput = {
  color: Scalars['String']['input'];
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  tagId: Scalars['ID']['input'];
};

/** Input for updating a tag. */
export type UpdateTagInput = {
  /**
   * The tag to update. Its organization is taken from the tag itself, and the
   * caller must be an administrator of that organization.
   */
  id: Scalars['TagId']['input'];
  /** The name and color to set on the tag. */
  tag: TagToUpdateInput;
};

/**
 * The result of `updateTag`: the tag as it now stands, or the reason the edit was
 * refused.
 *
 * **Members on the way out.** `RestProxyError`, `NotFoundError`,
 * `UnauthorizedError` and `UnexpectedError` are being removed from this union. No
 * new operation should select them by name.
 *
 * `RestProxyError` is never returned. The other three describe situations a caller
 * cannot correct — the tag not existing, the caller not being permitted, an
 * unexpected fault — and will be reported in the response's top-level `errors`
 * array instead of here.
 *
 * Select `... on MutationError { message }` rather than naming concrete error
 * types. Every error member implements that interface, so the selection keeps
 * working across the change.
 */
export type UpdateTagPayload = DuplicateError | InvalidInputError | NotFoundError | RestProxyError | TagActionSuccess | UnauthorizedError | UnexpectedError;

/** Input for updating a team member's organization role */
export type UpdateTeamMemberRoleInput = {
  /** The Account ID of the team member */
  accountId: Scalars['AccountId']['input'];
  /** The organization ID */
  organizationId: Scalars['OrganizationId']['input'];
  /** The new organization role */
  organizationRole: TeamMemberRole;
};

/** Result of updating a team member's organization role. */
export type UpdateTeamMemberRolePayload = LastAdminError | NotFoundError | UpdateTeamMemberRoleSuccess;

/** Success payload for updating team member role */
export type UpdateTeamMemberRoleSuccess = {
  __typename?: 'UpdateTeamMemberRoleSuccess';
  /** The updated team member */
  teamMember: TeamMember;
};

/** Input for the updateTimeFormatPreference mutation */
export type UpdateTimeFormatPreferenceInput = {
  /** preferences to update */
  timeFormat: TimeFormat;
};

/** updateTimeFormatPreference response payload */
export type UpdateTimeFormatPreferencePayload = InvalidInputError | NotFoundError | UnauthorizedError | UnexpectedError | UpdateTimeFormatPreferenceSuccess;

/** success response for updateTimeFormatPreference mutation */
export type UpdateTimeFormatPreferenceSuccess = MutationSuccess & {
  __typename?: 'UpdateTimeFormatPreferenceSuccess';
  /**
   * The value is always an empty string ''
   * Note: GraphQL doesn't allow types with no fields, so we have to add this field
   */
  _empty: Scalars['String']['output'];
};

/** Input for setting the timezone for a Channel */
export type UpdateTimezoneForChannelInput = {
  /** The channel id to update the timezone */
  channelId: Scalars['ChannelId']['input'];
  /** The timezone value (IANA timezone format) */
  timezone: Scalars['TimeZone']['input'];
};

/** The payload of the response from updateTimezoneForChannel */
export type UpdateTimezoneForChannelPayload = InvalidInputError | NotFoundError | UnauthorizedError | UnexpectedError | UpdateTimezoneForChannelResponse;

/** The response for updating timezone for a Channel */
export type UpdateTimezoneForChannelResponse = {
  __typename?: 'UpdateTimezoneForChannelResponse';
  /** The timezone updated in the Channel */
  channel: Channel;
};

/** Input for updating trending topic suggestions visibility for a channel */
export type UpdateTrendingTopicSuggestionsVisibilityInput = {
  /** The channel id to update the setting for */
  channelId: Scalars['ChannelId']['input'];
  /** Whether to show trending topic suggestions in the composer */
  showTrendingTopicSuggestions: Scalars['Boolean']['input'];
};

/** The payload of the response from updateTrendingTopicSuggestionsVisibility */
export type UpdateTrendingTopicSuggestionsVisibilityPayload = InvalidInputError | NotFoundError | UpdateTrendingTopicSuggestionsVisibilitySuccess;

/** The response for updating trending topic suggestions visibility */
export type UpdateTrendingTopicSuggestionsVisibilitySuccess = {
  __typename?: 'UpdateTrendingTopicSuggestionsVisibilitySuccess';
  /** The updated channel */
  channel: Channel;
};

/** Input parameters required to upgrade an organization's plan to annual billing */
export type UpgradePlanToAnnualBillingInput = {
  /** The attribution for the subscription upgrade */
  attribution?: InputMaybe<AttributionInput>;
  /** The ID of the organization to upgrade to annual billing */
  organizationId: Scalars['OrganizationId']['input'];
};

/** Union type representing either a successful annual billing upgrade or a billing error */
export type UpgradePlanToAnnualBillingPayload = BillingError | UpgradePlanToAnnualBillingResponse;

/** Response type for upgrading a plan to annual billing */
export type UpgradePlanToAnnualBillingResponse = {
  __typename?: 'UpgradePlanToAnnualBillingResponse';
  /**
   * Payment action requirements for completing the subscription update.
   * Only populated when status is 'requiresAction' and Strong Customer Authentication is required.
   * Contains client secret needed for 3D Secure authentication flow.
   */
  paymentAction?: Maybe<PaymentActionRequired>;
  /**
   * Status of the subscription update operation.
   * - 'success': Update completed immediately
   * - 'requiresAction': Payment requires additional user authentication (SCA/3D Secure)
   */
  status: SubscriptionUpdateStatus;
};

export type UploadDetails = {
  __typename?: 'UploadDetails';
  duration: Scalars['Int']['output'];
  durationMs: Scalars['Int']['output'];
  height: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  location?: Maybe<Scalars['String']['output']>;
  transcodedLocation?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

export type UploadIdInput = {
  id: Scalars['String']['input'];
};

export type UploadPayload = CoreWebAppCommonError | UploadDetails;

/** The type of uploads we support. It will determine where we store the media in S3. */
export enum UploadType {
  AccountAvatar = 'accountAvatar',
  ChannelAvatar = 'channelAvatar',
  ClientLogo = 'clientLogo',
  PostAsset = 'postAsset',
  StartPageAsset = 'startPageAsset'
}

/** Details to be used when allowing users to upvote service functionality */
export type UpvoteDetails = {
  __typename?: 'UpvoteDetails';
  /**
   * The (optional) message to be displayed when the feature upvote has been tracked. Clients should fallback to a default
   * message if this is not provided.
   */
  message?: Maybe<Scalars['String']['output']>;
  /** The ID to be used when tracking the upvote for the feature */
  upvoteId: Scalars['Int']['output'];
};

/**
 * An enum representing the streak status used to map client content.
 * The underlying logic is opaque and simply indicates the user-facing streak status.
 */
export enum UserStreakState {
  ChannelConnectionStreakCelebration = 'ChannelConnectionStreakCelebration',
  ExistingStreakAtRisk = 'ExistingStreakAtRisk',
  ExistingStreakHit = 'ExistingStreakHit',
  ExistingStreakHitAndAhead = 'ExistingStreakHitAndAhead',
  ExistingStreakOnTrack = 'ExistingStreakOnTrack',
  ExistingStreakOnTrackAndAhead = 'ExistingStreakOnTrackAndAhead',
  NewStreakHit = 'NewStreakHit',
  NewStreakHitAndAhead = 'NewStreakHitAndAhead',
  NewStreakNoProgress = 'NewStreakNoProgress',
  NewStreakOnTrack = 'NewStreakOnTrack',
  NewStreakOnTrackAndAhead = 'NewStreakOnTrackAndAhead',
  PerfectMonthCelebration = 'PerfectMonthCelebration',
  StreakLost = 'StreakLost'
}

/** User tag in the image */
export type UserTag = {
  __typename?: 'UserTag';
  /** The handle (username) of the tagged account, without the leading @. */
  handle: Scalars['String']['output'];
  /** Horizontal position of the tag as a normalized decimal float between 0.0 and 1.0 - the fraction of the image width from the left edge (0.5 is the horizontal center). */
  x: Scalars['Float']['output'];
  /** Vertical position of the tag as a normalized decimal float between 0.0 and 1.0 - the fraction of the image height from the top edge (0.5 is the vertical center). */
  y: Scalars['Float']['output'];
};

/** User tag in the image */
export type UserTagInput = {
  /** The handle (username) of the account to tag, without the leading @. */
  handle: Scalars['String']['input'];
  /** Horizontal position of the tag as a normalized decimal float between 0.0 and 1.0 - the fraction of the image width from the left edge (0.5 is the horizontal center). Pass a number, not a string, and do not use pixel coordinates; to convert, divide the pixel X by the image width. */
  x: Scalars['Float']['input'];
  /** Vertical position of the tag as a normalized decimal float between 0.0 and 1.0 - the fraction of the image height from the top edge (0.5 is the vertical center). Pass a number, not a string, and do not use pixel coordinates; to convert, divide the pixel Y by the image height. */
  y: Scalars['Float']['input'];
};

/** Input for the validateAPIClientName query */
export type ValidateApiClientNameInput = {
  /** The client name to validate */
  clientName: Scalars['String']['input'];
};

/** Validate API Client Name Query Payload */
export type ValidateApiClientNamePayload = InvalidInputError | ValidateApiClientNameSuccess;

/** Response for validateAPIClientName query */
export type ValidateApiClientNameSuccess = {
  __typename?: 'ValidateAPIClientNameSuccess';
  /** Whether the client name is valid */
  isValid: Scalars['Boolean']['output'];
};

/**
 * A validation rule constraining how a content property may be used. Each
 * concrete rule carries only the fields it needs; new constraint kinds are
 * additive (a new type implementing this interface). Clients switch on
 * `__typename`.
 */
export type ValidationRule = {
  /** The content property this rule constrains. */
  property: ContentProperty;
};

/** input for verifyAccountLogin mutation */
export type VerifyAccountLoginInput = {
  /** Account id to verify login for. */
  accountId: Scalars['AccountId']['input'];
};

/** verifyAccountLogin response payload */
export type VerifyAccountLoginPayload = VerifyAccountLoginSuccess | VoidMutationError;

/** success response for verifyAccountLogin mutation */
export type VerifyAccountLoginSuccess = MutationSuccess & {
  __typename?: 'VerifyAccountLoginSuccess';
  /**
   * The value is always an empty string ''
   * Note: GraphQL doesn't allow types with no fields, so we have to add this field
   */
  _empty: Scalars['String']['output'];
};

/** Input for the verifyPassword mutation */
export type VerifyPasswordInput = {
  /** current password for the account to be verified */
  password: Scalars['String']['input'];
};

/** verifyPassword response payload */
export type VerifyPasswordPayload = InvalidInputError | NotFoundError | UnauthorizedError | UnexpectedError | VerifyPasswordSuccess;

/** success response for verifypassword mutation */
export type VerifyPasswordSuccess = MutationSuccess & {
  __typename?: 'VerifyPasswordSuccess';
  /**
   * The value is always an empty string ''
   * Note: GraphQL doesn't allow types with no fields, so we have to add this field
   */
  _empty: Scalars['String']['output'];
};

/** input for verifyTfaCode mutation */
export type VerifyTfaCodeInput = {
  /** TFA code to verify. */
  tfaCode: Scalars['String']['input'];
};

/** verifyTfaCode response payload. */
export type VerifyTfaCodePayload = InvalidInputError | MutationBasicResponse | NotFoundError | UnexpectedError;

/** Video asset */
export type VideoAsset = Asset & {
  __typename?: 'VideoAsset';
  /** The ID of the asset in the database */
  id?: Maybe<Scalars['ID']['output']>;
  /** The MIME type of the asset */
  mimeType: Scalars['String']['output'];
  /** URL to the file source */
  source: Scalars['String']['output'];
  /** URL to the static thumbnail of the asset */
  thumbnail: Scalars['String']['output'];
  /** The type of the asset */
  type: AssetType;
  /** Video specific metadata */
  video: VideoMetadata;
};

/** Video asset */
export type VideoAssetInput = {
  /** Video specific metadata */
  metadata?: InputMaybe<VideoMetadataInput>;
  /**
   * Do not use: social networks do not accept custom video thumbnail images, and
   * the API rejects video assets that set this field. To choose the video
   * thumbnail, set `metadata.thumbnailOffset` to select a frame from the video
   * (supported for Instagram, TikTok, and Pinterest only).
   */
  thumbnailUrl?: InputMaybe<Scalars['String']['input']>;
  /** URL to the file source */
  url: Scalars['String']['input'];
};

/** Video metadata */
export type VideoMetadata = {
  __typename?: 'VideoMetadata';
  /** Audio codec */
  audioCodec?: Maybe<Scalars['String']['output']>;
  /** Video container format */
  containerFormat?: Maybe<Scalars['String']['output']>;
  /** Video duration in seconds */
  durationMs: Scalars['Int']['output'];
  /** Video fileSize in bytes */
  fileSize?: Maybe<Scalars['Int']['output']>;
  /** Video framerate */
  frameRate?: Maybe<Scalars['Int']['output']>;
  /** Video height in pixels */
  height: Scalars['Int']['output'];
  /** Whether the video needs to be transcoded before it can be broadcasted */
  isTranscodingRequired: Scalars['Boolean']['output'];
  /** Whether the video is currently being processed (transcoding in progress) */
  isVideoProcessing: Scalars['Boolean']['output'];
  /** Rotation degree */
  rotationDegree?: Maybe<Scalars['Int']['output']>;
  /** Offset of the thumbnail chosen for the video, in ms */
  thumbnailOffset?: Maybe<Scalars['Int']['output']>;
  /** Video title */
  title?: Maybe<Scalars['String']['output']>;
  /** Video bitrate in kbps */
  videoBitRate?: Maybe<Scalars['Int']['output']>;
  /** Video codec */
  videoCodec?: Maybe<Scalars['String']['output']>;
  /** Video width in pixels */
  width: Scalars['Int']['output'];
};

/** Video metadata */
export type VideoMetadataInput = {
  /** Offset of the thumbnail chosen for the video, in ms */
  thumbnailOffset?: InputMaybe<Scalars['Int']['input']>;
  /** Video title */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Error returned when video still processing error occurs */
export type VideoProcessingError = MutationError & {
  __typename?: 'VideoProcessingError';
  /** Error message */
  message: Scalars['String']['output'];
};

/**
 * Error implementation that allows clients to resolve the MutationError on mutations that do not currently have typed errors.
 * This allows clients to automatically handle errors that may be added to a mutation in future.
 *
 * Do not directly throw this error, use a custom typed error instead
 */
export type VoidMutationError = MutationError & {
  __typename?: 'VoidMutationError';
  /** Error message */
  message: Scalars['String']['output'];
};

/**
 * Billing information for organizations on web-based gateways (Stripe, PayPal,
 * and other non-mobile processors). Contains payment method details, tax information,
 * discounts, and invoice data not available on mobile platforms.
 */
export type WebBillingDetails = BillingDetails & {
  __typename?: 'WebBillingDetails';
  /**
   * The billing address on file. All inner fields are nullable since Stripe
   * allows partial addresses. An empty object indicates no address is on file.
   */
  address: BillingAddress;
  /** The customer's account balance with currency. */
  balance: AccountBalance;
  /**
   * The email address used for billing notifications (invoices, payment failures, etc.).
   * Returns the custom billing email if set, otherwise the organization owner's email.
   */
  billingEmail: Scalars['String']['output'];
  /** Whether this organization is eligible to start a free trial. */
  canStartTrial: Scalars['Boolean']['output'];
  /**
   * All active discounts applied to this organization's billing. Ordered by application
   * priority — when multiple discounts exist, they must be applied first to last.
   * Includes both customer-level and subscription-level discounts.
   */
  discounts: Array<PlanDiscount>;
  /**
   * Details about the most recent failed payment, if the subscription is past due.
   * Null when the subscription is in good standing. Provides richer context than
   * subscription.isPaymentPastDue, including a human-readable failure reason and
   * a URL where the customer can retry payment.
   */
  failedPayment?: Maybe<FailedPayment>;
  /** The current billing gateway processing payments for this organization. */
  gateway: BillingGatewayDetails;
  /** Whether this organization has ever had a paid subscription, across any gateway. */
  hasEverBeenPayingCustomer: Scalars['Boolean']['output'];
  /**
   * Whether this organization's subscription uses tiered per-channel pricing.
   * When true, Plan.pricing contains multiple tiers; when false, it contains a single tier.
   */
  isTieredPricing: Scalars['Boolean']['output'];
  /**
   * Preview of the next upcoming invoice. Returns zero amounts when there is no
   * upcoming invoice (e.g. canceled subscription, free plan).
   * Resolved via a separate Stripe API call.
   */
  nextInvoice?: Maybe<NextInvoice>;
  /**
   * The customer's current payment method on file. Null if no payment method is configured
   * (e.g. free plan users who have never entered payment details).
   */
  paymentMethodDetails?: Maybe<PaymentMethodDetails>;
  /**
   * The previous billing gateway, if the organization has migrated between platforms.
   * Null if no migration has occurred.
   */
  previousGateway?: Maybe<BillingGatewayDetails>;
  /** Whether this customer must contact Support to change their subscription. */
  requiresAssistedBilling: Scalars['Boolean']['output'];
  /** The organization's current subscription, including plan, billing cycle, and trial status. */
  subscription: BufferSubscription;
  /** Tax configuration and registered tax IDs for this organization's Stripe customer. */
  taxDetails: BillingTaxDetails;
};

/** Weekly posting limit for a channel */
export type WeeklyPostingLimit = {
  __typename?: 'WeeklyPostingLimit';
  /** The weekly posting limit for the channel */
  limit: Scalars['Int']['output'];
  /** The number of posts the channel has scheduled for this week */
  scheduled: Scalars['Int']['output'];
  /** The number of posts the channel has sent this week */
  sent: Scalars['Int']['output'];
};

/** A page of weekly posting streak periods and its complete summary. */
export type WeeklyPostingStreakHistoryConnection = {
  __typename?: 'WeeklyPostingStreakHistoryConnection';
  /** Period edges in newest-first order. */
  edges: Array<WeeklyPostingStreakPeriodEdge>;
  /** Pagination details for this page. */
  pageInfo: PaginationPageInfo;
  /** Summary values computed across the complete history. */
  summary: WeeklyPostingStreakHistorySummary;
};

/** Selects the organization for weekly posting streak history. */
export type WeeklyPostingStreakHistoryInput = {
  /** The organization whose weekly posting streak history is requested. */
  organizationId: Scalars['OrganizationId']['input'];
};

/** Important periods from the complete weekly posting streak history. */
export type WeeklyPostingStreakHistorySummary = {
  __typename?: 'WeeklyPostingStreakHistorySummary';
  /** The active period. Null means no streak is active. */
  currentStreak?: Maybe<WeeklyPostingStreakPeriod>;
  /** The earliest period. Null means no successful period exists. */
  firstStreak?: Maybe<WeeklyPostingStreakPeriod>;
  /** The longest period. Equal lengths select the most recent period. */
  longestStreak?: Maybe<WeeklyPostingStreakPeriod>;
};

/** Input for the weekly posting streak query */
export type WeeklyPostingStreakInput = {
  /** The organization to get the weekly posting streak for */
  organizationId: Scalars['String']['input'];
};

/** A continuous period of successful posting weeks. */
export type WeeklyPostingStreakPeriod = {
  __typename?: 'WeeklyPostingStreakPeriod';
  /** The end of the last successful week. Null means this period is active. */
  endedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The start of the first successful week in this period. */
  startedAt: Scalars['DateTime']['output'];
  /** The number of successful weeks in this period. */
  weekCount: Scalars['Int']['output'];
};

/** An edge in weekly posting streak history. */
export type WeeklyPostingStreakPeriodEdge = {
  __typename?: 'WeeklyPostingStreakPeriodEdge';
  /** An opaque cursor for the period. */
  cursor: Scalars['String']['output'];
  /** The streak period at this position. */
  node: WeeklyPostingStreakPeriod;
};

/** The organization and optional WhatsApp Channel to reconnect. */
export type WhatsAppConnectionInfoInput = {
  /** An existing WhatsApp Channel. Valid reconnects skip creation limits. */
  channelId?: InputMaybe<Scalars['ChannelId']['input']>;
  /** The organization connecting the phone. */
  organizationId: Scalars['OrganizationId']['input'];
};

/** Signup settings or an input or capacity error. */
export type WhatsAppConnectionInfoPayload = InvalidInputError | LimitReachedError | NotFoundError | WhatsAppConnectionInfoResponse;

/** The Meta settings needed to open Embedded Signup. */
export type WhatsAppConnectionInfoResponse = {
  __typename?: 'WhatsAppConnectionInfoResponse';
  /** Buffer's Embedded Signup configuration ID. */
  embeddedSignupConfigId: Scalars['String']['output'];
  /** The Graph API version to use for signup. */
  graphApiVersion: Scalars['String']['output'];
  /** Buffer's Meta app ID. */
  metaAppId: Scalars['String']['output'];
};

/** The WhatsApp phone's connection details, without credentials or synchronization request IDs. */
export type WhatsAppMetadata = {
  __typename?: 'WhatsAppMetadata';
  /** The Meta business portfolio that owns the WhatsApp Business Account. */
  businessPortfolioId: Scalars['String']['output'];
  /** When Buffer last confirmed the WABA subscription. Null before confirmation. */
  lastSubscribedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Meta's ID for the business phone. */
  phoneNumberId: Scalars['String']['output'];
  /** The WhatsApp Business Account that owns the phone. */
  wabaId: Scalars['String']['output'];
};

/**
 * A metric measured over a rolling window with an absolute comparison to
 * the prior window of the same length.
 */
export type WindowedUsageMetric = {
  __typename?: 'WindowedUsageMetric';
  /**
   * The period-over-period change vs the prior window of the same length.
   * May be negative when the consuming field permits it (e.g. engagement);
   * fields that gate on positive growth (e.g. followers) only surface
   * non-negative values.
   */
  change: Scalars['Int']['output'];
  /** The metric value for the current window. */
  current: Scalars['Int']['output'];
  /** The length of the rolling window in days. */
  windowDays: Scalars['Int']['output'];
};

export type YoutubeCategory = {
  __typename?: 'YoutubeCategory';
  categoryId: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type YoutubeData = {
  __typename?: 'YoutubeData';
  title?: Maybe<Scalars['String']['output']>;
};

/** List of license types */
export enum YoutubeLicense {
  CreativeCommon = 'creativeCommon',
  Youtube = 'youtube'
}

/** Youtube metadata */
export type YoutubeMetadata = {
  __typename?: 'YoutubeMetadata';
  /**
   * Indicates if we should default to reminder for Youtube
   * Source: field resolver: profile.default_to_reminders
   */
  defaultToReminders: Scalars['Boolean']['output'];
};

/** Youtube post metadata */
export type YoutubePostMetadata = CommonPostMetadata & {
  __typename?: 'YoutubePostMetadata';
  /** Annotations representing entities in the text */
  annotations: Array<Annotation>;
  /** Post category */
  category?: Maybe<YoutubeCategory>;
  /** Indicates whether the video allows embedding */
  embeddable: Scalars['Boolean']['output'];
  /** Whether the post discloses AI-generated content */
  isAiGenerated: Scalars['Boolean']['output'];
  /** Video license */
  license?: Maybe<YoutubeLicense>;
  /** Indicates whether the video is suitable for kids */
  madeForKids: Scalars['Boolean']['output'];
  /** Indicates whether to notify subscribers on publish video */
  notifySubscribers: Scalars['Boolean']['output'];
  /** Privacy setting for post */
  privacy?: Maybe<YoutubePrivacy>;
  /** Title of the Youtube post */
  title?: Maybe<Scalars['String']['output']>;
  /** The channel-specific type of the post, eg, post, story, reel for Youtube */
  type: PostType;
};

/** Youtube post metadata */
export type YoutubePostMetadataInput = {
  /**
   * Youtube Category ID, one ID of this list:
   * ID: 1 -> Film & Animation
   * ID: 2 -> Autos & Vehicles
   * ID: 10 -> Music
   * ID: 15 -> Pets & Animals
   * ID: 17 -> Sports
   * ID: 19 -> Travel & Events
   * ID: 20 -> Gaming
   * ID: 22 -> People & Blogs
   * ID: 23 -> Comedy
   * ID: 24 -> Entertainment
   * ID: 25 -> News & Politics
   * ID: 26 -> Howto & Style
   * ID: 27 -> Education
   * ID: 28 -> Science & Technology
   * ID: 29 -> Nonprofits & Activism
   *
   * Required on create; optional on edit (omitted preserves existing value).
   */
  categoryId?: InputMaybe<Scalars['String']['input']>;
  /** Indicates whether the video allows embedding (default: true) */
  embeddable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the post discloses AI-generated content */
  isAiGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  /** Video license (default: youtube) */
  license?: InputMaybe<YoutubeLicense>;
  /** Indicates whether the video is suitable for kids (default: false) */
  madeForKids?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates whether to notify subscribers on publish video (default: true) */
  notifySubscribers?: InputMaybe<Scalars['Boolean']['input']>;
  /** Privacy setting for post (default: public) */
  privacy?: InputMaybe<YoutubePrivacy>;
  /** Title of the Youtube post. Required on create; optional on edit (omitted preserves existing value). */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** List of privacy types */
export enum YoutubePrivacy {
  Private = 'private',
  Public = 'public',
  Unlisted = 'unlisted'
}

export type AccountSetSettingsPayload = AccountSetSettingsError | AccountSetSettingsResponse;

export type CanConnectChannelsInput = {
  organizationId: Scalars['ID']['input'];
  service: Service;
  serviceId: Scalars['String']['input'];
};

/** Result of tracking an onboarding survey action. */
export type TrackActionOnboardingSurveyPayload = InvalidInputError | TrackActionOnboardingSurveySuccess | UnauthorizedError | UnexpectedError;

export type VoteForFeatureMutationResponse = BasicError | MutationBasicResponse;

export type AccountSetCurrentOrganizationMutationVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type AccountSetCurrentOrganizationMutation = { __typename?: 'Mutation', accountSetCurrentOrganization: boolean };

export type DismissBannerMutationVariables = Exact<{
  banner: Scalars['String']['input'];
}>;


export type DismissBannerMutation = { __typename?: 'Mutation', dismissBanner: { __typename?: 'DismissBannerError', cause: string } | { __typename?: 'DismissBannerResponse', success: boolean } };

export type DismissObjectMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  dismissedObject: DismissedObjectInput;
}>;


export type DismissObjectMutation = { __typename?: 'Mutation', addOrUpdateDismissedObject: { __typename?: 'AddOrUpdateDismissedObjectError', cause: string, userFriendlyMessage: string } | { __typename?: 'AddOrUpdateDismissedObjectResponse', success: boolean } };

export type AccountQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountQuery = { __typename?: 'Query', account: { __typename?: 'Account', id: string, email: string, name?: string | null, hasVerifiedEmail?: boolean | null, helpScoutBeaconSignature?: string | null, avatar: string, createdAt?: any | null, featureFlips: Array<string>, isImpersonation: boolean, shouldShowEmailVerificationCommunication?: boolean | null, dismissedBanners?: Array<string | null> | null, hellonextSsoToken?: string | null, preferences?: { __typename?: 'Preferences', startOfWeek?: string | null } | null, channels: Array<{ __typename?: 'Channel', id: any, name: string, organizationId: any, isLocked: boolean, serverUrl?: string | null, allowedActions: Array<ChannelAction>, type: ChannelType, service: Service, serviceId: string }>, currentOrganization?: { __typename?: 'Organization', id: any, name: string, allowedActions: Array<OrganizationAction>, channelRecommendations: Array<string>, role: TeamMemberRole, shouldEnforce2FASetup: boolean, createdAt: any, isOneBufferOrganization: boolean, channelLimit: number, isBetaEnabled: boolean, isAlphaEnabled: boolean, shouldDisplayInviteCTA: boolean, featureFlips: Array<string>, ownerEmail: string, shouldShowTeamMemberOrganizationDowngradedBanner: boolean, members: { __typename?: 'MemberConnection', totalCount: number }, settings: { __typename?: 'OrganizationSettings', enforce2FA: boolean }, lifetimeConnectedChannelsCount: Array<{ __typename?: 'LifetimeConnectedChannelCount', service?: Service | null, serviceIds?: Array<string | null> | null }>, dismissedObjects: Array<{ __typename?: 'DismissedObject', id: string }>, commonTrackingProperties: { __typename?: 'CommonTrackingProperties', atEventBillingState: BillingState, atEventBillingPlan: string, atEventBillingCycle: BillingInterval, atEventBillingGateway: BillingGateway, atEventIsNewBuffer: boolean, atEventChannelQty: number }, channels: Array<{ __typename?: 'Channel', id: any, avatar: string, name: string, service: Service, serviceId: string, type: ChannelType, organizationId: any, isLocked: boolean, createdAt: any, shouldShowPinterestUpgradeBanner: boolean, shouldShowLinkedInUpgradeBanner: boolean, shouldShowTiktokUpgradeBanner: boolean, shouldShowIgLoginRefreshBanner: boolean, serverUrl?: string | null, apiVersion?: string | null, postingSchedule: Array<{ __typename?: 'ScheduleV2', day: DayOfWeek, times: Array<string>, paused: boolean }> }>, billing: { __typename?: 'MPBilling', taxExempt?: string | null, billingRedirectUrl: string, id: string, canAccessAnalytics: boolean, canAccessEngagement: boolean, canAccessPublishing: boolean, isAutomaticTaxEnabled?: boolean | null, subscriptions: Array<{ __typename?: 'MPSubscription', interval: BillingInterval, plan: string, product: Product, trial?: { __typename?: 'Trial', isActive: boolean } | null }>, paymentDetails: { __typename?: 'PaymentDetails', hasPaymentDetails?: boolean | null, paymentMethod?: string | null, creditCard?: { __typename?: 'CreditCard', brand: string, last4: string, expMonth: string, expYear: string } | null }, taxDetails?: { __typename?: 'TaxDetails', automaticTax?: string | null } | null } | { __typename?: 'OBBilling', canStartTrial: boolean, hasNeverBeenPayingCustomer: boolean, taxExempt?: string | null, id: string, canAccessAnalytics: boolean, canAccessEngagement: boolean, canAccessPublishing: boolean, isAutomaticTaxEnabled?: boolean | null, subscription: { __typename?: 'OBSubscription', quantity: number, interval: BillingInterval, periodEnd?: any | null, isCanceledAtPeriodEnd: boolean, isPaymentPastDue?: boolean | null, startDate?: any | null, trial?: { __typename?: 'Trial', isActive: boolean, remainingDays: number, isAwaitingUserAction: boolean, startDate: any, endDate: any } | null, plan: { __typename?: 'OBPlan', id: ObPlanId, name: string } }, gateway: { __typename?: 'GatewayDetails', gatewayType: BillingGateway, gatewayId?: string | null, gatewayPlatform?: BillingGatewayPlatform | null }, channelSlotDetails: { __typename?: 'ChannelSlotDetails', flatFee: number, currentQuantity: number, chargableQuantity: number, pricePerQuantity: number, minimumQuantity: number }, pricingTiers: Array<{ __typename?: 'PricingTier', flatFee: number, unitPrice: number, upperBound: number }>, paymentDetails: { __typename?: 'PaymentDetails', hasPaymentDetails?: boolean | null, paymentMethod?: string | null, creditCard?: { __typename?: 'CreditCard', brand: string, last4: string, expMonth: string, expYear: string } | null }, taxDetails?: { __typename?: 'TaxDetails', automaticTax?: string | null } | null } } | null, organizations: Array<{ __typename?: 'Organization', id: any, name: string, channelRecommendations: Array<string>, shouldEnforce2FASetup: boolean, allowedActions: Array<OrganizationAction>, role: TeamMemberRole, createdAt: any, isOneBufferOrganization: boolean, isBetaEnabled: boolean, ownerEmail: string, shouldDisplayInviteCTA: boolean, featureFlips: Array<string>, members: { __typename?: 'MemberConnection', totalCount: number }, settings: { __typename?: 'OrganizationSettings', enforce2FA: boolean }, dismissedObjects: Array<{ __typename?: 'DismissedObject', id: string }>, commonTrackingProperties: { __typename?: 'CommonTrackingProperties', atEventBillingState: BillingState, atEventBillingPlan: string, atEventBillingCycle: BillingInterval, atEventBillingGateway: BillingGateway, atEventIsNewBuffer: boolean, atEventChannelQty: number }, channels: Array<{ __typename?: 'Channel', id: any, avatar: string, name: string, service: Service, serviceId: string, organizationId: any, isLocked: boolean, shouldShowPinterestUpgradeBanner: boolean, shouldShowLinkedInUpgradeBanner: boolean, serverUrl?: string | null }>, billing: { __typename?: 'MPBilling', taxExempt?: string | null, billingRedirectUrl: string, id: string, canAccessAnalytics: boolean, canAccessEngagement: boolean, canAccessPublishing: boolean, isAutomaticTaxEnabled?: boolean | null, subscriptions: Array<{ __typename?: 'MPSubscription', interval: BillingInterval, plan: string, product: Product, trial?: { __typename?: 'Trial', isActive: boolean } | null }>, paymentDetails: { __typename?: 'PaymentDetails', hasPaymentDetails?: boolean | null, creditCard?: { __typename?: 'CreditCard', brand: string, last4: string, expMonth: string, expYear: string } | null }, taxDetails?: { __typename?: 'TaxDetails', automaticTax?: string | null } | null } | { __typename?: 'OBBilling', canStartTrial: boolean, hasNeverBeenPayingCustomer: boolean, taxExempt?: string | null, id: string, canAccessAnalytics: boolean, canAccessEngagement: boolean, canAccessPublishing: boolean, isAutomaticTaxEnabled?: boolean | null, subscription: { __typename?: 'OBSubscription', quantity: number, interval: BillingInterval, periodEnd?: any | null, isCanceledAtPeriodEnd: boolean, isPaymentPastDue?: boolean | null, startDate?: any | null, trial?: { __typename?: 'Trial', isActive: boolean, remainingDays: number, isAwaitingUserAction: boolean, startDate: any, endDate: any } | null, plan: { __typename?: 'OBPlan', id: ObPlanId, name: string } }, gateway: { __typename?: 'GatewayDetails', gatewayType: BillingGateway, gatewayId?: string | null }, channelSlotDetails: { __typename?: 'ChannelSlotDetails', flatFee: number, currentQuantity: number, chargableQuantity: number, pricePerQuantity: number, minimumQuantity: number }, paymentDetails: { __typename?: 'PaymentDetails', hasPaymentDetails?: boolean | null, creditCard?: { __typename?: 'CreditCard', brand: string, last4: string, expMonth: string, expYear: string } | null }, taxDetails?: { __typename?: 'TaxDetails', automaticTax?: string | null } | null } }>, products?: Array<{ __typename?: 'ProductLink', name: Product, userId?: string | null }> | null } };

export type SendTestNotificationMutationVariables = Exact<{ [key: string]: never; }>;


export type SendTestNotificationMutation = { __typename?: 'Mutation', sendTestNotification: { __typename?: 'SendTestNotificationError', code: number } | { __typename?: 'SendTestNotificationSuccess' } };

export type UpdatePlanMutationVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
  plan?: InputMaybe<ObPlanId>;
  interval?: InputMaybe<BillingInterval>;
  attribution?: InputMaybe<AttributionInput>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpdatePlanMutation = { __typename?: 'Mutation', billingUpdateSubscriptionPlan: { __typename?: 'BillingError', userFriendlyMessage: string } | { __typename?: 'BillingUpdateSubscriptionPlanResponse', success: boolean, scheduledUpdate?: { __typename?: 'ScheduledSubscriptionUpdate', newPlan: string, newInterval: BillingInterval, newQuantity: number, effectiveDate: any } | null } };

export type StartTrialMutationVariables = Exact<{
  input: StartTrialInput;
}>;


export type StartTrialMutation = { __typename?: 'Mutation', startTrial: { __typename: 'StartTrialResponse' } | { __typename: 'VoidMutationError', message: string } };

export type GetPreviewInvoiceQueryVariables = Exact<{
  organizationId: Scalars['OrganizationId']['input'];
  plan: ObPlanId;
  interval: BillingInterval;
  quantity: Scalars['Int']['input'];
}>;


export type GetPreviewInvoiceQuery = { __typename?: 'Query', getPreviewInvoice: { __typename?: 'GetPreviewInvoiceResponse', chargeAmount: number, creditAmount: number, isScheduledChange: boolean, nextBillingDate: any } | { __typename?: 'VoidMutationError', message: string } };

export type CreateCustomChannelsMutationVariables = Exact<{
  input: CreateCustomChannelsInput;
}>;


export type CreateCustomChannelsMutation = { __typename?: 'Mutation', createCustomChannels: { __typename?: 'CreateCustomChannelsResponse', channels: Array<{ __typename?: 'Channel', id: any }> } | { __typename?: 'CustomChannelError', message: string } };

export type UpdateCustomChannelMutationVariables = Exact<{
  input: UpdateCustomChannelInput;
}>;


export type UpdateCustomChannelMutation = { __typename?: 'Mutation', updateCustomChannel: { __typename?: 'CustomChannelError', message: string } | { __typename?: 'UpdateCustomChannelResponse', channel: { __typename?: 'Channel', id: any } } };

export type StartPagesQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type StartPagesQuery = { __typename?: 'Query', startPages?: { __typename?: 'CommonError', code: string, success: boolean } | { __typename?: 'StartPages', startPages?: Array<{ __typename?: 'StartPage', id: string, domain?: string | null, organizationId: string, isPublished?: boolean | null, title?: string | null, migrationAsAChannel?: { __typename?: 'StartPageMigrationAsAChannel', success?: boolean | null, wasPublished?: boolean | null, wasBilling?: string | null, wasMobile?: boolean | null, wasTrialist?: boolean | null, wasAtLimit?: boolean | null } | null } | null> | null } | null };

export type GetDismissedBannersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDismissedBannersQuery = { __typename?: 'Query', account: { __typename?: 'Account', id: string, dismissedBanners?: Array<string | null> | null } };

export type CreateCustomerPortalSessionMutationVariables = Exact<{
  organizationId: Scalars['OrganizationId']['input'];
  returnURL: Scalars['String']['input'];
  cta?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateCustomerPortalSessionMutation = { __typename?: 'Mutation', createCustomerPortalSession: { __typename?: 'BillingError', userFriendlyMessage: string } | { __typename?: 'CreateCustomerPortalSessionResponse', customerPortalSessionUrl: string } };

export type IncreaseSubscriptionQuantityByChannelIdsMutationVariables = Exact<{
  input: IncreaseSubscriptionQuantityByChannelIdsInput;
}>;


export type IncreaseSubscriptionQuantityByChannelIdsMutation = { __typename?: 'Mutation', increaseSubscriptionQuantityByChannelIds: { __typename: 'UpdateBillingSubscriptionPlanResponse', status: SubscriptionUpdateStatus, scheduledUpdate?: { __typename?: 'ScheduledSubscriptionUpdateV2', newPlan: ObPlanId, newInterval: BillingInterval, newQuantity: number, effectiveDate: any } | null, paymentAction?: { __typename?: 'PaymentActionRequired', clientSecret: string, paymentMethodId?: string | null } | null } | { __typename: 'VoidMutationError', message: string } };

export type OrgDataQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type OrgDataQueryQuery = { __typename?: 'Query', account: { __typename?: 'Account', id: string, isImpersonation: boolean, email: string, currentOrganization?: (
      { __typename?: 'Organization' }
      & { ' $fragmentRefs'?: { 'OrganizationFieldsFragment': OrganizationFieldsFragment } }
    ) | null, organizations: Array<(
      { __typename?: 'Organization' }
      & { ' $fragmentRefs'?: { 'OrganizationFieldsFragment': OrganizationFieldsFragment } }
    )> } };

export type OrganizationFieldsFragment = { __typename?: 'Organization', id: any, isOneBufferOrganization: boolean, createdAt: any, billing: (
    { __typename?: 'MPBilling' }
    & { ' $fragmentRefs'?: { 'BillingFields_MpBilling_Fragment': BillingFields_MpBilling_Fragment } }
  ) | (
    { __typename?: 'OBBilling' }
    & { ' $fragmentRefs'?: { 'BillingFields_ObBilling_Fragment': BillingFields_ObBilling_Fragment } }
  ) } & { ' $fragmentName'?: 'OrganizationFieldsFragment' };

type BillingFields_MpBilling_Fragment = { __typename?: 'MPBilling', id: string, subscriptions: Array<{ __typename?: 'MPSubscription', plan: string, product: Product, trial?: { __typename?: 'Trial', isActive: boolean } | null }> } & { ' $fragmentName'?: 'BillingFields_MpBilling_Fragment' };

type BillingFields_ObBilling_Fragment = { __typename?: 'OBBilling', hasNeverBeenPayingCustomer: boolean, canStartTrial: boolean, id: string, subscription: { __typename?: 'OBSubscription', trial?: { __typename?: 'Trial', isActive: boolean } | null, plan: { __typename?: 'OBPlan', id: ObPlanId, name: string } } } & { ' $fragmentName'?: 'BillingFields_ObBilling_Fragment' };

export type BillingFieldsFragment = BillingFields_MpBilling_Fragment | BillingFields_ObBilling_Fragment;

export type LocationDataQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type LocationDataQueryQuery = { __typename?: 'Query', location: { __typename?: 'LocationPayload', country?: string | null } };

export type GetAnnualUpgradePreviewInvoiceQueryVariables = Exact<{
  organizationId: Scalars['OrganizationId']['input'];
}>;


export type GetAnnualUpgradePreviewInvoiceQuery = { __typename?: 'Query', getAnnualUpgradePreviewInvoice: { __typename?: 'GetPreviewInvoiceResponse', chargeAmount: number, creditAmount: number, isScheduledChange: boolean, nextBillingDate: any } | { __typename?: 'VoidMutationError', message: string } };

export type UpgradePlanToAnnualBillingMutationVariables = Exact<{
  input: UpgradePlanToAnnualBillingInput;
}>;


export type UpgradePlanToAnnualBillingMutation = { __typename?: 'Mutation', upgradePlanToAnnualBilling: { __typename: 'BillingError', userFriendlyMessage: string, cause: string } | { __typename: 'UpgradePlanToAnnualBillingResponse', status: SubscriptionUpdateStatus, paymentAction?: { __typename?: 'PaymentActionRequired', clientSecret: string, paymentMethodId?: string | null } | null } };

export type CancelFlowDowngradeToFreeMutationVariables = Exact<{
  input: DowngradeToFreeInput;
}>;


export type CancelFlowDowngradeToFreeMutation = { __typename?: 'Mutation', downgradeToFree: { __typename: 'UpdateBillingSubscriptionPlanResponse', status: SubscriptionUpdateStatus } | { __typename: 'VoidMutationError', message: string } };

export type CancelFlowOrgActivitySummaryQueryVariables = Exact<{
  organizationId: Scalars['OrganizationId']['input'];
}>;


export type CancelFlowOrgActivitySummaryQuery = { __typename?: 'Query', organizationActivitySummary: { __typename: 'OrganizationActivitySummary', postsPublished?: { __typename?: 'LifetimeUsageMetric', total: number } | null, ideasCreated?: { __typename?: 'LifetimeUsageMetric', total: number } | null, commentReplies?: { __typename?: 'LifetimeUsageMetric', total: number } | null, followers?: { __typename?: 'WindowedUsageMetric', current: number } | null, engagement?: { __typename?: 'WindowedUsageMetric', current: number } | null, weeklyPostingStreak?: { __typename?: 'StreakUsageMetric', weeks: number } | null } | { __typename: 'OrganizationActivitySummaryDefaultState' } };

export type UpdateChannelPostingGoalMutationVariables = Exact<{
  input: UpdateChannelPostingGoalInput;
}>;


export type UpdateChannelPostingGoalMutation = { __typename?: 'Mutation', updateChannelPostingGoal: { __typename: 'InvalidInputError', message: string } | { __typename: 'NotFoundError', message: string } | { __typename: 'UnauthorizedError', message: string } | { __typename: 'UnexpectedError', message: string } | { __typename: 'UpdateChannelPostingGoalResponse', channel: { __typename?: 'Channel', id: any, postingGoal?: { __typename?: 'PostingGoal', goal: number, sentCount: number, scheduledCount: number, periodStart: any, periodEnd: any, status: PostingGoalStatus } | null } } };

export type GetPostingScheduleInfoQueryVariables = Exact<{
  input: ChannelInput;
}>;


export type GetPostingScheduleInfoQuery = { __typename?: 'Query', channel: { __typename?: 'Channel', id: any, postingSchedule: Array<{ __typename?: 'ScheduleV2', day: DayOfWeek, paused: boolean, times: Array<string> }> } };

export type SetPostingScheduleForChannelMutationVariables = Exact<{
  input: SetPostingScheduleForChannelInput;
}>;


export type SetPostingScheduleForChannelMutation = { __typename?: 'Mutation', setPostingScheduleForChannel: { __typename?: 'InvalidInputError', message: string } | { __typename?: 'NotFoundError', message: string } | { __typename?: 'SetPostingScheduleForChannelResponse', postingSchedule: Array<{ __typename?: 'ScheduleV2', day: DayOfWeek, paused: boolean, times: Array<string> }> } | { __typename?: 'UnauthorizedError', message: string } | { __typename?: 'UnexpectedError', message: string } };

export type CreateCheckoutSessionMutationVariables = Exact<{
  input: CreateCheckoutSessionInput;
}>;


export type CreateCheckoutSessionMutation = { __typename?: 'Mutation', createCheckoutSession: { __typename?: 'BillingError', userFriendlyMessage: string } | { __typename?: 'CreateCheckoutSessionResponse', redirectUrl: string } };

export type GetPlanSelectorDataQueryVariables = Exact<{
  input: PlanSelectorDataInput;
}>;


export type GetPlanSelectorDataQuery = { __typename?: 'Query', planSelectorData: { __typename: 'PlanSelectorData', organizationId: any, requiresAssistedBilling: boolean, hasEverBeenPayingCustomer: boolean, hasDefaultStripePaymentMethod: boolean, gateway: BillingGateway, nextInvoice: { __typename?: 'NextInvoice', totalAmount: number, currency: string, taxAmount: number }, balance: { __typename?: 'AccountBalance', amount: number, currency: string }, subscription: { __typename?: 'BufferSubscription', interval: BillingInterval, quantity: number, isCanceledAtPeriodEnd: boolean, periodEnd?: any | null, canceledAt?: any | null, isPaymentPastDue?: boolean | null, plan: { __typename?: 'Plan', id: ObPlanId, name: string, interval: BillingInterval, limits: { __typename?: 'PlanLimits', channels: number, members: number, scheduledPosts: number }, pricing: Array<{ __typename?: 'PlanPricingTier', unitPrice: number, currency: string, upperBound: number, flatFee: number }> }, trial?: { __typename?: 'PlanTrial', startDate: any, endDate: any } | null, scheduledUpdate?: { __typename?: 'ScheduledSubscriptionUpdateV2', newPlan: ObPlanId, newQuantity: number, newInterval: BillingInterval, effectiveDate: any } | null }, discounts: Array<{ __typename?: 'AmountDiscount', currency: string, scope: DiscountScope, duration: DiscountDuration, durationInMonths?: number | null, amountOff: number } | { __typename?: 'PercentDiscount', scope: DiscountScope, duration: DiscountDuration, durationInMonths?: number | null, percentOff: number }>, availablePlans: Array<{ __typename?: 'PlanOption', planId: ObPlanId, planName: string, planInterval: BillingInterval, pricing: Array<{ __typename?: 'PlanPricingTier', unitPrice: number, currency: string, upperBound: number, flatFee: number }>, pricingMetadata: { __typename?: 'PricingMetadata', quantityType: QuantityType } }> } };

export type UpdateBillingSubscriptionPlanMutationVariables = Exact<{
  input: UpdateBillingSubscriptionPlanInput;
}>;


export type UpdateBillingSubscriptionPlanMutation = { __typename?: 'Mutation', updateBillingSubscriptionPlan: { __typename: 'UpdateBillingSubscriptionPlanResponse', status: SubscriptionUpdateStatus, scheduledUpdate?: { __typename?: 'ScheduledSubscriptionUpdateV2', newPlan: ObPlanId, newInterval: BillingInterval, newQuantity: number, effectiveDate: any } | null, paymentAction?: { __typename?: 'PaymentActionRequired', clientSecret: string, paymentMethodId?: string | null } | null } | { __typename: 'VoidMutationError', message: string } };

export type UpdateSubscriptionQuantityMutationVariables = Exact<{
  organizationId: Scalars['OrganizationId']['input'];
  quantity: Scalars['Int']['input'];
  attribution?: InputMaybe<AttributionInput>;
}>;


export type UpdateSubscriptionQuantityMutation = { __typename?: 'Mutation', updateSubscriptionQuantity: { __typename?: 'UpdateBillingSubscriptionPlanResponse', status: SubscriptionUpdateStatus, scheduledUpdate?: { __typename?: 'ScheduledSubscriptionUpdateV2', newPlan: ObPlanId, newInterval: BillingInterval, newQuantity: number, effectiveDate: any } | null, paymentAction?: { __typename?: 'PaymentActionRequired', clientSecret: string, paymentMethodId?: string | null } | null } | { __typename?: 'VoidMutationError', message: string } };

export type GetConnectableServicesQueryVariables = Exact<{
  input: ConnectableServicesInput;
}>;


export type GetConnectableServicesQuery = { __typename?: 'Query', connectableServices: { __typename: 'ConnectableServicesError', userFriendlyMessage: string, cause: string } | { __typename: 'ConnectableServicesResponse', services: Array<{ __typename?: 'ConnectableService', service: Service, types: Array<ChannelType>, products: Array<Product>, isNew: boolean, canConnect: boolean, title: string, subtitle: string, serviceIconUrl: string, description: Array<string>, contentTypes: Array<ContentType>, audience?: string | null, socialProof?: string | null, similarNetworks?: Array<Service> | null, tag?: string | null, categories: Array<ChannelCategory>, serviceStatus: { __typename?: 'ServiceStatus', label: StatusLabel, details?: { __typename?: 'UpvoteDetails', message?: string | null, upvoteId: number } | null }, status: { __typename?: 'ChannelConnectionStatus', status: ConnectionStatus }, links?: Array<{ __typename?: 'HelpCenterLink', text: string, url: string }> | null }> } };

export type AccountHasActiveMemberDeviceQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountHasActiveMemberDeviceQuery = { __typename?: 'Query', account: { __typename?: 'Account', currentOrganization?: { __typename?: 'Organization', channels: Array<{ __typename?: 'Channel', hasActiveMemberDevice: boolean }> } | null } };

export type CompleteWhatsAppConnectionMutationVariables = Exact<{
  input: CompleteWhatsAppConnectionInput;
}>;


export type CompleteWhatsAppConnectionMutation = { __typename?: 'Mutation', completeWhatsAppConnection: { __typename: 'ChannelConnectionCannotStealChannelError', message: string } | { __typename: 'CompleteWhatsAppConnectionResponse', channel: { __typename?: 'Channel', id: any, service: Service, serviceId: string } } | { __typename: 'InvalidInputError', message: string } | { __typename: 'LimitReachedError', message: string } | { __typename: 'NotFoundError', message: string } };

export type WhatsAppChannelsQueryVariables = Exact<{
  input: ChannelsInput;
}>;


export type WhatsAppChannelsQuery = { __typename?: 'Query', channels: Array<{ __typename?: 'Channel', id: any, service: Service, serviceId: string }> };

export type WhatsAppChannelStatusQueryVariables = Exact<{
  input: ConfigurationInput;
}>;


export type WhatsAppChannelStatusQuery = { __typename?: 'Query', configuration: { __typename?: 'Configuration', channels: Array<{ __typename?: 'ChannelConfiguration', channelId: any, authorizationStatus: Array<{ __typename?: 'FeatureAuthorizationStatus', feature: Feature, status: AuthorizationStatus }> }> } };

export type WhatsAppConnectionInfoQueryVariables = Exact<{
  input: WhatsAppConnectionInfoInput;
}>;


export type WhatsAppConnectionInfoQuery = { __typename?: 'Query', whatsAppConnectionInfo: { __typename: 'InvalidInputError', message: string } | { __typename: 'LimitReachedError', message: string } | { __typename: 'NotFoundError', message: string } | { __typename: 'WhatsAppConnectionInfoResponse', metaAppId: string, embeddedSignupConfigId: string, graphApiVersion: string } };

export type ChannelAuthorizationInfoQueryVariables = Exact<{
  input: ChannelAuthorizationInfoInput;
}>;


export type ChannelAuthorizationInfoQuery = { __typename?: 'Query', channelAuthorizationInfo: { __typename?: 'ChannelAuthorizationInfoResponse', url: string, state: string, redirectUri: string, codeVerifier?: string | null } };

export const BillingFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BillingFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Billing"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MPBilling"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plan"}},{"kind":"Field","name":{"kind":"Name","value":"product"}},{"kind":"Field","name":{"kind":"Name","value":"trial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OBBilling"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNeverBeenPayingCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"canStartTrial"}},{"kind":"Field","name":{"kind":"Name","value":"subscription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}},{"kind":"Field","name":{"kind":"Name","value":"plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<BillingFieldsFragment, unknown>;
export const OrganizationFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganizationFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isOneBufferOrganization"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"billing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BillingFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BillingFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Billing"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MPBilling"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plan"}},{"kind":"Field","name":{"kind":"Name","value":"product"}},{"kind":"Field","name":{"kind":"Name","value":"trial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OBBilling"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNeverBeenPayingCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"canStartTrial"}},{"kind":"Field","name":{"kind":"Name","value":"subscription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}},{"kind":"Field","name":{"kind":"Name","value":"plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<OrganizationFieldsFragment, unknown>;
export const AccountSetCurrentOrganizationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AccountSetCurrentOrganization"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountSetCurrentOrganization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}]}]}}]} as unknown as DocumentNode<AccountSetCurrentOrganizationMutation, AccountSetCurrentOrganizationMutationVariables>;
export const DismissBannerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DismissBanner"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"banner"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dismissBanner"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"banner"},"value":{"kind":"Variable","name":{"kind":"Name","value":"banner"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DismissBannerResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DismissBannerError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cause"}}]}}]}}]}}]} as unknown as DocumentNode<DismissBannerMutation, DismissBannerMutationVariables>;
export const DismissObjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DismissObject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dismissedObject"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DismissedObjectInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addOrUpdateDismissedObject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"dismissedObject"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dismissedObject"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AddOrUpdateDismissedObjectResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AddOrUpdateDismissedObjectError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cause"}},{"kind":"Field","name":{"kind":"Name","value":"userFriendlyMessage"}}]}}]}}]}}]} as unknown as DocumentNode<DismissObjectMutation, DismissObjectMutationVariables>;
export const AccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"preferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startOfWeek"}}]}},{"kind":"Field","name":{"kind":"Name","value":"channels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"isLocked"}},{"kind":"Field","name":{"kind":"Name","value":"serverUrl"}},{"kind":"Field","name":{"kind":"Name","value":"allowedActions"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"service"}},{"kind":"Field","name":{"kind":"Name","value":"serviceId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"hasVerifiedEmail"}},{"kind":"Field","name":{"kind":"Name","value":"helpScoutBeaconSignature"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"featureFlips"}},{"kind":"Field","name":{"kind":"Name","value":"isImpersonation"}},{"kind":"Field","name":{"kind":"Name","value":"shouldShowEmailVerificationCommunication"}},{"kind":"Field","name":{"kind":"Name","value":"dismissedBanners"}},{"kind":"Field","name":{"kind":"Name","value":"hellonextSsoToken"}},{"kind":"Field","name":{"kind":"Name","value":"currentOrganization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"allowedActions"}},{"kind":"Field","name":{"kind":"Name","value":"channelRecommendations"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enforce2FA"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shouldEnforce2FASetup"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"isOneBufferOrganization"}},{"kind":"Field","name":{"kind":"Name","value":"channelLimit"}},{"kind":"Field","name":{"kind":"Name","value":"isBetaEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"isAlphaEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"lifetimeConnectedChannelsCount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"service"}},{"kind":"Field","name":{"kind":"Name","value":"serviceIds"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dismissedObjects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"commonTrackingProperties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"atEventBillingState"}},{"kind":"Field","name":{"kind":"Name","value":"atEventBillingPlan"}},{"kind":"Field","name":{"kind":"Name","value":"atEventBillingCycle"}},{"kind":"Field","name":{"kind":"Name","value":"atEventBillingGateway"}},{"kind":"Field","name":{"kind":"Name","value":"atEventIsNewBuffer"}},{"kind":"Field","name":{"kind":"Name","value":"atEventChannelQty"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shouldDisplayInviteCTA"}},{"kind":"Field","name":{"kind":"Name","value":"featureFlips"}},{"kind":"Field","name":{"kind":"Name","value":"channels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"service"}},{"kind":"Field","name":{"kind":"Name","value":"serviceId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"isLocked"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"shouldShowPinterestUpgradeBanner"}},{"kind":"Field","name":{"kind":"Name","value":"shouldShowLinkedInUpgradeBanner"}},{"kind":"Field","name":{"kind":"Name","value":"shouldShowTiktokUpgradeBanner"}},{"kind":"Field","name":{"kind":"Name","value":"shouldShowIgLoginRefreshBanner"}},{"kind":"Field","name":{"kind":"Name","value":"serverUrl"}},{"kind":"Field","name":{"kind":"Name","value":"apiVersion"}},{"kind":"Field","name":{"kind":"Name","value":"postingSchedule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"day"}},{"kind":"Field","name":{"kind":"Name","value":"times"}},{"kind":"Field","name":{"kind":"Name","value":"paused"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerEmail"}},{"kind":"Field","name":{"kind":"Name","value":"shouldShowTeamMemberOrganizationDowngradedBanner"}},{"kind":"Field","name":{"kind":"Name","value":"billing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"canAccessAnalytics"}},{"kind":"Field","name":{"kind":"Name","value":"canAccessEngagement"}},{"kind":"Field","name":{"kind":"Name","value":"canAccessPublishing"}},{"kind":"Field","name":{"kind":"Name","value":"paymentDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasPaymentDetails"}},{"kind":"Field","name":{"kind":"Name","value":"creditCard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"last4"}},{"kind":"Field","name":{"kind":"Name","value":"expMonth"}},{"kind":"Field","name":{"kind":"Name","value":"expYear"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAutomaticTaxEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"taxDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"automaticTax"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MPBilling"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxExempt"}},{"kind":"Field","name":{"kind":"Name","value":"billingRedirectUrl"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"plan"}},{"kind":"Field","name":{"kind":"Name","value":"product"}},{"kind":"Field","name":{"kind":"Name","value":"trial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OBBilling"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canStartTrial"}},{"kind":"Field","name":{"kind":"Name","value":"hasNeverBeenPayingCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"taxExempt"}},{"kind":"Field","name":{"kind":"Name","value":"subscription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"periodEnd"}},{"kind":"Field","name":{"kind":"Name","value":"isCanceledAtPeriodEnd"}},{"kind":"Field","name":{"kind":"Name","value":"trial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"remainingDays"}},{"kind":"Field","name":{"kind":"Name","value":"isAwaitingUserAction"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isPaymentPastDue"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"gateway"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gatewayType"}},{"kind":"Field","name":{"kind":"Name","value":"gatewayId"}},{"kind":"Field","name":{"kind":"Name","value":"gatewayPlatform"}}]}},{"kind":"Field","name":{"kind":"Name","value":"channelSlotDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flatFee"}},{"kind":"Field","name":{"kind":"Name","value":"currentQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"chargableQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"pricePerQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"minimumQuantity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricingTiers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flatFee"}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"}},{"kind":"Field","name":{"kind":"Name","value":"upperBound"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"channelRecommendations"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enforce2FA"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shouldEnforce2FASetup"}},{"kind":"Field","name":{"kind":"Name","value":"allowedActions"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"isOneBufferOrganization"}},{"kind":"Field","name":{"kind":"Name","value":"isBetaEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"ownerEmail"}},{"kind":"Field","name":{"kind":"Name","value":"dismissedObjects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"commonTrackingProperties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"atEventBillingState"}},{"kind":"Field","name":{"kind":"Name","value":"atEventBillingPlan"}},{"kind":"Field","name":{"kind":"Name","value":"atEventBillingCycle"}},{"kind":"Field","name":{"kind":"Name","value":"atEventBillingGateway"}},{"kind":"Field","name":{"kind":"Name","value":"atEventIsNewBuffer"}},{"kind":"Field","name":{"kind":"Name","value":"atEventChannelQty"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shouldDisplayInviteCTA"}},{"kind":"Field","name":{"kind":"Name","value":"featureFlips"}},{"kind":"Field","name":{"kind":"Name","value":"channels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"service"}},{"kind":"Field","name":{"kind":"Name","value":"serviceId"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"isLocked"}},{"kind":"Field","name":{"kind":"Name","value":"shouldShowPinterestUpgradeBanner"}},{"kind":"Field","name":{"kind":"Name","value":"shouldShowLinkedInUpgradeBanner"}},{"kind":"Field","name":{"kind":"Name","value":"serverUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"canAccessAnalytics"}},{"kind":"Field","name":{"kind":"Name","value":"canAccessEngagement"}},{"kind":"Field","name":{"kind":"Name","value":"canAccessPublishing"}},{"kind":"Field","name":{"kind":"Name","value":"paymentDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasPaymentDetails"}},{"kind":"Field","name":{"kind":"Name","value":"creditCard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"last4"}},{"kind":"Field","name":{"kind":"Name","value":"expMonth"}},{"kind":"Field","name":{"kind":"Name","value":"expYear"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAutomaticTaxEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"taxDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"automaticTax"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MPBilling"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxExempt"}},{"kind":"Field","name":{"kind":"Name","value":"billingRedirectUrl"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"plan"}},{"kind":"Field","name":{"kind":"Name","value":"product"}},{"kind":"Field","name":{"kind":"Name","value":"trial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OBBilling"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canStartTrial"}},{"kind":"Field","name":{"kind":"Name","value":"hasNeverBeenPayingCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"taxExempt"}},{"kind":"Field","name":{"kind":"Name","value":"subscription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"periodEnd"}},{"kind":"Field","name":{"kind":"Name","value":"isCanceledAtPeriodEnd"}},{"kind":"Field","name":{"kind":"Name","value":"trial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"remainingDays"}},{"kind":"Field","name":{"kind":"Name","value":"isAwaitingUserAction"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isPaymentPastDue"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"gateway"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gatewayType"}},{"kind":"Field","name":{"kind":"Name","value":"gatewayId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"channelSlotDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flatFee"}},{"kind":"Field","name":{"kind":"Name","value":"currentQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"chargableQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"pricePerQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"minimumQuantity"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}}]}}]} as unknown as DocumentNode<AccountQuery, AccountQueryVariables>;
export const SendTestNotificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendTestNotification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendTestNotification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SendTestNotificationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<SendTestNotificationMutation, SendTestNotificationMutationVariables>;
export const UpdatePlanDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updatePlan"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"plan"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OBPlanId"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"interval"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BillingInterval"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"attribution"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AttributionInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"quantity"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"billingUpdateSubscriptionPlan"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"plan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"plan"}}},{"kind":"Argument","name":{"kind":"Name","value":"interval"},"value":{"kind":"Variable","name":{"kind":"Name","value":"interval"}}},{"kind":"Argument","name":{"kind":"Name","value":"quantity"},"value":{"kind":"Variable","name":{"kind":"Name","value":"quantity"}}},{"kind":"Argument","name":{"kind":"Name","value":"attribution"},"value":{"kind":"Variable","name":{"kind":"Name","value":"attribution"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BillingUpdateSubscriptionPlanResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledUpdate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newPlan"}},{"kind":"Field","name":{"kind":"Name","value":"newInterval"}},{"kind":"Field","name":{"kind":"Name","value":"newQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveDate"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BillingError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userFriendlyMessage"}}]}}]}}]}}]} as unknown as DocumentNode<UpdatePlanMutation, UpdatePlanMutationVariables>;
export const StartTrialDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"StartTrial"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StartTrialInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startTrial"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VoidMutationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<StartTrialMutation, StartTrialMutationVariables>;
export const GetPreviewInvoiceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPreviewInvoice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationId"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"plan"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OBPlanId"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"interval"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BillingInterval"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"quantity"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getPreviewInvoice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"plan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"plan"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"interval"},"value":{"kind":"Variable","name":{"kind":"Name","value":"interval"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"quantity"},"value":{"kind":"Variable","name":{"kind":"Name","value":"quantity"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GetPreviewInvoiceResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chargeAmount"}},{"kind":"Field","name":{"kind":"Name","value":"creditAmount"}},{"kind":"Field","name":{"kind":"Name","value":"isScheduledChange"}},{"kind":"Field","name":{"kind":"Name","value":"nextBillingDate"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VoidMutationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<GetPreviewInvoiceQuery, GetPreviewInvoiceQueryVariables>;
export const CreateCustomChannelsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCustomChannels"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateCustomChannelsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCustomChannels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CreateCustomChannelsResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CustomChannelError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<CreateCustomChannelsMutation, CreateCustomChannelsMutationVariables>;
export const UpdateCustomChannelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCustomChannel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateCustomChannelInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCustomChannel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateCustomChannelResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CustomChannelError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateCustomChannelMutation, UpdateCustomChannelMutationVariables>;
export const StartPagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"startPages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startPages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StartPages"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startPages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"domain"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"isPublished"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"migrationAsAChannel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"wasPublished"}},{"kind":"Field","name":{"kind":"Name","value":"wasBilling"}},{"kind":"Field","name":{"kind":"Name","value":"wasMobile"}},{"kind":"Field","name":{"kind":"Name","value":"wasTrialist"}},{"kind":"Field","name":{"kind":"Name","value":"wasAtLimit"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CommonError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]}}]} as unknown as DocumentNode<StartPagesQuery, StartPagesQueryVariables>;
export const GetDismissedBannersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDismissedBanners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dismissedBanners"}}]}}]}}]} as unknown as DocumentNode<GetDismissedBannersQuery, GetDismissedBannersQueryVariables>;
export const CreateCustomerPortalSessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createCustomerPortalSession"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationId"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"returnURL"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cta"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCustomerPortalSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"returnURL"},"value":{"kind":"Variable","name":{"kind":"Name","value":"returnURL"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"cta"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cta"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CreateCustomerPortalSessionResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerPortalSessionUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BillingError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userFriendlyMessage"}}]}}]}}]}}]} as unknown as DocumentNode<CreateCustomerPortalSessionMutation, CreateCustomerPortalSessionMutationVariables>;
export const IncreaseSubscriptionQuantityByChannelIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"IncreaseSubscriptionQuantityByChannelIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"IncreaseSubscriptionQuantityByChannelIdsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"increaseSubscriptionQuantityByChannelIds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateBillingSubscriptionPlanResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledUpdate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newPlan"}},{"kind":"Field","name":{"kind":"Name","value":"newInterval"}},{"kind":"Field","name":{"kind":"Name","value":"newQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientSecret"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethodId"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VoidMutationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<IncreaseSubscriptionQuantityByChannelIdsMutation, IncreaseSubscriptionQuantityByChannelIdsMutationVariables>;
export const OrgDataQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrgDataQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isImpersonation"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"currentOrganization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganizationFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganizationFields"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BillingFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Billing"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MPBilling"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plan"}},{"kind":"Field","name":{"kind":"Name","value":"product"}},{"kind":"Field","name":{"kind":"Name","value":"trial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OBBilling"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNeverBeenPayingCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"canStartTrial"}},{"kind":"Field","name":{"kind":"Name","value":"subscription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}},{"kind":"Field","name":{"kind":"Name","value":"plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganizationFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isOneBufferOrganization"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"billing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BillingFields"}}]}}]}}]} as unknown as DocumentNode<OrgDataQueryQuery, OrgDataQueryQueryVariables>;
export const LocationDataQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LocationDataQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}}]} as unknown as DocumentNode<LocationDataQueryQuery, LocationDataQueryQueryVariables>;
export const GetAnnualUpgradePreviewInvoiceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAnnualUpgradePreviewInvoice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationId"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAnnualUpgradePreviewInvoice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GetPreviewInvoiceResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chargeAmount"}},{"kind":"Field","name":{"kind":"Name","value":"creditAmount"}},{"kind":"Field","name":{"kind":"Name","value":"isScheduledChange"}},{"kind":"Field","name":{"kind":"Name","value":"nextBillingDate"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VoidMutationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<GetAnnualUpgradePreviewInvoiceQuery, GetAnnualUpgradePreviewInvoiceQueryVariables>;
export const UpgradePlanToAnnualBillingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpgradePlanToAnnualBilling"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpgradePlanToAnnualBillingInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upgradePlanToAnnualBilling"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpgradePlanToAnnualBillingResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"paymentAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientSecret"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethodId"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BillingError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userFriendlyMessage"}},{"kind":"Field","name":{"kind":"Name","value":"cause"}}]}}]}}]}}]} as unknown as DocumentNode<UpgradePlanToAnnualBillingMutation, UpgradePlanToAnnualBillingMutationVariables>;
export const CancelFlowDowngradeToFreeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CancelFlowDowngradeToFree"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DowngradeToFreeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"downgradeToFree"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateBillingSubscriptionPlanResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VoidMutationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<CancelFlowDowngradeToFreeMutation, CancelFlowDowngradeToFreeMutationVariables>;
export const CancelFlowOrgActivitySummaryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CancelFlowOrgActivitySummary"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationId"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationActivitySummary"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationActivitySummary"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"postsPublished"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ideasCreated"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"commentReplies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"followers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"current"}}]}},{"kind":"Field","name":{"kind":"Name","value":"engagement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"current"}}]}},{"kind":"Field","name":{"kind":"Name","value":"weeklyPostingStreak"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"weeks"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CancelFlowOrgActivitySummaryQuery, CancelFlowOrgActivitySummaryQueryVariables>;
export const UpdateChannelPostingGoalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateChannelPostingGoal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateChannelPostingGoalInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateChannelPostingGoal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateChannelPostingGoalResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"postingGoal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"goal"}},{"kind":"Field","name":{"kind":"Name","value":"sentCount"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledCount"}},{"kind":"Field","name":{"kind":"Name","value":"periodStart"}},{"kind":"Field","name":{"kind":"Name","value":"periodEnd"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MutationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateChannelPostingGoalMutation, UpdateChannelPostingGoalMutationVariables>;
export const GetPostingScheduleInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPostingScheduleInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChannelInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"postingSchedule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"day"}},{"kind":"Field","name":{"kind":"Name","value":"paused"}},{"kind":"Field","name":{"kind":"Name","value":"times"}}]}}]}}]}}]} as unknown as DocumentNode<GetPostingScheduleInfoQuery, GetPostingScheduleInfoQueryVariables>;
export const SetPostingScheduleForChannelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetPostingScheduleForChannel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SetPostingScheduleForChannelInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setPostingScheduleForChannel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SetPostingScheduleForChannelResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"postingSchedule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"day"}},{"kind":"Field","name":{"kind":"Name","value":"paused"}},{"kind":"Field","name":{"kind":"Name","value":"times"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MutationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<SetPostingScheduleForChannelMutation, SetPostingScheduleForChannelMutationVariables>;
export const CreateCheckoutSessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createCheckoutSession"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateCheckoutSessionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCheckoutSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CreateCheckoutSessionResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"redirectUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BillingError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userFriendlyMessage"}}]}}]}}]}}]} as unknown as DocumentNode<CreateCheckoutSessionMutation, CreateCheckoutSessionMutationVariables>;
export const GetPlanSelectorDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPlanSelectorData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PlanSelectorDataInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"planSelectorData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PlanSelectorData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"requiresAssistedBilling"}},{"kind":"Field","name":{"kind":"Name","value":"hasEverBeenPayingCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"hasDefaultStripePaymentMethod"}},{"kind":"Field","name":{"kind":"Name","value":"nextInvoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"taxAmount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"balance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subscription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"limits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channels"}},{"kind":"Field","name":{"kind":"Name","value":"members"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledPosts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unitPrice"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"upperBound"}},{"kind":"Field","name":{"kind":"Name","value":"flatFee"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"isCanceledAtPeriodEnd"}},{"kind":"Field","name":{"kind":"Name","value":"periodEnd"}},{"kind":"Field","name":{"kind":"Name","value":"canceledAt"}},{"kind":"Field","name":{"kind":"Name","value":"trial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isPaymentPastDue"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledUpdate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newPlan"}},{"kind":"Field","name":{"kind":"Name","value":"newQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"newInterval"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveDate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"discounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AmountDiscount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"amountOff"},"name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"scope"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"durationInMonths"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PercentDiscount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"percentOff"},"name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"scope"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"durationInMonths"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"availablePlans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"planId"}},{"kind":"Field","name":{"kind":"Name","value":"planName"}},{"kind":"Field","name":{"kind":"Name","value":"planInterval"}},{"kind":"Field","name":{"kind":"Name","value":"pricing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unitPrice"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"upperBound"}},{"kind":"Field","name":{"kind":"Name","value":"flatFee"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pricingMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantityType"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"gateway"}}]}}]}}]}}]} as unknown as DocumentNode<GetPlanSelectorDataQuery, GetPlanSelectorDataQueryVariables>;
export const UpdateBillingSubscriptionPlanDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateBillingSubscriptionPlan"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateBillingSubscriptionPlanInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateBillingSubscriptionPlan"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateBillingSubscriptionPlanResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledUpdate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newPlan"}},{"kind":"Field","name":{"kind":"Name","value":"newInterval"}},{"kind":"Field","name":{"kind":"Name","value":"newQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientSecret"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethodId"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VoidMutationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateBillingSubscriptionPlanMutation, UpdateBillingSubscriptionPlanMutationVariables>;
export const UpdateSubscriptionQuantityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateSubscriptionQuantity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationId"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"quantity"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"attribution"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AttributionInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateSubscriptionQuantity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"quantity"},"value":{"kind":"Variable","name":{"kind":"Name","value":"quantity"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"attribution"},"value":{"kind":"Variable","name":{"kind":"Name","value":"attribution"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateBillingSubscriptionPlanResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledUpdate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newPlan"}},{"kind":"Field","name":{"kind":"Name","value":"newInterval"}},{"kind":"Field","name":{"kind":"Name","value":"newQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientSecret"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethodId"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VoidMutationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateSubscriptionQuantityMutation, UpdateSubscriptionQuantityMutationVariables>;
export const GetConnectableServicesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetConnectableServices"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ConnectableServicesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"connectableServices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConnectableServicesResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"services"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"service"}},{"kind":"Field","name":{"kind":"Name","value":"serviceStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"upvoteId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"types"}},{"kind":"Field","name":{"kind":"Name","value":"products"}},{"kind":"Field","name":{"kind":"Name","value":"isNew"}},{"kind":"Field","name":{"kind":"Name","value":"canConnect"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}},{"kind":"Field","name":{"kind":"Name","value":"serviceIconUrl"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"links"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contentTypes"}},{"kind":"Field","name":{"kind":"Name","value":"audience"}},{"kind":"Field","name":{"kind":"Name","value":"socialProof"}},{"kind":"Field","name":{"kind":"Name","value":"similarNetworks"}},{"kind":"Field","name":{"kind":"Name","value":"tag"}},{"kind":"Field","name":{"kind":"Name","value":"categories"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConnectableServicesError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"userFriendlyMessage"}},{"kind":"Field","name":{"kind":"Name","value":"cause"}}]}}]}}]}}]} as unknown as DocumentNode<GetConnectableServicesQuery, GetConnectableServicesQueryVariables>;
export const AccountHasActiveMemberDeviceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AccountHasActiveMemberDevice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentOrganization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasActiveMemberDevice"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AccountHasActiveMemberDeviceQuery, AccountHasActiveMemberDeviceQueryVariables>;
export const CompleteWhatsAppConnectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CompleteWhatsAppConnection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CompleteWhatsAppConnectionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completeWhatsAppConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompleteWhatsAppConnectionResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"service"}},{"kind":"Field","name":{"kind":"Name","value":"serviceId"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidInputError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NotFoundError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LimitReachedError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ChannelConnectionCannotStealChannelError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<CompleteWhatsAppConnectionMutation, CompleteWhatsAppConnectionMutationVariables>;
export const WhatsAppChannelsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WhatsAppChannels"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChannelsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"service"}},{"kind":"Field","name":{"kind":"Name","value":"serviceId"}}]}}]}}]} as unknown as DocumentNode<WhatsAppChannelsQuery, WhatsAppChannelsQueryVariables>;
export const WhatsAppChannelStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WhatsAppChannelStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ConfigurationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"configuration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"authorizationStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feature"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]}}]} as unknown as DocumentNode<WhatsAppChannelStatusQuery, WhatsAppChannelStatusQueryVariables>;
export const WhatsAppConnectionInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WhatsAppConnectionInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WhatsAppConnectionInfoInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"whatsAppConnectionInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WhatsAppConnectionInfoResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metaAppId"}},{"kind":"Field","name":{"kind":"Name","value":"embeddedSignupConfigId"}},{"kind":"Field","name":{"kind":"Name","value":"graphApiVersion"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidInputError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NotFoundError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LimitReachedError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<WhatsAppConnectionInfoQuery, WhatsAppConnectionInfoQueryVariables>;
export const ChannelAuthorizationInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ChannelAuthorizationInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChannelAuthorizationInfoInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channelAuthorizationInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ChannelAuthorizationInfoResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"redirectUri"}},{"kind":"Field","name":{"kind":"Name","value":"codeVerifier"}}]}}]}}]}}]} as unknown as DocumentNode<ChannelAuthorizationInfoQuery, ChannelAuthorizationInfoQueryVariables>;